import {
  Regex_init_$Create$2nx0fagcwc0mz as Regex_init_$Create$,
  toInt2q8uldh7sc951 as toInt,
  protoOf180f3jzyo7rfj as protoOf,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  padStart36w1507hs626a as padStart,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$1gox8sdqs91jy as IllegalArgumentException_init_$Create$,
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Long2qws0ah9gnpki as Long,
  fromInt1lka3ktyu79a4 as fromInt,
  multiply18i3gv3wlmcjg as multiply,
  toNumberlmbpvqo27r53 as toNumber,
  round2mrvepag8eey0 as round,
  numberToLong345n6tb1n1i71 as numberToLong,
  equalsLong28bsrfhwvd686 as equalsLong,
  divide3tol6kxdi8xn6 as divide,
  modulo3mmbfwxzpcw3a as modulo,
  VOID3gxj6tk5isa35 as VOID,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  replaceqbix900hl8kl as replace,
  substringAfter1hku067gwr5ve as substringAfter,
  toDouble1kn912gjoizjp as toDouble,
  startsWith26w8qjqapeeq6 as startsWith,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  split2bvyvnrlcifjv as split,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$a978fvbbts3d as ArrayList_init_$Create$,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  Triple1vhi3d0dgpnjb as Triple,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  isFinite2t9l5a275mxm6 as isFinite,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  numberToDouble210hrknaofnhf as numberToDouble,
  isNumberiramasdbon0i as isNumber,
  listOf1jh22dvmctj1r as listOf,
  copyToArray2j022khrow2yi as copyToArray,
  listOfvhqybd2zx248 as listOf_0,
  plus310ted5e4i90h as plus,
  emptyList1g2z5xcrvp2zy as emptyList,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$21wpz6bm2n4yn as LinkedHashMap_init_$Create$,
  isBlank1dvkhjjvox3p0 as isBlank,
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
  to2cs3ny02qtbcb as to,
  emptyMapr06gerzljqtm as emptyMap,
  LinkedHashMap_init_$Create$qwveozlot922 as LinkedHashMap_init_$Create$_0,
  enumEntries20mr21zbe3az4 as enumEntries,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString30pk9tzaqopn as toString_0,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  toList3jhuyej2anx2q as toList,
  minus1djrl64vbav3y as minus,
  coerceIn1xblvmyr0tby6 as coerceIn,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ArrayList_init_$Create$2xrifdqz5xirg as ArrayList_init_$Create$_0,
  average1u332mxgzjdwv as average,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  joinToString1cxrrlmo0chqs as joinToString,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  toSet2orjxp16sotqu as toSet,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  toMutableList20rdgwi7d3cwi as toMutableList,
  hashCodeq5arwsb9dgti as hashCode,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  NoSuchElementException_init_$Create$2uedmacu7g3r8 as NoSuchElementException_init_$Create$,
  LinkedHashMap_init_$Create$s27yccuovnls as LinkedHashMap_init_$Create$_1,
  compareTo3ankvs086tmwq as compareTo,
  last1vo29oleiqj36 as last,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  coerceAtMostfyc3emgaderp as coerceAtMost_0,
  NoSuchElementException_init_$Create$14710snnwdnfb as NoSuchElementException_init_$Create$_0,
  setOf45ia9pnfhe90 as setOf,
  HashSet_init_$Create$b2fvq2b4c4v2 as HashSet_init_$Create$,
  contains2gm06f5aa19ov as contains,
  first58ocm7j58k3q as first,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  until1jbpn0z3f8lbg as until,
  plus20p0vtfmu0596 as plus_0,
  isNaNymqb93xtq8w8 as isNaN_0,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  mapOf2zpbbmyqk8xpf as mapOf,
  emptySetcxexqki71qfa as emptySet,
  KtMap140uvy3s5zad8 as KtMap,
  coerceIn10f36k81le1mm as coerceIn_0,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  get_indices3txodfl5wuu5j as get_indices,
  mapOf1xd03cq9cnmy8 as mapOf_0,
  getValue48kllevslyh6 as getValue,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  distinct10qe1scfdvu5k as distinct,
  sorted354mfsiv4s7x5 as sorted,
  sum2ku6kbgxq0lee as sum,
  zipWithNext2nnv9puh4xyfv as zipWithNext,
  eachCount1imd75z0wkpbt as eachCount,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  last2n4gf5az1lkn4 as last_0,
  Char19o2r8palgjof as Char,
  dropLastlqc2oyv04br0 as dropLast,
  split3d3yeauc4rm2n as split_0,
  contains2el4s70rdq4ld as contains_0,
  StringBuilder_init_$Create$b2348mky3co as StringBuilder_init_$Create$,
  charCodeAt1yspne1d8erbm as charCodeAt,
  toString1n9qg6fb0b5i8 as toString_1,
  substringiqarkczpya5m as substring,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull_0,
  numberToChar93r9buh19yek as numberToChar,
  isDigit3mimrri4wkzop as isDigit,
  startsWith5hna0vjiqaqm as startsWith_0,
  getOrNull1cdnsfrisdp41 as getOrNull,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  Iterable1y3qizuf89iou as Iterable,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  toString1h6jjoch8cjt8 as toString_2,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
  KtList3hktaavzmj137 as KtList,
  take3onnpy6q7ctcz as take,
  Companion_instance13way2il9a8jt as Companion_instance_0,
  toMap1vec9topfei08 as toMap,
  getOrNull1go7ef9ldk0df as getOrNull_0,
  addAll1k27qatfgp3k5 as addAll,
  maxWithOrNullsohvqg0i6v8s as maxWithOrNull,
  listOfNotNull1v4ggfackvuny as listOfNotNull_0,
  withIndex37cl61h9v5txo as withIndex,
  contains3ue2qo8xhmpf1 as contains_1,
  setOf1u3mizs95ngxo as setOf_0,
  HashSet_init_$Create$1pjsbfu0jyfkj as HashSet_init_$Create$_0,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  minOrNull2eu8keq9f1w4i as minOrNull,
  min1hp1v7yf4yjv0 as min,
  max3idzx6y8yn3fk as max,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  HashMap_init_$Create$g6b5bm370ovq as HashMap_init_$Create$,
  Char__plus_impl_qi7pgj12gj4qbkhmj1y as Char__plus_impl_qi7pgj,
  downTo39qhfeycepm1j as downTo,
  compareBy2697bq0ffft96 as compareBy,
  constructCallableReference23y65rf941mch as constructCallableReference,
  RegexOption_IGNORE_CASE_getInstance2fmuzo7a7o03f as RegexOption_IGNORE_CASE_getInstance,
  Regex_init_$Create$ieoy8mfgcgs6 as Regex_init_$Create$_0,
  equals2v6cggk171b6e as equals_0,
  drop3na99dw9feawf as drop,
  minWithOrNull30i4uakvje35v as minWithOrNull,
  intersect7qttw6wlmz1n as intersect,
  union28sojvmrkgw6y as union,
  asSequence2phdjljfh9jhx as asSequence,
  filter184huxd00uyfg as filter,
  mapsbvh18eqox7a as map,
  sortedWith249tsu0292gn1 as sortedWith_0,
  take2rh6pen3z50h7 as take_0,
  toListx6x8nvfmvvht as toList_0,
  replace3le3ie7l9k8aq as replace_0,
  toSet2morh2kqexfa2 as toSet_0,
  trimStart5ewg8zf6cs5u as trimStart,
  endsWith3cq61xxngobwh as endsWith,
  removePrefix279df90bhrqqg as removePrefix,
  contains1tccixv8iwdcq as contains_2,
  lineSequencefj20mplblw0p as lineSequence,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  dropLast1vpiyky649o34 as dropLast_0,
  asReversed308kw52j6ls1u as asReversed,
  flatten2dh4kibw1u0qq as flatten,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  zipfdxxupzuj2p9 as zip,
  takeLasttm5u17ojwaaq as takeLast,
  LinkedHashSet_init_$Create$vv7nkva6wxy5 as LinkedHashSet_init_$Create$,
  ArrayList_init_$Create$2rx6gww4owbo3 as ArrayList_init_$Create$_1,
  ArrayDeque_init_$Create$6m79olxzrhzp as ArrayDeque_init_$Create$,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  get_indicesc04v40g017hw as get_indices_0,
  toDoubleArray1tu5g57mgriew as toDoubleArray,
  get_indices2kzl7ig72xk9x as get_indices_1,
  toIntArray2d4xwvtjb01mq as toIntArray,
  toSet30l41gpetsxbw as toSet_1,
  get_indices3jka924ymcx7p as get_indices_2,
  toList2z3tifmtru5ra as toList_1,
  toList2enan2cfix0ie as toList_2,
  toSet1glep2u1u9tcb as toSet_2,
  plus2lr02ok6jhhxu as plus_1,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForObject(EpochDays, 'EpochDays');
initMetadataForObject(Fmt, 'Fmt');
initMetadataForObject(NumberText, 'NumberText');
initMetadataForObject(UnitText, 'UnitText');
initMetadataForObject(AgeGate, 'AgeGate');
initMetadataForClass(AlgorithmOptionKind, 'AlgorithmOptionKind', VOID, Enum);
initMetadataForClass(AlgorithmChoice, 'AlgorithmChoice');
initMetadataForClass(AlgorithmOption, 'AlgorithmOption');
initMetadataForObject(AlgorithmJson, 'AlgorithmJson');
initMetadataForClass(ExpenditureEngine, 'ExpenditureEngine', VOID, Enum);
initMetadataForClass(ExpenditureMode, 'ExpenditureMode', VOID, Enum);
initMetadataForClass(EnergyDensityMode, 'EnergyDensityMode', VOID, Enum);
initMetadataForClass(PredictionStyle, 'PredictionStyle', VOID, Enum);
initMetadataForCompanion(Companion);
initMetadataForClass(AlgorithmSettings, 'AlgorithmSettings', AlgorithmSettings);
initMetadataForClass(FloorMode, 'FloorMode', VOID, Enum);
initMetadataForClass(MacroMinimums, 'MacroMinimums');
initMetadataForObject(CalorieFloors, 'CalorieFloors');
initMetadataForClass(GoalType, 'GoalType', VOID, Enum);
initMetadataForObject(GoalAvailability, 'GoalAvailability');
initMetadataForClass(Goal, 'Goal');
initMetadataForClass(CalorieFloor, 'CalorieFloor', VOID, Enum);
initMetadataForClass(CheckInSmoothing, 'CheckInSmoothing', VOID, Enum);
initMetadataForClass(CheckInInput, 'CheckInInput');
initMetadataForClass(CheckInResult, 'CheckInResult');
initMetadataForClass(Persistence, 'Persistence', Persistence);
initMetadataForObject(CheckIn, 'CheckIn');
initMetadataForClass(RecoveryTrend, 'RecoveryTrend');
initMetadataForClass(RecoverySignals, 'RecoverySignals');
initMetadataForObject(CheckInSignals, 'CheckInSignals');
initMetadataForClass(MacroField, 'MacroField', VOID, Enum);
initMetadataForObject(CollaborativeTargets, 'CollaborativeTargets');
initMetadataForObject(DailyTargets, 'DailyTargets');
initMetadataForCompanion(Companion_0);
initMetadataForClass(DietBreak, 'DietBreak');
initMetadataForClass(GoalPeriodStart, 'GoalPeriodStart');
initMetadataForClass(ExpenditureInput, 'ExpenditureInput');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ExpenditureRun, 'ExpenditureRun');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(ExpenditureRunner, 'ExpenditureRunner');
initMetadataForClass(PacePreset, 'PacePreset');
initMetadataForClass(PacePoint, 'PacePoint');
initMetadataForClass(PaceProjection, 'PaceProjection');
initMetadataForClass(CurvePoint, 'CurvePoint');
initMetadataForObject(GoalPace, 'GoalPace');
initMetadataForClass(Band, 'Band', VOID, Enum);
initMetadataForObject(WaistToHeight, 'WaistToHeight');
initMetadataForClass(GoalProgress, 'GoalProgress');
initMetadataForClass(MilestoneKind, 'MilestoneKind', VOID, Enum);
initMetadataForClass(WeightMilestone, 'WeightMilestone');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Goals, 'Goals');
initMetadataForClass(FastLossWarning, 'FastLossWarning');
initMetadataForObject(LossPace, 'LossPace');
initMetadataForClass(DietType, 'DietType', VOID, Enum);
initMetadataForClass(ProteinPreference, 'ProteinPreference', VOID, Enum);
initMetadataForClass(MacroTargets, 'MacroTargets');
initMetadataForClass(MacroSplit, 'MacroSplit', VOID, Enum);
initMetadataForObject(Macros, 'Macros');
initMetadataForObject(NewProgram, 'NewProgram');
initMetadataForObject(NutritionJson, 'NutritionJson');
initMetadataForClass(LoggingReview, 'LoggingReview');
initMetadataForObject(PartialDays, 'PartialDays');
initMetadataForClass(StrengthIndexPoint, 'StrengthIndexPoint');
initMetadataForClass(GuardrailResult, 'GuardrailResult');
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(PerformanceGuardrail, 'PerformanceGuardrail');
initMetadataForClass(TrainingType, 'TrainingType', VOID, Enum);
initMetadataForClass(ProteinMethod, 'ProteinMethod', VOID, Enum);
initMetadataForObject(ProteinTargets, 'ProteinTargets');
initMetadataForClass(ShiftResult, 'ShiftResult');
initMetadataForObject(TrainingShift, 'TrainingShift');
initMetadataForClass(BandPoint, 'BandPoint');
initMetadataForClass(TrendProjection, 'TrendProjection');
initMetadataForObject(TrendChart, 'TrendChart');
initMetadataForClass(ProgramKind, 'ProgramKind', VOID, Enum);
initMetadataForClass(DistributionKind, 'DistributionKind', VOID, Enum);
initMetadataForClass(TrainingShiftSetting, 'TrainingShiftSetting', TrainingShiftSetting);
initMetadataForClass(NutritionProgram, 'NutritionProgram', NutritionProgram);
initMetadataForClass(BodyProfile, 'BodyProfile');
initMetadataForClass(PreviousCheckIn, 'PreviousCheckIn');
initMetadataForClass(CheckInParams, 'CheckInParams', CheckInParams);
initMetadataForClass(WeeklyCheckInInput, 'WeeklyCheckInInput');
initMetadataForClass(WeekReview, 'WeekReview');
initMetadataForClass(CheckInModule, 'CheckInModule', VOID, Enum);
initMetadataForClass(CheckInFlagCode, 'CheckInFlagCode', VOID, Enum);
initMetadataForClass(CheckInFlag, 'CheckInFlag');
initMetadataForClass(WeeklyCheckInResult, 'WeeklyCheckInResult');
initMetadataForObject(WeeklyCheckIn, 'WeeklyCheckIn');
initMetadataForClass(HighDayMode, 'HighDayMode', VOID, Enum);
initMetadataForObject(WeeklyDistribution, 'WeeklyDistribution');
initMetadataForObject(TrendBand, 'TrendBand');
initMetadataForClass(DayStatus, 'DayStatus', VOID, Enum);
initMetadataForClass(IntakeDay, 'IntakeDay');
initMetadataForClass(ExpenditureStatus, 'ExpenditureStatus', VOID, Enum);
initMetadataForClass(ExpenditurePoint, 'ExpenditurePoint');
initMetadataForClass(GoalChange, 'GoalChange');
initMetadataForClass(ExpenditureParams, 'ExpenditureParams', ExpenditureParams);
initMetadataForObject(AdaptiveExpenditure, 'AdaptiveExpenditure');
initMetadataForObject(BodyComposition, 'BodyComposition');
initMetadataForClass(EnergyBalancePoint, 'EnergyBalancePoint');
initMetadataForClass(EnergyBalanceSummary, 'EnergyBalanceSummary');
initMetadataForObject(EnergyBalance, 'EnergyBalance');
initMetadataForObject(EnergyDensity, 'EnergyDensity');
initMetadataForClass(ExpenditureFloorKind, 'ExpenditureFloorKind', VOID, Enum);
initMetadataForObject(ExpenditureFloor, 'ExpenditureFloor');
initMetadataForClass(ExpenditureChange, 'ExpenditureChange');
initMetadataForClass(DisplayedExpenditure, 'DisplayedExpenditure');
initMetadataForObject(ExpenditureInsights, 'ExpenditureInsights');
initMetadataForClass(ExpenditureBand, 'ExpenditureBand');
initMetadataForObject(ExpenditureV2, 'ExpenditureV2');
initMetadataForClass(GoalAdjustmentParams, 'GoalAdjustmentParams', GoalAdjustmentParams);
initMetadataForClass(GoalStart, 'GoalStart');
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(Active, 'Active');
initMetadataForCompanion(Companion_2);
initMetadataForClass(GoalAdjuster, 'GoalAdjuster');
initMetadataForClass(Sex, 'Sex', VOID, Enum);
initMetadataForClass(Ethnicity, 'Ethnicity', VOID, Enum);
initMetadataForClass(ActivityLevel, 'ActivityLevel', VOID, Enum);
initMetadataForClass(BmrEquation, 'BmrEquation', VOID, Enum);
initMetadataForClass(DailyActivity, 'DailyActivity', VOID, Enum);
initMetadataForClass(ExerciseSessions, 'ExerciseSessions', VOID, Enum);
initMetadataForClass(InitialExpenditureOptions, 'InitialExpenditureOptions', InitialExpenditureOptions);
initMetadataForObject(InitialExpenditure, 'InitialExpenditure');
initMetadataForClass(IntakePrior, 'IntakePrior', VOID, Enum);
initMetadataForClass(StateSpaceParams, 'StateSpaceParams', StateSpaceParams);
initMetadataForCompanion(Companion_3);
initMetadataForClass(ExpenditureV2Terms, 'ExpenditureV2Terms', ExpenditureV2Terms);
initMetadataForClass(DailyInputs, 'DailyInputs', DailyInputs);
initMetadataForClass(StateSpaceExpenditure$filter$$inlined$groupingBy$1);
initMetadataForObject(StateSpaceExpenditure, 'StateSpaceExpenditure');
initMetadataForCompanion(Companion_4);
initMetadataForClass(Matrix3, 'Matrix3');
initMetadataForClass(AmountUnit, 'AmountUnit');
initMetadataForObject(Grams, 'Grams', VOID, AmountUnit);
initMetadataForObject(Ounces, 'Ounces', VOID, AmountUnit);
initMetadataForClass(Household, 'Household', VOID, AmountUnit);
initMetadataForCompanion(Companion_5);
initMetadataForClass(UnitChoice, 'UnitChoice');
initMetadataForClass(SuggestedAmount, 'SuggestedAmount');
initMetadataForClass(DishItem, 'DishItem');
initMetadataForObject(OffProduct, 'OffProduct');
initMetadataForClass(Portion, 'Portion');
initMetadataForClass(Message, 'Message');
initMetadataForClass(Parser, 'Parser');
initMetadataForObject(Json, 'Json');
initMetadataForObject(JsonRead, 'JsonRead');
initMetadataForClass(DrinkType, 'DrinkType', VOID, Enum);
initMetadataForClass(AlcoholEstimate, 'AlcoholEstimate');
initMetadataForObject(Alcohol, 'Alcohol');
initMetadataForCompanion(Companion_6);
initMetadataForClass(NutrientEntry, 'NutrientEntry');
initMetadataForClass(Completeness, 'Completeness');
initMetadataForClass(Contributor, 'Contributor');
initMetadataForClass(DailyNutrient, 'DailyNutrient');
initMetadataForClass(NutrientDay, 'NutrientDay');
initMetadataForClass(WeeklyNutrient, 'WeeklyNutrient');
initMetadataForClass(NutrientAverages, 'NutrientAverages');
initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(NutrientAnalysis, 'NutrientAnalysis');
initMetadataForClass(FocusDay, 'FocusDay');
initMetadataForCompanion(Companion_7);
initMetadataForClass(NutrientFocus, 'NutrientFocus');
initMetadataForCompanion(Companion_8);
initMetadataForClass(GoalMethod, 'GoalMethod', VOID, Enum);
initMetadataForClass(GoalStatus, 'GoalStatus', VOID, Enum);
initMetadataForClass(NutrientGoalSetting, 'NutrientGoalSetting');
initMetadataForObject(NutrientGoalMethods, 'NutrientGoalMethods');
initMetadataForClass(NutrientGoalPeriod, 'NutrientGoalPeriod');
initMetadataForClass(NutrientGoalChange, 'NutrientGoalChange');
initMetadataForClass(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(NutrientGoalHistory, 'NutrientGoalHistory');
initMetadataForObject(NutrientGoalJson, 'NutrientGoalJson');
initMetadataForObject(NutrientJson, 'NutrientJson');
initMetadataForClass(NutrientInfo, 'NutrientInfo');
initMetadataForClass(Per100g, 'Per100g');
initMetadataForObject(Nutrients, 'Nutrients');
initMetadataForClass(NutrientGoal, 'NutrientGoal');
initMetadataForObject(NutrientGoals, 'NutrientGoals');
initMetadataForClass(RecoveryDay, 'RecoveryDay');
initMetadataForClass(SuggestionKind, 'SuggestionKind', VOID, Enum);
initMetadataForClass(ProposedChange, 'ProposedChange');
initMetadataForClass(SwapExercise, 'SwapExercise', VOID, ProposedChange);
initMetadataForClass(Deload, 'Deload', VOID, ProposedChange);
initMetadataForClass(Consolidate, 'Consolidate', VOID, ProposedChange);
initMetadataForClass(StopSuggesting, 'StopSuggesting', VOID, ProposedChange);
initMetadataForClass(TrainingSuggestion, 'TrainingSuggestion');
initMetadataForCompanion(Companion_9);
initMetadataForClass(PlannedSession, 'PlannedSession');
initMetadataForClass(AdaptiveInput, 'AdaptiveInput');
initMetadataForClass(sam$kotlin_Comparator$0_7, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(AdaptiveTraining$frequency$$inlined$groupingBy$1);
initMetadataForClass(AdaptiveTraining$avoided$$inlined$groupingBy$1);
initMetadataForClass(AdaptiveTraining$consolidation$$inlined$groupingBy$1);
initMetadataForObject(AdaptiveTraining, 'AdaptiveTraining');
initMetadataForObject(BodyMapArt, 'BodyMapArt');
initMetadataForClass(Point, 'Point');
initMetadataForClass(Fit, 'Fit');
initMetadataForObject(CurveFit, 'CurveFit');
initMetadataForClass(FixedReps, 'FixedReps', FixedReps);
initMetadataForClass(PowerLaw, 'PowerLaw');
initMetadataForCompanion(Companion_10);
initMetadataForClass(FatigueChoice, 'FatigueChoice', VOID, Enum);
initMetadataForCompanion(Companion_11);
initMetadataForClass(SurpriseCarry, 'SurpriseCarry', VOID, Enum);
initMetadataForObject(GeneratorSettingsJson, 'GeneratorSettingsJson');
initMetadataForClass(Barbell, 'Barbell');
initMetadataForClass(PlatePair, 'PlatePair');
initMetadataForClass(DumbbellRange, 'DumbbellRange');
initMetadataForClass(MicroMode, 'MicroMode', VOID, Enum);
initMetadataForClass(WeightStack, 'WeightStack');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Gym, 'Gym', Gym);
initMetadataForClass(GymTemplate, 'GymTemplate', VOID, Enum);
initMetadataForClass(LoadRounding, 'LoadRounding', VOID, Enum);
initMetadataForClass(PlateLoadout, 'PlateLoadout');
initMetadataForObject(Loads, 'Loads');
initMetadataForClass(Search, 'Search');
initMetadataForClass(sam$kotlin_Comparator$0_8, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(PlateCalculator, 'PlateCalculator');
initMetadataForClass(LevelStatus, 'LevelStatus', VOID, Enum);
initMetadataForClass(MuscleLevel, 'MuscleLevel');
initMetadataForClass(BodyMapPeriod, 'BodyMapPeriod', VOID, Enum);
initMetadataForClass(PeriodLevels, 'PeriodLevels');
initMetadataForObject(MuscleLevels, 'MuscleLevels');
initMetadataForClass(MuscleIntensity, 'MuscleIntensity', VOID, Enum);
initMetadataForObject(MuscleHighlights, 'MuscleHighlights');
initMetadataForObject(Periodisation, 'Periodisation');
initMetadataForClass(Experience, 'Experience', VOID, Enum);
initMetadataForClass(Split, 'Split', VOID, Enum);
initMetadataForClass(CompoundSetRule, 'CompoundSetRule', VOID, Enum);
initMetadataForClass(RestRule, 'RestRule', VOID, Enum);
initMetadataForClass(GeneratorSettings, 'GeneratorSettings', GeneratorSettings);
initMetadataForClass(GeneratedProgram, 'GeneratedProgram');
initMetadataForClass(Slot, 'Slot', VOID, Enum);
initMetadataForClass(Template, 'Template', VOID, Enum);
initMetadataForClass(Picked, 'Picked');
initMetadataForClass(sam$kotlin_Comparator$0_9, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1);
initMetadataForClass(ProgramGenerator$nameDays$$inlined$groupingBy$1);
initMetadataForObject(ProgramGenerator, 'ProgramGenerator');
initMetadataForClass(Substitute, 'Substitute');
initMetadataForClass(sam$kotlin_Comparator$0_10, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Substitutions, 'Substitutions');
initMetadataForClass(ImportedProgram, 'ImportedProgram');
initMetadataForObject(ProgramImport, 'ProgramImport');
initMetadataForClass(CyclePrescription, 'CyclePrescription');
initMetadataForClass(SetRecord, 'SetRecord');
initMetadataForClass(AdjustmentPriority, 'AdjustmentPriority', VOID, Enum);
initMetadataForClass(ProgressionOptions, 'ProgressionOptions', ProgressionOptions);
initMetadataForClass(TargetIssue, 'TargetIssue', VOID, Enum);
initMetadataForClass(AlternativeKind, 'AlternativeKind', VOID, Enum);
initMetadataForClass(TargetAlternative, 'TargetAlternative');
initMetadataForClass(PlannedSet, 'PlannedSet');
initMetadataForClass(ExerciseTargets, 'ExerciseTargets');
initMetadataForClass(Context, 'Context');
initMetadataForClass(Choice, 'Choice');
initMetadataForClass(sam$kotlin_Comparator$0_11, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_12, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Progression, 'Progression');
initMetadataForClass(SeriesRange, 'SeriesRange', VOID, Enum);
initMetadataForClass(SeriesAggregation, 'SeriesAggregation', VOID, Enum);
initMetadataForClass(SeriesAverage, 'SeriesAverage', VOID, Enum);
initMetadataForClass(SeriesPoint, 'SeriesPoint');
initMetadataForClass(sam$kotlin_Comparator$0_13, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_14, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(SeriesRanges, 'SeriesRanges');
initMetadataForClass(LoggedSet, 'LoggedSet');
initMetadataForClass(SetTarget, 'SetTarget');
initMetadataForClass(Candidate, 'Candidate');
initMetadataForClass(sam$kotlin_Comparator$0_15, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Strength, 'Strength');
initMetadataForClass(StackRange, 'StackRange');
function oneRepMax(loadKg, rtf) {
  return rtf <= 1.0 ? loadKg : loadKg / this.h1e(rtf);
}
function load(oneRepMaxKg, rtf) {
  return oneRepMaxKg * this.h1e(rtf);
}
initMetadataForInterface(StrengthCurve, 'StrengthCurve');
initMetadataForClass(EpleyCurve, 'EpleyCurve', EpleyCurve, VOID, [StrengthCurve]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(FlooredExpCurve, 'FlooredExpCurve', VOID, VOID, [StrengthCurve]);
initMetadataForObject(OneRepMaxClamp, 'OneRepMaxClamp');
initMetadataForClass(CurveModel, 'CurveModel', VOID, Enum);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Region, 'Region', VOID, Enum);
initMetadataForCompanion(Companion_15);
initMetadataForClass(Muscle, 'Muscle', VOID, Enum);
initMetadataForCompanion(Companion_16);
initMetadataForClass(Equipment, 'Equipment', VOID, Enum);
initMetadataForCompanion(Companion_17);
initMetadataForClass(SetType, 'SetType', VOID, Enum);
initMetadataForCompanion(Companion_18);
initMetadataForClass(ProgressionScheme, 'ProgressionScheme', VOID, Enum);
initMetadataForCompanion(Companion_19);
initMetadataForClass(Mechanic, 'Mechanic', VOID, Enum);
initMetadataForCompanion(Companion_20);
initMetadataForClass(Force, 'Force', VOID, Enum);
initMetadataForCompanion(Companion_21);
initMetadataForClass(TrainingGoal, 'TrainingGoal', VOID, Enum);
initMetadataForCompanion(Companion_22);
initMetadataForClass(DeloadPosition, 'DeloadPosition', VOID, Enum);
initMetadataForCompanion(Companion_23);
initMetadataForClass(MovementPattern, 'MovementPattern', VOID, Enum);
initMetadataForCompanion(Companion_24);
initMetadataForClass(ExerciseSlot, 'ExerciseSlot', VOID, Enum);
initMetadataForClass(Exercise, 'Exercise');
initMetadataForObject(ExerciseCatalogue, 'ExerciseCatalogue');
initMetadataForClass(TrainingSet, 'TrainingSet');
initMetadataForClass(RepMaxPoint, 'RepMaxPoint');
initMetadataForClass(WorkoutVolume, 'WorkoutVolume');
initMetadataForClass(WeeklyVolume, 'WeeklyVolume');
initMetadataForClass(LevelsWindow, 'LevelsWindow', VOID, Enum);
initMetadataForClass(sam$kotlin_Comparator$0_16, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_17, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_18, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_19, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(TrainingAnalytics, 'TrainingAnalytics');
initMetadataForObject(TrainingBacktest, 'TrainingBacktest');
initMetadataForClass(Kind, 'Kind', VOID, Enum);
initMetadataForCompanion(Companion_25);
initMetadataForClass(WarmupSpec, 'WarmupSpec');
initMetadataForCompanion(Companion_26);
initMetadataForClass(GroupKind, 'GroupKind', VOID, Enum);
initMetadataForClass(ProgramExercise, 'ProgramExercise');
initMetadataForClass(ProgramDay, 'ProgramDay');
initMetadataForClass(TrainingProgram, 'TrainingProgram');
initMetadataForObject(TrainingProgramJson, 'TrainingProgramJson');
initMetadataForClass(Prefill, 'Prefill', VOID, Enum);
initMetadataForClass(PreviousScope, 'PreviousScope', VOID, Enum);
initMetadataForCompanion(Companion_27);
initMetadataForClass(WarmupCategory, 'WarmupCategory', VOID, Enum);
initMetadataForCompanion(Companion_28);
initMetadataForClass(TrainingSettings, 'TrainingSettings', TrainingSettings);
initMetadataForObject(TrainingSettingsJson, 'TrainingSettingsJson');
initMetadataForObject(TrainingWeekdays, 'TrainingWeekdays');
initMetadataForClass(WarmupStep, 'WarmupStep');
initMetadataForClass(WarmupSet, 'WarmupSet');
initMetadataForClass(SmartWarmupStyle, 'SmartWarmupStyle', VOID, Enum);
initMetadataForClass(sam$kotlin_Comparator$0_20, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Warmups, 'Warmups');
initMetadataForClass(TrendMethod, 'TrendMethod', VOID, Enum);
initMetadataForObject(Trend, 'Trend');
initMetadataForClass(LessLagParams, 'LessLagParams', LessLagParams);
initMetadataForClass(State, 'State');
initMetadataForClass(LessLagTrend$compute$$inlined$groupingBy$1);
initMetadataForObject(LessLagTrend, 'LessLagTrend');
initMetadataForClass(TransientTrendParams, 'TransientTrendParams', TransientTrendParams);
initMetadataForClass(TransientTrendPoint, 'TransientTrendPoint');
initMetadataForClass(TransientTrend$compute$$inlined$groupingBy$1);
initMetadataForObject(TransientTrend, 'TransientTrend');
initMetadataForClass(Direction, 'Direction', VOID, Enum);
initMetadataForClass(WeightChange, 'WeightChange');
initMetadataForCompanion(Companion_29);
initMetadataForClass(WeightInsights, 'WeightInsights');
initMetadataForObject(WeighInHabit, 'WeighInHabit');
initMetadataForClass(WeighIn, 'WeighIn');
initMetadataForClass(TrendPoint, 'TrendPoint');
initMetadataForClass(sam$kotlin_Comparator$0_21, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(WeightTrend, 'WeightTrend');
initMetadataForClass(JsSuggestedAmount, 'JsSuggestedAmount');
initMetadataForClass(JsUnitChoice, 'JsUnitChoice');
initMetadataForClass(JsExpenditureModel, 'JsExpenditureModel');
initMetadataForClass(JsAlgorithmOption, 'JsAlgorithmOption');
initMetadataForClass(JsDisplayedExpenditure, 'JsDisplayedExpenditure');
initMetadataForClass(JsExpenditureChanges, 'JsExpenditureChanges');
initMetadataForClass(JsEnergyBalancePoint, 'JsEnergyBalancePoint');
initMetadataForClass(JsEnergyBalance, 'JsEnergyBalance');
initMetadataForClass(JsMessageArg, 'JsMessageArg');
initMetadataForClass(JsMessage, 'JsMessage');
initMetadataForClass(JsWeeklyCheckIn, 'JsWeeklyCheckIn');
initMetadataForClass(JsFastLoss, 'JsFastLoss');
initMetadataForClass(JsDietBreak, 'JsDietBreak');
initMetadataForClass(JsGoalProgress, 'JsGoalProgress');
initMetadataForClass(JsWeightMilestone, 'JsWeightMilestone');
initMetadataForClass(JsNutrientGoal, 'JsNutrientGoal');
initMetadataForClass(JsCompleteness, 'JsCompleteness');
initMetadataForClass(JsContributor, 'JsContributor');
initMetadataForClass(JsNutrientAverages, 'JsNutrientAverages');
initMetadataForClass(JsAlcohol, 'JsAlcohol');
initMetadataForClass(JsDrinkType, 'JsDrinkType');
initMetadataForClass(JsTrendPoint, 'JsTrendPoint');
initMetadataForClass(JsExpenditurePoint, 'JsExpenditurePoint');
initMetadataForClass(JsCheckInResult, 'JsCheckInResult');
initMetadataForClass(JsMacros, 'JsMacros');
initMetadataForClass(JsWeightInsights, 'JsWeightInsights');
initMetadataForClass(JsNutrientInfo, 'JsNutrientInfo');
initMetadataForClass(JsNutrientGoalSetting, 'JsNutrientGoalSetting');
initMetadataForClass(JsGoalMethod, 'JsGoalMethod');
initMetadataForClass(JsNutrientDay, 'JsNutrientDay');
initMetadataForClass(JsNutrientFocus, 'JsNutrientFocus');
initMetadataForClass(JsPlateLoadout, 'JsPlateLoadout');
initMetadataForClass(JsWarmupSet, 'JsWarmupSet');
initMetadataForClass(JsExerciseTargets, 'JsExerciseTargets');
initMetadataForClass(JsGeneratedProgram, 'JsGeneratedProgram');
initMetadataForClass(JsSubstitute, 'JsSubstitute');
initMetadataForClass(JsRepMaxPoint, 'JsRepMaxPoint');
initMetadataForClass(JsMuscleSets, 'JsMuscleSets');
initMetadataForClass(JsMuscleLevels, 'JsMuscleLevels');
initMetadataForClass(JsMuscleHighlights, 'JsMuscleHighlights');
initMetadataForClass(JsImportedProgram, 'JsImportedProgram');
initMetadataForClass(JsSeries, 'JsSeries');
initMetadataForClass(JsWeeklyVolumes, 'JsWeeklyVolumes');
initMetadataForClass(JsPeriodLevels, 'JsPeriodLevels');
initMetadataForClass(JsTrainingSuggestion, 'JsTrainingSuggestion');
initMetadataForClass(JsTrendChart, 'JsTrendChart');
//endregion
function daysInMonth($this, year, month) {
  switch (month) {
    case 2:
      return (year % 4 | 0) === 0 && !((year % 100 | 0) === 0) || (year % 400 | 0) === 0 ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}
function EpochDays() {
  EpochDays_instance = this;
  this.ce_1 = Regex_init_$Create$('^(\\d{4})-(\\d{2})-(\\d{2})$');
}
protoOf(EpochDays).de = function (iso) {
  var tmp0_elvis_lhs = this.ce_1.c9(iso);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var match = tmp;
  var _destruct__k2r9zo = match.ca();
  // Inline function 'kotlin.text.Destructured.component1' call
  var y = _destruct__k2r9zo.xd_1.ba().n(1);
  // Inline function 'kotlin.text.Destructured.component2' call
  var m = _destruct__k2r9zo.xd_1.ba().n(2);
  // Inline function 'kotlin.text.Destructured.component3' call
  var d = _destruct__k2r9zo.xd_1.ba().n(3);
  var year = toInt(y);
  var month = toInt(m);
  var day = toInt(d);
  if (!(1 <= month ? month <= 12 : false) || day < 1 || day > daysInMonth(this, year, month))
    return null;
  var shifted = month <= 2 ? year - 1 | 0 : year;
  var era = (shifted >= 0 ? shifted : shifted - 399 | 0) / 400 | 0;
  var yearOfEra = shifted - imul(era, 400) | 0;
  var dayOfYear = (((imul(153, month + (month > 2 ? -3 : 9) | 0) + 2 | 0) / 5 | 0) + day | 0) - 1 | 0;
  var dayOfEra = ((imul(yearOfEra, 365) + (yearOfEra / 4 | 0) | 0) - (yearOfEra / 100 | 0) | 0) + dayOfYear | 0;
  return (imul(era, 146097) + dayOfEra | 0) - 719468 | 0;
};
protoOf(EpochDays).ee = function (epochDay) {
  var z = epochDay + 719468 | 0;
  var era = (z >= 0 ? z : z - 146096 | 0) / 146097 | 0;
  var dayOfEra = z - imul(era, 146097) | 0;
  var yearOfEra = (((dayOfEra - (dayOfEra / 1460 | 0) | 0) + (dayOfEra / 36524 | 0) | 0) - (dayOfEra / 146096 | 0) | 0) / 365 | 0;
  var dayOfYear = dayOfEra - ((imul(365, yearOfEra) + (yearOfEra / 4 | 0) | 0) - (yearOfEra / 100 | 0) | 0) | 0;
  var mp = (imul(5, dayOfYear) + 2 | 0) / 153 | 0;
  var day = (dayOfYear - ((imul(153, mp) + 2 | 0) / 5 | 0) | 0) + 1 | 0;
  var month = mp < 10 ? mp + 3 | 0 : mp - 9 | 0;
  var year = (yearOfEra + imul(era, 400) | 0) + (month <= 2 ? 1 : 0) | 0;
  return padStart(year.toString(), 4, _Char___init__impl__6a9atx(48)) + '-' + padStart(month.toString(), 2, _Char___init__impl__6a9atx(48)) + '-' + padStart(day.toString(), 2, _Char___init__impl__6a9atx(48));
};
protoOf(EpochDays).fe = function (epochDay) {
  return ((((epochDay + 3 | 0) % 7 | 0) + 7 | 0) % 7 | 0) + 1 | 0;
};
protoOf(EpochDays).ge = function (epochDay) {
  return epochDay - (this.fe(epochDay) - 1 | 0) | 0;
};
var EpochDays_instance;
function EpochDays_getInstance() {
  if (EpochDays_instance == null)
    new EpochDays();
  return EpochDays_instance;
}
function Fmt() {
}
protoOf(Fmt).he = function (value, decimals) {
  // Inline function 'kotlin.require' call
  if (!(0 <= decimals ? decimals <= 6 : false)) {
    var message = 'decimals must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var factor = new Long(1, 0);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < decimals)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.Long.times' call
      var this_0 = factor;
      factor = multiply(this_0, fromInt(10));
    }
     while (inductionVariable < decimals);
  // Inline function 'kotlin.math.abs' call
  var tmp$ret$5 = Math.abs(value);
  var scaled = numberToLong(round(tmp$ret$5 * toNumber(factor)));
  var sign = value < 0.0 && !equalsLong(scaled, new Long(0, 0)) ? '-' : '';
  var whole = divide(scaled, factor);
  if (decimals === 0)
    return sign + whole.toString();
  return sign + whole.toString() + '.' + padStart(modulo(scaled, factor).toString(), decimals, _Char___init__impl__6a9atx(48));
};
protoOf(Fmt).ie = function (value, decimals, $super) {
  decimals = decimals === VOID ? 0 : decimals;
  return $super === VOID ? this.he(value, decimals) : $super.he.call(this, value, decimals);
};
protoOf(Fmt).je = function (value, decimals) {
  var text = this.he(value, decimals);
  var tmp;
  var tmp_0;
  if (value > 0.0) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.text.any' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(text)) {
        var element = charSequenceGet(text, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (_Char___init__impl__6a9atx(49) <= element ? element <= _Char___init__impl__6a9atx(57) : false) {
          tmp$ret$0 = true;
          break $l$block;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = '+' + text;
  } else {
    tmp = text;
  }
  return tmp;
};
protoOf(Fmt).ke = function (value, decimals, $super) {
  decimals = decimals === VOID ? 0 : decimals;
  return $super === VOID ? this.je(value, decimals) : $super.je.call(this, value, decimals);
};
protoOf(Fmt).le = function (count, singular, plural) {
  return '' + count + ' ' + (count === 1 ? singular : plural);
};
protoOf(Fmt).me = function (count, singular, plural, $super) {
  plural = plural === VOID ? singular + 's' : plural;
  return $super === VOID ? this.le(count, singular, plural) : $super.le.call(this, count, singular, plural);
};
var Fmt_instance;
function Fmt_getInstance() {
  return Fmt_instance;
}
function NumberText() {
  NumberText_instance = this;
  this.ne_1 = _Char___init__impl__6a9atx(8722);
  this.oe_1 = 3600;
  this.pe_1 = 60;
}
protoOf(NumberText).he = function (value, decimals) {
  return replace(Fmt_instance.he(value, decimals), _Char___init__impl__6a9atx(45), _Char___init__impl__6a9atx(8722));
};
var NumberText_instance;
function NumberText_getInstance() {
  if (NumberText_instance == null)
    new NumberText();
  return NumberText_instance;
}
function decimals($this, number) {
  return substringAfter(number, _Char___init__impl__6a9atx(46), '').length;
}
function convert($this, number, factor, decimals) {
  var value = toDouble(number) * factor;
  return (startsWith(number, '+') && value > 0.0 ? '+' : '') + Fmt_instance.he(value, decimals);
}
function UnitText$localize$lambda(it) {
  return convert(UnitText_getInstance(), it.ba().n(1), 4.184, 0) + ' kJ';
}
function UnitText$localize$lambda_0(match) {
  return convert(UnitText_getInstance(), match.ba().n(1), 1.0 / 0.45359237, decimals(UnitText_getInstance(), match.ba().n(1))) + ' lb';
}
function UnitText() {
  UnitText_instance = this;
  this.qe_1 = 0.45359237;
  this.re_1 = 4.184;
  this.se_1 = Regex_init_$Create$('([+-]?\\d+(?:\\.\\d+)?) kcal\\b');
  this.te_1 = Regex_init_$Create$('([+-]?\\d+(?:\\.\\d+)?) kg\\b');
}
protoOf(UnitText).ue = function (message, pounds, kilojoules) {
  var text = message;
  if (kilojoules) {
    var tmp = text;
    text = this.se_1.f9(tmp, UnitText$localize$lambda);
  }
  if (pounds) {
    var tmp_0 = text;
    text = this.te_1.f9(tmp_0, UnitText$localize$lambda_0);
  }
  return text;
};
var UnitText_instance;
function UnitText_getInstance() {
  if (UnitText_instance == null)
    new UnitText();
  return UnitText_instance;
}
function parse($this, iso) {
  // Inline function 'kotlin.text.trim' call
  var tmp$ret$0 = toString(trim(isCharSequence(iso) ? iso : THROW_CCE()));
  var parts = split(tmp$ret$0, ['-']);
  if (!(parts.o() === 3))
    return null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(parts, 10));
  var _iterator__ex2g4s = parts.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = toIntOrNull(item);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp$ret$3 = tmp;
    destination.f(tmp$ret$3);
  }
  // Inline function 'kotlin.collections.component1' call
  var year = destination.n(0);
  // Inline function 'kotlin.collections.component2' call
  var month = destination.n(1);
  // Inline function 'kotlin.collections.component3' call
  var day = destination.n(2);
  // Inline function 'kotlin.takeIf' call
  var this_0 = new Triple(year, month, day);
  var tmp_0;
  if ((1 <= month ? month <= 12 : false) && (1 <= day ? day <= 31 : false)) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  return tmp_0;
}
function AgeGate() {
  this.ve_1 = 18;
  this.we_1 = 'Macrotide is for adults 18 and over.';
}
protoOf(AgeGate).xe = function (birthDate, today) {
  var tmp0_elvis_lhs = parse(this, birthDate);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var born = tmp;
  var tmp1_elvis_lhs = parse(this, today);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var now = tmp_0;
  var years = now.zd_1 - born.zd_1 | 0;
  if (now.ae_1 < born.ae_1 || (now.ae_1 === born.ae_1 && now.be_1 < born.be_1))
    years = years - 1 | 0;
  // Inline function 'kotlin.takeIf' call
  var this_0 = years;
  var tmp_1;
  if (this_0 >= 0) {
    tmp_1 = this_0;
  } else {
    tmp_1 = null;
  }
  return tmp_1;
};
protoOf(AgeGate).ye = function (birthDate, today) {
  var tmp0_elvis_lhs = this.xe(birthDate, today);
  return (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) >= 18;
};
var AgeGate_instance;
function AgeGate_getInstance() {
  return AgeGate_instance;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AlgorithmOptionKind_CHOICE_instance = new AlgorithmOptionKind('CHOICE', 0);
  AlgorithmOptionKind_BOOLEAN_instance = new AlgorithmOptionKind('BOOLEAN', 1);
  AlgorithmOptionKind_INTEGER_instance = new AlgorithmOptionKind('INTEGER', 2);
  AlgorithmOptionKind_NUMBER_instance = new AlgorithmOptionKind('NUMBER', 3);
  AlgorithmOptionKind_DATE_instance = new AlgorithmOptionKind('DATE', 4);
}
var AlgorithmOptionKind_CHOICE_instance;
var AlgorithmOptionKind_BOOLEAN_instance;
var AlgorithmOptionKind_INTEGER_instance;
var AlgorithmOptionKind_NUMBER_instance;
var AlgorithmOptionKind_DATE_instance;
function AlgorithmOptionKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function AlgorithmChoice(value, label) {
  this.ze_1 = value;
  this.af_1 = label;
}
protoOf(AlgorithmChoice).toString = function () {
  return 'AlgorithmChoice(value=' + this.ze_1 + ', label=' + this.af_1 + ')';
};
protoOf(AlgorithmChoice).hashCode = function () {
  var result = getStringHashCode(this.ze_1);
  result = imul(result, 31) + getStringHashCode(this.af_1) | 0;
  return result;
};
protoOf(AlgorithmChoice).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlgorithmChoice))
    return false;
  if (!(this.ze_1 === other.ze_1))
    return false;
  if (!(this.af_1 === other.af_1))
    return false;
  return true;
};
function AlgorithmOption(key, label, help, kind, choices, get, set) {
  this.bf_1 = key;
  this.cf_1 = label;
  this.df_1 = help;
  this.ef_1 = kind;
  this.ff_1 = choices;
  this.gf_1 = get;
  this.hf_1 = set;
}
function choices($this, values, labels) {
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(values.length);
  var index = 0;
  var inductionVariable = 0;
  var last = values.length;
  while (inductionVariable < last) {
    var item = values[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp$ret$2 = new AlgorithmChoice(item.x1_1, labels.n(_unary__edvuaz));
    destination.f(tmp$ret$2);
  }
  return destination;
}
function bool($this, text) {
  var tmp;
  switch (text) {
    case 'true':
      tmp = true;
      break;
    case 'false':
      tmp = false;
      break;
    default:
      throw IllegalArgumentException_init_$Create$("not true or false: '" + text + "'");
  }
  return tmp;
}
function positive($this, text) {
  var tmp0_safe_receiver = toDoubleOrNull(text);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver > 0.0 && isFinite(tmp0_safe_receiver)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("not a positive number: '" + text + "'");
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function typed($this, option, text) {
  var tmp;
  switch (option.ef_1.y1_1) {
    case 0:
    case 4:
      // Inline function 'kotlin.text.ifEmpty' call

      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call

      if (charSequenceLength(text) === 0) {
        tmp_0 = null;
      } else {
        tmp_0 = text;
      }

      tmp = tmp_0;
      break;
    case 1:
      tmp = text === 'true';
      break;
    case 2:
      tmp = toInt(text);
      break;
    case 3:
      tmp = toDoubleOrNull(text);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function text($this, value) {
  var tmp;
  if (value == null) {
    tmp = '';
  } else {
    if (typeof value === 'string') {
      tmp = value;
    } else {
      if (typeof value === 'boolean') {
        tmp = value.toString();
      } else {
        if (isNumber(value)) {
          // Inline function 'kotlin.let' call
          var it = numberToDouble(value);
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.math.floor' call
          if (it === Math.floor(it)) {
            // Inline function 'kotlin.math.abs' call
            tmp_1 = Math.abs(it) < 1.0E15;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = numberToLong(it).toString();
          } else {
            tmp_0 = it.toString();
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
      }
    }
  }
  return tmp;
}
function AlgorithmJson$OPTIONS$lambda(it) {
  return it.if_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_0(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_1(it) {
  var tmp0_safe_receiver = it.mf_1;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1_1;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_2(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
    AlgorithmJson_getInstance();
    // Inline function 'kotlin.enumValues' call
    var tmp0 = values();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.x1_1 === v) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return s.cg(VOID, VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_3(it) {
  return it.jf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_4(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_0();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_5(it) {
  var tmp0_safe_receiver = it.kf_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Fmt_instance.ie(tmp0_safe_receiver);
  }
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_6(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    tmp = positive(AlgorithmJson_getInstance(), v);
  }
  return s.cg(VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_7(it) {
  var tmp0_safe_receiver = it.lf_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = EpochDays_getInstance().ee(tmp0_safe_receiver);
  }
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_8(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    var tmp0_elvis_lhs = EpochDays_getInstance().de(v);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$("not an ISO date: '" + v + "'");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return s.cg(VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_9(it) {
  return it.nf_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_10(s, v) {
  var tmp0_elvis_lhs = toIntOrNull(v);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("not a whole number: '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return s.cg(VOID, VOID, VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_11(it) {
  return it.of_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_12(s, v) {
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, bool(AlgorithmJson_getInstance(), v));
}
function AlgorithmJson$OPTIONS$lambda_13(it) {
  return it.pf_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_14(s, v) {
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, bool(AlgorithmJson_getInstance(), v));
}
function AlgorithmJson$OPTIONS$lambda_15(it) {
  return it.qf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_16(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_15();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_17(it) {
  return it.rf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_18(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_1();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_19(it) {
  return it.sf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_20(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_22();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_21(it) {
  return it.tf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_22(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_6();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_23(it) {
  return it.uf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_24(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_2();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_25(it) {
  return it.vf_1.dg_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_26(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_19();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.vf_1.hg(tmp$ret$0));
}
function AlgorithmJson$OPTIONS$lambda_27(it) {
  var tmp0_safe_receiver = it.vf_1.eg_1;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1_1;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_28(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
    AlgorithmJson_getInstance();
    // Inline function 'kotlin.enumValues' call
    var tmp0 = values_20();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.x1_1 === v) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.vf_1.hg(VOID, tmp));
}
function AlgorithmJson$OPTIONS$lambda_29(it) {
  return it.vf_1.fg_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_30(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_21();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.vf_1.hg(VOID, VOID, tmp$ret$0));
}
function AlgorithmJson$OPTIONS$lambda_31(it) {
  return it.vf_1.gg_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_32(s, v) {
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.vf_1.hg(VOID, VOID, VOID, bool(AlgorithmJson_getInstance(), v)));
}
function AlgorithmJson$OPTIONS$lambda_33(it) {
  return it.wf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_34(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_11();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_35(it) {
  return it.xf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_36(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_10();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_37(it) {
  return Fmt_instance.he(it.yf_1, 1);
}
function AlgorithmJson$OPTIONS$lambda_38(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = 80.0;
  } else {
    tmp = positive(AlgorithmJson_getInstance(), v);
  }
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_39(it) {
  return it.zf_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_40(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_3();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_41(it) {
  return it.ag_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_42(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_9();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_43(it) {
  return it.bg_1.x1_1;
}
function AlgorithmJson$OPTIONS$lambda_44(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_14();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.cg(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson() {
  AlgorithmJson_instance = this;
  this.ig_1 = listOf([new AlgorithmChoice('false', 'Off'), new AlgorithmChoice('true', 'On')]);
  this.jg_1 = listOf(['v0 (adaptive, default)', 'v1 (state-space)', 'v2 (state-space with adaptation)']);
  var tmp = this;
  var tmp_0 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = get_entries();
  var tmp$ret$0 = copyToArray(this_0);
  var tmp_1 = choices(this, tmp$ret$0, this.jg_1);
  var tmp_2 = AlgorithmJson$OPTIONS$lambda;
  var tmp_3 = new AlgorithmOption('expenditureEngine', 'Expenditure engine', 'Which model estimates expenditure everywhere: the dashboard, the Expenditure screen and the check-in.', tmp_0, tmp_1, tmp_2, AlgorithmJson$OPTIONS$lambda_0);
  var tmp_4 = AlgorithmOptionKind_CHOICE_getInstance();
  var tmp_5 = listOf_0(new AlgorithmChoice('', 'None'));
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = get_entries();
  var tmp$ret$1 = copyToArray(this_1);
  var tmp_6 = plus(tmp_5, choices(this, tmp$ret$1, this.jg_1));
  var tmp_7 = AlgorithmJson$OPTIONS$lambda_1;
  var tmp_8 = new AlgorithmOption('compareEngine', 'Compare with', 'A second engine drawn on the Expenditure chart, the in-app version of the backtest.', tmp_4, tmp_6, tmp_7, AlgorithmJson$OPTIONS$lambda_2);
  var tmp_9 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_2 = get_entries_0();
  var tmp$ret$2 = copyToArray(this_2);
  var tmp_10 = choices(this, tmp$ret$2, listOf(['Dynamic', 'Static']));
  var tmp_11 = AlgorithmJson$OPTIONS$lambda_3;
  var tmp_12 = new AlgorithmOption('expenditureMode', 'Expenditure mode', 'Static uses the value below instead of the engine, bounded by the floor and 3 \xD7 BMR. The engine still runs for comparison.', tmp_9, tmp_10, tmp_11, AlgorithmJson$OPTIONS$lambda_4);
  var tmp_13 = AlgorithmOptionKind_NUMBER_getInstance();
  var tmp_14 = emptyList();
  var tmp_15 = AlgorithmJson$OPTIONS$lambda_5;
  var tmp_16 = new AlgorithmOption('staticKcal', 'Static expenditure (kcal)', 'Used when the mode is static.', tmp_13, tmp_14, tmp_15, AlgorithmJson$OPTIONS$lambda_6);
  var tmp_17 = AlgorithmOptionKind_DATE_getInstance();
  var tmp_18 = emptyList();
  var tmp_19 = AlgorithmJson$OPTIONS$lambda_7;
  var tmp_20 = new AlgorithmOption('expenditureStartDate', 'Expenditure start date', 'Start the estimate here instead of at the first weigh-in, after a long break or a reset. It seeds from the last check-in before it.', tmp_17, tmp_18, tmp_19, AlgorithmJson$OPTIONS$lambda_8);
  var tmp_21 = AlgorithmOptionKind_INTEGER_getInstance();
  var tmp_22 = listOf_0(new AlgorithmChoice('4', '4 of 7 days (default)'));
  var tmp_23 = AlgorithmJson$OPTIONS$lambda_9;
  var tmp_24 = new AlgorithmOption('holdMinUsableDays', 'Hold threshold', "Expenditure holds, and the check-in keeps last week's targets, when fewer of the last 7 days than this have usable intake.", tmp_21, tmp_22, tmp_23, AlgorithmJson$OPTIONS$lambda_10);
  var tmp_25 = AlgorithmOptionKind_BOOLEAN_getInstance();
  var tmp_26 = AlgorithmJson$OPTIONS$lambda_11;
  var tmp_27 = new AlgorithmOption('holdAfterLastWeighIn', 'Hold after the last weigh-in', 'Days after your last weigh-in hold the last value; the next weigh-in fills them in.', tmp_25, this.ig_1, tmp_26, AlgorithmJson$OPTIONS$lambda_12);
  var tmp_28 = AlgorithmOptionKind_BOOLEAN_getInstance();
  var tmp_29 = AlgorithmJson$OPTIONS$lambda_13;
  var tmp_30 = new AlgorithmOption('goalAdjustmentCaps', 'Cap the goal adjustment', 'Limits how fast expenditure moves after a goal change: 25 kcal a day and 300 kcal in each direction, refilled slowly.', tmp_28, this.ig_1, tmp_29, AlgorithmJson$OPTIONS$lambda_14);
  var tmp_31 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_3 = get_entries_10();
  var tmp$ret$3 = copyToArray(this_3);
  var tmp_32 = choices(this, tmp$ret$3, listOf(['None (default)', 'Resting burn (ours)']));
  var tmp_33 = AlgorithmJson$OPTIONS$lambda_15;
  var tmp_34 = new AlgorithmOption('expenditureFloor', 'Expenditure floor', 'A lower bound so a few wrongly logged days cannot drag expenditure to impossible values.', tmp_31, tmp_32, tmp_33, AlgorithmJson$OPTIONS$lambda_16);
  var tmp_35 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_4 = get_entries_1();
  var tmp$ret$4 = copyToArray(this_4);
  var tmp_36 = choices(this, tmp$ret$4, listOf(['By body fat (Forbes, default)', 'Flat 7,700 kcal (MacroFactor)']));
  var tmp_37 = AlgorithmJson$OPTIONS$lambda_17;
  var tmp_38 = new AlgorithmOption('energyDensity', 'Energy per kg', 'Energy in a kg of weight change, used by the engines and the check-in.', tmp_35, tmp_36, tmp_37, AlgorithmJson$OPTIONS$lambda_18);
  var tmp_39 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_5 = get_entries_17();
  var tmp$ret$5 = copyToArray(this_5);
  var tmp_40 = choices(this, tmp$ret$5, listOf(['Your recent average (default)', 'Your expenditure']));
  var tmp_41 = AlgorithmJson$OPTIONS$lambda_19;
  var tmp_42 = new AlgorithmOption('intakePrior', 'Unlogged days (v1, v2)', 'What the state-space engines assume you ate on a day with no usable log.', tmp_39, tmp_40, tmp_41, AlgorithmJson$OPTIONS$lambda_20);
  var tmp_43 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_6 = get_entries_5();
  var tmp$ret$6 = copyToArray(this_6);
  var tmp_44 = choices(this, tmp$ret$6, listOf(['35 %, 60 % after 3 weeks (default)', 'None: follow expenditure', "Adaptive: by the engine's certainty"]));
  var tmp_45 = AlgorithmJson$OPTIONS$lambda_21;
  var tmp_46 = new AlgorithmOption('checkInSmoothing', 'Check-in smoothing', "How far each check-in moves your target toward expenditure plus your goal's change.", tmp_43, tmp_44, tmp_45, AlgorithmJson$OPTIONS$lambda_22);
  var tmp_47 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_7 = get_entries_2();
  var tmp$ret$7 = copyToArray(this_7);
  var tmp_48 = choices(this, tmp$ret$7, listOf(['Weight data (default)', 'Goal rate', 'Blend']));
  var tmp_49 = AlgorithmJson$OPTIONS$lambda_23;
  var tmp_50 = new AlgorithmOption('predictionStyle', 'Weight prediction', 'Which rate projects your goal date: your trend, your goal rate, or half of each.', tmp_47, tmp_48, tmp_49, AlgorithmJson$OPTIONS$lambda_24);
  var tmp_51 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_8 = get_entries_14();
  var tmp$ret$8 = copyToArray(this_8);
  var tmp_52 = choices(this, tmp$ret$8, listOf(['Katch with body fat, else Mifflin (default)', 'Katch\u2013McArdle', 'Mifflin\u2013St Jeor', 'Cunningham', 'ten Haaf (athletes and lifters)']));
  var tmp_53 = AlgorithmJson$OPTIONS$lambda_25;
  var tmp_54 = new AlgorithmOption('bmrEquation', 'BMR equation', 'Seeds expenditure before there is data, after a reset or a long break.', tmp_51, tmp_52, tmp_53, AlgorithmJson$OPTIONS$lambda_26);
  var tmp_55 = AlgorithmOptionKind_CHOICE_getInstance();
  var tmp_56 = listOf_0(new AlgorithmChoice('', 'From the profile (default)'));
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_9 = get_entries_15();
  var tmp$ret$9 = copyToArray(this_9);
  var tmp_57 = plus(tmp_56, choices(this, tmp$ret$9, listOf(['Mostly sedentary', 'Moderately active', 'Very active'])));
  var tmp_58 = AlgorithmJson$OPTIONS$lambda_27;
  var tmp_59 = new AlgorithmOption('dailyActivity', 'Daily life', "Activity outside exercise; with a choice here, activity is daily life plus exercise sessions instead of the profile's level.", tmp_55, tmp_57, tmp_58, AlgorithmJson$OPTIONS$lambda_28);
  var tmp_60 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_10 = get_entries_16();
  var tmp$ret$10 = copyToArray(this_10);
  var tmp_61 = choices(this, tmp$ret$10, listOf(['None', '1\u20133', '4\u20136', '7 or more']));
  var tmp_62 = AlgorithmJson$OPTIONS$lambda_29;
  var tmp_63 = new AlgorithmOption('exerciseSessions', 'Exercise sessions a week', 'Added to daily life when that is set.', tmp_60, tmp_61, tmp_62, AlgorithmJson$OPTIONS$lambda_30);
  var tmp_64 = AlgorithmOptionKind_BOOLEAN_getInstance();
  var tmp_65 = AlgorithmJson$OPTIONS$lambda_31;
  var tmp_66 = new AlgorithmOption('recentlyLosing', 'Losing recently', 'Lowers the starting estimate by 5 %.', tmp_64, this.ig_1, tmp_65, AlgorithmJson$OPTIONS$lambda_32);
  var tmp_67 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_11 = get_entries_8();
  var tmp$ret$11 = copyToArray(this_11);
  var tmp_68 = choices(this, tmp$ret$11, listOf(['By lean mass (default)', 'By goal and training (ours)']));
  var tmp_69 = AlgorithmJson$OPTIONS$lambda_33;
  var tmp_70 = new AlgorithmOption('proteinMethod', 'Protein', 'How the check-in sets protein.', tmp_67, tmp_68, tmp_69, AlgorithmJson$OPTIONS$lambda_34);
  var tmp_71 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_12 = get_entries_7();
  var tmp$ret$12 = copyToArray(this_12);
  var tmp_72 = choices(this, tmp$ret$12, listOf(['Auto, from logged sets', 'None', 'Cardio', 'Strength', 'Both']));
  var tmp_73 = AlgorithmJson$OPTIONS$lambda_35;
  var tmp_74 = new AlgorithmOption('trainingType', 'Training type', 'For protein. Auto counts strength training from 6 hard sets a week in your logged workouts.', tmp_71, tmp_72, tmp_73, AlgorithmJson$OPTIONS$lambda_36);
  var tmp_75 = AlgorithmOptionKind_NUMBER_getInstance();
  var tmp_76 = emptyList();
  var tmp_77 = AlgorithmJson$OPTIONS$lambda_37;
  var tmp_78 = new AlgorithmOption('proteinLeanCapKg', 'Lean mass cap for protein (kg)', 'Lean mass above this does not raise protein.', tmp_75, tmp_76, tmp_77, AlgorithmJson$OPTIONS$lambda_38);
  var tmp_79 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_13 = get_entries_3();
  var tmp$ret$13 = copyToArray(this_13);
  var tmp_80 = choices(this, tmp$ret$13, listOf(['Fixed 1,200 / 800 (default)', 'By body size (ours)']));
  var tmp_81 = AlgorithmJson$OPTIONS$lambda_39;
  var tmp_82 = new AlgorithmOption('floorMode', 'Calorie floor', "How the program's standard or low floor is set.", tmp_79, tmp_80, tmp_81, AlgorithmJson$OPTIONS$lambda_40);
  var tmp_83 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_14 = get_entries_6();
  var tmp$ret$14 = copyToArray(this_14);
  var tmp_84 = choices(this, tmp$ret$14, listOf(['Current (default)', 'Revised (ours)']));
  var tmp_85 = AlgorithmJson$OPTIONS$lambda_41;
  var tmp_86 = new AlgorithmOption('macroSplit', 'Fat and carb split', 'How fat and carbs share the calories after protein, and what gives way first on a very low budget.', tmp_83, tmp_84, tmp_85, AlgorithmJson$OPTIONS$lambda_42);
  var tmp_87 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_15 = get_entries_9();
  var tmp$ret$15 = copyToArray(this_15);
  var tmp_88 = choices(this, tmp$ret$15, listOf(['1.10\xD7 (default)', 'By number of high days (ours)']));
  var tmp_89 = AlgorithmJson$OPTIONS$lambda_43;
  tmp.kg_1 = listOf([tmp_3, tmp_8, tmp_12, tmp_16, tmp_20, tmp_24, tmp_27, tmp_30, tmp_34, tmp_38, tmp_42, tmp_46, tmp_50, tmp_54, tmp_59, tmp_63, tmp_66, tmp_70, tmp_74, tmp_78, tmp_82, tmp_86, new AlgorithmOption('highDayMode', 'High days', 'How much more a high day gets, and whether low days pin to the floor instead of splitting evenly.', tmp_87, tmp_88, tmp_89, AlgorithmJson$OPTIONS$lambda_44)]);
  var tmp_90 = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_16 = this.kg_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_16, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_16.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$18 = element.bf_1;
    destination.l2(tmp$ret$18, element);
  }
  tmp_90.lg_1 = destination;
}
protoOf(AlgorithmJson).mg = function (json) {
  // Inline function 'kotlin.text.isNullOrBlank' call
  if (json == null || isBlank(json))
    return new AlgorithmSettings();
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = JsonRead_instance.og(Json_instance.ng(json), 'algorithms');
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return new AlgorithmSettings();
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var map = tmp_1;
  var tmp0 = this.kg_1;
  // Inline function 'kotlin.collections.fold' call
  var accumulator = new AlgorithmSettings();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_0 = accumulator;
    var tmp$ret$7;
    $l$block: {
      var tmp0_elvis_lhs_0 = text(AlgorithmJson_getInstance(), map.t1(element.bf_1));
      var tmp_2;
      if (tmp0_elvis_lhs_0 == null) {
        tmp$ret$7 = tmp0_0;
        break $l$block;
      } else {
        tmp_2 = tmp0_elvis_lhs_0;
      }
      var text_0 = tmp_2;
      // Inline function 'kotlin.runCatching' call
      AlgorithmJson_getInstance();
      var tmp_3;
      try {
        // Inline function 'kotlin.Companion.success' call
        var value_0 = element.hf_1(tmp0_0, text_0);
        tmp_3 = _Result___init__impl__xyqfz8(value_0);
      } catch ($p_0) {
        var tmp_4;
        if ($p_0 instanceof Error) {
          var e_0 = $p_0;
          // Inline function 'kotlin.Companion.failure' call
          tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
        } else {
          throw $p_0;
        }
        tmp_3 = tmp_4;
      }
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = tmp_3;
      var tmp1_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
      tmp$ret$7 = tmp1_elvis_lhs == null ? tmp0_0 : tmp1_elvis_lhs;
    }
    accumulator = tmp$ret$7;
  }
  return accumulator;
};
protoOf(AlgorithmJson).pg = function (settings) {
  // Inline function 'kotlin.collections.associate' call
  var this_0 = this.kg_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.bf_1, element.gf_1(settings));
    destination.l2(pair.nb_1, pair.ob_1);
  }
  return destination;
};
protoOf(AlgorithmJson).qg = function (json, key, value) {
  var tmp0_elvis_lhs = this.lg_1.t1(key);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown setting '" + key + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var option = tmp;
  var tmp_0;
  if (json == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(json)) {
      tmp_1 = json;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    AlgorithmJson_getInstance();
    var tmp_3;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value_0 = JsonRead_instance.og(Json_instance.ng(tmp2_safe_receiver), 'algorithms');
      tmp_3 = _Result___init__impl__xyqfz8(value_0);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_4 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_3;
    tmp_2 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs_0 = tmp_2;
  var raw = tmp0_elvis_lhs_0 == null ? emptyMap() : tmp0_elvis_lhs_0;
  var updated = option.hf_1(this.mg(json), value);
  return this.rg(updated, raw);
};
protoOf(AlgorithmJson).rg = function (settings, raw) {
  var out = LinkedHashMap_init_$Create$_0(raw);
  var _iterator__ex2g4s = this.kg_1.j();
  while (_iterator__ex2g4s.k()) {
    var option = _iterator__ex2g4s.l();
    var tmp2 = option.bf_1;
    // Inline function 'kotlin.collections.set' call
    var value = typed(this, option, option.gf_1(settings));
    out.l2(tmp2, value);
  }
  return Json_instance.sg(out);
};
var AlgorithmJson_instance;
function AlgorithmJson_getInstance() {
  if (AlgorithmJson_instance == null)
    new AlgorithmJson();
  return AlgorithmJson_instance;
}
function AlgorithmOptionKind_CHOICE_getInstance() {
  static_init();
  return AlgorithmOptionKind_CHOICE_instance;
}
function AlgorithmOptionKind_BOOLEAN_getInstance() {
  static_init();
  return AlgorithmOptionKind_BOOLEAN_instance;
}
function AlgorithmOptionKind_INTEGER_getInstance() {
  static_init();
  return AlgorithmOptionKind_INTEGER_instance;
}
function AlgorithmOptionKind_NUMBER_getInstance() {
  static_init();
  return AlgorithmOptionKind_NUMBER_instance;
}
function AlgorithmOptionKind_DATE_getInstance() {
  static_init();
  return AlgorithmOptionKind_DATE_instance;
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  ExpenditureEngine_V0_instance = new ExpenditureEngine('V0', 0);
  ExpenditureEngine_V1_instance = new ExpenditureEngine('V1', 1);
  ExpenditureEngine_V2_instance = new ExpenditureEngine('V2', 2);
}
var ExpenditureEngine_V0_instance;
var ExpenditureEngine_V1_instance;
var ExpenditureEngine_V2_instance;
function values() {
  static_init_0();
  return [ExpenditureEngine_V0_getInstance(), ExpenditureEngine_V1_getInstance(), ExpenditureEngine_V2_getInstance()];
}
function get_entries() {
  static_init_0();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
function ExpenditureEngine(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  ExpenditureMode_DYNAMIC_instance = new ExpenditureMode('DYNAMIC', 0);
  ExpenditureMode_STATIC_instance = new ExpenditureMode('STATIC', 1);
}
var ExpenditureMode_DYNAMIC_instance;
var ExpenditureMode_STATIC_instance;
function values_0() {
  static_init_1();
  return [ExpenditureMode_DYNAMIC_getInstance(), ExpenditureMode_STATIC_getInstance()];
}
function get_entries_0() {
  static_init_1();
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var $ENTRIES_0;
function ExpenditureMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_2;
function static_init_2() {
  if (static_init_called_2)
    return Unit_instance;
  static_init_called_2 = true;
  EnergyDensityMode_FORBES_instance = new EnergyDensityMode('FORBES', 0);
  EnergyDensityMode_FLAT_7700_instance = new EnergyDensityMode('FLAT_7700', 1);
}
var EnergyDensityMode_FORBES_instance;
var EnergyDensityMode_FLAT_7700_instance;
function values_1() {
  static_init_2();
  return [EnergyDensityMode_FORBES_getInstance(), EnergyDensityMode_FLAT_7700_getInstance()];
}
function get_entries_1() {
  static_init_2();
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var $ENTRIES_1;
function EnergyDensityMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_3;
function static_init_3() {
  if (static_init_called_3)
    return Unit_instance;
  static_init_called_3 = true;
  PredictionStyle_DATA_instance = new PredictionStyle('DATA', 0);
  PredictionStyle_GOAL_instance = new PredictionStyle('GOAL', 1);
  PredictionStyle_BLEND_instance = new PredictionStyle('BLEND', 2);
}
var PredictionStyle_DATA_instance;
var PredictionStyle_GOAL_instance;
var PredictionStyle_BLEND_instance;
function values_2() {
  static_init_3();
  return [PredictionStyle_DATA_getInstance(), PredictionStyle_GOAL_getInstance(), PredictionStyle_BLEND_getInstance()];
}
function get_entries_2() {
  static_init_3();
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_2());
  return $ENTRIES_2;
}
var $ENTRIES_2;
function PredictionStyle(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion() {
  Companion_instance_1 = this;
  this.tg_1 = 4;
  this.ug_1 = numberRangeToNumber(1, 7);
  this.vg_1 = 7;
}
var Companion_instance_1;
function Companion_getInstance() {
  if (Companion_instance_1 == null)
    new Companion();
  return Companion_instance_1;
}
function AlgorithmSettings(expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode) {
  Companion_getInstance();
  expenditureEngine = expenditureEngine === VOID ? ExpenditureEngine_V0_getInstance() : expenditureEngine;
  expenditureMode = expenditureMode === VOID ? ExpenditureMode_DYNAMIC_getInstance() : expenditureMode;
  staticKcal = staticKcal === VOID ? null : staticKcal;
  expenditureStartDay = expenditureStartDay === VOID ? null : expenditureStartDay;
  compareEngine = compareEngine === VOID ? null : compareEngine;
  holdMinUsableDays = holdMinUsableDays === VOID ? 4 : holdMinUsableDays;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? false : holdAfterLastWeighIn;
  goalAdjustmentCaps = goalAdjustmentCaps === VOID ? false : goalAdjustmentCaps;
  expenditureFloor = expenditureFloor === VOID ? ExpenditureFloorKind_NONE_getInstance() : expenditureFloor;
  energyDensity = energyDensity === VOID ? EnergyDensityMode_FORBES_getInstance() : energyDensity;
  intakePrior = intakePrior === VOID ? IntakePrior_RECENT_MEAN_getInstance() : intakePrior;
  checkInSmoothing = checkInSmoothing === VOID ? CheckInSmoothing_FIXED_getInstance() : checkInSmoothing;
  predictionStyle = predictionStyle === VOID ? PredictionStyle_DATA_getInstance() : predictionStyle;
  initial = initial === VOID ? new InitialExpenditureOptions() : initial;
  proteinMethod = proteinMethod === VOID ? ProteinMethod_LEAN_TABLE_getInstance() : proteinMethod;
  trainingType = trainingType === VOID ? TrainingType_AUTO_getInstance() : trainingType;
  proteinLeanCapKg = proteinLeanCapKg === VOID ? 80.0 : proteinLeanCapKg;
  floorMode = floorMode === VOID ? FloorMode_FIXED_getInstance() : floorMode;
  macroSplit = macroSplit === VOID ? MacroSplit_CURRENT_getInstance() : macroSplit;
  highDayMode = highDayMode === VOID ? HighDayMode_FIXED_getInstance() : highDayMode;
  this.if_1 = expenditureEngine;
  this.jf_1 = expenditureMode;
  this.kf_1 = staticKcal;
  this.lf_1 = expenditureStartDay;
  this.mf_1 = compareEngine;
  this.nf_1 = holdMinUsableDays;
  this.of_1 = holdAfterLastWeighIn;
  this.pf_1 = goalAdjustmentCaps;
  this.qf_1 = expenditureFloor;
  this.rf_1 = energyDensity;
  this.sf_1 = intakePrior;
  this.tf_1 = checkInSmoothing;
  this.uf_1 = predictionStyle;
  this.vf_1 = initial;
  this.wf_1 = proteinMethod;
  this.xf_1 = trainingType;
  this.yf_1 = proteinLeanCapKg;
  this.zf_1 = floorMode;
  this.ag_1 = macroSplit;
  this.bg_1 = highDayMode;
  var progression = Companion_getInstance().ug_1;
  var containsLower = progression.xc_1;
  var containsUpper = progression.yc_1;
  var containsArg = this.nf_1;
  // Inline function 'kotlin.require' call
  if (!(containsLower <= containsArg ? containsArg <= containsUpper : false)) {
    var message = 'holdMinUsableDays must be ' + Companion_getInstance().ug_1.toString();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.yf_1 > 0.0)) {
    var message_0 = 'proteinLeanCapKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(AlgorithmSettings).wg = function () {
  return new CheckInParams(8 - this.nf_1 | 0);
};
protoOf(AlgorithmSettings).xg = function (weightKg, bodyFatFraction) {
  var tmp;
  switch (this.rf_1.y1_1) {
    case 0:
      tmp = EnergyDensity_instance.xg(weightKg, bodyFatFraction);
      break;
    case 1:
      tmp = 7700.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(AlgorithmSettings).dh = function (expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode) {
  return new AlgorithmSettings(expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode);
};
protoOf(AlgorithmSettings).cg = function (expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode, $super) {
  expenditureEngine = expenditureEngine === VOID ? this.if_1 : expenditureEngine;
  expenditureMode = expenditureMode === VOID ? this.jf_1 : expenditureMode;
  staticKcal = staticKcal === VOID ? this.kf_1 : staticKcal;
  expenditureStartDay = expenditureStartDay === VOID ? this.lf_1 : expenditureStartDay;
  compareEngine = compareEngine === VOID ? this.mf_1 : compareEngine;
  holdMinUsableDays = holdMinUsableDays === VOID ? this.nf_1 : holdMinUsableDays;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? this.of_1 : holdAfterLastWeighIn;
  goalAdjustmentCaps = goalAdjustmentCaps === VOID ? this.pf_1 : goalAdjustmentCaps;
  expenditureFloor = expenditureFloor === VOID ? this.qf_1 : expenditureFloor;
  energyDensity = energyDensity === VOID ? this.rf_1 : energyDensity;
  intakePrior = intakePrior === VOID ? this.sf_1 : intakePrior;
  checkInSmoothing = checkInSmoothing === VOID ? this.tf_1 : checkInSmoothing;
  predictionStyle = predictionStyle === VOID ? this.uf_1 : predictionStyle;
  initial = initial === VOID ? this.vf_1 : initial;
  proteinMethod = proteinMethod === VOID ? this.wf_1 : proteinMethod;
  trainingType = trainingType === VOID ? this.xf_1 : trainingType;
  proteinLeanCapKg = proteinLeanCapKg === VOID ? this.yf_1 : proteinLeanCapKg;
  floorMode = floorMode === VOID ? this.zf_1 : floorMode;
  macroSplit = macroSplit === VOID ? this.ag_1 : macroSplit;
  highDayMode = highDayMode === VOID ? this.bg_1 : highDayMode;
  return $super === VOID ? this.dh(expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode) : $super.dh.call(this, expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode);
};
protoOf(AlgorithmSettings).toString = function () {
  return 'AlgorithmSettings(expenditureEngine=' + this.if_1.toString() + ', expenditureMode=' + this.jf_1.toString() + ', staticKcal=' + this.kf_1 + ', expenditureStartDay=' + this.lf_1 + ', compareEngine=' + toString_0(this.mf_1) + ', holdMinUsableDays=' + this.nf_1 + ', holdAfterLastWeighIn=' + this.of_1 + ', goalAdjustmentCaps=' + this.pf_1 + ', expenditureFloor=' + this.qf_1.toString() + ', energyDensity=' + this.rf_1.toString() + ', intakePrior=' + this.sf_1.toString() + ', checkInSmoothing=' + this.tf_1.toString() + ', predictionStyle=' + this.uf_1.toString() + ', initial=' + this.vf_1.toString() + ', proteinMethod=' + this.wf_1.toString() + ', trainingType=' + this.xf_1.toString() + ', proteinLeanCapKg=' + this.yf_1 + ', floorMode=' + this.zf_1.toString() + ', macroSplit=' + this.ag_1.toString() + ', highDayMode=' + this.bg_1.toString() + ')';
};
protoOf(AlgorithmSettings).hashCode = function () {
  var result = this.if_1.hashCode();
  result = imul(result, 31) + this.jf_1.hashCode() | 0;
  result = imul(result, 31) + (this.kf_1 == null ? 0 : getNumberHashCode(this.kf_1)) | 0;
  result = imul(result, 31) + (this.lf_1 == null ? 0 : this.lf_1) | 0;
  result = imul(result, 31) + (this.mf_1 == null ? 0 : this.mf_1.hashCode()) | 0;
  result = imul(result, 31) + this.nf_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.of_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.pf_1) | 0;
  result = imul(result, 31) + this.qf_1.hashCode() | 0;
  result = imul(result, 31) + this.rf_1.hashCode() | 0;
  result = imul(result, 31) + this.sf_1.hashCode() | 0;
  result = imul(result, 31) + this.tf_1.hashCode() | 0;
  result = imul(result, 31) + this.uf_1.hashCode() | 0;
  result = imul(result, 31) + this.vf_1.hashCode() | 0;
  result = imul(result, 31) + this.wf_1.hashCode() | 0;
  result = imul(result, 31) + this.xf_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.yf_1) | 0;
  result = imul(result, 31) + this.zf_1.hashCode() | 0;
  result = imul(result, 31) + this.ag_1.hashCode() | 0;
  result = imul(result, 31) + this.bg_1.hashCode() | 0;
  return result;
};
protoOf(AlgorithmSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlgorithmSettings))
    return false;
  if (!this.if_1.equals(other.if_1))
    return false;
  if (!this.jf_1.equals(other.jf_1))
    return false;
  if (!equals(this.kf_1, other.kf_1))
    return false;
  if (!(this.lf_1 == other.lf_1))
    return false;
  if (!equals(this.mf_1, other.mf_1))
    return false;
  if (!(this.nf_1 === other.nf_1))
    return false;
  if (!(this.of_1 === other.of_1))
    return false;
  if (!(this.pf_1 === other.pf_1))
    return false;
  if (!this.qf_1.equals(other.qf_1))
    return false;
  if (!this.rf_1.equals(other.rf_1))
    return false;
  if (!this.sf_1.equals(other.sf_1))
    return false;
  if (!this.tf_1.equals(other.tf_1))
    return false;
  if (!this.uf_1.equals(other.uf_1))
    return false;
  if (!this.vf_1.equals(other.vf_1))
    return false;
  if (!this.wf_1.equals(other.wf_1))
    return false;
  if (!this.xf_1.equals(other.xf_1))
    return false;
  if (!equals(this.yf_1, other.yf_1))
    return false;
  if (!this.zf_1.equals(other.zf_1))
    return false;
  if (!this.ag_1.equals(other.ag_1))
    return false;
  if (!this.bg_1.equals(other.bg_1))
    return false;
  return true;
};
function ExpenditureEngine_V0_getInstance() {
  static_init_0();
  return ExpenditureEngine_V0_instance;
}
function ExpenditureEngine_V1_getInstance() {
  static_init_0();
  return ExpenditureEngine_V1_instance;
}
function ExpenditureEngine_V2_getInstance() {
  static_init_0();
  return ExpenditureEngine_V2_instance;
}
function ExpenditureMode_DYNAMIC_getInstance() {
  static_init_1();
  return ExpenditureMode_DYNAMIC_instance;
}
function ExpenditureMode_STATIC_getInstance() {
  static_init_1();
  return ExpenditureMode_STATIC_instance;
}
function EnergyDensityMode_FORBES_getInstance() {
  static_init_2();
  return EnergyDensityMode_FORBES_instance;
}
function EnergyDensityMode_FLAT_7700_getInstance() {
  static_init_2();
  return EnergyDensityMode_FLAT_7700_instance;
}
function PredictionStyle_DATA_getInstance() {
  static_init_3();
  return PredictionStyle_DATA_instance;
}
function PredictionStyle_GOAL_getInstance() {
  static_init_3();
  return PredictionStyle_GOAL_instance;
}
function PredictionStyle_BLEND_getInstance() {
  static_init_3();
  return PredictionStyle_BLEND_instance;
}
var static_init_called_4;
function static_init_4() {
  if (static_init_called_4)
    return Unit_instance;
  static_init_called_4 = true;
  FloorMode_FIXED_instance = new FloorMode('FIXED', 0);
  FloorMode_BODY_SIZE_instance = new FloorMode('BODY_SIZE', 1);
}
var FloorMode_FIXED_instance;
var FloorMode_BODY_SIZE_instance;
function values_3() {
  static_init_4();
  return [FloorMode_FIXED_getInstance(), FloorMode_BODY_SIZE_getInstance()];
}
function get_entries_3() {
  static_init_4();
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_3());
  return $ENTRIES_3;
}
var $ENTRIES_3;
function FloorMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MacroMinimums(fatG, carbsG, proteinG) {
  this.eh_1 = fatG;
  this.fh_1 = carbsG;
  this.gh_1 = proteinG;
}
protoOf(MacroMinimums).hh = function () {
  return Macros_instance.th(this.gh_1, this.eh_1, this.fh_1);
};
protoOf(MacroMinimums).toString = function () {
  return 'MacroMinimums(fatG=' + this.eh_1 + ', carbsG=' + this.fh_1 + ', proteinG=' + this.gh_1 + ')';
};
protoOf(MacroMinimums).hashCode = function () {
  var result = getNumberHashCode(this.eh_1);
  result = imul(result, 31) + getNumberHashCode(this.fh_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.gh_1) | 0;
  return result;
};
protoOf(MacroMinimums).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MacroMinimums))
    return false;
  if (!equals(this.eh_1, other.eh_1))
    return false;
  if (!equals(this.fh_1, other.fh_1))
    return false;
  if (!equals(this.gh_1, other.gh_1))
    return false;
  return true;
};
function CalorieFloors() {
  this.uh_1 = 1.3;
  this.vh_1 = 50.0;
  this.wh_1 = 1.2;
}
protoOf(CalorieFloors).xh = function (mode, bodyWeightKg, leanMassKg, heightCm, leanCapKg) {
  var tmp;
  switch (mode.y1_1) {
    case 0:
    case 1:
      var tmp_0 = 0.6 * bodyWeightKg;
      // Inline function 'kotlin.math.min' call

      var tmp$ret$0 = Math.min(leanMassKg, leanCapKg);
      tmp = new MacroMinimums(tmp_0, 50.0, 1.2 * tmp$ret$0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CalorieFloors).yh = function (mode, floor, minimums) {
  var tmp0_elvis_lhs = floor.bi_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var fixed = tmp;
  var tmp_0;
  switch (mode.y1_1) {
    case 0:
      return fixed;
    case 1:
      tmp_0 = 1.3;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var margin = tmp_0;
  var tmp_1;
  switch (floor.y1_1) {
    case 0:
      // Inline function 'kotlin.math.max' call

      var b = margin * minimums.hh();
      tmp_1 = Math.max(fixed, b);
      break;
    case 1:
      // Inline function 'kotlin.math.max' call

      var b_0 = minimums.hh();
      tmp_1 = Math.max(fixed, b_0);
      break;
    case 2:
      tmp_1 = null;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_1;
};
var CalorieFloors_instance;
function CalorieFloors_getInstance() {
  return CalorieFloors_instance;
}
function FloorMode_FIXED_getInstance() {
  static_init_4();
  return FloorMode_FIXED_instance;
}
function FloorMode_BODY_SIZE_getInstance() {
  static_init_4();
  return FloorMode_BODY_SIZE_instance;
}
var static_init_called_5;
function static_init_5() {
  if (static_init_called_5)
    return Unit_instance;
  static_init_called_5 = true;
  GoalType_LOSE_instance = new GoalType('LOSE', 0);
  GoalType_MAINTAIN_instance = new GoalType('MAINTAIN', 1);
  GoalType_GAIN_instance = new GoalType('GAIN', 2);
}
var GoalType_LOSE_instance;
var GoalType_MAINTAIN_instance;
var GoalType_GAIN_instance;
function values_4() {
  static_init_5();
  return [GoalType_LOSE_getInstance(), GoalType_MAINTAIN_getInstance(), GoalType_GAIN_getInstance()];
}
function valueOf(value) {
  static_init_5();
  switch (value) {
    case 'LOSE':
      return GoalType_LOSE_getInstance();
    case 'MAINTAIN':
      return GoalType_MAINTAIN_getInstance();
    case 'GAIN':
      return GoalType_GAIN_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.GoalType.' + value);
      break;
  }
}
function get_entries_4() {
  static_init_5();
  if ($ENTRIES_4 == null)
    $ENTRIES_4 = enumEntries(values_4());
  return $ENTRIES_4;
}
var $ENTRIES_4;
function GoalType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function GoalAvailability() {
  this.ci_1 = 18;
  this.di_1 = "Weight-loss goals aren't offered under 18. A doctor or dietitian can help.";
}
protoOf(GoalAvailability).ei = function (ageYears) {
  return !(ageYears == null) && ageYears < 18 ? minus(get_entries_4(), GoalType_LOSE_getInstance()) : toList(get_entries_4());
};
var GoalAvailability_instance;
function GoalAvailability_getInstance() {
  return GoalAvailability_instance;
}
function Goal(type, ratePctPerWeek, targetWeightKg) {
  this.fi_1 = type;
  this.gi_1 = ratePctPerWeek;
  this.hi_1 = targetWeightKg;
}
protoOf(Goal).ii = function (type, ratePctPerWeek, targetWeightKg) {
  return new Goal(type, ratePctPerWeek, targetWeightKg);
};
protoOf(Goal).ji = function (type, ratePctPerWeek, targetWeightKg, $super) {
  type = type === VOID ? this.fi_1 : type;
  ratePctPerWeek = ratePctPerWeek === VOID ? this.gi_1 : ratePctPerWeek;
  targetWeightKg = targetWeightKg === VOID ? this.hi_1 : targetWeightKg;
  return $super === VOID ? this.ii(type, ratePctPerWeek, targetWeightKg) : $super.ii.call(this, type, ratePctPerWeek, targetWeightKg);
};
protoOf(Goal).toString = function () {
  return 'Goal(type=' + this.fi_1.toString() + ', ratePctPerWeek=' + this.gi_1 + ', targetWeightKg=' + this.hi_1 + ')';
};
protoOf(Goal).hashCode = function () {
  var result = this.fi_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.gi_1) | 0;
  result = imul(result, 31) + (this.hi_1 == null ? 0 : getNumberHashCode(this.hi_1)) | 0;
  return result;
};
protoOf(Goal).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Goal))
    return false;
  if (!this.fi_1.equals(other.fi_1))
    return false;
  if (!equals(this.gi_1, other.gi_1))
    return false;
  if (!equals(this.hi_1, other.hi_1))
    return false;
  return true;
};
var static_init_called_6;
function static_init_6() {
  if (static_init_called_6)
    return Unit_instance;
  static_init_called_6 = true;
  CalorieFloor_STANDARD_instance = new CalorieFloor('STANDARD', 0, 1200.0);
  CalorieFloor_LOW_instance = new CalorieFloor('LOW', 1, 800.0);
  CalorieFloor_NONE_instance = new CalorieFloor('NONE', 2, null);
}
var CalorieFloor_STANDARD_instance;
var CalorieFloor_LOW_instance;
var CalorieFloor_NONE_instance;
function values_5() {
  static_init_6();
  return [CalorieFloor_STANDARD_getInstance(), CalorieFloor_LOW_getInstance(), CalorieFloor_NONE_getInstance()];
}
function valueOf_0(value) {
  static_init_6();
  switch (value) {
    case 'STANDARD':
      return CalorieFloor_STANDARD_getInstance();
    case 'LOW':
      return CalorieFloor_LOW_getInstance();
    case 'NONE':
      return CalorieFloor_NONE_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.CalorieFloor.' + value);
      break;
  }
}
function CalorieFloor(name, ordinal, kcal) {
  Enum.call(this, name, ordinal);
  this.bi_1 = kcal;
}
var static_init_called_7;
function static_init_7() {
  if (static_init_called_7)
    return Unit_instance;
  static_init_called_7 = true;
  CheckInSmoothing_FIXED_instance = new CheckInSmoothing('FIXED', 0);
  CheckInSmoothing_NONE_instance = new CheckInSmoothing('NONE', 1);
  CheckInSmoothing_ADAPTIVE_instance = new CheckInSmoothing('ADAPTIVE', 2);
}
var CheckInSmoothing_FIXED_instance;
var CheckInSmoothing_NONE_instance;
var CheckInSmoothing_ADAPTIVE_instance;
function values_6() {
  static_init_7();
  return [CheckInSmoothing_FIXED_getInstance(), CheckInSmoothing_NONE_getInstance(), CheckInSmoothing_ADAPTIVE_getInstance()];
}
function get_entries_5() {
  static_init_7();
  if ($ENTRIES_5 == null)
    $ENTRIES_5 = enumEntries(values_6());
  return $ENTRIES_5;
}
var $ENTRIES_5;
function CheckInSmoothing(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function CheckInInput(expenditureKcal, trendWeightKg, goal, kcalPerKg, previousTargetKcal, sameDirectionWeeks, expenditureHolding, calorieFloor, floorKcal, smoothing, expenditureSdKcal) {
  sameDirectionWeeks = sameDirectionWeeks === VOID ? 0 : sameDirectionWeeks;
  expenditureHolding = expenditureHolding === VOID ? false : expenditureHolding;
  calorieFloor = calorieFloor === VOID ? CalorieFloor_STANDARD_getInstance() : calorieFloor;
  floorKcal = floorKcal === VOID ? calorieFloor.bi_1 : floorKcal;
  smoothing = smoothing === VOID ? CheckInSmoothing_FIXED_getInstance() : smoothing;
  expenditureSdKcal = expenditureSdKcal === VOID ? null : expenditureSdKcal;
  this.ki_1 = expenditureKcal;
  this.li_1 = trendWeightKg;
  this.mi_1 = goal;
  this.ni_1 = kcalPerKg;
  this.oi_1 = previousTargetKcal;
  this.pi_1 = sameDirectionWeeks;
  this.qi_1 = expenditureHolding;
  this.ri_1 = calorieFloor;
  this.si_1 = floorKcal;
  this.ti_1 = smoothing;
  this.ui_1 = expenditureSdKcal;
}
protoOf(CheckInInput).toString = function () {
  return 'CheckInInput(expenditureKcal=' + this.ki_1 + ', trendWeightKg=' + this.li_1 + ', goal=' + this.mi_1.toString() + ', kcalPerKg=' + this.ni_1 + ', previousTargetKcal=' + this.oi_1 + ', sameDirectionWeeks=' + this.pi_1 + ', expenditureHolding=' + this.qi_1 + ', calorieFloor=' + this.ri_1.toString() + ', floorKcal=' + this.si_1 + ', smoothing=' + this.ti_1.toString() + ', expenditureSdKcal=' + this.ui_1 + ')';
};
protoOf(CheckInInput).hashCode = function () {
  var result = getNumberHashCode(this.ki_1);
  result = imul(result, 31) + getNumberHashCode(this.li_1) | 0;
  result = imul(result, 31) + this.mi_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.ni_1) | 0;
  result = imul(result, 31) + (this.oi_1 == null ? 0 : getNumberHashCode(this.oi_1)) | 0;
  result = imul(result, 31) + this.pi_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.qi_1) | 0;
  result = imul(result, 31) + this.ri_1.hashCode() | 0;
  result = imul(result, 31) + (this.si_1 == null ? 0 : getNumberHashCode(this.si_1)) | 0;
  result = imul(result, 31) + this.ti_1.hashCode() | 0;
  result = imul(result, 31) + (this.ui_1 == null ? 0 : getNumberHashCode(this.ui_1)) | 0;
  return result;
};
protoOf(CheckInInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInInput))
    return false;
  if (!equals(this.ki_1, other.ki_1))
    return false;
  if (!equals(this.li_1, other.li_1))
    return false;
  if (!this.mi_1.equals(other.mi_1))
    return false;
  if (!equals(this.ni_1, other.ni_1))
    return false;
  if (!equals(this.oi_1, other.oi_1))
    return false;
  if (!(this.pi_1 === other.pi_1))
    return false;
  if (!(this.qi_1 === other.qi_1))
    return false;
  if (!this.ri_1.equals(other.ri_1))
    return false;
  if (!equals(this.si_1, other.si_1))
    return false;
  if (!this.ti_1.equals(other.ti_1))
    return false;
  if (!equals(this.ui_1, other.ui_1))
    return false;
  return true;
};
function CheckInResult(targetKcal, rawTargetKcal, effectiveRatePctPerWeek, limitedByFloor, changeKcal) {
  this.vi_1 = targetKcal;
  this.wi_1 = rawTargetKcal;
  this.xi_1 = effectiveRatePctPerWeek;
  this.yi_1 = limitedByFloor;
  this.zi_1 = changeKcal;
}
protoOf(CheckInResult).toString = function () {
  return 'CheckInResult(targetKcal=' + this.vi_1 + ', rawTargetKcal=' + this.wi_1 + ', effectiveRatePctPerWeek=' + this.xi_1 + ', limitedByFloor=' + this.yi_1 + ', changeKcal=' + this.zi_1 + ')';
};
protoOf(CheckInResult).hashCode = function () {
  var result = getNumberHashCode(this.vi_1);
  result = imul(result, 31) + getNumberHashCode(this.wi_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.xi_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.yi_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.zi_1) | 0;
  return result;
};
protoOf(CheckInResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInResult))
    return false;
  if (!equals(this.vi_1, other.vi_1))
    return false;
  if (!equals(this.wi_1, other.wi_1))
    return false;
  if (!equals(this.xi_1, other.xi_1))
    return false;
  if (!(this.yi_1 === other.yi_1))
    return false;
  if (!equals(this.zi_1, other.zi_1))
    return false;
  return true;
};
function Persistence(direction, weeks) {
  direction = direction === VOID ? 0 : direction;
  weeks = weeks === VOID ? 0 : weeks;
  this.aj_1 = direction;
  this.bj_1 = weeks;
}
protoOf(Persistence).toString = function () {
  return 'Persistence(direction=' + this.aj_1 + ', weeks=' + this.bj_1 + ')';
};
protoOf(Persistence).hashCode = function () {
  var result = this.aj_1;
  result = imul(result, 31) + this.bj_1 | 0;
  return result;
};
protoOf(Persistence).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Persistence))
    return false;
  if (!(this.aj_1 === other.aj_1))
    return false;
  if (!(this.bj_1 === other.bj_1))
    return false;
  return true;
};
function CheckIn() {
  this.cj_1 = 0.35;
  this.dj_1 = 0.6;
  this.ej_1 = 3;
  this.fj_1 = 0.7;
  this.gj_1 = 0.15;
  this.hj_1 = 100.0;
}
protoOf(CheckIn).ij = function (goal, trendWeightKg) {
  var tmp;
  switch (goal.fi_1.y1_1) {
    case 0:
      // Inline function 'kotlin.math.abs' call

      var x = goal.gi_1;
      tmp = -Math.abs(x);
      break;
    case 2:
      // Inline function 'kotlin.math.abs' call

      var x_0 = goal.gi_1;
      tmp = Math.abs(x_0);
      break;
    case 1:
      var target = goal.hi_1;
      tmp = target == null ? 0.0 : trendWeightKg > target + 0.7 ? -0.15 : trendWeightKg < target - 0.7 ? 0.15 : 0.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CheckIn).jj = function (ratePctPerWeek, trendWeightKg, kcalPerKg) {
  return ratePctPerWeek / 100.0 * trendWeightKg * kcalPerKg / 7.0;
};
protoOf(CheckIn).kj = function (smoothing, sameDirectionWeeks, expenditureSdKcal) {
  var fixed = sameDirectionWeeks >= 3 ? 0.6 : 0.35;
  var tmp;
  switch (smoothing.y1_1) {
    case 0:
      tmp = fixed;
      break;
    case 1:
      tmp = 1.0;
      break;
    case 2:
      var tmp_0;
      if (expenditureSdKcal == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_1;
        if (expenditureSdKcal >= 0.0) {
          tmp_1 = expenditureSdKcal;
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }

      var tmp2_safe_receiver = tmp_0;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = coerceIn(100.0 / (100.0 + tmp2_safe_receiver), 0.35, 1.0);
      }

      var tmp3_elvis_lhs = tmp_2;
      tmp = tmp3_elvis_lhs == null ? fixed : tmp3_elvis_lhs;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CheckIn).lj = function (input) {
  var rate = this.ij(input.mi_1, input.li_1);
  var raw = input.ki_1 + this.jj(rate, input.li_1, input.ni_1);
  var previous = input.oi_1;
  var smoothed = previous == null ? raw : input.qi_1 ? previous : previous + this.kj(input.ti_1, input.pi_1, input.ui_1) * (raw - previous);
  var floor = input.si_1;
  var limited = !(floor == null) && smoothed < floor;
  var target = !(floor == null) && limited ? floor : smoothed;
  return new CheckInResult(target, raw, rate, limited, previous == null ? 0.0 : target - previous);
};
protoOf(CheckIn).mj = function (current, previousTargetKcal, rawTargetKcal) {
  if (previousTargetKcal == null)
    return new Persistence();
  var direction = rawTargetKcal > previousTargetKcal ? 1 : rawTargetKcal < previousTargetKcal ? -1 : 0;
  return direction === 0 ? new Persistence() : direction === current.aj_1 ? new Persistence(direction, current.bj_1 + 1 | 0) : new Persistence(direction, 1);
};
var CheckIn_instance;
function CheckIn_getInstance() {
  return CheckIn_instance;
}
function GoalType_LOSE_getInstance() {
  static_init_5();
  return GoalType_LOSE_instance;
}
function GoalType_MAINTAIN_getInstance() {
  static_init_5();
  return GoalType_MAINTAIN_instance;
}
function GoalType_GAIN_getInstance() {
  static_init_5();
  return GoalType_GAIN_instance;
}
function CalorieFloor_STANDARD_getInstance() {
  static_init_6();
  return CalorieFloor_STANDARD_instance;
}
function CalorieFloor_LOW_getInstance() {
  static_init_6();
  return CalorieFloor_LOW_instance;
}
function CalorieFloor_NONE_getInstance() {
  static_init_6();
  return CalorieFloor_NONE_instance;
}
function CheckInSmoothing_FIXED_getInstance() {
  static_init_7();
  return CheckInSmoothing_FIXED_instance;
}
function CheckInSmoothing_NONE_getInstance() {
  static_init_7();
  return CheckInSmoothing_NONE_instance;
}
function CheckInSmoothing_ADAPTIVE_getInstance() {
  static_init_7();
  return CheckInSmoothing_ADAPTIVE_instance;
}
function RecoveryTrend(weekAverage, baselineAverage) {
  this.nj_1 = weekAverage;
  this.oj_1 = baselineAverage;
}
protoOf(RecoveryTrend).toString = function () {
  return 'RecoveryTrend(weekAverage=' + this.nj_1 + ', baselineAverage=' + this.oj_1 + ')';
};
protoOf(RecoveryTrend).hashCode = function () {
  var result = getNumberHashCode(this.nj_1);
  result = imul(result, 31) + (this.oj_1 == null ? 0 : getNumberHashCode(this.oj_1)) | 0;
  return result;
};
protoOf(RecoveryTrend).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecoveryTrend))
    return false;
  if (!equals(this.nj_1, other.nj_1))
    return false;
  if (!equals(this.oj_1, other.oj_1))
    return false;
  return true;
};
function RecoverySignals(sleepAverageMin, shortSleep, energyAvailability, lowEnergyAvailability, restingHr, hrvMs) {
  this.pj_1 = sleepAverageMin;
  this.qj_1 = shortSleep;
  this.rj_1 = energyAvailability;
  this.sj_1 = lowEnergyAvailability;
  this.tj_1 = restingHr;
  this.uj_1 = hrvMs;
}
protoOf(RecoverySignals).toString = function () {
  return 'RecoverySignals(sleepAverageMin=' + this.pj_1 + ', shortSleep=' + this.qj_1 + ', energyAvailability=' + this.rj_1 + ', lowEnergyAvailability=' + this.sj_1 + ', restingHr=' + toString_0(this.tj_1) + ', hrvMs=' + toString_0(this.uj_1) + ')';
};
protoOf(RecoverySignals).hashCode = function () {
  var result = this.pj_1 == null ? 0 : getNumberHashCode(this.pj_1);
  result = imul(result, 31) + getBooleanHashCode(this.qj_1) | 0;
  result = imul(result, 31) + (this.rj_1 == null ? 0 : getNumberHashCode(this.rj_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.sj_1) | 0;
  result = imul(result, 31) + (this.tj_1 == null ? 0 : this.tj_1.hashCode()) | 0;
  result = imul(result, 31) + (this.uj_1 == null ? 0 : this.uj_1.hashCode()) | 0;
  return result;
};
protoOf(RecoverySignals).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecoverySignals))
    return false;
  if (!equals(this.pj_1, other.pj_1))
    return false;
  if (!(this.qj_1 === other.qj_1))
    return false;
  if (!equals(this.rj_1, other.rj_1))
    return false;
  if (!(this.sj_1 === other.sj_1))
    return false;
  if (!equals(this.tj_1, other.tj_1))
    return false;
  if (!equals(this.uj_1, other.uj_1))
    return false;
  return true;
};
function trendText($this, trend, unit) {
  var tmp = Fmt_instance.ie(trend.nj_1) + ' ' + unit + ' this week';
  var tmp0_safe_receiver = trend.oj_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = ' against ' + Fmt_instance.ie(tmp0_safe_receiver) + ' ' + unit + ' over the previous 30 days';
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
}
function hoursMinutes($this, minutes) {
  var total = numberToInt(round(minutes));
  return '' + (total / 60 | 0) + ' h ' + padStart((total % 60 | 0).toString(), 2, _Char___init__impl__6a9atx(48)) + ' min';
}
function average_0($this, values) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = values.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  if (destination.o() >= 4) {
    tmp = destination;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  return tmp0_safe_receiver == null ? null : average(tmp0_safe_receiver);
}
function recovery$trend(support, week, baseline, pick) {
  if (!support)
    return null;
  var tmp = CheckInSignals_instance;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = week.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = pick(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var tmp0_elvis_lhs = average_0(tmp, destination);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var recent = tmp_0;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = baseline.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver_0 = pick(element_0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    if (element_1 > 0.0) {
      destination_1.f(element_1);
    }
  }
  var past = destination_1;
  // Inline function 'kotlin.takeIf' call
  var tmp_1;
  if (past.o() >= 7) {
    tmp_1 = past;
  } else {
    tmp_1 = null;
  }
  var tmp1_safe_receiver = tmp_1;
  return new RecoveryTrend(recent, tmp1_safe_receiver == null ? null : average(tmp1_safe_receiver));
}
function CheckInSignals$recovery$lambda(it) {
  return it.yj_1;
}
function CheckInSignals$recovery$lambda_0(it) {
  return it.xj_1;
}
function CheckInSignals() {
  this.zj_1 = 330.0;
  this.ak_1 = 30.0;
  this.bk_1 = 4;
  this.ck_1 = 30;
  this.dk_1 = 7;
}
protoOf(CheckInSignals).ek = function (day, recovery, intake, reviewFrom, reviewTo, fatFreeMassKg, deficit, loggingBreak, strengthFalling) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = recovery.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsLower = (day - 7 | 0) + 1 | 0;
    var containsArg = element.vj_1;
    if (containsLower <= containsArg ? containsArg <= day : false) {
      destination.f(element);
    }
  }
  var week = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = week.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = element_0.wj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver);
    }
  }
  var sleep = average_0(this, destination_0);
  var shortSleep = deficit && !(sleep == null) && sleep <= 330.0 + 1.0E-9;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = intake.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp;
    var containsArg_0 = element_1.fk_1;
    if (reviewFrom <= containsArg_0 ? containsArg_0 <= reviewTo : false) {
      tmp = element_1.hk_1.equals(DayStatus_COMPLETE_getInstance()) || element_1.hk_1.equals(DayStatus_FASTED_getInstance());
    } else {
      tmp = false;
    }
    if (tmp) {
      destination_1.f(element_1);
    }
  }
  var usable = destination_1;
  var tmp_0;
  var tmp_1;
  if (!(fatFreeMassKg == null) && fatFreeMassKg > 0.0 && !loggingBreak) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_1 = !usable.m();
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = usable.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      var tmp_2 = sum;
      sum = tmp_2 + (element_2.hk_1.equals(DayStatus_FASTED_getInstance()) ? 0.0 : element_2.gk_1);
    }
    tmp_0 = sum / usable.o() / fatFreeMassKg;
  } else {
    tmp_0 = null;
  }
  var ea = tmp_0;
  var lowEa = !(ea == null) && ea < 30.0;
  var support = lowEa || strengthFalling;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = recovery.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var containsLower_0 = ((day - 7 | 0) - 30 | 0) + 1 | 0;
    var containsUpper = day - 7 | 0;
    var containsArg_1 = element_3.vj_1;
    if (containsLower_0 <= containsArg_1 ? containsArg_1 <= containsUpper : false) {
      destination_2.f(element_3);
    }
  }
  var baseline = destination_2;
  var tmp_3 = recovery$trend(support, week, baseline, CheckInSignals$recovery$lambda);
  return new RecoverySignals(sleep, shortSleep, ea, lowEa, tmp_3, recovery$trend(support, week, baseline, CheckInSignals$recovery$lambda_0));
};
protoOf(CheckInSignals).ik = function (signals) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$_0();
  if (signals.qj_1) {
    var tmp0_elvis_lhs = signals.pj_1;
    var minutes = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    this_0.f(new CheckInFlag(CheckInModule_RECOVERY_getInstance(), CheckInFlagCode_SHORT_SLEEP_getInstance(), 'You slept about ' + hoursMinutes(CheckInSignals_instance, minutes) + ' a night this week. In a trial of dieters, sleeping 5.5 hours instead of ' + '8.5 meant less fat and more muscle lost, with more hunger. Getting more sleep may help more than cutting further.'));
  }
  if (signals.sj_1) {
    var tmp = CheckInModule_RECOVERY_getInstance();
    var tmp_0 = CheckInFlagCode_LOW_ENERGY_AVAILABILITY_getInstance();
    var tmp_1 = Fmt_instance;
    var tmp1_elvis_lhs = signals.rj_1;
    this_0.f(new CheckInFlag(tmp, tmp_0, 'Before any exercise, you ate about ' + tmp_1.ie(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) + ' kcal per kg of fat-free mass a day ' + 'this week, and exercise leaves less than that for the rest of your body. A study found hormone changes below 30 kcal per kg of fat-free mass. This is not a diagnosis: if it carries on and you feel run down or unwell, talk to a health professional.'));
  }
  var tmp2_safe_receiver = signals.tj_1;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = 'resting heart rate ' + trendText(CheckInSignals_instance, tmp2_safe_receiver, 'bpm');
  }
  var tmp_3 = tmp_2;
  var tmp3_safe_receiver = signals.uj_1;
  var tmp_4;
  if (tmp3_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = 'HRV ' + trendText(CheckInSignals_instance, tmp3_safe_receiver, 'ms');
  }
  var context = listOfNotNull([tmp_3, tmp_4]);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!context.m()) {
    this_0.f(new CheckInFlag(CheckInModule_RECOVERY_getInstance(), CheckInFlagCode_RECOVERY_CONTEXT_getInstance(), 'For context only: ' + joinToString(context, '; ') + '. These readings are too noisy to act on by themselves.'));
  }
  return this_0.y3();
};
var CheckInSignals_instance;
function CheckInSignals_getInstance() {
  return CheckInSignals_instance;
}
var static_init_called_8;
function static_init_8() {
  if (static_init_called_8)
    return Unit_instance;
  static_init_called_8 = true;
  MacroField_KCAL_instance = new MacroField('KCAL', 0);
  MacroField_PROTEIN_instance = new MacroField('PROTEIN', 1);
  MacroField_FAT_instance = new MacroField('FAT', 2);
  MacroField_CARBS_instance = new MacroField('CARBS', 3);
}
var MacroField_KCAL_instance;
var MacroField_PROTEIN_instance;
var MacroField_FAT_instance;
var MacroField_CARBS_instance;
function valueOf_1(value) {
  static_init_8();
  switch (value) {
    case 'KCAL':
      return MacroField_KCAL_getInstance();
    case 'PROTEIN':
      return MacroField_PROTEIN_getInstance();
    case 'FAT':
      return MacroField_FAT_getInstance();
    case 'CARBS':
      return MacroField_CARBS_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.MacroField.' + value);
      break;
  }
}
function MacroField(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function editDay($this, day, field, value, bodyWeightKg, diet, keepCalories) {
  var tmp;
  switch (field.y1_1) {
    case 0:
      tmp = Macros_instance.nk(value, bodyWeightKg, day.kk_1, diet);
      break;
    case 1:
      var tmp_0;
      if (keepCalories) {
        tmp_0 = withProtein($this, day.jk_1, value, bodyWeightKg, diet);
      } else {
        tmp_0 = new MacroTargets(Macros_instance.th(value, day.lk_1, day.mk_1), value, day.lk_1, day.mk_1);
      }

      tmp = tmp_0;
      break;
    case 2:
      var tmp_1;
      if (keepCalories) {
        // Inline function 'kotlin.math.max' call
        var b = day.jk_1 - day.kk_1 * 4.0;
        // Inline function 'kotlin.math.min' call
        var b_0 = Math.max(0.0, b) / 9.0;
        var fat = Math.min(value, b_0);
        // Inline function 'kotlin.math.max' call
        var b_1 = (day.jk_1 - day.kk_1 * 4.0 - fat * 9.0) / 4.0;
        var carbs = Math.max(0.0, b_1);
        tmp_1 = new MacroTargets(day.jk_1, day.kk_1, fat, carbs);
      } else {
        tmp_1 = new MacroTargets(Macros_instance.th(day.kk_1, value, day.mk_1), day.kk_1, value, day.mk_1);
      }

      tmp = tmp_1;
      break;
    case 3:
      var tmp_2;
      if (keepCalories) {
        // Inline function 'kotlin.math.max' call
        var b_2 = day.jk_1 - day.kk_1 * 4.0;
        // Inline function 'kotlin.math.min' call
        var b_3 = Math.max(0.0, b_2) / 4.0;
        var carbs_0 = Math.min(value, b_3);
        // Inline function 'kotlin.math.max' call
        var b_4 = (day.jk_1 - day.kk_1 * 4.0 - carbs_0 * 4.0) / 9.0;
        var fat_0 = Math.max(0.0, b_4);
        tmp_2 = new MacroTargets(day.jk_1, day.kk_1, fat_0, carbs_0);
      } else {
        tmp_2 = new MacroTargets(Macros_instance.th(day.kk_1, day.lk_1, value), day.kk_1, day.lk_1, value);
      }

      tmp = tmp_2;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function withProtein($this, kcal, proteinG, bodyWeightKg, diet) {
  // Inline function 'kotlin.math.min' call
  var b = kcal / 4.0;
  var protein = Math.min(proteinG, b);
  var rest = kcal - protein * 4.0;
  var tmp0 = 0.6 * bodyWeightKg;
  // Inline function 'kotlin.math.min' call
  var b_0 = rest / 9.0;
  var fatFloorG = Math.min(tmp0, b_0);
  var _destruct__k2r9zo = Macros_instance.ok(kcal, protein, fatFloorG, diet);
  var fat = _destruct__k2r9zo.hb();
  var carbs = _destruct__k2r9zo.ib();
  return new MacroTargets(kcal, protein, fat, carbs);
}
function CollaborativeTargets() {
}
protoOf(CollaborativeTargets).pk = function (targets, field, value, bodyWeightKg, diet, days, keepCalories, keepWeeklyTotal) {
  // Inline function 'kotlin.require' call
  if (!(value >= 0.0)) {
    var message = 'value must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(days, Collection)) {
      tmp = days.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = days.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
    }
    tmp$ret$2 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$2) {
    var message_0 = 'days must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var week = DailyTargets_instance.qk(targets);
  var edited = days.m() ? toSet(numberRangeToNumber(0, 6)) : days;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(week, 10));
  var index = 0;
  var _iterator__ex2g4s_0 = week.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$8 = !edited.r(index_0) ? item : editDay(CollaborativeTargets_instance, item, field, value, bodyWeightKg, diet, keepCalories);
    destination.f(tmp$ret$8);
  }
  var result = toMutableList(destination);
  if (field.equals(MacroField_KCAL_getInstance()) && keepWeeklyTotal && edited.o() < 7) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = numberRangeToNumber(0, 6);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var inductionVariable = tmp0.xc_1;
    var last = tmp0.yc_1;
    if (inductionVariable <= last)
      do {
        var element_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = element_0;
        if (!edited.r(it)) {
          destination_0.f(element_0);
        }
      }
       while (!(element_0 === last));
    var others = destination_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = edited.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      var tmp_0 = sum;
      sum = tmp_0 + (result.n(element_1).jk_1 - week.n(element_1).jk_1);
    }
    var difference = sum;
    var perDay = difference / others.o();
    var _iterator__ex2g4s_2 = others.j();
    while (_iterator__ex2g4s_2.k()) {
      var index_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.math.max' call
      var b = week.n(index_1).jk_1 - perDay;
      var kcal = Math.max(0.0, b);
      result.o2(index_1, Macros_instance.nk(kcal, bodyWeightKg, week.n(index_1).kk_1, diet));
    }
  }
  return result;
};
var CollaborativeTargets_instance;
function CollaborativeTargets_getInstance() {
  return CollaborativeTargets_instance;
}
function DailyTargets() {
}
protoOf(DailyTargets).qk = function (targets) {
  var tmp;
  switch (targets.o()) {
    case 7:
      tmp = targets;
      break;
    case 1:
      // Inline function 'kotlin.collections.List' call

      // Inline function 'kotlin.collections.MutableList' call

      var list = ArrayList_init_$Create$(7);
      // Inline function 'kotlin.repeat' call

      var inductionVariable = 0;
      if (inductionVariable < 7)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = targets.n(0);
          list.f(tmp$ret$4);
        }
         while (inductionVariable < 7);
      tmp = list;
      break;
    default:
      throw IllegalArgumentException_init_$Create$('targets must have 1 or 7 entries, not ' + targets.o());
  }
  return tmp;
};
protoOf(DailyTargets).rk = function (targets) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = this.qk(targets).j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    sum = tmp + element.jk_1;
  }
  return sum / 7.0;
};
var DailyTargets_instance;
function DailyTargets_getInstance() {
  return DailyTargets_instance;
}
function MacroField_KCAL_getInstance() {
  static_init_8();
  return MacroField_KCAL_instance;
}
function MacroField_PROTEIN_getInstance() {
  static_init_8();
  return MacroField_PROTEIN_instance;
}
function MacroField_FAT_getInstance() {
  static_init_8();
  return MacroField_FAT_instance;
}
function MacroField_CARBS_getInstance() {
  static_init_8();
  return MacroField_CARBS_instance;
}
function Companion_0() {
  Companion_instance_2 = this;
  this.sk_1 = 7;
  this.tk_1 = listOf([1, 2]);
  this.uk_1 = "A diet break holds your calories at maintenance. Breaks can make dieting easier on appetite; they don't speed up fat loss, and each break week adds a week to your diet.";
}
var Companion_instance_2;
function Companion_getInstance_0() {
  if (Companion_instance_2 == null)
    new Companion_0();
  return Companion_instance_2;
}
function DietBreak(startDay, weeks) {
  Companion_getInstance_0();
  this.vk_1 = startDay;
  this.wk_1 = weeks;
}
protoOf(DietBreak).xk = function () {
  return this.vk_1 + imul(this.wk_1, 7) | 0;
};
protoOf(DietBreak).yk = function (day) {
  var containsLower = this.vk_1;
  return day < this.xk() ? containsLower <= day : false;
};
protoOf(DietBreak).zk = function (day) {
  var containsLower = this.xk();
  return day < (this.xk() + 7 | 0) ? containsLower <= day : false;
};
protoOf(DietBreak).toString = function () {
  return 'DietBreak(startDay=' + this.vk_1 + ', weeks=' + this.wk_1 + ')';
};
protoOf(DietBreak).hashCode = function () {
  var result = this.vk_1;
  result = imul(result, 31) + this.wk_1 | 0;
  return result;
};
protoOf(DietBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DietBreak))
    return false;
  if (!(this.vk_1 === other.vk_1))
    return false;
  if (!(this.wk_1 === other.wk_1))
    return false;
  return true;
};
function GoalPeriodStart(day, goal) {
  this.al_1 = day;
  this.bl_1 = goal;
}
protoOf(GoalPeriodStart).toString = function () {
  return 'GoalPeriodStart(day=' + this.al_1 + ', goal=' + this.bl_1.toString() + ')';
};
protoOf(GoalPeriodStart).hashCode = function () {
  var result = this.al_1;
  result = imul(result, 31) + this.bl_1.hashCode() | 0;
  return result;
};
protoOf(GoalPeriodStart).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalPeriodStart))
    return false;
  if (!(this.al_1 === other.al_1))
    return false;
  if (!this.bl_1.equals(other.bl_1))
    return false;
  return true;
};
function ExpenditureInput(endDay, weighIns, intake, profile, trendKg, bodyFatFraction, goals, inputs, checkInExpenditure, initialKcal, kcalPerKg, gainKcalPerKg, v2Terms) {
  var tmp;
  if (bodyFatFraction === VOID) {
    tmp = profile == null ? null : profile.fl_1;
  } else {
    tmp = bodyFatFraction;
  }
  bodyFatFraction = tmp;
  goals = goals === VOID ? emptyList() : goals;
  inputs = inputs === VOID ? new DailyInputs() : inputs;
  checkInExpenditure = checkInExpenditure === VOID ? emptyMap() : checkInExpenditure;
  initialKcal = initialKcal === VOID ? null : initialKcal;
  kcalPerKg = kcalPerKg === VOID ? null : kcalPerKg;
  gainKcalPerKg = gainKcalPerKg === VOID ? null : gainKcalPerKg;
  v2Terms = v2Terms === VOID ? Companion_getInstance_3().kl_1 : v2Terms;
  this.ll_1 = endDay;
  this.ml_1 = weighIns;
  this.nl_1 = intake;
  this.ol_1 = profile;
  this.pl_1 = trendKg;
  this.ql_1 = bodyFatFraction;
  this.rl_1 = goals;
  this.sl_1 = inputs;
  this.tl_1 = checkInExpenditure;
  this.ul_1 = initialKcal;
  this.vl_1 = kcalPerKg;
  this.wl_1 = gainKcalPerKg;
  this.xl_1 = v2Terms;
}
protoOf(ExpenditureInput).toString = function () {
  return 'ExpenditureInput(endDay=' + this.ll_1 + ', weighIns=' + toString(this.ml_1) + ', intake=' + toString(this.nl_1) + ', profile=' + toString_0(this.ol_1) + ', trendKg=' + this.pl_1 + ', bodyFatFraction=' + this.ql_1 + ', goals=' + toString(this.rl_1) + ', inputs=' + this.sl_1.toString() + ', checkInExpenditure=' + toString(this.tl_1) + ', initialKcal=' + this.ul_1 + ', kcalPerKg=' + this.vl_1 + ', gainKcalPerKg=' + this.wl_1 + ', v2Terms=' + this.xl_1.toString() + ')';
};
protoOf(ExpenditureInput).hashCode = function () {
  var result = this.ll_1;
  result = imul(result, 31) + hashCode(this.ml_1) | 0;
  result = imul(result, 31) + hashCode(this.nl_1) | 0;
  result = imul(result, 31) + (this.ol_1 == null ? 0 : this.ol_1.hashCode()) | 0;
  result = imul(result, 31) + (this.pl_1 == null ? 0 : getNumberHashCode(this.pl_1)) | 0;
  result = imul(result, 31) + (this.ql_1 == null ? 0 : getNumberHashCode(this.ql_1)) | 0;
  result = imul(result, 31) + hashCode(this.rl_1) | 0;
  result = imul(result, 31) + this.sl_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.tl_1) | 0;
  result = imul(result, 31) + (this.ul_1 == null ? 0 : getNumberHashCode(this.ul_1)) | 0;
  result = imul(result, 31) + (this.vl_1 == null ? 0 : getNumberHashCode(this.vl_1)) | 0;
  result = imul(result, 31) + (this.wl_1 == null ? 0 : getNumberHashCode(this.wl_1)) | 0;
  result = imul(result, 31) + this.xl_1.hashCode() | 0;
  return result;
};
protoOf(ExpenditureInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureInput))
    return false;
  if (!(this.ll_1 === other.ll_1))
    return false;
  if (!equals(this.ml_1, other.ml_1))
    return false;
  if (!equals(this.nl_1, other.nl_1))
    return false;
  if (!equals(this.ol_1, other.ol_1))
    return false;
  if (!equals(this.pl_1, other.pl_1))
    return false;
  if (!equals(this.ql_1, other.ql_1))
    return false;
  if (!equals(this.rl_1, other.rl_1))
    return false;
  if (!this.sl_1.equals(other.sl_1))
    return false;
  if (!equals(this.tl_1, other.tl_1))
    return false;
  if (!equals(this.ul_1, other.ul_1))
    return false;
  if (!equals(this.vl_1, other.vl_1))
    return false;
  if (!equals(this.wl_1, other.wl_1))
    return false;
  if (!this.xl_1.equals(other.xl_1))
    return false;
  return true;
};
function Companion_1() {
  Companion_instance_3 = this;
  this.yl_1 = new ExpenditureRun(emptyList(), emptyList(), null, null, null, null);
}
var Companion_instance_3;
function Companion_getInstance_1() {
  if (Companion_instance_3 == null)
    new Companion_1();
  return Companion_instance_3;
}
function ExpenditureRun(series, dynamic, initialKcal, kcalPerKg, band, comparison) {
  Companion_getInstance_1();
  this.zl_1 = series;
  this.am_1 = dynamic;
  this.bm_1 = initialKcal;
  this.cm_1 = kcalPerKg;
  this.dm_1 = band;
  this.em_1 = comparison;
}
protoOf(ExpenditureRun).toString = function () {
  return 'ExpenditureRun(series=' + toString(this.zl_1) + ', dynamic=' + toString(this.am_1) + ', initialKcal=' + this.bm_1 + ', kcalPerKg=' + this.cm_1 + ', band=' + toString_0(this.dm_1) + ', comparison=' + toString_0(this.em_1) + ')';
};
protoOf(ExpenditureRun).hashCode = function () {
  var result = hashCode(this.zl_1);
  result = imul(result, 31) + hashCode(this.am_1) | 0;
  result = imul(result, 31) + (this.bm_1 == null ? 0 : getNumberHashCode(this.bm_1)) | 0;
  result = imul(result, 31) + (this.cm_1 == null ? 0 : getNumberHashCode(this.cm_1)) | 0;
  result = imul(result, 31) + (this.dm_1 == null ? 0 : this.dm_1.hashCode()) | 0;
  result = imul(result, 31) + (this.em_1 == null ? 0 : hashCode(this.em_1)) | 0;
  return result;
};
protoOf(ExpenditureRun).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureRun))
    return false;
  if (!equals(this.zl_1, other.zl_1))
    return false;
  if (!equals(this.am_1, other.am_1))
    return false;
  if (!equals(this.bm_1, other.bm_1))
    return false;
  if (!equals(this.cm_1, other.cm_1))
    return false;
  if (!equals(this.dm_1, other.dm_1))
    return false;
  if (!equals(this.em_1, other.em_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0(function_0) {
  this.fm_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).ea = function (a, b) {
  return this.fm_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0).h2 = function () {
  return this.fm_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.h2());
};
function ExpenditureRunner$run$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.gm_1;
  var tmp$ret$2 = b.gm_1;
  return compareValues(tmp, tmp$ret$2);
}
function run$engine($settings, $input, goalParams, initial, start, weights, intake, kcalPerKg, changes, floor, choice) {
  var tmp0_minUsableIntakeDaysInLastWeek = $settings.nf_1;
  var tmp1_holdAfterLastWeighIn = $settings.of_1;
  var tmp2_intakePrior = $settings.sf_1;
  var tmp3_gainKcalPerKg = $input.wl_1;
  var stateSpace = new StateSpaceParams(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_intakePrior, VOID, tmp0_minUsableIntakeDaysInLastWeek, VOID, tmp1_holdAfterLastWeighIn, tmp3_gainKcalPerKg, goalParams);
  var tmp;
  switch (choice.y1_1) {
    case 0:
      tmp = to(AdaptiveExpenditure_instance.im(initial, start, $input.ll_1, weights, intake, kcalPerKg, changes, new ExpenditureParams(VOID, VOID, $settings.nf_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $settings.of_1, $input.wl_1, goalParams), floor), null);
      break;
    case 1:
      tmp = to(StateSpaceExpenditure_instance.jm(initial, start, $input.ll_1, weights, intake, kcalPerKg, changes, stateSpace, floor), null);
      break;
    case 2:
      tmp = to(ExpenditureV2_instance.mm(initial, start, $input.ll_1, weights, intake, kcalPerKg, changes, stateSpace, $input.xl_1, $input.sl_1, floor), ExpenditureV2_instance.nm(initial, start, $input.ll_1, weights, intake, kcalPerKg, changes, stateSpace, $input.xl_1, $input.sl_1, floor));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function ExpenditureRunner() {
  this.om_1 = 3.0;
}
protoOf(ExpenditureRunner).pm = function (settings, input) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = input.ml_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.gm_1 <= input.ll_1) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = ExpenditureRunner$run$lambda;
  var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
  var weights = sortedWith(destination, tmp$ret$4);
  var valid = WeightTrend_instance.um(weights);
  var tmp0_elvis_lhs = firstOrNull(valid);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Companion_getInstance_1().yl_1;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var first = tmp_0;
  var tmp1_elvis_lhs = input.pl_1;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return Companion_getInstance_1().yl_1;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var trendKg = tmp_1;
  var profile = input.ol_1;
  var bodyFat = input.ql_1;
  var tmp2_elvis_lhs = input.vl_1;
  var kcalPerKg = tmp2_elvis_lhs == null ? settings.xg(trendKg, bodyFat) : tmp2_elvis_lhs;
  var tmp0_0 = first.gm_1;
  var tmp3_elvis_lhs = settings.lf_1;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = tmp3_elvis_lhs == null ? first.gm_1 : tmp3_elvis_lhs;
  var tmp$ret$5 = Math.max(tmp0_0, b);
  var start = coerceAtMost(tmp$ret$5, input.ll_1);
  var tmp_2;
  if (start === first.gm_1) {
    var tmp$ret$6;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var _iterator__ex2g4s_0 = weights.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (element_0.hm_1 >= 25.0) {
          tmp$ret$6 = element_0;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
    }
    tmp_2 = tmp$ret$6.hm_1;
  } else {
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.last' call
      var iterator = valid.p(valid.o());
      while (iterator.c3()) {
        var element_1 = iterator.d3();
        if (element_1.gm_1 <= start) {
          tmp$ret$8 = element_1;
          break $l$block_0;
        }
      }
      throw NoSuchElementException_init_$Create$('List contains no element matching the predicate.');
    }
    tmp_2 = tmp$ret$8.hm_1;
  }
  var startWeight = tmp_2;
  var tmp_3;
  if (profile == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = InitialExpenditure_instance.xm(profile.cl_1, startWeight, profile.el_1, profile.dl_1, profile.hl_1, bodyFat, settings.vf_1, profile.il_1);
  }
  var formula = tmp_3;
  var tmp_4;
  if (!(settings.lf_1 == null)) {
    // Inline function 'kotlin.collections.filterKeys' call
    var this_0 = input.tl_1;
    var result = LinkedHashMap_init_$Create$_1();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = this_0.w1().j();
    while (_iterator__ex2g4s_1.k()) {
      var entry = _iterator__ex2g4s_1.l();
      if (entry.p1() <= start) {
        result.l2(entry.p1(), entry.q1());
      }
    }
    // Inline function 'kotlin.collections.maxByOrNull' call
    var tmp0_1 = result.w1();
    var tmp$ret$16;
    $l$block_2: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var iterator_0 = tmp0_1.j();
      if (!iterator_0.k()) {
        tmp$ret$16 = null;
        break $l$block_2;
      }
      var maxElem = iterator_0.l();
      if (!iterator_0.k()) {
        tmp$ret$16 = maxElem;
        break $l$block_2;
      }
      var maxValue = maxElem.p1();
      do {
        var e = iterator_0.l();
        var v = e.p1();
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator_0.k());
      tmp$ret$16 = maxElem;
    }
    var tmp5_safe_receiver = tmp$ret$16;
    tmp_4 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.q1();
  } else {
    tmp_4 = null;
  }
  var ownBefore = tmp_4;
  var tmp6_elvis_lhs = input.ul_1;
  var tmp_5;
  if (tmp6_elvis_lhs == null) {
    var tmp_6;
    if (formula == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_6 = InitialExpenditure_instance.ym(null, ownBefore, formula);
    }
    tmp_5 = tmp_6;
  } else {
    tmp_5 = tmp6_elvis_lhs;
  }
  var tmp8_elvis_lhs = tmp_5;
  var tmp_7;
  if (tmp8_elvis_lhs == null) {
    return new ExpenditureRun(emptyList(), emptyList(), null, kcalPerKg, null, null);
  } else {
    tmp_7 = tmp8_elvis_lhs;
  }
  var initial = tmp_7;
  var tmp_8;
  if (bodyFat == null) {
    var tmp_9;
    if (profile == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_9 = BodyComposition_instance.bn(profile.cl_1, profile.dl_1, startWeight, profile.el_1, profile.il_1);
    }
    tmp_8 = tmp_9;
  } else {
    tmp_8 = bodyFat;
  }
  var tmp11_elvis_lhs = tmp_8;
  var leanFraction = 1.0 - (tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs);
  var floor = ExpenditureFloor_instance.en(settings.qf_1, leanFraction);
  var changes = this.fn(input.rl_1, valid);
  // Inline function 'kotlin.collections.filter' call
  var tmp0_2 = input.nl_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_2 = tmp0_2.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    if (element_2.fk_1 >= start) {
      destination_0.f(element_2);
    }
  }
  var intake = destination_0;
  var goalParams = new GoalAdjustmentParams(VOID, VOID, settings.pf_1);
  var _destruct__k2r9zo = run$engine(settings, input, goalParams, initial, start, weights, intake, kcalPerKg, changes, floor, settings.if_1);
  var dynamic = _destruct__k2r9zo.hb();
  var band = _destruct__k2r9zo.ib();
  var tmp12_safe_receiver = settings.mf_1;
  var tmp_10;
  if (tmp12_safe_receiver == null) {
    tmp_10 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_11;
    if (!tmp12_safe_receiver.equals(settings.if_1)) {
      tmp_11 = tmp12_safe_receiver;
    } else {
      tmp_11 = null;
    }
    tmp_10 = tmp_11;
  }
  var tmp13_safe_receiver = tmp_10;
  var tmp_12;
  if (tmp13_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_12 = run$engine(settings, input, goalParams, initial, start, weights, intake, kcalPerKg, changes, floor, tmp13_safe_receiver).nb_1;
  }
  var comparison = tmp_12;
  var staticKcal = settings.kf_1;
  var tmp_13;
  if (settings.jf_1.equals(ExpenditureMode_STATIC_getInstance()) && !(staticKcal == null)) {
    var latest = last(valid).hm_1;
    var tmp15_elvis_lhs = floor == null ? null : floor(latest);
    var low = tmp15_elvis_lhs == null ? ExpenditureFloor_instance.gn(latest * leanFraction) : tmp15_elvis_lhs;
    var tmp_14;
    if (profile == null) {
      tmp_14 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_14 = 3.0 * InitialExpenditure_instance.hn(profile.cl_1, latest, profile.el_1, profile.dl_1, bodyFat, settings.vf_1, profile.il_1);
    }
    var high = tmp_14;
    // Inline function 'kotlin.let' call
    var it = coerceAtLeast_0(staticKcal, low);
    var bounded = !(high == null) && high > low ? coerceAtMost_0(it, high) : it;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(dynamic, 10));
    var _iterator__ex2g4s_3 = dynamic.j();
    while (_iterator__ex2g4s_3.k()) {
      var item = _iterator__ex2g4s_3.l();
      var tmp$ret$36 = new ExpenditurePoint(item.in_1, bounded, 0.0, ExpenditureStatus_UPDATING_getInstance());
      destination_1.f(tmp$ret$36);
    }
    tmp_13 = destination_1;
  } else {
    tmp_13 = dynamic;
  }
  var series = tmp_13;
  return new ExpenditureRun(series, dynamic, initial, kcalPerKg, band, comparison);
};
protoOf(ExpenditureRunner).fn = function (goals, weighIns) {
  if (goals.o() < 2)
    return emptyList();
  var tmp = WeightTrend_instance;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator = goals.j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var maxValue = iterator.l().al_1;
  while (iterator.k()) {
    var v = iterator.l().al_1;
    if (compareTo(maxValue, v) < 0) {
      maxValue = v;
    }
  }
  var tmp$ret$0 = maxValue;
  var trend = tmp.on(weighIns, tmp$ret$0);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(trend, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = trend.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp_0 = element.pn_1;
    var tmp$ret$6 = element.sn_1;
    destination.l2(tmp_0, tmp$ret$6);
  }
  var trendByDay = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(goals, 10));
  var _iterator__ex2g4s_0 = goals.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp0_elvis_lhs = trendByDay.t1(item.al_1);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = firstOrNull(trend);
      tmp_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sn_1;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var trendKg = tmp_1;
    var goal = trendKg == null ? item.bl_1.ji(VOID, VOID, null) : item.bl_1;
    var tmp_2 = CheckIn_instance;
    var tmp$ret$9 = new GoalStart(item.al_1, tmp_2.ij(goal, trendKg == null ? 0.0 : trendKg));
    destination_0.f(tmp$ret$9);
  }
  var starts = destination_0;
  return Companion_instance_4.tn(starts);
};
var ExpenditureRunner_instance;
function ExpenditureRunner_getInstance() {
  return ExpenditureRunner_instance;
}
function PacePreset(key, label, ratePctPerWeek, note) {
  this.un_1 = key;
  this.vn_1 = label;
  this.wn_1 = ratePctPerWeek;
  this.xn_1 = note;
}
protoOf(PacePreset).toString = function () {
  return 'PacePreset(key=' + this.un_1 + ', label=' + this.vn_1 + ', ratePctPerWeek=' + this.wn_1 + ', note=' + this.xn_1 + ')';
};
protoOf(PacePreset).hashCode = function () {
  var result = getStringHashCode(this.un_1);
  result = imul(result, 31) + getStringHashCode(this.vn_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.wn_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.xn_1) | 0;
  return result;
};
protoOf(PacePreset).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PacePreset))
    return false;
  if (!(this.un_1 === other.un_1))
    return false;
  if (!(this.vn_1 === other.vn_1))
    return false;
  if (!equals(this.wn_1, other.wn_1))
    return false;
  if (!(this.xn_1 === other.xn_1))
    return false;
  return true;
};
function PacePoint(day, kg) {
  this.yn_1 = day;
  this.zn_1 = kg;
}
protoOf(PacePoint).toString = function () {
  return 'PacePoint(day=' + this.yn_1 + ', kg=' + this.zn_1 + ')';
};
protoOf(PacePoint).hashCode = function () {
  var result = this.yn_1;
  result = imul(result, 31) + getNumberHashCode(this.zn_1) | 0;
  return result;
};
protoOf(PacePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PacePoint))
    return false;
  if (!(this.yn_1 === other.yn_1))
    return false;
  if (!equals(this.zn_1, other.zn_1))
    return false;
  return true;
};
function PaceProjection(points, reachDay) {
  this.ao_1 = points;
  this.bo_1 = reachDay;
}
protoOf(PaceProjection).toString = function () {
  return 'PaceProjection(points=' + toString(this.ao_1) + ', reachDay=' + this.bo_1 + ')';
};
protoOf(PaceProjection).hashCode = function () {
  var result = hashCode(this.ao_1);
  result = imul(result, 31) + (this.bo_1 == null ? 0 : this.bo_1) | 0;
  return result;
};
protoOf(PaceProjection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PaceProjection))
    return false;
  if (!equals(this.ao_1, other.ao_1))
    return false;
  if (!(this.bo_1 == other.bo_1))
    return false;
  return true;
};
function CurvePoint(day, kg) {
  this.co_1 = day;
  this.do_1 = kg;
}
protoOf(CurvePoint).toString = function () {
  return 'CurvePoint(day=' + this.co_1 + ', kg=' + this.do_1 + ')';
};
protoOf(CurvePoint).hashCode = function () {
  var result = getNumberHashCode(this.co_1);
  result = imul(result, 31) + getNumberHashCode(this.do_1) | 0;
  return result;
};
protoOf(CurvePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CurvePoint))
    return false;
  if (!equals(this.co_1, other.co_1))
    return false;
  if (!equals(this.do_1, other.do_1))
    return false;
  return true;
};
function GoalPace() {
  GoalPace_instance = this;
  this.eo_1 = listOf([new PacePreset('GENTLE', 'Gentle', 0.25, 'Easiest to keep'), new PacePreset('STANDARD', 'Standard', 0.5, 'Steady; most people pick this'), new PacePreset('FAST', 'Fast', 1.0, 'Harder, more hunger')]);
  this.fo_1 = listOf([new PacePreset('SLOW', 'Slow', 0.1, 'Least fat gained'), new PacePreset('STANDARD', 'Standard', 0.25, 'Steady muscle gain'), new PacePreset('FAST', 'Fast', 0.5, 'Quicker, with more fat')]);
  this.go_1 = 0.05;
  this.ho_1 = 1.5;
  this.io_1 = 12;
  this.jo_1 = 0.1;
  this.ko_1 = 25.0;
  this.lo_1 = 23.0;
  this.mo_1 = setOf([Ethnicity_SOUTH_ASIAN_getInstance(), Ethnicity_CHINESE_getInstance(), Ethnicity_OTHER_ASIAN_getInstance(), Ethnicity_BLACK_AFRICAN_getInstance(), Ethnicity_BLACK_CARIBBEAN_getInstance(), Ethnicity_MIDDLE_EASTERN_getInstance()]);
  this.no_1 = 28.0;
  this.oo_1 = 0.25;
  this.po_1 = 16;
}
protoOf(GoalPace).qo = function (type) {
  var tmp;
  switch (type.y1_1) {
    case 0:
      tmp = this.eo_1;
      break;
    case 2:
      tmp = this.fo_1;
      break;
    case 1:
      tmp = emptyList();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(GoalPace).ro = function (startKg, targetKg, ratePctPerWeek, today) {
  var tmp;
  if (targetKg == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Goals_instance.fp(startKg, targetKg, startKg, today, null, ratePctPerWeek).ap_1;
  }
  var reach = tmp;
  var tmp_0;
  if (reach == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = ((reach - today | 0) + 6 | 0) / 7 | 0;
  }
  var tmp2_elvis_lhs = tmp_0;
  var weeks = tmp2_elvis_lhs == null ? 12 : tmp2_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  var this_0 = numberRangeToNumber(0, weeks);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var week = item;
      var day = today + imul(week, 7) | 0;
      var tmp_1;
      if (!(reach == null) && day >= reach) {
        tmp_1 = new PacePoint(reach, targetKg);
      } else {
        // Inline function 'kotlin.math.pow' call
        var this_1 = 1.0 + ratePctPerWeek / 100.0;
        var tmp$ret$7 = Math.pow(this_1, week);
        tmp_1 = new PacePoint(day, startKg * tmp$ret$7);
      }
      var tmp$ret$6 = tmp_1;
      destination.f(tmp$ret$6);
    }
     while (!(item === last));
  var points = destination;
  // Inline function 'kotlin.collections.distinctBy' call
  var set = HashSet_init_$Create$();
  var list = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var e = _iterator__ex2g4s.l();
    var key = e.yn_1;
    if (set.f(key)) {
      list.f(e);
    }
  }
  return new PaceProjection(list, reach);
};
protoOf(GoalPace).gp = function (ethnicity) {
  return contains(this.mo_1, ethnicity) ? 23.0 : 25.0;
};
protoOf(GoalPace).hp = function (weightKg, heightCm, waistCm, bmiThreshold) {
  if (heightCm == null || !(heightCm > 0.0) || !(weightKg > 0.0))
    return null;
  var heightM = heightCm / 100.0;
  var bmi = weightKg / (heightM * heightM);
  var tmp;
  if (waistCm == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (waistCm > 0.0) {
      tmp_0 = waistCm;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_safe_receiver = tmp;
  var whtr = tmp1_safe_receiver == null ? null : tmp1_safe_receiver / heightCm;
  var eligible = !(whtr == null) ? whtr >= 0.5 : bmi >= bmiThreshold;
  if (!eligible)
    return null;
  return weightKg * (1.0 - 0.1);
};
protoOf(GoalPace).ip = function (projection, lastDay) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = projection.ao_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new CurvePoint(item.yn_1, item.zn_1);
    destination.f(tmp$ret$2);
  }
  var points = destination;
  var tmp0_safe_receiver = projection.bo_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return points;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var reach = tmp;
  var end = last(points);
  var start = first(points);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = 0.25 * (reach - start.co_1);
  var ease = Math.min(28.0, b);
  var flat = lastDay > reach ? listOf_0(new CurvePoint(lastDay, end.do_1)) : emptyList();
  if (ease <= 0.0 || points.o() < 2)
    return plus(points, flat);
  var from = reach - ease;
  var tmp0 = until(0, get_lastIndex(points));
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var inductionVariable = tmp0.xc_1;
    var last_0 = tmp0.yc_1;
    if (inductionVariable <= last_0)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = element;
        if (points.n(it + 1 | 0).co_1 >= from) {
          tmp$ret$4 = element;
          break $l$block;
        }
      }
       while (!(element === last_0));
    throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
  }
  var segment = tmp$ret$4;
  var a = points.n(segment);
  var b_0 = points.n(segment + 1 | 0);
  var slope = (b_0.do_1 - a.do_1) / (b_0.co_1 - a.co_1);
  var y0 = a.do_1 + slope * (from - a.co_1);
  var tmp_0 = y0 + slope * ease / 3.0;
  // Inline function 'kotlin.comparisons.minOf' call
  var b_1 = end.do_1;
  var tmp_1 = Math.min(y0, b_1);
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_2 = end.do_1;
  var tmp$ret$7 = Math.max(y0, b_2);
  var y1 = coerceIn(tmp_0, tmp_1, tmp$ret$7);
  var y3 = end.do_1;
  // Inline function 'kotlin.collections.map' call
  var this_1 = numberRangeToNumber(1, 16);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable_0 = this_1.xc_1;
  var last_1 = this_1.yc_1;
  if (inductionVariable_0 <= last_1)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var t = item_0 / 16;
      var u = 1.0 - t;
      var tmp$ret$10 = new CurvePoint(from + ease * t, u * u * u * y0 + 3 * u * u * t * y1 + 3 * u * t * t * y3 + t * t * t * y3);
      destination_0.f(tmp$ret$10);
    }
     while (!(item_0 === last_1));
  var corner = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = points.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0.co_1 < from) {
      destination_1.f(element_0);
    }
  }
  return plus(plus(plus_0(destination_1, new CurvePoint(from, y0)), corner), flat);
};
var GoalPace_instance;
function GoalPace_getInstance() {
  if (GoalPace_instance == null)
    new GoalPace();
  return GoalPace_instance;
}
var static_init_called_9;
function static_init_9() {
  if (static_init_called_9)
    return Unit_instance;
  static_init_called_9 = true;
  Band_HEALTHY_instance = new Band('HEALTHY', 0);
  Band_INCREASED_instance = new Band('INCREASED', 1);
  Band_HIGH_instance = new Band('HIGH', 2);
}
var Band_HEALTHY_instance;
var Band_INCREASED_instance;
var Band_HIGH_instance;
function Band(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Band_HEALTHY_getInstance() {
  static_init_9();
  return Band_HEALTHY_instance;
}
function Band_INCREASED_getInstance() {
  static_init_9();
  return Band_INCREASED_instance;
}
function Band_HIGH_getInstance() {
  static_init_9();
  return Band_HIGH_instance;
}
function WaistToHeight() {
  this.jp_1 = 0.5;
  this.kp_1 = 0.6;
  this.lp_1 = 'Try to keep your waist under half your height.';
}
protoOf(WaistToHeight).mp = function (waistCm, heightCm) {
  if (waistCm == null || heightCm == null || !(waistCm > 0.0) || !(heightCm > 0.0))
    return null;
  var ratio = waistCm / heightCm;
  return ratio < 0.5 ? Band_HEALTHY_getInstance() : ratio < 0.6 ? Band_INCREASED_getInstance() : Band_HIGH_getInstance();
};
var WaistToHeight_instance;
function WaistToHeight_getInstance() {
  return WaistToHeight_instance;
}
function GoalProgress(startKg, currentKg, targetKg, changeKg, remainingKg, fractionDone, reached, projectedDay, projectedDayAtGoalRate) {
  this.so_1 = startKg;
  this.to_1 = currentKg;
  this.uo_1 = targetKg;
  this.vo_1 = changeKg;
  this.wo_1 = remainingKg;
  this.xo_1 = fractionDone;
  this.yo_1 = reached;
  this.zo_1 = projectedDay;
  this.ap_1 = projectedDayAtGoalRate;
}
protoOf(GoalProgress).toString = function () {
  return 'GoalProgress(startKg=' + this.so_1 + ', currentKg=' + this.to_1 + ', targetKg=' + this.uo_1 + ', changeKg=' + this.vo_1 + ', remainingKg=' + this.wo_1 + ', fractionDone=' + this.xo_1 + ', reached=' + this.yo_1 + ', projectedDay=' + this.zo_1 + ', projectedDayAtGoalRate=' + this.ap_1 + ')';
};
protoOf(GoalProgress).hashCode = function () {
  var result = getNumberHashCode(this.so_1);
  result = imul(result, 31) + getNumberHashCode(this.to_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.uo_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.vo_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.wo_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.xo_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.yo_1) | 0;
  result = imul(result, 31) + (this.zo_1 == null ? 0 : this.zo_1) | 0;
  result = imul(result, 31) + (this.ap_1 == null ? 0 : this.ap_1) | 0;
  return result;
};
protoOf(GoalProgress).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalProgress))
    return false;
  if (!equals(this.so_1, other.so_1))
    return false;
  if (!equals(this.to_1, other.to_1))
    return false;
  if (!equals(this.uo_1, other.uo_1))
    return false;
  if (!equals(this.vo_1, other.vo_1))
    return false;
  if (!equals(this.wo_1, other.wo_1))
    return false;
  if (!equals(this.xo_1, other.xo_1))
    return false;
  if (!(this.yo_1 === other.yo_1))
    return false;
  if (!(this.zo_1 == other.zo_1))
    return false;
  if (!(this.ap_1 == other.ap_1))
    return false;
  return true;
};
var static_init_called_10;
function static_init_10() {
  if (static_init_called_10)
    return Unit_instance;
  static_init_called_10 = true;
  MilestoneKind_KG_instance = new MilestoneKind('KG', 0);
  MilestoneKind_PERCENT_OF_GOAL_instance = new MilestoneKind('PERCENT_OF_GOAL', 1);
}
var MilestoneKind_KG_instance;
var MilestoneKind_PERCENT_OF_GOAL_instance;
function valueOf_2(value) {
  static_init_10();
  switch (value) {
    case 'KG':
      return MilestoneKind_KG_getInstance();
    case 'PERCENT_OF_GOAL':
      return MilestoneKind_PERCENT_OF_GOAL_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.MilestoneKind.' + value);
      break;
  }
}
function MilestoneKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeightMilestone(index, thresholdKg, changeKg, fractionOfGoal, reachedDay, isTarget) {
  this.np_1 = index;
  this.op_1 = thresholdKg;
  this.pp_1 = changeKg;
  this.qp_1 = fractionOfGoal;
  this.rp_1 = reachedDay;
  this.sp_1 = isTarget;
}
protoOf(WeightMilestone).toString = function () {
  return 'WeightMilestone(index=' + this.np_1 + ', thresholdKg=' + this.op_1 + ', changeKg=' + this.pp_1 + ', fractionOfGoal=' + this.qp_1 + ', reachedDay=' + this.rp_1 + ', isTarget=' + this.sp_1 + ')';
};
protoOf(WeightMilestone).hashCode = function () {
  var result = this.np_1;
  result = imul(result, 31) + getNumberHashCode(this.op_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.pp_1) | 0;
  result = imul(result, 31) + (this.qp_1 == null ? 0 : getNumberHashCode(this.qp_1)) | 0;
  result = imul(result, 31) + (this.rp_1 == null ? 0 : this.rp_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.sp_1) | 0;
  return result;
};
protoOf(WeightMilestone).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightMilestone))
    return false;
  if (!(this.np_1 === other.np_1))
    return false;
  if (!equals(this.op_1, other.op_1))
    return false;
  if (!equals(this.pp_1, other.pp_1))
    return false;
  if (!equals(this.qp_1, other.qp_1))
    return false;
  if (!(this.rp_1 == other.rp_1))
    return false;
  if (!(this.sp_1 === other.sp_1))
    return false;
  return true;
};
function projectedDay($this, today, days) {
  if (isNaN_0(days) || days < 0.0 || days > 1826)
    return null;
  // Inline function 'kotlin.math.ceil' call
  var x = days - 1.0E-9;
  var tmp$ret$0 = Math.ceil(x);
  return today + numberToInt(tmp$ret$0) | 0;
}
function sam$kotlin_Comparator$0_0(function_0) {
  this.tp_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_0).ea = function (a, b) {
  return this.tp_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).h2 = function () {
  return this.tp_1;
};
protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
  return hashCode(this.h2());
};
function Goals$milestones$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.pn_1;
  var tmp$ret$2 = b.pn_1;
  return compareValues(tmp, tmp$ret$2);
}
function milestones$reachedDay(sorted, down, threshold) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = sorted.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (down ? element.sn_1 <= threshold + 1.0E-9 : element.sn_1 >= threshold - 1.0E-9) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pn_1;
}
function Goals() {
  this.bp_1 = 0.01;
  this.cp_1 = 1826;
  this.dp_1 = 1.5;
  this.ep_1 = 14;
}
protoOf(Goals).up = function (goal, weightKg) {
  return this.vp(CheckIn_instance.ij(goal, weightKg), weightKg) / 7.0;
};
protoOf(Goals).wp = function (style, dataSlopeKgPerDay, dataDays, goal, weightKg) {
  var tmp;
  if (dataSlopeKgPerDay == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (dataDays >= 14) {
      tmp_0 = dataSlopeKgPerDay;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var data = tmp;
  var tmp_1;
  if (goal == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = Goals_instance.up(goal, weightKg);
  }
  var goalSlope = tmp_1;
  var tmp_2;
  switch (style.y1_1) {
    case 0:
      tmp_2 = data == null ? goalSlope : data;
      break;
    case 1:
      tmp_2 = goalSlope == null ? data : goalSlope;
      break;
    case 2:
      var tmp_3;
      if (!(data == null) && !(goalSlope == null)) {
        tmp_3 = (data + goalSlope) / 2.0;
      } else {
        tmp_3 = data == null ? goalSlope : data;
      }

      tmp_2 = tmp_3;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tmp6_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp6_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp6_elvis_lhs;
  }
  var slope = tmp_4;
  var cap = this.vp(1.5, weightKg) / 7.0;
  return coerceIn(slope, -cap, cap);
};
protoOf(Goals).vp = function (ratePctPerWeek, weightKg) {
  return ratePctPerWeek / 100.0 * weightKg;
};
protoOf(Goals).xp = function (kgPerWeek, weightKg) {
  // Inline function 'kotlin.require' call
  if (!(weightKg > 0.0)) {
    var message = 'weightKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return kgPerWeek / weightKg * 100.0;
};
protoOf(Goals).fp = function (startKg, targetKg, currentKg, today, currentRateKgPerWeek, goalRatePctPerWeek) {
  var total = targetKg - startKg;
  var remaining = targetKg - currentKg;
  var tmp;
  // Inline function 'kotlin.math.abs' call
  if (Math.abs(total) < 1.0E-9) {
    tmp = 1.0;
  } else {
    tmp = coerceIn((currentKg - startKg) / total, 0.0, 1.0);
  }
  var fraction = tmp;
  var tmp_0;
  // Inline function 'kotlin.math.abs' call
  if (Math.abs(total) < 1.0E-9) {
    tmp_0 = true;
  } else {
    tmp_0 = (currentKg - targetKg) * total >= 0.0;
  }
  var reached = tmp_0;
  var tmp_1;
  if (reached) {
    tmp_1 = today;
  } else {
    var tmp_2;
    if (currentRateKgPerWeek == null) {
      tmp_2 = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      tmp_2 = Math.abs(currentRateKgPerWeek) < 0.01;
    }
    if (tmp_2) {
      tmp_1 = null;
    } else {
      if (currentRateKgPerWeek * remaining <= 0.0) {
        tmp_1 = null;
      } else {
        tmp_1 = projectedDay(this, today, remaining / (currentRateKgPerWeek / 7.0));
      }
    }
  }
  var projected = tmp_1;
  var tmp_3;
  if (reached) {
    tmp_3 = today;
  } else if (goalRatePctPerWeek == null || goalRatePctPerWeek === 0.0 || goalRatePctPerWeek <= -100.0) {
    tmp_3 = null;
  } else if (goalRatePctPerWeek * remaining <= 0.0) {
    tmp_3 = null;
  } else if (currentKg <= 0.0 || targetKg <= 0.0) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.math.ln' call
    var x = targetKg / currentKg;
    var tmp_4 = Math.log(x);
    // Inline function 'kotlin.math.ln' call
    var x_0 = 1.0 + goalRatePctPerWeek / 100.0;
    var tmp$ret$4 = Math.log(x_0);
    tmp_3 = projectedDay(this, today, tmp_4 / tmp$ret$4 * 7.0);
  }
  var projectedAtGoal = tmp_3;
  return new GoalProgress(startKg, currentKg, targetKg, currentKg - startKg, remaining, fraction, reached, projected, projectedAtGoal);
};
protoOf(Goals).yp = function (startKg, targetKg, trend, kind, step, losing) {
  // Inline function 'kotlin.require' call
  if (!(step > 0.0)) {
    var message = 'step must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  if (!(targetKg == null)) {
    // Inline function 'kotlin.math.abs' call
    var x = targetKg - startKg;
    tmp = Math.abs(x) < 1.0E-9;
  } else {
    tmp = false;
  }
  if (tmp)
    return emptyList();
  var down = !(targetKg == null) ? targetKg < startKg : losing;
  var sign = down ? -1.0 : 1.0;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = Goals$milestones$lambda;
  var tmp$ret$4 = new sam$kotlin_Comparator$0_0(tmp_0);
  var sorted = sortedWith(trend, tmp$ret$4);
  var thresholds = ArrayList_init_$Create$_0();
  switch (kind.y1_1) {
    case 1:
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (targetKg == null) {
          var message_0 = 'PERCENT_OF_GOAL milestones need a target';
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          break $l$block;
        }
      }

      // Inline function 'kotlin.require' call

      if (!(step <= 100.0)) {
        var message_1 = 'step must be at most 100 %';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }

      // Inline function 'kotlin.math.floor' call

      var x_0 = 100.0 / step + 1.0E-9;
      var tmp$ret$9 = Math.floor(x_0);
      var count = numberToInt(tmp$ret$9);
      var inductionVariable = 1;
      if (inductionVariable <= count)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var share = n * step / 100.0;
          var tmp_1 = startKg + (targetKg - startKg) * share;
          // Inline function 'kotlin.math.abs' call
          var x_1 = share - 1.0;
          var tmp$ret$10 = Math.abs(x_1);
          thresholds.f(to(tmp_1, tmp$ret$10 < 1.0E-9));
        }
         while (!(n === count));
      var tmp1_safe_receiver = lastOrNull(thresholds);
      if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ob_1) === true)) {
        thresholds.f(to(targetKg, true));
      }

      break;
    case 0:
      if (!(targetKg == null)) {
        // Inline function 'kotlin.math.abs' call
        var x_2 = targetKg - startKg;
        // Inline function 'kotlin.math.ceil' call
        var x_3 = Math.abs(x_2) / step - 1.0E-9;
        var tmp$ret$12 = Math.ceil(x_3);
        var count_0 = numberToInt(tmp$ret$12);
        var inductionVariable_0 = 1;
        if (inductionVariable_0 < count_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            thresholds.f(to(startKg + sign * n_0 * step, false));
          }
           while (inductionVariable_0 < count_0);
        thresholds.f(to(targetKg, true));
      } else {
        var tmp$ret$13;
        $l$block_0: {
          // Inline function 'kotlin.collections.maxOfOrNull' call
          var iterator = sorted.j();
          if (!iterator.k()) {
            tmp$ret$13 = null;
            break $l$block_0;
          }
          var maxValue = sign * (iterator.l().sn_1 - startKg);
          while (iterator.k()) {
            var v = sign * (iterator.l().sn_1 - startKg);
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = maxValue;
            maxValue = Math.max(a, v);
          }
          tmp$ret$13 = maxValue;
        }
        var tmp2_elvis_lhs = tmp$ret$13;
        var furthest = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.math.floor' call
        var x_4 = furthest / step + 1.0E-9;
        var tmp$ret$17 = Math.floor(x_4);
        var count_1 = coerceAtLeast(numberToInt(tmp$ret$17), 0) + 1 | 0;
        var inductionVariable_1 = 1;
        if (inductionVariable_1 <= count_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            thresholds.f(to(startKg + sign * n_1 * step, false));
          }
           while (!(n_1 === count_1));
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(thresholds, 10));
  var index = 0;
  var _iterator__ex2g4s = thresholds.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var threshold = item.hb();
    var isTarget = item.ib();
    var tmp_2 = threshold - startKg;
    var tmp_3;
    if (targetKg == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = (threshold - startKg) / (targetKg - startKg);
    }
    var tmp$ret$20 = new WeightMilestone(index_0, threshold, tmp_2, tmp_3, milestones$reachedDay(sorted, down, threshold), isTarget);
    destination.f(tmp$ret$20);
  }
  return destination;
};
var Goals_instance;
function Goals_getInstance() {
  return Goals_instance;
}
function MilestoneKind_KG_getInstance() {
  static_init_10();
  return MilestoneKind_KG_instance;
}
function MilestoneKind_PERCENT_OF_GOAL_getInstance() {
  static_init_10();
  return MilestoneKind_PERCENT_OF_GOAL_instance;
}
function pct($this, value) {
  return trimEnd(trimEnd(Fmt_instance.he(value, 2), charArrayOf([_Char___init__impl__6a9atx(48)])), charArrayOf([_Char___init__impl__6a9atx(46)]));
}
function FastLossWarning(ratePctPerWeek, deficitKcal, suggestedRatePctPerWeek) {
  this.zp_1 = ratePctPerWeek;
  this.aq_1 = deficitKcal;
  this.bq_1 = suggestedRatePctPerWeek;
}
protoOf(FastLossWarning).c7 = function () {
  return 'Losing ' + pct(this, this.zp_1) + ' % a week is about ' + Fmt_instance.ie(this.aq_1) + ' kcal a day under maintenance. ' + 'In studies of people who lift, losing faster than about 1 % of body weight a week, or eating more than about 500 kcal a day under maintenance, stopped muscle gains, while 0.5\u20130.7 % a week kept or built muscle.';
};
protoOf(FastLossWarning).cq = function () {
  return 'Use a gentler pace (' + pct(this, this.bq_1) + ' % a week)';
};
protoOf(FastLossWarning).toString = function () {
  return 'FastLossWarning(ratePctPerWeek=' + this.zp_1 + ', deficitKcal=' + this.aq_1 + ', suggestedRatePctPerWeek=' + this.bq_1 + ')';
};
protoOf(FastLossWarning).hashCode = function () {
  var result = getNumberHashCode(this.zp_1);
  result = imul(result, 31) + getNumberHashCode(this.aq_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.bq_1) | 0;
  return result;
};
protoOf(FastLossWarning).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FastLossWarning))
    return false;
  if (!equals(this.zp_1, other.zp_1))
    return false;
  if (!equals(this.aq_1, other.aq_1))
    return false;
  if (!equals(this.bq_1, other.bq_1))
    return false;
  return true;
};
function LossPace() {
  this.dq_1 = 'A gentler pace may keep more muscle';
  this.eq_1 = 1.0;
  this.fq_1 = 500.0;
  this.gq_1 = 0.7;
  this.hq_1 = 0.5;
  this.iq_1 = 0.05;
}
protoOf(LossPace).jq = function (trainingType, weeklyHardSets) {
  // Inline function 'kotlin.let' call
  var it = ProteinTargets_getInstance().sq(trainingType, weeklyHardSets);
  return it.equals(TrainingType_STRENGTH_getInstance()) || it.equals(TrainingType_BOTH_getInstance());
};
protoOf(LossPace).tq = function (ratePctPerWeek, weightKg, kcalPerKg, lifts) {
  if (!lifts || ratePctPerWeek >= 0.0 || !(weightKg > 0.0) || !(kcalPerKg > 0.0))
    return null;
  // Inline function 'kotlin.math.abs' call
  var rate = Math.abs(ratePctPerWeek);
  if (rate <= 0.5 + 1.0E-9)
    return null;
  var deficit = -CheckIn_instance.jj(ratePctPerWeek, weightKg, kcalPerKg);
  if (rate <= 1.0 + 1.0E-9 && deficit <= 500.0 + 1.0E-9)
    return null;
  var atMaxDeficit = 500.0 * 7.0 * 100.0 / (weightKg * kcalPerKg);
  // Inline function 'kotlin.math.floor' call
  var x = coerceIn(atMaxDeficit, 0.5, 0.7) / 0.05 + 1.0E-9;
  var snapped = Math.floor(x) * 0.05;
  return new FastLossWarning(rate, deficit, snapped);
};
var LossPace_instance;
function LossPace_getInstance() {
  return LossPace_instance;
}
var static_init_called_11;
function static_init_11() {
  if (static_init_called_11)
    return Unit_instance;
  static_init_called_11 = true;
  DietType_BALANCED_instance = new DietType('BALANCED', 0);
  DietType_LOW_FAT_instance = new DietType('LOW_FAT', 1);
  DietType_LOW_CARB_instance = new DietType('LOW_CARB', 2);
  DietType_KETO_instance = new DietType('KETO', 3);
}
var DietType_BALANCED_instance;
var DietType_LOW_FAT_instance;
var DietType_LOW_CARB_instance;
var DietType_KETO_instance;
function values_7() {
  static_init_11();
  return [DietType_BALANCED_getInstance(), DietType_LOW_FAT_getInstance(), DietType_LOW_CARB_getInstance(), DietType_KETO_getInstance()];
}
function valueOf_3(value) {
  static_init_11();
  switch (value) {
    case 'BALANCED':
      return DietType_BALANCED_getInstance();
    case 'LOW_FAT':
      return DietType_LOW_FAT_getInstance();
    case 'LOW_CARB':
      return DietType_LOW_CARB_getInstance();
    case 'KETO':
      return DietType_KETO_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.DietType.' + value);
      break;
  }
}
function DietType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_12;
function static_init_12() {
  if (static_init_called_12)
    return Unit_instance;
  static_init_called_12 = true;
  ProteinPreference_LOW_instance = new ProteinPreference('LOW', 0, 1.8);
  ProteinPreference_MODERATE_instance = new ProteinPreference('MODERATE', 1, 2.2);
  ProteinPreference_HIGH_instance = new ProteinPreference('HIGH', 2, 2.6);
  ProteinPreference_EXTRA_HIGH_instance = new ProteinPreference('EXTRA_HIGH', 3, 3.0);
}
var ProteinPreference_LOW_instance;
var ProteinPreference_MODERATE_instance;
var ProteinPreference_HIGH_instance;
var ProteinPreference_EXTRA_HIGH_instance;
function values_8() {
  static_init_12();
  return [ProteinPreference_LOW_getInstance(), ProteinPreference_MODERATE_getInstance(), ProteinPreference_HIGH_getInstance(), ProteinPreference_EXTRA_HIGH_getInstance()];
}
function valueOf_4(value) {
  static_init_12();
  switch (value) {
    case 'LOW':
      return ProteinPreference_LOW_getInstance();
    case 'MODERATE':
      return ProteinPreference_MODERATE_getInstance();
    case 'HIGH':
      return ProteinPreference_HIGH_getInstance();
    case 'EXTRA_HIGH':
      return ProteinPreference_EXTRA_HIGH_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.ProteinPreference.' + value);
      break;
  }
}
function ProteinPreference(name, ordinal, gramsPerKgLean) {
  Enum.call(this, name, ordinal);
  this.wq_1 = gramsPerKgLean;
}
function MacroTargets(kcal, proteinG, fatG, carbsG) {
  this.jk_1 = kcal;
  this.kk_1 = proteinG;
  this.lk_1 = fatG;
  this.mk_1 = carbsG;
}
protoOf(MacroTargets).xq = function (kcal, proteinG, fatG, carbsG) {
  return new MacroTargets(kcal, proteinG, fatG, carbsG);
};
protoOf(MacroTargets).yq = function (kcal, proteinG, fatG, carbsG, $super) {
  kcal = kcal === VOID ? this.jk_1 : kcal;
  proteinG = proteinG === VOID ? this.kk_1 : proteinG;
  fatG = fatG === VOID ? this.lk_1 : fatG;
  carbsG = carbsG === VOID ? this.mk_1 : carbsG;
  return $super === VOID ? this.xq(kcal, proteinG, fatG, carbsG) : $super.xq.call(this, kcal, proteinG, fatG, carbsG);
};
protoOf(MacroTargets).toString = function () {
  return 'MacroTargets(kcal=' + this.jk_1 + ', proteinG=' + this.kk_1 + ', fatG=' + this.lk_1 + ', carbsG=' + this.mk_1 + ')';
};
protoOf(MacroTargets).hashCode = function () {
  var result = getNumberHashCode(this.jk_1);
  result = imul(result, 31) + getNumberHashCode(this.kk_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.lk_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.mk_1) | 0;
  return result;
};
protoOf(MacroTargets).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MacroTargets))
    return false;
  if (!equals(this.jk_1, other.jk_1))
    return false;
  if (!equals(this.kk_1, other.kk_1))
    return false;
  if (!equals(this.lk_1, other.lk_1))
    return false;
  if (!equals(this.mk_1, other.mk_1))
    return false;
  return true;
};
var static_init_called_13;
function static_init_13() {
  if (static_init_called_13)
    return Unit_instance;
  static_init_called_13 = true;
  MacroSplit_CURRENT_instance = new MacroSplit('CURRENT', 0);
  MacroSplit_REVISED_instance = new MacroSplit('REVISED', 1);
}
var MacroSplit_CURRENT_instance;
var MacroSplit_REVISED_instance;
function values_9() {
  static_init_13();
  return [MacroSplit_CURRENT_getInstance(), MacroSplit_REVISED_getInstance()];
}
function get_entries_6() {
  static_init_13();
  if ($ENTRIES_6 == null)
    $ENTRIES_6 = enumEntries(values_9());
  return $ENTRIES_6;
}
var $ENTRIES_6;
function MacroSplit(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function keto($this, kcal, proteinG, carbsG, fatMinG) {
  // Inline function 'kotlin.math.min' call
  var b = kcal / 4.0;
  var carbs = Math.min(carbsG, b);
  var fatRoom = kcal - carbs * 4.0;
  // Inline function 'kotlin.math.min' call
  var b_0 = fatRoom / 9.0;
  var tmp0 = Math.min(fatMinG, b_0);
  // Inline function 'kotlin.math.max' call
  var b_1 = (fatRoom - proteinG * 4.0) / 9.0;
  var fat = Math.max(tmp0, b_1);
  // Inline function 'kotlin.math.max' call
  var b_2 = (fatRoom - fat * 9.0) / 4.0;
  var protein = Math.max(0.0, b_2);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$4 = Math.min(proteinG, protein);
  return new MacroTargets(kcal, tmp$ret$4, fat, carbs);
}
function splitByFatShare($this, kcal, remaining, fatShare, fatFloorG) {
  // Inline function 'kotlin.math.max' call
  var a = fatShare * kcal / 9.0;
  var tmp0 = Math.max(a, fatFloorG);
  // Inline function 'kotlin.math.min' call
  var b = remaining / 9.0;
  var fatG = Math.min(tmp0, b);
  // Inline function 'kotlin.math.max' call
  var b_0 = (remaining - fatG * 9.0) / 4.0;
  var carbsG = Math.max(0.0, b_0);
  return to(fatG, carbsG);
}
function splitByCarbCap($this, remaining, carbCapG, fatFloorG) {
  // Inline function 'kotlin.math.max' call
  var b = (remaining - fatFloorG * 9.0) / 4.0;
  var maxCarbsLeavingFloor = Math.max(0.0, b);
  // Inline function 'kotlin.math.min' call
  var carbsG = Math.min(carbCapG, maxCarbsLeavingFloor);
  var fatG = (remaining - carbsG * 4.0) / 9.0;
  return to(fatG, carbsG);
}
function Macros() {
  this.ih_1 = 4.0;
  this.jh_1 = 4.0;
  this.kh_1 = 9.0;
  this.lh_1 = 0.6;
  this.mh_1 = 0.3;
  this.nh_1 = 0.22;
  this.oh_1 = 0.3;
  this.ph_1 = 200.0;
  this.qh_1 = 30.0;
  this.rh_1 = 0.2;
  this.sh_1 = 0.4;
}
protoOf(Macros).zq = function (kcal, bodyWeightKg, leanMassKg, diet, protein) {
  return this.nk(kcal, bodyWeightKg, protein.wq_1 * leanMassKg, diet);
};
protoOf(Macros).nk = function (kcal, bodyWeightKg, proteinG, diet) {
  // Inline function 'kotlin.require' call
  if (!(kcal >= 0.0)) {
    var message = 'kcal must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(proteinG >= 0.0)) {
    var message_0 = 'proteinG must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var fatFloorG = 0.6 * bodyWeightKg;
  if (proteinG * 4.0 + fatFloorG * 9.0 >= kcal) {
    // Inline function 'kotlin.math.min' call
    var b = kcal / 9.0;
    var fat = Math.min(fatFloorG, b);
    // Inline function 'kotlin.math.max' call
    var b_0 = (kcal - fat * 9.0) / 4.0;
    var proteinLeft = Math.max(0.0, b_0);
    // Inline function 'kotlin.math.min' call
    var tmp$ret$6 = Math.min(proteinG, proteinLeft);
    return new MacroTargets(kcal, tmp$ret$6, fat, 0.0);
  }
  var _destruct__k2r9zo = this.ok(kcal, proteinG, fatFloorG, diet);
  var fatG = _destruct__k2r9zo.hb();
  var carbsG = _destruct__k2r9zo.ib();
  return new MacroTargets(kcal, proteinG, fatG, carbsG);
};
protoOf(Macros).ok = function (kcal, proteinG, fatFloorG, diet) {
  var remaining = kcal - proteinG * 4.0;
  var tmp;
  switch (diet.y1_1) {
    case 0:
      tmp = splitByFatShare(this, kcal, remaining, 0.3, fatFloorG);
      break;
    case 1:
      tmp = splitByFatShare(this, kcal, remaining, 0.22, fatFloorG);
      break;
    case 2:
      // Inline function 'kotlin.math.min' call

      var a = 0.3 * kcal / 4.0;
      var tmp$ret$0 = Math.min(a, 200.0);
      tmp = splitByCarbCap(this, remaining, tmp$ret$0, fatFloorG);
      break;
    case 3:
      tmp = splitByCarbCap(this, remaining, 30.0, fatFloorG);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(Macros).ar = function (kcal, bodyWeightKg, proteinG, diet, split, minimums) {
  // Inline function 'kotlin.require' call
  if (!(kcal >= 0.0)) {
    var message = 'kcal must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(proteinG >= 0.0)) {
    var message_0 = 'proteinG must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (split.equals(MacroSplit_CURRENT_getInstance()))
    return this.nk(kcal, bodyWeightKg, proteinG, diet);
  var rest = kcal - proteinG * 4.0;
  if (!diet.equals(DietType_KETO_getInstance())) {
    var tmp;
    switch (diet.y1_1) {
      case 2:
        var tmp0 = minimums.eh_1;
        // Inline function 'kotlin.math.max' call

        var b = 0.4 * kcal / 9.0;
        tmp = Math.max(tmp0, b);
        break;
      case 1:
        var tmp0_0 = minimums.eh_1;
        // Inline function 'kotlin.math.min' call

        var a = 0.2 * kcal;
        // Inline function 'kotlin.math.max' call

        var b_0 = Math.min(a, rest) / 9.0;
        tmp = Math.max(tmp0_0, b_0);
        break;
      default:
        var tmp0_1 = minimums.eh_1;
        // Inline function 'kotlin.math.min' call

        var a_0 = 0.3 * kcal;
        // Inline function 'kotlin.math.max' call

        var b_1 = Math.min(a_0, rest) / 9.0;
        tmp = Math.max(tmp0_1, b_1);
        break;
    }
    var fat = tmp;
    var carbs = (rest - fat * 9.0) / 4.0;
    if (carbs > minimums.fh_1) {
      if (diet.equals(DietType_LOW_CARB_getInstance()) && carbs > 200.0) {
        return new MacroTargets(kcal, proteinG, fat + (carbs - 200.0) * 4.0 / 9.0, 200.0);
      }
      return new MacroTargets(kcal, proteinG, fat, carbs);
    }
    return keto(this, kcal, proteinG, minimums.fh_1, minimums.eh_1);
  }
  return keto(this, kcal, proteinG, 30.0, minimums.eh_1);
};
protoOf(Macros).th = function (proteinG, fatG, carbsG) {
  return proteinG * 4.0 + fatG * 9.0 + carbsG * 4.0;
};
var Macros_instance;
function Macros_getInstance() {
  return Macros_instance;
}
function DietType_BALANCED_getInstance() {
  static_init_11();
  return DietType_BALANCED_instance;
}
function DietType_LOW_FAT_getInstance() {
  static_init_11();
  return DietType_LOW_FAT_instance;
}
function DietType_LOW_CARB_getInstance() {
  static_init_11();
  return DietType_LOW_CARB_instance;
}
function DietType_KETO_getInstance() {
  static_init_11();
  return DietType_KETO_instance;
}
function ProteinPreference_LOW_getInstance() {
  static_init_12();
  return ProteinPreference_LOW_instance;
}
function ProteinPreference_MODERATE_getInstance() {
  static_init_12();
  return ProteinPreference_MODERATE_instance;
}
function ProteinPreference_HIGH_getInstance() {
  static_init_12();
  return ProteinPreference_HIGH_instance;
}
function ProteinPreference_EXTRA_HIGH_getInstance() {
  static_init_12();
  return ProteinPreference_EXTRA_HIGH_instance;
}
function MacroSplit_CURRENT_getInstance() {
  static_init_13();
  return MacroSplit_CURRENT_instance;
}
function MacroSplit_REVISED_getInstance() {
  static_init_13();
  return MacroSplit_REVISED_instance;
}
function goal($this, json) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = JsonRead_instance.og(Json_instance.ng(json), 'GOAL');
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var map = tmp_1;
  var tmp1_safe_receiver = JsonRead_instance.br(map, 'type');
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_entries_4();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.x1_1 === tmp1_safe_receiver) {
          tmp$ret$7 = element;
          break $l$block;
        }
      }
      tmp$ret$7 = null;
    }
    tmp_2 = tmp$ret$7;
  }
  var tmp2_elvis_lhs = tmp_2;
  var tmp_3;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_3 = tmp2_elvis_lhs;
  }
  var type = tmp_3;
  var tmp3_elvis_lhs = JsonRead_instance.cr(map, 'ratePctPerWeek');
  return new Goal(type, tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs, JsonRead_instance.cr(map, 'targetWeightKg'));
}
function dayOneJson$missing(input) {
  return Json_instance.sg(mapOf(to('missing', input)));
}
function NewProgram() {
  this.dr_1 = 7;
}
protoOf(NewProgram).er = function (setupDay) {
  return EpochDays_getInstance().fe(setupDay);
};
protoOf(NewProgram).fr = function (setupDay) {
  return new NutritionProgram(VOID, VOID, VOID, VOID, this.er(setupDay));
};
protoOf(NewProgram).gr = function (initialDay, weekday) {
  var earliest = initialDay + 7 | 0;
  return earliest + (((weekday - EpochDays_getInstance().fe(earliest) | 0) + 7 | 0) % 7 | 0) | 0;
};
protoOf(NewProgram).hr = function (initialDay, weekday, $super) {
  weekday = weekday === VOID ? this.er(initialDay) : weekday;
  return $super === VOID ? this.gr(initialDay, weekday) : $super.gr.call(this, initialDay, weekday);
};
protoOf(NewProgram).ir = function (day, program, goal, profile, weightKg, algorithms, trainingWeekdays) {
  if (!(weightKg > 0.0))
    return null;
  return WeeklyCheckIn_instance.kr(new WeeklyCheckInInput(day, program, goal, profile, emptyList(), listOf_0(new WeighIn(day, weightKg)), emptyList(), VOID, VOID, trainingWeekdays, VOID, algorithms, VOID, VOID, VOID, day));
};
protoOf(NewProgram).lr = function (goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays) {
  var tmp;
  if (goalJson == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = goal(this, goalJson);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return dayOneJson$missing('goal');
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var goal_0 = tmp_0;
  var tmp_1;
  if (profileJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_2;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.og(Json_instance.ng(profileJson), 'profile');
      tmp_2 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_2;
    tmp_1 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp3_elvis_lhs = tmp_1;
  var profile = tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
  var tmp4_safe_receiver = JsonRead_instance.br(profile, 'sex');
  var tmp_4;
  if (tmp4_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4 = tmp4_safe_receiver.toUpperCase();
  }
  var tmp5_safe_receiver = tmp_4;
  var tmp_5;
  if (tmp5_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_entries_11();
    var tmp$ret$13;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.x1_1 === tmp5_safe_receiver) {
          tmp$ret$13 = element;
          break $l$block;
        }
      }
      tmp$ret$13 = null;
    }
    tmp_5 = tmp$ret$13;
  }
  var tmp6_elvis_lhs = tmp_5;
  var tmp_6;
  if (tmp6_elvis_lhs == null) {
    return dayOneJson$missing('profile.sex');
  } else {
    tmp_6 = tmp6_elvis_lhs;
  }
  var sex = tmp_6;
  var tmp7_safe_receiver = JsonRead_instance.br(profile, 'birthDate');
  var tmp_7;
  if (tmp7_safe_receiver == null) {
    tmp_7 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_7 = EpochDays_getInstance().de(tmp7_safe_receiver);
  }
  var tmp8_elvis_lhs = tmp_7;
  var tmp_8;
  if (tmp8_elvis_lhs == null) {
    return dayOneJson$missing('profile.birthDate');
  } else {
    tmp_8 = tmp8_elvis_lhs;
  }
  var birthDay = tmp_8;
  var tmp9_safe_receiver = JsonRead_instance.cr(profile, 'heightCm');
  var tmp_9;
  if (tmp9_safe_receiver == null) {
    tmp_9 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_10;
    if (tmp9_safe_receiver > 0.0) {
      tmp_10 = tmp9_safe_receiver;
    } else {
      tmp_10 = null;
    }
    tmp_9 = tmp_10;
  }
  var tmp10_elvis_lhs = tmp_9;
  var tmp_11;
  if (tmp10_elvis_lhs == null) {
    return dayOneJson$missing('profile.heightCm');
  } else {
    tmp_11 = tmp10_elvis_lhs;
  }
  var height = tmp_11;
  var tmp11_safe_receiver = JsonRead_instance.br(profile, 'activityLevel');
  var tmp_12;
  if (tmp11_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_0 = get_entries_13();
    var tmp$ret$21;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (element_0.x1_1 === tmp11_safe_receiver) {
          tmp$ret$21 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$21 = null;
    }
    tmp_12 = tmp$ret$21;
  }
  var tmp12_elvis_lhs = tmp_12;
  var tmp_13;
  if (tmp12_elvis_lhs == null) {
    return dayOneJson$missing('profile.activityLevel');
  } else {
    tmp_13 = tmp12_elvis_lhs;
  }
  var activity = tmp_13;
  var tmp13_safe_receiver = JsonRead_instance.cr(profile, 'bodyFatPct');
  var bodyFat = tmp13_safe_receiver == null ? null : tmp13_safe_receiver / 100.0;
  var body = new BodyProfile(sex, this.mr(birthDay, today), height, bodyFat, null, activity);
  var tmp_14;
  if (programJson == null) {
    tmp_14 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_14 = NutritionJson_instance.nr(programJson);
  }
  var tmp15_elvis_lhs = tmp_14;
  var program = tmp15_elvis_lhs == null ? this.fr(today) : tmp15_elvis_lhs;
  var tmp16_elvis_lhs = this.ir(today, program, goal_0, body, weightKg, AlgorithmJson_getInstance().mg(algorithmsJson), trainingWeekdays);
  var tmp_15;
  if (tmp16_elvis_lhs == null) {
    return dayOneJson$missing('weightKg');
  } else {
    tmp_15 = tmp16_elvis_lhs;
  }
  var result = tmp_15;
  return NutritionJson_instance.or(result, true, true);
};
protoOf(NewProgram).pr = function (goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays, $super) {
  trainingWeekdays = trainingWeekdays === VOID ? emptySet() : trainingWeekdays;
  return $super === VOID ? this.lr(goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays) : $super.lr.call(this, goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays);
};
protoOf(NewProgram).mr = function (birthDay, today) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = split(EpochDays_getInstance().ee(birthDay), ['-']);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = toInt(item);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.component1' call
  var by = destination.n(0);
  // Inline function 'kotlin.collections.component2' call
  var bm = destination.n(1);
  // Inline function 'kotlin.collections.component3' call
  var bd = destination.n(2);
  // Inline function 'kotlin.collections.map' call
  var this_1 = split(EpochDays_getInstance().ee(today), ['-']);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$8 = toInt(item_0);
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.component1' call
  var ty = destination_0.n(0);
  // Inline function 'kotlin.collections.component2' call
  var tm = destination_0.n(1);
  // Inline function 'kotlin.collections.component3' call
  var td = destination_0.n(2);
  return (ty - by | 0) - (tm < bm || (tm === bm && td < bd) ? 1 : 0) | 0;
};
var NewProgram_instance;
function NewProgram_getInstance() {
  return NewProgram_instance;
}
function dietBreak($this, value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var map = tmp;
  var tmp1_safe_receiver = JsonRead_instance.br(map, 'startDate');
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = EpochDays_getInstance().de(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var start = tmp_1;
  var tmp3_safe_receiver = JsonRead_instance.qr(map, 'weeks');
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    if (Companion_getInstance_0().tk_1.r(tmp3_safe_receiver)) {
      tmp_3 = tmp3_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var tmp4_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  var weeks = tmp_4;
  return new DietBreak(start, weeks);
}
function targets($this, value) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.rr(value);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block_0: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var map = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.cr(map, 'kcal');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var kcal = tmp_0;
      var tmp2_elvis_lhs = JsonRead_instance.cr(map, 'protein');
      var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = JsonRead_instance.cr(map, 'fat');
      var tmp_2 = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
      var tmp4_elvis_lhs = JsonRead_instance.cr(map, 'carbs');
      tmp$ret$4 = new MacroTargets(kcal, tmp_1, tmp_2, tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs);
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function round2($this, value) {
  return round(value * 100.0) / 100.0;
}
function NutritionJson() {
}
protoOf(NutritionJson).nr = function (json) {
  var map = JsonRead_instance.og(Json_instance.ng(json), 'PROGRAM');
  var tmp = map.t1('distribution');
  var distribution = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : null;
  var tmp_0 = map.t1('trainingShift');
  var shift = (!(tmp_0 == null) ? isInterface(tmp_0, KtMap) : false) ? tmp_0 : null;
  var tmp0_elvis_lhs = (!(distribution == null) ? isInterface(distribution, KtMap) : false) ? distribution : null;
  var distributionMap = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = (!(shift == null) ? isInterface(shift, KtMap) : false) ? shift : null;
  var shiftMap = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp2 = JsonRead_instance.br(map, 'kind');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_0 = ProgramKind_COACHED_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_12();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === tmp2) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs_0 = tmp$ret$2;
  var tmp_1 = tmp0_elvis_lhs_0 == null ? default_0 : tmp0_elvis_lhs_0;
  var tmp2_0 = JsonRead_instance.br(map, 'dietType');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_1 = DietType_BALANCED_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_0 = values_7();
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_0 = 0;
    var last_0 = tmp0_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = tmp0_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (element_0.x1_1 === tmp2_0) {
        tmp$ret$6 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$6 = null;
  }
  var tmp0_elvis_lhs_1 = tmp$ret$6;
  var tmp_2 = tmp0_elvis_lhs_1 == null ? default_1 : tmp0_elvis_lhs_1;
  var tmp2_1 = JsonRead_instance.br(map, 'proteinPreference');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_2 = ProteinPreference_MODERATE_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_1 = values_8();
  var tmp$ret$10;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_1 = 0;
    var last_1 = tmp0_1.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = tmp0_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      if (element_1.x1_1 === tmp2_1) {
        tmp$ret$10 = element_1;
        break $l$block_1;
      }
    }
    tmp$ret$10 = null;
  }
  var tmp0_elvis_lhs_2 = tmp$ret$10;
  var tmp_3 = tmp0_elvis_lhs_2 == null ? default_2 : tmp0_elvis_lhs_2;
  var tmp2_2 = JsonRead_instance.br(map, 'calorieFloor');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_3 = CalorieFloor_STANDARD_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_2 = values_5();
  var tmp$ret$14;
  $l$block_2: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_2 = 0;
    var last_2 = tmp0_2.length;
    while (inductionVariable_2 < last_2) {
      var element_2 = tmp0_2[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      if (element_2.x1_1 === tmp2_2) {
        tmp$ret$14 = element_2;
        break $l$block_2;
      }
    }
    tmp$ret$14 = null;
  }
  var tmp0_elvis_lhs_3 = tmp$ret$14;
  var tmp_4 = tmp0_elvis_lhs_3 == null ? default_3 : tmp0_elvis_lhs_3;
  var tmp2_elvis_lhs = JsonRead_instance.qr(map, 'checkInWeekday');
  var tmp_5 = coerceIn_0(tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs, 1, 7);
  var tmp2_3 = JsonRead_instance.br(distributionMap, 'kind');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_4 = DistributionKind_EVEN_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_3 = values_13();
  var tmp$ret$18;
  $l$block_3: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_3 = 0;
    var last_3 = tmp0_3.length;
    while (inductionVariable_3 < last_3) {
      var element_3 = tmp0_3[inductionVariable_3];
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      if (element_3.x1_1 === tmp2_3) {
        tmp$ret$18 = element_3;
        break $l$block_3;
      }
    }
    tmp$ret$18 = null;
  }
  var tmp0_elvis_lhs_4 = tmp$ret$18;
  var tmp_6 = tmp0_elvis_lhs_4 == null ? default_4 : tmp0_elvis_lhs_4;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_4 = JsonRead_instance.sr(distributionMap, 'highDays');
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0_4.j();
  while (_iterator__ex2g4s.k()) {
    var element_4 = _iterator__ex2g4s.l();
    if (1 <= element_4 ? element_4 <= 7 : false) {
      destination.f(element_4);
    }
  }
  var tmp_7 = toSet(destination);
  var tmp3_elvis_lhs = JsonRead_instance.tr(shiftMap, 'enabled');
  var tmp_8 = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  var tmp4_elvis_lhs = JsonRead_instance.cr(shiftMap, 'kcal');
  var tmp_9 = tmp4_elvis_lhs == null ? 150.0 : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = JsonRead_instance.tr(shiftMap, 'carbs');
  return new NutritionProgram(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, new TrainingShiftSetting(tmp_8, tmp_9, tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs), targets(this, map.t1('manual')), dietBreak(this, map.t1('dietBreak')));
};
protoOf(NutritionJson).ur = function (json, dietBreak) {
  var tmp;
  if (json == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = JsonRead_instance.og(Json_instance.ng(json), 'PROGRAM');
  }
  var tmp1_elvis_lhs = tmp;
  var map = LinkedHashMap_init_$Create$_0(tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs);
  var tmp2 = 'dietBreak';
  var tmp_0;
  if (dietBreak == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = linkedMapOf([to('startDate', EpochDays_getInstance().ee(dietBreak.vk_1)), to('weeks', dietBreak.wk_1)]);
  }
  // Inline function 'kotlin.collections.set' call
  var value = tmp_0;
  map.l2(tmp2, value);
  return Json_instance.sg(map);
};
protoOf(NutritionJson).vr = function (json) {
  var map = JsonRead_instance.og(Json_instance.ng(json), 'CHECKIN');
  // Inline function 'kotlin.takeIf' call
  var this_0 = targets(this, map.t1('targets'));
  var tmp;
  if (this_0.o() === 1 || this_0.o() === 7) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var targets_0 = tmp_0;
  var tmp_1 = map.t1('persistence');
  var tmp1_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var persistence = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = JsonRead_instance.qr(persistence, 'direction');
  var tmp_2 = coerceIn_0(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, -1, 1);
  var tmp3_elvis_lhs = JsonRead_instance.qr(persistence, 'weeks');
  return new PreviousCheckIn(targets_0, new Persistence(tmp_2, coerceAtLeast(tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs, 0)));
};
protoOf(NutritionJson).or = function (result, accepted, initial) {
  var tmp = Json_instance;
  var tmp_0 = to('date', EpochDays_getInstance().ee(result.wr_1));
  var tmp_1 = to('expenditureKcal', round(result.cs_1.jn_1));
  var tmp_2 = to('trendWeightKg', round2(this, result.es_1));
  var tmp0_safe_receiver = result.fs_1;
  var tmp_3;
  if (tmp0_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = round2(NutritionJson_instance, tmp0_safe_receiver);
  }
  var tmp_4 = to('weeklyChangeKg', tmp_3);
  var tmp_5 = to('rawTargetKcal', round(result.js_1));
  // Inline function 'kotlin.collections.map' call
  var this_0 = result.ns_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = linkedMapOf([to('kcal', round(item.jk_1)), to('protein', round(item.kk_1)), to('fat', round(item.lk_1)), to('carbs', round(item.mk_1))]);
    destination.f(tmp$ret$4);
  }
  var tmp_6 = to('targets', destination);
  // Inline function 'kotlin.collections.map' call
  var this_1 = result.xr_1.at_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$7 = EpochDays_getInstance().ee(item_0);
    destination_0.f(tmp$ret$7);
  }
  var tmp_7 = to('partialDays', destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_2 = result.xr_1.bt_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$10 = EpochDays_getInstance().ee(item_1);
    destination_1.f(tmp$ret$10);
  }
  // Inline function 'kotlin.apply' call
  var this_3 = linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_4, tmp_5, tmp_6, to('loggingReview', linkedMapOf([tmp_7, to('fastedDays', destination_1)])), to('persistence', linkedMapOf([to('direction', result.ps_1.aj_1), to('weeks', result.ps_1.bj_1)])), to('accepted', accepted)]);
  if (initial) {
    this_3.l2('initial', true);
  }
  return tmp.sg(this_3);
};
protoOf(NutritionJson).et = function (result, accepted, initial, $super) {
  accepted = accepted === VOID ? true : accepted;
  initial = initial === VOID ? false : initial;
  return $super === VOID ? this.or(result, accepted, initial) : $super.or.call(this, result, accepted, initial);
};
var NutritionJson_instance;
function NutritionJson_getInstance() {
  return NutritionJson_instance;
}
function LoggingReview(possibleFastingDays) {
  this.ft_1 = possibleFastingDays;
}
protoOf(LoggingReview).toString = function () {
  return 'LoggingReview(possibleFastingDays=' + toString(this.ft_1) + ')';
};
protoOf(LoggingReview).hashCode = function () {
  return hashCode(this.ft_1);
};
protoOf(LoggingReview).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LoggingReview))
    return false;
  if (!equals(this.ft_1, other.ft_1))
    return false;
  return true;
};
function PartialDays() {
}
protoOf(PartialDays).gt = function (intake, fromDay, toDay) {
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = intake.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.fk_1;
    destination.l2(tmp$ret$2, element);
  }
  var byDay = destination;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var day = element_0;
      var entry = byDay.t1(day);
      if (entry == null ? true : entry.hk_1.equals(DayStatus_UNLOGGED_getInstance()) ? true : entry.hk_1.equals(DayStatus_COMPLETE_getInstance()) && entry.gk_1 <= 0.0 ? true : false) {
        destination_0.f(element_0);
      }
    }
     while (!(element_0 === last));
  var fasting = destination_0;
  return new LoggingReview(fasting);
};
var PartialDays_instance;
function PartialDays_getInstance() {
  return PartialDays_instance;
}
function StrengthIndexPoint(day, index) {
  this.ht_1 = day;
  this.it_1 = index;
}
protoOf(StrengthIndexPoint).toString = function () {
  return 'StrengthIndexPoint(day=' + this.ht_1 + ', index=' + this.it_1 + ')';
};
protoOf(StrengthIndexPoint).hashCode = function () {
  var result = this.ht_1;
  result = imul(result, 31) + getNumberHashCode(this.it_1) | 0;
  return result;
};
protoOf(StrengthIndexPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StrengthIndexPoint))
    return false;
  if (!(this.ht_1 === other.ht_1))
    return false;
  if (!equals(this.it_1, other.it_1))
    return false;
  return true;
};
function GuardrailResult(triggered, changePct, sessions, suggestedRatePctPerWeek, suggestDietBreak) {
  this.jt_1 = triggered;
  this.kt_1 = changePct;
  this.lt_1 = sessions;
  this.mt_1 = suggestedRatePctPerWeek;
  this.nt_1 = suggestDietBreak;
}
protoOf(GuardrailResult).toString = function () {
  return 'GuardrailResult(triggered=' + this.jt_1 + ', changePct=' + this.kt_1 + ', sessions=' + this.lt_1 + ', suggestedRatePctPerWeek=' + this.mt_1 + ', suggestDietBreak=' + this.nt_1 + ')';
};
protoOf(GuardrailResult).hashCode = function () {
  var result = getBooleanHashCode(this.jt_1);
  result = imul(result, 31) + (this.kt_1 == null ? 0 : getNumberHashCode(this.kt_1)) | 0;
  result = imul(result, 31) + this.lt_1 | 0;
  result = imul(result, 31) + (this.mt_1 == null ? 0 : getNumberHashCode(this.mt_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.nt_1) | 0;
  return result;
};
protoOf(GuardrailResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GuardrailResult))
    return false;
  if (!(this.jt_1 === other.jt_1))
    return false;
  if (!equals(this.kt_1, other.kt_1))
    return false;
  if (!(this.lt_1 === other.lt_1))
    return false;
  if (!equals(this.mt_1, other.mt_1))
    return false;
  if (!(this.nt_1 === other.nt_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_1(function_0) {
  this.ot_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_1).ea = function (a, b) {
  return this.ot_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).h2 = function () {
  return this.ot_1;
};
protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
  return hashCode(this.h2());
};
function PerformanceGuardrail$evaluate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.ht_1;
  var tmp$ret$2 = b.ht_1;
  return compareValues(tmp, tmp$ret$2);
}
function PerformanceGuardrail() {
  this.pt_1 = 21;
  this.qt_1 = 3.0;
  this.rt_1 = 3;
  this.st_1 = 7;
  this.tt_1 = 0.25;
  this.ut_1 = 0.05;
}
protoOf(PerformanceGuardrail).vt = function (points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    var containsLower = today - windowDays | 0;
    var containsArg = element.ht_1;
    if (containsLower <= containsArg ? containsArg <= today : false) {
      tmp = element.it_1 > 0.0;
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = PerformanceGuardrail$evaluate$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_0);
  var window_0 = sortedWith(destination, tmp$ret$6);
  var change = this.wt(window_0, minSessions);
  var triggered = !(change == null) && ratePctPerWeek < 0.0 && change < -dropThresholdPct;
  if (!triggered)
    return new GuardrailResult(false, change, window_0.o(), null, false);
  // Inline function 'kotlin.math.abs' call
  var magnitude = Math.abs(ratePctPerWeek);
  var dietBreak = magnitude <= 0.25 + 1.0E-9;
  var tmp_1;
  if (dietBreak) {
    tmp_1 = 0.0;
  } else {
    // Inline function 'kotlin.math.floor' call
    var x = magnitude / 2.0 / 0.05 + 1.0E-9;
    tmp_1 = -(Math.floor(x) * 0.05);
  }
  var suggested = tmp_1;
  return new GuardrailResult(true, change, window_0.o(), suggested, dietBreak);
};
protoOf(PerformanceGuardrail).xt = function (points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions, $super) {
  windowDays = windowDays === VOID ? 21 : windowDays;
  dropThresholdPct = dropThresholdPct === VOID ? 3.0 : dropThresholdPct;
  minSessions = minSessions === VOID ? 3 : minSessions;
  return $super === VOID ? this.vt(points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions) : $super.vt.call(this, points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions);
};
protoOf(PerformanceGuardrail).wt = function (window_0, minSessions) {
  if (window_0.o() < minSessions || (last(window_0).ht_1 - first(window_0).ht_1 | 0) < 7)
    return null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(window_0, 10));
  var _iterator__ex2g4s = window_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.ht_1;
    destination.f(tmp$ret$2);
  }
  var xs = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(window_0, 10));
  var _iterator__ex2g4s_0 = window_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.it_1;
    destination_0.f(tmp$ret$5);
  }
  var ys = destination_0;
  var meanX = average(xs);
  var meanY = average(ys);
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_1 = xs.j();
  while (_iterator__ex2g4s_1.k()) {
    var element = _iterator__ex2g4s_1.l();
    var tmp = sum;
    sum = tmp + (element - meanX) * (element - meanX);
  }
  var sxx = sum;
  // Inline function 'kotlin.collections.sumOf' call
  var sum_0 = 0;
  var progression = get_indices(xs);
  var inductionVariable = progression.xc_1;
  var last_0 = progression.yc_1;
  if (inductionVariable <= last_0)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0 = sum_0;
      var it = element_0;
      sum_0 = tmp_0 + (xs.n(it) - meanX) * (ys.n(it) - meanY);
    }
     while (!(element_0 === last_0));
  var slope = sum_0 / sxx;
  var start = meanY + slope * (first(xs) - meanX);
  if (start <= 0.0)
    return null;
  return slope * (last(xs) - first(xs)) / start * 100.0;
};
protoOf(PerformanceGuardrail).yt = function (window_0, minSessions, $super) {
  minSessions = minSessions === VOID ? 3 : minSessions;
  return $super === VOID ? this.wt(window_0, minSessions) : $super.wt.call(this, window_0, minSessions);
};
var PerformanceGuardrail_instance;
function PerformanceGuardrail_getInstance() {
  return PerformanceGuardrail_instance;
}
var static_init_called_14;
function static_init_14() {
  if (static_init_called_14)
    return Unit_instance;
  static_init_called_14 = true;
  TrainingType_AUTO_instance = new TrainingType('AUTO', 0);
  TrainingType_NONE_instance = new TrainingType('NONE', 1);
  TrainingType_CARDIO_instance = new TrainingType('CARDIO', 2);
  TrainingType_STRENGTH_instance = new TrainingType('STRENGTH', 3);
  TrainingType_BOTH_instance = new TrainingType('BOTH', 4);
}
var TrainingType_AUTO_instance;
var TrainingType_NONE_instance;
var TrainingType_CARDIO_instance;
var TrainingType_STRENGTH_instance;
var TrainingType_BOTH_instance;
function values_10() {
  static_init_14();
  return [TrainingType_AUTO_getInstance(), TrainingType_NONE_getInstance(), TrainingType_CARDIO_getInstance(), TrainingType_STRENGTH_getInstance(), TrainingType_BOTH_getInstance()];
}
function get_entries_7() {
  static_init_14();
  if ($ENTRIES_7 == null)
    $ENTRIES_7 = enumEntries(values_10());
  return $ENTRIES_7;
}
var $ENTRIES_7;
function TrainingType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_15;
function static_init_15() {
  if (static_init_called_15)
    return Unit_instance;
  static_init_called_15 = true;
  ProteinMethod_LEAN_TABLE_instance = new ProteinMethod('LEAN_TABLE', 0);
  ProteinMethod_GOAL_TRAINING_instance = new ProteinMethod('GOAL_TRAINING', 1);
}
var ProteinMethod_LEAN_TABLE_instance;
var ProteinMethod_GOAL_TRAINING_instance;
function values_11() {
  static_init_15();
  return [ProteinMethod_LEAN_TABLE_getInstance(), ProteinMethod_GOAL_TRAINING_getInstance()];
}
function get_entries_8() {
  static_init_15();
  if ($ENTRIES_8 == null)
    $ENTRIES_8 = enumEntries(values_11());
  return $ENTRIES_8;
}
var $ENTRIES_8;
function ProteinMethod(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ProteinTargets() {
  ProteinTargets_instance = this;
  this.kq_1 = 80.0;
  this.lq_1 = 6.0;
  this.mq_1 = mapOf_0([to(ProteinPreference_LOW_getInstance(), 1.6), to(ProteinPreference_MODERATE_getInstance(), 2.0), to(ProteinPreference_HIGH_getInstance(), 2.4), to(ProteinPreference_EXTRA_HIGH_getInstance(), 2.8)]);
  this.nq_1 = 0.3;
  this.oq_1 = 0.3;
  this.pq_1 = 0.15;
  this.qq_1 = 65;
  this.rq_1 = 1.0;
}
protoOf(ProteinTargets).sq = function (choice, weeklyHardSets) {
  return !choice.equals(TrainingType_AUTO_getInstance()) ? choice : !(weeklyHardSets == null) && weeklyHardSets >= 6.0 ? TrainingType_STRENGTH_getInstance() : TrainingType_NONE_getInstance();
};
protoOf(ProteinTargets).zt = function (method, preference, leanMassKg, cutting, training, leanCapKg, ageYears, weightKg) {
  // Inline function 'kotlin.math.min' call
  var capped = Math.min(leanMassKg, leanCapKg);
  var tmp;
  switch (method.y1_1) {
    case 0:
      tmp = preference.wq_1 * leanMassKg;
      break;
    case 1:
      var tmp_0;
      switch (training.y1_1) {
        case 3:
        case 4:
          tmp_0 = 0.3;
          break;
        case 2:
          tmp_0 = 0.15;
          break;
        case 1:
        case 0:
          tmp_0 = 0.0;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      var train = tmp_0;
      tmp = capped * (getValue(this.mq_1, preference) + (cutting ? 0.3 : 0.0) + train);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var result = tmp;
  var floor = !(ageYears == null) && ageYears >= 65 && !(weightKg == null) ? 1.0 * weightKg : null;
  var tmp_1;
  if (!(floor == null)) {
    // Inline function 'kotlin.comparisons.maxOf' call
    tmp_1 = Math.max(result, floor);
  } else {
    tmp_1 = result;
  }
  return tmp_1;
};
var ProteinTargets_instance;
function ProteinTargets_getInstance() {
  if (ProteinTargets_instance == null)
    new ProteinTargets();
  return ProteinTargets_instance;
}
function TrainingType_AUTO_getInstance() {
  static_init_14();
  return TrainingType_AUTO_instance;
}
function TrainingType_NONE_getInstance() {
  static_init_14();
  return TrainingType_NONE_instance;
}
function TrainingType_CARDIO_getInstance() {
  static_init_14();
  return TrainingType_CARDIO_instance;
}
function TrainingType_STRENGTH_getInstance() {
  static_init_14();
  return TrainingType_STRENGTH_instance;
}
function TrainingType_BOTH_getInstance() {
  static_init_14();
  return TrainingType_BOTH_instance;
}
function ProteinMethod_LEAN_TABLE_getInstance() {
  static_init_15();
  return ProteinMethod_LEAN_TABLE_instance;
}
function ProteinMethod_GOAL_TRAINING_getInstance() {
  static_init_15();
  return ProteinMethod_GOAL_TRAINING_instance;
}
function ShiftResult(kcal, shiftKcal, limitedByFloor) {
  this.au_1 = kcal;
  this.bu_1 = shiftKcal;
  this.cu_1 = limitedByFloor;
}
protoOf(ShiftResult).toString = function () {
  return 'ShiftResult(kcal=' + toString(this.au_1) + ', shiftKcal=' + this.bu_1 + ', limitedByFloor=' + this.cu_1 + ')';
};
protoOf(ShiftResult).hashCode = function () {
  var result = hashCode(this.au_1);
  result = imul(result, 31) + getNumberHashCode(this.bu_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.cu_1) | 0;
  return result;
};
protoOf(ShiftResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftResult))
    return false;
  if (!equals(this.au_1, other.au_1))
    return false;
  if (!equals(this.bu_1, other.bu_1))
    return false;
  if (!(this.cu_1 === other.cu_1))
    return false;
  return true;
};
function TrainingShift() {
  this.du_1 = 150.0;
  this.eu_1 = "The extra calories on training days are carbohydrate, to fuel harder sessions, and rest days have a little less. Protein and fat stay the same and so does the weekly total; it supports performance, it doesn't speed up fat loss.";
}
protoOf(TrainingShift).fu = function (dailyKcal, trainingDays, kcalPerTrainingDay, floorKcal) {
  // Inline function 'kotlin.require' call
  if (!(dailyKcal.o() === 7)) {
    var message = 'dailyKcal must have 7 days';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(trainingDays, Collection)) {
      tmp = trainingDays.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = trainingDays.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
    }
    tmp$ret$2 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$2) {
    var message_0 = 'trainingDays must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(kcalPerTrainingDay >= 0.0)) {
    var message_1 = 'kcalPerTrainingDay must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  if (trainingDays.m() || trainingDays.o() === 7 || kcalPerTrainingDay === 0.0) {
    return new ShiftResult(dailyKcal, 0.0, false);
  }
  var training = trainingDays.o();
  var rest = 7.0 - training;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = numberRangeToNumber(0, 6);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element_0;
      if (!trainingDays.r(it)) {
        destination.f(element_0);
      }
    }
     while (!(element_0 === last));
  // Inline function 'kotlin.collections.minOf' call
  var iterator = destination.j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var it_0 = iterator.l();
  var minValue = dailyKcal.n(it_0);
  while (iterator.k()) {
    var it_1 = iterator.l();
    var v = dailyKcal.n(it_1);
    // Inline function 'kotlin.comparisons.minOf' call
    var a = minValue;
    minValue = Math.min(a, v);
  }
  var lowestRest = minValue;
  var tmp_0;
  if (floorKcal == null) {
    tmp_0 = kcalPerTrainingDay;
  } else {
    // Inline function 'kotlin.math.max' call
    var b = (lowestRest - floorKcal) * rest / training;
    tmp_0 = Math.max(0.0, b);
  }
  var allowed = tmp_0;
  // Inline function 'kotlin.math.min' call
  var shift = Math.min(kcalPerTrainingDay, allowed);
  var restLoss = shift * training / rest;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(dailyKcal, 10));
  var index = 0;
  var _iterator__ex2g4s_0 = dailyKcal.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$19 = trainingDays.r(index_0) ? item + shift : item - restLoss;
    destination_0.f(tmp$ret$19);
  }
  var days = destination_0;
  return new ShiftResult(days, shift, shift < kcalPerTrainingDay - 1.0E-9);
};
protoOf(TrainingShift).gu = function (even, shiftedKcal) {
  // Inline function 'kotlin.require' call
  if (!(even.o() === 7 && shiftedKcal.o() === 7)) {
    var message = 'even and shiftedKcal must have 7 days';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices(even);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = item;
      var day = even.n(index);
      var tmp$ret$4 = day.yq(shiftedKcal.n(index), VOID, VOID, day.mk_1 + (shiftedKcal.n(index) - day.jk_1) / 4.0);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var days = destination;
  // Inline function 'kotlin.takeIf' call
  var tmp;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp_0;
    if (isInterface(days, Collection)) {
      tmp_0 = days.m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$7 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = days.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(element.mk_1 >= 0.0)) {
        tmp$ret$7 = false;
        break $l$block_0;
      }
    }
    tmp$ret$7 = true;
  }
  if (tmp$ret$7) {
    tmp = days;
  } else {
    tmp = null;
  }
  return tmp;
};
var TrainingShift_instance;
function TrainingShift_getInstance() {
  return TrainingShift_instance;
}
function BandPoint(day, lowKg, highKg) {
  this.hu_1 = day;
  this.iu_1 = lowKg;
  this.ju_1 = highKg;
}
protoOf(BandPoint).toString = function () {
  return 'BandPoint(day=' + this.hu_1 + ', lowKg=' + this.iu_1 + ', highKg=' + this.ju_1 + ')';
};
protoOf(BandPoint).hashCode = function () {
  var result = this.hu_1;
  result = imul(result, 31) + getNumberHashCode(this.iu_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ju_1) | 0;
  return result;
};
protoOf(BandPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BandPoint))
    return false;
  if (!(this.hu_1 === other.hu_1))
    return false;
  if (!equals(this.iu_1, other.iu_1))
    return false;
  if (!equals(this.ju_1, other.ju_1))
    return false;
  return true;
};
function TrendProjection(fromDay, fromKg, toDay, toKg, style) {
  this.ku_1 = fromDay;
  this.lu_1 = fromKg;
  this.mu_1 = toDay;
  this.nu_1 = toKg;
  this.ou_1 = style;
}
protoOf(TrendProjection).toString = function () {
  return 'TrendProjection(fromDay=' + this.ku_1 + ', fromKg=' + this.lu_1 + ', toDay=' + this.mu_1 + ', toKg=' + this.nu_1 + ', style=' + this.ou_1.toString() + ')';
};
protoOf(TrendProjection).hashCode = function () {
  var result = this.ku_1;
  result = imul(result, 31) + getNumberHashCode(this.lu_1) | 0;
  result = imul(result, 31) + this.mu_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.nu_1) | 0;
  result = imul(result, 31) + this.ou_1.hashCode() | 0;
  return result;
};
protoOf(TrendProjection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrendProjection))
    return false;
  if (!(this.ku_1 === other.ku_1))
    return false;
  if (!equals(this.lu_1, other.lu_1))
    return false;
  if (!(this.mu_1 === other.mu_1))
    return false;
  if (!equals(this.nu_1, other.nu_1))
    return false;
  if (!this.ou_1.equals(other.ou_1))
    return false;
  return true;
};
function TrendChart() {
  this.pu_1 = 30;
}
protoOf(TrendChart).qu = function (trend, weighIns, params) {
  if (trend.m())
    return emptyList();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = TransientTrend_instance.tu(weighIns, last(trend).pn_1, params);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.uu_1.pn_1, element.wu_1);
    destination.l2(pair.nb_1, pair.ob_1);
  }
  var noise = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = trend.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = noise.t1(element_0.pn_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new BandPoint(element_0.pn_1, element_0.sn_1 - tmp0_safe_receiver, element_0.sn_1 + tmp0_safe_receiver);
    }
    var tmp0_safe_receiver_0 = tmp;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  return destination_0;
};
protoOf(TrendChart).xu = function (trend, weighIns, params, $super) {
  params = params === VOID ? new TransientTrendParams() : params;
  return $super === VOID ? this.qu(trend, weighIns, params) : $super.qu.call(this, trend, weighIns, params);
};
protoOf(TrendChart).yu = function (trend, style, goal, days) {
  // Inline function 'kotlin.require' call
  if (!(days > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = lastOrNull(trend);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var tmp1_safe_receiver = WeightTrend_instance.zu(trend);
  var dataSlope = tmp1_safe_receiver == null ? null : tmp1_safe_receiver / 7.0;
  var tmp2_elvis_lhs = Goals_instance.wp(style, dataSlope, trend.o(), goal, last.sn_1);
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var slope = tmp_0;
  return new TrendProjection(last.pn_1, last.sn_1, last.pn_1 + days | 0, last.sn_1 + slope * days, style);
};
protoOf(TrendChart).av = function (trend, style, goal, days, $super) {
  days = days === VOID ? 30 : days;
  return $super === VOID ? this.yu(trend, style, goal, days) : $super.yu.call(this, trend, style, goal, days);
};
var TrendChart_instance;
function TrendChart_getInstance() {
  return TrendChart_instance;
}
var static_init_called_16;
function static_init_16() {
  if (static_init_called_16)
    return Unit_instance;
  static_init_called_16 = true;
  ProgramKind_COACHED_instance = new ProgramKind('COACHED', 0);
  ProgramKind_COLLABORATIVE_instance = new ProgramKind('COLLABORATIVE', 1);
  ProgramKind_MANUAL_instance = new ProgramKind('MANUAL', 2);
}
var ProgramKind_COACHED_instance;
var ProgramKind_COLLABORATIVE_instance;
var ProgramKind_MANUAL_instance;
function values_12() {
  static_init_16();
  return [ProgramKind_COACHED_getInstance(), ProgramKind_COLLABORATIVE_getInstance(), ProgramKind_MANUAL_getInstance()];
}
function ProgramKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_17;
function static_init_17() {
  if (static_init_called_17)
    return Unit_instance;
  static_init_called_17 = true;
  DistributionKind_EVEN_instance = new DistributionKind('EVEN', 0);
  DistributionKind_HIGH_DAYS_instance = new DistributionKind('HIGH_DAYS', 1);
}
var DistributionKind_EVEN_instance;
var DistributionKind_HIGH_DAYS_instance;
function values_13() {
  static_init_17();
  return [DistributionKind_EVEN_getInstance(), DistributionKind_HIGH_DAYS_getInstance()];
}
function DistributionKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TrainingShiftSetting(enabled, kcal, carbs) {
  enabled = enabled === VOID ? false : enabled;
  kcal = kcal === VOID ? 150.0 : kcal;
  carbs = carbs === VOID ? false : carbs;
  this.bv_1 = enabled;
  this.cv_1 = kcal;
  this.dv_1 = carbs;
}
protoOf(TrainingShiftSetting).toString = function () {
  return 'TrainingShiftSetting(enabled=' + this.bv_1 + ', kcal=' + this.cv_1 + ', carbs=' + this.dv_1 + ')';
};
protoOf(TrainingShiftSetting).hashCode = function () {
  var result = getBooleanHashCode(this.bv_1);
  result = imul(result, 31) + getNumberHashCode(this.cv_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.dv_1) | 0;
  return result;
};
protoOf(TrainingShiftSetting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingShiftSetting))
    return false;
  if (!(this.bv_1 === other.bv_1))
    return false;
  if (!equals(this.cv_1, other.cv_1))
    return false;
  if (!(this.dv_1 === other.dv_1))
    return false;
  return true;
};
function NutritionProgram(kind, dietType, proteinPreference, calorieFloor, checkInWeekday, distribution, highDays, trainingShift, manual, dietBreak) {
  kind = kind === VOID ? ProgramKind_COACHED_getInstance() : kind;
  dietType = dietType === VOID ? DietType_BALANCED_getInstance() : dietType;
  proteinPreference = proteinPreference === VOID ? ProteinPreference_MODERATE_getInstance() : proteinPreference;
  calorieFloor = calorieFloor === VOID ? CalorieFloor_STANDARD_getInstance() : calorieFloor;
  checkInWeekday = checkInWeekday === VOID ? 1 : checkInWeekday;
  distribution = distribution === VOID ? DistributionKind_EVEN_getInstance() : distribution;
  highDays = highDays === VOID ? emptySet() : highDays;
  trainingShift = trainingShift === VOID ? new TrainingShiftSetting() : trainingShift;
  manual = manual === VOID ? emptyList() : manual;
  dietBreak = dietBreak === VOID ? null : dietBreak;
  this.ev_1 = kind;
  this.fv_1 = dietType;
  this.gv_1 = proteinPreference;
  this.hv_1 = calorieFloor;
  this.iv_1 = checkInWeekday;
  this.jv_1 = distribution;
  this.kv_1 = highDays;
  this.lv_1 = trainingShift;
  this.mv_1 = manual;
  this.nv_1 = dietBreak;
}
protoOf(NutritionProgram).toString = function () {
  return 'NutritionProgram(kind=' + this.ev_1.toString() + ', dietType=' + this.fv_1.toString() + ', proteinPreference=' + this.gv_1.toString() + ', calorieFloor=' + this.hv_1.toString() + ', checkInWeekday=' + this.iv_1 + ', distribution=' + this.jv_1.toString() + ', highDays=' + toString(this.kv_1) + ', trainingShift=' + this.lv_1.toString() + ', manual=' + toString(this.mv_1) + ', dietBreak=' + toString_0(this.nv_1) + ')';
};
protoOf(NutritionProgram).hashCode = function () {
  var result = this.ev_1.hashCode();
  result = imul(result, 31) + this.fv_1.hashCode() | 0;
  result = imul(result, 31) + this.gv_1.hashCode() | 0;
  result = imul(result, 31) + this.hv_1.hashCode() | 0;
  result = imul(result, 31) + this.iv_1 | 0;
  result = imul(result, 31) + this.jv_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.kv_1) | 0;
  result = imul(result, 31) + this.lv_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.mv_1) | 0;
  result = imul(result, 31) + (this.nv_1 == null ? 0 : this.nv_1.hashCode()) | 0;
  return result;
};
protoOf(NutritionProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutritionProgram))
    return false;
  if (!this.ev_1.equals(other.ev_1))
    return false;
  if (!this.fv_1.equals(other.fv_1))
    return false;
  if (!this.gv_1.equals(other.gv_1))
    return false;
  if (!this.hv_1.equals(other.hv_1))
    return false;
  if (!(this.iv_1 === other.iv_1))
    return false;
  if (!this.jv_1.equals(other.jv_1))
    return false;
  if (!equals(this.kv_1, other.kv_1))
    return false;
  if (!this.lv_1.equals(other.lv_1))
    return false;
  if (!equals(this.mv_1, other.mv_1))
    return false;
  if (!equals(this.nv_1, other.nv_1))
    return false;
  return true;
};
function BodyProfile(sex, ageYears, heightCm, bodyFatFraction, leanMassKg, activityLevel, waistCm) {
  bodyFatFraction = bodyFatFraction === VOID ? null : bodyFatFraction;
  leanMassKg = leanMassKg === VOID ? null : leanMassKg;
  activityLevel = activityLevel === VOID ? ActivityLevel_MODERATE_getInstance() : activityLevel;
  waistCm = waistCm === VOID ? null : waistCm;
  this.cl_1 = sex;
  this.dl_1 = ageYears;
  this.el_1 = heightCm;
  this.fl_1 = bodyFatFraction;
  this.gl_1 = leanMassKg;
  this.hl_1 = activityLevel;
  this.il_1 = waistCm;
}
protoOf(BodyProfile).toString = function () {
  return 'BodyProfile(sex=' + this.cl_1.toString() + ', ageYears=' + this.dl_1 + ', heightCm=' + this.el_1 + ', bodyFatFraction=' + this.fl_1 + ', leanMassKg=' + this.gl_1 + ', activityLevel=' + this.hl_1.toString() + ', waistCm=' + this.il_1 + ')';
};
protoOf(BodyProfile).hashCode = function () {
  var result = this.cl_1.hashCode();
  result = imul(result, 31) + this.dl_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.el_1) | 0;
  result = imul(result, 31) + (this.fl_1 == null ? 0 : getNumberHashCode(this.fl_1)) | 0;
  result = imul(result, 31) + (this.gl_1 == null ? 0 : getNumberHashCode(this.gl_1)) | 0;
  result = imul(result, 31) + this.hl_1.hashCode() | 0;
  result = imul(result, 31) + (this.il_1 == null ? 0 : getNumberHashCode(this.il_1)) | 0;
  return result;
};
protoOf(BodyProfile).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BodyProfile))
    return false;
  if (!this.cl_1.equals(other.cl_1))
    return false;
  if (!(this.dl_1 === other.dl_1))
    return false;
  if (!equals(this.el_1, other.el_1))
    return false;
  if (!equals(this.fl_1, other.fl_1))
    return false;
  if (!equals(this.gl_1, other.gl_1))
    return false;
  if (!this.hl_1.equals(other.hl_1))
    return false;
  if (!equals(this.il_1, other.il_1))
    return false;
  return true;
};
function PreviousCheckIn(targets, persistence) {
  persistence = persistence === VOID ? new Persistence() : persistence;
  this.ov_1 = targets;
  this.pv_1 = persistence;
}
protoOf(PreviousCheckIn).qv = function () {
  return DailyTargets_instance.rk(this.ov_1);
};
protoOf(PreviousCheckIn).toString = function () {
  return 'PreviousCheckIn(targets=' + toString(this.ov_1) + ', persistence=' + this.pv_1.toString() + ')';
};
protoOf(PreviousCheckIn).hashCode = function () {
  var result = hashCode(this.ov_1);
  result = imul(result, 31) + this.pv_1.hashCode() | 0;
  return result;
};
protoOf(PreviousCheckIn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PreviousCheckIn))
    return false;
  if (!equals(this.ov_1, other.ov_1))
    return false;
  if (!this.pv_1.equals(other.pv_1))
    return false;
  return true;
};
function CheckInParams(loggingBreakMinUnusableDays, weighInLookbackDays, highDayMultiplier) {
  loggingBreakMinUnusableDays = loggingBreakMinUnusableDays === VOID ? 4 : loggingBreakMinUnusableDays;
  weighInLookbackDays = weighInLookbackDays === VOID ? 3 : weighInLookbackDays;
  highDayMultiplier = highDayMultiplier === VOID ? 1.1 : highDayMultiplier;
  this.rv_1 = loggingBreakMinUnusableDays;
  this.sv_1 = weighInLookbackDays;
  this.tv_1 = highDayMultiplier;
}
protoOf(CheckInParams).toString = function () {
  return 'CheckInParams(loggingBreakMinUnusableDays=' + this.rv_1 + ', weighInLookbackDays=' + this.sv_1 + ', highDayMultiplier=' + this.tv_1 + ')';
};
protoOf(CheckInParams).hashCode = function () {
  var result = this.rv_1;
  result = imul(result, 31) + this.sv_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.tv_1) | 0;
  return result;
};
protoOf(CheckInParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInParams))
    return false;
  if (!(this.rv_1 === other.rv_1))
    return false;
  if (!(this.sv_1 === other.sv_1))
    return false;
  if (!equals(this.tv_1, other.tv_1))
    return false;
  return true;
};
function WeeklyCheckInInput(day, program, goal, profile, intake, weighIns, expenditure, previous, trendMethod, trainingWeekdays, strength, algorithms, weeklyHardSets, params, recovery, startDay) {
  previous = previous === VOID ? null : previous;
  trendMethod = trendMethod === VOID ? TrendMethod_CLASSIC_getInstance() : trendMethod;
  trainingWeekdays = trainingWeekdays === VOID ? emptySet() : trainingWeekdays;
  strength = strength === VOID ? emptyList() : strength;
  algorithms = algorithms === VOID ? new AlgorithmSettings() : algorithms;
  weeklyHardSets = weeklyHardSets === VOID ? null : weeklyHardSets;
  params = params === VOID ? algorithms.wg() : params;
  recovery = recovery === VOID ? emptyList() : recovery;
  startDay = startDay === VOID ? null : startDay;
  this.uv_1 = day;
  this.vv_1 = program;
  this.wv_1 = goal;
  this.xv_1 = profile;
  this.yv_1 = intake;
  this.zv_1 = weighIns;
  this.aw_1 = expenditure;
  this.bw_1 = previous;
  this.cw_1 = trendMethod;
  this.dw_1 = trainingWeekdays;
  this.ew_1 = strength;
  this.fw_1 = algorithms;
  this.gw_1 = weeklyHardSets;
  this.hw_1 = params;
  this.iw_1 = recovery;
  this.jw_1 = startDay;
}
protoOf(WeeklyCheckInInput).toString = function () {
  return 'WeeklyCheckInInput(day=' + this.uv_1 + ', program=' + this.vv_1.toString() + ', goal=' + this.wv_1.toString() + ', profile=' + this.xv_1.toString() + ', intake=' + toString(this.yv_1) + ', weighIns=' + toString(this.zv_1) + ', expenditure=' + toString(this.aw_1) + ', previous=' + toString_0(this.bw_1) + ', trendMethod=' + this.cw_1.toString() + ', trainingWeekdays=' + toString(this.dw_1) + ', strength=' + toString(this.ew_1) + ', algorithms=' + this.fw_1.toString() + ', weeklyHardSets=' + this.gw_1 + ', params=' + this.hw_1.toString() + ', recovery=' + toString(this.iw_1) + ', startDay=' + this.jw_1 + ')';
};
protoOf(WeeklyCheckInInput).hashCode = function () {
  var result = this.uv_1;
  result = imul(result, 31) + this.vv_1.hashCode() | 0;
  result = imul(result, 31) + this.wv_1.hashCode() | 0;
  result = imul(result, 31) + this.xv_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.yv_1) | 0;
  result = imul(result, 31) + hashCode(this.zv_1) | 0;
  result = imul(result, 31) + hashCode(this.aw_1) | 0;
  result = imul(result, 31) + (this.bw_1 == null ? 0 : this.bw_1.hashCode()) | 0;
  result = imul(result, 31) + this.cw_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.dw_1) | 0;
  result = imul(result, 31) + hashCode(this.ew_1) | 0;
  result = imul(result, 31) + this.fw_1.hashCode() | 0;
  result = imul(result, 31) + (this.gw_1 == null ? 0 : getNumberHashCode(this.gw_1)) | 0;
  result = imul(result, 31) + this.hw_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.iw_1) | 0;
  result = imul(result, 31) + (this.jw_1 == null ? 0 : this.jw_1) | 0;
  return result;
};
protoOf(WeeklyCheckInInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyCheckInInput))
    return false;
  if (!(this.uv_1 === other.uv_1))
    return false;
  if (!this.vv_1.equals(other.vv_1))
    return false;
  if (!this.wv_1.equals(other.wv_1))
    return false;
  if (!this.xv_1.equals(other.xv_1))
    return false;
  if (!equals(this.yv_1, other.yv_1))
    return false;
  if (!equals(this.zv_1, other.zv_1))
    return false;
  if (!equals(this.aw_1, other.aw_1))
    return false;
  if (!equals(this.bw_1, other.bw_1))
    return false;
  if (!this.cw_1.equals(other.cw_1))
    return false;
  if (!equals(this.dw_1, other.dw_1))
    return false;
  if (!equals(this.ew_1, other.ew_1))
    return false;
  if (!this.fw_1.equals(other.fw_1))
    return false;
  if (!equals(this.gw_1, other.gw_1))
    return false;
  if (!this.hw_1.equals(other.hw_1))
    return false;
  if (!equals(this.iw_1, other.iw_1))
    return false;
  if (!(this.jw_1 == other.jw_1))
    return false;
  return true;
};
function WeekReview(fromDay, toDay, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays) {
  this.xs_1 = fromDay;
  this.ys_1 = toDay;
  this.zs_1 = possibleFastingDays;
  this.at_1 = partialDays;
  this.bt_1 = fastedDays;
  this.ct_1 = unloggedDays;
  this.dt_1 = usableDays;
}
protoOf(WeekReview).kw = function (fromDay, toDay, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays) {
  return new WeekReview(fromDay, toDay, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays);
};
protoOf(WeekReview).lw = function (fromDay, toDay, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays, $super) {
  fromDay = fromDay === VOID ? this.xs_1 : fromDay;
  toDay = toDay === VOID ? this.ys_1 : toDay;
  possibleFastingDays = possibleFastingDays === VOID ? this.zs_1 : possibleFastingDays;
  partialDays = partialDays === VOID ? this.at_1 : partialDays;
  fastedDays = fastedDays === VOID ? this.bt_1 : fastedDays;
  unloggedDays = unloggedDays === VOID ? this.ct_1 : unloggedDays;
  usableDays = usableDays === VOID ? this.dt_1 : usableDays;
  return $super === VOID ? this.kw(fromDay, toDay, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays) : $super.kw.call(this, fromDay, toDay, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays);
};
protoOf(WeekReview).toString = function () {
  return 'WeekReview(fromDay=' + this.xs_1 + ', toDay=' + this.ys_1 + ', possibleFastingDays=' + toString(this.zs_1) + ', partialDays=' + toString(this.at_1) + ', fastedDays=' + toString(this.bt_1) + ', unloggedDays=' + toString(this.ct_1) + ', usableDays=' + this.dt_1 + ')';
};
protoOf(WeekReview).hashCode = function () {
  var result = this.xs_1;
  result = imul(result, 31) + this.ys_1 | 0;
  result = imul(result, 31) + hashCode(this.zs_1) | 0;
  result = imul(result, 31) + hashCode(this.at_1) | 0;
  result = imul(result, 31) + hashCode(this.bt_1) | 0;
  result = imul(result, 31) + hashCode(this.ct_1) | 0;
  result = imul(result, 31) + this.dt_1 | 0;
  return result;
};
protoOf(WeekReview).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeekReview))
    return false;
  if (!(this.xs_1 === other.xs_1))
    return false;
  if (!(this.ys_1 === other.ys_1))
    return false;
  if (!equals(this.zs_1, other.zs_1))
    return false;
  if (!equals(this.at_1, other.at_1))
    return false;
  if (!equals(this.bt_1, other.bt_1))
    return false;
  if (!equals(this.ct_1, other.ct_1))
    return false;
  if (!(this.dt_1 === other.dt_1))
    return false;
  return true;
};
var static_init_called_18;
function static_init_18() {
  if (static_init_called_18)
    return Unit_instance;
  static_init_called_18 = true;
  CheckInModule_PARTIAL_LOGGING_instance = new CheckInModule('PARTIAL_LOGGING', 0);
  CheckInModule_WEIGH_IN_instance = new CheckInModule('WEIGH_IN', 1);
  CheckInModule_FASTING_instance = new CheckInModule('FASTING', 2);
  CheckInModule_LOGGING_BREAK_instance = new CheckInModule('LOGGING_BREAK', 3);
  CheckInModule_PROGRAM_UPDATE_instance = new CheckInModule('PROGRAM_UPDATE', 4);
  CheckInModule_TRAINING_PERFORMANCE_instance = new CheckInModule('TRAINING_PERFORMANCE', 5);
  CheckInModule_TRAINING_SPLIT_instance = new CheckInModule('TRAINING_SPLIT', 6);
  CheckInModule_RECOVERY_instance = new CheckInModule('RECOVERY', 7);
}
var CheckInModule_PARTIAL_LOGGING_instance;
var CheckInModule_WEIGH_IN_instance;
var CheckInModule_FASTING_instance;
var CheckInModule_LOGGING_BREAK_instance;
var CheckInModule_PROGRAM_UPDATE_instance;
var CheckInModule_TRAINING_PERFORMANCE_instance;
var CheckInModule_TRAINING_SPLIT_instance;
var CheckInModule_RECOVERY_instance;
function CheckInModule(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_19;
function static_init_19() {
  if (static_init_called_19)
    return Unit_instance;
  static_init_called_19 = true;
  CheckInFlagCode_LIKELY_PARTIAL_DAYS_instance = new CheckInFlagCode('LIKELY_PARTIAL_DAYS', 0);
  CheckInFlagCode_POSSIBLE_FASTING_DAYS_instance = new CheckInFlagCode('POSSIBLE_FASTING_DAYS', 1);
  CheckInFlagCode_WEIGH_IN_NEEDED_instance = new CheckInFlagCode('WEIGH_IN_NEEDED', 2);
  CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_instance = new CheckInFlagCode('NO_WEIGH_IN_THIS_WEEK', 3);
  CheckInFlagCode_LOGGING_BREAK_instance = new CheckInFlagCode('LOGGING_BREAK', 4);
  CheckInFlagCode_EXPENDITURE_HOLDING_instance = new CheckInFlagCode('EXPENDITURE_HOLDING', 5);
  CheckInFlagCode_FIRST_CHECK_IN_instance = new CheckInFlagCode('FIRST_CHECK_IN', 6);
  CheckInFlagCode_TARGETS_UPDATED_instance = new CheckInFlagCode('TARGETS_UPDATED', 7);
  CheckInFlagCode_TARGETS_KEPT_instance = new CheckInFlagCode('TARGETS_KEPT', 8);
  CheckInFlagCode_MANUAL_TARGETS_instance = new CheckInFlagCode('MANUAL_TARGETS', 9);
  CheckInFlagCode_FLOOR_LIMITED_instance = new CheckInFlagCode('FLOOR_LIMITED', 10);
  CheckInFlagCode_EVEN_SPLIT_FALLBACK_instance = new CheckInFlagCode('EVEN_SPLIT_FALLBACK', 11);
  CheckInFlagCode_MAINTENANCE_CORRECTION_instance = new CheckInFlagCode('MAINTENANCE_CORRECTION', 12);
  CheckInFlagCode_STRENGTH_FALLING_instance = new CheckInFlagCode('STRENGTH_FALLING', 13);
  CheckInFlagCode_TRAINING_SHIFT_APPLIED_instance = new CheckInFlagCode('TRAINING_SHIFT_APPLIED', 14);
  CheckInFlagCode_TRAINING_SHIFT_LIMITED_instance = new CheckInFlagCode('TRAINING_SHIFT_LIMITED', 15);
  CheckInFlagCode_FAST_LOSS_instance = new CheckInFlagCode('FAST_LOSS', 16);
  CheckInFlagCode_STRENGTH_TREND_instance = new CheckInFlagCode('STRENGTH_TREND', 17);
  CheckInFlagCode_SHORT_SLEEP_instance = new CheckInFlagCode('SHORT_SLEEP', 18);
  CheckInFlagCode_LOW_ENERGY_AVAILABILITY_instance = new CheckInFlagCode('LOW_ENERGY_AVAILABILITY', 19);
  CheckInFlagCode_RECOVERY_CONTEXT_instance = new CheckInFlagCode('RECOVERY_CONTEXT', 20);
  CheckInFlagCode_DIET_BREAK_instance = new CheckInFlagCode('DIET_BREAK', 21);
  CheckInFlagCode_DIET_BREAK_ENDED_instance = new CheckInFlagCode('DIET_BREAK_ENDED', 22);
  CheckInFlagCode_NOT_A_FULL_WEEK_YET_instance = new CheckInFlagCode('NOT_A_FULL_WEEK_YET', 23);
}
var CheckInFlagCode_LIKELY_PARTIAL_DAYS_instance;
var CheckInFlagCode_POSSIBLE_FASTING_DAYS_instance;
var CheckInFlagCode_WEIGH_IN_NEEDED_instance;
var CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_instance;
var CheckInFlagCode_LOGGING_BREAK_instance;
var CheckInFlagCode_EXPENDITURE_HOLDING_instance;
var CheckInFlagCode_FIRST_CHECK_IN_instance;
var CheckInFlagCode_TARGETS_UPDATED_instance;
var CheckInFlagCode_TARGETS_KEPT_instance;
var CheckInFlagCode_MANUAL_TARGETS_instance;
var CheckInFlagCode_FLOOR_LIMITED_instance;
var CheckInFlagCode_EVEN_SPLIT_FALLBACK_instance;
var CheckInFlagCode_MAINTENANCE_CORRECTION_instance;
var CheckInFlagCode_STRENGTH_FALLING_instance;
var CheckInFlagCode_TRAINING_SHIFT_APPLIED_instance;
var CheckInFlagCode_TRAINING_SHIFT_LIMITED_instance;
var CheckInFlagCode_FAST_LOSS_instance;
var CheckInFlagCode_STRENGTH_TREND_instance;
var CheckInFlagCode_SHORT_SLEEP_instance;
var CheckInFlagCode_LOW_ENERGY_AVAILABILITY_instance;
var CheckInFlagCode_RECOVERY_CONTEXT_instance;
var CheckInFlagCode_DIET_BREAK_instance;
var CheckInFlagCode_DIET_BREAK_ENDED_instance;
var CheckInFlagCode_NOT_A_FULL_WEEK_YET_instance;
function CheckInFlagCode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function CheckInFlag(module_0, code, message, days, messageKey) {
  days = days === VOID ? emptyList() : days;
  var tmp;
  if (messageKey === VOID) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = code.x1_1.toLowerCase();
    tmp = new Message('checkin.' + tmp$ret$0);
  } else {
    tmp = messageKey;
  }
  messageKey = tmp;
  this.mw_1 = module_0;
  this.nw_1 = code;
  this.ow_1 = message;
  this.pw_1 = days;
  this.qw_1 = messageKey;
}
protoOf(CheckInFlag).toString = function () {
  return 'CheckInFlag(module=' + this.mw_1.toString() + ', code=' + this.nw_1.toString() + ', message=' + this.ow_1 + ', days=' + toString(this.pw_1) + ', messageKey=' + this.qw_1.toString() + ')';
};
protoOf(CheckInFlag).hashCode = function () {
  var result = this.mw_1.hashCode();
  result = imul(result, 31) + this.nw_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.ow_1) | 0;
  result = imul(result, 31) + hashCode(this.pw_1) | 0;
  result = imul(result, 31) + this.qw_1.hashCode() | 0;
  return result;
};
protoOf(CheckInFlag).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInFlag))
    return false;
  if (!this.mw_1.equals(other.mw_1))
    return false;
  if (!this.nw_1.equals(other.nw_1))
    return false;
  if (!(this.ow_1 === other.ow_1))
    return false;
  if (!equals(this.pw_1, other.pw_1))
    return false;
  if (!this.qw_1.equals(other.qw_1))
    return false;
  return true;
};
function WeeklyCheckInResult(day, review, weighInsThisWeek, hasWeighInThisWeek, needsWeighIn, loggingBreak, expenditure, expenditureHolding, trendWeightKg, weeklyChangeKg, kcalPerKg, leanMassKg, effectiveRatePctPerWeek, rawTargetKcal, averageTargetKcal, changeKcal, limitedByFloor, targets, targetsUpdated, persistence, trainingShiftKcal, guardrail, flags, lifts, fastLoss, recoverySignals, onDietBreak) {
  lifts = lifts === VOID ? false : lifts;
  fastLoss = fastLoss === VOID ? null : fastLoss;
  recoverySignals = recoverySignals === VOID ? null : recoverySignals;
  onDietBreak = onDietBreak === VOID ? false : onDietBreak;
  this.wr_1 = day;
  this.xr_1 = review;
  this.yr_1 = weighInsThisWeek;
  this.zr_1 = hasWeighInThisWeek;
  this.as_1 = needsWeighIn;
  this.bs_1 = loggingBreak;
  this.cs_1 = expenditure;
  this.ds_1 = expenditureHolding;
  this.es_1 = trendWeightKg;
  this.fs_1 = weeklyChangeKg;
  this.gs_1 = kcalPerKg;
  this.hs_1 = leanMassKg;
  this.is_1 = effectiveRatePctPerWeek;
  this.js_1 = rawTargetKcal;
  this.ks_1 = averageTargetKcal;
  this.ls_1 = changeKcal;
  this.ms_1 = limitedByFloor;
  this.ns_1 = targets;
  this.os_1 = targetsUpdated;
  this.ps_1 = persistence;
  this.qs_1 = trainingShiftKcal;
  this.rs_1 = guardrail;
  this.ss_1 = flags;
  this.ts_1 = lifts;
  this.us_1 = fastLoss;
  this.vs_1 = recoverySignals;
  this.ws_1 = onDietBreak;
}
protoOf(WeeklyCheckInResult).toString = function () {
  return 'WeeklyCheckInResult(day=' + this.wr_1 + ', review=' + this.xr_1.toString() + ', weighInsThisWeek=' + this.yr_1 + ', hasWeighInThisWeek=' + this.zr_1 + ', needsWeighIn=' + this.as_1 + ', loggingBreak=' + this.bs_1 + ', expenditure=' + this.cs_1.toString() + ', expenditureHolding=' + this.ds_1 + ', trendWeightKg=' + this.es_1 + ', weeklyChangeKg=' + this.fs_1 + ', kcalPerKg=' + this.gs_1 + ', leanMassKg=' + this.hs_1 + ', effectiveRatePctPerWeek=' + this.is_1 + ', rawTargetKcal=' + this.js_1 + ', averageTargetKcal=' + this.ks_1 + ', changeKcal=' + this.ls_1 + ', limitedByFloor=' + this.ms_1 + ', targets=' + toString(this.ns_1) + ', targetsUpdated=' + this.os_1 + ', persistence=' + this.ps_1.toString() + ', trainingShiftKcal=' + this.qs_1 + ', guardrail=' + toString_0(this.rs_1) + ', flags=' + toString(this.ss_1) + ', lifts=' + this.ts_1 + ', fastLoss=' + toString_0(this.us_1) + ', recoverySignals=' + toString_0(this.vs_1) + ', onDietBreak=' + this.ws_1 + ')';
};
protoOf(WeeklyCheckInResult).hashCode = function () {
  var result = this.wr_1;
  result = imul(result, 31) + this.xr_1.hashCode() | 0;
  result = imul(result, 31) + this.yr_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.zr_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.as_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.bs_1) | 0;
  result = imul(result, 31) + this.cs_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ds_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.es_1) | 0;
  result = imul(result, 31) + (this.fs_1 == null ? 0 : getNumberHashCode(this.fs_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.gs_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.hs_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.is_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.js_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ks_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ls_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ms_1) | 0;
  result = imul(result, 31) + hashCode(this.ns_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.os_1) | 0;
  result = imul(result, 31) + this.ps_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.qs_1) | 0;
  result = imul(result, 31) + (this.rs_1 == null ? 0 : this.rs_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.ss_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ts_1) | 0;
  result = imul(result, 31) + (this.us_1 == null ? 0 : this.us_1.hashCode()) | 0;
  result = imul(result, 31) + (this.vs_1 == null ? 0 : this.vs_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ws_1) | 0;
  return result;
};
protoOf(WeeklyCheckInResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyCheckInResult))
    return false;
  if (!(this.wr_1 === other.wr_1))
    return false;
  if (!this.xr_1.equals(other.xr_1))
    return false;
  if (!(this.yr_1 === other.yr_1))
    return false;
  if (!(this.zr_1 === other.zr_1))
    return false;
  if (!(this.as_1 === other.as_1))
    return false;
  if (!(this.bs_1 === other.bs_1))
    return false;
  if (!this.cs_1.equals(other.cs_1))
    return false;
  if (!(this.ds_1 === other.ds_1))
    return false;
  if (!equals(this.es_1, other.es_1))
    return false;
  if (!equals(this.fs_1, other.fs_1))
    return false;
  if (!equals(this.gs_1, other.gs_1))
    return false;
  if (!equals(this.hs_1, other.hs_1))
    return false;
  if (!equals(this.is_1, other.is_1))
    return false;
  if (!equals(this.js_1, other.js_1))
    return false;
  if (!equals(this.ks_1, other.ks_1))
    return false;
  if (!equals(this.ls_1, other.ls_1))
    return false;
  if (!(this.ms_1 === other.ms_1))
    return false;
  if (!equals(this.ns_1, other.ns_1))
    return false;
  if (!(this.os_1 === other.os_1))
    return false;
  if (!this.ps_1.equals(other.ps_1))
    return false;
  if (!equals(this.qs_1, other.qs_1))
    return false;
  if (!equals(this.rs_1, other.rs_1))
    return false;
  if (!equals(this.ss_1, other.ss_1))
    return false;
  if (!(this.ts_1 === other.ts_1))
    return false;
  if (!equals(this.us_1, other.us_1))
    return false;
  if (!equals(this.vs_1, other.vs_1))
    return false;
  if (!(this.ws_1 === other.ws_1))
    return false;
  return true;
};
function addReviewFlags($this, flags, review, fullWeek, needsWeighIn, weighInsThisWeek, lookback) {
  if (!fullWeek) {
    flags.f(new CheckInFlag(CheckInModule_FASTING_getInstance(), CheckInFlagCode_NOT_A_FULL_WEEK_YET_getInstance(), "This is your first week, so there isn't a full 7 days to review yet."));
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!review.zs_1.m()) {
      var count = review.zs_1.o();
      flags.f(new CheckInFlag(CheckInModule_FASTING_getInstance(), CheckInFlagCode_POSSIBLE_FASTING_DAYS_getInstance(), 'Nothing was logged on ' + Fmt_instance.me(count, 'day') + '. Mark a day fasted (counts as 0 kcal) or leave it unlogged (ignored).', review.zs_1, new Message('checkin.possible_fasting_days', mapOf(to('count', count.toString())))));
    }
  }
  if (needsWeighIn) {
    flags.f(new CheckInFlag(CheckInModule_WEIGH_IN_getInstance(), CheckInFlagCode_WEIGH_IN_NEEDED_getInstance(), 'No weigh-in today or in the previous ' + lookback + ' days. Add one before new targets are set.', VOID, new Message('checkin.weigh_in_needed', mapOf(to('lookbackDays', lookback.toString())))));
  }
  if (weighInsThisWeek === 0) {
    flags.f(new CheckInFlag(CheckInModule_WEIGH_IN_getInstance(), CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_getInstance(), 'No weigh-in in the last 7 days; at least one a week keeps expenditure updating.'));
  }
}
function run$macros(trendKg, proteinG, program, algorithms, minimums, kcal) {
  return Macros_instance.ar(kcal, trendKg, proteinG, program.fv_1, algorithms.ag_1, minimums);
}
function WeeklyCheckIn() {
  this.jr_1 = 350.0;
}
protoOf(WeeklyCheckIn).kr = function (input) {
  var day = input.uv_1;
  var params = input.hw_1;
  var program = input.vv_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = input.zv_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.gm_1 <= day) {
      destination.f(element);
    }
  }
  var weighIns = destination;
  var trend = Trend_instance.rw(weighIns, day, input.cw_1);
  var tmp0_elvis_lhs = lastOrNull(trend);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var current = tmp;
  var trendKg = current.sn_1;
  var tmp1_safe_receiver = input.jw_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = day - 7 | 0;
    tmp_0 = Math.max(tmp1_safe_receiver, b);
  }
  var tmp2_elvis_lhs = tmp_0;
  var reviewFrom = tmp2_elvis_lhs == null ? day - 7 | 0 : tmp2_elvis_lhs;
  var fullWeek = (day - reviewFrom | 0) >= 7;
  // Inline function 'kotlin.let' call
  var it = this.gt(input.yv_1, reviewFrom, day - 1 | 0);
  var review = fullWeek ? it : it.lw(VOID, VOID, emptyList());
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(weighIns, 10));
  var _iterator__ex2g4s_0 = weighIns.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$10 = item.gm_1;
    destination_0.f(tmp$ret$10);
  }
  var weighInDays = toSet(destination_0);
  var tmp$ret$11;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_1;
    if (isInterface(weighInDays, Collection)) {
      tmp_1 = weighInDays.m();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp$ret$11 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s_1 = weighInDays.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      if ((day - 6 | 0) <= element_0 ? element_0 <= day : false) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$11 = count;
  }
  var weighInsThisWeek = tmp$ret$11;
  var tmp$ret$13;
  $l$block_1: {
    // Inline function 'kotlin.collections.none' call
    var tmp_2;
    if (isInterface(weighInDays, Collection)) {
      tmp_2 = weighInDays.m();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$13 = true;
      break $l$block_1;
    }
    var _iterator__ex2g4s_2 = weighInDays.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      if ((day - params.sv_1 | 0) <= element_1 ? element_1 <= day : false) {
        tmp$ret$13 = false;
        break $l$block_1;
      }
    }
    tmp$ret$13 = true;
  }
  var needsWeighIn = tmp$ret$13;
  var profile = input.xv_1;
  var algorithms = input.fw_1;
  var tmp3_elvis_lhs = profile.fl_1;
  var tmp_3;
  if (tmp3_elvis_lhs == null) {
    var tmp4_safe_receiver = profile.gl_1;
    var tmp_4;
    if (tmp4_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.takeIf' call
      var this_0 = 1.0 - tmp4_safe_receiver / trendKg;
      var tmp_5;
      if (this_0 > 0.0 && this_0 < 1.0) {
        tmp_5 = this_0;
      } else {
        tmp_5 = null;
      }
      tmp_4 = tmp_5;
    }
    tmp_3 = tmp_4;
  } else {
    tmp_3 = tmp3_elvis_lhs;
  }
  var bodyFat = tmp_3;
  var kcalPerKg = algorithms.xg(trendKg, bodyFat);
  var tmp5_elvis_lhs = profile.gl_1;
  var leanMass = tmp5_elvis_lhs == null ? BodyComposition_instance.sw(profile.cl_1, profile.dl_1, trendKg, profile.el_1, bodyFat, profile.il_1) : tmp5_elvis_lhs;
  var tmp_6 = ExpenditureInsights_getInstance();
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = input.aw_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = tmp0_0.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    if (element_2.in_1 <= day) {
      destination_1.f(element_2);
    }
  }
  var shown = tmp_6.vw(destination_1, day, weighInDays.r(day));
  var tmp7_elvis_lhs = shown == null ? null : shown.ww_1;
  var expenditure = tmp7_elvis_lhs == null ? new ExpenditurePoint(day, InitialExpenditure_instance.xm(profile.cl_1, trendKg, profile.el_1, profile.dl_1, profile.hl_1, bodyFat, algorithms.vf_1, profile.il_1), 350.0, ExpenditureStatus_INITIAL_getInstance()) : tmp7_elvis_lhs;
  var holding = expenditure.ln_1.equals(ExpenditureStatus_HOLDING_getInstance());
  var unusable = ((review.ys_1 - review.xs_1 | 0) + 1 | 0) - review.dt_1 | 0;
  var loggingBreak = holding || (fullWeek && unusable >= params.rv_1);
  var tmp8_safe_receiver = program.nv_1;
  var tmp_7;
  if (tmp8_safe_receiver == null) {
    tmp_7 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_8;
    if (input.wv_1.fi_1.equals(GoalType_LOSE_getInstance())) {
      tmp_8 = tmp8_safe_receiver;
    } else {
      tmp_8 = null;
    }
    tmp_7 = tmp_8;
  }
  var dietBreak = tmp_7;
  var onBreak = (dietBreak == null ? null : dietBreak.yk(day)) === true;
  var tmp_9;
  var tmp_10;
  if (onBreak) {
    tmp_10 = true;
  } else {
    tmp_10 = (dietBreak == null ? null : dietBreak.zk(day)) === true;
  }
  if (tmp_10) {
    tmp_9 = CheckInSmoothing_NONE_getInstance();
  } else {
    tmp_9 = algorithms.tf_1;
  }
  var smoothing = tmp_9;
  var goal = onBreak ? new Goal(GoalType_MAINTAIN_getInstance(), 0.0, null) : input.wv_1;
  var goalRate = CheckIn_instance.ij(input.wv_1, trendKg);
  var rate = CheckIn_instance.ij(goal, trendKg);
  var raw = expenditure.jn_1 + CheckIn_instance.jj(rate, trendKg, kcalPerKg);
  var previous = input.bw_1;
  var previousAverage = previous == null ? null : previous.qv();
  var minimums = CalorieFloors_instance.xh(algorithms.zf_1, trendKg, leanMass, profile.el_1, algorithms.yf_1);
  var floor = CalorieFloors_instance.yh(algorithms.zf_1, program.hv_1, minimums);
  var training = ProteinTargets_getInstance().sq(algorithms.xf_1, input.gw_1);
  var proteinG = ProteinTargets_getInstance().zt(algorithms.wf_1, program.gv_1, leanMass, goalRate < 0.0, training, algorithms.yf_1, profile.dl_1, trendKg);
  var flags = ArrayList_init_$Create$_0();
  var limitedByFloor = false;
  var shiftKcal = 0.0;
  var updated;
  var persistence;
  var targets;
  var tmp_11;
  if (program.ev_1.equals(ProgramKind_MANUAL_getInstance())) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_11 = !program.mv_1.m();
  } else {
    tmp_11 = false;
  }
  var manual = tmp_11;
  if (manual) {
    targets = DailyTargets_instance.qk(program.mv_1);
    var tmp13_elvis_lhs = previous == null ? null : previous.pv_1;
    persistence = tmp13_elvis_lhs == null ? new Persistence() : tmp13_elvis_lhs;
    updated = false;
    flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_MANUAL_TARGETS_getInstance(), 'Manual program: your targets stay as you set them.'));
  } else if (loggingBreak && !(previous == null)) {
    targets = DailyTargets_instance.qk(previous.ov_1);
    persistence = previous.pv_1;
    updated = false;
    flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_TARGETS_KEPT_getInstance(), "Last week's targets are kept until there is enough data again."));
  } else {
    var tmp_12 = CheckIn_instance;
    var tmp15_elvis_lhs = previous == null ? null : previous.pv_1;
    persistence = tmp_12.mj(tmp15_elvis_lhs == null ? new Persistence() : tmp15_elvis_lhs, previousAverage, raw);
    var result = CheckIn_instance.lj(new CheckInInput(expenditure.jn_1, trendKg, goal, kcalPerKg, previousAverage, persistence.bj_1, VOID, program.hv_1, floor, smoothing, expenditure.kn_1));
    limitedByFloor = result.yi_1;
    var tmp_13;
    if (program.jv_1.equals(DistributionKind_HIGH_DAYS_getInstance())) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_1 = program.kv_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_4 = tmp0_1.j();
      while (_iterator__ex2g4s_4.k()) {
        var element_3 = _iterator__ex2g4s_4.l();
        if (1 <= element_3 ? element_3 <= 7 : false) {
          destination_2.f(element_3);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_2, 10));
      var _iterator__ex2g4s_5 = destination_2.j();
      while (_iterator__ex2g4s_5.k()) {
        var item_0 = _iterator__ex2g4s_5.l();
        var tmp$ret$30 = item_0 - 1 | 0;
        destination_3.f(tmp$ret$30);
      }
      tmp_13 = toSet(destination_3);
    } else {
      tmp_13 = emptySet();
    }
    var highDays = tmp_13;
    var daily = WeeklyDistribution_instance.dx(result.vi_1, highDays, algorithms.bg_1, floor, params.tv_1);
    var tmp_14;
    var tmp_15;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!highDays.m()) {
      tmp_15 = highDays.o() < 7;
    } else {
      tmp_15 = false;
    }
    if (tmp_15) {
      tmp_14 = distinct(daily).o() === 1;
    } else {
      tmp_14 = false;
    }
    if (tmp_14) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_EVEN_SPLIT_FALLBACK_getInstance(), 'High days would push a low day under the calorie floor, so the week is split evenly.'));
    }
    var carbShift = null;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_2 = input.dw_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_4 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_6 = tmp0_2.j();
    while (_iterator__ex2g4s_6.k()) {
      var element_4 = _iterator__ex2g4s_6.l();
      if (1 <= element_4 ? element_4 <= 7 : false) {
        destination_4.f(element_4);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_4, 10));
    var _iterator__ex2g4s_7 = destination_4.j();
    while (_iterator__ex2g4s_7.k()) {
      var item_1 = _iterator__ex2g4s_7.l();
      var tmp$ret$37 = item_1 - 1 | 0;
      destination_5.f(tmp$ret$37);
    }
    var trainingDays = toSet(destination_5);
    var tmp_16;
    var tmp_17;
    if (program.lv_1.bv_1) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_17 = !trainingDays.m();
    } else {
      tmp_17 = false;
    }
    if (tmp_17) {
      tmp_16 = trainingDays.o() < 7;
    } else {
      tmp_16 = false;
    }
    if (tmp_16) {
      var shift = TrainingShift_instance.fu(daily, trainingDays, program.lv_1.cv_1, floor);
      if (program.lv_1.dv_1 && shift.bu_1 > 0.0) {
        var tmp_18 = TrainingShift_instance;
        // Inline function 'kotlin.collections.map' call
        var this_1 = daily;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_8 = this_1.j();
        while (_iterator__ex2g4s_8.k()) {
          var item_2 = _iterator__ex2g4s_8.l();
          var tmp$ret$41 = run$macros(trendKg, proteinG, program, algorithms, minimums, item_2);
          destination_6.f(tmp$ret$41);
        }
        carbShift = tmp_18.gu(destination_6, shift.au_1);
      }
      daily = shift.au_1;
      shiftKcal = shift.bu_1;
      var asCarbs = !(carbShift == null) ? ' as carbohydrate' : '';
      if (shift.cu_1) {
        flags.f(new CheckInFlag(CheckInModule_TRAINING_SPLIT_getInstance(), CheckInFlagCode_TRAINING_SHIFT_LIMITED_getInstance(), 'Training days get ' + Fmt_instance.ie(shift.bu_1) + ' kcal more' + asCarbs + ' instead of ' + Fmt_instance.ie(program.lv_1.cv_1) + ', so rest days stay above the floor.', VOID, new Message('checkin.training_shift_limited', mapOf_0([to('shiftKcal', Fmt_instance.ie(shift.bu_1)), to('plannedKcal', Fmt_instance.ie(program.lv_1.cv_1)), to('carbs', (!(carbShift == null)).toString())]))));
      } else {
        flags.f(new CheckInFlag(CheckInModule_TRAINING_SPLIT_getInstance(), CheckInFlagCode_TRAINING_SHIFT_APPLIED_getInstance(), Fmt_instance.ie(shift.bu_1) + ' kcal moved to each training day' + asCarbs + '; the weekly total is unchanged.', VOID, new Message('checkin.training_shift_applied', mapOf_0([to('shiftKcal', Fmt_instance.ie(shift.bu_1)), to('carbs', (!(carbShift == null)).toString())]))));
      }
    }
    var tmp16_elvis_lhs = carbShift;
    var tmp_19;
    if (tmp16_elvis_lhs == null) {
      // Inline function 'kotlin.collections.map' call
      var this_2 = daily;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_9 = this_2.j();
      while (_iterator__ex2g4s_9.k()) {
        var item_3 = _iterator__ex2g4s_9.l();
        var tmp$ret$44 = run$macros(trendKg, proteinG, program, algorithms, minimums, item_3);
        destination_7.f(tmp$ret$44);
      }
      tmp_19 = destination_7;
    } else {
      tmp_19 = tmp16_elvis_lhs;
    }
    targets = tmp_19;
    updated = true;
    if (onBreak && !(dietBreak == null)) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_DIET_BREAK_getInstance(), 'Diet break: targets are at maintenance until ' + EpochDays_getInstance().ee(dietBreak.xk() - 1 | 0) + ". A diet break holds your calories at maintenance. Breaks can make dieting easier on appetite; they don't speed up fat loss, and each break week adds a week to your diet."));
    } else {
      if ((dietBreak == null ? null : dietBreak.zk(day)) === true) {
        flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_DIET_BREAK_ENDED_getInstance(), 'Your diet break is over, so targets return to your goal pace.'));
      }
    }
    if (previous == null) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_FIRST_CHECK_IN_getInstance(), 'First check-in: targets start at ' + Fmt_instance.ie(result.vi_1) + ' kcal a day.', VOID, new Message('checkin.first_check_in', mapOf(to('kcal', Fmt_instance.ie(result.vi_1))))));
    } else {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_TARGETS_UPDATED_getInstance(), 'Average daily target ' + Fmt_instance.ie(result.vi_1) + ' kcal (' + Fmt_instance.ke(result.vi_1 - previous.qv()) + ' kcal).', VOID, new Message('checkin.targets_updated', mapOf_0([to('kcal', Fmt_instance.ie(result.vi_1)), to('changeKcal', Fmt_instance.ke(result.vi_1 - previous.qv()))]))));
    }
    if (limitedByFloor && !(floor == null)) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_FLOOR_LIMITED_getInstance(), 'Targets are held at the ' + Fmt_instance.ie(floor) + ' kcal floor; a slower rate would avoid it.', VOID, new Message('checkin.floor_limited', mapOf(to('floorKcal', Fmt_instance.ie(floor))))));
    }
  }
  var average = DailyTargets_instance.rk(targets);
  addReviewFlags(this, flags, review, fullWeek, needsWeighIn, weighInsThisWeek, params.sv_1);
  if (loggingBreak) {
    if (holding) {
      flags.f(new CheckInFlag(CheckInModule_LOGGING_BREAK_getInstance(), CheckInFlagCode_EXPENDITURE_HOLDING_getInstance(), 'Expenditure is holding for lack of recent data; it resumes after a few days of logging and a weigh-in.'));
    }
    if (unusable >= params.rv_1) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_3 = numberRangeToNumber(review.xs_1, review.ys_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_8 = ArrayList_init_$Create$_0();
      var inductionVariable = tmp0_3.xc_1;
      var last = tmp0_3.yc_1;
      if (inductionVariable <= last)
        do {
          var element_5 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it_0 = element_5;
          if (review.ct_1.r(it_0) || review.at_1.r(it_0)) {
            destination_8.f(element_5);
          }
        }
         while (!(element_5 === last));
      var missing = destination_8;
      flags.f(new CheckInFlag(CheckInModule_LOGGING_BREAK_getInstance(), CheckInFlagCode_LOGGING_BREAK_getInstance(), Fmt_instance.me(unusable, 'day') + ' of the last 7 had no usable food log, so this week is treated as a logging break.', missing, new Message('checkin.logging_break', mapOf(to('days', unusable.toString())))));
    }
  }
  if (input.wv_1.fi_1.equals(GoalType_MAINTAIN_getInstance()) && !(rate === 0.0)) {
    var tmp18_elvis_lhs = input.wv_1.hi_1;
    var target = tmp18_elvis_lhs == null ? trendKg : tmp18_elvis_lhs;
    var side = trendKg > target ? 'above' : 'below';
    var tmp_20 = CheckInModule_PROGRAM_UPDATE_getInstance();
    var tmp_21 = CheckInFlagCode_MAINTENANCE_CORRECTION_getInstance();
    var tmp_22 = Fmt_instance;
    // Inline function 'kotlin.math.abs' call
    var x = trendKg - target;
    var tmp$ret$48 = Math.abs(x);
    var tmp_23 = tmp_22.he(tmp$ret$48, 1);
    var tmp_24 = Fmt_instance;
    // Inline function 'kotlin.math.abs' call
    var tmp$ret$49 = Math.abs(rate);
    var tmp_25 = 'Trend is ' + tmp_23 + ' kg ' + side + ' the target weight; aiming for a ' + tmp_24.he(tmp$ret$49, 2) + ' %/week correction.';
    var tmp_26 = Fmt_instance;
    // Inline function 'kotlin.math.abs' call
    var x_0 = trendKg - target;
    var tmp$ret$50 = Math.abs(x_0);
    var tmp_27 = to('diffKg', tmp_26.he(tmp$ret$50, 1));
    var tmp_28 = to('side', side);
    var tmp_29 = Fmt_instance;
    // Inline function 'kotlin.math.abs' call
    var tmp$ret$51 = Math.abs(rate);
    flags.f(new CheckInFlag(tmp_20, tmp_21, tmp_25, VOID, new Message('checkin.maintenance_correction', mapOf_0([tmp_27, tmp_28, to('ratePct', tmp_29.he(tmp$ret$51, 2))]))));
  }
  var guardrail = input.ew_1.m() ? null : PerformanceGuardrail_instance.xt(input.ew_1, day, rate);
  if (!(guardrail == null) && guardrail.jt_1) {
    var tmp_30;
    if (guardrail.nt_1) {
      tmp_30 = 'Consider a 1\u20132 week diet break at maintenance.';
    } else {
      var tmp_31 = Fmt_instance;
      var tmp19_elvis_lhs = guardrail.mt_1;
      tmp_30 = 'Consider a slower rate (' + tmp_31.he(tmp19_elvis_lhs == null ? 0.0 : tmp19_elvis_lhs, 2) + ' %/week) or a 1\u20132 week diet break.';
    }
    var advice = tmp_30;
    var tmp_32 = CheckInModule_TRAINING_PERFORMANCE_getInstance();
    var tmp_33 = CheckInFlagCode_STRENGTH_FALLING_getInstance();
    var tmp_34 = Fmt_instance;
    var tmp20_elvis_lhs = guardrail.kt_1;
    // Inline function 'kotlin.math.abs' call
    var x_1 = tmp20_elvis_lhs == null ? 0.0 : tmp20_elvis_lhs;
    var tmp$ret$52 = Math.abs(x_1);
    var tmp_35 = 'Estimated strength fell ' + tmp_34.he(tmp$ret$52, 1) + ' % over the last 3 weeks while in a deficit. ' + advice;
    var tmp_36 = Fmt_instance;
    var tmp21_elvis_lhs = guardrail.kt_1;
    // Inline function 'kotlin.math.abs' call
    var x_2 = tmp21_elvis_lhs == null ? 0.0 : tmp21_elvis_lhs;
    var tmp$ret$53 = Math.abs(x_2);
    var tmp_37 = to('changePct', tmp_36.he(tmp$ret$53, 1));
    var tmp_38 = to('suggestDietBreak', guardrail.nt_1.toString());
    var tmp_39 = Fmt_instance;
    var tmp22_elvis_lhs = guardrail.mt_1;
    flags.f(new CheckInFlag(tmp_32, tmp_33, tmp_35, VOID, new Message('checkin.strength_falling', mapOf_0([tmp_37, tmp_38, to('suggestedRatePct', tmp_39.he(tmp22_elvis_lhs == null ? 0.0 : tmp22_elvis_lhs, 2))]))));
  }
  var lifts = LossPace_instance.jq(algorithms.xf_1, input.gw_1);
  var change = guardrail == null ? null : guardrail.kt_1;
  var tmp_40;
  if (lifts && !(change == null)) {
    tmp_40 = !((guardrail == null ? null : guardrail.jt_1) === true);
  } else {
    tmp_40 = false;
  }
  if (tmp_40) {
    var note = rate < 0.0 ? ' Strength usually holds during a diet, so a steady line is a good sign.' : '';
    flags.f(new CheckInFlag(CheckInModule_TRAINING_PERFORMANCE_getInstance(), CheckInFlagCode_STRENGTH_TREND_getInstance(), 'Estimated strength on your logged lifts: ' + Fmt_instance.je(change, 1) + ' % over the last 3 weeks.' + note, VOID, new Message('checkin.strength_trend', mapOf_0([to('changePct', Fmt_instance.je(change, 1)), to('deficit', (rate < 0.0).toString())]))));
  }
  var fastLoss = LossPace_instance.tq(rate, trendKg, kcalPerKg, lifts);
  if (!(fastLoss == null)) {
    flags.f(new CheckInFlag(CheckInModule_TRAINING_PERFORMANCE_getInstance(), CheckInFlagCode_FAST_LOSS_getInstance(), fastLoss.c7()));
  }
  var tmp_41 = CheckInSignals_instance;
  var tmp_42 = !(profile.gl_1 == null) || !(bodyFat == null) ? leanMass : null;
  var tmp_43 = rate < 0.0;
  var signals = tmp_41.ek(day, input.iw_1, input.yv_1, review.xs_1, review.ys_1, tmp_42, tmp_43, loggingBreak, (guardrail == null ? null : guardrail.jt_1) === true);
  flags.q(CheckInSignals_instance.ik(signals));
  return new WeeklyCheckInResult(day, review, weighInsThisWeek, weighInsThisWeek > 0, needsWeighIn, loggingBreak, expenditure, holding, trendKg, Companion_getInstance_28().ix(trend, 7), kcalPerKg, leanMass, rate, raw, average, previousAverage == null ? 0.0 : average - previousAverage, limitedByFloor, targets, updated, persistence, shiftKcal, guardrail, flags, lifts, fastLoss, signals, onBreak);
};
protoOf(WeeklyCheckIn).gt = function (intake, fromDay, toDay) {
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = intake.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.fk_1;
    destination.l2(tmp$ret$2, element);
  }
  var byDay = destination;
  var days = numberRangeToNumber(fromDay, toDay);
  var logging = PartialDays_instance.gt(intake, fromDay, toDay);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var inductionVariable = days.xc_1;
  var last = days.yc_1;
  if (inductionVariable <= last)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element_0;
      var tmp0_safe_receiver = byDay.t1(it);
      if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hk_1, DayStatus_PARTIAL_getInstance())) {
        destination_0.f(element_0);
      }
    }
     while (!(element_0 === last));
  var tmp = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var inductionVariable_0 = days.xc_1;
  var last_0 = days.yc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var element_1 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = element_1;
      var tmp0_safe_receiver_0 = byDay.t1(it_0);
      if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.hk_1, DayStatus_FASTED_getInstance())) {
        destination_1.f(element_1);
      }
    }
     while (!(element_1 === last_0));
  var tmp_0 = destination_1;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var inductionVariable_1 = days.xc_1;
  var last_1 = days.yc_1;
  if (inductionVariable_1 <= last_1)
    do {
      var element_2 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var it_1 = element_2;
      var tmp_1;
      if (byDay.t1(it_1) == null) {
        tmp_1 = true;
      } else {
        var tmp0_safe_receiver_1 = byDay.t1(it_1);
        tmp_1 = equals(tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.hk_1, DayStatus_UNLOGGED_getInstance());
      }
      if (tmp_1) {
        destination_2.f(element_2);
      }
    }
     while (!(element_2 === last_1));
  var tmp_2 = destination_2;
  var tmp$ret$12;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_3;
    if (isInterface(days, Collection)) {
      tmp_3 = days.m();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$12 = 0;
      break $l$block;
    }
    var count = 0;
    var inductionVariable_2 = days.xc_1;
    var last_2 = days.yc_1;
    if (inductionVariable_2 <= last_2)
      do {
        var element_3 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var it_2 = element_3;
        var tmp_4;
        var tmp0_safe_receiver_2 = byDay.t1(it_2);
        if (equals(tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.hk_1, DayStatus_COMPLETE_getInstance())) {
          tmp_4 = true;
        } else {
          var tmp1_safe_receiver = byDay.t1(it_2);
          tmp_4 = equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hk_1, DayStatus_FASTED_getInstance());
        }
        if (tmp_4) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
       while (!(element_3 === last_2));
    tmp$ret$12 = count;
  }
  return new WeekReview(fromDay, toDay, logging.ft_1, tmp, tmp_0, tmp_2, tmp$ret$12);
};
var WeeklyCheckIn_instance;
function WeeklyCheckIn_getInstance() {
  return WeeklyCheckIn_instance;
}
function ProgramKind_COACHED_getInstance() {
  static_init_16();
  return ProgramKind_COACHED_instance;
}
function ProgramKind_COLLABORATIVE_getInstance() {
  static_init_16();
  return ProgramKind_COLLABORATIVE_instance;
}
function ProgramKind_MANUAL_getInstance() {
  static_init_16();
  return ProgramKind_MANUAL_instance;
}
function DistributionKind_EVEN_getInstance() {
  static_init_17();
  return DistributionKind_EVEN_instance;
}
function DistributionKind_HIGH_DAYS_getInstance() {
  static_init_17();
  return DistributionKind_HIGH_DAYS_instance;
}
function CheckInModule_WEIGH_IN_getInstance() {
  static_init_18();
  return CheckInModule_WEIGH_IN_instance;
}
function CheckInModule_FASTING_getInstance() {
  static_init_18();
  return CheckInModule_FASTING_instance;
}
function CheckInModule_LOGGING_BREAK_getInstance() {
  static_init_18();
  return CheckInModule_LOGGING_BREAK_instance;
}
function CheckInModule_PROGRAM_UPDATE_getInstance() {
  static_init_18();
  return CheckInModule_PROGRAM_UPDATE_instance;
}
function CheckInModule_TRAINING_PERFORMANCE_getInstance() {
  static_init_18();
  return CheckInModule_TRAINING_PERFORMANCE_instance;
}
function CheckInModule_TRAINING_SPLIT_getInstance() {
  static_init_18();
  return CheckInModule_TRAINING_SPLIT_instance;
}
function CheckInModule_RECOVERY_getInstance() {
  static_init_18();
  return CheckInModule_RECOVERY_instance;
}
function CheckInFlagCode_POSSIBLE_FASTING_DAYS_getInstance() {
  static_init_19();
  return CheckInFlagCode_POSSIBLE_FASTING_DAYS_instance;
}
function CheckInFlagCode_WEIGH_IN_NEEDED_getInstance() {
  static_init_19();
  return CheckInFlagCode_WEIGH_IN_NEEDED_instance;
}
function CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_getInstance() {
  static_init_19();
  return CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_instance;
}
function CheckInFlagCode_LOGGING_BREAK_getInstance() {
  static_init_19();
  return CheckInFlagCode_LOGGING_BREAK_instance;
}
function CheckInFlagCode_EXPENDITURE_HOLDING_getInstance() {
  static_init_19();
  return CheckInFlagCode_EXPENDITURE_HOLDING_instance;
}
function CheckInFlagCode_FIRST_CHECK_IN_getInstance() {
  static_init_19();
  return CheckInFlagCode_FIRST_CHECK_IN_instance;
}
function CheckInFlagCode_TARGETS_UPDATED_getInstance() {
  static_init_19();
  return CheckInFlagCode_TARGETS_UPDATED_instance;
}
function CheckInFlagCode_TARGETS_KEPT_getInstance() {
  static_init_19();
  return CheckInFlagCode_TARGETS_KEPT_instance;
}
function CheckInFlagCode_MANUAL_TARGETS_getInstance() {
  static_init_19();
  return CheckInFlagCode_MANUAL_TARGETS_instance;
}
function CheckInFlagCode_FLOOR_LIMITED_getInstance() {
  static_init_19();
  return CheckInFlagCode_FLOOR_LIMITED_instance;
}
function CheckInFlagCode_EVEN_SPLIT_FALLBACK_getInstance() {
  static_init_19();
  return CheckInFlagCode_EVEN_SPLIT_FALLBACK_instance;
}
function CheckInFlagCode_MAINTENANCE_CORRECTION_getInstance() {
  static_init_19();
  return CheckInFlagCode_MAINTENANCE_CORRECTION_instance;
}
function CheckInFlagCode_STRENGTH_FALLING_getInstance() {
  static_init_19();
  return CheckInFlagCode_STRENGTH_FALLING_instance;
}
function CheckInFlagCode_TRAINING_SHIFT_APPLIED_getInstance() {
  static_init_19();
  return CheckInFlagCode_TRAINING_SHIFT_APPLIED_instance;
}
function CheckInFlagCode_TRAINING_SHIFT_LIMITED_getInstance() {
  static_init_19();
  return CheckInFlagCode_TRAINING_SHIFT_LIMITED_instance;
}
function CheckInFlagCode_FAST_LOSS_getInstance() {
  static_init_19();
  return CheckInFlagCode_FAST_LOSS_instance;
}
function CheckInFlagCode_STRENGTH_TREND_getInstance() {
  static_init_19();
  return CheckInFlagCode_STRENGTH_TREND_instance;
}
function CheckInFlagCode_SHORT_SLEEP_getInstance() {
  static_init_19();
  return CheckInFlagCode_SHORT_SLEEP_instance;
}
function CheckInFlagCode_LOW_ENERGY_AVAILABILITY_getInstance() {
  static_init_19();
  return CheckInFlagCode_LOW_ENERGY_AVAILABILITY_instance;
}
function CheckInFlagCode_RECOVERY_CONTEXT_getInstance() {
  static_init_19();
  return CheckInFlagCode_RECOVERY_CONTEXT_instance;
}
function CheckInFlagCode_DIET_BREAK_getInstance() {
  static_init_19();
  return CheckInFlagCode_DIET_BREAK_instance;
}
function CheckInFlagCode_DIET_BREAK_ENDED_getInstance() {
  static_init_19();
  return CheckInFlagCode_DIET_BREAK_ENDED_instance;
}
function CheckInFlagCode_NOT_A_FULL_WEEK_YET_getInstance() {
  static_init_19();
  return CheckInFlagCode_NOT_A_FULL_WEEK_YET_instance;
}
var static_init_called_20;
function static_init_20() {
  if (static_init_called_20)
    return Unit_instance;
  static_init_called_20 = true;
  HighDayMode_FIXED_instance = new HighDayMode('FIXED', 0);
  HighDayMode_SCALED_instance = new HighDayMode('SCALED', 1);
}
var HighDayMode_FIXED_instance;
var HighDayMode_SCALED_instance;
function values_14() {
  static_init_20();
  return [HighDayMode_FIXED_getInstance(), HighDayMode_SCALED_getInstance()];
}
function get_entries_9() {
  static_init_20();
  if ($ENTRIES_9 == null)
    $ENTRIES_9 = enumEntries(values_14());
  return $ENTRIES_9;
}
var $ENTRIES_9;
function HighDayMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeeklyDistribution() {
  this.yw_1 = 1.1;
  this.zw_1 = 0.3;
  this.ax_1 = 1.05;
  this.bx_1 = 1.15;
  this.cx_1 = 10.0;
}
protoOf(WeeklyDistribution).jx = function (mode, highDays, fixed) {
  var tmp;
  switch (mode.y1_1) {
    case 0:
      tmp = fixed;
      break;
    case 1:
      tmp = coerceIn(1.0 + 0.3 / highDays, 1.05, 1.15);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(WeeklyDistribution).dx = function (averageDailyKcal, highDays, mode, floorKcal, fixedMultiplier) {
  if (mode.equals(HighDayMode_FIXED_getInstance()) || highDays.m() || highDays.o() === 7)
    return this.kx(averageDailyKcal, highDays, fixedMultiplier, floorKcal);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(highDays, Collection)) {
      tmp = highDays.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = highDays.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$0) {
    var message = 'highDays must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var lowDays = 7 - highDays.o() | 0;
  var m = this.jx(mode, highDays.o(), fixedMultiplier);
  var low = averageDailyKcal * 7.0 / (lowDays + m * highDays.o());
  var high = low * m;
  if (!(floorKcal == null) && low < floorKcal) {
    if (averageDailyKcal - floorKcal < 10.0) {
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var list = ArrayList_init_$Create$(7);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < 7)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          list.f(averageDailyKcal);
        }
         while (inductionVariable < 7);
      return list;
    }
    low = floorKcal;
    high = (averageDailyKcal * 7.0 - lowDays * floorKcal) / highDays.o();
  }
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list_0 = ArrayList_init_$Create$(7);
  // Inline function 'kotlin.repeat' call
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < 7)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp$ret$13 = highDays.r(index_0) ? high : low;
      list_0.f(tmp$ret$13);
    }
     while (inductionVariable_0 < 7);
  return list_0;
};
protoOf(WeeklyDistribution).kx = function (averageDailyKcal, highDays, highDayMultiplier, floorKcal) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(highDays, Collection)) {
      tmp = highDays.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = highDays.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$0) {
    var message = 'highDays must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(highDayMultiplier >= 1.0)) {
    var message_0 = 'highDayMultiplier must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (highDays.m() || highDays.o() === 7) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list = ArrayList_init_$Create$(7);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < 7)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.f(averageDailyKcal);
      }
       while (inductionVariable < 7);
    return list;
  }
  var lowDays = 7 - highDays.o() | 0;
  var low = averageDailyKcal * 7.0 / (lowDays + highDayMultiplier * highDays.o());
  if (!(floorKcal == null) && low < floorKcal) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list_0 = ArrayList_init_$Create$(7);
    // Inline function 'kotlin.repeat' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 7)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        list_0.f(averageDailyKcal);
      }
       while (inductionVariable_0 < 7);
    return list_0;
  }
  var high = low * highDayMultiplier;
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list_1 = ArrayList_init_$Create$(7);
  // Inline function 'kotlin.repeat' call
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < 7)
    do {
      var index_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var tmp$ret$20 = highDays.r(index_1) ? high : low;
      list_1.f(tmp$ret$20);
    }
     while (inductionVariable_1 < 7);
  return list_1;
};
var WeeklyDistribution_instance;
function WeeklyDistribution_getInstance() {
  return WeeklyDistribution_instance;
}
function HighDayMode_FIXED_getInstance() {
  static_init_20();
  return HighDayMode_FIXED_instance;
}
function HighDayMode_SCALED_getInstance() {
  static_init_20();
  return HighDayMode_SCALED_instance;
}
function TrendBand() {
  this.lx_1 = 9;
}
protoOf(TrendBand).mx = function (values, window_0) {
  // Inline function 'kotlin.require' call
  if (!((window_0 % 2 | 0) === 1)) {
    var message = 'window must be odd for a centred average';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (values.m())
    return emptyList();
  var half = window_0 / 2 | 0;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices(values);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last_0 = this_0.yc_1;
  if (inductionVariable <= last_0)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = item;
      var from = coerceAtLeast(index - half | 0, 0);
      var to = coerceAtMost(index + half | 0, get_lastIndex(values));
      var tmp$ret$4 = average(values.o1(from, to + 1 | 0));
      destination.f(tmp$ret$4);
    }
     while (!(item === last_0));
  var smoothed = destination;
  // Inline function 'kotlin.also' call
  var this_1 = toMutableList(smoothed);
  this_1.o2(get_lastIndex(this_1), last(values));
  return this_1;
};
protoOf(TrendBand).nx = function (residuals) {
  if (residuals.o() < 2)
    return 0.0;
  var mean = average(residuals);
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = residuals.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    sum = tmp + (element - mean) * (element - mean);
  }
  var variance = sum / (residuals.o() - 1 | 0);
  // Inline function 'kotlin.math.sqrt' call
  return Math.sqrt(variance);
};
var TrendBand_instance;
function TrendBand_getInstance() {
  return TrendBand_instance;
}
var static_init_called_21;
function static_init_21() {
  if (static_init_called_21)
    return Unit_instance;
  static_init_called_21 = true;
  DayStatus_COMPLETE_instance = new DayStatus('COMPLETE', 0);
  DayStatus_PARTIAL_instance = new DayStatus('PARTIAL', 1);
  DayStatus_FASTED_instance = new DayStatus('FASTED', 2);
  DayStatus_UNLOGGED_instance = new DayStatus('UNLOGGED', 3);
}
var DayStatus_COMPLETE_instance;
var DayStatus_PARTIAL_instance;
var DayStatus_FASTED_instance;
var DayStatus_UNLOGGED_instance;
function valueOf_5(value) {
  static_init_21();
  switch (value) {
    case 'COMPLETE':
      return DayStatus_COMPLETE_getInstance();
    case 'PARTIAL':
      return DayStatus_PARTIAL_getInstance();
    case 'FASTED':
      return DayStatus_FASTED_getInstance();
    case 'UNLOGGED':
      return DayStatus_UNLOGGED_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.DayStatus.' + value);
      break;
  }
}
function DayStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function IntakeDay(day, kcal, status) {
  this.fk_1 = day;
  this.gk_1 = kcal;
  this.hk_1 = status;
}
protoOf(IntakeDay).toString = function () {
  return 'IntakeDay(day=' + this.fk_1 + ', kcal=' + this.gk_1 + ', status=' + this.hk_1.toString() + ')';
};
protoOf(IntakeDay).hashCode = function () {
  var result = this.fk_1;
  result = imul(result, 31) + getNumberHashCode(this.gk_1) | 0;
  result = imul(result, 31) + this.hk_1.hashCode() | 0;
  return result;
};
protoOf(IntakeDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof IntakeDay))
    return false;
  if (!(this.fk_1 === other.fk_1))
    return false;
  if (!equals(this.gk_1, other.gk_1))
    return false;
  if (!this.hk_1.equals(other.hk_1))
    return false;
  return true;
};
var static_init_called_22;
function static_init_22() {
  if (static_init_called_22)
    return Unit_instance;
  static_init_called_22 = true;
  ExpenditureStatus_INITIAL_instance = new ExpenditureStatus('INITIAL', 0);
  ExpenditureStatus_UPDATING_instance = new ExpenditureStatus('UPDATING', 1);
  ExpenditureStatus_HOLDING_instance = new ExpenditureStatus('HOLDING', 2);
}
var ExpenditureStatus_INITIAL_instance;
var ExpenditureStatus_UPDATING_instance;
var ExpenditureStatus_HOLDING_instance;
function valueOf_6(value) {
  static_init_22();
  switch (value) {
    case 'INITIAL':
      return ExpenditureStatus_INITIAL_getInstance();
    case 'UPDATING':
      return ExpenditureStatus_UPDATING_getInstance();
    case 'HOLDING':
      return ExpenditureStatus_HOLDING_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.ExpenditureStatus.' + value);
      break;
  }
}
function ExpenditureStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ExpenditurePoint(day, kcal, sdKcal, status, floored, goalAdjustmentKcal) {
  floored = floored === VOID ? false : floored;
  goalAdjustmentKcal = goalAdjustmentKcal === VOID ? 0.0 : goalAdjustmentKcal;
  this.in_1 = day;
  this.jn_1 = kcal;
  this.kn_1 = sdKcal;
  this.ln_1 = status;
  this.mn_1 = floored;
  this.nn_1 = goalAdjustmentKcal;
}
protoOf(ExpenditurePoint).ox = function (day, kcal, sdKcal, status, floored, goalAdjustmentKcal) {
  return new ExpenditurePoint(day, kcal, sdKcal, status, floored, goalAdjustmentKcal);
};
protoOf(ExpenditurePoint).px = function (day, kcal, sdKcal, status, floored, goalAdjustmentKcal, $super) {
  day = day === VOID ? this.in_1 : day;
  kcal = kcal === VOID ? this.jn_1 : kcal;
  sdKcal = sdKcal === VOID ? this.kn_1 : sdKcal;
  status = status === VOID ? this.ln_1 : status;
  floored = floored === VOID ? this.mn_1 : floored;
  goalAdjustmentKcal = goalAdjustmentKcal === VOID ? this.nn_1 : goalAdjustmentKcal;
  return $super === VOID ? this.ox(day, kcal, sdKcal, status, floored, goalAdjustmentKcal) : $super.ox.call(this, day, kcal, sdKcal, status, floored, goalAdjustmentKcal);
};
protoOf(ExpenditurePoint).toString = function () {
  return 'ExpenditurePoint(day=' + this.in_1 + ', kcal=' + this.jn_1 + ', sdKcal=' + this.kn_1 + ', status=' + this.ln_1.toString() + ', floored=' + this.mn_1 + ', goalAdjustmentKcal=' + this.nn_1 + ')';
};
protoOf(ExpenditurePoint).hashCode = function () {
  var result = this.in_1;
  result = imul(result, 31) + getNumberHashCode(this.jn_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.kn_1) | 0;
  result = imul(result, 31) + this.ln_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.mn_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.nn_1) | 0;
  return result;
};
protoOf(ExpenditurePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditurePoint))
    return false;
  if (!(this.in_1 === other.in_1))
    return false;
  if (!equals(this.jn_1, other.jn_1))
    return false;
  if (!equals(this.kn_1, other.kn_1))
    return false;
  if (!this.ln_1.equals(other.ln_1))
    return false;
  if (!(this.mn_1 === other.mn_1))
    return false;
  if (!equals(this.nn_1, other.nn_1))
    return false;
  return true;
};
function GoalChange(day, fromRatePctPerWeek, toRatePctPerWeek) {
  this.qx_1 = day;
  this.rx_1 = fromRatePctPerWeek;
  this.sx_1 = toRatePctPerWeek;
}
protoOf(GoalChange).toString = function () {
  return 'GoalChange(day=' + this.qx_1 + ', fromRatePctPerWeek=' + this.rx_1 + ', toRatePctPerWeek=' + this.sx_1 + ')';
};
protoOf(GoalChange).hashCode = function () {
  var result = this.qx_1;
  result = imul(result, 31) + getNumberHashCode(this.rx_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.sx_1) | 0;
  return result;
};
protoOf(GoalChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalChange))
    return false;
  if (!(this.qx_1 === other.qx_1))
    return false;
  if (!equals(this.rx_1, other.rx_1))
    return false;
  if (!equals(this.sx_1, other.sx_1))
    return false;
  return true;
};
function ExpenditureParams(windowDays, minUsableIntakeDaysInWindow, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, minWeighInDaysInWindow, firstUpdateAfterDays, weightNoiseKg, intakeNoiseKcal, processNoiseKcal, initialUncertaintyKcal, overlapFactor, maxDailyChangeKcal, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) {
  windowDays = windowDays === VOID ? 14 : windowDays;
  minUsableIntakeDaysInWindow = minUsableIntakeDaysInWindow === VOID ? 4 : minUsableIntakeDaysInWindow;
  minUsableIntakeDaysInLastWeek = minUsableIntakeDaysInLastWeek === VOID ? 4 : minUsableIntakeDaysInLastWeek;
  maxDaysSinceWeighIn = maxDaysSinceWeighIn === VOID ? 7 : maxDaysSinceWeighIn;
  minWeighInDaysInWindow = minWeighInDaysInWindow === VOID ? 2 : minWeighInDaysInWindow;
  firstUpdateAfterDays = firstUpdateAfterDays === VOID ? 2 : firstUpdateAfterDays;
  weightNoiseKg = weightNoiseKg === VOID ? 0.6 : weightNoiseKg;
  intakeNoiseKcal = intakeNoiseKcal === VOID ? 350.0 : intakeNoiseKcal;
  processNoiseKcal = processNoiseKcal === VOID ? 40.0 : processNoiseKcal;
  initialUncertaintyKcal = initialUncertaintyKcal === VOID ? 350.0 : initialUncertaintyKcal;
  overlapFactor = overlapFactor === VOID ? 0.5 : overlapFactor;
  maxDailyChangeKcal = maxDailyChangeKcal === VOID ? 150.0 : maxDailyChangeKcal;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? false : holdAfterLastWeighIn;
  gainKcalPerKg = gainKcalPerKg === VOID ? null : gainKcalPerKg;
  goalAdjustment = goalAdjustment === VOID ? new GoalAdjustmentParams() : goalAdjustment;
  this.tx_1 = windowDays;
  this.ux_1 = minUsableIntakeDaysInWindow;
  this.vx_1 = minUsableIntakeDaysInLastWeek;
  this.wx_1 = maxDaysSinceWeighIn;
  this.xx_1 = minWeighInDaysInWindow;
  this.yx_1 = firstUpdateAfterDays;
  this.zx_1 = weightNoiseKg;
  this.ay_1 = intakeNoiseKcal;
  this.by_1 = processNoiseKcal;
  this.cy_1 = initialUncertaintyKcal;
  this.dy_1 = overlapFactor;
  this.ey_1 = maxDailyChangeKcal;
  this.fy_1 = holdAfterLastWeighIn;
  this.gy_1 = gainKcalPerKg;
  this.hy_1 = goalAdjustment;
}
protoOf(ExpenditureParams).toString = function () {
  return 'ExpenditureParams(windowDays=' + this.tx_1 + ', minUsableIntakeDaysInWindow=' + this.ux_1 + ', minUsableIntakeDaysInLastWeek=' + this.vx_1 + ', maxDaysSinceWeighIn=' + this.wx_1 + ', minWeighInDaysInWindow=' + this.xx_1 + ', firstUpdateAfterDays=' + this.yx_1 + ', weightNoiseKg=' + this.zx_1 + ', intakeNoiseKcal=' + this.ay_1 + ', processNoiseKcal=' + this.by_1 + ', initialUncertaintyKcal=' + this.cy_1 + ', overlapFactor=' + this.dy_1 + ', maxDailyChangeKcal=' + this.ey_1 + ', holdAfterLastWeighIn=' + this.fy_1 + ', gainKcalPerKg=' + this.gy_1 + ', goalAdjustment=' + this.hy_1.toString() + ')';
};
protoOf(ExpenditureParams).hashCode = function () {
  var result = this.tx_1;
  result = imul(result, 31) + this.ux_1 | 0;
  result = imul(result, 31) + this.vx_1 | 0;
  result = imul(result, 31) + this.wx_1 | 0;
  result = imul(result, 31) + this.xx_1 | 0;
  result = imul(result, 31) + this.yx_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.zx_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ay_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.by_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.cy_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.dy_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ey_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.fy_1) | 0;
  result = imul(result, 31) + (this.gy_1 == null ? 0 : getNumberHashCode(this.gy_1)) | 0;
  result = imul(result, 31) + this.hy_1.hashCode() | 0;
  return result;
};
protoOf(ExpenditureParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureParams))
    return false;
  if (!(this.tx_1 === other.tx_1))
    return false;
  if (!(this.ux_1 === other.ux_1))
    return false;
  if (!(this.vx_1 === other.vx_1))
    return false;
  if (!(this.wx_1 === other.wx_1))
    return false;
  if (!(this.xx_1 === other.xx_1))
    return false;
  if (!(this.yx_1 === other.yx_1))
    return false;
  if (!equals(this.zx_1, other.zx_1))
    return false;
  if (!equals(this.ay_1, other.ay_1))
    return false;
  if (!equals(this.by_1, other.by_1))
    return false;
  if (!equals(this.cy_1, other.cy_1))
    return false;
  if (!equals(this.dy_1, other.dy_1))
    return false;
  if (!equals(this.ey_1, other.ey_1))
    return false;
  if (!(this.fy_1 === other.fy_1))
    return false;
  if (!equals(this.gy_1, other.gy_1))
    return false;
  if (!this.hy_1.equals(other.hy_1))
    return false;
  return true;
};
function usableIntakeBetween($this, intakeByDay, fromDay, toDay) {
  var values = ArrayList_init_$Create$_0();
  var inductionVariable = fromDay;
  if (inductionVariable <= toDay)
    $l$loop: do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_elvis_lhs = intakeByDay.t1(day);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var entry = tmp;
      switch (entry.hk_1.y1_1) {
        case 0:
          values.f(entry.gk_1);
          break;
        case 2:
          values.f(0.0);
          break;
        case 1:
        case 3:
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
     while (!(day === toDay));
  return values;
}
function AdaptiveExpenditure() {
}
protoOf(AdaptiveExpenditure).im = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, floorKcal) {
  // Inline function 'kotlin.require' call
  if (!(endDay >= startDay)) {
    var message = 'endDay must not be before startDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(kcalPerKg > 0.0)) {
    var message_0 = 'kcalPerKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = WeightTrend_instance.um(weighIns);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = element.gm_1;
    var tmp$ret$7 = element.hm_1;
    destination.l2(tmp, tmp$ret$7);
  }
  var weights = destination;
  var weighInDays = sorted(weights.u1());
  var finalWeighIn = lastOrNull(weighInDays);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_0 = intake.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$10 = element_0.fk_1;
    destination_0.l2(tmp$ret$10, element_0);
  }
  var intakeByDay = destination_0;
  var adjuster = new GoalAdjuster(goalChanges, params.hy_1);
  var estimate = initialKcal;
  var variance = params.cy_1 * params.cy_1;
  var processVariance = params.by_1 * params.by_1;
  var everUpdated = false;
  var points = ArrayList_init_$Create$((endDay - startDay | 0) + 1 | 0);
  var inductionVariable = startDay;
  if (inductionVariable <= endDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      variance = variance + processVariance;
      var windowStart = (day - params.tx_1 | 0) + 1 | 0;
      var usableIntake = usableIntakeBetween(this, intakeByDay, windowStart, day);
      var usableLastWeek = usableIntakeBetween(this, intakeByDay, day - 6 | 0, day).o();
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_1 = weighInDays.j();
      while (_iterator__ex2g4s_1.k()) {
        var element_1 = _iterator__ex2g4s_1.l();
        if (windowStart <= element_1 ? element_1 <= day : false) {
          destination_1.f(element_1);
        }
      }
      var windowWeights = destination_1;
      var tmp$ret$14;
      $l$block: {
        // Inline function 'kotlin.collections.lastOrNull' call
        var iterator = weighInDays.p(weighInDays.o());
        while (iterator.c3()) {
          var element_2 = iterator.d3();
          if (element_2 <= day) {
            tmp$ret$14 = element_2;
            break $l$block;
          }
        }
        tmp$ret$14 = null;
      }
      var lastWeighIn = tmp$ret$14;
      var tmp_0;
      if (lastWeighIn == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = floorKcal == null ? null : floorKcal(getValue(weights, lastWeighIn));
      }
      var floor = tmp_0;
      var eligible = (day - startDay | 0) >= params.yx_1 && usableIntake.o() >= params.ux_1 && usableLastWeek >= params.vx_1 && windowWeights.o() >= params.xx_1 && !(lastWeighIn == null) && (day - lastWeighIn | 0) < params.wx_1 && !(params.fy_1 && !(finalWeighIn == null) && day > finalWeighIn);
      var shiftToday = adjuster.oy(day, estimate, !eligible, floor);
      estimate = estimate + shiftToday;
      var tmp_1;
      if (eligible) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(windowWeights, 10));
        var _iterator__ex2g4s_2 = windowWeights.j();
        while (_iterator__ex2g4s_2.k()) {
          var item = _iterator__ex2g4s_2.l();
          destination_2.f(item);
        }
        var xs = destination_2;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(windowWeights, 10));
        var _iterator__ex2g4s_3 = windowWeights.j();
        while (_iterator__ex2g4s_3.k()) {
          var item_0 = _iterator__ex2g4s_3.l();
          var tmp$ret$23 = getValue(weights, item_0);
          destination_3.f(tmp$ret$23);
        }
        var ys = destination_3;
        var meanX = average(xs);
        var meanY = average(ys);
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_4 = xs.j();
        while (_iterator__ex2g4s_4.k()) {
          var element_3 = _iterator__ex2g4s_4.l();
          var tmp_2 = sum;
          sum = tmp_2 + (element_3 - meanX) * (element_3 - meanX);
        }
        var sxx = sum;
        // Inline function 'kotlin.collections.sumOf' call
        var sum_0 = 0;
        var progression = get_indices(xs);
        var inductionVariable_0 = progression.xc_1;
        var last = progression.yc_1;
        if (inductionVariable_0 <= last)
          do {
            var element_4 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp_3 = sum_0;
            var it = element_4;
            sum_0 = tmp_3 + (xs.n(it) - meanX) * (ys.n(it) - meanY);
          }
           while (!(element_4 === last));
        var sxy = sum_0;
        var slopeKgPerDay = sxy / sxx;
        var meanIntake = average(usableIntake);
        var tmp1_safe_receiver = params.gy_1;
        var tmp_4;
        if (tmp1_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_5;
          if (slopeKgPerDay > 0.0) {
            tmp_5 = tmp1_safe_receiver;
          } else {
            tmp_5 = null;
          }
          tmp_4 = tmp_5;
        }
        var tmp2_elvis_lhs = tmp_4;
        var density = tmp2_elvis_lhs == null ? kcalPerKg : tmp2_elvis_lhs;
        var raw = meanIntake - density * slopeKgPerDay;
        // Inline function 'kotlin.let' call
        var it_0 = density * params.zx_1;
        var weightTerm = it_0 * it_0 / sxx;
        var intakeTerm = params.ay_1 * params.ay_1 / usableIntake.o();
        var measurementVariance = (weightTerm + intakeTerm) * params.tx_1 * params.dy_1;
        var gain = variance / (variance + measurementVariance);
        var step = gain * (raw - estimate);
        estimate = estimate + coerceIn(step, -params.ey_1, params.ey_1);
        variance = variance * (1.0 - gain);
        everUpdated = true;
        tmp_1 = ExpenditureStatus_UPDATING_getInstance();
      } else if (everUpdated) {
        tmp_1 = ExpenditureStatus_HOLDING_getInstance();
      } else {
        tmp_1 = ExpenditureStatus_INITIAL_getInstance();
      }
      var status = tmp_1;
      var floored = !(floor == null) && estimate < floor;
      if (!(floor == null) && floored)
        estimate = floor;
      var tmp_6 = estimate;
      // Inline function 'kotlin.math.sqrt' call
      var x = variance;
      var tmp$ret$32 = Math.sqrt(x);
      points.f(new ExpenditurePoint(day, tmp_6, tmp$ret$32, status, floored, shiftToday));
    }
     while (!(day === endDay));
  return points;
};
var AdaptiveExpenditure_instance;
function AdaptiveExpenditure_getInstance() {
  return AdaptiveExpenditure_instance;
}
function DayStatus_COMPLETE_getInstance() {
  static_init_21();
  return DayStatus_COMPLETE_instance;
}
function DayStatus_PARTIAL_getInstance() {
  static_init_21();
  return DayStatus_PARTIAL_instance;
}
function DayStatus_FASTED_getInstance() {
  static_init_21();
  return DayStatus_FASTED_instance;
}
function DayStatus_UNLOGGED_getInstance() {
  static_init_21();
  return DayStatus_UNLOGGED_instance;
}
function ExpenditureStatus_INITIAL_getInstance() {
  static_init_22();
  return ExpenditureStatus_INITIAL_instance;
}
function ExpenditureStatus_UPDATING_getInstance() {
  static_init_22();
  return ExpenditureStatus_UPDATING_instance;
}
function ExpenditureStatus_HOLDING_getInstance() {
  static_init_22();
  return ExpenditureStatus_HOLDING_instance;
}
function BodyComposition() {
  this.zm_1 = 0.03;
  this.an_1 = 0.6;
}
protoOf(BodyComposition).py = function (sex, ageYears, weightKg, heightCm) {
  // Inline function 'kotlin.require' call
  if (!(weightKg > 0.0 && heightCm > 0.0)) {
    var message = 'weight and height must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var heightM = heightCm / 100.0;
  var bmi = weightKg / (heightM * heightM);
  var male = sex.equals(Sex_MALE_getInstance()) ? 1.0 : 0.0;
  var percent = 1.2 * bmi + 0.23 * ageYears - 10.8 * male - 5.4;
  return coerceIn(percent / 100.0, 0.03, 0.6);
};
protoOf(BodyComposition).qy = function (sex, heightCm, waistCm) {
  // Inline function 'kotlin.require' call
  if (!(heightCm > 0.0 && waistCm > 0.0)) {
    var message = 'height and waist must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var base = sex.equals(Sex_MALE_getInstance()) ? 64.0 : 76.0;
  var percent = base - 20.0 * (heightCm / waistCm);
  return coerceIn(percent / 100.0, 0.03, 0.6);
};
protoOf(BodyComposition).bn = function (sex, ageYears, weightKg, heightCm, waistCm) {
  var tmp;
  if (!(waistCm == null) && waistCm > 0.0) {
    tmp = this.qy(sex, heightCm, waistCm);
  } else {
    tmp = this.py(sex, ageYears, weightKg, heightCm);
  }
  return tmp;
};
protoOf(BodyComposition).sw = function (sex, ageYears, weightKg, heightCm, bodyFatFraction, waistCm) {
  var fraction = bodyFatFraction == null ? this.bn(sex, ageYears, weightKg, heightCm, waistCm) : bodyFatFraction;
  // Inline function 'kotlin.require' call
  if (!(fraction > 0.0 && fraction < 1.0)) {
    var message = 'bodyFatFraction must be in (0, 1)';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return weightKg * (1.0 - fraction);
};
var BodyComposition_instance;
function BodyComposition_getInstance() {
  return BodyComposition_instance;
}
function EnergyBalancePoint(day, intakeKcal, status, usable, expenditureKcal, targetKcal, balanceKcal, intakeAverageKcal, expenditureAverageKcal, balanceAverageKcal) {
  this.ry_1 = day;
  this.sy_1 = intakeKcal;
  this.ty_1 = status;
  this.uy_1 = usable;
  this.vy_1 = expenditureKcal;
  this.wy_1 = targetKcal;
  this.xy_1 = balanceKcal;
  this.yy_1 = intakeAverageKcal;
  this.zy_1 = expenditureAverageKcal;
  this.az_1 = balanceAverageKcal;
}
protoOf(EnergyBalancePoint).toString = function () {
  return 'EnergyBalancePoint(day=' + this.ry_1 + ', intakeKcal=' + this.sy_1 + ', status=' + toString_0(this.ty_1) + ', usable=' + this.uy_1 + ', expenditureKcal=' + this.vy_1 + ', targetKcal=' + this.wy_1 + ', balanceKcal=' + this.xy_1 + ', intakeAverageKcal=' + this.yy_1 + ', expenditureAverageKcal=' + this.zy_1 + ', balanceAverageKcal=' + this.az_1 + ')';
};
protoOf(EnergyBalancePoint).hashCode = function () {
  var result = this.ry_1;
  result = imul(result, 31) + (this.sy_1 == null ? 0 : getNumberHashCode(this.sy_1)) | 0;
  result = imul(result, 31) + (this.ty_1 == null ? 0 : this.ty_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.uy_1) | 0;
  result = imul(result, 31) + (this.vy_1 == null ? 0 : getNumberHashCode(this.vy_1)) | 0;
  result = imul(result, 31) + (this.wy_1 == null ? 0 : getNumberHashCode(this.wy_1)) | 0;
  result = imul(result, 31) + (this.xy_1 == null ? 0 : getNumberHashCode(this.xy_1)) | 0;
  result = imul(result, 31) + (this.yy_1 == null ? 0 : getNumberHashCode(this.yy_1)) | 0;
  result = imul(result, 31) + (this.zy_1 == null ? 0 : getNumberHashCode(this.zy_1)) | 0;
  result = imul(result, 31) + (this.az_1 == null ? 0 : getNumberHashCode(this.az_1)) | 0;
  return result;
};
protoOf(EnergyBalancePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EnergyBalancePoint))
    return false;
  if (!(this.ry_1 === other.ry_1))
    return false;
  if (!equals(this.sy_1, other.sy_1))
    return false;
  if (!equals(this.ty_1, other.ty_1))
    return false;
  if (!(this.uy_1 === other.uy_1))
    return false;
  if (!equals(this.vy_1, other.vy_1))
    return false;
  if (!equals(this.wy_1, other.wy_1))
    return false;
  if (!equals(this.xy_1, other.xy_1))
    return false;
  if (!equals(this.yy_1, other.yy_1))
    return false;
  if (!equals(this.zy_1, other.zy_1))
    return false;
  if (!equals(this.az_1, other.az_1))
    return false;
  return true;
};
function EnergyBalanceSummary(days, usableDays, averageIntakeKcal, averageExpenditureKcal, averageBalanceKcal, averageTargetKcal, impliedChangeKg) {
  this.bz_1 = days;
  this.cz_1 = usableDays;
  this.dz_1 = averageIntakeKcal;
  this.ez_1 = averageExpenditureKcal;
  this.fz_1 = averageBalanceKcal;
  this.gz_1 = averageTargetKcal;
  this.hz_1 = impliedChangeKg;
}
protoOf(EnergyBalanceSummary).toString = function () {
  return 'EnergyBalanceSummary(days=' + this.bz_1 + ', usableDays=' + this.cz_1 + ', averageIntakeKcal=' + this.dz_1 + ', averageExpenditureKcal=' + this.ez_1 + ', averageBalanceKcal=' + this.fz_1 + ', averageTargetKcal=' + this.gz_1 + ', impliedChangeKg=' + this.hz_1 + ')';
};
protoOf(EnergyBalanceSummary).hashCode = function () {
  var result = this.bz_1;
  result = imul(result, 31) + this.cz_1 | 0;
  result = imul(result, 31) + (this.dz_1 == null ? 0 : getNumberHashCode(this.dz_1)) | 0;
  result = imul(result, 31) + (this.ez_1 == null ? 0 : getNumberHashCode(this.ez_1)) | 0;
  result = imul(result, 31) + (this.fz_1 == null ? 0 : getNumberHashCode(this.fz_1)) | 0;
  result = imul(result, 31) + (this.gz_1 == null ? 0 : getNumberHashCode(this.gz_1)) | 0;
  result = imul(result, 31) + (this.hz_1 == null ? 0 : getNumberHashCode(this.hz_1)) | 0;
  return result;
};
protoOf(EnergyBalanceSummary).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EnergyBalanceSummary))
    return false;
  if (!(this.bz_1 === other.bz_1))
    return false;
  if (!(this.cz_1 === other.cz_1))
    return false;
  if (!equals(this.dz_1, other.dz_1))
    return false;
  if (!equals(this.ez_1, other.ez_1))
    return false;
  if (!equals(this.fz_1, other.fz_1))
    return false;
  if (!equals(this.gz_1, other.gz_1))
    return false;
  if (!equals(this.hz_1, other.hz_1))
    return false;
  return true;
};
function averageOrNull($this, $receiver) {
  return $receiver.m() ? null : average($receiver);
}
function series$usableIntake(intakeByDay, day) {
  var tmp0_safe_receiver = intakeByDay.t1(day);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    switch (tmp0_safe_receiver.hk_1.y1_1) {
      case 0:
        tmp_0 = tmp0_safe_receiver.gk_1;
        break;
      case 2:
        tmp_0 = 0.0;
        break;
      case 1:
      case 3:
        tmp_0 = null;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function EnergyBalance() {
  this.iz_1 = 7;
}
protoOf(EnergyBalance).jz = function (intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays) {
  // Inline function 'kotlin.require' call
  if (!(toDay >= fromDay)) {
    var message = 'toDay must not be before fromDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(averageDays > 0)) {
    var message_0 = 'averageDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = intake.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$6 = element.fk_1;
    destination.l2(tmp$ret$6, element);
  }
  var intakeByDay = destination;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(expenditure, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_0 = expenditure.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = element_0.in_1;
    var tmp$ret$10 = element_0.jn_1;
    destination_0.l2(tmp, tmp$ret$10);
  }
  var expenditureByDay = destination_0;
  // Inline function 'kotlin.collections.map' call
  var this_0 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var day = item;
      var entry = intakeByDay.t1(day);
      var shown = entry == null ? null : entry.hk_1.equals(DayStatus_FASTED_getInstance()) ? 0.0 : entry.hk_1.equals(DayStatus_UNLOGGED_getInstance()) && entry.gk_1 <= 0.0 ? null : entry.gk_1;
      var usable = series$usableIntake(intakeByDay, day);
      var expenditureKcal = expenditureByDay.t1(day);
      var window_0 = numberRangeToNumber((day - averageDays | 0) + 1 | 0, day);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = window_0.xc_1;
      var last_0 = window_0.yc_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var it = element_1;
          var tmp0_safe_receiver = series$usableIntake(intakeByDay, it);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_2.f(tmp0_safe_receiver);
          }
        }
         while (!(element_1 === last_0));
      var intakes = destination_2;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_3 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = window_0.xc_1;
      var last_1 = window_0.yc_1;
      if (inductionVariable_1 <= last_1)
        do {
          var element_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var it_0 = element_2;
          var tmp0_safe_receiver_0 = expenditureByDay.t1(it_0);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_3.f(tmp0_safe_receiver_0);
          }
        }
         while (!(element_2 === last_1));
      var expenditures = destination_3;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_2 = window_0.xc_1;
      var last_2 = window_0.yc_1;
      if (inductionVariable_2 <= last_2)
        do {
          var element_3 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var d = element_3;
          var tmp0_safe_receiver_1 = series$usableIntake(intakeByDay, d);
          var tmp_0;
          if (tmp0_safe_receiver_1 == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_2 = expenditureByDay.t1(d);
            var tmp_1;
            if (tmp0_safe_receiver_2 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_1 = tmp0_safe_receiver_1 - tmp0_safe_receiver_2;
            }
            tmp_0 = tmp_1;
          }
          var tmp0_safe_receiver_3 = tmp_0;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_4.f(tmp0_safe_receiver_3);
          }
        }
         while (!(element_3 === last_2));
      var balances = destination_4;
      var tmp_2 = entry == null ? null : entry.hk_1;
      var tmp_3 = !(usable == null);
      var tmp_4 = targetKcalByDay.t1(day);
      var tmp_5;
      if (usable == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_6;
        if (expenditureKcal == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_6 = usable - expenditureKcal;
        }
        tmp_5 = tmp_6;
      }
      var tmp$ret$13 = new EnergyBalancePoint(day, shown, tmp_2, tmp_3, expenditureKcal, tmp_4, tmp_5, averageOrNull(EnergyBalance_instance, intakes), averageOrNull(EnergyBalance_instance, expenditures), averageOrNull(EnergyBalance_instance, balances));
      destination_1.f(tmp$ret$13);
    }
     while (!(item === last));
  return destination_1;
};
protoOf(EnergyBalance).kz = function (intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays, $super) {
  targetKcalByDay = targetKcalByDay === VOID ? emptyMap() : targetKcalByDay;
  averageDays = averageDays === VOID ? 7 : averageDays;
  return $super === VOID ? this.jz(intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays) : $super.jz.call(this, intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays);
};
protoOf(EnergyBalance).lz = function (points, kcalPerKg) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.uy_1) {
      destination.f(element);
    }
  }
  var usable = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = points.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = element_0.xy_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver);
    }
  }
  var balances = destination_0;
  var tmp = points.o();
  var tmp_0 = usable.o();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = usable.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver_0 = element_1.sy_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_1 = averageOrNull(this, destination_1);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = points.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var tmp0_safe_receiver_1 = element_2.vy_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_2.f(tmp0_safe_receiver_1);
    }
  }
  var tmp_2 = averageOrNull(this, destination_2);
  var tmp_3 = averageOrNull(this, balances);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_3 = points.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var tmp0_safe_receiver_2 = element_3.wy_1;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_3.f(tmp0_safe_receiver_2);
    }
  }
  var tmp_4 = averageOrNull(this, destination_3);
  var tmp_5;
  var tmp_6;
  if (!(kcalPerKg == null)) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_6 = !balances.m();
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    tmp_5 = sum(balances) / kcalPerKg;
  } else {
    tmp_5 = null;
  }
  return new EnergyBalanceSummary(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5);
};
var EnergyBalance_instance;
function EnergyBalance_getInstance() {
  return EnergyBalance_instance;
}
function EnergyDensity() {
  this.yg_1 = 239.0057361376673;
  this.zg_1 = 9440.726577437857;
  this.ah_1 = 1816.4435946462713;
  this.bh_1 = 7700.0;
  this.ch_1 = 10.4;
}
protoOf(EnergyDensity).mz = function (fatMassKg) {
  // Inline function 'kotlin.require' call
  if (!(fatMassKg > 0.0)) {
    var message = 'fatMassKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return 10.4 / (10.4 + fatMassKg);
};
protoOf(EnergyDensity).nz = function (fatMassKg) {
  var lean = this.mz(fatMassKg);
  return lean * 1816.4435946462713 + (1.0 - lean) * 9440.726577437857;
};
protoOf(EnergyDensity).xg = function (bodyWeightKg, bodyFatFraction) {
  if (bodyFatFraction == null)
    return 7700.0;
  // Inline function 'kotlin.require' call
  if (!(bodyFatFraction > 0.0 && bodyFatFraction < 1.0)) {
    var message = 'bodyFatFraction must be in (0, 1)';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.nz(bodyWeightKg * bodyFatFraction);
};
var EnergyDensity_instance;
function EnergyDensity_getInstance() {
  return EnergyDensity_instance;
}
var static_init_called_23;
function static_init_23() {
  if (static_init_called_23)
    return Unit_instance;
  static_init_called_23 = true;
  ExpenditureFloorKind_NONE_instance = new ExpenditureFloorKind('NONE', 0);
  ExpenditureFloorKind_BMR_instance = new ExpenditureFloorKind('BMR', 1);
}
var ExpenditureFloorKind_NONE_instance;
var ExpenditureFloorKind_BMR_instance;
function values_15() {
  static_init_23();
  return [ExpenditureFloorKind_NONE_getInstance(), ExpenditureFloorKind_BMR_getInstance()];
}
function get_entries_10() {
  static_init_23();
  if ($ENTRIES_10 == null)
    $ENTRIES_10 = enumEntries(values_15());
  return $ENTRIES_10;
}
var $ENTRIES_10;
function ExpenditureFloorKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ExpenditureFloor$of$lambda($leanFraction) {
  return function (weightKg) {
    return ExpenditureFloor_instance.gn(weightKg * $leanFraction);
  };
}
function ExpenditureFloor() {
  this.cn_1 = 1000.0;
  this.dn_1 = 1.0;
}
protoOf(ExpenditureFloor).oz = function (leanMassKg, factor) {
  // Inline function 'kotlin.math.max' call
  var b = factor * InitialExpenditure_instance.pz(leanMassKg);
  return Math.max(1000.0, b);
};
protoOf(ExpenditureFloor).gn = function (leanMassKg, factor, $super) {
  factor = factor === VOID ? 1.0 : factor;
  return $super === VOID ? this.oz(leanMassKg, factor) : $super.oz.call(this, leanMassKg, factor);
};
protoOf(ExpenditureFloor).en = function (kind, leanFraction) {
  var tmp;
  switch (kind.y1_1) {
    case 0:
      tmp = null;
      break;
    case 1:
      tmp = ExpenditureFloor$of$lambda(leanFraction);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var ExpenditureFloor_instance;
function ExpenditureFloor_getInstance() {
  return ExpenditureFloor_instance;
}
function ExpenditureFloorKind_NONE_getInstance() {
  static_init_23();
  return ExpenditureFloorKind_NONE_instance;
}
function ExpenditureFloorKind_BMR_getInstance() {
  static_init_23();
  return ExpenditureFloorKind_BMR_instance;
}
function ExpenditureChange(days, kcal) {
  this.qz_1 = days;
  this.rz_1 = kcal;
}
protoOf(ExpenditureChange).sz = function () {
  var tmp0_safe_receiver = this.rz_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp0_safe_receiver >= 0.5 ? Direction_INCREASE_getInstance() : tmp0_safe_receiver <= -0.5 ? Direction_DECREASE_getInstance() : Direction_NO_CHANGE_getInstance();
  }
  return tmp;
};
protoOf(ExpenditureChange).toString = function () {
  return 'ExpenditureChange(days=' + this.qz_1 + ', kcal=' + this.rz_1 + ')';
};
protoOf(ExpenditureChange).hashCode = function () {
  var result = this.qz_1;
  result = imul(result, 31) + (this.rz_1 == null ? 0 : getNumberHashCode(this.rz_1)) | 0;
  return result;
};
protoOf(ExpenditureChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureChange))
    return false;
  if (!(this.qz_1 === other.qz_1))
    return false;
  if (!equals(this.rz_1, other.rz_1))
    return false;
  return true;
};
function DisplayedExpenditure(point, waitingForWeighIn) {
  this.ww_1 = point;
  this.xw_1 = waitingForWeighIn;
}
protoOf(DisplayedExpenditure).toString = function () {
  return 'DisplayedExpenditure(point=' + this.ww_1.toString() + ', waitingForWeighIn=' + this.xw_1 + ')';
};
protoOf(DisplayedExpenditure).hashCode = function () {
  var result = this.ww_1.hashCode();
  result = imul(result, 31) + getBooleanHashCode(this.xw_1) | 0;
  return result;
};
protoOf(DisplayedExpenditure).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DisplayedExpenditure))
    return false;
  if (!this.ww_1.equals(other.ww_1))
    return false;
  if (!(this.xw_1 === other.xw_1))
    return false;
  return true;
};
function ExpenditureInsights() {
  ExpenditureInsights_instance = this;
  this.tw_1 = listOf([3, 7, 14, 30, 90]);
  this.uw_1 = 0.5;
}
protoOf(ExpenditureInsights).vw = function (points, today, weighedInToday) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator = points.p(points.o());
    while (iterator.c3()) {
      var element = iterator.d3();
      if (element.in_1 === today) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var todayPoint = tmp$ret$0;
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator_0 = points.p(points.o());
    while (iterator_0.c3()) {
      var element_0 = iterator_0.d3();
      if (element_0.in_1 < today) {
        tmp$ret$2 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$2 = null;
  }
  var before = tmp$ret$2;
  var tmp;
  if (todayPoint == null) {
    var tmp_0;
    if (before == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new DisplayedExpenditure(before.px(today), !weighedInToday);
    }
    tmp = tmp_0;
  } else if (weighedInToday || before == null) {
    tmp = new DisplayedExpenditure(todayPoint, false);
  } else {
    tmp = new DisplayedExpenditure(before.px(today), true);
  }
  return tmp;
};
protoOf(ExpenditureInsights).tz = function (points, windows) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(windows, 10));
  var _iterator__ex2g4s = windows.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new ExpenditureChange(item, ExpenditureInsights_getInstance().uz(points, item));
    destination.f(tmp$ret$2);
  }
  return destination;
};
protoOf(ExpenditureInsights).vz = function (points, windows, $super) {
  windows = windows === VOID ? this.tw_1 : windows;
  return $super === VOID ? this.tz(points, windows) : $super.tz.call(this, points, windows);
};
protoOf(ExpenditureInsights).uz = function (points, days) {
  // Inline function 'kotlin.require' call
  if (!(days > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = lastOrNull(points);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = points.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.in_1 === (last.in_1 - days | 0)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var start = tmp_0;
  return last.jn_1 - start.jn_1;
};
protoOf(ExpenditureInsights).wz = function (points) {
  if (points.o() < 2)
    return null;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var progression = until(1, points.o());
  var inductionVariable = progression.xc_1;
  var last = progression.yc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = sum;
      var it = element;
      // Inline function 'kotlin.math.abs' call
      var x = points.n(it).jn_1 - points.n(it - 1 | 0).jn_1;
      sum = tmp + Math.abs(x);
    }
     while (!(element === last));
  return sum / (points.o() - 1 | 0);
};
var ExpenditureInsights_instance;
function ExpenditureInsights_getInstance() {
  if (ExpenditureInsights_instance == null)
    new ExpenditureInsights();
  return ExpenditureInsights_instance;
}
function ExpenditureBand(days, settledKcal, responsiveKcal) {
  this.xz_1 = days;
  this.yz_1 = settledKcal;
  this.zz_1 = responsiveKcal;
}
protoOf(ExpenditureBand).toString = function () {
  return 'ExpenditureBand(days=' + toString(this.xz_1) + ', settledKcal=' + toString(this.yz_1) + ', responsiveKcal=' + toString(this.zz_1) + ')';
};
protoOf(ExpenditureBand).hashCode = function () {
  var result = hashCode(this.xz_1);
  result = imul(result, 31) + hashCode(this.yz_1) | 0;
  result = imul(result, 31) + hashCode(this.zz_1) | 0;
  return result;
};
protoOf(ExpenditureBand).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureBand))
    return false;
  if (!equals(this.xz_1, other.xz_1))
    return false;
  if (!equals(this.yz_1, other.yz_1))
    return false;
  if (!equals(this.zz_1, other.zz_1))
    return false;
  return true;
};
function band$run($initialKcal, $startDay, $endDay, $weighIns, $intake, $kcalPerKg, $goalChanges, $params, $terms, $inputs, $floorKcal, scale) {
  return ExpenditureV2_instance.mm($initialKcal, $startDay, $endDay, $weighIns, $intake, $kcalPerKg, $goalChanges, $params.r10(VOID, VOID, VOID, VOID, $params.e10_1 * scale), $terms, $inputs, $floorKcal);
}
function ExpenditureV2() {
  this.km_1 = 0.5;
  this.lm_1 = 2.0;
}
protoOf(ExpenditureV2).mm = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal) {
  return StateSpaceExpenditure_instance.s10(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal);
};
protoOf(ExpenditureV2).nm = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal) {
  var settled = band$run(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal, 0.5);
  var responsive = band$run(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal, 2.0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(settled, 10));
  var _iterator__ex2g4s = settled.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.in_1;
    destination.f(tmp$ret$2);
  }
  var tmp = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(settled, 10));
  var _iterator__ex2g4s_0 = settled.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.jn_1;
    destination_0.f(tmp$ret$5);
  }
  var tmp_0 = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(responsive, 10));
  var _iterator__ex2g4s_1 = responsive.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item_1.jn_1;
    destination_1.f(tmp$ret$8);
  }
  return new ExpenditureBand(tmp, tmp_0, destination_1);
};
var ExpenditureV2_instance;
function ExpenditureV2_getInstance() {
  return ExpenditureV2_instance;
}
function GoalAdjustmentParams(multiplier, days, capped, capPerDayKcal, budgetKcal, refillKcalPerDay, floorMarginKcal) {
  multiplier = multiplier === VOID ? 4.0 : multiplier;
  days = days === VOID ? 14 : days;
  capped = capped === VOID ? false : capped;
  capPerDayKcal = capPerDayKcal === VOID ? 25.0 : capPerDayKcal;
  budgetKcal = budgetKcal === VOID ? 300.0 : budgetKcal;
  refillKcalPerDay = refillKcalPerDay === VOID ? 5.0 : refillKcalPerDay;
  floorMarginKcal = floorMarginKcal === VOID ? 0.0 : floorMarginKcal;
  this.t10_1 = multiplier;
  this.u10_1 = days;
  this.v10_1 = capped;
  this.w10_1 = capPerDayKcal;
  this.x10_1 = budgetKcal;
  this.y10_1 = refillKcalPerDay;
  this.z10_1 = floorMarginKcal;
  // Inline function 'kotlin.require' call
  if (!(this.u10_1 > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.w10_1 >= 0.0 && this.x10_1 >= 0.0 && this.y10_1 >= 0.0 && this.z10_1 >= 0.0)) {
    var message_0 = 'caps must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(GoalAdjustmentParams).toString = function () {
  return 'GoalAdjustmentParams(multiplier=' + this.t10_1 + ', days=' + this.u10_1 + ', capped=' + this.v10_1 + ', capPerDayKcal=' + this.w10_1 + ', budgetKcal=' + this.x10_1 + ', refillKcalPerDay=' + this.y10_1 + ', floorMarginKcal=' + this.z10_1 + ')';
};
protoOf(GoalAdjustmentParams).hashCode = function () {
  var result = getNumberHashCode(this.t10_1);
  result = imul(result, 31) + this.u10_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.v10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.w10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.x10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.y10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z10_1) | 0;
  return result;
};
protoOf(GoalAdjustmentParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalAdjustmentParams))
    return false;
  if (!equals(this.t10_1, other.t10_1))
    return false;
  if (!(this.u10_1 === other.u10_1))
    return false;
  if (!(this.v10_1 === other.v10_1))
    return false;
  if (!equals(this.w10_1, other.w10_1))
    return false;
  if (!equals(this.x10_1, other.x10_1))
    return false;
  if (!equals(this.y10_1, other.y10_1))
    return false;
  if (!equals(this.z10_1, other.z10_1))
    return false;
  return true;
};
function GoalStart(day, ratePctPerWeek) {
  this.a11_1 = day;
  this.b11_1 = ratePctPerWeek;
}
protoOf(GoalStart).toString = function () {
  return 'GoalStart(day=' + this.a11_1 + ', ratePctPerWeek=' + this.b11_1 + ')';
};
protoOf(GoalStart).hashCode = function () {
  var result = this.a11_1;
  result = imul(result, 31) + getNumberHashCode(this.b11_1) | 0;
  return result;
};
protoOf(GoalStart).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalStart))
    return false;
  if (!(this.a11_1 === other.a11_1))
    return false;
  if (!equals(this.b11_1, other.b11_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_2(function_0) {
  this.c11_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_2).ea = function (a, b) {
  return this.c11_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).h2 = function () {
  return this.c11_1;
};
protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
  return hashCode(this.h2());
};
function GoalAdjuster$Companion$changes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.a11_1;
  var tmp$ret$2 = b.a11_1;
  return compareValues(tmp, tmp$ret$2);
}
function capped($this, wanted, running, held, estimate, floorKcal) {
  if (!running) {
    var tmp = $this;
    var tmp0 = $this.iy_1.x10_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.ly_1 + $this.iy_1.y10_1;
    tmp.ly_1 = Math.min(tmp0, b);
    var tmp_0 = $this;
    var tmp0_0 = $this.iy_1.x10_1;
    // Inline function 'kotlin.math.min' call
    var b_0 = $this.my_1 + $this.iy_1.y10_1;
    tmp_0.my_1 = Math.min(tmp0_0, b_0);
    return 0.0;
  }
  if (held || wanted === 0.0)
    return 0.0;
  var step = coerceIn(wanted, -$this.iy_1.w10_1, $this.iy_1.w10_1);
  if (step > 0.0) {
    var tmp0_1 = step;
    // Inline function 'kotlin.math.min' call
    var b_1 = $this.ly_1;
    step = Math.min(tmp0_1, b_1);
    $this.ly_1 = $this.ly_1 - step;
  } else {
    if (!(floorKcal == null) && estimate + step < floorKcal + $this.iy_1.z10_1)
      return 0.0;
    // Inline function 'kotlin.math.abs' call
    var x = step;
    var tmp0_2 = Math.abs(x);
    // Inline function 'kotlin.math.min' call
    var b_2 = $this.my_1;
    step = -Math.min(tmp0_2, b_2);
    var tmp_1 = $this;
    var tmp_2 = $this.my_1;
    // Inline function 'kotlin.math.abs' call
    var x_0 = step;
    tmp_1.my_1 = tmp_2 - Math.abs(x_0);
  }
  return step;
}
function Active(perDay, remaining) {
  this.d11_1 = perDay;
  this.e11_1 = remaining;
}
function Companion_2() {
}
protoOf(Companion_2).tn = function (starts) {
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = GoalAdjuster$Companion$changes$lambda;
  var tmp$ret$1 = new sam$kotlin_Comparator$0_2(tmp);
  var sorted = sortedWith(starts, tmp$ret$1);
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = zipWithNext(sorted);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var previous = element.hb();
    var current = element.ib();
    var tmp0_safe_receiver = current.b11_1 === previous.b11_1 ? null : new GoalChange(current.a11_1, previous.b11_1, current.b11_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
};
var Companion_instance_4;
function Companion_getInstance_2() {
  return Companion_instance_4;
}
function GoalAdjuster(changes, params) {
  params = params === VOID ? new GoalAdjustmentParams() : params;
  this.iy_1 = params;
  var tmp = this;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = changes.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = element.qx_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.t1(key);
    var tmp_0;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.l2(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var list = tmp_0;
    list.f(element);
  }
  tmp.jy_1 = destination;
  var tmp_1 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_1.ky_1 = ArrayList_init_$Create$_0();
  this.ly_1 = this.iy_1.x10_1;
  this.my_1 = this.iy_1.x10_1;
  this.ny_1 = 0.0;
}
protoOf(GoalAdjuster).oy = function (day, estimate, held, floorKcal) {
  var tmp0_safe_receiver = this.jy_1.t1(day);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0_safe_receiver.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var total = estimate * this.iy_1.t10_1 * (element.sx_1 - element.rx_1) / 100.0;
      this.ky_1.f(new Active(total / this.iy_1.u10_1, this.iy_1.u10_1));
    }
  }
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_0 = this.ky_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = sum;
    sum = tmp + element_0.d11_1;
  }
  var wanted = sum;
  // Inline function 'kotlin.collections.isNotEmpty' call
  var running = !this.ky_1.m();
  var iterator = this.ky_1.j();
  while (iterator.k()) {
    var adjustment = iterator.l();
    adjustment.e11_1 = adjustment.e11_1 - 1 | 0;
    if (adjustment.e11_1 <= 0) {
      iterator.r2();
    }
  }
  this.ny_1 = this.iy_1.v10_1 ? capped(this, wanted, running, held, estimate, floorKcal) : wanted;
  return this.ny_1;
};
var static_init_called_24;
function static_init_24() {
  if (static_init_called_24)
    return Unit_instance;
  static_init_called_24 = true;
  Sex_MALE_instance = new Sex('MALE', 0);
  Sex_FEMALE_instance = new Sex('FEMALE', 1);
}
var Sex_MALE_instance;
var Sex_FEMALE_instance;
function values_16() {
  static_init_24();
  return [Sex_MALE_getInstance(), Sex_FEMALE_getInstance()];
}
function valueOf_7(value) {
  static_init_24();
  switch (value) {
    case 'MALE':
      return Sex_MALE_getInstance();
    case 'FEMALE':
      return Sex_FEMALE_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.Sex.' + value);
      break;
  }
}
function get_entries_11() {
  static_init_24();
  if ($ENTRIES_11 == null)
    $ENTRIES_11 = enumEntries(values_16());
  return $ENTRIES_11;
}
var $ENTRIES_11;
function Sex(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_25;
function static_init_25() {
  if (static_init_called_25)
    return Unit_instance;
  static_init_called_25 = true;
  Ethnicity_SOUTH_ASIAN_instance = new Ethnicity('SOUTH_ASIAN', 0);
  Ethnicity_CHINESE_instance = new Ethnicity('CHINESE', 1);
  Ethnicity_OTHER_ASIAN_instance = new Ethnicity('OTHER_ASIAN', 2);
  Ethnicity_BLACK_AFRICAN_instance = new Ethnicity('BLACK_AFRICAN', 3);
  Ethnicity_BLACK_CARIBBEAN_instance = new Ethnicity('BLACK_CARIBBEAN', 4);
  Ethnicity_MIDDLE_EASTERN_instance = new Ethnicity('MIDDLE_EASTERN', 5);
  Ethnicity_WHITE_OR_OTHER_instance = new Ethnicity('WHITE_OR_OTHER', 6);
  Ethnicity_PREFER_NOT_TO_SAY_instance = new Ethnicity('PREFER_NOT_TO_SAY', 7);
}
var Ethnicity_SOUTH_ASIAN_instance;
var Ethnicity_CHINESE_instance;
var Ethnicity_OTHER_ASIAN_instance;
var Ethnicity_BLACK_AFRICAN_instance;
var Ethnicity_BLACK_CARIBBEAN_instance;
var Ethnicity_MIDDLE_EASTERN_instance;
var Ethnicity_WHITE_OR_OTHER_instance;
var Ethnicity_PREFER_NOT_TO_SAY_instance;
function values_17() {
  static_init_25();
  return [Ethnicity_SOUTH_ASIAN_getInstance(), Ethnicity_CHINESE_getInstance(), Ethnicity_OTHER_ASIAN_getInstance(), Ethnicity_BLACK_AFRICAN_getInstance(), Ethnicity_BLACK_CARIBBEAN_getInstance(), Ethnicity_MIDDLE_EASTERN_getInstance(), Ethnicity_WHITE_OR_OTHER_getInstance(), Ethnicity_PREFER_NOT_TO_SAY_getInstance()];
}
function get_entries_12() {
  static_init_25();
  if ($ENTRIES_12 == null)
    $ENTRIES_12 = enumEntries(values_17());
  return $ENTRIES_12;
}
var $ENTRIES_12;
function Ethnicity(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_26;
function static_init_26() {
  if (static_init_called_26)
    return Unit_instance;
  static_init_called_26 = true;
  ActivityLevel_SEDENTARY_instance = new ActivityLevel('SEDENTARY', 0, 1.2);
  ActivityLevel_LIGHT_instance = new ActivityLevel('LIGHT', 1, 1.375);
  ActivityLevel_MODERATE_instance = new ActivityLevel('MODERATE', 2, 1.55);
  ActivityLevel_VERY_instance = new ActivityLevel('VERY', 3, 1.725);
  ActivityLevel_EXTREME_instance = new ActivityLevel('EXTREME', 4, 1.9);
}
var ActivityLevel_SEDENTARY_instance;
var ActivityLevel_LIGHT_instance;
var ActivityLevel_MODERATE_instance;
var ActivityLevel_VERY_instance;
var ActivityLevel_EXTREME_instance;
function values_18() {
  static_init_26();
  return [ActivityLevel_SEDENTARY_getInstance(), ActivityLevel_LIGHT_getInstance(), ActivityLevel_MODERATE_getInstance(), ActivityLevel_VERY_getInstance(), ActivityLevel_EXTREME_getInstance()];
}
function valueOf_8(value) {
  static_init_26();
  switch (value) {
    case 'SEDENTARY':
      return ActivityLevel_SEDENTARY_getInstance();
    case 'LIGHT':
      return ActivityLevel_LIGHT_getInstance();
    case 'MODERATE':
      return ActivityLevel_MODERATE_getInstance();
    case 'VERY':
      return ActivityLevel_VERY_getInstance();
    case 'EXTREME':
      return ActivityLevel_EXTREME_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.ActivityLevel.' + value);
      break;
  }
}
function get_entries_13() {
  static_init_26();
  if ($ENTRIES_13 == null)
    $ENTRIES_13 = enumEntries(values_18());
  return $ENTRIES_13;
}
var $ENTRIES_13;
function ActivityLevel(name, ordinal, factor) {
  Enum.call(this, name, ordinal);
  this.h11_1 = factor;
}
var static_init_called_27;
function static_init_27() {
  if (static_init_called_27)
    return Unit_instance;
  static_init_called_27 = true;
  BmrEquation_AUTO_instance = new BmrEquation('AUTO', 0);
  BmrEquation_KATCH_instance = new BmrEquation('KATCH', 1);
  BmrEquation_MIFFLIN_instance = new BmrEquation('MIFFLIN', 2);
  BmrEquation_CUNNINGHAM_instance = new BmrEquation('CUNNINGHAM', 3);
  BmrEquation_TEN_HAAF_instance = new BmrEquation('TEN_HAAF', 4);
}
var BmrEquation_AUTO_instance;
var BmrEquation_KATCH_instance;
var BmrEquation_MIFFLIN_instance;
var BmrEquation_CUNNINGHAM_instance;
var BmrEquation_TEN_HAAF_instance;
function values_19() {
  static_init_27();
  return [BmrEquation_AUTO_getInstance(), BmrEquation_KATCH_getInstance(), BmrEquation_MIFFLIN_getInstance(), BmrEquation_CUNNINGHAM_getInstance(), BmrEquation_TEN_HAAF_getInstance()];
}
function get_entries_14() {
  static_init_27();
  if ($ENTRIES_14 == null)
    $ENTRIES_14 = enumEntries(values_19());
  return $ENTRIES_14;
}
var $ENTRIES_14;
function BmrEquation(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_28;
function static_init_28() {
  if (static_init_called_28)
    return Unit_instance;
  static_init_called_28 = true;
  DailyActivity_SEDENTARY_instance = new DailyActivity('SEDENTARY', 0, 1.2);
  DailyActivity_MODERATE_instance = new DailyActivity('MODERATE', 1, 1.4);
  DailyActivity_VERY_instance = new DailyActivity('VERY', 2, 1.6);
}
var DailyActivity_SEDENTARY_instance;
var DailyActivity_MODERATE_instance;
var DailyActivity_VERY_instance;
function values_20() {
  static_init_28();
  return [DailyActivity_SEDENTARY_getInstance(), DailyActivity_MODERATE_getInstance(), DailyActivity_VERY_getInstance()];
}
function get_entries_15() {
  static_init_28();
  if ($ENTRIES_15 == null)
    $ENTRIES_15 = enumEntries(values_20());
  return $ENTRIES_15;
}
var $ENTRIES_15;
function DailyActivity(name, ordinal, factor) {
  Enum.call(this, name, ordinal);
  this.k11_1 = factor;
}
var static_init_called_29;
function static_init_29() {
  if (static_init_called_29)
    return Unit_instance;
  static_init_called_29 = true;
  ExerciseSessions_NONE_instance = new ExerciseSessions('NONE', 0, 0.0);
  ExerciseSessions_ONE_TO_THREE_instance = new ExerciseSessions('ONE_TO_THREE', 1, 0.1);
  ExerciseSessions_FOUR_TO_SIX_instance = new ExerciseSessions('FOUR_TO_SIX', 2, 0.2);
  ExerciseSessions_SEVEN_PLUS_instance = new ExerciseSessions('SEVEN_PLUS', 3, 0.3);
}
var ExerciseSessions_NONE_instance;
var ExerciseSessions_ONE_TO_THREE_instance;
var ExerciseSessions_FOUR_TO_SIX_instance;
var ExerciseSessions_SEVEN_PLUS_instance;
function values_21() {
  static_init_29();
  return [ExerciseSessions_NONE_getInstance(), ExerciseSessions_ONE_TO_THREE_getInstance(), ExerciseSessions_FOUR_TO_SIX_getInstance(), ExerciseSessions_SEVEN_PLUS_getInstance()];
}
function get_entries_16() {
  static_init_29();
  if ($ENTRIES_16 == null)
    $ENTRIES_16 = enumEntries(values_21());
  return $ENTRIES_16;
}
var $ENTRIES_16;
function ExerciseSessions(name, ordinal, add) {
  Enum.call(this, name, ordinal);
  this.n11_1 = add;
}
function InitialExpenditureOptions(bmrEquation, dailyActivity, exerciseSessions, recentlyLosing) {
  bmrEquation = bmrEquation === VOID ? BmrEquation_AUTO_getInstance() : bmrEquation;
  dailyActivity = dailyActivity === VOID ? null : dailyActivity;
  exerciseSessions = exerciseSessions === VOID ? ExerciseSessions_NONE_getInstance() : exerciseSessions;
  recentlyLosing = recentlyLosing === VOID ? false : recentlyLosing;
  this.dg_1 = bmrEquation;
  this.eg_1 = dailyActivity;
  this.fg_1 = exerciseSessions;
  this.gg_1 = recentlyLosing;
}
protoOf(InitialExpenditureOptions).o11 = function (bmrEquation, dailyActivity, exerciseSessions, recentlyLosing) {
  return new InitialExpenditureOptions(bmrEquation, dailyActivity, exerciseSessions, recentlyLosing);
};
protoOf(InitialExpenditureOptions).hg = function (bmrEquation, dailyActivity, exerciseSessions, recentlyLosing, $super) {
  bmrEquation = bmrEquation === VOID ? this.dg_1 : bmrEquation;
  dailyActivity = dailyActivity === VOID ? this.eg_1 : dailyActivity;
  exerciseSessions = exerciseSessions === VOID ? this.fg_1 : exerciseSessions;
  recentlyLosing = recentlyLosing === VOID ? this.gg_1 : recentlyLosing;
  return $super === VOID ? this.o11(bmrEquation, dailyActivity, exerciseSessions, recentlyLosing) : $super.o11.call(this, bmrEquation, dailyActivity, exerciseSessions, recentlyLosing);
};
protoOf(InitialExpenditureOptions).toString = function () {
  return 'InitialExpenditureOptions(bmrEquation=' + this.dg_1.toString() + ', dailyActivity=' + toString_0(this.eg_1) + ', exerciseSessions=' + this.fg_1.toString() + ', recentlyLosing=' + this.gg_1 + ')';
};
protoOf(InitialExpenditureOptions).hashCode = function () {
  var result = this.dg_1.hashCode();
  result = imul(result, 31) + (this.eg_1 == null ? 0 : this.eg_1.hashCode()) | 0;
  result = imul(result, 31) + this.fg_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.gg_1) | 0;
  return result;
};
protoOf(InitialExpenditureOptions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof InitialExpenditureOptions))
    return false;
  if (!this.dg_1.equals(other.dg_1))
    return false;
  if (!equals(this.eg_1, other.eg_1))
    return false;
  if (!this.fg_1.equals(other.fg_1))
    return false;
  if (!(this.gg_1 === other.gg_1))
    return false;
  return true;
};
function InitialExpenditure() {
  this.vm_1 = 100.0;
  this.wm_1 = 0.95;
}
protoOf(InitialExpenditure).p11 = function (leanMassKg) {
  // Inline function 'kotlin.comparisons.minOf' call
  return 500.0 + 22.0 * Math.min(leanMassKg, 100.0);
};
protoOf(InitialExpenditure).q11 = function (recentlyLosing) {
  return recentlyLosing ? 0.95 : 1.0;
};
protoOf(InitialExpenditure).r11 = function (daily, sessions) {
  return daily.k11_1 + sessions.n11_1;
};
protoOf(InitialExpenditure).xm = function (sex, weightKg, heightCm, ageYears, activity, bodyFatFraction, options, waistCm) {
  var tmp0_safe_receiver = options.eg_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = InitialExpenditure_instance.r11(tmp0_safe_receiver, options.fg_1);
  }
  var tmp1_elvis_lhs = tmp;
  var factor = tmp1_elvis_lhs == null ? activity.h11_1 : tmp1_elvis_lhs;
  return this.hn(sex, weightKg, heightCm, ageYears, bodyFatFraction, options, waistCm) * factor;
};
protoOf(InitialExpenditure).hn = function (sex, weightKg, heightCm, ageYears, bodyFatFraction, options, waistCm) {
  var fat = bodyFatFraction == null ? BodyComposition_instance.bn(sex, ageYears, weightKg, heightCm, waistCm) : bodyFatFraction;
  var lean = weightKg * (1.0 - fat);
  var tmp;
  switch (options.dg_1.y1_1) {
    case 0:
      tmp = !(bodyFatFraction == null) ? this.pz(lean) : this.s11(sex, weightKg, heightCm, ageYears);
      break;
    case 1:
      tmp = this.pz(lean);
      break;
    case 2:
      tmp = this.s11(sex, weightKg, heightCm, ageYears);
      break;
    case 3:
      tmp = this.p11(lean);
      break;
    case 4:
      tmp = this.t11(sex, weightKg, heightCm, ageYears);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var bmr = tmp;
  return bmr * this.q11(options.gg_1);
};
protoOf(InitialExpenditure).ym = function (importedKcal, lastOwnKcal, formulaKcal) {
  var tmp1_elvis_lhs = importedKcal == null ? lastOwnKcal : importedKcal;
  return tmp1_elvis_lhs == null ? formulaKcal : tmp1_elvis_lhs;
};
protoOf(InitialExpenditure).s11 = function (sex, weightKg, heightCm, ageYears) {
  var base = 10.0 * weightKg + 6.25 * heightCm - 5.0 * ageYears;
  var tmp;
  switch (sex.y1_1) {
    case 0:
      tmp = base + 5.0;
      break;
    case 1:
      tmp = base - 161.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(InitialExpenditure).pz = function (leanMassKg) {
  return 370.0 + 21.6 * leanMassKg;
};
protoOf(InitialExpenditure).t11 = function (sex, weightKg, heightCm, ageYears) {
  var male = sex.equals(Sex_MALE_getInstance()) ? 1.0 : 0.0;
  return 11.936 * weightKg + 587.728 * (heightCm / 100.0) - 8.129 * ageYears + 191.027 * male + 29.279;
};
var InitialExpenditure_instance;
function InitialExpenditure_getInstance() {
  return InitialExpenditure_instance;
}
function Sex_MALE_getInstance() {
  static_init_24();
  return Sex_MALE_instance;
}
function Sex_FEMALE_getInstance() {
  static_init_24();
  return Sex_FEMALE_instance;
}
function Ethnicity_SOUTH_ASIAN_getInstance() {
  static_init_25();
  return Ethnicity_SOUTH_ASIAN_instance;
}
function Ethnicity_CHINESE_getInstance() {
  static_init_25();
  return Ethnicity_CHINESE_instance;
}
function Ethnicity_OTHER_ASIAN_getInstance() {
  static_init_25();
  return Ethnicity_OTHER_ASIAN_instance;
}
function Ethnicity_BLACK_AFRICAN_getInstance() {
  static_init_25();
  return Ethnicity_BLACK_AFRICAN_instance;
}
function Ethnicity_BLACK_CARIBBEAN_getInstance() {
  static_init_25();
  return Ethnicity_BLACK_CARIBBEAN_instance;
}
function Ethnicity_MIDDLE_EASTERN_getInstance() {
  static_init_25();
  return Ethnicity_MIDDLE_EASTERN_instance;
}
function Ethnicity_WHITE_OR_OTHER_getInstance() {
  static_init_25();
  return Ethnicity_WHITE_OR_OTHER_instance;
}
function Ethnicity_PREFER_NOT_TO_SAY_getInstance() {
  static_init_25();
  return Ethnicity_PREFER_NOT_TO_SAY_instance;
}
function ActivityLevel_SEDENTARY_getInstance() {
  static_init_26();
  return ActivityLevel_SEDENTARY_instance;
}
function ActivityLevel_LIGHT_getInstance() {
  static_init_26();
  return ActivityLevel_LIGHT_instance;
}
function ActivityLevel_MODERATE_getInstance() {
  static_init_26();
  return ActivityLevel_MODERATE_instance;
}
function ActivityLevel_VERY_getInstance() {
  static_init_26();
  return ActivityLevel_VERY_instance;
}
function ActivityLevel_EXTREME_getInstance() {
  static_init_26();
  return ActivityLevel_EXTREME_instance;
}
function BmrEquation_AUTO_getInstance() {
  static_init_27();
  return BmrEquation_AUTO_instance;
}
function BmrEquation_KATCH_getInstance() {
  static_init_27();
  return BmrEquation_KATCH_instance;
}
function BmrEquation_MIFFLIN_getInstance() {
  static_init_27();
  return BmrEquation_MIFFLIN_instance;
}
function BmrEquation_CUNNINGHAM_getInstance() {
  static_init_27();
  return BmrEquation_CUNNINGHAM_instance;
}
function BmrEquation_TEN_HAAF_getInstance() {
  static_init_27();
  return BmrEquation_TEN_HAAF_instance;
}
function DailyActivity_SEDENTARY_getInstance() {
  static_init_28();
  return DailyActivity_SEDENTARY_instance;
}
function DailyActivity_MODERATE_getInstance() {
  static_init_28();
  return DailyActivity_MODERATE_instance;
}
function DailyActivity_VERY_getInstance() {
  static_init_28();
  return DailyActivity_VERY_instance;
}
function ExerciseSessions_NONE_getInstance() {
  static_init_29();
  return ExerciseSessions_NONE_instance;
}
function ExerciseSessions_ONE_TO_THREE_getInstance() {
  static_init_29();
  return ExerciseSessions_ONE_TO_THREE_instance;
}
function ExerciseSessions_FOUR_TO_SIX_getInstance() {
  static_init_29();
  return ExerciseSessions_FOUR_TO_SIX_instance;
}
function ExerciseSessions_SEVEN_PLUS_getInstance() {
  static_init_29();
  return ExerciseSessions_SEVEN_PLUS_instance;
}
var static_init_called_30;
function static_init_30() {
  if (static_init_called_30)
    return Unit_instance;
  static_init_called_30 = true;
  IntakePrior_RECENT_MEAN_instance = new IntakePrior('RECENT_MEAN', 0);
  IntakePrior_EXPENDITURE_instance = new IntakePrior('EXPENDITURE', 1);
}
var IntakePrior_RECENT_MEAN_instance;
var IntakePrior_EXPENDITURE_instance;
function values_22() {
  static_init_30();
  return [IntakePrior_RECENT_MEAN_getInstance(), IntakePrior_EXPENDITURE_getInstance()];
}
function get_entries_17() {
  static_init_30();
  if ($ENTRIES_17 == null)
    $ENTRIES_17 = enumEntries(values_22());
  return $ENTRIES_17;
}
var $ENTRIES_17;
function IntakePrior(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function StateSpaceParams(scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) {
  scaleNoiseKg = scaleNoiseKg === VOID ? 0.4 : scaleNoiseKg;
  waterSdKg = waterSdKg === VOID ? 0.4 : waterSdKg;
  waterHalfLifeDays = waterHalfLifeDays === VOID ? 4.0 : waterHalfLifeDays;
  tissueNoiseKg = tissueNoiseKg === VOID ? 0.01 : tissueNoiseKg;
  expenditureNoiseKcal = expenditureNoiseKcal === VOID ? 15.0 : expenditureNoiseKcal;
  initialUncertaintyKcal = initialUncertaintyKcal === VOID ? 350.0 : initialUncertaintyKcal;
  initialWeightSdKg = initialWeightSdKg === VOID ? 0.5 : initialWeightSdKg;
  loggedIntakeRelativeNoise = loggedIntakeRelativeNoise === VOID ? 0.1 : loggedIntakeRelativeNoise;
  unknownIntakeSdKcal = unknownIntakeSdKcal === VOID ? 600.0 : unknownIntakeSdKcal;
  unknownIntakeWindowDays = unknownIntakeWindowDays === VOID ? 14 : unknownIntakeWindowDays;
  intakePrior = intakePrior === VOID ? IntakePrior_RECENT_MEAN_getInstance() : intakePrior;
  firstUpdateAfterDays = firstUpdateAfterDays === VOID ? 2 : firstUpdateAfterDays;
  minUsableIntakeDaysInLastWeek = minUsableIntakeDaysInLastWeek === VOID ? 4 : minUsableIntakeDaysInLastWeek;
  maxDaysSinceWeighIn = maxDaysSinceWeighIn === VOID ? 7 : maxDaysSinceWeighIn;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? false : holdAfterLastWeighIn;
  gainKcalPerKg = gainKcalPerKg === VOID ? null : gainKcalPerKg;
  goalAdjustment = goalAdjustment === VOID ? new GoalAdjustmentParams() : goalAdjustment;
  this.a10_1 = scaleNoiseKg;
  this.b10_1 = waterSdKg;
  this.c10_1 = waterHalfLifeDays;
  this.d10_1 = tissueNoiseKg;
  this.e10_1 = expenditureNoiseKcal;
  this.f10_1 = initialUncertaintyKcal;
  this.g10_1 = initialWeightSdKg;
  this.h10_1 = loggedIntakeRelativeNoise;
  this.i10_1 = unknownIntakeSdKcal;
  this.j10_1 = unknownIntakeWindowDays;
  this.k10_1 = intakePrior;
  this.l10_1 = firstUpdateAfterDays;
  this.m10_1 = minUsableIntakeDaysInLastWeek;
  this.n10_1 = maxDaysSinceWeighIn;
  this.o10_1 = holdAfterLastWeighIn;
  this.p10_1 = gainKcalPerKg;
  this.q10_1 = goalAdjustment;
  // Inline function 'kotlin.require' call
  if (!(this.a10_1 > 0.0 && this.b10_1 >= 0.0 && this.d10_1 >= 0.0 && this.e10_1 >= 0.0)) {
    var message = 'noise must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.c10_1 > 0.0 && this.f10_1 > 0.0 && this.g10_1 > 0.0)) {
    var message_0 = 'settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(this.h10_1 >= 0.0 && this.i10_1 > 0.0 && this.j10_1 > 0)) {
    var message_1 = 'intake settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(StateSpaceParams).u11 = function (scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) {
  return new StateSpaceParams(scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment);
};
protoOf(StateSpaceParams).r10 = function (scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment, $super) {
  scaleNoiseKg = scaleNoiseKg === VOID ? this.a10_1 : scaleNoiseKg;
  waterSdKg = waterSdKg === VOID ? this.b10_1 : waterSdKg;
  waterHalfLifeDays = waterHalfLifeDays === VOID ? this.c10_1 : waterHalfLifeDays;
  tissueNoiseKg = tissueNoiseKg === VOID ? this.d10_1 : tissueNoiseKg;
  expenditureNoiseKcal = expenditureNoiseKcal === VOID ? this.e10_1 : expenditureNoiseKcal;
  initialUncertaintyKcal = initialUncertaintyKcal === VOID ? this.f10_1 : initialUncertaintyKcal;
  initialWeightSdKg = initialWeightSdKg === VOID ? this.g10_1 : initialWeightSdKg;
  loggedIntakeRelativeNoise = loggedIntakeRelativeNoise === VOID ? this.h10_1 : loggedIntakeRelativeNoise;
  unknownIntakeSdKcal = unknownIntakeSdKcal === VOID ? this.i10_1 : unknownIntakeSdKcal;
  unknownIntakeWindowDays = unknownIntakeWindowDays === VOID ? this.j10_1 : unknownIntakeWindowDays;
  intakePrior = intakePrior === VOID ? this.k10_1 : intakePrior;
  firstUpdateAfterDays = firstUpdateAfterDays === VOID ? this.l10_1 : firstUpdateAfterDays;
  minUsableIntakeDaysInLastWeek = minUsableIntakeDaysInLastWeek === VOID ? this.m10_1 : minUsableIntakeDaysInLastWeek;
  maxDaysSinceWeighIn = maxDaysSinceWeighIn === VOID ? this.n10_1 : maxDaysSinceWeighIn;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? this.o10_1 : holdAfterLastWeighIn;
  gainKcalPerKg = gainKcalPerKg === VOID ? this.p10_1 : gainKcalPerKg;
  goalAdjustment = goalAdjustment === VOID ? this.q10_1 : goalAdjustment;
  return $super === VOID ? this.u11(scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) : $super.u11.call(this, scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment);
};
protoOf(StateSpaceParams).toString = function () {
  return 'StateSpaceParams(scaleNoiseKg=' + this.a10_1 + ', waterSdKg=' + this.b10_1 + ', waterHalfLifeDays=' + this.c10_1 + ', tissueNoiseKg=' + this.d10_1 + ', expenditureNoiseKcal=' + this.e10_1 + ', initialUncertaintyKcal=' + this.f10_1 + ', initialWeightSdKg=' + this.g10_1 + ', loggedIntakeRelativeNoise=' + this.h10_1 + ', unknownIntakeSdKcal=' + this.i10_1 + ', unknownIntakeWindowDays=' + this.j10_1 + ', intakePrior=' + this.k10_1.toString() + ', firstUpdateAfterDays=' + this.l10_1 + ', minUsableIntakeDaysInLastWeek=' + this.m10_1 + ', maxDaysSinceWeighIn=' + this.n10_1 + ', holdAfterLastWeighIn=' + this.o10_1 + ', gainKcalPerKg=' + this.p10_1 + ', goalAdjustment=' + this.q10_1.toString() + ')';
};
protoOf(StateSpaceParams).hashCode = function () {
  var result = getNumberHashCode(this.a10_1);
  result = imul(result, 31) + getNumberHashCode(this.b10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.c10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.d10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.e10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.f10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.g10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.h10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.i10_1) | 0;
  result = imul(result, 31) + this.j10_1 | 0;
  result = imul(result, 31) + this.k10_1.hashCode() | 0;
  result = imul(result, 31) + this.l10_1 | 0;
  result = imul(result, 31) + this.m10_1 | 0;
  result = imul(result, 31) + this.n10_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.o10_1) | 0;
  result = imul(result, 31) + (this.p10_1 == null ? 0 : getNumberHashCode(this.p10_1)) | 0;
  result = imul(result, 31) + this.q10_1.hashCode() | 0;
  return result;
};
protoOf(StateSpaceParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StateSpaceParams))
    return false;
  if (!equals(this.a10_1, other.a10_1))
    return false;
  if (!equals(this.b10_1, other.b10_1))
    return false;
  if (!equals(this.c10_1, other.c10_1))
    return false;
  if (!equals(this.d10_1, other.d10_1))
    return false;
  if (!equals(this.e10_1, other.e10_1))
    return false;
  if (!equals(this.f10_1, other.f10_1))
    return false;
  if (!equals(this.g10_1, other.g10_1))
    return false;
  if (!equals(this.h10_1, other.h10_1))
    return false;
  if (!equals(this.i10_1, other.i10_1))
    return false;
  if (!(this.j10_1 === other.j10_1))
    return false;
  if (!this.k10_1.equals(other.k10_1))
    return false;
  if (!(this.l10_1 === other.l10_1))
    return false;
  if (!(this.m10_1 === other.m10_1))
    return false;
  if (!(this.n10_1 === other.n10_1))
    return false;
  if (!(this.o10_1 === other.o10_1))
    return false;
  if (!equals(this.p10_1, other.p10_1))
    return false;
  if (!this.q10_1.equals(other.q10_1))
    return false;
  return true;
};
function Companion_3() {
  Companion_instance_5 = this;
  this.jl_1 = new ExpenditureV2Terms();
  this.kl_1 = new ExpenditureV2Terms(0.5, 1.0, 5.0E-4, 6.0E-5, 1.0);
}
var Companion_instance_5;
function Companion_getInstance_3() {
  if (Companion_instance_5 == null)
    new Companion_3();
  return Companion_instance_5;
}
function ExpenditureV2Terms(adaptation, massScaling, carbsWaterKgPerG, sodiumWaterKgPerMg, stepsFlexibility, setsFlexibility, creatineWaterKg, creatineDays, baselineDays) {
  Companion_getInstance_3();
  adaptation = adaptation === VOID ? 0.0 : adaptation;
  massScaling = massScaling === VOID ? 0.0 : massScaling;
  carbsWaterKgPerG = carbsWaterKgPerG === VOID ? 0.0 : carbsWaterKgPerG;
  sodiumWaterKgPerMg = sodiumWaterKgPerMg === VOID ? 0.0 : sodiumWaterKgPerMg;
  stepsFlexibility = stepsFlexibility === VOID ? 0.0 : stepsFlexibility;
  setsFlexibility = setsFlexibility === VOID ? 0.0 : setsFlexibility;
  creatineWaterKg = creatineWaterKg === VOID ? 0.0 : creatineWaterKg;
  creatineDays = creatineDays === VOID ? 14 : creatineDays;
  baselineDays = baselineDays === VOID ? 14 : baselineDays;
  this.v11_1 = adaptation;
  this.w11_1 = massScaling;
  this.x11_1 = carbsWaterKgPerG;
  this.y11_1 = sodiumWaterKgPerMg;
  this.z11_1 = stepsFlexibility;
  this.a12_1 = setsFlexibility;
  this.b12_1 = creatineWaterKg;
  this.c12_1 = creatineDays;
  this.d12_1 = baselineDays;
  // Inline function 'kotlin.require' call
  if (!(this.z11_1 >= 0.0 && this.a12_1 >= 0.0)) {
    var message = 'flexibility must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.c12_1 > 0 && this.d12_1 > 0)) {
    var message_0 = 'windows must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(ExpenditureV2Terms).toString = function () {
  return 'ExpenditureV2Terms(adaptation=' + this.v11_1 + ', massScaling=' + this.w11_1 + ', carbsWaterKgPerG=' + this.x11_1 + ', sodiumWaterKgPerMg=' + this.y11_1 + ', stepsFlexibility=' + this.z11_1 + ', setsFlexibility=' + this.a12_1 + ', creatineWaterKg=' + this.b12_1 + ', creatineDays=' + this.c12_1 + ', baselineDays=' + this.d12_1 + ')';
};
protoOf(ExpenditureV2Terms).hashCode = function () {
  var result = getNumberHashCode(this.v11_1);
  result = imul(result, 31) + getNumberHashCode(this.w11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.x11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.y11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a12_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.b12_1) | 0;
  result = imul(result, 31) + this.c12_1 | 0;
  result = imul(result, 31) + this.d12_1 | 0;
  return result;
};
protoOf(ExpenditureV2Terms).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureV2Terms))
    return false;
  if (!equals(this.v11_1, other.v11_1))
    return false;
  if (!equals(this.w11_1, other.w11_1))
    return false;
  if (!equals(this.x11_1, other.x11_1))
    return false;
  if (!equals(this.y11_1, other.y11_1))
    return false;
  if (!equals(this.z11_1, other.z11_1))
    return false;
  if (!equals(this.a12_1, other.a12_1))
    return false;
  if (!equals(this.b12_1, other.b12_1))
    return false;
  if (!(this.c12_1 === other.c12_1))
    return false;
  if (!(this.d12_1 === other.d12_1))
    return false;
  return true;
};
function DailyInputs(carbsG, sodiumMg, steps, hardSets, creatineStartDays) {
  carbsG = carbsG === VOID ? emptyMap() : carbsG;
  sodiumMg = sodiumMg === VOID ? emptyMap() : sodiumMg;
  steps = steps === VOID ? emptyMap() : steps;
  hardSets = hardSets === VOID ? emptyMap() : hardSets;
  creatineStartDays = creatineStartDays === VOID ? emptySet() : creatineStartDays;
  this.e12_1 = carbsG;
  this.f12_1 = sodiumMg;
  this.g12_1 = steps;
  this.h12_1 = hardSets;
  this.i12_1 = creatineStartDays;
}
protoOf(DailyInputs).toString = function () {
  return 'DailyInputs(carbsG=' + toString(this.e12_1) + ', sodiumMg=' + toString(this.f12_1) + ', steps=' + toString(this.g12_1) + ', hardSets=' + toString(this.h12_1) + ', creatineStartDays=' + toString(this.i12_1) + ')';
};
protoOf(DailyInputs).hashCode = function () {
  var result = hashCode(this.e12_1);
  result = imul(result, 31) + hashCode(this.f12_1) | 0;
  result = imul(result, 31) + hashCode(this.g12_1) | 0;
  result = imul(result, 31) + hashCode(this.h12_1) | 0;
  result = imul(result, 31) + hashCode(this.i12_1) | 0;
  return result;
};
protoOf(DailyInputs).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DailyInputs))
    return false;
  if (!equals(this.e12_1, other.e12_1))
    return false;
  if (!equals(this.f12_1, other.f12_1))
    return false;
  if (!equals(this.g12_1, other.g12_1))
    return false;
  if (!equals(this.h12_1, other.h12_1))
    return false;
  if (!equals(this.i12_1, other.i12_1))
    return false;
  return true;
};
function intakeFor($this, day, intakeByDay, expenditure, params) {
  var entry = intakeByDay.t1(day);
  if (!(entry == null) && entry.hk_1.equals(DayStatus_COMPLETE_getInstance())) {
    var sd = params.h10_1 * entry.gk_1;
    return to(entry.gk_1, sd * sd);
  }
  if (!(entry == null) && entry.hk_1.equals(DayStatus_FASTED_getInstance()))
    return to(0.0, 0.0);
  var tmp;
  if (params.k10_1.equals(IntakePrior_EXPENDITURE_getInstance())) {
    tmp = expenditure;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = until(day - params.j10_1 | 0, day);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = tmp0.xc_1;
    var last = tmp0.yc_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = element;
        var tmp0_safe_receiver = intakeByDay.t1(d);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1;
          switch (tmp0_safe_receiver.hk_1.y1_1) {
            case 0:
              tmp_1 = tmp0_safe_receiver.gk_1;
              break;
            case 2:
              tmp_1 = 0.0;
              break;
            case 1:
            case 3:
              tmp_1 = null;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp_0 = tmp_1;
        }
        var tmp0_safe_receiver_0 = tmp_0;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.f(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var recent = destination;
    tmp = recent.m() ? expenditure : average(recent);
  }
  var prior = tmp;
  return to(prior, params.i10_1 * params.i10_1);
}
function waterInput($this, day, inputs, terms) {
  return waterInput$excess(day, terms, inputs.e12_1, terms.x11_1) + waterInput$excess(day, terms, inputs.f12_1, terms.y11_1);
}
function creatine($this, day, starts, terms) {
  var tmp;
  var tmp_0;
  if (!(terms.b12_1 === 0.0)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(starts, Collection)) {
        tmp_1 = starts.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = starts.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (day >= element && day < (element + terms.c12_1 | 0)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = terms.b12_1;
  } else {
    tmp = 0.0;
  }
  return tmp;
}
function relativeChange($this, day, series, gain) {
  if (gain === 0.0 || series.m())
    return 0.0;
  var tmp0_elvis_lhs = relativeChange$mean(series, day - 6 | 0, day);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var recent = tmp;
  var tmp1_elvis_lhs = relativeChange$mean(series, day - 13 | 0, day - 7 | 0);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var before = tmp_0;
  var tmp2_safe_receiver = relativeChange$mean(series, day - 27 | 0, day);
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (tmp2_safe_receiver > 0.0) {
      tmp_2 = tmp2_safe_receiver;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var tmp3_elvis_lhs = tmp_1;
  var tmp_3;
  if (tmp3_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp_3 = tmp3_elvis_lhs;
  }
  var level = tmp_3;
  // Inline function 'kotlin.math.abs' call
  var x = recent - before;
  // Inline function 'kotlin.math.min' call
  var b = Math.abs(x) / level;
  return Math.min(1.0, b);
}
function update($this, x, p, reading, r) {
  var tmp = 0;
  var tmp_0 = new Float64Array(3);
  while (tmp < 3) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = p.k12(tmp_1, 0) + p.k12(tmp_1, 1);
    tmp = tmp + 1 | 0;
  }
  var ph = tmp_0;
  var s = ph[0] + ph[1] + r;
  var tmp_2 = 0;
  var tmp_3 = new Float64Array(3);
  while (tmp_2 < 3) {
    var tmp_4 = tmp_2;
    tmp_3[tmp_4] = ph[tmp_4] / s;
    tmp_2 = tmp_2 + 1 | 0;
  }
  var gain = tmp_3;
  var innovation = reading - (x[0] + x[1]);
  var inductionVariable = 0;
  if (inductionVariable <= 2)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      x[i] = x[i] + gain[i] * innovation;
    }
     while (inductionVariable <= 2);
  var tmp_5 = 0;
  var tmp_6 = new Float64Array(9);
  while (tmp_5 < 9) {
    var tmp_7 = tmp_5;
    var i_0 = tmp_7 / 3 | 0;
    var j = tmp_7 % 3 | 0;
    tmp_6[tmp_7] = (i_0 === j ? 1.0 : 0.0) - gain[i_0] * (j < 2 ? 1.0 : 0.0);
    tmp_5 = tmp_5 + 1 | 0;
  }
  var a = new Matrix3(tmp_6);
  var joseph = a.l12(p).m12(a);
  var tmp_8 = 0;
  var tmp_9 = new Float64Array(9);
  while (tmp_8 < 9) {
    var tmp_10 = tmp_8;
    tmp_9[tmp_10] = joseph.j12_1[tmp_10] + gain[tmp_10 / 3 | 0] * r * gain[tmp_10 % 3 | 0];
    tmp_8 = tmp_8 + 1 | 0;
  }
  return new Matrix3(tmp_9);
}
function isUsable($this, entry) {
  return !(entry == null) && (entry.hk_1.equals(DayStatus_COMPLETE_getInstance()) || entry.hk_1.equals(DayStatus_FASTED_getInstance()));
}
function StateSpaceExpenditure$filter$$inlined$groupingBy$1($this) {
  this.n12_1 = $this;
}
protoOf(StateSpaceExpenditure$filter$$inlined$groupingBy$1).j2 = function () {
  return this.n12_1.j();
};
protoOf(StateSpaceExpenditure$filter$$inlined$groupingBy$1).o12 = function (element) {
  return element.gm_1;
};
protoOf(StateSpaceExpenditure$filter$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function waterInput$excess($day, $terms, series, gain) {
  if (gain === 0.0)
    return 0.0;
  var tmp0_elvis_lhs = series.t1($day);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var today = tmp;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = until($day - $terms.d12_1 | 0, $day);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      var tmp0_safe_receiver = series.t1(it);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.f(tmp0_safe_receiver);
      }
    }
     while (!(element === last));
  var baseline = destination;
  return baseline.m() ? 0.0 : gain * (today - average(baseline));
}
function relativeChange$mean($series, from, to) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = numberRangeToNumber(from, to);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      var tmp0_safe_receiver = $series.t1(it);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.f(tmp0_safe_receiver);
      }
    }
     while (!(element === last));
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination.m()) {
    tmp = destination;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver_0 = tmp;
  return tmp0_safe_receiver_0 == null ? null : average(tmp0_safe_receiver_0);
}
function StateSpaceExpenditure() {
}
protoOf(StateSpaceExpenditure).jm = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, floorKcal) {
  return this.s10(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, Companion_getInstance_3().jl_1, new DailyInputs(), floorKcal);
};
protoOf(StateSpaceExpenditure).s10 = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal) {
  // Inline function 'kotlin.require' call
  if (!(endDay >= startDay)) {
    var message = 'endDay must not be before startDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(kcalPerKg > 0.0)) {
    var message_0 = 'kcalPerKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var daily = WeightTrend_instance.um(weighIns);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = daily.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = element.gm_1;
    var tmp$ret$7 = element.hm_1;
    destination.l2(tmp, tmp$ret$7);
  }
  var weights = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = weighIns.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0.hm_1 >= 25.0) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$11 = new StateSpaceExpenditure$filter$$inlined$groupingBy$1(destination_0);
  var counts = eachCount(tmp$ret$11);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(daily, 10));
  var _iterator__ex2g4s_1 = daily.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$14 = item.gm_1;
    destination_1.f(tmp$ret$14);
  }
  var weighInDays = destination_1;
  var finalWeighIn = lastOrNull(weighInDays);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_2 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_2 = intake.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    var tmp$ret$17 = element_1.fk_1;
    destination_2.l2(tmp$ret$17, element_1);
  }
  var intakeByDay = destination_2;
  var adjuster = new GoalAdjuster(goalChanges, params.q10_1);
  // Inline function 'kotlin.math.pow' call
  var x = 1.0 / params.c10_1;
  var phi = Math.pow(0.5, x);
  var waterVariance = params.b10_1 * params.b10_1;
  var tmp$ret$19;
  $l$block: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator = daily.p(daily.o());
    while (iterator.c3()) {
      var element_2 = iterator.d3();
      if (element_2.gm_1 <= startDay) {
        tmp$ret$19 = element_2;
        break $l$block;
      }
    }
    tmp$ret$19 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$19;
  var tmp1_safe_receiver = tmp0_elvis_lhs == null ? firstOrNull(daily) : tmp0_elvis_lhs;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hm_1;
  var startWeight = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  // Inline function 'kotlin.doubleArrayOf' call
  var x_0 = new Float64Array([startWeight, 0.0, initialKcal]);
  var p = Companion_instance_6.p12(params.g10_1 * params.g10_1, waterVariance, params.f10_1 * params.f10_1);
  var qWater = waterVariance * (1.0 - phi * phi);
  var qTissue = params.d10_1 * params.d10_1;
  var qExpenditure = params.e10_1 * params.e10_1;
  var feedback = terms.v11_1 + terms.w11_1;
  var covariance = p;
  var reported = initialKcal;
  var everUpdated = false;
  var points = ArrayList_init_$Create$((endDay - startDay | 0) + 1 | 0);
  var inductionVariable = startDay;
  if (inductionVariable <= endDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (day > startDay) {
        var _destruct__k2r9zo = intakeFor(this, day - 1 | 0, intakeByDay, x_0[2], params);
        var intakeKcal = _destruct__k2r9zo.hb();
        var intakeVariance = _destruct__k2r9zo.ib();
        var tmp3_safe_receiver = params.p10_1;
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          if (intakeKcal - x_0[2] > 0.0) {
            tmp_1 = tmp3_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp4_elvis_lhs = tmp_0;
        var density = tmp4_elvis_lhs == null ? kcalPerKg : tmp4_elvis_lhs;
        var mass = x_0[0];
        var energy = x_0[2];
        var c = !(feedback === 0.0) && mass > 0.0 ? feedback / (density * mass) : 0.0;
        var dEdM = c === 0.0 ? 0.0 : -c * energy * (intakeKcal - energy) / mass;
        // Inline function 'kotlin.doubleArrayOf' call
        var tmp$ret$24 = new Float64Array([1.0, 0.0, -1.0 / density, 0.0, phi, 0.0, dEdM, 0.0, 1.0 + c * (intakeKcal - 2.0 * energy)]);
        var f = new Matrix3(tmp$ret$24);
        var water = creatine(this, day - 1 | 0, inputs.i12_1, terms);
        x_0[0] = x_0[0] + (intakeKcal - x_0[2]) / density;
        x_0[1] = water + phi * (x_0[1] - water) + waterInput(this, day - 1 | 0, inputs, terms);
        x_0[2] = energy + c * energy * (intakeKcal - energy);
        var flex = (1.0 + terms.z11_1 * relativeChange(this, day - 1 | 0, inputs.g12_1, terms.z11_1)) * (1.0 + terms.a12_1 * relativeChange(this, day - 1 | 0, inputs.h12_1, terms.a12_1));
        covariance = f.l12(covariance).m12(f).q12(qTissue + intakeVariance / (density * density), qWater, qExpenditure * flex);
        if (!(c === 0.0)) {
          var ce = c * energy;
          covariance = covariance.r12(0, 2, intakeVariance * ce / density).q12(0.0, 0.0, intakeVariance * ce * ce);
        }
      }
      var tmp$ret$25;
      $l$block_0: {
        // Inline function 'kotlin.collections.lastOrNull' call
        var iterator_0 = weighInDays.p(weighInDays.o());
        while (iterator_0.c3()) {
          var element_3 = iterator_0.d3();
          if (element_3 <= day) {
            tmp$ret$25 = element_3;
            break $l$block_0;
          }
        }
        tmp$ret$25 = null;
      }
      var lastWeighIn = tmp$ret$25;
      var tmp_2;
      if (lastWeighIn == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = floorKcal == null ? null : floorKcal(getValue(weights, lastWeighIn));
      }
      var floor = tmp_2;
      var tmp0 = numberRangeToNumber(day - 6 | 0, day);
      var tmp$ret$29;
      $l$block_1: {
        // Inline function 'kotlin.collections.count' call
        var tmp_3;
        if (isInterface(tmp0, Collection)) {
          tmp_3 = tmp0.m();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$29 = 0;
          break $l$block_1;
        }
        var count = 0;
        var inductionVariable_0 = tmp0.xc_1;
        var last = tmp0.yc_1;
        if (inductionVariable_0 <= last)
          do {
            var element_4 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var it = element_4;
            if (isUsable(StateSpaceExpenditure_instance, intakeByDay.t1(it))) {
              count = count + 1 | 0;
              checkCountOverflow(count);
            }
          }
           while (!(element_4 === last));
        tmp$ret$29 = count;
      }
      var usableLastWeek = tmp$ret$29;
      var eligible = (day - startDay | 0) >= params.l10_1 && usableLastWeek >= params.m10_1 && !(lastWeighIn == null) && (day - lastWeighIn | 0) < params.n10_1 && !(params.o10_1 && !(finalWeighIn == null) && day > finalWeighIn);
      var shiftToday = adjuster.oy(day, x_0[2], !eligible, floor);
      x_0[2] = x_0[2] + shiftToday;
      var reading = weights.t1(day);
      if (!(reading == null)) {
        var tmp_4 = params.a10_1 * params.a10_1;
        var tmp6_elvis_lhs = counts.t1(day);
        var r = tmp_4 / (tmp6_elvis_lhs == null ? 1 : tmp6_elvis_lhs);
        covariance = update(this, x_0, covariance, reading, r);
      }
      if (!(floor == null) && x_0[2] < floor) {
        x_0[2] = floor;
      }
      var tmp_5;
      if (eligible) {
        reported = x_0[2];
        everUpdated = true;
        tmp_5 = ExpenditureStatus_UPDATING_getInstance();
      } else if (everUpdated) {
        reported = reported + shiftToday;
        tmp_5 = ExpenditureStatus_HOLDING_getInstance();
      } else {
        reported = reported + shiftToday;
        tmp_5 = ExpenditureStatus_INITIAL_getInstance();
      }
      var status = tmp_5;
      var floored = !(floor == null) && reported <= floor;
      if (!(floor == null) && reported < floor)
        reported = floor;
      var tmp_6 = reported;
      // Inline function 'kotlin.math.abs' call
      var x_1 = covariance.k12(2, 2);
      // Inline function 'kotlin.math.sqrt' call
      var x_2 = Math.abs(x_1);
      var tmp$ret$32 = Math.sqrt(x_2);
      points.f(new ExpenditurePoint(day, tmp_6, tmp$ret$32, status, floored, shiftToday));
    }
     while (!(day === endDay));
  return points;
};
var StateSpaceExpenditure_instance;
function StateSpaceExpenditure_getInstance() {
  return StateSpaceExpenditure_instance;
}
function Companion_4() {
}
protoOf(Companion_4).p12 = function (a, b, c) {
  // Inline function 'kotlin.doubleArrayOf' call
  var tmp$ret$0 = new Float64Array([a, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, c]);
  return new Matrix3(tmp$ret$0);
};
var Companion_instance_6;
function Companion_getInstance_4() {
  return Companion_instance_6;
}
function Matrix3(values) {
  this.j12_1 = values;
  // Inline function 'kotlin.require' call
  if (!(this.j12_1.length === 9)) {
    var message = 'a 3\xD73 matrix has 9 values';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(Matrix3).k12 = function (row, column) {
  return this.j12_1[imul(row, 3) + column | 0];
};
protoOf(Matrix3).l12 = function (other) {
  var tmp = 0;
  var tmp_0 = new Float64Array(9);
  while (tmp < 9) {
    var tmp_1 = tmp;
    var i = tmp_1 / 3 | 0;
    var j = tmp_1 % 3 | 0;
    tmp_0[tmp_1] = this.k12(i, 0) * other.k12(0, j) + this.k12(i, 1) * other.k12(1, j) + this.k12(i, 2) * other.k12(2, j);
    tmp = tmp + 1 | 0;
  }
  return new Matrix3(tmp_0);
};
protoOf(Matrix3).m12 = function (other) {
  var tmp = 0;
  var tmp_0 = new Float64Array(9);
  while (tmp < 9) {
    var tmp_1 = tmp;
    var i = tmp_1 / 3 | 0;
    var j = tmp_1 % 3 | 0;
    tmp_0[tmp_1] = this.k12(i, 0) * other.k12(j, 0) + this.k12(i, 1) * other.k12(j, 1) + this.k12(i, 2) * other.k12(j, 2);
    tmp = tmp + 1 | 0;
  }
  return new Matrix3(tmp_0);
};
protoOf(Matrix3).q12 = function (a, b, c) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.also' call
  var this_0 = this.j12_1.slice();
  this_0[0] = this_0[0] + a;
  this_0[4] = this_0[4] + b;
  this_0[8] = this_0[8] + c;
  return new Matrix3(this_0);
};
protoOf(Matrix3).r12 = function (row, column, value) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.also' call
  var this_0 = this.j12_1.slice();
  var _index_0__fvwizt = imul(row, 3) + column | 0;
  this_0[_index_0__fvwizt] = this_0[_index_0__fvwizt] + value;
  var _index_0__fvwizt_0 = imul(column, 3) + row | 0;
  this_0[_index_0__fvwizt_0] = this_0[_index_0__fvwizt_0] + value;
  return new Matrix3(this_0);
};
protoOf(Matrix3).s12 = function () {
  var a = this.j12_1;
  var c00 = a[4] * a[8] - a[5] * a[7];
  var c01 = a[5] * a[6] - a[3] * a[8];
  var c02 = a[3] * a[7] - a[4] * a[6];
  var det = a[0] * c00 + a[1] * c01 + a[2] * c02;
  // Inline function 'kotlin.require' call
  if (!!(det === 0.0)) {
    var message = 'matrix is singular';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.doubleArrayOf' call
  var tmp$ret$2 = new Float64Array([c00 / det, (a[2] * a[7] - a[1] * a[8]) / det, (a[1] * a[5] - a[2] * a[4]) / det, c01 / det, (a[0] * a[8] - a[2] * a[6]) / det, (a[2] * a[3] - a[0] * a[5]) / det, c02 / det, (a[1] * a[6] - a[0] * a[7]) / det, (a[0] * a[4] - a[1] * a[3]) / det]);
  return new Matrix3(tmp$ret$2);
};
function IntakePrior_RECENT_MEAN_getInstance() {
  static_init_30();
  return IntakePrior_RECENT_MEAN_instance;
}
function IntakePrior_EXPENDITURE_getInstance() {
  static_init_30();
  return IntakePrior_EXPENDITURE_instance;
}
function Grams() {
  Grams_instance = this;
  AmountUnit.call(this);
}
protoOf(Grams).toString = function () {
  return 'Grams';
};
protoOf(Grams).hashCode = function () {
  return 88276644;
};
protoOf(Grams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Grams))
    return false;
  return true;
};
var Grams_instance;
function Grams_getInstance() {
  if (Grams_instance == null)
    new Grams();
  return Grams_instance;
}
function Ounces() {
  Ounces_instance = this;
  AmountUnit.call(this);
}
protoOf(Ounces).toString = function () {
  return 'Ounces';
};
protoOf(Ounces).hashCode = function () {
  return -1326210207;
};
protoOf(Ounces).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Ounces))
    return false;
  return true;
};
var Ounces_instance;
function Ounces_getInstance() {
  if (Ounces_instance == null)
    new Ounces();
  return Ounces_instance;
}
function Household(portion) {
  AmountUnit.call(this);
  this.t12_1 = portion;
}
protoOf(Household).toString = function () {
  return 'Household(portion=' + this.t12_1.toString() + ')';
};
protoOf(Household).hashCode = function () {
  return this.t12_1.hashCode();
};
protoOf(Household).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Household))
    return false;
  if (!this.t12_1.equals(other.t12_1))
    return false;
  return true;
};
function Companion_5() {
  this.u12_1 = 28.349523125;
}
var Companion_instance_7;
function Companion_getInstance_5() {
  return Companion_instance_7;
}
function AmountUnit() {
}
function UnitChoice(unit, isAiChosen) {
  isAiChosen = isAiChosen === VOID ? false : isAiChosen;
  this.v12_1 = unit;
  this.w12_1 = isAiChosen;
}
protoOf(UnitChoice).toString = function () {
  return 'UnitChoice(unit=' + toString(this.v12_1) + ', isAiChosen=' + this.w12_1 + ')';
};
protoOf(UnitChoice).hashCode = function () {
  var result = hashCode(this.v12_1);
  result = imul(result, 31) + getBooleanHashCode(this.w12_1) | 0;
  return result;
};
protoOf(UnitChoice).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UnitChoice))
    return false;
  if (!equals(this.v12_1, other.v12_1))
    return false;
  if (!(this.w12_1 === other.w12_1))
    return false;
  return true;
};
function unitChoicesFor(portions, useImperialWeight, aiPortion) {
  aiPortion = aiPortion === VOID ? null : aiPortion;
  var choices = mutableListOf([new UnitChoice(Grams_getInstance())]);
  if (useImperialWeight) {
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new UnitChoice(Ounces_getInstance());
    choices.f(element);
  }
  // Inline function 'kotlin.collections.mapTo' call
  var _iterator__ex2g4s = portions.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new UnitChoice(new Household(item), !(aiPortion == null) && aiPortion.x12_1 === item.x12_1);
    choices.f(tmp$ret$2);
  }
  return choices;
}
function gramsFor(amount, portion) {
  return portion == null ? amount : amount * portion.y12_1;
}
function amountFor(grams, portion) {
  return portion == null || portion.y12_1 <= 0.0 ? grams : grams / portion.y12_1;
}
function SuggestedAmount(label, amount, portion) {
  this.z12_1 = label;
  this.a13_1 = amount;
  this.b13_1 = portion;
}
protoOf(SuggestedAmount).toString = function () {
  return 'SuggestedAmount(label=' + this.z12_1 + ', amount=' + this.a13_1 + ', portion=' + toString_0(this.b13_1) + ')';
};
protoOf(SuggestedAmount).hashCode = function () {
  var result = getStringHashCode(this.z12_1);
  result = imul(result, 31) + getNumberHashCode(this.a13_1) | 0;
  result = imul(result, 31) + (this.b13_1 == null ? 0 : this.b13_1.hashCode()) | 0;
  return result;
};
protoOf(SuggestedAmount).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SuggestedAmount))
    return false;
  if (!(this.z12_1 === other.z12_1))
    return false;
  if (!equals(this.a13_1, other.a13_1))
    return false;
  if (!equals(this.b13_1, other.b13_1))
    return false;
  return true;
};
function suggestedAmounts(portions, usualGrams, usualPortion) {
  var tmp;
  if (usualGrams == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new SuggestedAmount('Your usual ' + tenths(usualGrams) + ' g', amountFor(usualGrams, usualPortion), usualPortion);
  }
  var usual = tmp;
  var tmp1_safe_receiver = firstOrNull(portions);
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = new SuggestedAmount(tmp1_safe_receiver.x12_1 + ' (' + tenths(tmp1_safe_receiver.y12_1) + ' g)', 1.0, tmp1_safe_receiver);
  }
  var portion = tmp_0;
  // Inline function 'kotlin.collections.distinctBy' call
  var this_0 = listOfNotNull([usual, portion, new SuggestedAmount('100 g', 100.0, null)]);
  var set = HashSet_init_$Create$();
  var list = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var e = _iterator__ex2g4s.l();
    var key = gramsFor(e.a13_1, e.b13_1);
    if (set.f(key)) {
      list.f(e);
    }
  }
  return list;
}
function tenths(value) {
  return removeSuffix(NumberText_getInstance().he(value, 1), '.0');
}
function get_VULGAR_FRACTIONS() {
  _init_properties_AmountText_kt__xwru2j();
  return VULGAR_FRACTIONS;
}
var VULGAR_FRACTIONS;
function parseAmountText(text) {
  _init_properties_AmountText_kt__xwru2j();
  // Inline function 'kotlin.text.trim' call
  var trimmed = toString(trim(isCharSequence(text) ? text : THROW_CCE()));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(trimmed) === 0)
    return null;
  var lastChar = last_0(trimmed);
  var tmp0 = get_VULGAR_FRACTIONS();
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  var key = new Char(lastChar);
  if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).r1(key)) {
    // Inline function 'kotlin.text.trim' call
    var this_0 = dropLast(trimmed, 1);
    var wholeText = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(wholeText) === 0) {
      tmp = 0.0;
    } else {
      var tmp0_safe_receiver = toDoubleOrNull(wholeText);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_1;
        if (tmp0_safe_receiver >= 0.0) {
          tmp_1 = tmp0_safe_receiver;
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }
      var tmp1_elvis_lhs = tmp_0;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      tmp = tmp_2;
    }
    var whole = tmp;
    // Inline function 'kotlin.takeIf' call
    var this_1 = whole + getValue(get_VULGAR_FRACTIONS(), new Char(lastChar));
    var tmp_3;
    if (this_1 > 0.0) {
      tmp_3 = this_1;
    } else {
      tmp_3 = null;
    }
    return tmp_3;
  }
  // Inline function 'kotlin.text.split' call
  var tokens = Regex_init_$Create$('\\s+').m9(trimmed, 2);
  var fractionText = last(tokens);
  if (contains_0(fractionText, _Char___init__impl__6a9atx(47))) {
    // Inline function 'kotlin.takeIf' call
    var tmp_4;
    if (tokens.o() === 2) {
      tmp_4 = tokens;
    } else {
      tmp_4 = null;
    }
    var tmp2_safe_receiver = tmp_4;
    var wholeText_0 = tmp2_safe_receiver == null ? null : first(tmp2_safe_receiver);
    var fractionParts = split_0(fractionText, charArrayOf([_Char___init__impl__6a9atx(47)]));
    if (!(fractionParts.o() === 2))
      return null;
    var tmp3_elvis_lhs = toDoubleOrNull(fractionParts.n(0));
    var tmp_5;
    if (tmp3_elvis_lhs == null) {
      return null;
    } else {
      tmp_5 = tmp3_elvis_lhs;
    }
    var numerator = tmp_5;
    var tmp4_elvis_lhs = toDoubleOrNull(fractionParts.n(1));
    var tmp_6;
    if (tmp4_elvis_lhs == null) {
      return null;
    } else {
      tmp_6 = tmp4_elvis_lhs;
    }
    var denominator = tmp_6;
    if (numerator < 0.0 || denominator <= 0.0)
      return null;
    var tmp_7;
    if (wholeText_0 == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = toDoubleOrNull(wholeText_0);
      var tmp_8;
      if (tmp0_safe_receiver_0 == null) {
        tmp_8 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_9;
        if (tmp0_safe_receiver_0 >= 0.0) {
          tmp_9 = tmp0_safe_receiver_0;
        } else {
          tmp_9 = null;
        }
        tmp_8 = tmp_9;
      }
      var tmp1_elvis_lhs_0 = tmp_8;
      var tmp_10;
      if (tmp1_elvis_lhs_0 == null) {
        return null;
      } else {
        tmp_10 = tmp1_elvis_lhs_0;
      }
      tmp_7 = tmp_10;
    }
    var tmp6_elvis_lhs = tmp_7;
    var whole_0 = tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs;
    // Inline function 'kotlin.takeIf' call
    var this_2 = whole_0 + numerator / denominator;
    var tmp_11;
    if (this_2 > 0.0) {
      tmp_11 = this_2;
    } else {
      tmp_11 = null;
    }
    return tmp_11;
  }
  if (tokens.o() > 1)
    return null;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(trimmed)) {
    var element = charSequenceGet(trimmed, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (element === _Char___init__impl__6a9atx(46) || element === _Char___init__impl__6a9atx(44)) {
      count = count + 1 | 0;
    }
  }
  var separators = count;
  if (separators > 1)
    return null;
  var tmp7_safe_receiver = toDoubleOrNull(replace(trimmed, _Char___init__impl__6a9atx(44), _Char___init__impl__6a9atx(46)));
  var tmp_12;
  if (tmp7_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_13;
    if (isFinite(tmp7_safe_receiver) && tmp7_safe_receiver > 0.0) {
      tmp_13 = tmp7_safe_receiver;
    } else {
      tmp_13 = null;
    }
    tmp_12 = tmp_13;
  }
  return tmp_12;
}
var properties_initialized_AmountText_kt_p8z4ft;
function _init_properties_AmountText_kt__xwru2j() {
  if (!properties_initialized_AmountText_kt_p8z4ft) {
    properties_initialized_AmountText_kt_p8z4ft = true;
    VULGAR_FRACTIONS = mapOf_0([to(new Char(_Char___init__impl__6a9atx(189)), 1.0 / 2), to(new Char(_Char___init__impl__6a9atx(8531)), 1.0 / 3), to(new Char(_Char___init__impl__6a9atx(8532)), 2.0 / 3), to(new Char(_Char___init__impl__6a9atx(188)), 1.0 / 4), to(new Char(_Char___init__impl__6a9atx(190)), 3.0 / 4), to(new Char(_Char___init__impl__6a9atx(8533)), 1.0 / 5), to(new Char(_Char___init__impl__6a9atx(8534)), 2.0 / 5), to(new Char(_Char___init__impl__6a9atx(8535)), 3.0 / 5), to(new Char(_Char___init__impl__6a9atx(8536)), 4.0 / 5), to(new Char(_Char___init__impl__6a9atx(8537)), 1.0 / 6), to(new Char(_Char___init__impl__6a9atx(8538)), 5.0 / 6), to(new Char(_Char___init__impl__6a9atx(8528)), 1.0 / 7), to(new Char(_Char___init__impl__6a9atx(8539)), 1.0 / 8), to(new Char(_Char___init__impl__6a9atx(8540)), 3.0 / 8), to(new Char(_Char___init__impl__6a9atx(8541)), 5.0 / 8), to(new Char(_Char___init__impl__6a9atx(8542)), 7.0 / 8), to(new Char(_Char___init__impl__6a9atx(8529)), 1.0 / 9), to(new Char(_Char___init__impl__6a9atx(8530)), 1.0 / 10)]);
  }
}
function DishItem(grams, per100g) {
  this.c13_1 = grams;
  this.d13_1 = per100g;
}
protoOf(DishItem).toString = function () {
  return 'DishItem(grams=' + this.c13_1 + ', per100g=' + this.d13_1.toString() + ')';
};
protoOf(DishItem).hashCode = function () {
  var result = getNumberHashCode(this.c13_1);
  result = imul(result, 31) + this.d13_1.hashCode() | 0;
  return result;
};
protoOf(DishItem).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DishItem))
    return false;
  if (!equals(this.c13_1, other.c13_1))
    return false;
  if (!this.d13_1.equals(other.d13_1))
    return false;
  return true;
};
function dishTotal(items) {
  var total = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = items.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = item.d13_1.o13(item.c13_1).w1().j();
    while (_iterator__ex2g4s_0.k()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.l();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.p1();
      // Inline function 'kotlin.collections.component2' call
      var amount = _destruct__k2r9zo.q1();
      var tmp0_elvis_lhs = total.t1(key);
      // Inline function 'kotlin.collections.set' call
      var value = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) + amount;
      total.l2(key, value);
    }
  }
  return total;
}
function round1($this, value) {
  return round(value * 10.0) / 10.0;
}
function number($this, value) {
  var tmp;
  if (!(value == null) ? typeof value === 'number' : false) {
    tmp = value;
  } else {
    if (isNumber(value)) {
      tmp = numberToDouble(value);
    } else {
      if (!(value == null) ? typeof value === 'string' : false) {
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$0 = toString(trim(isCharSequence(value) ? value : THROW_CCE()));
        tmp = toDoubleOrNull(tmp$ret$0);
      } else {
        tmp = null;
      }
    }
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (isFinite(tmp1_safe_receiver)) {
      tmp_1 = tmp1_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function text_0($this, value) {
  var tmp0_safe_receiver = (!(value == null) ? typeof value === 'string' : false) ? value : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.ifEmpty' call
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(tmp0_safe_receiver) === 0) {
      tmp_0 = null;
    } else {
      tmp_0 = tmp0_safe_receiver;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function normalise$nutrient(nutriments, key) {
  var tmp = OffProduct_getInstance();
  // Inline function 'kotlin.collections.get' call
  var key_0 = key + '_100g';
  var tmp$ret$0 = (isInterface(nutriments, KtMap) ? nutriments : THROW_CCE()).t1(key_0);
  return number(tmp, tmp$ret$0);
}
function OffProduct() {
  OffProduct_instance = this;
  this.p13_1 = 'https://world.openfoodfacts.org';
  this.q13_1 = 'code,product_name,generic_name,brands,nutriments,serving_size,serving_quantity,product_quantity,lang,countries_tags';
  this.r13_1 = Regex_init_$Create$('^\\d{8,14}$');
  this.s13_1 = 4.184;
  this.t13_1 = 2.5;
  this.u13_1 = 'Macrotide';
}
protoOf(OffProduct).v13 = function (code) {
  return this.r13_1.a9(code);
};
protoOf(OffProduct).w13 = function (code, baseUrl) {
  return this.v13(code) ? baseUrl + '/api/v3/product/' + code + '?fields=code,product_name,generic_name,brands,nutriments,serving_size,serving_quantity,product_quantity,lang,countries_tags&app_name=Macrotide' : null;
};
protoOf(OffProduct).x13 = function (code, baseUrl, $super) {
  baseUrl = baseUrl === VOID ? 'https://world.openfoodfacts.org' : baseUrl;
  return $super === VOID ? this.w13(code, baseUrl) : $super.w13.call(this, code, baseUrl);
};
protoOf(OffProduct).y13 = function (code, response) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = Json_instance.ng(response);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp_1 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp0_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  var payload = tmp_2;
  // Inline function 'kotlin.collections.get' call
  var status = (isInterface(payload, KtMap) ? payload : THROW_CCE()).t1('status');
  if (!equals(status, 'success') && !equals(status, 1.0))
    return null;
  // Inline function 'kotlin.collections.get' call
  var tmp_3 = (isInterface(payload, KtMap) ? payload : THROW_CCE()).t1('product');
  var tmp1_elvis_lhs = (!(tmp_3 == null) ? isInterface(tmp_3, KtMap) : false) ? tmp_3 : null;
  var tmp_4;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp1_elvis_lhs;
  }
  var product = tmp_4;
  var tmp2_safe_receiver = this.z13(code, product);
  var tmp_5;
  if (tmp2_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_5 = Json_instance.sg(tmp2_safe_receiver);
  }
  return tmp_5;
};
protoOf(OffProduct).z13 = function (code, product) {
  // Inline function 'kotlin.collections.get' call
  var key = 'nutriments';
  var tmp = (isInterface(product, KtMap) ? product : THROW_CCE()).t1(key);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : null;
  var nutriments = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = normalise$nutrient(nutriments, 'energy-kcal');
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = normalise$nutrient(nutriments, 'energy');
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = round1(OffProduct_getInstance(), tmp2_safe_receiver / 4.184);
    }
    tmp_0 = tmp_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var kcal = tmp_0;
  var protein = normalise$nutrient(nutriments, 'proteins');
  var fat = normalise$nutrient(nutriments, 'fat');
  var carbs = normalise$nutrient(nutriments, 'carbohydrates');
  if (kcal == null || protein == null || fat == null || carbs == null)
    return null;
  var tmp3_elvis_lhs = normalise$nutrient(nutriments, 'sodium');
  var tmp_2;
  if (tmp3_elvis_lhs == null) {
    var tmp4_safe_receiver = normalise$nutrient(nutriments, 'salt');
    var tmp_3;
    if (tmp4_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = tmp4_safe_receiver / 2.5;
    }
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp3_elvis_lhs;
  }
  var sodiumGrams = tmp_2;
  // Inline function 'kotlin.collections.get' call
  var key_0 = 'product_name';
  var tmp$ret$5 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1(key_0);
  var tmp5_elvis_lhs = text_0(this, tmp$ret$5);
  var tmp_4;
  if (tmp5_elvis_lhs == null) {
    // Inline function 'kotlin.collections.get' call
    var key_1 = 'generic_name';
    var tmp$ret$6 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1(key_1);
    tmp_4 = text_0(this, tmp$ret$6);
  } else {
    tmp_4 = tmp5_elvis_lhs;
  }
  var tmp6_elvis_lhs = tmp_4;
  // Inline function 'kotlin.text.trim' call
  var this_0 = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
  // Inline function 'kotlin.text.ifEmpty' call
  var this_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp_5;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_1) === 0) {
    tmp_5 = 'Product ' + code;
  } else {
    tmp_5 = this_1;
  }
  var name = tmp_5;
  // Inline function 'kotlin.collections.get' call
  var tmp$ret$11 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1('brands');
  var tmp7_elvis_lhs = text_0(this, tmp$ret$11);
  // Inline function 'kotlin.text.trim' call
  var this_2 = split(tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs, [',']).n(0);
  // Inline function 'kotlin.text.ifEmpty' call
  var this_3 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  var tmp_6;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_3) === 0) {
    tmp_6 = null;
  } else {
    tmp_6 = this_3;
  }
  var brand = tmp_6;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_4 = ArrayList_init_$Create$_0();
  var tmp_7 = OffProduct_getInstance();
  // Inline function 'kotlin.collections.get' call
  var key_2 = 'serving_quantity';
  var tmp$ret$20 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1(key_2);
  var tmp0_safe_receiver = number(tmp_7, tmp$ret$20);
  var tmp_8;
  if (tmp0_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_9;
    if (!(tmp0_safe_receiver === 0.0)) {
      tmp_9 = tmp0_safe_receiver;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var tmp1_safe_receiver = tmp_8;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_10 = OffProduct_getInstance();
    // Inline function 'kotlin.collections.get' call
    var key_3 = 'serving_size';
    var tmp$ret$25 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1(key_3);
    var tmp0_elvis_lhs_0 = text_0(tmp_10, tmp$ret$25);
    this_4.f(mapOf_0([to('label', tmp0_elvis_lhs_0 == null ? '1 serving' : tmp0_elvis_lhs_0), to('grams', tmp1_safe_receiver)]));
  }
  var tmp_11 = OffProduct_getInstance();
  // Inline function 'kotlin.collections.get' call
  var key_4 = 'product_quantity';
  var tmp$ret$26 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1(key_4);
  var tmp2_safe_receiver_0 = number(tmp_11, tmp$ret$26);
  var tmp_12;
  if (tmp2_safe_receiver_0 == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_13;
    if (!(tmp2_safe_receiver_0 === 0.0)) {
      tmp_13 = tmp2_safe_receiver_0;
    } else {
      tmp_13 = null;
    }
    tmp_12 = tmp_13;
  }
  var tmp3_safe_receiver = tmp_12;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_4.f(mapOf_0([to('label', '1 package'), to('grams', tmp3_safe_receiver)]));
  }
  var portions = this_4.y3();
  var tmp_14 = to('id', 'off:' + code);
  var tmp_15 = to('name', name);
  var tmp_16 = to('brand', brand);
  var tmp_17 = to('source', 'OFF');
  var tmp_18 = to('kind', 'branded');
  // Inline function 'kotlin.collections.get' call
  var tmp$ret$31 = (isInterface(product, KtMap) ? product : THROW_CCE()).t1('lang');
  var tmp8_elvis_lhs = text_0(this, tmp$ret$31);
  var tmp_19 = to('lang', tmp8_elvis_lhs == null ? 'en' : tmp8_elvis_lhs);
  var tmp_20 = to('barcode', code);
  var tmp_21 = to('kcal', kcal);
  var tmp_22 = to('protein', protein);
  var tmp_23 = to('fat', fat);
  var tmp_24 = to('carbs', carbs);
  var tmp_25 = to('fiber', normalise$nutrient(nutriments, 'fiber'));
  var tmp_26 = to('sugar', normalise$nutrient(nutriments, 'sugars'));
  var tmp_27 = to('satFat', normalise$nutrient(nutriments, 'saturated-fat'));
  var tmp_28;
  if (sodiumGrams == null) {
    tmp_28 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_28 = round1(OffProduct_getInstance(), sodiumGrams * 1000.0);
  }
  return linkedMapOf([tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, to('per100g', linkedMapOf([tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, to('sodiumMg', tmp_28), to('alcohol', normalise$nutrient(nutriments, 'alcohol'))])), to('portions', portions)]);
};
var OffProduct_instance;
function OffProduct_getInstance() {
  if (OffProduct_instance == null)
    new OffProduct();
  return OffProduct_instance;
}
function Portion(label, grams) {
  this.x12_1 = label;
  this.y12_1 = grams;
}
protoOf(Portion).toString = function () {
  return 'Portion(label=' + this.x12_1 + ', grams=' + this.y12_1 + ')';
};
protoOf(Portion).hashCode = function () {
  var result = getStringHashCode(this.x12_1);
  result = imul(result, 31) + getNumberHashCode(this.y12_1) | 0;
  return result;
};
protoOf(Portion).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Portion))
    return false;
  if (!(this.x12_1 === other.x12_1))
    return false;
  if (!equals(this.y12_1, other.y12_1))
    return false;
  return true;
};
function Message(key, args) {
  args = args === VOID ? emptyMap() : args;
  this.a14_1 = key;
  this.b14_1 = args;
}
protoOf(Message).toString = function () {
  return 'Message(key=' + this.a14_1 + ', args=' + toString(this.b14_1) + ')';
};
protoOf(Message).hashCode = function () {
  var result = getStringHashCode(this.a14_1);
  result = imul(result, 31) + hashCode(this.b14_1) | 0;
  return result;
};
protoOf(Message).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Message))
    return false;
  if (!(this.a14_1 === other.a14_1))
    return false;
  if (!equals(this.b14_1, other.b14_1))
    return false;
  return true;
};
function obj($this) {
  $this.d14_1 = $this.d14_1 + 1 | 0;
  var map = LinkedHashMap_init_$Create$_1();
  $this.e14();
  var tmp = peek($this);
  if (equals(tmp == null ? null : new Char(tmp), new Char(_Char___init__impl__6a9atx(125)))) {
    $this.d14_1 = $this.d14_1 + 1 | 0;
    return map;
  }
  while (true) {
    $this.e14();
    var tmp_0 = peek($this);
    // Inline function 'kotlin.require' call
    if (!equals(tmp_0 == null ? null : new Char(tmp_0), new Char(_Char___init__impl__6a9atx(34)))) {
      var message = 'expected a key at ' + $this.d14_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var key = string($this);
    $this.e14();
    expect($this, _Char___init__impl__6a9atx(58));
    // Inline function 'kotlin.collections.set' call
    var value = $this.f14();
    map.l2(key, value);
    $this.e14();
    var tmp0_subject = peek($this);
    var tmp_1 = tmp0_subject;
    if (equals(tmp_1 == null ? null : new Char(tmp_1), new Char(_Char___init__impl__6a9atx(44)))) {
      $this.d14_1 = $this.d14_1 + 1 | 0;
    } else {
      var tmp_2 = tmp0_subject;
      if (equals(tmp_2 == null ? null : new Char(tmp_2), new Char(_Char___init__impl__6a9atx(125)))) {
        $this.d14_1 = $this.d14_1 + 1 | 0;
        return map;
      } else {
        throw IllegalArgumentException_init_$Create$("expected ',' or '}' at " + $this.d14_1);
      }
    }
  }
}
function array($this) {
  $this.d14_1 = $this.d14_1 + 1 | 0;
  var list = ArrayList_init_$Create$_0();
  $this.e14();
  var tmp = peek($this);
  if (equals(tmp == null ? null : new Char(tmp), new Char(_Char___init__impl__6a9atx(93)))) {
    $this.d14_1 = $this.d14_1 + 1 | 0;
    return list;
  }
  while (true) {
    list.f($this.f14());
    $this.e14();
    var tmp0_subject = peek($this);
    var tmp_0 = tmp0_subject;
    if (equals(tmp_0 == null ? null : new Char(tmp_0), new Char(_Char___init__impl__6a9atx(44)))) {
      $this.d14_1 = $this.d14_1 + 1 | 0;
    } else {
      var tmp_1 = tmp0_subject;
      if (equals(tmp_1 == null ? null : new Char(tmp_1), new Char(_Char___init__impl__6a9atx(93)))) {
        $this.d14_1 = $this.d14_1 + 1 | 0;
        return list;
      } else {
        throw IllegalArgumentException_init_$Create$("expected ',' or ']' at " + $this.d14_1);
      }
    }
  }
}
function string($this) {
  expect($this, _Char___init__impl__6a9atx(34));
  var out = StringBuilder_init_$Create$();
  while (true) {
    // Inline function 'kotlin.require' call
    if (!($this.d14_1 < $this.c14_1.length)) {
      var message = 'unterminated string';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var _unary__edvuaz = $this.d14_1;
    $this.d14_1 = _unary__edvuaz + 1 | 0;
    var c = charCodeAt($this.c14_1, _unary__edvuaz);
    if (c === _Char___init__impl__6a9atx(34))
      return out.toString();
    else if (c === _Char___init__impl__6a9atx(92)) {
      // Inline function 'kotlin.require' call
      if (!($this.d14_1 < $this.c14_1.length)) {
        var message_0 = 'unterminated escape';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var _unary__edvuaz_0 = $this.d14_1;
      $this.d14_1 = _unary__edvuaz_0 + 1 | 0;
      var e = charCodeAt($this.c14_1, _unary__edvuaz_0);
      if (e === _Char___init__impl__6a9atx(34))
        out.t6(_Char___init__impl__6a9atx(34));
      else if (e === _Char___init__impl__6a9atx(92))
        out.t6(_Char___init__impl__6a9atx(92));
      else if (e === _Char___init__impl__6a9atx(47))
        out.t6(_Char___init__impl__6a9atx(47));
      else if (e === _Char___init__impl__6a9atx(98))
        out.t6(_Char___init__impl__6a9atx(8));
      else if (e === _Char___init__impl__6a9atx(102))
        out.t6(_Char___init__impl__6a9atx(12));
      else if (e === _Char___init__impl__6a9atx(110))
        out.t6(_Char___init__impl__6a9atx(10));
      else if (e === _Char___init__impl__6a9atx(114))
        out.t6(_Char___init__impl__6a9atx(13));
      else if (e === _Char___init__impl__6a9atx(116))
        out.t6(_Char___init__impl__6a9atx(9));
      else if (e === _Char___init__impl__6a9atx(117)) {
        // Inline function 'kotlin.require' call
        if (!(($this.d14_1 + 4 | 0) <= $this.c14_1.length)) {
          var message_1 = 'bad unicode escape at ' + $this.d14_1;
          throw IllegalArgumentException_init_$Create$(toString(message_1));
        }
        var tmp1_elvis_lhs = toIntOrNull_0(substring($this.c14_1, $this.d14_1, $this.d14_1 + 4 | 0), 16);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          throw IllegalArgumentException_init_$Create$('bad unicode escape at ' + $this.d14_1);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var code = tmp;
        out.t6(numberToChar(code));
        $this.d14_1 = $this.d14_1 + 4 | 0;
      } else
        throw IllegalArgumentException_init_$Create$("bad escape '\\" + toString_1(e) + "' at " + $this.d14_1);
    } else
      out.t6(c);
  }
}
function number_0($this) {
  var start = $this.d14_1;
  var tmp = peek($this);
  if (equals(tmp == null ? null : new Char(tmp), new Char(_Char___init__impl__6a9atx(45)))) {
    $this.d14_1 = $this.d14_1 + 1 | 0;
  }
  while ($this.d14_1 < $this.c14_1.length && (isDigit(charCodeAt($this.c14_1, $this.d14_1)) || contains_0('.eE+-', charCodeAt($this.c14_1, $this.d14_1)))) {
    $this.d14_1 = $this.d14_1 + 1 | 0;
  }
  var token = substring($this.c14_1, start, $this.d14_1);
  var tmp0_elvis_lhs = toDoubleOrNull(token);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("bad number '" + token + "' at " + start);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function literal($this, word, value) {
  // Inline function 'kotlin.require' call
  if (!startsWith_0($this.c14_1, word, $this.d14_1)) {
    var message = 'unexpected token at ' + $this.d14_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  $this.d14_1 = $this.d14_1 + word.length | 0;
  return value;
}
function peek($this) {
  return getOrNull($this.c14_1, $this.d14_1);
}
function expect($this, c) {
  var tmp = peek($this);
  // Inline function 'kotlin.require' call
  if (!equals(tmp == null ? null : new Char(tmp), new Char(c))) {
    var message = "expected '" + toString_1(c) + "' at " + $this.d14_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  $this.d14_1 = $this.d14_1 + 1 | 0;
}
function write($this, out, value) {
  if (value == null)
    out.s6('null');
  else {
    if (typeof value === 'boolean')
      out.k8(value);
    else {
      if (typeof value === 'number')
        out.l8(value);
      else {
        if (value instanceof Long)
          out.m8(value);
        else {
          if (typeof value === 'number')
            out.s6(number_1($this, value));
          else {
            if (typeof value === 'number')
              out.s6(number_1($this, value));
            else {
              if (typeof value === 'string') {
                string_0($this, out, value);
              } else {
                if (isInterface(value, KtMap)) {
                  out.t6(_Char___init__impl__6a9atx(123));
                  var first = true;
                  // Inline function 'kotlin.collections.iterator' call
                  var _iterator__ex2g4s = value.w1().j();
                  while (_iterator__ex2g4s.k()) {
                    var _destruct__k2r9zo = _iterator__ex2g4s.l();
                    // Inline function 'kotlin.collections.component1' call
                    var key = _destruct__k2r9zo.p1();
                    // Inline function 'kotlin.collections.component2' call
                    var item = _destruct__k2r9zo.q1();
                    if (!first) {
                      out.t6(_Char___init__impl__6a9atx(44));
                    }
                    first = false;
                    string_0($this, out, toString_0(key));
                    out.t6(_Char___init__impl__6a9atx(58));
                    write($this, out, item);
                  }
                  out.t6(_Char___init__impl__6a9atx(125));
                } else {
                  if (isInterface(value, Iterable)) {
                    out.t6(_Char___init__impl__6a9atx(91));
                    var first_0 = true;
                    var _iterator__ex2g4s_0 = value.j();
                    while (_iterator__ex2g4s_0.k()) {
                      var item_0 = _iterator__ex2g4s_0.l();
                      if (!first_0) {
                        out.t6(_Char___init__impl__6a9atx(44));
                      }
                      first_0 = false;
                      write($this, out, item_0);
                    }
                    out.t6(_Char___init__impl__6a9atx(93));
                  } else {
                    throw IllegalArgumentException_init_$Create$('cannot write ' + getKClassFromExpression(value).e7() + ' as JSON');
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function number_1($this, value) {
  // Inline function 'kotlin.require' call
  if (!(!isNaN_0(value) && !isInfinite(value))) {
    var message = 'JSON has no NaN or infinity';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  // Inline function 'kotlin.math.floor' call
  if (value === Math.floor(value)) {
    // Inline function 'kotlin.math.abs' call
    tmp = Math.abs(value) < 1.0E15;
  } else {
    tmp = false;
  }
  if (tmp)
    return numberToLong(value).toString();
  return value.toString();
}
function string_0($this, out, value) {
  out.t6(_Char___init__impl__6a9atx(34));
  var inductionVariable = 0;
  var last = value.length;
  while (inductionVariable < last) {
    var c = charCodeAt(value, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (c === _Char___init__impl__6a9atx(34))
      out.s6('\\"');
    else if (c === _Char___init__impl__6a9atx(92))
      out.s6('\\\\');
    else if (c === _Char___init__impl__6a9atx(10))
      out.s6('\\n');
    else if (c === _Char___init__impl__6a9atx(13))
      out.s6('\\r');
    else if (c === _Char___init__impl__6a9atx(9))
      out.s6('\\t');
    else if (c === _Char___init__impl__6a9atx(8))
      out.s6('\\b');
    else if (c === _Char___init__impl__6a9atx(12))
      out.s6('\\f');
    else if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(32)) < 0) {
      var tmp = out.s6('\\u');
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      tmp.s6(padStart(toString_2(tmp$ret$0, 16), 4, _Char___init__impl__6a9atx(48)));
    } else
      out.t6(c);
  }
  out.t6(_Char___init__impl__6a9atx(34));
}
function Parser(text) {
  this.c14_1 = text;
  this.d14_1 = 0;
}
protoOf(Parser).e14 = function () {
  while (this.d14_1 < this.c14_1.length && contains_0(' \t\r\n', charCodeAt(this.c14_1, this.d14_1))) {
    this.d14_1 = this.d14_1 + 1 | 0;
  }
};
protoOf(Parser).f14 = function () {
  this.e14();
  // Inline function 'kotlin.require' call
  if (!(this.d14_1 < this.c14_1.length)) {
    var message = 'unexpected end of JSON';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var c = charCodeAt(this.c14_1, this.d14_1);
  var tmp;
  if (c === _Char___init__impl__6a9atx(123)) {
    tmp = obj(this);
  } else if (c === _Char___init__impl__6a9atx(91)) {
    tmp = array(this);
  } else if (c === _Char___init__impl__6a9atx(34)) {
    tmp = string(this);
  } else if (c === _Char___init__impl__6a9atx(116)) {
    tmp = literal(this, 'true', true);
  } else if (c === _Char___init__impl__6a9atx(102)) {
    tmp = literal(this, 'false', false);
  } else if (c === _Char___init__impl__6a9atx(110)) {
    tmp = literal(this, 'null', null);
  } else {
    var tmp_0;
    if (c === _Char___init__impl__6a9atx(45) || (_Char___init__impl__6a9atx(48) <= c ? c <= _Char___init__impl__6a9atx(57) : false)) {
      tmp_0 = number_0(this);
    } else {
      throw IllegalArgumentException_init_$Create$("unexpected '" + toString_1(c) + "' at " + this.d14_1);
    }
    tmp = tmp_0;
  }
  return tmp;
};
function Json() {
}
protoOf(Json).ng = function (text) {
  var parser = new Parser(text);
  var value = parser.f14();
  parser.e14();
  // Inline function 'kotlin.require' call
  if (!(parser.d14_1 === text.length)) {
    var message = "unexpected '" + toString_1(charCodeAt(text, parser.d14_1)) + "' at " + parser.d14_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return value;
};
protoOf(Json).sg = function (value) {
  // Inline function 'kotlin.also' call
  var this_0 = StringBuilder_init_$Create$();
  write(Json_instance, this_0, value);
  return this_0.toString();
};
var Json_instance;
function Json_getInstance() {
  return Json_instance;
}
function JsonRead() {
}
protoOf(JsonRead).og = function (value, what) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(what + ' must be a JSON object');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(JsonRead).g14 = function (value, what, $super) {
  what = what === VOID ? 'value' : what;
  return $super === VOID ? this.og(value, what) : $super.og.call(this, value, what);
};
protoOf(JsonRead).rr = function (value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtList) : false) ? value : null;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(JsonRead).br = function (map, key) {
  var tmp = map.t1(key);
  return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
};
protoOf(JsonRead).cr = function (map, key) {
  var tmp = map.t1(key);
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  return tmp0_safe_receiver == null ? null : numberToDouble(tmp0_safe_receiver);
};
protoOf(JsonRead).qr = function (map, key) {
  var tmp = map.t1(key);
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : numberToDouble(tmp0_safe_receiver);
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = numberToInt(round(tmp1_safe_receiver));
  }
  return tmp_0;
};
protoOf(JsonRead).tr = function (map, key) {
  var tmp = map.t1(key);
  return (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
};
protoOf(JsonRead).h14 = function (map, key) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = this.rr(map.t1(key));
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!(element == null) ? typeof element === 'string' : false) {
      destination.f(element);
    }
  }
  return destination;
};
protoOf(JsonRead).i14 = function (map, key) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = this.rr(map.t1(key));
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (isNumber(element)) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$4 = numberToDouble(item);
    destination_0.f(tmp$ret$4);
  }
  return destination_0;
};
protoOf(JsonRead).sr = function (map, key) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.i14(map, key);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = numberToInt(round(item));
    destination.f(tmp$ret$2);
  }
  return destination;
};
var JsonRead_instance;
function JsonRead_getInstance() {
  return JsonRead_instance;
}
var static_init_called_31;
function static_init_31() {
  if (static_init_called_31)
    return Unit_instance;
  static_init_called_31 = true;
  DrinkType_BEER_instance = new DrinkType('BEER', 0, 'Beer (ale, bitter)', 5.0, 3.6, 1.01, 568.0);
  DrinkType_LAGER_instance = new DrinkType('LAGER', 1, 'Lager', 4.5, 3.0, 1.008, 568.0);
  DrinkType_CIDER_instance = new DrinkType('CIDER', 2, 'Cider', 5.0, 4.0, 1.01, 568.0);
  DrinkType_RED_WINE_instance = new DrinkType('RED_WINE', 3, 'Red wine', 13.5, 2.6, 0.993, 175.0);
  DrinkType_WHITE_WINE_instance = new DrinkType('WHITE_WINE', 4, 'White wine', 12.5, 2.6, 0.993, 175.0);
  DrinkType_ROSE_WINE_instance = new DrinkType('ROSE_WINE', 5, 'Ros\xE9 wine', 12.0, 3.8, 0.995, 175.0);
  DrinkType_SPARKLING_WINE_instance = new DrinkType('SPARKLING_WINE', 6, 'Sparkling wine', 12.0, 1.5, 0.995, 125.0);
  DrinkType_SPIRITS_instance = new DrinkType('SPIRITS', 7, 'Spirits', 40.0, 0.0, 0.948, 25.0);
  DrinkType_SPIRIT_AND_MIXER_instance = new DrinkType('SPIRIT_AND_MIXER', 8, 'Spirit and mixer (e.g. gin and tonic)', 10.0, 6.6, 1.02, 200.0);
  DrinkType_COCKTAIL_instance = new DrinkType('COCKTAIL', 9, 'Cocktail (sweetened)', 12.0, 12.0, 1.04, 200.0);
}
var DrinkType_BEER_instance;
var DrinkType_LAGER_instance;
var DrinkType_CIDER_instance;
var DrinkType_RED_WINE_instance;
var DrinkType_WHITE_WINE_instance;
var DrinkType_ROSE_WINE_instance;
var DrinkType_SPARKLING_WINE_instance;
var DrinkType_SPIRITS_instance;
var DrinkType_SPIRIT_AND_MIXER_instance;
var DrinkType_COCKTAIL_instance;
function values_23() {
  static_init_31();
  return [DrinkType_BEER_getInstance(), DrinkType_LAGER_getInstance(), DrinkType_CIDER_getInstance(), DrinkType_RED_WINE_getInstance(), DrinkType_WHITE_WINE_getInstance(), DrinkType_ROSE_WINE_getInstance(), DrinkType_SPARKLING_WINE_getInstance(), DrinkType_SPIRITS_getInstance(), DrinkType_SPIRIT_AND_MIXER_getInstance(), DrinkType_COCKTAIL_getInstance()];
}
function valueOf_9(value) {
  static_init_31();
  switch (value) {
    case 'BEER':
      return DrinkType_BEER_getInstance();
    case 'LAGER':
      return DrinkType_LAGER_getInstance();
    case 'CIDER':
      return DrinkType_CIDER_getInstance();
    case 'RED_WINE':
      return DrinkType_RED_WINE_getInstance();
    case 'WHITE_WINE':
      return DrinkType_WHITE_WINE_getInstance();
    case 'ROSE_WINE':
      return DrinkType_ROSE_WINE_getInstance();
    case 'SPARKLING_WINE':
      return DrinkType_SPARKLING_WINE_getInstance();
    case 'SPIRITS':
      return DrinkType_SPIRITS_getInstance();
    case 'SPIRIT_AND_MIXER':
      return DrinkType_SPIRIT_AND_MIXER_getInstance();
    case 'COCKTAIL':
      return DrinkType_COCKTAIL_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.nutrients.DrinkType.' + value);
      break;
  }
}
function get_entries_18() {
  static_init_31();
  if ($ENTRIES_18 == null)
    $ENTRIES_18 = enumEntries(values_23());
  return $ENTRIES_18;
}
var $ENTRIES_18;
function DrinkType(name, ordinal, label, abvPct, carbsPer100Ml, densityGPerMl, servingMl) {
  Enum.call(this, name, ordinal);
  this.l14_1 = label;
  this.m14_1 = abvPct;
  this.n14_1 = carbsPer100Ml;
  this.o14_1 = densityGPerMl;
  this.p14_1 = servingMl;
}
function AlcoholEstimate(volumeMl, abvPct, alcoholG, alcoholKcal, carbsG, kcal, ukUnits, grams, per100g) {
  this.q14_1 = volumeMl;
  this.r14_1 = abvPct;
  this.s14_1 = alcoholG;
  this.t14_1 = alcoholKcal;
  this.u14_1 = carbsG;
  this.v14_1 = kcal;
  this.w14_1 = ukUnits;
  this.x14_1 = grams;
  this.y14_1 = per100g;
}
protoOf(AlcoholEstimate).toString = function () {
  return 'AlcoholEstimate(volumeMl=' + this.q14_1 + ', abvPct=' + this.r14_1 + ', alcoholG=' + this.s14_1 + ', alcoholKcal=' + this.t14_1 + ', carbsG=' + this.u14_1 + ', kcal=' + this.v14_1 + ', ukUnits=' + this.w14_1 + ', grams=' + this.x14_1 + ', per100g=' + this.y14_1.toString() + ')';
};
protoOf(AlcoholEstimate).hashCode = function () {
  var result = getNumberHashCode(this.q14_1);
  result = imul(result, 31) + getNumberHashCode(this.r14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.s14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.t14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.u14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.v14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.w14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.x14_1) | 0;
  result = imul(result, 31) + this.y14_1.hashCode() | 0;
  return result;
};
protoOf(AlcoholEstimate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlcoholEstimate))
    return false;
  if (!equals(this.q14_1, other.q14_1))
    return false;
  if (!equals(this.r14_1, other.r14_1))
    return false;
  if (!equals(this.s14_1, other.s14_1))
    return false;
  if (!equals(this.t14_1, other.t14_1))
    return false;
  if (!equals(this.u14_1, other.u14_1))
    return false;
  if (!equals(this.v14_1, other.v14_1))
    return false;
  if (!equals(this.w14_1, other.w14_1))
    return false;
  if (!equals(this.x14_1, other.x14_1))
    return false;
  if (!this.y14_1.equals(other.y14_1))
    return false;
  return true;
};
function Alcohol() {
  this.z14_1 = 0.789;
  this.a15_1 = 7.0;
  this.b15_1 = 10.0;
}
protoOf(Alcohol).c15 = function (volumeMl, abvPct) {
  // Inline function 'kotlin.require' call
  if (!(volumeMl >= 0.0)) {
    var message = 'volumeMl must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(0.0 <= abvPct ? abvPct <= 100.0 : false)) {
    var message_0 = 'abvPct must be 0\u2013100';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  return volumeMl * abvPct / 100.0 * 0.789;
};
protoOf(Alcohol).d15 = function (volumeMl, abvPct, carbsPer100Ml, densityGPerMl) {
  // Inline function 'kotlin.require' call
  if (!(carbsPer100Ml >= 0.0)) {
    var message = 'carbsPer100Ml must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(densityGPerMl > 0.0)) {
    var message_0 = 'densityGPerMl must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var alcohol = this.c15(volumeMl, abvPct);
  var carbs = volumeMl * carbsPer100Ml / 100.0;
  var alcoholKcal = alcohol * 7.0;
  var kcal = alcoholKcal + carbs * 4.0;
  var grams = volumeMl * densityGPerMl;
  var tmp;
  if (grams > 0.0) {
    tmp = new Per100g(kcal / grams * 100.0, 0.0, 0.0, carbs / grams * 100.0, VOID, VOID, VOID, VOID, alcohol / grams * 100.0);
  } else {
    tmp = new Per100g(0.0, 0.0, 0.0, 0.0, VOID, VOID, VOID, VOID, 0.0);
  }
  var per100g = tmp;
  return new AlcoholEstimate(volumeMl, abvPct, alcohol, alcoholKcal, carbs, kcal, volumeMl * abvPct / 100.0 / 10.0, grams, per100g);
};
protoOf(Alcohol).e15 = function (drink, volumeMl, abvPct) {
  return this.d15(volumeMl, abvPct, drink.n14_1, drink.o14_1);
};
var Alcohol_instance;
function Alcohol_getInstance() {
  return Alcohol_instance;
}
function DrinkType_BEER_getInstance() {
  static_init_31();
  return DrinkType_BEER_instance;
}
function DrinkType_LAGER_getInstance() {
  static_init_31();
  return DrinkType_LAGER_instance;
}
function DrinkType_CIDER_getInstance() {
  static_init_31();
  return DrinkType_CIDER_instance;
}
function DrinkType_RED_WINE_getInstance() {
  static_init_31();
  return DrinkType_RED_WINE_instance;
}
function DrinkType_WHITE_WINE_getInstance() {
  static_init_31();
  return DrinkType_WHITE_WINE_instance;
}
function DrinkType_ROSE_WINE_getInstance() {
  static_init_31();
  return DrinkType_ROSE_WINE_instance;
}
function DrinkType_SPARKLING_WINE_getInstance() {
  static_init_31();
  return DrinkType_SPARKLING_WINE_instance;
}
function DrinkType_SPIRITS_getInstance() {
  static_init_31();
  return DrinkType_SPIRITS_instance;
}
function DrinkType_SPIRIT_AND_MIXER_getInstance() {
  static_init_31();
  return DrinkType_SPIRIT_AND_MIXER_instance;
}
function DrinkType_COCKTAIL_getInstance() {
  static_init_31();
  return DrinkType_COCKTAIL_instance;
}
function Companion_6() {
}
protoOf(Companion_6).f15 = function (day, foodKey, name, grams, per100g) {
  return new NutrientEntry(day, foodKey, name, per100g.e13_1 * grams / 100.0, per100g.o13(grams));
};
var Companion_instance_8;
function Companion_getInstance_6() {
  return Companion_instance_8;
}
function NutrientEntry(day, foodKey, name, kcal, amounts) {
  this.g15_1 = day;
  this.h15_1 = foodKey;
  this.i15_1 = name;
  this.j15_1 = kcal;
  this.k15_1 = amounts;
}
protoOf(NutrientEntry).toString = function () {
  return 'NutrientEntry(day=' + this.g15_1 + ', foodKey=' + this.h15_1 + ', name=' + this.i15_1 + ', kcal=' + this.j15_1 + ', amounts=' + toString(this.k15_1) + ')';
};
protoOf(NutrientEntry).hashCode = function () {
  var result = this.g15_1;
  result = imul(result, 31) + getStringHashCode(this.h15_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.i15_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.j15_1) | 0;
  result = imul(result, 31) + hashCode(this.k15_1) | 0;
  return result;
};
protoOf(NutrientEntry).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientEntry))
    return false;
  if (!(this.g15_1 === other.g15_1))
    return false;
  if (!(this.h15_1 === other.h15_1))
    return false;
  if (!(this.i15_1 === other.i15_1))
    return false;
  if (!equals(this.j15_1, other.j15_1))
    return false;
  if (!equals(this.k15_1, other.k15_1))
    return false;
  return true;
};
function Completeness(key, byKcal, byEntries, entries, entriesWithValue) {
  this.l15_1 = key;
  this.m15_1 = byKcal;
  this.n15_1 = byEntries;
  this.o15_1 = entries;
  this.p15_1 = entriesWithValue;
}
protoOf(Completeness).toString = function () {
  return 'Completeness(key=' + this.l15_1 + ', byKcal=' + this.m15_1 + ', byEntries=' + this.n15_1 + ', entries=' + this.o15_1 + ', entriesWithValue=' + this.p15_1 + ')';
};
protoOf(Completeness).hashCode = function () {
  var result = getStringHashCode(this.l15_1);
  result = imul(result, 31) + (this.m15_1 == null ? 0 : getNumberHashCode(this.m15_1)) | 0;
  result = imul(result, 31) + (this.n15_1 == null ? 0 : getNumberHashCode(this.n15_1)) | 0;
  result = imul(result, 31) + this.o15_1 | 0;
  result = imul(result, 31) + this.p15_1 | 0;
  return result;
};
protoOf(Completeness).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Completeness))
    return false;
  if (!(this.l15_1 === other.l15_1))
    return false;
  if (!equals(this.m15_1, other.m15_1))
    return false;
  if (!equals(this.n15_1, other.n15_1))
    return false;
  if (!(this.o15_1 === other.o15_1))
    return false;
  if (!(this.p15_1 === other.p15_1))
    return false;
  return true;
};
function Contributor(foodKey, name, amount, share, entries) {
  this.q15_1 = foodKey;
  this.r15_1 = name;
  this.s15_1 = amount;
  this.t15_1 = share;
  this.u15_1 = entries;
}
protoOf(Contributor).toString = function () {
  return 'Contributor(foodKey=' + this.q15_1 + ', name=' + this.r15_1 + ', amount=' + this.s15_1 + ', share=' + this.t15_1 + ', entries=' + this.u15_1 + ')';
};
protoOf(Contributor).hashCode = function () {
  var result = getStringHashCode(this.q15_1);
  result = imul(result, 31) + getStringHashCode(this.r15_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.s15_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.t15_1) | 0;
  result = imul(result, 31) + this.u15_1 | 0;
  return result;
};
protoOf(Contributor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Contributor))
    return false;
  if (!(this.q15_1 === other.q15_1))
    return false;
  if (!(this.r15_1 === other.r15_1))
    return false;
  if (!equals(this.s15_1, other.s15_1))
    return false;
  if (!equals(this.t15_1, other.t15_1))
    return false;
  if (!(this.u15_1 === other.u15_1))
    return false;
  return true;
};
function DailyNutrient(day, amount, completenessByKcal) {
  this.v15_1 = day;
  this.w15_1 = amount;
  this.x15_1 = completenessByKcal;
}
protoOf(DailyNutrient).toString = function () {
  return 'DailyNutrient(day=' + this.v15_1 + ', amount=' + this.w15_1 + ', completenessByKcal=' + this.x15_1 + ')';
};
protoOf(DailyNutrient).hashCode = function () {
  var result = this.v15_1;
  result = imul(result, 31) + getNumberHashCode(this.w15_1) | 0;
  result = imul(result, 31) + (this.x15_1 == null ? 0 : getNumberHashCode(this.x15_1)) | 0;
  return result;
};
protoOf(DailyNutrient).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DailyNutrient))
    return false;
  if (!(this.v15_1 === other.v15_1))
    return false;
  if (!equals(this.w15_1, other.w15_1))
    return false;
  if (!equals(this.x15_1, other.x15_1))
    return false;
  return true;
};
function NutrientDay(day, amount, completenessByKcal, average7) {
  this.y15_1 = day;
  this.z15_1 = amount;
  this.a16_1 = completenessByKcal;
  this.b16_1 = average7;
}
protoOf(NutrientDay).toString = function () {
  return 'NutrientDay(day=' + this.y15_1 + ', amount=' + this.z15_1 + ', completenessByKcal=' + this.a16_1 + ', average7=' + this.b16_1 + ')';
};
protoOf(NutrientDay).hashCode = function () {
  var result = this.y15_1;
  result = imul(result, 31) + (this.z15_1 == null ? 0 : getNumberHashCode(this.z15_1)) | 0;
  result = imul(result, 31) + (this.a16_1 == null ? 0 : getNumberHashCode(this.a16_1)) | 0;
  result = imul(result, 31) + (this.b16_1 == null ? 0 : getNumberHashCode(this.b16_1)) | 0;
  return result;
};
protoOf(NutrientDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientDay))
    return false;
  if (!(this.y15_1 === other.y15_1))
    return false;
  if (!equals(this.z15_1, other.z15_1))
    return false;
  if (!equals(this.a16_1, other.a16_1))
    return false;
  if (!equals(this.b16_1, other.b16_1))
    return false;
  return true;
};
function WeeklyNutrient(weekStart, dailyAverage, days) {
  this.c16_1 = weekStart;
  this.d16_1 = dailyAverage;
  this.e16_1 = days;
}
protoOf(WeeklyNutrient).toString = function () {
  return 'WeeklyNutrient(weekStart=' + this.c16_1 + ', dailyAverage=' + this.d16_1 + ', days=' + this.e16_1 + ')';
};
protoOf(WeeklyNutrient).hashCode = function () {
  var result = this.c16_1;
  result = imul(result, 31) + getNumberHashCode(this.d16_1) | 0;
  result = imul(result, 31) + this.e16_1 | 0;
  return result;
};
protoOf(WeeklyNutrient).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyNutrient))
    return false;
  if (!(this.c16_1 === other.c16_1))
    return false;
  if (!equals(this.d16_1, other.d16_1))
    return false;
  if (!(this.e16_1 === other.e16_1))
    return false;
  return true;
};
function NutrientAverages(key, dailyAverage, days, weekly) {
  this.f16_1 = key;
  this.g16_1 = dailyAverage;
  this.h16_1 = days;
  this.i16_1 = weekly;
}
protoOf(NutrientAverages).toString = function () {
  return 'NutrientAverages(key=' + this.f16_1 + ', dailyAverage=' + this.g16_1 + ', days=' + this.h16_1 + ', weekly=' + toString(this.i16_1) + ')';
};
protoOf(NutrientAverages).hashCode = function () {
  var result = getStringHashCode(this.f16_1);
  result = imul(result, 31) + (this.g16_1 == null ? 0 : getNumberHashCode(this.g16_1)) | 0;
  result = imul(result, 31) + this.h16_1 | 0;
  result = imul(result, 31) + hashCode(this.i16_1) | 0;
  return result;
};
protoOf(NutrientAverages).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientAverages))
    return false;
  if (!(this.f16_1 === other.f16_1))
    return false;
  if (!equals(this.g16_1, other.g16_1))
    return false;
  if (!(this.h16_1 === other.h16_1))
    return false;
  if (!equals(this.i16_1, other.i16_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_3(function_0) {
  this.j16_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_3).ea = function (a, b) {
  return this.j16_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).h2 = function () {
  return this.j16_1;
};
protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_4(function_0) {
  this.k16_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_4).ea = function (a, b) {
  return this.k16_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).h2 = function () {
  return this.k16_1;
};
protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_5(function_0) {
  this.l16_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_5).ea = function (a, b) {
  return this.l16_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).h2 = function () {
  return this.l16_1;
};
protoOf(sam$kotlin_Comparator$0_5).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_5).hashCode = function () {
  return hashCode(this.h2());
};
function NutrientAnalysis$topContributors$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.s15_1;
  var tmp$ret$2 = a.s15_1;
  return compareValues(tmp, tmp$ret$2);
}
function NutrientAnalysis$topContributors$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.r15_1;
      var tmp$ret$2 = b.r15_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function NutrientAnalysis$topContributors$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.q15_1;
      var tmp$ret$2 = b.q15_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function NutrientAnalysis$dailyTotals$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.p1();
  var tmp$ret$2 = b.p1();
  return compareValues(tmp, tmp$ret$2);
}
function NutrientAnalysis$averages$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.p1();
  var tmp$ret$2 = b.p1();
  return compareValues(tmp, tmp$ret$2);
}
function NutrientAnalysis() {
  this.m16_1 = 7;
}
protoOf(NutrientAnalysis).n16 = function (entries, key, fromDay, toDay) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsArg = element.g15_1;
    if (fromDay <= containsArg ? containsArg <= toDay : false) {
      destination.f(element);
    }
  }
  var inRange = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = inRange.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = element_0.k15_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).r1(key)) {
      destination_0.f(element_0);
    }
  }
  var known = destination_0;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_1 = inRange.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp = sum;
    sum = tmp + element_1.j15_1;
  }
  var totalKcal = sum;
  var tmp_0;
  if (totalKcal > 0.0) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = known.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      var tmp_1 = sum_0;
      sum_0 = tmp_1 + element_2.j15_1;
    }
    tmp_0 = sum_0 / totalKcal;
  } else {
    tmp_0 = null;
  }
  return new Completeness(key, tmp_0, inRange.m() ? null : known.o() / inRange.o(), inRange.o(), known.o());
};
protoOf(NutrientAnalysis).o16 = function (entries, fromDay, toDay, keys) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(keys, 10));
  var _iterator__ex2g4s = keys.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = NutrientAnalysis_instance.n16(entries, item, fromDay, toDay);
    destination.f(tmp$ret$2);
  }
  return destination;
};
protoOf(NutrientAnalysis).p16 = function (entries, fromDay, toDay, keys, $super) {
  keys = keys === VOID ? Nutrients_getInstance().b17_1 : keys;
  return $super === VOID ? this.o16(entries, fromDay, toDay, keys) : $super.o16.call(this, entries, fromDay, toDay, keys);
};
protoOf(NutrientAnalysis).c17 = function (entries, key, fromDay, toDay, limit) {
  // Inline function 'kotlin.require' call
  if (!(limit > 0)) {
    var message = 'limit must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    var containsArg = element.g15_1;
    if (fromDay <= containsArg ? containsArg <= toDay : false) {
      var tmp0_elvis_lhs = element.k15_1.t1(key);
      tmp = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) > 0.0;
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  var known = destination;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_0 = known.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp_0 = sum;
    sum = tmp_0 + getValue(element_0.k15_1, key);
  }
  var total = sum;
  if (total <= 0.0)
    return emptyList();
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_1 = known.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var key_0 = element_1.h15_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key_0);
    var tmp_1;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key_0, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    var list = tmp_1;
    list.f(element_1);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(destination_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = destination_0.w1().j();
  while (_iterator__ex2g4s_2.k()) {
    var item = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.component1' call
    var foodKey = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.q1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_3 = group.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      var tmp_2 = sum_0;
      sum_0 = tmp_2 + getValue(element_2.k15_1, key);
    }
    var amount = sum_0;
    var tmp$ret$15 = new Contributor(foodKey, first(group).i15_1, amount, amount / total, group.o());
    destination_1.f(tmp$ret$15);
  }
  var tmp_3 = destination_1;
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_4 = NutrientAnalysis$topContributors$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_3(tmp_4);
  var tmp_5 = NutrientAnalysis$topContributors$lambda_0(this_0);
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_1 = new sam$kotlin_Comparator$0_3(tmp_5);
  var tmp_6 = NutrientAnalysis$topContributors$lambda_1(this_1);
  var tmp$ret$22 = new sam$kotlin_Comparator$0_3(tmp_6);
  return take(sortedWith(tmp_3, tmp$ret$22), limit);
};
protoOf(NutrientAnalysis).d17 = function (entries, key, fromDay, toDay) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsArg = element.g15_1;
    if (fromDay <= containsArg ? containsArg <= toDay : false) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key_0 = element_0.g15_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key_0);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key_0, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination_0.w1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = NutrientAnalysis$dailyTotals$lambda;
  var tmp$ret$9 = new sam$kotlin_Comparator$0_4(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$9);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_1 = this_1.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var day = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.q1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = group.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_1 = sum;
      sum = tmp_1 + element_1.j15_1;
    }
    var kcal = sum;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_3 = group.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_2 = element_2.k15_1;
      if ((isInterface(this_2, KtMap) ? this_2 : THROW_CCE()).r1(key)) {
        destination_2.f(element_2);
      }
    }
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_4 = destination_2.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      var tmp_2 = sum_0;
      sum_0 = tmp_2 + element_3.j15_1;
    }
    var knownKcal = sum_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_5 = group.j();
    while (_iterator__ex2g4s_5.k()) {
      var element_4 = _iterator__ex2g4s_5.l();
      var tmp_3 = sum_1;
      var tmp0_elvis_lhs = element_4.k15_1.t1(key);
      sum_1 = tmp_3 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    var tmp$ret$24 = sum_1;
    var tmp$ret$12 = new DailyNutrient(day, tmp$ret$24, kcal > 0.0 ? knownKcal / kcal : null);
    destination_1.f(tmp$ret$12);
  }
  return destination_1;
};
protoOf(NutrientAnalysis).e17 = function (entries, key, fromDay, toDay) {
  // Inline function 'kotlin.require' call
  if (!(toDay >= fromDay)) {
    var message = 'toDay must not be before fromDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = element.k15_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).r1(key)) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$9 = item.g15_1;
    destination_0.f(tmp$ret$9);
  }
  var daysWithValue = toSet(destination_0);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = this.d17(entries, key, fromDay - 6 | 0, toDay);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = tmp0.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_0 = _iterator__ex2g4s_1.l();
    if (daysWithValue.r(element_0.v15_1)) {
      destination_1.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_2 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_2 = destination_1.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    var tmp$ret$15 = element_1.v15_1;
    destination_2.l2(tmp$ret$15, element_1);
  }
  var known = destination_2;
  // Inline function 'kotlin.collections.map' call
  var this_1 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable = this_1.xc_1;
  var last = this_1.yc_1;
  if (inductionVariable <= last)
    do {
      var item_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var day = item_0;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = numberRangeToNumber(day - 6 | 0, day);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = tmp0_0.xc_1;
      var last_0 = tmp0_0.yc_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var it = element_2;
          var tmp0_safe_receiver = known.t1(it);
          var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w15_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_4.f(tmp0_safe_receiver_0);
          }
        }
         while (!(element_2 === last_0));
      var window_0 = destination_4;
      var tmp0_safe_receiver_1 = known.t1(day);
      var tmp = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.w15_1;
      var tmp1_safe_receiver = known.t1(day);
      var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x15_1;
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!window_0.m()) {
        tmp_1 = window_0;
      } else {
        tmp_1 = null;
      }
      var tmp2_safe_receiver = tmp_1;
      var tmp$ret$18 = new NutrientDay(day, tmp, tmp_0, tmp2_safe_receiver == null ? null : average(tmp2_safe_receiver));
      destination_3.f(tmp$ret$18);
    }
     while (!(item_0 === last));
  return destination_3;
};
protoOf(NutrientAnalysis).f17 = function (entries, key, fromDay, toDay) {
  var daily = this.d17(entries, key, fromDay, toDay);
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = daily.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key_0 = EpochDays_getInstance().ge(element.v15_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.t1(key_0);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.l2(key_0, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination.w1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = NutrientAnalysis$averages$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_5(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$6);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var start = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var days = item.q1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = days.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var tmp_1 = sum;
      sum = tmp_1 + element_0.w15_1;
    }
    var tmp$ret$12 = sum;
    var tmp$ret$9 = new WeeklyNutrient(start, tmp$ret$12 / days.o(), days.o());
    destination_0.f(tmp$ret$9);
  }
  var weekly = destination_0;
  var tmp_2;
  if (daily.m()) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = daily.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_3 = sum_0;
      sum_0 = tmp_3 + element_1.w15_1;
    }
    tmp_2 = sum_0 / daily.o();
  }
  return new NutrientAverages(key, tmp_2, daily.o(), weekly);
};
var NutrientAnalysis_instance;
function NutrientAnalysis_getInstance() {
  return NutrientAnalysis_instance;
}
function FocusDay(day, amount, average7, goal, status) {
  this.g17_1 = day;
  this.h17_1 = amount;
  this.i17_1 = average7;
  this.j17_1 = goal;
  this.k17_1 = status;
}
protoOf(FocusDay).toString = function () {
  return 'FocusDay(day=' + this.g17_1 + ', amount=' + this.h17_1 + ', average7=' + this.i17_1 + ', goal=' + toString_0(this.j17_1) + ', status=' + this.k17_1.toString() + ')';
};
protoOf(FocusDay).hashCode = function () {
  var result = this.g17_1;
  result = imul(result, 31) + (this.h17_1 == null ? 0 : getNumberHashCode(this.h17_1)) | 0;
  result = imul(result, 31) + (this.i17_1 == null ? 0 : getNumberHashCode(this.i17_1)) | 0;
  result = imul(result, 31) + (this.j17_1 == null ? 0 : this.j17_1.hashCode()) | 0;
  result = imul(result, 31) + this.k17_1.hashCode() | 0;
  return result;
};
protoOf(FocusDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FocusDay))
    return false;
  if (!(this.g17_1 === other.g17_1))
    return false;
  if (!equals(this.h17_1, other.h17_1))
    return false;
  if (!equals(this.i17_1, other.i17_1))
    return false;
  if (!equals(this.j17_1, other.j17_1))
    return false;
  if (!this.k17_1.equals(other.k17_1))
    return false;
  return true;
};
function Companion_7() {
}
protoOf(Companion_7).l17 = function (entries, key, fromDay, toDay, setting, default_0, bodyWeightKg, energyKcal) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientAnalysis_instance.e17(entries, key, fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var goal = NutrientGoalHistory_instance.m17(item.y15_1, key, setting, default_0, bodyWeightKg, energyKcal);
    var tmp$ret$2 = new FocusDay(item.y15_1, item.z15_1, item.b16_1, goal, NutrientGoalMethods_getInstance().o17(item.z15_1, goal));
    destination.f(tmp$ret$2);
  }
  var days = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = days.j();
  while (_iterator__ex2g4s_0.k()) {
    var element = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = element.h17_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver);
    }
  }
  var known = destination_0;
  var tmp0_elvis_lhs = Nutrients_getInstance().p17(key);
  var tmp = tmp0_elvis_lhs == null ? new NutrientInfo(key, key, '') : tmp0_elvis_lhs;
  // Inline function 'kotlin.takeIf' call
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!known.m()) {
    tmp_0 = known;
  } else {
    tmp_0 = null;
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_1 = tmp1_safe_receiver == null ? null : average(tmp1_safe_receiver);
  var tmp_2 = known.o();
  var tmp$ret$13;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_3;
    if (isInterface(days, Collection)) {
      tmp_3 = days.m();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$13 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s_1 = days.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      if (element_0.k17_1.equals(GoalStatus_ON_TARGET_getInstance())) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$13 = count;
  }
  return new NutrientFocus(tmp, days, tmp_1, tmp_2, tmp$ret$13, setting, NutrientGoalHistory_instance.q17(key, setting, default_0, bodyWeightKg, energyKcal));
};
var Companion_instance_9;
function Companion_getInstance_7() {
  return Companion_instance_9;
}
function NutrientFocus(info, days, average, loggedDays, goalDays, setting, periods) {
  this.r17_1 = info;
  this.s17_1 = days;
  this.t17_1 = average;
  this.u17_1 = loggedDays;
  this.v17_1 = goalDays;
  this.w17_1 = setting;
  this.x17_1 = periods;
}
protoOf(NutrientFocus).toString = function () {
  return 'NutrientFocus(info=' + this.r17_1.toString() + ', days=' + toString(this.s17_1) + ', average=' + this.t17_1 + ', loggedDays=' + this.u17_1 + ', goalDays=' + this.v17_1 + ', setting=' + toString_0(this.w17_1) + ', periods=' + toString(this.x17_1) + ')';
};
protoOf(NutrientFocus).hashCode = function () {
  var result = this.r17_1.hashCode();
  result = imul(result, 31) + hashCode(this.s17_1) | 0;
  result = imul(result, 31) + (this.t17_1 == null ? 0 : getNumberHashCode(this.t17_1)) | 0;
  result = imul(result, 31) + this.u17_1 | 0;
  result = imul(result, 31) + this.v17_1 | 0;
  result = imul(result, 31) + (this.w17_1 == null ? 0 : this.w17_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.x17_1) | 0;
  return result;
};
protoOf(NutrientFocus).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientFocus))
    return false;
  if (!this.r17_1.equals(other.r17_1))
    return false;
  if (!equals(this.s17_1, other.s17_1))
    return false;
  if (!equals(this.t17_1, other.t17_1))
    return false;
  if (!(this.u17_1 === other.u17_1))
    return false;
  if (!(this.v17_1 === other.v17_1))
    return false;
  if (!equals(this.w17_1, other.w17_1))
    return false;
  if (!equals(this.x17_1, other.x17_1))
    return false;
  return true;
};
var static_init_called_32;
function static_init_32() {
  if (static_init_called_32)
    return Unit_instance;
  static_init_called_32 = true;
  GoalMethod_FIXED_instance = new GoalMethod('FIXED', 0, 'fixed', 'Fixed amount');
  GoalMethod_PER_KG_instance = new GoalMethod('PER_KG', 1, 'perKg', 'Per kg of body weight');
  GoalMethod_PER_1000_KCAL_instance = new GoalMethod('PER_1000_KCAL', 2, 'perKcal', 'Per 1,000 kcal of the calorie target');
  GoalMethod_PCT_ENERGY_instance = new GoalMethod('PCT_ENERGY', 3, 'pctEnergy', '% of the calorie target');
  if (Companion_instance_10 == null) {
    Companion_instance_0;
    new Companion_8();
  }
}
var GoalMethod_FIXED_instance;
var GoalMethod_PER_KG_instance;
var GoalMethod_PER_1000_KCAL_instance;
var GoalMethod_PCT_ENERGY_instance;
function Companion_8() {
}
protoOf(Companion_8).y17 = function (value) {
  var tmp0 = get_entries_19();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.b18_1 === value) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_10;
function Companion_getInstance_8() {
  return Companion_instance_10;
}
function values_24() {
  static_init_32();
  return [GoalMethod_FIXED_getInstance(), GoalMethod_PER_KG_getInstance(), GoalMethod_PER_1000_KCAL_getInstance(), GoalMethod_PCT_ENERGY_getInstance()];
}
function get_entries_19() {
  static_init_32();
  if ($ENTRIES_19 == null)
    $ENTRIES_19 = enumEntries(values_24());
  return $ENTRIES_19;
}
var $ENTRIES_19;
function GoalMethod(name, ordinal, json, label) {
  Enum.call(this, name, ordinal);
  this.b18_1 = json;
  this.c18_1 = label;
}
var static_init_called_33;
function static_init_33() {
  if (static_init_called_33)
    return Unit_instance;
  static_init_called_33 = true;
  GoalStatus_UNKNOWN_instance = new GoalStatus('UNKNOWN', 0);
  GoalStatus_BELOW_FLOOR_instance = new GoalStatus('BELOW_FLOOR', 1);
  GoalStatus_BELOW_TARGET_instance = new GoalStatus('BELOW_TARGET', 2);
  GoalStatus_ON_TARGET_instance = new GoalStatus('ON_TARGET', 3);
  GoalStatus_ABOVE_CEILING_instance = new GoalStatus('ABOVE_CEILING', 4);
}
var GoalStatus_UNKNOWN_instance;
var GoalStatus_BELOW_FLOOR_instance;
var GoalStatus_BELOW_TARGET_instance;
var GoalStatus_ON_TARGET_instance;
var GoalStatus_ABOVE_CEILING_instance;
function GoalStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function NutrientGoalSetting(floor, target, ceiling, method, since) {
  method = method === VOID ? GoalMethod_FIXED_getInstance() : method;
  since = since === VOID ? null : since;
  this.d18_1 = floor;
  this.e18_1 = target;
  this.f18_1 = ceiling;
  this.g18_1 = method;
  this.h18_1 = since;
}
protoOf(NutrientGoalSetting).i18 = function () {
  var tmp0_safe_receiver = this.h18_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = EpochDays_getInstance().de(tmp0_safe_receiver);
  }
  return tmp;
};
protoOf(NutrientGoalSetting).j18 = function (key, bodyWeightKg, energyKcal) {
  var tmp0_elvis_lhs = NutrientGoalMethods_getInstance().k18(key, this.g18_1, bodyWeightKg, energyKcal);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var factor = tmp;
  var tmp1_safe_receiver = this.d18_1;
  var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver * factor;
  var tmp2_safe_receiver = this.e18_1;
  var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver * factor;
  var tmp3_safe_receiver = this.f18_1;
  return new NutrientGoal(tmp_0, tmp_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver * factor);
};
protoOf(NutrientGoalSetting).toString = function () {
  return 'NutrientGoalSetting(floor=' + this.d18_1 + ', target=' + this.e18_1 + ', ceiling=' + this.f18_1 + ', method=' + this.g18_1.toString() + ', since=' + this.h18_1 + ')';
};
protoOf(NutrientGoalSetting).hashCode = function () {
  var result = this.d18_1 == null ? 0 : getNumberHashCode(this.d18_1);
  result = imul(result, 31) + (this.e18_1 == null ? 0 : getNumberHashCode(this.e18_1)) | 0;
  result = imul(result, 31) + (this.f18_1 == null ? 0 : getNumberHashCode(this.f18_1)) | 0;
  result = imul(result, 31) + this.g18_1.hashCode() | 0;
  result = imul(result, 31) + (this.h18_1 == null ? 0 : getStringHashCode(this.h18_1)) | 0;
  return result;
};
protoOf(NutrientGoalSetting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoalSetting))
    return false;
  if (!equals(this.d18_1, other.d18_1))
    return false;
  if (!equals(this.e18_1, other.e18_1))
    return false;
  if (!equals(this.f18_1, other.f18_1))
    return false;
  if (!this.g18_1.equals(other.g18_1))
    return false;
  if (!(this.h18_1 == other.h18_1))
    return false;
  return true;
};
function NutrientGoalMethods() {
  NutrientGoalMethods_instance = this;
  this.n17_1 = mapOf_0([to('protein', 4.0), to('carbs', 4.0), to('sugar', 4.0), to('fat', 9.0), to('satFat', 9.0), to('monoFat', 9.0), to('polyFat', 9.0), to('transFat', 9.0), to('alcohol', 7.0)]);
}
protoOf(NutrientGoalMethods).l18 = function (key) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_entries_19();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    switch (element.y1_1) {
      case 3:
        // Inline function 'kotlin.collections.contains' call

        // Inline function 'kotlin.collections.containsKey' call

        var this_0 = NutrientGoalMethods_getInstance().n17_1;
        tmp = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).r1(key);
        break;
      case 2:
        tmp = !(key === 'kcal');
        break;
      default:
        tmp = true;
        break;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  return destination;
};
protoOf(NutrientGoalMethods).k18 = function (key, method, bodyWeightKg, energyKcal) {
  if (!this.l18(key).r(method))
    return null;
  var tmp;
  if (bodyWeightKg == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (bodyWeightKg > 0.0 && isFinite(bodyWeightKg)) {
      tmp_0 = bodyWeightKg;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var weight = tmp;
  var tmp_1;
  if (energyKcal == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (energyKcal > 0.0 && isFinite(energyKcal)) {
      tmp_2 = energyKcal;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var energy = tmp_1;
  var tmp_3;
  switch (method.y1_1) {
    case 0:
      tmp_3 = 1.0;
      break;
    case 1:
      tmp_3 = weight;
      break;
    case 2:
      tmp_3 = energy == null ? null : energy / 1000.0;
      break;
    case 3:
      var tmp_4;
      if (energy == null) {
        tmp_4 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_4 = energy / 100.0 / getValue(NutrientGoalMethods_getInstance().n17_1, key);
      }

      tmp_3 = tmp_4;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_3;
};
protoOf(NutrientGoalMethods).o17 = function (amount, goal) {
  if (amount == null || goal == null)
    return GoalStatus_UNKNOWN_getInstance();
  var floor = goal.hb();
  var target = goal.ib();
  var ceiling = goal.p18();
  return !(ceiling == null) && amount > ceiling ? GoalStatus_ABOVE_CEILING_getInstance() : !(floor == null) && amount < floor ? GoalStatus_BELOW_FLOOR_getInstance() : !(target == null) && amount < target ? GoalStatus_BELOW_TARGET_getInstance() : floor == null && target == null && ceiling == null ? GoalStatus_UNKNOWN_getInstance() : GoalStatus_ON_TARGET_getInstance();
};
var NutrientGoalMethods_instance;
function NutrientGoalMethods_getInstance() {
  if (NutrientGoalMethods_instance == null)
    new NutrientGoalMethods();
  return NutrientGoalMethods_instance;
}
function NutrientGoalPeriod(fromDay, toDay, goal, custom, method) {
  this.q18_1 = fromDay;
  this.r18_1 = toDay;
  this.s18_1 = goal;
  this.t18_1 = custom;
  this.u18_1 = method;
}
protoOf(NutrientGoalPeriod).toString = function () {
  return 'NutrientGoalPeriod(fromDay=' + this.q18_1 + ', toDay=' + this.r18_1 + ', goal=' + toString_0(this.s18_1) + ', custom=' + this.t18_1 + ', method=' + this.u18_1.toString() + ')';
};
protoOf(NutrientGoalPeriod).hashCode = function () {
  var result = this.q18_1 == null ? 0 : this.q18_1;
  result = imul(result, 31) + (this.r18_1 == null ? 0 : this.r18_1) | 0;
  result = imul(result, 31) + (this.s18_1 == null ? 0 : this.s18_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t18_1) | 0;
  result = imul(result, 31) + this.u18_1.hashCode() | 0;
  return result;
};
protoOf(NutrientGoalPeriod).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoalPeriod))
    return false;
  if (!(this.q18_1 == other.q18_1))
    return false;
  if (!(this.r18_1 == other.r18_1))
    return false;
  if (!equals(this.s18_1, other.s18_1))
    return false;
  if (!(this.t18_1 === other.t18_1))
    return false;
  if (!this.u18_1.equals(other.u18_1))
    return false;
  return true;
};
function NutrientGoalChange(key, name, unit, setting) {
  this.v18_1 = key;
  this.w18_1 = name;
  this.x18_1 = unit;
  this.y18_1 = setting;
}
protoOf(NutrientGoalChange).toString = function () {
  return 'NutrientGoalChange(key=' + this.v18_1 + ', name=' + this.w18_1 + ', unit=' + this.x18_1 + ', setting=' + this.y18_1.toString() + ')';
};
protoOf(NutrientGoalChange).hashCode = function () {
  var result = getStringHashCode(this.v18_1);
  result = imul(result, 31) + getStringHashCode(this.w18_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.x18_1) | 0;
  result = imul(result, 31) + this.y18_1.hashCode() | 0;
  return result;
};
protoOf(NutrientGoalChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoalChange))
    return false;
  if (!(this.v18_1 === other.v18_1))
    return false;
  if (!(this.w18_1 === other.w18_1))
    return false;
  if (!(this.x18_1 === other.x18_1))
    return false;
  if (!this.y18_1.equals(other.y18_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_6(function_0) {
  this.z18_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_6).ea = function (a, b) {
  return this.z18_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).h2 = function () {
  return this.z18_1;
};
protoOf(sam$kotlin_Comparator$0_6).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_6).hashCode = function () {
  return hashCode(this.h2());
};
function NutrientGoalHistory$changes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_elvis_lhs = b.y18_1.i18();
  var tmp = tmp0_elvis_lhs == null ? -2147483648 : tmp0_elvis_lhs;
  var tmp0_elvis_lhs_0 = a.y18_1.i18();
  var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? -2147483648 : tmp0_elvis_lhs_0;
  return compareValues(tmp, tmp$ret$2);
}
function NutrientGoalHistory$changes$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.w18_1;
      var tmp$ret$2 = b.w18_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function NutrientGoalHistory() {
}
protoOf(NutrientGoalHistory).m17 = function (day, key, setting, default_0, bodyWeightKg, energyKcal) {
  var since = setting == null ? null : setting.i18();
  return !(setting == null) && (since == null || day >= since) ? setting.j18(key, bodyWeightKg, energyKcal) : default_0;
};
protoOf(NutrientGoalHistory).q17 = function (key, setting, default_0, bodyWeightKg, energyKcal) {
  if (setting == null)
    return listOf_0(new NutrientGoalPeriod(null, null, default_0, false, GoalMethod_FIXED_getInstance()));
  var custom = new NutrientGoalPeriod(setting.i18(), null, setting.j18(key, bodyWeightKg, energyKcal), true, setting.g18_1);
  var tmp0_elvis_lhs = setting.i18();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return listOf_0(custom);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var since = tmp;
  return listOf([new NutrientGoalPeriod(null, since - 1 | 0, default_0, false, GoalMethod_FIXED_getInstance()), custom]);
};
protoOf(NutrientGoalHistory).a19 = function (settings) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(settings.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = settings.w1().j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var setting = item.q1();
    var info = Nutrients_getInstance().p17(key);
    var tmp1_elvis_lhs = info == null ? null : info.c19_1;
    var tmp = tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = info == null ? null : info.d19_1;
    var tmp$ret$3 = new NutrientGoalChange(key, tmp, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs, setting);
    destination.f(tmp$ret$3);
  }
  var tmp_0 = destination;
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_1 = NutrientGoalHistory$changes$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_6(tmp_1);
  var tmp_2 = NutrientGoalHistory$changes$lambda_0(this_0);
  var tmp$ret$7 = new sam$kotlin_Comparator$0_6(tmp_2);
  return sortedWith(tmp_0, tmp$ret$7);
};
var NutrientGoalHistory_instance;
function NutrientGoalHistory_getInstance() {
  return NutrientGoalHistory_instance;
}
function read$amount(map, name) {
  var tmp0_safe_receiver = JsonRead_instance.cr(map, name);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (isFinite(tmp0_safe_receiver) && tmp0_safe_receiver >= 0.0) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function NutrientGoalJson() {
}
protoOf(NutrientGoalJson).e19 = function (nutrientsJson) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = JsonRead_instance.g14(Json_instance.ng(nutrientsJson));
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_safe_receiver = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t1('goals');
  var tmp1_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return emptyMap();
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var goals = tmp_2;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = goals.w1();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$9;
    $l$block_1: {
      // Inline function 'kotlin.collections.component1' call
      var key = element.p1();
      // Inline function 'kotlin.collections.component2' call
      var value_0 = element.q1();
      var tmp0_elvis_lhs = (!(value_0 == null) ? isInterface(value_0, KtMap) : false) ? value_0 : null;
      var tmp_3;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$9 = null;
        break $l$block_1;
      } else {
        tmp_3 = tmp0_elvis_lhs;
      }
      var map = tmp_3;
      if (!(!(key == null) ? typeof key === 'string' : false)) {
        tmp$ret$9 = null;
        break $l$block_1;
      }
      var tmp_4;
      if (map.t1('method') == null) {
        tmp_4 = GoalMethod_FIXED_getInstance();
      } else {
        var tmp_5 = Companion_instance_10;
        var tmp_6 = map.t1('method');
        var tmp1_elvis_lhs_0 = tmp_5.y17((!(tmp_6 == null) ? typeof tmp_6 === 'string' : false) ? tmp_6 : null);
        var tmp_7;
        if (tmp1_elvis_lhs_0 == null) {
          tmp$ret$9 = null;
          break $l$block_1;
        } else {
          tmp_7 = tmp1_elvis_lhs_0;
        }
        tmp_4 = tmp_7;
      }
      var method = tmp_4;
      var tmp2_safe_receiver = JsonRead_instance.br(map, 'since');
      var tmp_8;
      if (tmp2_safe_receiver == null) {
        tmp_8 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_9;
        if (!(EpochDays_getInstance().de(tmp2_safe_receiver) == null)) {
          tmp_9 = tmp2_safe_receiver;
        } else {
          tmp_9 = null;
        }
        tmp_8 = tmp_9;
      }
      var since = tmp_8;
      tmp$ret$9 = to(key, new NutrientGoalSetting(read$amount(map, 'floor'), read$amount(map, 'target'), read$amount(map, 'ceiling'), method, since));
    }
    var tmp0_safe_receiver_0 = tmp$ret$9;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_0);
    }
  }
  return toMap(destination);
};
protoOf(NutrientGoalJson).f19 = function (nutrientsJson, key, setting) {
  var tmp;
  if (nutrientsJson == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(nutrientsJson)) {
      tmp_0 = nutrientsJson;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_2;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.g14(Json_instance.ng(tmp1_safe_receiver));
      tmp_2 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_2;
    tmp_1 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp2_elvis_lhs = tmp_1;
  var data = tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs;
  var tmp_4 = data.t1('goals');
  var tmp3_elvis_lhs = (!(tmp_4 == null) ? isInterface(tmp_4, KtMap) : false) ? tmp_4 : null;
  var goals = LinkedHashMap_init_$Create$_0(tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs);
  if (setting == null) {
    goals.i4(key);
  } else {
    var tmp_5 = goals.t1(key);
    var tmp4_elvis_lhs = (!(tmp_5 == null) ? isInterface(tmp_5, KtMap) : false) ? tmp_5 : null;
    var previous = tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs;
    var goal = LinkedHashMap_init_$Create$_0(previous);
    // Inline function 'kotlin.collections.set' call
    var value_0 = setting.d18_1;
    goal.l2('floor', value_0);
    // Inline function 'kotlin.collections.set' call
    var value_1 = setting.e18_1;
    goal.l2('target', value_1);
    // Inline function 'kotlin.collections.set' call
    var value_2 = setting.f18_1;
    goal.l2('ceiling', value_2);
    if (setting.g18_1.equals(GoalMethod_FIXED_getInstance()))
      goal.i4('method');
    else {
      // Inline function 'kotlin.collections.set' call
      var value_3 = setting.g18_1.b18_1;
      goal.l2('method', value_3);
    }
    if (setting.h18_1 == null)
      goal.i4('since');
    else {
      // Inline function 'kotlin.collections.set' call
      var value_4 = setting.h18_1;
      goal.l2('since', value_4);
    }
    // Inline function 'kotlin.collections.set' call
    goals.l2(key, goal);
  }
  var out = LinkedHashMap_init_$Create$_0(data);
  if (out.t1('pinned') == null) {
    // Inline function 'kotlin.collections.set' call
    var value_5 = emptyList();
    out.l2('pinned', value_5);
  }
  // Inline function 'kotlin.collections.set' call
  out.l2('goals', goals);
  return Json_instance.sg(out);
};
var NutrientGoalJson_instance;
function NutrientGoalJson_getInstance() {
  return NutrientGoalJson_instance;
}
function GoalMethod_FIXED_getInstance() {
  static_init_32();
  return GoalMethod_FIXED_instance;
}
function GoalMethod_PER_KG_getInstance() {
  static_init_32();
  return GoalMethod_PER_KG_instance;
}
function GoalMethod_PER_1000_KCAL_getInstance() {
  static_init_32();
  return GoalMethod_PER_1000_KCAL_instance;
}
function GoalMethod_PCT_ENERGY_getInstance() {
  static_init_32();
  return GoalMethod_PCT_ENERGY_instance;
}
function GoalStatus_UNKNOWN_getInstance() {
  static_init_33();
  return GoalStatus_UNKNOWN_instance;
}
function GoalStatus_BELOW_FLOOR_getInstance() {
  static_init_33();
  return GoalStatus_BELOW_FLOOR_instance;
}
function GoalStatus_BELOW_TARGET_getInstance() {
  static_init_33();
  return GoalStatus_BELOW_TARGET_instance;
}
function GoalStatus_ON_TARGET_getInstance() {
  static_init_33();
  return GoalStatus_ON_TARGET_instance;
}
function GoalStatus_ABOVE_CEILING_getInstance() {
  static_init_33();
  return GoalStatus_ABOVE_CEILING_instance;
}
function NutrientJson() {
}
protoOf(NutrientJson).g19 = function (json) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.rr(Json_instance.ng(json));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block_2: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var map = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.qr(map, 'day');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var day = tmp_0;
      var tmp2_safe_receiver = JsonRead_instance.cr(map, 'grams');
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        if (tmp2_safe_receiver > 0.0) {
          tmp_2 = tmp2_safe_receiver;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      }
      var tmp3_elvis_lhs = tmp_1;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var grams = tmp_3;
      var tmp_4 = map.t1('per100g');
      var tmp4_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, KtMap) : false) ? tmp_4 : null;
      var tmp_5;
      if (tmp4_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_5 = NutrientJson_instance.h19(tmp4_safe_receiver);
      }
      var tmp5_elvis_lhs = tmp_5;
      var tmp_6;
      if (tmp5_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp_6 = tmp5_elvis_lhs;
      }
      var per100g = tmp_6;
      var tmp6_elvis_lhs = JsonRead_instance.br(map, 'name');
      var name = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var tmp7_elvis_lhs = JsonRead_instance.br(map, 'foodKey');
      var tmp8_elvis_lhs = tmp7_elvis_lhs == null ? JsonRead_instance.br(map, 'foodId') : tmp7_elvis_lhs;
      var key = tmp8_elvis_lhs == null ? name : tmp8_elvis_lhs;
      tmp$ret$4 = Companion_instance_8.f15(day, key, name, grams, per100g);
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
};
protoOf(NutrientJson).h19 = function (map) {
  var tmp0_safe_receiver = JsonRead_instance.cr(map, 'kcal');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver >= 0.0) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var kcal = tmp_1;
  var tmp2_safe_receiver = JsonRead_instance.cr(map, 'protein');
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    if (tmp2_safe_receiver >= 0.0) {
      tmp_3 = tmp2_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var protein = tmp_4;
  var tmp4_safe_receiver = JsonRead_instance.cr(map, 'fat');
  var tmp_5;
  if (tmp4_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_6;
    if (tmp4_safe_receiver >= 0.0) {
      tmp_6 = tmp4_safe_receiver;
    } else {
      tmp_6 = null;
    }
    tmp_5 = tmp_6;
  }
  var tmp5_elvis_lhs = tmp_5;
  var tmp_7;
  if (tmp5_elvis_lhs == null) {
    return null;
  } else {
    tmp_7 = tmp5_elvis_lhs;
  }
  var fat = tmp_7;
  var tmp6_safe_receiver = JsonRead_instance.cr(map, 'carbs');
  var tmp_8;
  if (tmp6_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_9;
    if (tmp6_safe_receiver >= 0.0) {
      tmp_9 = tmp6_safe_receiver;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var tmp7_elvis_lhs = tmp_8;
  var tmp_10;
  if (tmp7_elvis_lhs == null) {
    return null;
  } else {
    tmp_10 = tmp7_elvis_lhs;
  }
  var carbs = tmp_10;
  var tmp_11 = map.t1('micros');
  var tmp8_safe_receiver = (!(tmp_11 == null) ? isInterface(tmp_11, KtMap) : false) ? tmp_11 : null;
  var tmp_12;
  if (tmp8_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tmp8_safe_receiver.w1().j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      // Inline function 'kotlin.collections.component1' call
      var key = element.p1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.q1();
      var tmp0_safe_receiver_0 = isNumber(value) ? value : null;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : numberToDouble(tmp0_safe_receiver_0);
      var tmp_13;
      if (tmp1_safe_receiver == null) {
        tmp_13 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_13 = to(key, tmp1_safe_receiver);
      }
      var tmp0_safe_receiver_1 = tmp_13;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.f(tmp0_safe_receiver_1);
      }
    }
    tmp_12 = destination;
  }
  var tmp9_safe_receiver = tmp_12;
  var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toMap(tmp9_safe_receiver);
  var micros = tmp10_elvis_lhs == null ? emptyMap() : tmp10_elvis_lhs;
  return new Per100g(kcal, protein, fat, carbs, JsonRead_instance.cr(map, 'fiber'), JsonRead_instance.cr(map, 'sugar'), JsonRead_instance.cr(map, 'satFat'), JsonRead_instance.cr(map, 'sodiumMg'), JsonRead_instance.cr(map, 'alcohol'), micros);
};
var NutrientJson_instance;
function NutrientJson_getInstance() {
  return NutrientJson_instance;
}
function NutrientInfo(key, name, unit) {
  this.b19_1 = key;
  this.c19_1 = name;
  this.d19_1 = unit;
}
protoOf(NutrientInfo).toString = function () {
  return 'NutrientInfo(key=' + this.b19_1 + ', name=' + this.c19_1 + ', unit=' + this.d19_1 + ')';
};
protoOf(NutrientInfo).hashCode = function () {
  var result = getStringHashCode(this.b19_1);
  result = imul(result, 31) + getStringHashCode(this.c19_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.d19_1) | 0;
  return result;
};
protoOf(NutrientInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientInfo))
    return false;
  if (!(this.b19_1 === other.b19_1))
    return false;
  if (!(this.c19_1 === other.c19_1))
    return false;
  if (!(this.d19_1 === other.d19_1))
    return false;
  return true;
};
function Per100g(kcal, protein, fat, carbs, fiber, sugar, satFat, sodiumMg, alcohol, micros) {
  fiber = fiber === VOID ? null : fiber;
  sugar = sugar === VOID ? null : sugar;
  satFat = satFat === VOID ? null : satFat;
  sodiumMg = sodiumMg === VOID ? null : sodiumMg;
  alcohol = alcohol === VOID ? null : alcohol;
  micros = micros === VOID ? emptyMap() : micros;
  this.e13_1 = kcal;
  this.f13_1 = protein;
  this.g13_1 = fat;
  this.h13_1 = carbs;
  this.i13_1 = fiber;
  this.j13_1 = sugar;
  this.k13_1 = satFat;
  this.l13_1 = sodiumMg;
  this.m13_1 = alcohol;
  this.n13_1 = micros;
}
protoOf(Per100g).o13 = function (grams) {
  // Inline function 'kotlin.require' call
  if (!(grams >= 0.0)) {
    var message = 'grams must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var factor = grams / 100.0;
  var amounts = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.set' call
  var value = this.e13_1 * factor;
  amounts.l2('kcal', value);
  // Inline function 'kotlin.collections.set' call
  var value_0 = this.f13_1 * factor;
  amounts.l2('protein', value_0);
  // Inline function 'kotlin.collections.set' call
  var value_1 = this.g13_1 * factor;
  amounts.l2('fat', value_1);
  // Inline function 'kotlin.collections.set' call
  var value_2 = this.h13_1 * factor;
  amounts.l2('carbs', value_2);
  var tmp0_safe_receiver = this.i13_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_3 = tmp0_safe_receiver * factor;
    amounts.l2('fiber', value_3);
  }
  var tmp1_safe_receiver = this.j13_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_4 = tmp1_safe_receiver * factor;
    amounts.l2('sugar', value_4);
  }
  var tmp2_safe_receiver = this.k13_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_5 = tmp2_safe_receiver * factor;
    amounts.l2('satFat', value_5);
  }
  var tmp3_safe_receiver = this.l13_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp2 = 'sodiumMg';
    // Inline function 'kotlin.collections.set' call
    var value_6 = tmp3_safe_receiver * factor;
    amounts.l2(tmp2, value_6);
  }
  var tmp4_safe_receiver = this.m13_1;
  if (tmp4_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_7 = tmp4_safe_receiver * factor;
    amounts.l2('alcohol', value_7);
  }
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this.n13_1.w1().j();
  while (_iterator__ex2g4s.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.p1();
    // Inline function 'kotlin.collections.component2' call
    var value_8 = _destruct__k2r9zo.q1();
    // Inline function 'kotlin.collections.set' call
    var value_9 = value_8 * factor;
    amounts.l2(key, value_9);
  }
  return amounts;
};
protoOf(Per100g).toString = function () {
  return 'Per100g(kcal=' + this.e13_1 + ', protein=' + this.f13_1 + ', fat=' + this.g13_1 + ', carbs=' + this.h13_1 + ', fiber=' + this.i13_1 + ', sugar=' + this.j13_1 + ', satFat=' + this.k13_1 + ', sodiumMg=' + this.l13_1 + ', alcohol=' + this.m13_1 + ', micros=' + toString(this.n13_1) + ')';
};
protoOf(Per100g).hashCode = function () {
  var result = getNumberHashCode(this.e13_1);
  result = imul(result, 31) + getNumberHashCode(this.f13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.g13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.h13_1) | 0;
  result = imul(result, 31) + (this.i13_1 == null ? 0 : getNumberHashCode(this.i13_1)) | 0;
  result = imul(result, 31) + (this.j13_1 == null ? 0 : getNumberHashCode(this.j13_1)) | 0;
  result = imul(result, 31) + (this.k13_1 == null ? 0 : getNumberHashCode(this.k13_1)) | 0;
  result = imul(result, 31) + (this.l13_1 == null ? 0 : getNumberHashCode(this.l13_1)) | 0;
  result = imul(result, 31) + (this.m13_1 == null ? 0 : getNumberHashCode(this.m13_1)) | 0;
  result = imul(result, 31) + hashCode(this.n13_1) | 0;
  return result;
};
protoOf(Per100g).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Per100g))
    return false;
  if (!equals(this.e13_1, other.e13_1))
    return false;
  if (!equals(this.f13_1, other.f13_1))
    return false;
  if (!equals(this.g13_1, other.g13_1))
    return false;
  if (!equals(this.h13_1, other.h13_1))
    return false;
  if (!equals(this.i13_1, other.i13_1))
    return false;
  if (!equals(this.j13_1, other.j13_1))
    return false;
  if (!equals(this.k13_1, other.k13_1))
    return false;
  if (!equals(this.l13_1, other.l13_1))
    return false;
  if (!equals(this.m13_1, other.m13_1))
    return false;
  if (!equals(this.n13_1, other.n13_1))
    return false;
  return true;
};
function Nutrients() {
  Nutrients_instance = this;
  this.q16_1 = 'kcal';
  this.r16_1 = 'protein';
  this.s16_1 = 'fat';
  this.t16_1 = 'carbs';
  this.u16_1 = 'fiber';
  this.v16_1 = 'sugar';
  this.w16_1 = 'satFat';
  this.x16_1 = 'sodiumMg';
  this.y16_1 = 'alcohol';
  this.z16_1 = 'water';
  this.a17_1 = listOf([new NutrientInfo('kcal', 'Energy', 'kcal'), new NutrientInfo('protein', 'Protein', 'g'), new NutrientInfo('fat', 'Fat', 'g'), new NutrientInfo('carbs', 'Carbohydrate', 'g'), new NutrientInfo('fiber', 'Fibre', 'g'), new NutrientInfo('sugar', 'Sugars', 'g'), new NutrientInfo('satFat', 'Saturated fat', 'g'), new NutrientInfo('sodiumMg', 'Sodium', 'mg'), new NutrientInfo('alcohol', 'Alcohol', 'g'), new NutrientInfo('water', 'Water', 'ml'), new NutrientInfo('monoFat', 'Monounsaturated fat', 'g'), new NutrientInfo('polyFat', 'Polyunsaturated fat', 'g'), new NutrientInfo('transFat', 'Trans fat', 'g'), new NutrientInfo('cholesterolMg', 'Cholesterol', 'mg'), new NutrientInfo('potassiumMg', 'Potassium', 'mg'), new NutrientInfo('calciumMg', 'Calcium', 'mg'), new NutrientInfo('ironMg', 'Iron', 'mg'), new NutrientInfo('magnesiumMg', 'Magnesium', 'mg'), new NutrientInfo('zincMg', 'Zinc', 'mg'), new NutrientInfo('phosphorusMg', 'Phosphorus', 'mg'), new NutrientInfo('copperMg', 'Copper', 'mg'), new NutrientInfo('seleniumUg', 'Selenium', '\xB5g'), new NutrientInfo('iodineUg', 'Iodine', '\xB5g'), new NutrientInfo('vitaminAUg', 'Vitamin A (RAE)', '\xB5g'), new NutrientInfo('vitaminDUg', 'Vitamin D', '\xB5g'), new NutrientInfo('vitaminEMg', 'Vitamin E', 'mg'), new NutrientInfo('vitaminKUg', 'Vitamin K', '\xB5g'), new NutrientInfo('vitaminCMg', 'Vitamin C', 'mg'), new NutrientInfo('thiaminMg', 'Thiamin (B1)', 'mg'), new NutrientInfo('riboflavinMg', 'Riboflavin (B2)', 'mg'), new NutrientInfo('niacinMg', 'Niacin (B3)', 'mg'), new NutrientInfo('vitaminB6Mg', 'Vitamin B6', 'mg'), new NutrientInfo('folateUg', 'Folate (DFE)', '\xB5g'), new NutrientInfo('vitaminB12Ug', 'Vitamin B12', '\xB5g'), new NutrientInfo('caffeineMg', 'Caffeine', 'mg')]);
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.a17_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.b19_1;
    destination.f(tmp$ret$2);
  }
  tmp.b17_1 = destination;
}
protoOf(Nutrients).p17 = function (key) {
  var tmp0 = this.a17_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.b19_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Nutrients_instance;
function Nutrients_getInstance() {
  if (Nutrients_instance == null)
    new Nutrients();
  return Nutrients_instance;
}
function NutrientGoal(floor, target, ceiling) {
  this.m18_1 = floor;
  this.n18_1 = target;
  this.o18_1 = ceiling;
}
protoOf(NutrientGoal).hb = function () {
  return this.m18_1;
};
protoOf(NutrientGoal).ib = function () {
  return this.n18_1;
};
protoOf(NutrientGoal).p18 = function () {
  return this.o18_1;
};
protoOf(NutrientGoal).toString = function () {
  return 'NutrientGoal(floor=' + this.m18_1 + ', target=' + this.n18_1 + ', ceiling=' + this.o18_1 + ')';
};
protoOf(NutrientGoal).hashCode = function () {
  var result = this.m18_1 == null ? 0 : getNumberHashCode(this.m18_1);
  result = imul(result, 31) + (this.n18_1 == null ? 0 : getNumberHashCode(this.n18_1)) | 0;
  result = imul(result, 31) + (this.o18_1 == null ? 0 : getNumberHashCode(this.o18_1)) | 0;
  return result;
};
protoOf(NutrientGoal).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoal))
    return false;
  if (!equals(this.m18_1, other.m18_1))
    return false;
  if (!equals(this.n18_1, other.n18_1))
    return false;
  if (!equals(this.o18_1, other.o18_1))
    return false;
  return true;
};
function defaults$pick(male, stage, values) {
  // Inline function 'kotlin.require' call
  if (!(values.length === 10)) {
    var message = 'need 10 values';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return values[male ? stage : 5 + stage | 0];
}
function defaults$teen(stage, teen, adult) {
  return stage === 0 ? teen : adult;
}
function defaults$sexes(male, men, women) {
  return male ? men : women;
}
function NutrientGoals() {
  this.i19_1 = 2000.0;
  this.j19_1 = 14.0;
  this.k19_1 = 2200.0;
  this.l19_1 = 3000.0;
}
protoOf(NutrientGoals).m19 = function (sex) {
  return equals(sex, Sex_MALE_getInstance()) ? 3000.0 : 2200.0;
};
protoOf(NutrientGoals).n19 = function (ageYears) {
  return ageYears <= 18 ? 0 : ageYears <= 30 ? 1 : ageYears <= 50 ? 2 : ageYears <= 70 ? 3 : 4;
};
protoOf(NutrientGoals).o19 = function (sex, ageYears, energyKcal) {
  // Inline function 'kotlin.require' call
  if (!(energyKcal == null || energyKcal > 0.0)) {
    var message = 'energyKcal must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var stage = this.n19(ageYears);
  var male = sex.equals(Sex_MALE_getInstance());
  var kcal = energyKcal == null ? 2000.0 : energyKcal;
  var tmp;
  if (energyKcal == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = energyKcal / 1000.0 * 14.0;
  }
  var tmp2_elvis_lhs = tmp;
  return linkedMapOf([to('fiber', new NutrientGoal(null, tmp2_elvis_lhs == null ? defaults$pick(male, stage, new Float64Array([38.0, 38.0, 38.0, 30.0, 30.0, 26.0, 25.0, 25.0, 21.0, 21.0])) : tmp2_elvis_lhs, null)), to('sugar', new NutrientGoal(null, null, null)), to('satFat', new NutrientGoal(null, null, 0.1 * kcal / 9.0)), to('sodiumMg', new NutrientGoal(null, 1500.0, 2300.0)), to('water', new NutrientGoal(null, this.m19(sex), null)), to('monoFat', new NutrientGoal(null, null, null)), to('polyFat', new NutrientGoal(null, defaults$pick(male, stage, new Float64Array([17.6, 18.6, 18.6, 15.6, 15.6, 12.1, 13.1, 13.1, 12.1, 12.1])), null)), to('transFat', new NutrientGoal(null, null, 0.01 * kcal / 9.0)), to('cholesterolMg', new NutrientGoal(null, null, 300.0)), to('potassiumMg', new NutrientGoal(null, defaults$pick(male, stage, new Float64Array([3000.0, 3400.0, 3400.0, 3400.0, 3400.0, 2300.0, 2600.0, 2600.0, 2600.0, 2600.0])), null)), to('calciumMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([1100.0, 800.0, 800.0, 800.0, 1000.0, 1100.0, 800.0, 800.0, 1000.0, 1000.0])), defaults$pick(male, stage, new Float64Array([1300.0, 1000.0, 1000.0, 1000.0, 1200.0, 1300.0, 1000.0, 1000.0, 1200.0, 1200.0])), defaults$pick(male, stage, new Float64Array([3000.0, 2500.0, 2500.0, 2000.0, 2000.0, 3000.0, 2500.0, 2500.0, 2000.0, 2000.0])))), to('ironMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([7.7, 6.0, 6.0, 6.0, 6.0, 7.9, 8.1, 8.1, 5.0, 5.0])), defaults$pick(male, stage, new Float64Array([11.0, 8.0, 8.0, 8.0, 8.0, 15.0, 18.0, 18.0, 8.0, 8.0])), 45.0)), to('magnesiumMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([340.0, 330.0, 350.0, 350.0, 350.0, 300.0, 255.0, 265.0, 265.0, 265.0])), defaults$pick(male, stage, new Float64Array([410.0, 400.0, 420.0, 420.0, 420.0, 360.0, 310.0, 320.0, 320.0, 320.0])), null)), to('zincMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([8.5, 9.4, 9.4, 9.4, 9.4, 7.3, 6.8, 6.8, 6.8, 6.8])), defaults$pick(male, stage, new Float64Array([11.0, 11.0, 11.0, 11.0, 11.0, 9.0, 8.0, 8.0, 8.0, 8.0])), defaults$teen(stage, 34.0, 40.0))), to('phosphorusMg', new NutrientGoal(defaults$teen(stage, 1055.0, 580.0), defaults$teen(stage, 1250.0, 700.0), stage === 4 ? 3000.0 : 4000.0)), to('copperMg', new NutrientGoal(defaults$teen(stage, 0.685, 0.7), defaults$teen(stage, 0.89, 0.9), defaults$teen(stage, 8.0, 10.0))), to('seleniumUg', new NutrientGoal(45.0, 55.0, 400.0)), to('iodineUg', new NutrientGoal(95.0, 150.0, defaults$teen(stage, 900.0, 1100.0))), to('vitaminAUg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([630.0, 625.0, 625.0, 625.0, 625.0, 485.0, 500.0, 500.0, 500.0, 500.0])), defaults$sexes(male, 900.0, 700.0), defaults$teen(stage, 2800.0, 3000.0))), to('vitaminDUg', new NutrientGoal(10.0, stage === 4 ? 20.0 : 15.0, 100.0)), to('vitaminEMg', new NutrientGoal(12.0, 15.0, defaults$teen(stage, 800.0, 1000.0))), to('vitaminKUg', new NutrientGoal(null, defaults$teen(stage, 75.0, defaults$sexes(male, 120.0, 90.0)), null)), to('vitaminCMg', new NutrientGoal(defaults$teen(stage, defaults$sexes(male, 63.0, 56.0), defaults$sexes(male, 75.0, 60.0)), defaults$teen(stage, defaults$sexes(male, 75.0, 65.0), defaults$sexes(male, 90.0, 75.0)), defaults$teen(stage, 1800.0, 2000.0))), to('thiaminMg', new NutrientGoal(defaults$sexes(male, 1.0, 0.9), defaults$teen(stage, defaults$sexes(male, 1.2, 1.0), defaults$sexes(male, 1.2, 1.1)), null)), to('riboflavinMg', new NutrientGoal(defaults$sexes(male, 1.1, 0.9), defaults$teen(stage, defaults$sexes(male, 1.3, 1.0), defaults$sexes(male, 1.3, 1.1)), null)), to('niacinMg', new NutrientGoal(defaults$sexes(male, 12.0, 11.0), defaults$sexes(male, 16.0, 14.0), defaults$teen(stage, 30.0, 35.0))), to('vitaminB6Mg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([1.1, 1.1, 1.1, 1.4, 1.4, 1.0, 1.1, 1.1, 1.3, 1.3])), defaults$pick(male, stage, new Float64Array([1.3, 1.3, 1.3, 1.7, 1.7, 1.2, 1.3, 1.3, 1.5, 1.5])), defaults$teen(stage, 80.0, 100.0))), to('folateUg', new NutrientGoal(330.0, 400.0, defaults$teen(stage, 800.0, 1000.0))), to('vitaminB12Ug', new NutrientGoal(2.0, 2.4, null)), to('caffeineMg', new NutrientGoal(null, null, defaults$teen(stage, 100.0, 400.0)))]);
};
var NutrientGoals_instance;
function NutrientGoals_getInstance() {
  return NutrientGoals_instance;
}
function RecoveryDay(day, sleepMin, hrvMs, restingHr) {
  sleepMin = sleepMin === VOID ? null : sleepMin;
  hrvMs = hrvMs === VOID ? null : hrvMs;
  restingHr = restingHr === VOID ? null : restingHr;
  this.vj_1 = day;
  this.wj_1 = sleepMin;
  this.xj_1 = hrvMs;
  this.yj_1 = restingHr;
}
protoOf(RecoveryDay).toString = function () {
  return 'RecoveryDay(day=' + this.vj_1 + ', sleepMin=' + this.wj_1 + ', hrvMs=' + this.xj_1 + ', restingHr=' + this.yj_1 + ')';
};
protoOf(RecoveryDay).hashCode = function () {
  var result = this.vj_1;
  result = imul(result, 31) + (this.wj_1 == null ? 0 : getNumberHashCode(this.wj_1)) | 0;
  result = imul(result, 31) + (this.xj_1 == null ? 0 : getNumberHashCode(this.xj_1)) | 0;
  result = imul(result, 31) + (this.yj_1 == null ? 0 : getNumberHashCode(this.yj_1)) | 0;
  return result;
};
protoOf(RecoveryDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecoveryDay))
    return false;
  if (!(this.vj_1 === other.vj_1))
    return false;
  if (!equals(this.wj_1, other.wj_1))
    return false;
  if (!equals(this.xj_1, other.xj_1))
    return false;
  if (!equals(this.yj_1, other.yj_1))
    return false;
  return true;
};
var static_init_called_34;
function static_init_34() {
  if (static_init_called_34)
    return Unit_instance;
  static_init_called_34 = true;
  SuggestionKind_SWAP_instance = new SuggestionKind('SWAP', 0);
  SuggestionKind_DELOAD_instance = new SuggestionKind('DELOAD', 1);
  SuggestionKind_CONSOLIDATE_instance = new SuggestionKind('CONSOLIDATE', 2);
  SuggestionKind_STOP_SUGGESTING_instance = new SuggestionKind('STOP_SUGGESTING', 3);
}
var SuggestionKind_SWAP_instance;
var SuggestionKind_DELOAD_instance;
var SuggestionKind_CONSOLIDATE_instance;
var SuggestionKind_STOP_SUGGESTING_instance;
function SuggestionKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function SwapExercise(fromExerciseId, toExerciseId) {
  ProposedChange.call(this);
  this.p19_1 = fromExerciseId;
  this.q19_1 = toExerciseId;
}
protoOf(SwapExercise).toString = function () {
  return 'SwapExercise(fromExerciseId=' + this.p19_1 + ', toExerciseId=' + this.q19_1 + ')';
};
protoOf(SwapExercise).hashCode = function () {
  var result = getStringHashCode(this.p19_1);
  result = imul(result, 31) + getStringHashCode(this.q19_1) | 0;
  return result;
};
protoOf(SwapExercise).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SwapExercise))
    return false;
  if (!(this.p19_1 === other.p19_1))
    return false;
  if (!(this.q19_1 === other.q19_1))
    return false;
  return true;
};
function Deload(exerciseIds) {
  ProposedChange.call(this);
  this.r19_1 = exerciseIds;
}
protoOf(Deload).toString = function () {
  return 'Deload(exerciseIds=' + toString(this.r19_1) + ')';
};
protoOf(Deload).hashCode = function () {
  return hashCode(this.r19_1);
};
protoOf(Deload).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Deload))
    return false;
  if (!equals(this.r19_1, other.r19_1))
    return false;
  return true;
};
function Consolidate(fromDays, toDays, program) {
  ProposedChange.call(this);
  this.s19_1 = fromDays;
  this.t19_1 = toDays;
  this.u19_1 = program;
}
protoOf(Consolidate).toString = function () {
  return 'Consolidate(fromDays=' + this.s19_1 + ', toDays=' + this.t19_1 + ', program=' + this.u19_1.toString() + ')';
};
protoOf(Consolidate).hashCode = function () {
  var result = this.s19_1;
  result = imul(result, 31) + this.t19_1 | 0;
  result = imul(result, 31) + this.u19_1.hashCode() | 0;
  return result;
};
protoOf(Consolidate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Consolidate))
    return false;
  if (!(this.s19_1 === other.s19_1))
    return false;
  if (!(this.t19_1 === other.t19_1))
    return false;
  if (!this.u19_1.equals(other.u19_1))
    return false;
  return true;
};
function StopSuggesting(exerciseId, replacementId) {
  ProposedChange.call(this);
  this.v19_1 = exerciseId;
  this.w19_1 = replacementId;
}
protoOf(StopSuggesting).toString = function () {
  return 'StopSuggesting(exerciseId=' + this.v19_1 + ', replacementId=' + this.w19_1 + ')';
};
protoOf(StopSuggesting).hashCode = function () {
  var result = getStringHashCode(this.v19_1);
  result = imul(result, 31) + (this.w19_1 == null ? 0 : getStringHashCode(this.w19_1)) | 0;
  return result;
};
protoOf(StopSuggesting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StopSuggesting))
    return false;
  if (!(this.v19_1 === other.v19_1))
    return false;
  if (!(this.w19_1 == other.w19_1))
    return false;
  return true;
};
function ProposedChange() {
}
function TrainingSuggestion(id, kind, exerciseId, title, body, evidence, change) {
  this.x19_1 = id;
  this.y19_1 = kind;
  this.z19_1 = exerciseId;
  this.a1a_1 = title;
  this.b1a_1 = body;
  this.c1a_1 = evidence;
  this.d1a_1 = change;
}
protoOf(TrainingSuggestion).toString = function () {
  return 'TrainingSuggestion(id=' + this.x19_1 + ', kind=' + this.y19_1.toString() + ', exerciseId=' + this.z19_1 + ', title=' + this.a1a_1 + ', body=' + this.b1a_1 + ', evidence=' + this.c1a_1 + ', change=' + toString(this.d1a_1) + ')';
};
protoOf(TrainingSuggestion).hashCode = function () {
  var result = getStringHashCode(this.x19_1);
  result = imul(result, 31) + this.y19_1.hashCode() | 0;
  result = imul(result, 31) + (this.z19_1 == null ? 0 : getStringHashCode(this.z19_1)) | 0;
  result = imul(result, 31) + getStringHashCode(this.a1a_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.b1a_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.c1a_1) | 0;
  result = imul(result, 31) + hashCode(this.d1a_1) | 0;
  return result;
};
protoOf(TrainingSuggestion).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingSuggestion))
    return false;
  if (!(this.x19_1 === other.x19_1))
    return false;
  if (!this.y19_1.equals(other.y19_1))
    return false;
  if (!(this.z19_1 == other.z19_1))
    return false;
  if (!(this.a1a_1 === other.a1a_1))
    return false;
  if (!(this.b1a_1 === other.b1a_1))
    return false;
  if (!(this.c1a_1 === other.c1a_1))
    return false;
  if (!equals(this.d1a_1, other.d1a_1))
    return false;
  return true;
};
function Companion_9() {
}
protoOf(Companion_9).e1a = function (workoutId, day, program, cycle, dayIndex) {
  var tmp0_safe_receiver = getOrNull_0(program.j1a_1, dayIndex);
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o1a_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.e1b(cycle).v1a_1) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$6 = item.w1a_1;
    destination_0.f(tmp$ret$6);
  }
  return new PlannedSession(workoutId, day, destination_0);
};
var Companion_instance_11;
function Companion_getInstance_9() {
  return Companion_instance_11;
}
function PlannedSession(workoutId, day, plannedExerciseIds) {
  this.f1b_1 = workoutId;
  this.g1b_1 = day;
  this.h1b_1 = plannedExerciseIds;
}
protoOf(PlannedSession).toString = function () {
  return 'PlannedSession(workoutId=' + this.f1b_1 + ', day=' + this.g1b_1 + ', plannedExerciseIds=' + toString(this.h1b_1) + ')';
};
protoOf(PlannedSession).hashCode = function () {
  var result = getStringHashCode(this.f1b_1);
  result = imul(result, 31) + this.g1b_1 | 0;
  result = imul(result, 31) + hashCode(this.h1b_1) | 0;
  return result;
};
protoOf(PlannedSession).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlannedSession))
    return false;
  if (!(this.f1b_1 === other.f1b_1))
    return false;
  if (!(this.g1b_1 === other.g1b_1))
    return false;
  if (!equals(this.h1b_1, other.h1b_1))
    return false;
  return true;
};
function AdaptiveInput(sets, catalogue, program, sessions, today, programStartDay, gym, skills, recoveryFlag, dismissed) {
  programStartDay = programStartDay === VOID ? null : programStartDay;
  gym = gym === VOID ? null : gym;
  skills = skills === VOID ? null : skills;
  recoveryFlag = recoveryFlag === VOID ? false : recoveryFlag;
  dismissed = dismissed === VOID ? emptyMap() : dismissed;
  this.i1b_1 = sets;
  this.j1b_1 = catalogue;
  this.k1b_1 = program;
  this.l1b_1 = sessions;
  this.m1b_1 = today;
  this.n1b_1 = programStartDay;
  this.o1b_1 = gym;
  this.p1b_1 = skills;
  this.q1b_1 = recoveryFlag;
  this.r1b_1 = dismissed;
}
protoOf(AdaptiveInput).toString = function () {
  return 'AdaptiveInput(sets=' + toString(this.i1b_1) + ', catalogue=' + toString(this.j1b_1) + ', program=' + this.k1b_1.toString() + ', sessions=' + toString(this.l1b_1) + ', today=' + this.m1b_1 + ', programStartDay=' + this.n1b_1 + ', gym=' + toString_0(this.o1b_1) + ', skills=' + toString_0(this.p1b_1) + ', recoveryFlag=' + this.q1b_1 + ', dismissed=' + toString(this.r1b_1) + ')';
};
protoOf(AdaptiveInput).hashCode = function () {
  var result = hashCode(this.i1b_1);
  result = imul(result, 31) + hashCode(this.j1b_1) | 0;
  result = imul(result, 31) + this.k1b_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.l1b_1) | 0;
  result = imul(result, 31) + this.m1b_1 | 0;
  result = imul(result, 31) + (this.n1b_1 == null ? 0 : this.n1b_1) | 0;
  result = imul(result, 31) + (this.o1b_1 == null ? 0 : this.o1b_1.hashCode()) | 0;
  result = imul(result, 31) + (this.p1b_1 == null ? 0 : hashCode(this.p1b_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.q1b_1) | 0;
  result = imul(result, 31) + hashCode(this.r1b_1) | 0;
  return result;
};
protoOf(AdaptiveInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AdaptiveInput))
    return false;
  if (!equals(this.i1b_1, other.i1b_1))
    return false;
  if (!equals(this.j1b_1, other.j1b_1))
    return false;
  if (!this.k1b_1.equals(other.k1b_1))
    return false;
  if (!equals(this.l1b_1, other.l1b_1))
    return false;
  if (!(this.m1b_1 === other.m1b_1))
    return false;
  if (!(this.n1b_1 == other.n1b_1))
    return false;
  if (!equals(this.o1b_1, other.o1b_1))
    return false;
  if (!equals(this.p1b_1, other.p1b_1))
    return false;
  if (!(this.q1b_1 === other.q1b_1))
    return false;
  if (!equals(this.r1b_1, other.r1b_1))
    return false;
  return true;
};
function frequency($this, program, byId) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = program.j1a_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_0 = element.o1a_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = tmp0_0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      var tmp0_safe_receiver = byId.t1(element_0.w1a_1);
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v1b_1;
      var list = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      addAll(destination_0, list);
    }
    var list_0 = distinct(destination_0);
    addAll(destination, list_0);
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$7 = new AdaptiveTraining$frequency$$inlined$groupingBy$1(destination);
  return eachCount(tmp$ret$7);
}
function notRising($this, input, exercise) {
  if (exercise == null)
    return null;
  var from = input.m1b_1 - 21 | 0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = TrainingAnalytics_instance.k1c(input.i1b_1, exercise.s1b_1, VOID, exercise.a1c_1);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsUpper = input.m1b_1;
    var containsArg = element.l1c_1;
    if (from <= containsArg ? containsArg <= containsUpper : false) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = new StrengthIndexPoint(item.l1c_1, item.n1c_1);
    destination_0.f(tmp$ret$5);
  }
  var points = destination_0;
  var tmp1_safe_receiver = PerformanceGuardrail_instance.yt(points);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp1_safe_receiver <= 5.0) {
      tmp_0 = tmp1_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function avoided($this, input) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = input.i1b_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.s1c_1.equals(SetType_WARMUP_getInstance()) && element.u1c_1 > 0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.o1c_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    var tmp$ret$8 = element_0.q1c_1;
    list.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_1 = LinkedHashMap_init_$Create$(mapCapacity(destination_0.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_1 = destination_0.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp_0 = element_1.p1();
    var tmp$ret$13 = toSet(element_1.q1());
    destination_1.l2(tmp_0, tmp$ret$13);
  }
  var done = destination_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = input.l1b_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_2 = tmp0_0.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var containsLower = (input.m1b_1 - 28 | 0) + 1 | 0;
    var containsUpper = input.m1b_1;
    var containsArg = element_2.g1b_1;
    if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
      destination_2.f(element_2);
    }
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = destination_2.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var tmp0_safe_receiver = done.t1(element_3.f1b_1);
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.filter' call
      var tmp0_1 = distinct(element_3.h1b_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_4 = tmp0_1.j();
      while (_iterator__ex2g4s_4.k()) {
        var element_4 = _iterator__ex2g4s_4.l();
        if (!tmp0_safe_receiver.r(element_4)) {
          destination_4.f(element_4);
        }
      }
      tmp_1 = destination_4;
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp_1;
    var list_0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    addAll(destination_3, list_0);
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$26 = new AdaptiveTraining$avoided$$inlined$groupingBy$1(destination_3);
  // Inline function 'kotlin.collections.filter' call
  var tmp0_2 = eachCount(tmp$ret$26);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_5 = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_5 = tmp0_2.w1().j();
  while (_iterator__ex2g4s_5.k()) {
    var element_5 = _iterator__ex2g4s_5.l();
    if (element_5.q1() >= 3) {
      destination_5.l2(element_5.p1(), element_5.q1());
    }
  }
  return sorted(destination_5.u1());
}
function consolidation($this, input) {
  var planned = input.k1b_1.j1a_1.o();
  var start = (input.m1b_1 - 28 | 0) + 1 | 0;
  if (!(input.n1b_1 == null) && input.n1b_1 > start)
    return null;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = input.i1b_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.s1c_1.equals(SetType_WARMUP_getInstance()) && element.u1c_1 > 0) {
      destination.f(element);
    }
  }
  var working = destination;
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, 4);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var week = item;
      var from = start + imul(week, 7) | 0;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_0 = working.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        var containsUpper = from + 7 | 0;
        var containsArg = element_0.p1c_1;
        if (from <= containsArg ? containsArg < containsUpper : false) {
          destination_1.f(element_0);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_1, 10));
      var _iterator__ex2g4s_1 = destination_1.j();
      while (_iterator__ex2g4s_1.k()) {
        var item_0 = _iterator__ex2g4s_1.l();
        var tmp$ret$11 = item_0.o1c_1;
        destination_2.f(tmp$ret$11);
      }
      var tmp$ret$5 = distinct(destination_2).o();
      destination_0.f(tmp$ret$5);
    }
     while (!(item === last));
  var weeks = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_2 = weeks.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    if (element_1 < planned) {
      destination_3.f(element_1);
    }
  }
  var short = destination_3;
  if (short.o() < 3)
    return null;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_4 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = short.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    if (element_2 > 0) {
      destination_4.f(element_2);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$18 = new AdaptiveTraining$consolidation$$inlined$groupingBy$1(destination_4);
  var tmp = eachCount(tmp$ret$18).w1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = AdaptiveTraining$consolidation$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_1 = new sam$kotlin_Comparator$0_7(tmp_0);
  var tmp_1 = AdaptiveTraining$consolidation$lambda_0(this_1);
  var tmp$ret$20 = new sam$kotlin_Comparator$0_7(tmp_1);
  var tmp0_safe_receiver = maxWithOrNull(tmp, tmp$ret$20);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p1();
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var usual = tmp_2;
  // Inline function 'kotlin.math.max' call
  var toDays = Math.max(usual, 2);
  if (toDays >= planned)
    return null;
  var program = $this.j1d(input.k1b_1, toDays);
  // Inline function 'kotlin.collections.associateBy' call
  var this_2 = input.j1b_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_5 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_4 = this_2.j();
  while (_iterator__ex2g4s_4.k()) {
    var element_3 = _iterator__ex2g4s_4.l();
    var tmp$ret$24 = element_3.s1b_1;
    destination_5.l2(tmp$ret$24, element_3);
  }
  var byId = destination_5;
  var after = frequency($this, program, byId);
  var tmp0_0 = frequency($this, input.k1b_1, byId);
  var tmp$ret$25;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    if (tmp0_0.m()) {
      tmp$ret$25 = false;
      break $l$block_0;
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_5 = tmp0_0.w1().j();
    while (_iterator__ex2g4s_5.k()) {
      var element_4 = _iterator__ex2g4s_5.l();
      // Inline function 'kotlin.collections.component1' call
      var muscle = element_4.p1();
      // Inline function 'kotlin.collections.component2' call
      var days = element_4.q1();
      var tmp0_elvis_lhs = after.t1(muscle);
      var tmp_3 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      // Inline function 'kotlin.math.min' call
      if (tmp_3 < Math.min(days, 2)) {
        tmp$ret$25 = true;
        break $l$block_0;
      }
    }
    tmp$ret$25 = false;
  }
  if (tmp$ret$25)
    return null;
  return new TrainingSuggestion('consolidate:' + toDays, SuggestionKind_CONSOLIDATE_getInstance(), null, 'Train ' + toDays + ' days a week instead of ' + planned + '?', "You've been training " + usual + ' ' + (usual === 1 ? 'day' : 'days') + ' most weeks instead of ' + planned + '. Splitting the same ' + ('weekly sets across ' + toDays + " days shouldn't cost you muscle or strength."), 'Schoenfeld 2019 (volume-equated frequency makes little difference); Schoenfeld 2016 (at least twice a week per muscle).', new Consolidate(planned, toDays, program));
}
function sam$kotlin_Comparator$0_7(function_0) {
  this.k1d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_7).ea = function (a, b) {
  return this.k1d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_7).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_7).h2 = function () {
  return this.k1d_1;
};
protoOf(sam$kotlin_Comparator$0_7).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_7).hashCode = function () {
  return hashCode(this.h2());
};
function suggestions$name(byId, id) {
  var tmp0_safe_receiver = byId.t1(id);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t1b_1;
  return tmp1_elvis_lhs == null ? id : tmp1_elvis_lhs;
}
function suggestions$swapFor(byId, $input, programIds, id) {
  var tmp0_elvis_lhs = byId.t1(id);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var exercise = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = Substitutions_instance.l1d(exercise, $input.j1b_1, $input.o1b_1, toSet(programIds), VOID, $input.p1b_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.m1d_1;
    destination.f(tmp$ret$2);
  }
  var ranked = destination;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = ranked.j();
    while (_iterator__ex2g4s_0.k()) {
      var element = _iterator__ex2g4s_0.l();
      if (!(exercise.d1c_1 == null) && element.d1c_1 == exercise.d1c_1 || (!(exercise.h1c_1 == null) && equals(element.h1c_1, exercise.h1c_1))) {
        tmp$ret$3 = element;
        break $l$block;
      }
    }
    tmp$ret$3 = null;
  }
  var sameMovement = tmp$ret$3;
  return sameMovement == null ? firstOrNull(ranked) : sameMovement;
}
function suggestions$trend(falling, ids) {
  var tmp;
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp_0;
    if (isInterface(ids, Collection)) {
      tmp_0 = ids.m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = ids.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!falling.r(element)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  if (tmp$ret$0) {
    tmp = 'been dropping';
  } else {
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(ids, Collection)) {
        tmp_1 = ids.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
      var _iterator__ex2g4s_0 = ids.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (falling.r(element_0)) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
      }
      tmp$ret$2 = true;
    }
    if (tmp$ret$2) {
      tmp = 'been flat';
    } else {
      tmp = 'stalled or dropped';
    }
  }
  return tmp;
}
function AdaptiveTraining$suggestions$lambda($byId) {
  return function (it) {
    return suggestions$name($byId, it);
  };
}
function AdaptiveTraining$consolidated$lambda(it) {
  return it.n1a_1;
}
function AdaptiveTraining$frequency$$inlined$groupingBy$1($this) {
  this.o1d_1 = $this;
}
protoOf(AdaptiveTraining$frequency$$inlined$groupingBy$1).j2 = function () {
  return this.o1d_1.j();
};
protoOf(AdaptiveTraining$frequency$$inlined$groupingBy$1).o12 = function (element) {
  return element;
};
protoOf(AdaptiveTraining$frequency$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function AdaptiveTraining$avoided$$inlined$groupingBy$1($this) {
  this.p1d_1 = $this;
}
protoOf(AdaptiveTraining$avoided$$inlined$groupingBy$1).j2 = function () {
  return this.p1d_1.j();
};
protoOf(AdaptiveTraining$avoided$$inlined$groupingBy$1).o12 = function (element) {
  return element;
};
protoOf(AdaptiveTraining$avoided$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function AdaptiveTraining$consolidation$$inlined$groupingBy$1($this) {
  this.q1d_1 = $this;
}
protoOf(AdaptiveTraining$consolidation$$inlined$groupingBy$1).j2 = function () {
  return this.q1d_1.j();
};
protoOf(AdaptiveTraining$consolidation$$inlined$groupingBy$1).o12 = function (element) {
  return element;
};
protoOf(AdaptiveTraining$consolidation$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function AdaptiveTraining$consolidation$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.q1();
  var tmp$ret$2 = b.q1();
  return compareValues(tmp, tmp$ret$2);
}
function AdaptiveTraining$consolidation$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.p1();
      var tmp$ret$2 = b.p1();
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function AdaptiveTraining() {
  this.x1c_1 = 5.0;
  this.y1c_1 = 3;
  this.z1c_1 = 28;
  this.a1d_1 = 4;
  this.b1d_1 = 3;
  this.c1d_1 = 2;
  this.d1d_1 = 28;
  this.e1d_1 = 'Grgic 2020 (1RM test-retest noise, median CV 4.2 %); the \xB15 % band and 3-week window are a design choice.';
  this.f1d_1 = 'Fonseca 2014; Baz-Valle 2019 (changing exercises: mixed effect on strength, higher motivation).';
  this.g1d_1 = 'Pancar 2026 (a reduced-volume deload kept muscle and strength); Coleman 2024 (a week off cost a little strength).';
  this.h1d_1 = 'Schoenfeld 2019 (volume-equated frequency makes little difference); Schoenfeld 2016 (at least twice a week per muscle).';
  this.i1d_1 = 'Teixeira 2012 (autonomy and long-term adherence); Baz-Valle 2019 (choice raised motivation). The 3-in-4-weeks trigger is a design choice.';
}
protoOf(AdaptiveTraining).r1d = function (input) {
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = input.j1b_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.s1b_1;
    destination.l2(tmp$ret$2, element);
  }
  var byId = destination;
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = input.k1b_1.j1a_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = tmp0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.map' call
    var this_1 = element_0.o1a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_1 = this_1.j();
    while (_iterator__ex2g4s_1.k()) {
      var item = _iterator__ex2g4s_1.l();
      var tmp$ret$8 = item.w1a_1;
      destination_1.f(tmp$ret$8);
    }
    var list = destination_1;
    addAll(destination_0, list);
  }
  var programIds = distinct(destination_0);
  var avoided_0 = avoided(this, input);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(avoided_0, 10));
  var _iterator__ex2g4s_2 = avoided_0.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var replacement = suggestions$swapFor(byId, input, programIds, item_0);
    var tmp = 'prefer:' + item_0;
    var tmp_0 = SuggestionKind_STOP_SUGGESTING_getInstance();
    var tmp_1 = 'Stop suggesting ' + suggestions$name(byId, item_0) + '?';
    var tmp_2 = "You've skipped or swapped " + suggestions$name(byId, item_0) + ' several times recently. Exercises you actually want to do are linked to ' + 'sticking with training longer';
    var tmp_3;
    if (replacement == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = ', so ' + replacement.t1b_1 + ' could take its place.';
    }
    var tmp1_elvis_lhs = tmp_3;
    var tmp_4 = tmp_2 + (tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs);
    var tmp$ret$11 = new TrainingSuggestion(tmp, tmp_0, item_0, tmp_1, tmp_4, 'Teixeira 2012 (autonomy and long-term adherence); Baz-Valle 2019 (choice raised motivation). The 3-in-4-weeks trigger is a design choice.', new StopSuggesting(item_0, replacement == null ? null : replacement.s1b_1));
    destination_2.f(tmp$ret$11);
  }
  var preference = destination_2;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = programIds.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_1 = _iterator__ex2g4s_3.l();
    if (!avoided_0.r(element_1)) {
      destination_3.f(element_1);
    }
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_4 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_4 = destination_3.j();
  while (_iterator__ex2g4s_4.k()) {
    var element_2 = _iterator__ex2g4s_4.l();
    var tmp0_safe_receiver = notRising(AdaptiveTraining_instance, input, byId.t1(element_2));
    var tmp_5;
    if (tmp0_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_5 = to(element_2, tmp0_safe_receiver);
    }
    var tmp0_safe_receiver_0 = tmp_5;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_4.f(tmp0_safe_receiver_0);
    }
  }
  var changes = toMap(destination_4);
  var stalled = toList(changes.u1());
  // Inline function 'kotlin.collections.filterValues' call
  var result = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_5 = changes.w1().j();
  while (_iterator__ex2g4s_5.k()) {
    var entry = _iterator__ex2g4s_5.l();
    if (entry.q1() < -5.0) {
      result.l2(entry.p1(), entry.q1());
    }
  }
  var falling = result.u1();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_5 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_6 = stalled.j();
  while (_iterator__ex2g4s_6.k()) {
    var element_3 = _iterator__ex2g4s_6.l();
    var tmp$ret$33;
    $l$block: {
      var tmp0_elvis_lhs = suggestions$swapFor(byId, input, programIds, element_3);
      var tmp_6;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$33 = null;
        break $l$block;
      } else {
        tmp_6 = tmp0_elvis_lhs;
      }
      var replacement_0 = tmp_6;
      tmp$ret$33 = new TrainingSuggestion('stall-swap:' + element_3, SuggestionKind_SWAP_getInstance(), element_3, 'Swap ' + suggestions$name(byId, element_3) + ' for ' + replacement_0.t1b_1 + '?', 'Your estimated max on ' + suggestions$name(byId, element_3) + ' has ' + suggestions$trend(falling, listOf_0(element_3)) + ' for 3 weeks. ' + replacement_0.t1b_1 + ' works the same muscles and might ' + 'help, and a lot of people find variety easier to stick with.', 'Grgic 2020 (1RM test-retest noise, median CV 4.2 %); the \xB15 % band and 3-week window are a design choice. Fonseca 2014; Baz-Valle 2019 (changing exercises: mixed effect on strength, higher motivation).', new SwapExercise(element_3, replacement_0.s1b_1));
    }
    var tmp0_safe_receiver_1 = tmp$ret$33;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_5.f(tmp0_safe_receiver_1);
    }
  }
  var swaps = destination_5;
  // Inline function 'kotlin.takeIf' call
  var tmp_7;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!stalled.m()) {
    tmp_7 = stalled;
  } else {
    tmp_7 = null;
  }
  var tmp0_safe_receiver_2 = tmp_7;
  var tmp_8;
  if (tmp0_safe_receiver_2 == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_9 = SuggestionKind_DELOAD_getInstance();
    tmp_8 = new TrainingSuggestion('deload', tmp_9, null, 'Take a lighter week?', 'Strength on ' + joinToString(tmp0_safe_receiver_2, ', ', VOID, VOID, VOID, VOID, AdaptiveTraining$suggestions$lambda(byId)) + ' has ' + suggestions$trend(falling, tmp0_safe_receiver_2) + ' for 3 weeks' + (input.q1b_1 ? ', and your check-in noted short sleep or low energy availability' : '') + '. A lighter week (half the sets, 2 more reps in reserve, not a full week off) kept strength and muscle in a ' + 'recent trial; a complete week off cost a little strength in another.', 'Grgic 2020 (1RM test-retest noise, median CV 4.2 %); the \xB15 % band and 3-week window are a design choice. Pancar 2026 (a reduced-volume deload kept muscle and strength); Coleman 2024 (a week off cost a little strength).', new Deload(tmp0_safe_receiver_2));
  }
  var deload = tmp_8;
  var tmp_10;
  var tmp_11;
  if (input.q1b_1) {
    tmp_11 = true;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_11 = !falling.m();
  }
  if (tmp_11) {
    tmp_10 = plus(listOfNotNull_0(deload), swaps);
  } else {
    tmp_10 = plus(swaps, listOfNotNull_0(deload));
  }
  var stall = tmp_10;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = plus(plus(stall, preference), listOfNotNull_0(consolidation(this, input)));
  // Inline function 'kotlin.collections.filterTo' call
  var destination_6 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_7 = tmp0_0.j();
  while (_iterator__ex2g4s_7.k()) {
    var element_4 = _iterator__ex2g4s_7.l();
    var tmp0_safe_receiver_3 = input.r1b_1.t1(element_4.x19_1);
    var tmp_12;
    if (tmp0_safe_receiver_3 == null) {
      tmp_12 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_12 = (input.m1b_1 - tmp0_safe_receiver_3 | 0) < 28;
    }
    if (!(tmp_12 === true)) {
      destination_6.f(element_4);
    }
  }
  return destination_6;
};
protoOf(AdaptiveTraining).j1d = function (program, toDays) {
  // Inline function 'kotlin.require' call
  if (!(1 <= toDays ? toDays <= program.j1a_1.o() : false)) {
    var message = 'toDays must be 1\u2013' + program.j1a_1.o();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0 = withIndex(program.j1a_1);
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = imul(element.fb_1, toDays) / program.j1a_1.o() | 0;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    var tmp$ret$7 = element.gb_1;
    list.f(tmp$ret$7);
  }
  var groups = destination.v1();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(groups, 10));
  var _iterator__ex2g4s_0 = groups.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp_0 = joinToString(item, ' + ', VOID, VOID, VOID, VOID, AdaptiveTraining$consolidated$lambda);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_1 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_1 = item.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var list_0 = element_0.o1a_1;
      addAll(destination_1, list_0);
    }
    var tmp$ret$10 = new ProgramDay(tmp_0, destination_1, first(item).p1a_1);
    destination_0.f(tmp$ret$10);
  }
  return program.s1d(VOID, VOID, VOID, VOID, destination_0);
};
var AdaptiveTraining_instance;
function AdaptiveTraining_getInstance() {
  return AdaptiveTraining_instance;
}
function SuggestionKind_SWAP_getInstance() {
  static_init_34();
  return SuggestionKind_SWAP_instance;
}
function SuggestionKind_DELOAD_getInstance() {
  static_init_34();
  return SuggestionKind_DELOAD_instance;
}
function SuggestionKind_CONSOLIDATE_getInstance() {
  static_init_34();
  return SuggestionKind_CONSOLIDATE_instance;
}
function SuggestionKind_STOP_SUGGESTING_getInstance() {
  static_init_34();
  return SuggestionKind_STOP_SUGGESTING_instance;
}
function BodyMapArt() {
  BodyMapArt_instance = this;
  this.t1d_1 = mapOf_0([to('sternocleidomastoid', listOf_0(Muscle_NECK_getInstance())), to('trapezius', listOf([Muscle_TRAPS_getInstance(), Muscle_MIDDLE_BACK_getInstance()])), to('anterior_deltoid', listOf_0(Muscle_SHOULDERS_getInstance())), to('lateral_deltoid', listOf_0(Muscle_SHOULDERS_getInstance())), to('posterior_deltoid', listOf_0(Muscle_SHOULDERS_getInstance())), to('pectoralis_major', listOf_0(Muscle_CHEST_getInstance())), to('serratus_anterior', listOf_0(Muscle_CHEST_getInstance())), to('biceps_brachii', listOf_0(Muscle_BICEPS_getInstance())), to('brachialis', listOf_0(Muscle_BICEPS_getInstance())), to('triceps_brachii', listOf_0(Muscle_TRICEPS_getInstance())), to('forearm_flexors', listOf_0(Muscle_FOREARMS_getInstance())), to('forearm_extensors', listOf_0(Muscle_FOREARMS_getInstance())), to('latissimus_dorsi', listOf_0(Muscle_LATS_getInstance())), to('posterior_rotator_cuff', listOf_0(Muscle_MIDDLE_BACK_getInstance())), to('erector_spinae', listOf_0(Muscle_LOWER_BACK_getInstance())), to('rectus_abdominis', listOf_0(Muscle_ABDOMINALS_getInstance())), to('external_oblique', listOf_0(Muscle_ABDOMINALS_getInstance())), to('rectus_femoris', listOf_0(Muscle_QUADRICEPS_getInstance())), to('vastus_lateralis', listOf_0(Muscle_QUADRICEPS_getInstance())), to('vastus_medialis', listOf_0(Muscle_QUADRICEPS_getInstance())), to('biceps_femoris', listOf_0(Muscle_HAMSTRINGS_getInstance())), to('medial_hamstrings', listOf_0(Muscle_HAMSTRINGS_getInstance())), to('gluteus_maximus', listOf_0(Muscle_GLUTES_getInstance())), to('gluteus_medius', listOf_0(Muscle_ABDUCTORS_getInstance())), to('tensor_fasciae_latae', listOf_0(Muscle_ABDUCTORS_getInstance())), to('hip_adductors', listOf_0(Muscle_ADDUCTORS_getInstance())), to('gastrocnemius', listOf_0(Muscle_CALVES_getInstance())), to('soleus', listOf_0(Muscle_CALVES_getInstance()))]);
}
protoOf(BodyMapArt).u1d = function (muscleId) {
  var tmp;
  if (muscleId == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = BodyMapArt_getInstance().t1d_1.t1(muscleId);
  }
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
var BodyMapArt_instance;
function BodyMapArt_getInstance() {
  if (BodyMapArt_instance == null)
    new BodyMapArt();
  return BodyMapArt_instance;
}
function Point(loadKg, rtf) {
  this.v1d_1 = loadKg;
  this.w1d_1 = rtf;
}
protoOf(Point).toString = function () {
  return 'Point(loadKg=' + this.v1d_1 + ', rtf=' + this.w1d_1 + ')';
};
protoOf(Point).hashCode = function () {
  var result = getNumberHashCode(this.v1d_1);
  result = imul(result, 31) + getNumberHashCode(this.w1d_1) | 0;
  return result;
};
protoOf(Point).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Point))
    return false;
  if (!equals(this.v1d_1, other.v1d_1))
    return false;
  if (!equals(this.w1d_1, other.w1d_1))
    return false;
  return true;
};
function Fit(base, sessions) {
  this.x1d_1 = base;
  this.y1d_1 = sessions;
}
protoOf(Fit).toString = function () {
  return 'Fit(base=' + this.x1d_1 + ', sessions=' + this.y1d_1 + ')';
};
protoOf(Fit).hashCode = function () {
  var result = getNumberHashCode(this.x1d_1);
  result = imul(result, 31) + this.y1d_1 | 0;
  return result;
};
protoOf(Fit).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Fit))
    return false;
  if (!equals(this.x1d_1, other.x1d_1))
    return false;
  if (!(this.y1d_1 === other.y1d_1))
    return false;
  return true;
};
function CurveFit() {
  this.z1d_1 = 6;
  this.a1e_1 = 6.0;
  this.b1e_1 = 0.95;
  this.c1e_1 = 0.99;
  this.d1e_1 = 5.0E-4;
}
protoOf(CurveFit).e1e = function (sessions, floor, minSessions) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(sessions, 10));
  var _iterator__ex2g4s = sessions.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = item.j();
    while (_iterator__ex2g4s_0.k()) {
      var element = _iterator__ex2g4s_0.l();
      if (element.v1d_1 > 0.0 && element.w1d_1 >= 1.0) {
        destination_0.f(element);
      }
    }
    destination.f(destination_0);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_0 = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(element_0, 10));
    var _iterator__ex2g4s_2 = element_0.j();
    while (_iterator__ex2g4s_2.k()) {
      var item_0 = _iterator__ex2g4s_2.l();
      var tmp$ret$11 = item_0.w1d_1;
      destination_2.f(tmp$ret$11);
    }
    if (distinct(destination_2).o() >= 2) {
      destination_1.f(element_0);
    }
  }
  var usable = destination_1;
  if (usable.o() < minSessions)
    return null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(usable, 10));
  var _iterator__ex2g4s_3 = usable.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_1 = _iterator__ex2g4s_3.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(item_1, 10));
    var _iterator__ex2g4s_4 = item_1.j();
    while (_iterator__ex2g4s_4.k()) {
      var item_2 = _iterator__ex2g4s_4.l();
      // Inline function 'kotlin.math.ln' call
      var x = item_2.v1d_1;
      var tmp$ret$18 = Math.log(x);
      var tmp$ret$17 = to(tmp$ret$18, item_2.w1d_1);
      destination_4.f(tmp$ret$17);
    }
    destination_3.f(destination_4);
  }
  var logs = destination_3;
  var steps = numberToInt((0.99 - 0.95) / 5.0E-4 + 0.5);
  var best = 0.95;
  var bestError = 1.7976931348623157E308;
  var inductionVariable = 0;
  if (inductionVariable <= steps)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var base = 0.95 + i * 5.0E-4;
      var curve = new FlooredExpCurve(base, floor);
      var error = 0.0;
      var _iterator__ex2g4s_5 = logs.j();
      while (_iterator__ex2g4s_5.k()) {
        var session = _iterator__ex2g4s_5.l();
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(session, 10));
        var _iterator__ex2g4s_6 = session.j();
        while (_iterator__ex2g4s_6.k()) {
          var item_3 = _iterator__ex2g4s_6.l();
          var logLoad = item_3.hb();
          var rtf = item_3.ib();
          // Inline function 'kotlin.math.ln' call
          var x_0 = curve.h1e(rtf);
          var tmp$ret$21 = logLoad - Math.log(x_0);
          destination_5.f(tmp$ret$21);
        }
        var residuals = destination_5;
        var mean = average(residuals);
        var tmp = error;
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_7 = residuals.j();
        while (_iterator__ex2g4s_7.k()) {
          var element_1 = _iterator__ex2g4s_7.l();
          var tmp_0 = sum;
          sum = tmp_0 + (element_1 - mean) * (element_1 - mean);
        }
        error = tmp + sum;
      }
      if (error < bestError - 1.0E-15) {
        bestError = error;
        best = base;
      }
    }
     while (!(i === steps));
  return new Fit(best, usable.o());
};
protoOf(CurveFit).i1e = function (sessions, floor, minSessions, $super) {
  floor = floor === VOID ? 0.2 : floor;
  minSessions = minSessions === VOID ? 6 : minSessions;
  return $super === VOID ? this.e1e(sessions, floor, minSessions) : $super.e1e.call(this, sessions, floor, minSessions);
};
protoOf(CurveFit).j1e = function (sessions, prior) {
  var tmp0_elvis_lhs = this.i1e(sessions);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return prior;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var fit = tmp;
  return prior + fit.y1d_1 / (fit.y1d_1 + 6.0) * (fit.x1d_1 - prior);
};
protoOf(CurveFit).k1e = function (history, bodyweightKg, assumedRir, prior) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = history.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if ((element.p1e_1.equals(SetType_STANDARD_getInstance()) || element.p1e_1.equals(SetType_FAILURE_getInstance())) && element.n1e_1 > 0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_elvis_lhs = element_0.q1e_1;
    var key = tmp0_elvis_lhs == null ? 'day:' + element_0.l1e_1 : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = destination_0.v1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_1 = this_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(item, 10));
    var _iterator__ex2g4s_2 = item.j();
    while (_iterator__ex2g4s_2.k()) {
      var item_0 = _iterator__ex2g4s_2.l();
      var tmp_0 = item_0.m1e_1 + bodyweightKg;
      var tmp0_elvis_lhs_0 = item_0.o1e_1;
      var tmp$ret$13 = new Point(tmp_0, item_0.n1e_1 + (tmp0_elvis_lhs_0 == null ? assumedRir : tmp0_elvis_lhs_0) | 0);
      destination_2.f(tmp$ret$13);
    }
    destination_1.f(destination_2);
  }
  var sessions = destination_1;
  return new FlooredExpCurve(this.j1e(sessions, prior));
};
protoOf(CurveFit).r1e = function (history, bodyweightKg, assumedRir, prior, $super) {
  bodyweightKg = bodyweightKg === VOID ? 0.0 : bodyweightKg;
  assumedRir = assumedRir === VOID ? 2 : assumedRir;
  prior = prior === VOID ? 0.958 : prior;
  return $super === VOID ? this.k1e(history, bodyweightKg, assumedRir, prior) : $super.k1e.call(this, history, bodyweightKg, assumedRir, prior);
};
var CurveFit_instance;
function CurveFit_getInstance() {
  return CurveFit_instance;
}
function FixedReps(repsPerSet) {
  repsPerSet = repsPerSet === VOID ? 1.0 : repsPerSet;
  this.s1e_1 = repsPerSet;
  // Inline function 'kotlin.require' call
  if (!(this.s1e_1 >= 0.0)) {
    var message = 'repsPerSet must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(FixedReps).toString = function () {
  return 'FixedReps(repsPerSet=' + this.s1e_1 + ')';
};
protoOf(FixedReps).hashCode = function () {
  return getNumberHashCode(this.s1e_1);
};
protoOf(FixedReps).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FixedReps))
    return false;
  if (!equals(this.s1e_1, other.s1e_1))
    return false;
  return true;
};
function PowerLaw(lambda, alpha, beta) {
  this.t1e_1 = lambda;
  this.u1e_1 = alpha;
  this.v1e_1 = beta;
  // Inline function 'kotlin.require' call
  if (!(this.t1e_1 >= 0.0 && this.u1e_1 >= 0.0 && this.v1e_1 > 0.0)) {
    var message = 'invalid fatigue parameters';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(PowerLaw).w1e = function (reps, rir) {
  // Inline function 'kotlin.math.exp' call
  var x = -this.t1e_1 * rir;
  return reps * Math.exp(x);
};
protoOf(PowerLaw).x1e = function (fatiguingReps) {
  var tmp;
  if (fatiguingReps <= 0.0) {
    tmp = 1.0;
  } else {
    // Inline function 'kotlin.math.pow' call
    var x = this.v1e_1;
    var tmp$ret$0 = Math.pow(fatiguingReps, x);
    // Inline function 'kotlin.math.max' call
    var b = 1.0 - this.u1e_1 * tmp$ret$0;
    tmp = Math.max(0.5, b);
  }
  return tmp;
};
protoOf(PowerLaw).toString = function () {
  return 'PowerLaw(lambda=' + this.t1e_1 + ', alpha=' + this.u1e_1 + ', beta=' + this.v1e_1 + ')';
};
protoOf(PowerLaw).hashCode = function () {
  var result = getNumberHashCode(this.t1e_1);
  result = imul(result, 31) + getNumberHashCode(this.u1e_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.v1e_1) | 0;
  return result;
};
protoOf(PowerLaw).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PowerLaw))
    return false;
  if (!equals(this.t1e_1, other.t1e_1))
    return false;
  if (!equals(this.u1e_1, other.u1e_1))
    return false;
  if (!equals(this.v1e_1, other.v1e_1))
    return false;
  return true;
};
function Companion_10() {
  Companion_instance_12 = this;
  this.y1e_1 = 0.5;
  this.z1e_1 = new PowerLaw(0.5, 0.025, 0.6);
}
var Companion_instance_12;
function Companion_getInstance_10() {
  if (Companion_instance_12 == null)
    new Companion_10();
  return Companion_instance_12;
}
var static_init_called_35;
function static_init_35() {
  if (static_init_called_35)
    return Unit_instance;
  static_init_called_35 = true;
  FatigueChoice_FIXED_instance = new FatigueChoice('FIXED', 0, new FixedReps());
  FatigueChoice_POWER_OURS_instance = new FatigueChoice('POWER_OURS', 1, Companion_getInstance_10().z1e_1);
}
var FatigueChoice_FIXED_instance;
var FatigueChoice_POWER_OURS_instance;
function values_25() {
  static_init_35();
  return [FatigueChoice_FIXED_getInstance(), FatigueChoice_POWER_OURS_getInstance()];
}
function get_entries_20() {
  static_init_35();
  if ($ENTRIES_20 == null)
    $ENTRIES_20 = enumEntries(values_25());
  return $ENTRIES_20;
}
var $ENTRIES_20;
function FatigueChoice(name, ordinal, model) {
  Enum.call(this, name, ordinal);
  this.c1f_1 = model;
}
var static_init_called_36;
function static_init_36() {
  if (static_init_called_36)
    return Unit_instance;
  static_init_called_36 = true;
  SurpriseCarry_NONE_instance = new SurpriseCarry('NONE', 0);
  SurpriseCarry_SYMMETRIC_instance = new SurpriseCarry('SYMMETRIC', 1);
  SurpriseCarry_ASYMMETRIC_instance = new SurpriseCarry('ASYMMETRIC', 2);
  if (Companion_instance_13 == null) {
    Companion_instance_0;
    new Companion_11();
  }
}
var SurpriseCarry_NONE_instance;
var SurpriseCarry_SYMMETRIC_instance;
var SurpriseCarry_ASYMMETRIC_instance;
function Companion_11() {
  this.d1f_1 = 0.25;
}
var Companion_instance_13;
function values_26() {
  static_init_36();
  return [SurpriseCarry_NONE_getInstance(), SurpriseCarry_SYMMETRIC_getInstance(), SurpriseCarry_ASYMMETRIC_getInstance()];
}
function get_entries_21() {
  static_init_36();
  if ($ENTRIES_21 == null)
    $ENTRIES_21 = enumEntries(values_26());
  return $ENTRIES_21;
}
var $ENTRIES_21;
function SurpriseCarry(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(SurpriseCarry).g1f = function (surprise) {
  var tmp;
  switch (this.y1_1) {
    case 0:
      tmp = 0.0;
      break;
    case 1:
      tmp = 1.0;
      break;
    case 2:
      tmp = surprise < 0.0 ? 1.0 : 0.5;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
function FatigueChoice_FIXED_getInstance() {
  static_init_35();
  return FatigueChoice_FIXED_instance;
}
function FatigueChoice_POWER_OURS_getInstance() {
  static_init_35();
  return FatigueChoice_POWER_OURS_instance;
}
function SurpriseCarry_NONE_getInstance() {
  static_init_36();
  return SurpriseCarry_NONE_instance;
}
function SurpriseCarry_SYMMETRIC_getInstance() {
  static_init_36();
  return SurpriseCarry_SYMMETRIC_instance;
}
function SurpriseCarry_ASYMMETRIC_getInstance() {
  static_init_36();
  return SurpriseCarry_ASYMMETRIC_instance;
}
function GeneratorSettingsJson() {
}
protoOf(GeneratorSettingsJson).ng = function (json) {
  var map = JsonRead_instance.og(Json_instance.ng(json), 'settings');
  var defaults = new GeneratorSettings();
  var tmp0_safe_receiver = JsonRead_instance.br(map, 'goal');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_instance_23.h1f(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0 = tmp1_elvis_lhs == null ? defaults.i1f_1 : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = JsonRead_instance.qr(map, 'daysPerWeek');
  var tmp_1 = tmp2_elvis_lhs == null ? defaults.j1f_1 : tmp2_elvis_lhs;
  var tmp3_elvis_lhs = JsonRead_instance.qr(map, 'minutesPerSession');
  var tmp_2 = tmp3_elvis_lhs == null ? defaults.k1f_1 : tmp3_elvis_lhs;
  var tmp0 = get_entries_24();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.x1_1 === JsonRead_instance.br(map, 'experience')) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp4_elvis_lhs = tmp$ret$2;
  var tmp_3 = tmp4_elvis_lhs == null ? defaults.l1f_1 : tmp4_elvis_lhs;
  var tmp0_0 = get_entries_25();
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = tmp0_0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0.x1_1 === JsonRead_instance.br(map, 'split')) {
        tmp$ret$4 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$4 = null;
  }
  var tmp5_elvis_lhs = tmp$ret$4;
  var tmp_4 = tmp5_elvis_lhs == null ? defaults.m1f_1 : tmp5_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_1 = JsonRead_instance.h14(map, 'focus');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = tmp0_1.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver_0 = Companion_instance_17.b1g(element_1);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_5 = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_2 = JsonRead_instance.h14(map, 'deprioritised');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = tmp0_2.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var tmp0_safe_receiver_1 = Companion_instance_17.b1g(element_2);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_1);
    }
  }
  var tmp_6 = destination_0;
  var tmp6_elvis_lhs = JsonRead_instance.tr(map, 'includeDeloads');
  var tmp_7 = tmp6_elvis_lhs == null ? defaults.p1f_1 : tmp6_elvis_lhs;
  var tmp7_safe_receiver = JsonRead_instance.br(map, 'deload');
  var tmp_8;
  if (tmp7_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_8 = Companion_instance_24.h1f(tmp7_safe_receiver);
  }
  var tmp8_elvis_lhs = tmp_8;
  var tmp_9 = tmp8_elvis_lhs == null ? defaults.q1f_1 : tmp8_elvis_lhs;
  var tmp9_elvis_lhs = JsonRead_instance.qr(map, 'cycles');
  var tmp_10 = tmp9_elvis_lhs == null ? defaults.r1f_1 : tmp9_elvis_lhs;
  var tmp10_safe_receiver = JsonRead_instance.br(map, 'progression');
  var tmp_11;
  if (tmp10_safe_receiver == null) {
    tmp_11 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_11 = Companion_instance_20.h1f(tmp10_safe_receiver);
  }
  var tmp11_elvis_lhs = tmp_11;
  var tmp_12 = tmp11_elvis_lhs == null ? defaults.s1f_1 : tmp11_elvis_lhs;
  var tmp_13 = toSet(JsonRead_instance.h14(map, 'excludedExercises'));
  var tmp_14 = JsonRead_instance.br(map, 'name');
  var tmp12_elvis_lhs = JsonRead_instance.tr(map, 'useLibraryRanks');
  var tmp_15 = tmp12_elvis_lhs == null ? defaults.v1f_1 : tmp12_elvis_lhs;
  var tmp_16 = toSet(JsonRead_instance.h14(map, 'skills'));
  var tmp_17 = map.t1('familiar');
  var tmp13_safe_receiver = (!(tmp_17 == null) ? isInterface(tmp_17, KtMap) : false) ? tmp_17 : null;
  var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.w1();
  var tmp_18;
  if (tmp14_safe_receiver == null) {
    tmp_18 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_1 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = tmp14_safe_receiver.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_3 = _iterator__ex2g4s_3.l();
      // Inline function 'kotlin.collections.component1' call
      var id = element_3.p1();
      // Inline function 'kotlin.collections.component2' call
      var count = element_3.q1();
      var tmp0_safe_receiver_2 = (!(id == null) ? typeof id === 'string' : false) ? id : null;
      var tmp_19;
      if (tmp0_safe_receiver_2 == null) {
        tmp_19 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_3 = isNumber(count) ? count : null;
        var tmp1_safe_receiver = tmp0_safe_receiver_3 == null ? null : numberToInt(tmp0_safe_receiver_3);
        var tmp_20;
        if (tmp1_safe_receiver == null) {
          tmp_20 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_20 = to(tmp0_safe_receiver_2, tmp1_safe_receiver);
        }
        tmp_19 = tmp_20;
      }
      var tmp0_safe_receiver_4 = tmp_19;
      if (tmp0_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_1.f(tmp0_safe_receiver_4);
      }
    }
    tmp_18 = destination_1;
  }
  var tmp15_safe_receiver = tmp_18;
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = tmp15_safe_receiver == null ? null : toMap(tmp15_safe_receiver);
  var tmp_21 = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  var tmp0_3 = get_entries_26();
  var tmp$ret$38;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_4 = tmp0_3.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_4 = _iterator__ex2g4s_4.l();
      if (element_4.x1_1 === JsonRead_instance.br(map, 'compoundSets')) {
        tmp$ret$38 = element_4;
        break $l$block_1;
      }
    }
    tmp$ret$38 = null;
  }
  var tmp16_elvis_lhs = tmp$ret$38;
  var tmp_22 = tmp16_elvis_lhs == null ? defaults.y1f_1 : tmp16_elvis_lhs;
  var tmp0_4 = get_entries_27();
  var tmp$ret$40;
  $l$block_2: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_5 = tmp0_4.j();
    while (_iterator__ex2g4s_5.k()) {
      var element_5 = _iterator__ex2g4s_5.l();
      if (element_5.x1_1 === JsonRead_instance.br(map, 'rest')) {
        tmp$ret$40 = element_5;
        break $l$block_2;
      }
    }
    tmp$ret$40 = null;
  }
  var tmp17_elvis_lhs = tmp$ret$40;
  var tmp_23 = tmp17_elvis_lhs == null ? defaults.z1f_1 : tmp17_elvis_lhs;
  var tmp18_elvis_lhs = JsonRead_instance.tr(map, 'powerWork');
  return new GeneratorSettings(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_9, tmp_10, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_21, tmp_22, tmp_23, tmp18_elvis_lhs == null ? defaults.a1g_1 : tmp18_elvis_lhs);
};
var GeneratorSettingsJson_instance;
function GeneratorSettingsJson_getInstance() {
  return GeneratorSettingsJson_instance;
}
function Barbell(name, kg) {
  this.c1g_1 = name;
  this.d1g_1 = kg;
}
protoOf(Barbell).toString = function () {
  return 'Barbell(name=' + this.c1g_1 + ', kg=' + this.d1g_1 + ')';
};
protoOf(Barbell).hashCode = function () {
  var result = getStringHashCode(this.c1g_1);
  result = imul(result, 31) + getNumberHashCode(this.d1g_1) | 0;
  return result;
};
protoOf(Barbell).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Barbell))
    return false;
  if (!(this.c1g_1 === other.c1g_1))
    return false;
  if (!equals(this.d1g_1, other.d1g_1))
    return false;
  return true;
};
function PlatePair(kg, pairs, unit) {
  unit = unit === VOID ? null : unit;
  this.e1g_1 = kg;
  this.f1g_1 = pairs;
  this.g1g_1 = unit;
}
protoOf(PlatePair).toString = function () {
  return 'PlatePair(kg=' + this.e1g_1 + ', pairs=' + this.f1g_1 + ', unit=' + this.g1g_1 + ')';
};
protoOf(PlatePair).hashCode = function () {
  var result = getNumberHashCode(this.e1g_1);
  result = imul(result, 31) + this.f1g_1 | 0;
  result = imul(result, 31) + (this.g1g_1 == null ? 0 : getStringHashCode(this.g1g_1)) | 0;
  return result;
};
protoOf(PlatePair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlatePair))
    return false;
  if (!equals(this.e1g_1, other.e1g_1))
    return false;
  if (!(this.f1g_1 === other.f1g_1))
    return false;
  if (!(this.g1g_1 == other.g1g_1))
    return false;
  return true;
};
function DumbbellRange(fromKg, toKg, stepKg) {
  this.h1g_1 = fromKg;
  this.i1g_1 = toKg;
  this.j1g_1 = stepKg;
}
protoOf(DumbbellRange).toString = function () {
  return 'DumbbellRange(fromKg=' + this.h1g_1 + ', toKg=' + this.i1g_1 + ', stepKg=' + this.j1g_1 + ')';
};
protoOf(DumbbellRange).hashCode = function () {
  var result = getNumberHashCode(this.h1g_1);
  result = imul(result, 31) + getNumberHashCode(this.i1g_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.j1g_1) | 0;
  return result;
};
protoOf(DumbbellRange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DumbbellRange))
    return false;
  if (!equals(this.h1g_1, other.h1g_1))
    return false;
  if (!equals(this.i1g_1, other.i1g_1))
    return false;
  if (!equals(this.j1g_1, other.j1g_1))
    return false;
  return true;
};
var static_init_called_37;
function static_init_37() {
  if (static_init_called_37)
    return Unit_instance;
  static_init_called_37 = true;
  MicroMode_ANY_instance = new MicroMode('ANY', 0);
  MicroMode_ONE_instance = new MicroMode('ONE', 1);
}
var MicroMode_ANY_instance;
var MicroMode_ONE_instance;
function values_27() {
  static_init_37();
  return [MicroMode_ANY_getInstance(), MicroMode_ONE_getInstance()];
}
function get_entries_22() {
  static_init_37();
  if ($ENTRIES_22 == null)
    $ENTRIES_22 = enumEntries(values_27());
  return $ENTRIES_22;
}
var $ENTRIES_22;
function MicroMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeightStack(name, ranges, microKg, microMode) {
  microKg = microKg === VOID ? emptyList() : microKg;
  microMode = microMode === VOID ? MicroMode_ANY_getInstance() : microMode;
  this.k1g_1 = name;
  this.l1g_1 = ranges;
  this.m1g_1 = microKg;
  this.n1g_1 = microMode;
}
protoOf(WeightStack).toString = function () {
  return 'WeightStack(name=' + this.k1g_1 + ', ranges=' + toString(this.l1g_1) + ', microKg=' + toString(this.m1g_1) + ', microMode=' + this.n1g_1.toString() + ')';
};
protoOf(WeightStack).hashCode = function () {
  var result = getStringHashCode(this.k1g_1);
  result = imul(result, 31) + hashCode(this.l1g_1) | 0;
  result = imul(result, 31) + hashCode(this.m1g_1) | 0;
  result = imul(result, 31) + this.n1g_1.hashCode() | 0;
  return result;
};
protoOf(WeightStack).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightStack))
    return false;
  if (!(this.k1g_1 === other.k1g_1))
    return false;
  if (!equals(this.l1g_1, other.l1g_1))
    return false;
  if (!equals(this.m1g_1, other.m1g_1))
    return false;
  if (!this.n1g_1.equals(other.n1g_1))
    return false;
  return true;
};
function plates($this, value) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = objects($this, value);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block: {
      var tmp0_elvis_lhs = JsonRead_instance.cr(element, 'kg');
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var kg = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.qr(element, 'pairs');
      var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp2_safe_receiver = JsonRead_instance.br(element, 'unit');
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        if (tmp2_safe_receiver === 'kg' || tmp2_safe_receiver === 'lb') {
          tmp_2 = tmp2_safe_receiver;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      }
      // Inline function 'kotlin.takeIf' call
      var this_0 = new PlatePair(kg, tmp_0, tmp_1);
      var tmp_3;
      if (kg > 0.0 && this_0.f1g_1 > 0) {
        tmp_3 = this_0;
      } else {
        tmp_3 = null;
      }
      tmp$ret$4 = tmp_3;
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function objects($this, value) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.rr(value);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function plateMap($this, plate) {
  // Inline function 'kotlin.apply' call
  var this_0 = linkedMapOf([to('kg', plate.e1g_1), to('pairs', plate.f1g_1)]);
  var tmp0_safe_receiver = plate.g1g_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.l2('unit', tmp0_safe_receiver);
  }
  return this_0;
}
function Companion_12() {
  Companion_instance_14 = this;
  this.o1g_1 = setOf(['bumperPlates', 'offsets']);
}
protoOf(Companion_12).p1g = function (json) {
  return this.q1g(JsonRead_instance.og(Json_instance.ng(json), 'GYM'));
};
protoOf(Companion_12).q1g = function (map) {
  var tmp0_elvis_lhs = JsonRead_instance.br(map, 'name');
  var tmp5_name = tmp0_elvis_lhs == null ? 'Gym' : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = JsonRead_instance.tr(map, 'isDefault');
  var tmp6_isDefault = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.rr(map.t1('barbells'));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block: {
      var tmp0_elvis_lhs_0 = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs_0 == null) {
        tmp$ret$4 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs_0;
      }
      var bar = tmp;
      var m = isInterface(bar, KtMap) ? bar : THROW_CCE();
      var tmp1_safe_receiver = JsonRead_instance.cr(m, 'kg');
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_elvis_lhs_1 = JsonRead_instance.br(m, 'name');
        tmp_0 = new Barbell(tmp0_elvis_lhs_1 == null ? 'Bar' : tmp0_elvis_lhs_1, tmp1_safe_receiver);
      }
      tmp$ret$4 = tmp_0;
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var tmp8_plates = plates(this, map.t1('plates'));
  var tmp9_bumperPlates = plates(this, map.t1('bumperPlates'));
  var tmp_1 = map.t1('offsets');
  var tmp2_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w1();
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp3_safe_receiver.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$13;
      $l$block_1: {
        // Inline function 'kotlin.collections.component1' call
        var key = element_0.p1();
        // Inline function 'kotlin.collections.component2' call
        var kg = element_0.q1();
        var tmp0_0 = get_entries_32();
        var tmp$ret$16;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_1 = tmp0_0.j();
          while (_iterator__ex2g4s_1.k()) {
            var element_1 = _iterator__ex2g4s_1.l();
            if (equals(element_1.t1g_1, key)) {
              tmp$ret$16 = element_1;
              break $l$block_0;
            }
          }
          tmp$ret$16 = null;
        }
        var tmp0_elvis_lhs_2 = tmp$ret$16;
        var tmp_3;
        if (tmp0_elvis_lhs_2 == null) {
          tmp$ret$13 = null;
          break $l$block_1;
        } else {
          tmp_3 = tmp0_elvis_lhs_2;
        }
        var equipment = tmp_3;
        var tmp1_safe_receiver_0 = isNumber(kg) ? kg : null;
        var tmp2_safe_receiver_0 = tmp1_safe_receiver_0 == null ? null : numberToDouble(tmp1_safe_receiver_0);
        var tmp_4;
        if (tmp2_safe_receiver_0 == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_5;
          if (isFinite(tmp2_safe_receiver_0)) {
            tmp_5 = tmp2_safe_receiver_0;
          } else {
            tmp_5 = null;
          }
          tmp_4 = tmp_5;
        }
        var tmp3_safe_receiver_0 = tmp_4;
        var tmp_6;
        if (tmp3_safe_receiver_0 == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_6 = to(equipment, tmp3_safe_receiver_0);
        }
        tmp$ret$13 = tmp_6;
      }
      var tmp0_safe_receiver_0 = tmp$ret$13;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.f(tmp0_safe_receiver_0);
      }
    }
    tmp_2 = destination_0;
  }
  var tmp4_safe_receiver = tmp_2;
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs_3 = tmp4_safe_receiver == null ? null : toMap(tmp4_safe_receiver);
  var tmp10_offsets = tmp0_elvis_lhs_3 == null ? emptyMap() : tmp0_elvis_lhs_3;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_1 = objects(this, map.t1('dumbbells'));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = tmp0_1.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var tmp$ret$29;
    $l$block_4: {
      var tmp0_elvis_lhs_4 = JsonRead_instance.cr(element_2, 'fromKg');
      var tmp_7;
      if (tmp0_elvis_lhs_4 == null) {
        tmp$ret$29 = null;
        break $l$block_4;
      } else {
        tmp_7 = tmp0_elvis_lhs_4;
      }
      var from = tmp_7;
      var tmp1_elvis_lhs_0 = JsonRead_instance.cr(element_2, 'toKg');
      var tmp_8;
      if (tmp1_elvis_lhs_0 == null) {
        tmp$ret$29 = null;
        break $l$block_4;
      } else {
        tmp_8 = tmp1_elvis_lhs_0;
      }
      var to_0 = tmp_8;
      var tmp2_elvis_lhs = JsonRead_instance.cr(element_2, 'stepKg');
      var tmp_9;
      if (tmp2_elvis_lhs == null) {
        tmp$ret$29 = null;
        break $l$block_4;
      } else {
        tmp_9 = tmp2_elvis_lhs;
      }
      var step = tmp_9;
      // Inline function 'kotlin.takeIf' call
      var this_0 = new DumbbellRange(from, to_0, step);
      var tmp_10;
      if (step > 0.0 && to_0 >= from) {
        tmp_10 = this_0;
      } else {
        tmp_10 = null;
      }
      tmp$ret$29 = tmp_10;
    }
    var tmp0_safe_receiver_1 = tmp$ret$29;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_1);
    }
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = objects(this, map.t1('stacks'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_3 = this_1.j();
  while (_iterator__ex2g4s_3.k()) {
    var item = _iterator__ex2g4s_3.l();
    var tmp0_elvis_lhs_5 = JsonRead_instance.br(item, 'name');
    var tmp_11 = tmp0_elvis_lhs_5 == null ? 'Stack' : tmp0_elvis_lhs_5;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_2 = objects(Companion_getInstance_11(), item.t1('ranges'));
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_3 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_4 = tmp0_2.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      var tmp$ret$41;
      $l$block_7: {
        var tmp0_elvis_lhs_6 = JsonRead_instance.cr(element_3, 'startKg');
        var tmp_12;
        if (tmp0_elvis_lhs_6 == null) {
          tmp$ret$41 = null;
          break $l$block_7;
        } else {
          tmp_12 = tmp0_elvis_lhs_6;
        }
        var start = tmp_12;
        var tmp1_elvis_lhs_1 = JsonRead_instance.cr(element_3, 'endKg');
        var tmp_13;
        if (tmp1_elvis_lhs_1 == null) {
          tmp$ret$41 = null;
          break $l$block_7;
        } else {
          tmp_13 = tmp1_elvis_lhs_1;
        }
        var end = tmp_13;
        var tmp2_elvis_lhs_0 = JsonRead_instance.cr(element_3, 'incrementKg');
        var tmp_14;
        if (tmp2_elvis_lhs_0 == null) {
          tmp$ret$41 = null;
          break $l$block_7;
        } else {
          tmp_14 = tmp2_elvis_lhs_0;
        }
        var increment = tmp_14;
        // Inline function 'kotlin.takeIf' call
        var this_2 = new StackRange(start, end, increment);
        var tmp_15;
        if (increment > 0.0 && end >= start) {
          tmp_15 = this_2;
        } else {
          tmp_15 = null;
        }
        tmp$ret$41 = tmp_15;
      }
      var tmp0_safe_receiver_2 = tmp$ret$41;
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_3.f(tmp0_safe_receiver_2);
      }
    }
    var tmp_16 = destination_3;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_3 = JsonRead_instance.i14(item, 'microKg');
    // Inline function 'kotlin.collections.filterTo' call
    var destination_4 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_5 = tmp0_3.j();
    while (_iterator__ex2g4s_5.k()) {
      var element_4 = _iterator__ex2g4s_5.l();
      if (element_4 > 0.0) {
        destination_4.f(element_4);
      }
    }
    var tmp_17 = destination_4;
    var tmp0_4 = get_entries_22();
    var tmp$ret$49;
    $l$block_8: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_6 = tmp0_4.j();
      while (_iterator__ex2g4s_6.k()) {
        var element_5 = _iterator__ex2g4s_6.l();
        if (element_5.x1_1 === JsonRead_instance.br(item, 'microMode')) {
          tmp$ret$49 = element_5;
          break $l$block_8;
        }
      }
      tmp$ret$49 = null;
    }
    var tmp1_elvis_lhs_2 = tmp$ret$49;
    var tmp$ret$36 = new WeightStack(tmp_11, tmp_16, tmp_17, tmp1_elvis_lhs_2 == null ? MicroMode_ANY_getInstance() : tmp1_elvis_lhs_2);
    destination_2.f(tmp$ret$36);
  }
  // Inline function 'kotlin.collections.filter' call
  var tmp0_5 = JsonRead_instance.i14(map, 'kettlebells');
  // Inline function 'kotlin.collections.filterTo' call
  var destination_5 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_7 = tmp0_5.j();
  while (_iterator__ex2g4s_7.k()) {
    var element_6 = _iterator__ex2g4s_7.l();
    if (element_6 > 0.0) {
      destination_5.f(element_6);
    }
  }
  var tmp14_bands = JsonRead_instance.h14(map, 'bands');
  var tmp15_excludedExercises = toSet(JsonRead_instance.h14(map, 'excludedExercises'));
  return new Gym(tmp5_name, tmp6_isDefault, destination, tmp8_plates, destination_1, destination_2, destination_5, tmp14_bands, tmp15_excludedExercises, tmp9_bumperPlates, tmp10_offsets);
};
protoOf(Companion_12).u1g = function (kind) {
  var tmp;
  switch (kind.y1_1) {
    case 0:
      var tmp_0 = listOf_0(new Barbell('Olympic bar', 20.0));
      // Inline function 'kotlin.collections.map' call

      var this_0 = listOf([to(20.0, 2), to(10.0, 2), to(5.0, 2), to(2.5, 2), to(1.25, 2)]);
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.j();
      while (_iterator__ex2g4s.k()) {
        var item = _iterator__ex2g4s.l();
        var tmp$ret$2 = new PlatePair(item.nb_1, item.ob_1);
        destination.f(tmp$ret$2);
      }

      tmp = new Gym('Home', VOID, tmp_0, destination, listOf_0(new DumbbellRange(2.0, 30.0, 2.0)));
      break;
    case 1:
      var tmp_1 = listOf([new Barbell('Olympic bar', 20.0), new Barbell('Smith machine', 15.0)]);
      // Inline function 'kotlin.collections.map' call

      var this_1 = listOf([to(25.0, 4), to(20.0, 4), to(15.0, 2), to(10.0, 2), to(5.0, 2), to(2.5, 2), to(1.25, 2)]);
      // Inline function 'kotlin.collections.mapTo' call

      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_0 = this_1.j();
      while (_iterator__ex2g4s_0.k()) {
        var item_0 = _iterator__ex2g4s_0.l();
        var tmp$ret$5 = new PlatePair(item_0.nb_1, item_0.ob_1);
        destination_0.f(tmp$ret$5);
      }

      tmp = new Gym('Commercial gym', VOID, tmp_1, destination_0, listOf_0(new DumbbellRange(2.0, 50.0, 2.0)), listOf([new WeightStack('Cable stack', listOf_0(new StackRange(5.0, 100.0, 5.0)), listOf_0(2.5)), new WeightStack('Machine stack', listOf_0(new StackRange(10.0, 150.0, 10.0)), listOf_0(5.0), MicroMode_ONE_getInstance())]), listOf([8.0, 12.0, 16.0, 20.0, 24.0, 28.0, 32.0]), listOf(['light', 'medium', 'heavy']));
      break;
    case 2:
      tmp = new Gym('Hotel', VOID, VOID, VOID, listOf_0(new DumbbellRange(2.0, 25.0, 2.0)));
      break;
    case 3:
      tmp = new Gym('Gym');
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Companion_instance_14;
function Companion_getInstance_11() {
  if (Companion_instance_14 == null)
    new Companion_12();
  return Companion_instance_14;
}
function Gym(name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets) {
  Companion_getInstance_11();
  name = name === VOID ? 'Gym' : name;
  isDefault = isDefault === VOID ? false : isDefault;
  barbells = barbells === VOID ? emptyList() : barbells;
  plates = plates === VOID ? emptyList() : plates;
  dumbbells = dumbbells === VOID ? emptyList() : dumbbells;
  stacks = stacks === VOID ? emptyList() : stacks;
  kettlebells = kettlebells === VOID ? emptyList() : kettlebells;
  bands = bands === VOID ? emptyList() : bands;
  excludedExercises = excludedExercises === VOID ? emptySet() : excludedExercises;
  bumperPlates = bumperPlates === VOID ? emptyList() : bumperPlates;
  offsets = offsets === VOID ? emptyMap() : offsets;
  this.v1g_1 = name;
  this.w1g_1 = isDefault;
  this.x1g_1 = barbells;
  this.y1g_1 = plates;
  this.z1g_1 = dumbbells;
  this.a1h_1 = stacks;
  this.b1h_1 = kettlebells;
  this.c1h_1 = bands;
  this.d1h_1 = excludedExercises;
  this.e1h_1 = bumperPlates;
  this.f1h_1 = offsets;
}
protoOf(Gym).g1h = function () {
  // Inline function 'kotlin.text.trim' call
  var this_0 = this.v1g_1;
  // Inline function 'kotlin.text.ifEmpty' call
  var this_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_1) === 0) {
    tmp = 'Gym';
  } else {
    tmp = this_1;
  }
  var tmp$ret$1 = tmp;
  var tmp_0 = to('name', tmp$ret$1);
  var tmp_1 = to('isDefault', this.w1g_1);
  // Inline function 'kotlin.collections.map' call
  var this_2 = this.x1g_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$6 = linkedMapOf([to('name', item.c1g_1), to('kg', item.d1g_1)]);
    destination.f(tmp$ret$6);
  }
  var tmp_2 = to('barbells', destination);
  // Inline function 'kotlin.collections.map' call
  var this_3 = this.y1g_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$9 = plateMap(this, item_0);
    destination_0.f(tmp$ret$9);
  }
  var tmp_3 = to('plates', destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_4 = this.z1g_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_1 = this_4.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$12 = linkedMapOf([to('fromKg', item_1.h1g_1), to('toKg', item_1.i1g_1), to('stepKg', item_1.j1g_1)]);
    destination_1.f(tmp$ret$12);
  }
  var tmp_4 = to('dumbbells', destination_1);
  // Inline function 'kotlin.collections.map' call
  var this_5 = this.a1h_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_2 = this_5.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_2 = _iterator__ex2g4s_2.l();
    var tmp_5 = to('name', item_2.k1g_1);
    // Inline function 'kotlin.collections.map' call
    var this_6 = item_2.l1g_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_6, 10));
    var _iterator__ex2g4s_3 = this_6.j();
    while (_iterator__ex2g4s_3.k()) {
      var item_3 = _iterator__ex2g4s_3.l();
      var tmp$ret$18 = linkedMapOf([to('startKg', item_3.h1h_1), to('endKg', item_3.i1h_1), to('incrementKg', item_3.j1h_1)]);
      destination_3.f(tmp$ret$18);
    }
    // Inline function 'kotlin.apply' call
    var this_7 = linkedMapOf([tmp_5, to('ranges', destination_3), to('microKg', item_2.m1g_1)]);
    if (!item_2.n1g_1.equals(MicroMode_ANY_getInstance())) {
      this_7.l2('microMode', item_2.n1g_1.x1_1);
    }
    destination_2.f(this_7);
  }
  // Inline function 'kotlin.apply' call
  var this_8 = linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('stacks', destination_2), to('kettlebells', this.b1h_1), to('bands', this.c1h_1), to('excludedExercises', sorted(this.d1h_1))]);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!this.e1h_1.m()) {
    // Inline function 'kotlin.collections.map' call
    var this_9 = this.e1h_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
    var _iterator__ex2g4s_4 = this_9.j();
    while (_iterator__ex2g4s_4.k()) {
      var item_4 = _iterator__ex2g4s_4.l();
      var tmp$ret$26 = plateMap(this, item_4);
      destination_4.f(tmp$ret$26);
    }
    this_8.l2('bumperPlates', destination_4);
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!this.f1h_1.m()) {
    // Inline function 'kotlin.collections.associate' call
    var this_10 = this.f1h_1.w1();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_10, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_5 = LinkedHashMap_init_$Create$(capacity);
    var _iterator__ex2g4s_5 = this_10.j();
    while (_iterator__ex2g4s_5.k()) {
      var element = _iterator__ex2g4s_5.l();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.p1().t1g_1, element.q1());
      destination_5.l2(pair.nb_1, pair.ob_1);
    }
    this_8.l2('offsets', destination_5);
  }
  return this_8;
};
protoOf(Gym).k1h = function (equipment) {
  var tmp;
  switch (equipment.y1_1) {
    case 0:
      var tmp0 = this.x1g_1;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.m();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.j();
        while (_iterator__ex2g4s.k()) {
          var element = _iterator__ex2g4s.l();
          if (!isSmith(element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }

      tmp = tmp$ret$0;
      break;
    case 1:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.z1g_1.m();
      break;
    case 2:
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call

      if (!this.a1h_1.m()) {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_1 = !this.y1g_1.m();
      }

      tmp = tmp_1;
      break;
    case 3:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.a1h_1.m();
      break;
    case 4:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.b1h_1.m();
      break;
    case 5:
      tmp = true;
      break;
    case 6:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.c1h_1.m();
      break;
    case 7:
      var tmp0_0 = this.x1g_1;
      var tmp$ret$8;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_2;
        if (isInterface(tmp0_0, Collection)) {
          tmp_2 = tmp0_0.m();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$8 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp0_0.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          if (isSmith(element_0)) {
            tmp$ret$8 = true;
            break $l$block_2;
          }
        }
        tmp$ret$8 = false;
      }

      tmp = tmp$ret$8;
      break;
    case 8:
      tmp = false;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(Gym).l1h = function (equipment) {
  var tmp;
  if (equipment.equals(Equipment_SMITH_getInstance())) {
    var tmp0 = this.x1g_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (isSmith(element)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    tmp = tmp$ret$0;
  } else {
    var tmp0_0 = this.x1g_1;
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (!isSmith(element_0)) {
          tmp$ret$2 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$2;
    tmp = tmp0_elvis_lhs == null ? firstOrNull(this.x1g_1) : tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Gym).m1h = function (name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets) {
  return new Gym(name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets);
};
protoOf(Gym).n1h = function (name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets, $super) {
  name = name === VOID ? this.v1g_1 : name;
  isDefault = isDefault === VOID ? this.w1g_1 : isDefault;
  barbells = barbells === VOID ? this.x1g_1 : barbells;
  plates = plates === VOID ? this.y1g_1 : plates;
  dumbbells = dumbbells === VOID ? this.z1g_1 : dumbbells;
  stacks = stacks === VOID ? this.a1h_1 : stacks;
  kettlebells = kettlebells === VOID ? this.b1h_1 : kettlebells;
  bands = bands === VOID ? this.c1h_1 : bands;
  excludedExercises = excludedExercises === VOID ? this.d1h_1 : excludedExercises;
  bumperPlates = bumperPlates === VOID ? this.e1h_1 : bumperPlates;
  offsets = offsets === VOID ? this.f1h_1 : offsets;
  return $super === VOID ? this.m1h(name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets) : $super.m1h.call(this, name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets);
};
protoOf(Gym).toString = function () {
  return 'Gym(name=' + this.v1g_1 + ', isDefault=' + this.w1g_1 + ', barbells=' + toString(this.x1g_1) + ', plates=' + toString(this.y1g_1) + ', dumbbells=' + toString(this.z1g_1) + ', stacks=' + toString(this.a1h_1) + ', kettlebells=' + toString(this.b1h_1) + ', bands=' + toString(this.c1h_1) + ', excludedExercises=' + toString(this.d1h_1) + ', bumperPlates=' + toString(this.e1h_1) + ', offsets=' + toString(this.f1h_1) + ')';
};
protoOf(Gym).hashCode = function () {
  var result = getStringHashCode(this.v1g_1);
  result = imul(result, 31) + getBooleanHashCode(this.w1g_1) | 0;
  result = imul(result, 31) + hashCode(this.x1g_1) | 0;
  result = imul(result, 31) + hashCode(this.y1g_1) | 0;
  result = imul(result, 31) + hashCode(this.z1g_1) | 0;
  result = imul(result, 31) + hashCode(this.a1h_1) | 0;
  result = imul(result, 31) + hashCode(this.b1h_1) | 0;
  result = imul(result, 31) + hashCode(this.c1h_1) | 0;
  result = imul(result, 31) + hashCode(this.d1h_1) | 0;
  result = imul(result, 31) + hashCode(this.e1h_1) | 0;
  result = imul(result, 31) + hashCode(this.f1h_1) | 0;
  return result;
};
protoOf(Gym).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Gym))
    return false;
  if (!(this.v1g_1 === other.v1g_1))
    return false;
  if (!(this.w1g_1 === other.w1g_1))
    return false;
  if (!equals(this.x1g_1, other.x1g_1))
    return false;
  if (!equals(this.y1g_1, other.y1g_1))
    return false;
  if (!equals(this.z1g_1, other.z1g_1))
    return false;
  if (!equals(this.a1h_1, other.a1h_1))
    return false;
  if (!equals(this.b1h_1, other.b1h_1))
    return false;
  if (!equals(this.c1h_1, other.c1h_1))
    return false;
  if (!equals(this.d1h_1, other.d1h_1))
    return false;
  if (!equals(this.e1h_1, other.e1h_1))
    return false;
  if (!equals(this.f1h_1, other.f1h_1))
    return false;
  return true;
};
var static_init_called_38;
function static_init_38() {
  if (static_init_called_38)
    return Unit_instance;
  static_init_called_38 = true;
  GymTemplate_HOME_instance = new GymTemplate('HOME', 0);
  GymTemplate_COMMERCIAL_instance = new GymTemplate('COMMERCIAL', 1);
  GymTemplate_HOTEL_instance = new GymTemplate('HOTEL', 2);
  GymTemplate_BLANK_instance = new GymTemplate('BLANK', 3);
}
var GymTemplate_HOME_instance;
var GymTemplate_COMMERCIAL_instance;
var GymTemplate_HOTEL_instance;
var GymTemplate_BLANK_instance;
function valueOf_10(value) {
  static_init_38();
  switch (value) {
    case 'HOME':
      return GymTemplate_HOME_getInstance();
    case 'COMMERCIAL':
      return GymTemplate_COMMERCIAL_getInstance();
    case 'HOTEL':
      return GymTemplate_HOTEL_getInstance();
    case 'BLANK':
      return GymTemplate_BLANK_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.GymTemplate.' + value);
      break;
  }
}
function GymTemplate(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function isSmith(_this__u8e3s4) {
  return contains_1(_this__u8e3s4.c1g_1, 'smith', true);
}
var static_init_called_39;
function static_init_39() {
  if (static_init_called_39)
    return Unit_instance;
  static_init_called_39 = true;
  LoadRounding_DOWN_instance = new LoadRounding('DOWN', 0);
  LoadRounding_UP_instance = new LoadRounding('UP', 1);
  LoadRounding_NEAREST_instance = new LoadRounding('NEAREST', 2);
}
var LoadRounding_DOWN_instance;
var LoadRounding_UP_instance;
var LoadRounding_NEAREST_instance;
function valueOf_11(value) {
  static_init_39();
  switch (value) {
    case 'DOWN':
      return LoadRounding_DOWN_getInstance();
    case 'UP':
      return LoadRounding_UP_getInstance();
    case 'NEAREST':
      return LoadRounding_NEAREST_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.LoadRounding.' + value);
      break;
  }
}
function LoadRounding(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function PlateLoadout(targetKg, barKg, platesPerSide, achievedKg, remainderKg, exact) {
  this.o1h_1 = targetKg;
  this.p1h_1 = barKg;
  this.q1h_1 = platesPerSide;
  this.r1h_1 = achievedKg;
  this.s1h_1 = remainderKg;
  this.t1h_1 = exact;
}
protoOf(PlateLoadout).toString = function () {
  return 'PlateLoadout(targetKg=' + this.o1h_1 + ', barKg=' + this.p1h_1 + ', platesPerSide=' + toString(this.q1h_1) + ', achievedKg=' + this.r1h_1 + ', remainderKg=' + this.s1h_1 + ', exact=' + this.t1h_1 + ')';
};
protoOf(PlateLoadout).hashCode = function () {
  var result = getNumberHashCode(this.o1h_1);
  result = imul(result, 31) + getNumberHashCode(this.p1h_1) | 0;
  result = imul(result, 31) + hashCode(this.q1h_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1h_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.s1h_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t1h_1) | 0;
  return result;
};
protoOf(PlateLoadout).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlateLoadout))
    return false;
  if (!equals(this.o1h_1, other.o1h_1))
    return false;
  if (!equals(this.p1h_1, other.p1h_1))
    return false;
  if (!equals(this.q1h_1, other.q1h_1))
    return false;
  if (!equals(this.r1h_1, other.r1h_1))
    return false;
  if (!equals(this.s1h_1, other.s1h_1))
    return false;
  if (!(this.t1h_1 === other.t1h_1))
    return false;
  return true;
};
function subsetSums($this, weights, max) {
  var sums = setOf_0(0.0);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weights.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var weight = _iterator__ex2g4s_0.l();
    var next = HashSet_init_$Create$_0(sums);
    var _iterator__ex2g4s_1 = sums.j();
    while (_iterator__ex2g4s_1.k()) {
      var sum = _iterator__ex2g4s_1.l();
      var total = $this.v1h(sum + weight);
      if (total <= max + 1.0E-9) {
        next.f(total);
      }
    }
    sums = next;
  }
  return sorted(sums);
}
function Loads() {
  this.u1h_1 = 500.0;
}
protoOf(Loads).w1h = function (barKg, plates, maxLoadKg) {
  // Inline function 'kotlin.require' call
  if (!(barKg >= 0.0)) {
    var message = 'barKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = plates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = element.f1g_1;
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$9 = element.e1g_1;
        list.f(tmp$ret$9);
      }
       while (inductionVariable < size);
    var list_0 = list;
    addAll(destination, list_0);
  }
  var perSide = subsetSums(this, destination, (maxLoadKg - barKg) / 2.0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(perSide, 10));
  var _iterator__ex2g4s_0 = perSide.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$12 = Loads_instance.v1h(barKg + 2.0 * item);
    destination_0.f(tmp$ret$12);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_0 = _iterator__ex2g4s_1.l();
    if (element_0 <= maxLoadKg + 1.0E-9) {
      destination_1.f(element_0);
    }
  }
  return sorted(distinct(destination_1));
};
protoOf(Loads).x1h = function (plates, maxLoadKg) {
  return this.w1h(0.0, plates, maxLoadKg);
};
protoOf(Loads).y1h = function (ranges) {
  var loads = HashSet_init_$Create$();
  var _iterator__ex2g4s = ranges.j();
  while (_iterator__ex2g4s.k()) {
    var range = _iterator__ex2g4s.l();
    // Inline function 'kotlin.require' call
    if (!(range.j1g_1 > 0.0 && range.i1g_1 >= range.h1g_1)) {
      var message = 'invalid dumbbell range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var load = range.h1g_1;
    while (load <= range.i1g_1 + 1.0E-9) {
      loads.f(this.v1h(load));
      load = load + range.j1g_1;
    }
  }
  return sorted(loads);
};
protoOf(Loads).z1h = function (stack) {
  var settings = Strength_instance.b1i(stack.l1g_1);
  var tmp;
  switch (stack.n1g_1.y1_1) {
    case 0:
      tmp = subsetSums(this, stack.m1g_1, 1.7976931348623157E308);
      break;
    case 1:
      tmp = plus(listOf_0(0.0), stack.m1g_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var extras = tmp;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = settings.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(extras, 10));
    var _iterator__ex2g4s_0 = extras.j();
    while (_iterator__ex2g4s_0.k()) {
      var item = _iterator__ex2g4s_0.l();
      var tmp$ret$5 = Loads_instance.v1h(element + item);
      destination_0.f(tmp$ret$5);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return sorted(distinct(destination));
};
protoOf(Loads).c1i = function (weights) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weights.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = Loads_instance.v1h(item);
    destination_0.f(tmp$ret$5);
  }
  return sorted(distinct(destination_0));
};
protoOf(Loads).d1i = function (gym, maxAddedKg) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = gym.y1g_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = imul(element.f1g_1, 2);
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$7 = element.e1g_1;
        list.f(tmp$ret$7);
      }
       while (inductionVariable < size);
    var list_0 = list;
    addAll(destination, list_0);
  }
  var plates = subsetSums(this, destination, maxAddedKg);
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = plus(plus(plus(listOf_0(0.0), plates), this.y1h(gym.z1g_1)), this.c1i(gym.b1h_1));
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = tmp0_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0 <= maxAddedKg + 1.0E-9) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_0, 10));
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$13 = Loads_instance.v1h(item);
    destination_1.f(tmp$ret$13);
  }
  return sorted(distinct(destination_1));
};
protoOf(Loads).e1i = function (gym, maxAddedKg, $super) {
  maxAddedKg = maxAddedKg === VOID ? 100.0 : maxAddedKg;
  return $super === VOID ? this.d1i(gym, maxAddedKg) : $super.d1i.call(this, gym, maxAddedKg);
};
protoOf(Loads).f1i = function (gym, equipment, stackName, maxLoadKg) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = gym.a1h_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (stackName == null || element.k1g_1 === stackName) {
      destination.f(element);
    }
  }
  var stacks = destination;
  var plates = plus(gym.y1g_1, gym.e1h_1);
  var tmp;
  switch (equipment.y1_1) {
    case 0:
    case 7:
      var tmp1_safe_receiver = gym.l1h(equipment);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Loads_instance.w1h(tmp1_safe_receiver.d1g_1, plates, maxLoadKg);
      }

      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
      break;
    case 1:
      tmp = this.y1h(gym.z1g_1);
      break;
    case 2:
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call

      if (!stacks.m()) {
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_0 = stacks.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          var list = Loads_instance.z1h(element_0);
          addAll(destination_0, list);
        }
        tmp_1 = sorted(distinct(destination_0));
      } else {
        tmp_1 = this.x1h(plates, maxLoadKg);
      }

      tmp = tmp_1;
      break;
    case 3:
      // Inline function 'kotlin.collections.flatMap' call

      // Inline function 'kotlin.collections.flatMapTo' call

      var destination_1 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_1 = stacks.j();
      while (_iterator__ex2g4s_1.k()) {
        var element_1 = _iterator__ex2g4s_1.l();
        var list_0 = Loads_instance.z1h(element_1);
        addAll(destination_1, list_0);
      }

      tmp = sorted(distinct(destination_1));
      break;
    case 4:
      tmp = this.c1i(gym.b1h_1);
      break;
    case 5:
      tmp = this.e1i(gym);
      break;
    case 6:
    case 8:
      tmp = emptyList();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var loads = tmp;
  var tmp3_elvis_lhs = gym.f1h_1.t1(equipment);
  var tmp_2;
  if (tmp3_elvis_lhs == null) {
    return loads;
  } else {
    tmp_2 = tmp3_elvis_lhs;
  }
  var offset = tmp_2;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(loads, 10));
  var _iterator__ex2g4s_2 = loads.j();
  while (_iterator__ex2g4s_2.k()) {
    var item = _iterator__ex2g4s_2.l();
    var tmp$ret$14 = Loads_instance.v1h(item + offset);
    destination_2.f(tmp$ret$14);
  }
  return destination_2;
};
protoOf(Loads).g1i = function (gym, equipment, stackName, maxLoadKg, $super) {
  stackName = stackName === VOID ? null : stackName;
  maxLoadKg = maxLoadKg === VOID ? 500.0 : maxLoadKg;
  return $super === VOID ? this.f1i(gym, equipment, stackName, maxLoadKg) : $super.f1i.call(this, gym, equipment, stackName, maxLoadKg);
};
protoOf(Loads).h1i = function (loads, targetKg, rounding) {
  if (loads.m())
    return null;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = loads.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element <= targetKg + 1.0E-9) {
      destination.f(element);
    }
  }
  var below = maxOrNull(destination);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = loads.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0 >= targetKg - 1.0E-9) {
      destination_0.f(element_0);
    }
  }
  var above = minOrNull(destination_0);
  var tmp;
  switch (rounding.y1_1) {
    case 0:
      tmp = below == null ? min(loads) : below;
      break;
    case 1:
      tmp = above == null ? max(loads) : above;
      break;
    case 2:
      var tmp_0;
      if (below == null) {
        tmp_0 = above;
      } else {
        if (above == null) {
          tmp_0 = below;
        } else {
          // Inline function 'kotlin.math.abs' call
          var x = above - targetKg;
          var tmp_1 = Math.abs(x);
          // Inline function 'kotlin.math.abs' call
          var x_0 = targetKg - below;
          if (tmp_1 < Math.abs(x_0) - 1.0E-9) {
            tmp_0 = above;
          } else {
            tmp_0 = below;
          }
        }
      }

      tmp = tmp_0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(Loads).i1i = function (loads, targetKg, rounding, $super) {
  rounding = rounding === VOID ? LoadRounding_NEAREST_getInstance() : rounding;
  return $super === VOID ? this.h1i(loads, targetKg, rounding) : $super.h1i.call(this, loads, targetKg, rounding);
};
protoOf(Loads).j1i = function (loads, currentKg, up) {
  var tmp;
  if (up) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = loads.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element > currentKg + 1.0E-9) {
        destination.f(element);
      }
    }
    tmp = minOrNull(destination);
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = loads.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0 < currentKg - 1.0E-9) {
        destination_0.f(element_0);
      }
    }
    tmp = maxOrNull(destination_0);
  }
  return tmp;
};
protoOf(Loads).k1i = function (loads, currentKg, up, $super) {
  up = up === VOID ? true : up;
  return $super === VOID ? this.j1i(loads, currentKg, up) : $super.j1i.call(this, loads, currentKg, up);
};
protoOf(Loads).v1h = function (value) {
  return round(value * 1000.0) / 1000.0;
};
var Loads_instance;
function Loads_getInstance() {
  return Loads_instance;
}
function Search(sizes, perSide) {
  this.l1i_1 = sizes;
  this.m1i_1 = perSide;
  this.n1i_1 = 0.0;
  this.o1i_1 = 0;
  this.p1i_1 = new Int32Array(this.l1i_1.o());
  var tmp = this;
  // Inline function 'kotlin.also' call
  var this_0 = new Float64Array(this.l1i_1.o() + 1 | 0);
  var inductionVariable = this.l1i_1.o() - 1 | 0;
  if (0 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      this_0[i] = this_0[i + 1 | 0] + this.l1i_1.n(i).e1g_1 * this.l1i_1.n(i).f1g_1;
    }
     while (0 <= inductionVariable);
  tmp.q1i_1 = this_0;
}
protoOf(Search).r1i = function (index, sum, counts, plates) {
  var tmp;
  if (sum > this.n1i_1 + 1.0E-9) {
    tmp = true;
  } else {
    var tmp_0;
    // Inline function 'kotlin.math.abs' call
    var x = sum - this.n1i_1;
    if (Math.abs(x) < 1.0E-9) {
      tmp_0 = plates < this.o1i_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  if (tmp) {
    this.n1i_1 = sum;
    this.o1i_1 = plates;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1.p1i_1 = counts.slice();
  }
  var tmp_2;
  if (index === this.l1i_1.o()) {
    tmp_2 = true;
  } else {
    var tmp_3;
    // Inline function 'kotlin.math.abs' call
    var x_0 = this.n1i_1 - this.m1i_1;
    if (Math.abs(x_0) < 1.0E-9) {
      tmp_3 = plates >= this.o1i_1;
    } else {
      tmp_3 = false;
    }
    tmp_2 = tmp_3;
  }
  if (tmp_2)
    return Unit_instance;
  if (sum + this.q1i_1[index] < this.n1i_1 - 1.0E-9)
    return Unit_instance;
  var size = this.l1i_1.n(index);
  var tmp0 = size.f1g_1;
  // Inline function 'kotlin.math.floor' call
  var x_1 = (this.m1i_1 - sum) / size.e1g_1 + 1.0E-9;
  var tmp$ret$4 = Math.floor(x_1);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = numberToInt(tmp$ret$4);
  var most = Math.min(tmp0, b);
  var inductionVariable = most;
  if (0 <= inductionVariable)
    do {
      var count = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      counts[index] = count;
      this.r1i(index + 1 | 0, sum + count * size.e1g_1, counts, plates + count | 0);
    }
     while (0 <= inductionVariable);
  counts[index] = 0;
};
function sam$kotlin_Comparator$0_8(function_0) {
  this.s1i_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_8).ea = function (a, b) {
  return this.s1i_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_8).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_8).h2 = function () {
  return this.s1i_1;
};
protoOf(sam$kotlin_Comparator$0_8).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_8).hashCode = function () {
  return hashCode(this.h2());
};
function PlateCalculator$calculate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.e1g_1;
  var tmp$ret$2 = a.e1g_1;
  return compareValues(tmp, tmp$ret$2);
}
function PlateCalculator() {
}
protoOf(PlateCalculator).t1i = function (targetKg, barKg, plates) {
  // Inline function 'kotlin.require' call
  if (!(barKg >= 0.0)) {
    var message = 'barKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (targetKg <= barKg + 1.0E-9) {
    var tmp = emptyList();
    var tmp_0 = Loads_instance.v1h(targetKg - barKg);
    // Inline function 'kotlin.math.abs' call
    var x = targetKg - barKg;
    var tmp$ret$2 = Math.abs(x);
    return new PlateLoadout(targetKg, barKg, tmp, barKg, tmp_0, tmp$ret$2 < 1.0E-9);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = plates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.e1g_1 > 0.0 && element.f1g_1 > 0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.e1g_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp_1;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    var list = tmp_1;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(destination_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var kg = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.q1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = group.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_2 = sum;
      sum = tmp_2 + element_1.f1g_1 | 0;
    }
    var tmp$ret$17 = sum;
    var tmp$ret$14 = new PlatePair(kg, tmp$ret$17);
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_3 = PlateCalculator$calculate$lambda;
  var tmp$ret$20 = new sam$kotlin_Comparator$0_8(tmp_3);
  var sizes = sortedWith(destination_1, tmp$ret$20);
  var perSide = (targetKg - barKg) / 2.0;
  var search = new Search(sizes, perSide);
  search.r1i(0, 0.0, new Int32Array(sizes.o()), 0);
  var counts = search.p1i_1;
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = get_indices(sizes);
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element_2 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = element_2;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = counts[i];
      var list_0 = ArrayList_init_$Create$(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < size)
        do {
          var index = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp$ret$28 = sizes.n(i).e1g_1;
          list_0.f(tmp$ret$28);
        }
         while (inductionVariable_0 < size);
      var list_1 = list_0;
      addAll(destination_2, list_1);
    }
     while (!(element_2 === last));
  var side = destination_2;
  var achieved = Loads_instance.v1h(barKg + 2.0 * search.n1i_1);
  var remainder = Loads_instance.v1h(targetKg - achieved);
  // Inline function 'kotlin.math.abs' call
  var tmp$ret$29 = Math.abs(remainder);
  return new PlateLoadout(targetKg, barKg, side, achieved, remainder, tmp$ret$29 < 1.0E-6);
};
protoOf(PlateCalculator).u1i = function (previous, next) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(next, 10));
  var _iterator__ex2g4s = next.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = Loads_instance.v1h(item);
    destination.f(tmp$ret$2);
  }
  var remaining = toMutableList(destination);
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(previous, Collection)) {
      tmp = previous.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$3 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = previous.j();
    while (_iterator__ex2g4s_0.k()) {
      var element = _iterator__ex2g4s_0.l();
      if (!remaining.p2(Loads_instance.v1h(element))) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
    }
    tmp$ret$3 = true;
  }
  return tmp$ret$3;
};
var PlateCalculator_instance;
function PlateCalculator_getInstance() {
  return PlateCalculator_instance;
}
function MicroMode_ANY_getInstance() {
  static_init_37();
  return MicroMode_ANY_instance;
}
function MicroMode_ONE_getInstance() {
  static_init_37();
  return MicroMode_ONE_instance;
}
function GymTemplate_HOME_getInstance() {
  static_init_38();
  return GymTemplate_HOME_instance;
}
function GymTemplate_COMMERCIAL_getInstance() {
  static_init_38();
  return GymTemplate_COMMERCIAL_instance;
}
function GymTemplate_HOTEL_getInstance() {
  static_init_38();
  return GymTemplate_HOTEL_instance;
}
function GymTemplate_BLANK_getInstance() {
  static_init_38();
  return GymTemplate_BLANK_instance;
}
function LoadRounding_DOWN_getInstance() {
  static_init_39();
  return LoadRounding_DOWN_instance;
}
function LoadRounding_UP_getInstance() {
  static_init_39();
  return LoadRounding_UP_instance;
}
function LoadRounding_NEAREST_getInstance() {
  static_init_39();
  return LoadRounding_NEAREST_instance;
}
function get_CHECKLIST_EQUIPMENT() {
  _init_properties_GymEquipment_kt__chemgj();
  return CHECKLIST_EQUIPMENT;
}
var CHECKLIST_EQUIPMENT;
function get_MACHINE_STEP_PRESETS_KG() {
  _init_properties_GymEquipment_kt__chemgj();
  return MACHINE_STEP_PRESETS_KG;
}
var MACHINE_STEP_PRESETS_KG;
function isWeightStack(_this__u8e3s4) {
  _init_properties_GymEquipment_kt__chemgj();
  return _this__u8e3s4.equals(Equipment_MACHINE_getInstance()) || _this__u8e3s4.equals(Equipment_CABLE_getInstance());
}
function stackFromStep(name, stepKg) {
  _init_properties_GymEquipment_kt__chemgj();
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.ifEmpty' call
  var this_0 = toString(trim(isCharSequence(name) ? name : THROW_CCE()));
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_0) === 0) {
    tmp = 'Machine';
  } else {
    tmp = this_0;
  }
  var tmp$ret$1 = tmp;
  return new WeightStack(tmp$ret$1, listOf_0(new StackRange(stepKg, 200.0, stepKg)));
}
function adding(_this__u8e3s4, equipment, stack) {
  stack = stack === VOID ? null : stack;
  _init_properties_GymEquipment_kt__chemgj();
  if (_this__u8e3s4.k1h(equipment))
    return _this__u8e3s4;
  var home = Companion_getInstance_11().u1g(GymTemplate_HOME_getInstance());
  var commercial = Companion_getInstance_11().u1g(GymTemplate_COMMERCIAL_getInstance());
  var tmp;
  switch (equipment.y1_1) {
    case 0:
      var tmp_0 = plus(_this__u8e3s4.x1g_1, home.x1g_1);
      // Inline function 'kotlin.collections.ifEmpty' call

      var this_0 = _this__u8e3s4.y1g_1;
      var tmp_1;
      if (this_0.m()) {
        tmp_1 = home.y1g_1;
      } else {
        tmp_1 = this_0;
      }

      var tmp$ret$0 = tmp_1;
      tmp = _this__u8e3s4.n1h(VOID, VOID, tmp_0, tmp$ret$0);
      break;
    case 7:
      // Inline function 'kotlin.collections.filter' call

      var tmp0 = commercial.x1g_1;
      // Inline function 'kotlin.collections.filterTo' call

      var destination = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (contains_1(element.c1g_1, 'smith', true)) {
          destination.f(element);
        }
      }

      tmp = _this__u8e3s4.n1h(VOID, VOID, plus(_this__u8e3s4.x1g_1, destination));
      break;
    case 1:
      tmp = _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, home.z1g_1);
      break;
    case 4:
      tmp = _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, VOID, VOID, commercial.b1h_1);
      break;
    case 6:
      tmp = _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, commercial.c1h_1);
      break;
    case 2:
    case 3:
      var tmp_2;
      if (stack == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, VOID, plus_0(_this__u8e3s4.a1h_1, stack));
      }

      var tmp2_elvis_lhs = tmp_2;
      tmp = tmp2_elvis_lhs == null ? _this__u8e3s4 : tmp2_elvis_lhs;
      break;
    case 5:
    case 8:
      tmp = _this__u8e3s4;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function removing(_this__u8e3s4, equipment) {
  _init_properties_GymEquipment_kt__chemgj();
  switch (equipment.y1_1) {
    case 0:
      return _this__u8e3s4.n1h(VOID, VOID, emptyList(), emptyList());
    case 1:
      return _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, emptyList());
    case 4:
      return _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, VOID, VOID, emptyList());
    case 6:
      return _this__u8e3s4.n1h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, emptyList());
    default:
      return _this__u8e3s4;
  }
}
var properties_initialized_GymEquipment_kt_2uuwtx;
function _init_properties_GymEquipment_kt__chemgj() {
  if (!properties_initialized_GymEquipment_kt_2uuwtx) {
    properties_initialized_GymEquipment_kt_2uuwtx = true;
    CHECKLIST_EQUIPMENT = listOf([Equipment_BARBELL_getInstance(), Equipment_DUMBBELL_getInstance(), Equipment_KETTLEBELL_getInstance(), Equipment_BAND_getInstance(), Equipment_MACHINE_getInstance(), Equipment_CABLE_getInstance()]);
    MACHINE_STEP_PRESETS_KG = listOf([2.5, 5.0, 7.0]);
  }
}
var static_init_called_40;
function static_init_40() {
  if (static_init_called_40)
    return Unit_instance;
  static_init_called_40 = true;
  LevelStatus_NONE_instance = new LevelStatus('NONE', 0);
  LevelStatus_UNDER_instance = new LevelStatus('UNDER', 1);
  LevelStatus_ON_instance = new LevelStatus('ON', 2);
  LevelStatus_HIGH_instance = new LevelStatus('HIGH', 3);
}
var LevelStatus_NONE_instance;
var LevelStatus_UNDER_instance;
var LevelStatus_ON_instance;
var LevelStatus_HIGH_instance;
function LevelStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MuscleLevel(muscle, weeklySets, targetSets, ratio, status, recovery) {
  this.v1i_1 = muscle;
  this.w1i_1 = weeklySets;
  this.x1i_1 = targetSets;
  this.y1i_1 = ratio;
  this.z1i_1 = status;
  this.a1j_1 = recovery;
}
protoOf(MuscleLevel).toString = function () {
  return 'MuscleLevel(muscle=' + this.v1i_1.toString() + ', weeklySets=' + this.w1i_1 + ', targetSets=' + this.x1i_1 + ', ratio=' + this.y1i_1 + ', status=' + this.z1i_1.toString() + ', recovery=' + this.a1j_1 + ')';
};
protoOf(MuscleLevel).hashCode = function () {
  var result = this.v1i_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.w1i_1) | 0;
  result = imul(result, 31) + (this.x1i_1 == null ? 0 : getNumberHashCode(this.x1i_1)) | 0;
  result = imul(result, 31) + (this.y1i_1 == null ? 0 : getNumberHashCode(this.y1i_1)) | 0;
  result = imul(result, 31) + this.z1i_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.a1j_1) | 0;
  return result;
};
protoOf(MuscleLevel).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MuscleLevel))
    return false;
  if (!this.v1i_1.equals(other.v1i_1))
    return false;
  if (!equals(this.w1i_1, other.w1i_1))
    return false;
  if (!equals(this.x1i_1, other.x1i_1))
    return false;
  if (!equals(this.y1i_1, other.y1i_1))
    return false;
  if (!this.z1i_1.equals(other.z1i_1))
    return false;
  if (!equals(this.a1j_1, other.a1j_1))
    return false;
  return true;
};
var static_init_called_41;
function static_init_41() {
  if (static_init_called_41)
    return Unit_instance;
  static_init_called_41 = true;
  BodyMapPeriod_WEEK_instance = new BodyMapPeriod('WEEK', 0, '1W', 7);
  BodyMapPeriod_MONTH_instance = new BodyMapPeriod('MONTH', 1, '1M', 30);
  BodyMapPeriod_THREE_MONTHS_instance = new BodyMapPeriod('THREE_MONTHS', 2, '3M', 91);
  BodyMapPeriod_SIX_MONTHS_instance = new BodyMapPeriod('SIX_MONTHS', 3, '6M', 182);
  BodyMapPeriod_YEAR_instance = new BodyMapPeriod('YEAR', 4, '1Y', 365);
  BodyMapPeriod_ALL_instance = new BodyMapPeriod('ALL', 5, 'All', null);
}
var BodyMapPeriod_WEEK_instance;
var BodyMapPeriod_MONTH_instance;
var BodyMapPeriod_THREE_MONTHS_instance;
var BodyMapPeriod_SIX_MONTHS_instance;
var BodyMapPeriod_YEAR_instance;
var BodyMapPeriod_ALL_instance;
function values_28() {
  static_init_41();
  return [BodyMapPeriod_WEEK_getInstance(), BodyMapPeriod_MONTH_getInstance(), BodyMapPeriod_THREE_MONTHS_getInstance(), BodyMapPeriod_SIX_MONTHS_getInstance(), BodyMapPeriod_YEAR_getInstance(), BodyMapPeriod_ALL_getInstance()];
}
function get_entries_23() {
  static_init_41();
  if ($ENTRIES_23 == null)
    $ENTRIES_23 = enumEntries(values_28());
  return $ENTRIES_23;
}
var $ENTRIES_23;
function BodyMapPeriod(name, ordinal, key, days) {
  Enum.call(this, name, ordinal);
  this.d1j_1 = key;
  this.e1j_1 = days;
}
function PeriodLevels(period, days, totalSets, levels) {
  this.f1j_1 = period;
  this.g1j_1 = days;
  this.h1j_1 = totalSets;
  this.i1j_1 = levels;
}
protoOf(PeriodLevels).toString = function () {
  return 'PeriodLevels(period=' + this.f1j_1.toString() + ', days=' + this.g1j_1 + ', totalSets=' + toString(this.h1j_1) + ', levels=' + toString(this.i1j_1) + ')';
};
protoOf(PeriodLevels).hashCode = function () {
  var result = this.f1j_1.hashCode();
  result = imul(result, 31) + this.g1j_1 | 0;
  result = imul(result, 31) + hashCode(this.h1j_1) | 0;
  result = imul(result, 31) + hashCode(this.i1j_1) | 0;
  return result;
};
protoOf(PeriodLevels).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PeriodLevels))
    return false;
  if (!this.f1j_1.equals(other.f1j_1))
    return false;
  if (!(this.g1j_1 === other.g1j_1))
    return false;
  if (!equals(this.h1j_1, other.h1j_1))
    return false;
  if (!equals(this.i1j_1, other.i1j_1))
    return false;
  return true;
};
function MuscleLevels() {
  this.j1j_1 = 0.8;
  this.k1j_1 = 1.2;
  this.l1j_1 = 2.0;
}
protoOf(MuscleLevels).m1j = function (sets, exercises, today, targets, windowDays) {
  var weekly = TrainingAnalytics_instance.n1j(sets, exercises, today, windowDays);
  var recovery = this.o1j(sets, exercises, today);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries_31();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var done = getValue(weekly, item);
    var tmp0_safe_receiver = targets.t1(item);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver > 0.0) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var target = tmp;
    var tmp_1;
    if (target == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = done / target;
    }
    var ratio = tmp_1;
    var status = ratio == null ? LevelStatus_NONE_getInstance() : ratio < 0.8 ? LevelStatus_UNDER_getInstance() : ratio <= 1.2 ? LevelStatus_ON_getInstance() : LevelStatus_HIGH_getInstance();
    var tmp$ret$2 = new MuscleLevel(item, done, target, ratio, status, getValue(recovery, item));
    destination.f(tmp$ret$2);
  }
  return destination;
};
protoOf(MuscleLevels).p1j = function (sets, exercises, today, targets, windowDays, $super) {
  windowDays = windowDays === VOID ? LevelsWindow_WEEK_getInstance().s1j_1 : windowDays;
  return $super === VOID ? this.m1j(sets, exercises, today, targets, windowDays) : $super.m1j.call(this, sets, exercises, today, targets, windowDays);
};
protoOf(MuscleLevels).t1j = function (sets, exercises, today, targets, period) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.s1c_1.equals(SetType_WARMUP_getInstance()) && element.u1c_1 > 0 && element.p1c_1 <= today) {
      destination.f(element);
    }
  }
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.minOfOrNull' call
    var iterator = destination.j();
    if (!iterator.k()) {
      tmp$ret$3 = null;
      break $l$block;
    }
    var minValue = iterator.l().p1c_1;
    while (iterator.k()) {
      var v = iterator.l().p1c_1;
      if (compareTo(minValue, v) > 0) {
        minValue = v;
      }
    }
    tmp$ret$3 = minValue;
  }
  var tmp0_elvis_lhs = tmp$ret$3;
  var first = tmp0_elvis_lhs == null ? today : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = period.e1j_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = (today - first | 0) + 1 | 0;
    tmp = Math.max(7, b);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var days = tmp;
  var levels = this.m1j(sets, exercises, today, targets, days);
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(levels, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = levels.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element_0.v1i_1, element_0.w1i_1 * days / 7.0);
    destination_0.l2(pair.nb_1, pair.ob_1);
  }
  return new PeriodLevels(period, days, destination_0, levels);
};
protoOf(MuscleLevels).u1j = function (sets, exercises, today, tauDays) {
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = get_entries_31();
  var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    result.l2(element, 0.0);
  }
  var totals = toMutableMap(result);
  var _iterator__ex2g4s_0 = sets.j();
  $l$loop_0: while (_iterator__ex2g4s_0.k()) {
    var set = _iterator__ex2g4s_0.l();
    if (set.s1c_1.equals(SetType_WARMUP_getInstance()) || set.u1c_1 <= 0 || set.p1c_1 > today)
      continue $l$loop_0;
    var tmp0_elvis_lhs = exercises.t1(set.q1c_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var exercise = tmp;
    // Inline function 'kotlin.math.exp' call
    var x = (-(today - set.p1c_1 | 0) | 0) / tauDays;
    var weight = Math.exp(x);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = exercise.v1b_1.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      // Inline function 'kotlin.collections.set' call
      var value = getValue(totals, element_0) + weight;
      totals.l2(element_0, value);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = exercise.w1b_1.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.collections.set' call
      var value_0 = getValue(totals, element_1) + 0.5 * weight;
      totals.l2(element_1, value_0);
    }
  }
  return totals;
};
protoOf(MuscleLevels).o1j = function (sets, exercises, today, tauDays, $super) {
  tauDays = tauDays === VOID ? 2.0 : tauDays;
  return $super === VOID ? this.u1j(sets, exercises, today, tauDays) : $super.u1j.call(this, sets, exercises, today, tauDays);
};
var MuscleLevels_instance;
function MuscleLevels_getInstance() {
  return MuscleLevels_instance;
}
var static_init_called_42;
function static_init_42() {
  if (static_init_called_42)
    return Unit_instance;
  static_init_called_42 = true;
  MuscleIntensity_PRIMARY_instance = new MuscleIntensity('PRIMARY', 0);
  MuscleIntensity_SECONDARY_instance = new MuscleIntensity('SECONDARY', 1);
}
var MuscleIntensity_PRIMARY_instance;
var MuscleIntensity_SECONDARY_instance;
function MuscleIntensity(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MuscleHighlights() {
}
protoOf(MuscleHighlights).v1j = function (primaryMuscles, secondaryMuscles) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var result = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = secondaryMuscles.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.set' call
    var value = MuscleIntensity_SECONDARY_getInstance();
    result.l2(element, value);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = primaryMuscles.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.set' call
    var value_0 = MuscleIntensity_PRIMARY_getInstance();
    result.l2(element_0, value_0);
  }
  return result;
};
var MuscleHighlights_instance;
function MuscleHighlights_getInstance() {
  return MuscleHighlights_instance;
}
function LevelStatus_NONE_getInstance() {
  static_init_40();
  return LevelStatus_NONE_instance;
}
function LevelStatus_UNDER_getInstance() {
  static_init_40();
  return LevelStatus_UNDER_instance;
}
function LevelStatus_ON_getInstance() {
  static_init_40();
  return LevelStatus_ON_instance;
}
function LevelStatus_HIGH_getInstance() {
  static_init_40();
  return LevelStatus_HIGH_instance;
}
function BodyMapPeriod_WEEK_getInstance() {
  static_init_41();
  return BodyMapPeriod_WEEK_instance;
}
function BodyMapPeriod_MONTH_getInstance() {
  static_init_41();
  return BodyMapPeriod_MONTH_instance;
}
function BodyMapPeriod_THREE_MONTHS_getInstance() {
  static_init_41();
  return BodyMapPeriod_THREE_MONTHS_instance;
}
function BodyMapPeriod_SIX_MONTHS_getInstance() {
  static_init_41();
  return BodyMapPeriod_SIX_MONTHS_instance;
}
function BodyMapPeriod_YEAR_getInstance() {
  static_init_41();
  return BodyMapPeriod_YEAR_instance;
}
function BodyMapPeriod_ALL_getInstance() {
  static_init_41();
  return BodyMapPeriod_ALL_instance;
}
function MuscleIntensity_PRIMARY_getInstance() {
  static_init_42();
  return MuscleIntensity_PRIMARY_instance;
}
function MuscleIntensity_SECONDARY_getInstance() {
  static_init_42();
  return MuscleIntensity_SECONDARY_instance;
}
function roundHalfUp($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function repRange$at($repMin, window_0, offset) {
  return to($repMin + offset | 0, ($repMin + offset | 0) + window_0 | 0);
}
function Periodisation() {
  this.w1j_1 = 3;
  this.x1j_1 = 1;
  this.y1j_1 = 2;
}
protoOf(Periodisation).z1j = function (cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence) {
  // Inline function 'kotlin.require' call
  if (!(cycles >= 1)) {
    var message = 'cycles must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startSets >= 1 && peakSets >= 1)) {
    var message_0 = 'sets must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(1 <= repMin ? repMin <= repMax : false)) {
    var message_1 = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.require' call
  if (!((0 <= startRir ? startRir <= 10 : false) && (0 <= endRir ? endRir <= 10 : false))) {
    var message_2 = 'rir must be 0\u201310';
    throw IllegalArgumentException_init_$Create$(toString(message_2));
  }
  // Inline function 'kotlin.require' call
  if (!(occurrence >= 0)) {
    var message_3 = 'occurrence must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_3));
  }
  var hasDeload = !deload.equals(DeloadPosition_NONE_getInstance()) && cycles >= 2;
  var loadingCycles = hasDeload ? cycles - 1 | 0 : cycles;
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, loadingCycles);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last_0 = this_0.yc_1;
  if (inductionVariable <= last_0)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = item;
      var t = loadingCycles === 1 ? 0.0 : c / (loadingCycles - 1 | 0);
      var _destruct__k2r9zo = Periodisation_instance.a1k(repMin, repMax, scheme, c, loadingCycles, occurrence);
      var low = _destruct__k2r9zo.hb();
      var high = _destruct__k2r9zo.ib();
      // Inline function 'kotlin.math.max' call
      var b = roundHalfUp(Periodisation_instance, startSets + (peakSets - startSets | 0) * t);
      var tmp$ret$13 = Math.max(1, b);
      var tmp$ret$12 = new CyclePrescription(tmp$ret$13, low, high, coerceIn_0(roundHalfUp(Periodisation_instance, startRir + (endRir - startRir | 0) * t), 0, 10), setType);
      destination.f(tmp$ret$12);
    }
     while (!(item === last_0));
  var loading = destination;
  if (!hasDeload)
    return loading;
  var reference = deload.equals(DeloadPosition_FIRST_getInstance()) ? first(loading) : last(loading);
  // Inline function 'kotlin.math.ceil' call
  var x = reference.q1a_1 / 2.0;
  var tmp$ret$14 = Math.ceil(x);
  // Inline function 'kotlin.math.max' call
  var b_0 = numberToInt(tmp$ret$14);
  var tmp = Math.max(1, b_0);
  // Inline function 'kotlin.math.min' call
  var b_1 = reference.t1a_1 + 2 | 0;
  var tmp$ret$16 = Math.min(10, b_1);
  var deloadCycle = new CyclePrescription(tmp, reference.r1a_1, reference.s1a_1, tmp$ret$16, setType.equals(SetType_FAILURE_getInstance()) ? SetType_STANDARD_getInstance() : setType);
  return deload.equals(DeloadPosition_FIRST_getInstance()) ? plus(listOf_0(deloadCycle), loading) : plus_0(loading, deloadCycle);
};
protoOf(Periodisation).b1k = function (cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence, $super) {
  deload = deload === VOID ? DeloadPosition_NONE_getInstance() : deload;
  startRir = startRir === VOID ? 3 : startRir;
  endRir = endRir === VOID ? 1 : endRir;
  setType = setType === VOID ? SetType_STANDARD_getInstance() : setType;
  occurrence = occurrence === VOID ? 0 : occurrence;
  return $super === VOID ? this.z1j(cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence) : $super.z1j.call(this, cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence);
};
protoOf(Periodisation).a1k = function (repMin, repMax, scheme, cycle, loadingCycles, occurrence) {
  var width = repMax - repMin | 0;
  var tmp;
  if (width <= 1) {
    tmp = width;
  } else {
    // Inline function 'kotlin.math.ceil' call
    var x = width / 2.0;
    var tmp$ret$0 = Math.ceil(x);
    tmp = numberToInt(tmp$ret$0);
  }
  var window_0 = tmp;
  var slack = width - window_0 | 0;
  var t = loadingCycles <= 1 ? 0.0 : cycle / (loadingCycles - 1 | 0);
  var tmp_0;
  switch (scheme.y1_1) {
    case 0:
    case 4:
      tmp_0 = to(repMin, repMax);
      break;
    case 1:
      tmp_0 = loadingCycles <= 1 ? to(repMin, repMax) : repRange$at(repMin, window_0, roundHalfUp(this, slack * (1.0 - t)));
      break;
    case 2:
      tmp_0 = loadingCycles <= 1 ? to(repMin, repMax) : repRange$at(repMin, window_0, roundHalfUp(this, slack * t));
      break;
    case 3:
      switch ((cycle + occurrence | 0) % 3 | 0) {
        case 0:
          tmp_0 = repRange$at(repMin, window_0, 0);
          break;
        case 1:
          tmp_0 = repRange$at(repMin, window_0, slack);
          break;
        default:
          tmp_0 = repRange$at(repMin, window_0, slack / 2 | 0);
          break;
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
};
var Periodisation_instance;
function Periodisation_getInstance() {
  return Periodisation_instance;
}
var static_init_called_43;
function static_init_43() {
  if (static_init_called_43)
    return Unit_instance;
  static_init_called_43 = true;
  Experience_BEGINNER_instance = new Experience('BEGINNER', 0);
  Experience_INTERMEDIATE_instance = new Experience('INTERMEDIATE', 1);
  Experience_ADVANCED_instance = new Experience('ADVANCED', 2);
}
var Experience_BEGINNER_instance;
var Experience_INTERMEDIATE_instance;
var Experience_ADVANCED_instance;
function values_29() {
  static_init_43();
  return [Experience_BEGINNER_getInstance(), Experience_INTERMEDIATE_getInstance(), Experience_ADVANCED_getInstance()];
}
function get_entries_24() {
  static_init_43();
  if ($ENTRIES_24 == null)
    $ENTRIES_24 = enumEntries(values_29());
  return $ENTRIES_24;
}
var $ENTRIES_24;
function Experience(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_44;
function static_init_44() {
  if (static_init_called_44)
    return Unit_instance;
  static_init_called_44 = true;
  Split_AUTO_instance = new Split('AUTO', 0, 'Auto');
  Split_FULL_BODY_instance = new Split('FULL_BODY', 1, 'Full Body');
  Split_UPPER_LOWER_instance = new Split('UPPER_LOWER', 2, 'Upper/Lower');
  Split_PPL_instance = new Split('PPL', 3, 'Push/Pull/Legs');
  Split_PUSH_PULL_HINGE_SQUAT_instance = new Split('PUSH_PULL_HINGE_SQUAT', 4, 'Push/Pull/Hinge/Squat');
  Split_PPL_ACCESSORIES_instance = new Split('PPL_ACCESSORIES', 5, 'PPL + Accessories');
  Split_PPHS_ACCESSORIES_instance = new Split('PPHS_ACCESSORIES', 6, 'PPHS + Accessories');
  Split_PPL_UPPER_LOWER_instance = new Split('PPL_UPPER_LOWER', 7, 'PPL + Upper/Lower');
  Split_PPHS_UPPER_LOWER_instance = new Split('PPHS_UPPER_LOWER', 8, 'PPHS + Upper/Lower');
}
var Split_AUTO_instance;
var Split_FULL_BODY_instance;
var Split_UPPER_LOWER_instance;
var Split_PPL_instance;
var Split_PUSH_PULL_HINGE_SQUAT_instance;
var Split_PPL_ACCESSORIES_instance;
var Split_PPHS_ACCESSORIES_instance;
var Split_PPL_UPPER_LOWER_instance;
var Split_PPHS_UPPER_LOWER_instance;
function values_30() {
  static_init_44();
  return [Split_AUTO_getInstance(), Split_FULL_BODY_getInstance(), Split_UPPER_LOWER_getInstance(), Split_PPL_getInstance(), Split_PUSH_PULL_HINGE_SQUAT_getInstance(), Split_PPL_ACCESSORIES_getInstance(), Split_PPHS_ACCESSORIES_getInstance(), Split_PPL_UPPER_LOWER_getInstance(), Split_PPHS_UPPER_LOWER_getInstance()];
}
function get_entries_25() {
  static_init_44();
  if ($ENTRIES_25 == null)
    $ENTRIES_25 = enumEntries(values_30());
  return $ENTRIES_25;
}
var $ENTRIES_25;
function Split(name, ordinal, label) {
  Enum.call(this, name, ordinal);
  this.e1k_1 = label;
}
var static_init_called_45;
function static_init_45() {
  if (static_init_called_45)
    return Unit_instance;
  static_init_called_45 = true;
  CompoundSetRule_GREEDY_instance = new CompoundSetRule('GREEDY', 0);
  CompoundSetRule_POWER_instance = new CompoundSetRule('POWER', 1);
}
var CompoundSetRule_GREEDY_instance;
var CompoundSetRule_POWER_instance;
function values_31() {
  static_init_45();
  return [CompoundSetRule_GREEDY_getInstance(), CompoundSetRule_POWER_getInstance()];
}
function get_entries_26() {
  static_init_45();
  if ($ENTRIES_26 == null)
    $ENTRIES_26 = enumEntries(values_31());
  return $ENTRIES_26;
}
var $ENTRIES_26;
function CompoundSetRule(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(CompoundSetRule).h1k = function (need) {
  // Inline function 'kotlin.math.floor' call
  var x = need + 0.5;
  var tmp$ret$0 = Math.floor(x);
  var n = numberToInt(tmp$ret$0);
  if (this.equals(CompoundSetRule_GREEDY_getInstance()) || n < 1)
    return null;
  // Inline function 'kotlin.math.pow' call
  var raw = 2.0 * Math.pow(n, 0.33);
  // Inline function 'kotlin.math.floor' call
  var x_0 = raw + 0.5;
  var tmp$ret$2 = Math.floor(x_0);
  // Inline function 'kotlin.math.min' call
  var b = numberToInt(tmp$ret$2);
  // Inline function 'kotlin.math.min' call
  var b_0 = Math.min(5, b);
  var tmp$ret$4 = Math.min(n, b_0);
  return coerceAtLeast(tmp$ret$4, 1);
};
var static_init_called_46;
function static_init_46() {
  if (static_init_called_46)
    return Unit_instance;
  static_init_called_46 = true;
  RestRule_BY_GOAL_instance = new RestRule('BY_GOAL', 0);
  RestRule_BY_TYPE_instance = new RestRule('BY_TYPE', 1);
}
var RestRule_BY_GOAL_instance;
var RestRule_BY_TYPE_instance;
function values_32() {
  static_init_46();
  return [RestRule_BY_GOAL_getInstance(), RestRule_BY_TYPE_getInstance()];
}
function get_entries_27() {
  static_init_46();
  if ($ENTRIES_27 == null)
    $ENTRIES_27 = enumEntries(values_32());
  return $ENTRIES_27;
}
var $ENTRIES_27;
function RestRule(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function GeneratorSettings(goal, daysPerWeek, minutesPerSession, experience, split, focus, deprioritised, includeDeloads, deload, cycles, progression, excludedExercises, name, useLibraryRanks, skills, familiar, compoundSets, rest, powerWork) {
  goal = goal === VOID ? TrainingGoal_HYPERTROPHY_getInstance() : goal;
  daysPerWeek = daysPerWeek === VOID ? 3 : daysPerWeek;
  minutesPerSession = minutesPerSession === VOID ? 60 : minutesPerSession;
  experience = experience === VOID ? Experience_INTERMEDIATE_getInstance() : experience;
  split = split === VOID ? Split_AUTO_getInstance() : split;
  focus = focus === VOID ? emptyList() : focus;
  deprioritised = deprioritised === VOID ? emptyList() : deprioritised;
  includeDeloads = includeDeloads === VOID ? true : includeDeloads;
  deload = deload === VOID ? DeloadPosition_LAST_getInstance() : deload;
  cycles = cycles === VOID ? 5 : cycles;
  progression = progression === VOID ? ProgressionScheme_DOUBLE_getInstance() : progression;
  excludedExercises = excludedExercises === VOID ? emptySet() : excludedExercises;
  name = name === VOID ? null : name;
  useLibraryRanks = useLibraryRanks === VOID ? false : useLibraryRanks;
  skills = skills === VOID ? emptySet() : skills;
  familiar = familiar === VOID ? emptyMap() : familiar;
  compoundSets = compoundSets === VOID ? CompoundSetRule_GREEDY_getInstance() : compoundSets;
  rest = rest === VOID ? RestRule_BY_GOAL_getInstance() : rest;
  powerWork = powerWork === VOID ? false : powerWork;
  this.i1f_1 = goal;
  this.j1f_1 = daysPerWeek;
  this.k1f_1 = minutesPerSession;
  this.l1f_1 = experience;
  this.m1f_1 = split;
  this.n1f_1 = focus;
  this.o1f_1 = deprioritised;
  this.p1f_1 = includeDeloads;
  this.q1f_1 = deload;
  this.r1f_1 = cycles;
  this.s1f_1 = progression;
  this.t1f_1 = excludedExercises;
  this.u1f_1 = name;
  this.v1f_1 = useLibraryRanks;
  this.w1f_1 = skills;
  this.x1f_1 = familiar;
  this.y1f_1 = compoundSets;
  this.z1f_1 = rest;
  this.a1g_1 = powerWork;
}
protoOf(GeneratorSettings).toString = function () {
  return 'GeneratorSettings(goal=' + this.i1f_1.toString() + ', daysPerWeek=' + this.j1f_1 + ', minutesPerSession=' + this.k1f_1 + ', experience=' + this.l1f_1.toString() + ', split=' + this.m1f_1.toString() + ', focus=' + toString(this.n1f_1) + ', deprioritised=' + toString(this.o1f_1) + ', includeDeloads=' + this.p1f_1 + ', deload=' + this.q1f_1.toString() + ', cycles=' + this.r1f_1 + ', progression=' + this.s1f_1.toString() + ', excludedExercises=' + toString(this.t1f_1) + ', name=' + this.u1f_1 + ', useLibraryRanks=' + this.v1f_1 + ', skills=' + toString(this.w1f_1) + ', familiar=' + toString(this.x1f_1) + ', compoundSets=' + this.y1f_1.toString() + ', rest=' + this.z1f_1.toString() + ', powerWork=' + this.a1g_1 + ')';
};
protoOf(GeneratorSettings).hashCode = function () {
  var result = this.i1f_1.hashCode();
  result = imul(result, 31) + this.j1f_1 | 0;
  result = imul(result, 31) + this.k1f_1 | 0;
  result = imul(result, 31) + this.l1f_1.hashCode() | 0;
  result = imul(result, 31) + this.m1f_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.n1f_1) | 0;
  result = imul(result, 31) + hashCode(this.o1f_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.p1f_1) | 0;
  result = imul(result, 31) + this.q1f_1.hashCode() | 0;
  result = imul(result, 31) + this.r1f_1 | 0;
  result = imul(result, 31) + this.s1f_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.t1f_1) | 0;
  result = imul(result, 31) + (this.u1f_1 == null ? 0 : getStringHashCode(this.u1f_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.v1f_1) | 0;
  result = imul(result, 31) + hashCode(this.w1f_1) | 0;
  result = imul(result, 31) + hashCode(this.x1f_1) | 0;
  result = imul(result, 31) + this.y1f_1.hashCode() | 0;
  result = imul(result, 31) + this.z1f_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.a1g_1) | 0;
  return result;
};
protoOf(GeneratorSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GeneratorSettings))
    return false;
  if (!this.i1f_1.equals(other.i1f_1))
    return false;
  if (!(this.j1f_1 === other.j1f_1))
    return false;
  if (!(this.k1f_1 === other.k1f_1))
    return false;
  if (!this.l1f_1.equals(other.l1f_1))
    return false;
  if (!this.m1f_1.equals(other.m1f_1))
    return false;
  if (!equals(this.n1f_1, other.n1f_1))
    return false;
  if (!equals(this.o1f_1, other.o1f_1))
    return false;
  if (!(this.p1f_1 === other.p1f_1))
    return false;
  if (!this.q1f_1.equals(other.q1f_1))
    return false;
  if (!(this.r1f_1 === other.r1f_1))
    return false;
  if (!this.s1f_1.equals(other.s1f_1))
    return false;
  if (!equals(this.t1f_1, other.t1f_1))
    return false;
  if (!(this.u1f_1 == other.u1f_1))
    return false;
  if (!(this.v1f_1 === other.v1f_1))
    return false;
  if (!equals(this.w1f_1, other.w1f_1))
    return false;
  if (!equals(this.x1f_1, other.x1f_1))
    return false;
  if (!this.y1f_1.equals(other.y1f_1))
    return false;
  if (!this.z1f_1.equals(other.z1f_1))
    return false;
  if (!(this.a1g_1 === other.a1g_1))
    return false;
  return true;
};
function GeneratedProgram(program, split, targetSets, peakTargetSets, weeklySets, peakWeeklySets, estimatedMinutes) {
  this.i1k_1 = program;
  this.j1k_1 = split;
  this.k1k_1 = targetSets;
  this.l1k_1 = peakTargetSets;
  this.m1k_1 = weeklySets;
  this.n1k_1 = peakWeeklySets;
  this.o1k_1 = estimatedMinutes;
}
protoOf(GeneratedProgram).toString = function () {
  return 'GeneratedProgram(program=' + this.i1k_1.toString() + ', split=' + this.j1k_1.toString() + ', targetSets=' + toString(this.k1k_1) + ', peakTargetSets=' + toString(this.l1k_1) + ', weeklySets=' + toString(this.m1k_1) + ', peakWeeklySets=' + toString(this.n1k_1) + ', estimatedMinutes=' + toString(this.o1k_1) + ')';
};
protoOf(GeneratedProgram).hashCode = function () {
  var result = this.i1k_1.hashCode();
  result = imul(result, 31) + this.j1k_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.k1k_1) | 0;
  result = imul(result, 31) + hashCode(this.l1k_1) | 0;
  result = imul(result, 31) + hashCode(this.m1k_1) | 0;
  result = imul(result, 31) + hashCode(this.n1k_1) | 0;
  result = imul(result, 31) + hashCode(this.o1k_1) | 0;
  return result;
};
protoOf(GeneratedProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GeneratedProgram))
    return false;
  if (!this.i1k_1.equals(other.i1k_1))
    return false;
  if (!this.j1k_1.equals(other.j1k_1))
    return false;
  if (!equals(this.k1k_1, other.k1k_1))
    return false;
  if (!equals(this.l1k_1, other.l1k_1))
    return false;
  if (!equals(this.m1k_1, other.m1k_1))
    return false;
  if (!equals(this.n1k_1, other.n1k_1))
    return false;
  if (!equals(this.o1k_1, other.o1k_1))
    return false;
  return true;
};
var static_init_called_47;
function static_init_47() {
  if (static_init_called_47)
    return Unit_instance;
  static_init_called_47 = true;
  Slot_SQUAT_instance = new Slot('SQUAT', 0, setOf_0(Muscle_QUADRICEPS_getInstance()), Force_PUSH_getInstance(), MovementPattern_SQUAT_getInstance(), false);
  Slot_HINGE_instance = new Slot('HINGE', 1, setOf([Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_LOWER_BACK_getInstance()]), Force_PULL_getInstance(), MovementPattern_HINGE_getInstance());
  Slot_HORIZONTAL_PUSH_instance = new Slot('HORIZONTAL_PUSH', 2, setOf_0(Muscle_CHEST_getInstance()), Force_PUSH_getInstance(), MovementPattern_HORIZONTAL_PUSH_getInstance());
  Slot_VERTICAL_PUSH_instance = new Slot('VERTICAL_PUSH', 3, setOf_0(Muscle_SHOULDERS_getInstance()), Force_PUSH_getInstance(), MovementPattern_VERTICAL_PUSH_getInstance());
  Slot_HORIZONTAL_PULL_instance = new Slot('HORIZONTAL_PULL', 4, setOf_0(Muscle_MIDDLE_BACK_getInstance()), Force_PULL_getInstance(), MovementPattern_HORIZONTAL_PULL_getInstance());
  Slot_VERTICAL_PULL_instance = new Slot('VERTICAL_PULL', 5, setOf_0(Muscle_LATS_getInstance()), Force_PULL_getInstance(), MovementPattern_VERTICAL_PULL_getInstance());
  Slot_SINGLE_LEG_instance = new Slot('SINGLE_LEG', 6, setOf([Muscle_QUADRICEPS_getInstance(), Muscle_GLUTES_getInstance()]), Force_PUSH_getInstance(), MovementPattern_SQUAT_getInstance(), true);
}
var Slot_SQUAT_instance;
var Slot_HINGE_instance;
var Slot_HORIZONTAL_PUSH_instance;
var Slot_VERTICAL_PUSH_instance;
var Slot_HORIZONTAL_PULL_instance;
var Slot_VERTICAL_PULL_instance;
var Slot_SINGLE_LEG_instance;
var static_init_called_48;
function static_init_48() {
  if (static_init_called_48)
    return Unit_instance;
  static_init_called_48 = true;
  Template_FULL_BODY_instance = new Template('FULL_BODY', 0, 'Full Body', listOf([Slot_SQUAT_getInstance(), Slot_HORIZONTAL_PUSH_getInstance(), Slot_HORIZONTAL_PULL_getInstance(), Slot_HINGE_getInstance(), Slot_VERTICAL_PUSH_getInstance(), Slot_VERTICAL_PULL_getInstance()]), toSet(get_entries_31()));
  Template_UPPER_instance = new Template('UPPER', 1, 'Upper', listOf([Slot_HORIZONTAL_PUSH_getInstance(), Slot_HORIZONTAL_PULL_getInstance(), Slot_VERTICAL_PUSH_getInstance(), Slot_VERTICAL_PULL_getInstance()]), setOf([Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_TRAPS_getInstance(), Muscle_NECK_getInstance()]));
  Template_LOWER_instance = new Template('LOWER', 2, 'Lower', listOf([Slot_SQUAT_getInstance(), Slot_HINGE_getInstance()]), setOf([Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_ABDOMINALS_getInstance()]), listOf_0(Slot_SINGLE_LEG_getInstance()));
  Template_PUSH_instance = new Template('PUSH', 3, 'Push', listOf([Slot_HORIZONTAL_PUSH_getInstance(), Slot_VERTICAL_PUSH_getInstance()]), setOf([Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance()]));
  Template_PULL_instance = new Template('PULL', 4, 'Pull', listOf([Slot_VERTICAL_PULL_getInstance(), Slot_HORIZONTAL_PULL_getInstance()]), setOf([Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_BICEPS_getInstance(), Muscle_TRAPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_NECK_getInstance()]));
  Template_LEGS_instance = new Template('LEGS', 5, 'Legs', listOf([Slot_SQUAT_getInstance(), Slot_HINGE_getInstance()]), setOf([Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_ABDOMINALS_getInstance()]), listOf_0(Slot_SINGLE_LEG_getInstance()));
  Template_HINGE_instance = new Template('HINGE', 6, 'Hinge', listOf_0(Slot_HINGE_getInstance()), setOf([Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDOMINALS_getInstance()]));
  Template_SQUAT_instance = new Template('SQUAT', 7, 'Squat', listOf_0(Slot_SQUAT_getInstance()), setOf([Muscle_QUADRICEPS_getInstance(), Muscle_CALVES_getInstance(), Muscle_ABDUCTORS_getInstance()]));
  Template_ACCESSORIES_instance = new Template('ACCESSORIES', 8, 'Accessories', emptyList(), setOf([Muscle_SHOULDERS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_CALVES_getInstance(), Muscle_ABDOMINALS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_TRAPS_getInstance(), Muscle_NECK_getInstance()]));
}
var Template_FULL_BODY_instance;
var Template_UPPER_instance;
var Template_LOWER_instance;
var Template_PUSH_instance;
var Template_PULL_instance;
var Template_LEGS_instance;
var Template_HINGE_instance;
var Template_SQUAT_instance;
var Template_ACCESSORIES_instance;
function Slot(name, ordinal, muscles, force, pattern, unilateral) {
  unilateral = unilateral === VOID ? null : unilateral;
  Enum.call(this, name, ordinal);
  this.r1k_1 = muscles;
  this.s1k_1 = force;
  this.t1k_1 = pattern;
  this.u1k_1 = unilateral;
}
function Template(name, ordinal, label, slots, muscles, after) {
  after = after === VOID ? emptyList() : after;
  Enum.call(this, name, ordinal);
  this.x1k_1 = label;
  this.y1k_1 = slots;
  this.z1k_1 = muscles;
  this.a1l_1 = after;
}
function templates($this, split) {
  var tmp;
  switch (split.y1_1) {
    case 0:
    case 1:
      tmp = listOf_0(Template_FULL_BODY_getInstance());
      break;
    case 2:
      tmp = listOf([Template_UPPER_getInstance(), Template_LOWER_getInstance()]);
      break;
    case 3:
      tmp = listOf([Template_PUSH_getInstance(), Template_PULL_getInstance(), Template_LEGS_getInstance()]);
      break;
    case 4:
      tmp = listOf([Template_PUSH_getInstance(), Template_HINGE_getInstance(), Template_PULL_getInstance(), Template_SQUAT_getInstance()]);
      break;
    case 5:
      tmp = listOf([Template_PUSH_getInstance(), Template_PULL_getInstance(), Template_LEGS_getInstance(), Template_ACCESSORIES_getInstance()]);
      break;
    case 6:
      tmp = listOf([Template_PUSH_getInstance(), Template_HINGE_getInstance(), Template_PULL_getInstance(), Template_SQUAT_getInstance(), Template_ACCESSORIES_getInstance()]);
      break;
    case 7:
      tmp = listOf([Template_PUSH_getInstance(), Template_PULL_getInstance(), Template_LEGS_getInstance(), Template_UPPER_getInstance(), Template_LOWER_getInstance()]);
      break;
    case 8:
      tmp = listOf([Template_PUSH_getInstance(), Template_HINGE_getInstance(), Template_PULL_getInstance(), Template_SQUAT_getInstance(), Template_UPPER_getInstance(), Template_LOWER_getInstance()]);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function Picked(exercise, muscle, sets, mainLift, cap) {
  cap = cap === VOID ? null : cap;
  this.b1l_1 = exercise;
  this.c1l_1 = muscle;
  this.d1l_1 = sets;
  this.e1l_1 = mainLift;
  this.f1l_1 = cap;
}
function getsAutoWarmup($this, $receiver) {
  return !$receiver.equals(Equipment_BODYWEIGHT_getInstance()) && !$receiver.equals(Equipment_BAND_getInstance()) && !$receiver.equals(Equipment_OTHER_getInstance());
}
function nameDays($this, days) {
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$0 = new ProgramGenerator$nameDays$$inlined$groupingBy$1(days);
  var counts = eachCount(tmp$ret$0);
  var seen = HashMap_init_$Create$();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(days, 10));
  var _iterator__ex2g4s = days.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp;
    var tmp0_elvis_lhs = counts.t1(item.n1a_1);
    if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) <= 1) {
      tmp = item;
    } else {
      var tmp1_elvis_lhs = seen.t1(item.n1a_1);
      var index = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp2 = item.n1a_1;
      // Inline function 'kotlin.collections.set' call
      var value = index + 1 | 0;
      seen.l2(tmp2, value);
      tmp = item.g1l(item.n1a_1 + ' ' + toString_1(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), index)));
    }
    var tmp$ret$3 = tmp;
    destination.f(tmp$ret$3);
  }
  return destination;
}
function roundHalfUp_0($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function sam$kotlin_Comparator$0_9(function_0) {
  this.h1l_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_9).ea = function (a, b) {
  return this.h1l_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_9).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_9).h2 = function () {
  return this.h1l_1;
};
protoOf(sam$kotlin_Comparator$0_9).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_9).hashCode = function () {
  return hashCode(this.h2());
};
function ProgramGenerator$weeklyTargets$$inlined$groupingBy$1($this) {
  this.i1l_1 = $this;
}
protoOf(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1).j2 = function () {
  return this.i1l_1.j();
};
protoOf(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1).o12 = function (element) {
  return element;
};
protoOf(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function ProgramGenerator$generate$preferred$lambda(it) {
  return false;
}
function generate$preferred$ifStaple(exercise, value, otherwise) {
  return !(generate$staple(exercise) == null) ? value : otherwise;
}
function ProgramGenerator$generate$preferred$lambda_0(it) {
  return generate$staple(it) == null;
}
function ProgramGenerator$generate$preferred$lambda_1(it) {
  return it.x1b_1 == null;
}
function ProgramGenerator$generate$preferred$lambda_2($duplicate) {
  return function (it) {
    return $duplicate(it);
  };
}
function ProgramGenerator$generate$preferred$lambda_3(it) {
  var tmp0_elvis_lhs = generate$staple(it);
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function ProgramGenerator$generate$preferred$lambda_4(it) {
  return generate$preferred$ifStaple(it, ProgramGenerator_getInstance().i1m_1.b9(it.t1b_1), false);
}
function ProgramGenerator$generate$preferred$lambda_5(it) {
  return generate$preferred$ifStaple(it, it.i1c_1, false);
}
function ProgramGenerator$generate$preferred$lambda_6($usage) {
  return function (it) {
    var tmp0_elvis_lhs = $usage.t1(it.s1b_1);
    return generate$preferred$ifStaple(it, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, 0);
  };
}
function ProgramGenerator$generate$preferred$lambda_7(it) {
  return generate$preferred$ifStaple(it, it.u1b_1.y1_1, 0);
}
function ProgramGenerator$generate$preferred$lambda_8($score) {
  return function (it) {
    return -$score(it);
  };
}
function ProgramGenerator$generate$preferred$lambda_9(it) {
  return generate$preferred$ifStaple(it, it.t1b_1.length, 0);
}
function ProgramGenerator$generate$preferred$lambda_10(it) {
  return it.s1b_1;
}
function ProgramGenerator$generate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.s1b_1;
  var tmp$ret$2 = b.s1b_1;
  return compareValues(tmp, tmp$ret$2);
}
function generate$poolFor(candidates, dayGym) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = candidates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!dayGym.d1h_1.r(element.s1b_1) && dayGym.k1h(element.u1b_1)) {
      destination.f(element);
    }
  }
  return destination;
}
function generate$allowed($settings, groupOwner, exercise) {
  var tmp;
  if (!$settings.v1f_1) {
    tmp = true;
  } else {
    var tmp0 = exercise.e1c_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        var tmp0_elvis_lhs = groupOwner.t1(element);
        if (!((tmp0_elvis_lhs == null ? exercise.s1b_1 : tmp0_elvis_lhs) === exercise.s1b_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function generate$rankBonus($settings, exercise, slot) {
  if (!$settings.v1f_1)
    return 0.0;
  var tmp0_safe_receiver = exercise.f1c_1.t1($settings.i1f_1);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t1(slot);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = 2.0 * (9.0 - tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  var rank = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  var tmp3_safe_receiver = $settings.x1f_1.t1(exercise.s1b_1);
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.math.ln' call
    var x = 1.0 + tmp3_safe_receiver;
    // Inline function 'kotlin.math.min' call
    var b = Math.log(x);
    tmp_0 = Math.min(3.0, b);
  }
  var tmp4_elvis_lhs = tmp_0;
  var familiar = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
  return rank + familiar;
}
function generate$seconds(chosen, $settings, exercise, sets) {
  var tmp;
  var tmp_0;
  if (getsAutoWarmup(ProgramGenerator_getInstance(), exercise.u1b_1)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(chosen, Collection)) {
        tmp_1 = chosen.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = chosen.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.b1l_1.u1b_1.equals(exercise.u1b_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = imul(Warmups_getInstance().j1m_1.o(), 75);
  } else {
    tmp = 0;
  }
  var warmup = tmp;
  return imul(sets, 40 + ProgramGenerator_getInstance().p1m($settings, exercise) | 0) + 60 + warmup;
}
function generate$contribute(need, exercise, sets) {
  var _iterator__ex2g4s = exercise.v1b_1.j();
  while (_iterator__ex2g4s.k()) {
    var m = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = need.t1(m);
    // Inline function 'kotlin.collections.set' call
    var value = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) - sets;
    need.l2(m, value);
  }
  var _iterator__ex2g4s_0 = exercise.w1b_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var m_0 = _iterator__ex2g4s_0.l();
    var tmp1_elvis_lhs = need.t1(m_0);
    // Inline function 'kotlin.collections.set' call
    var value_0 = (tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) - 0.5 * sets;
    need.l2(m_0, value_0);
  }
}
function generate$addExercise(used, budget, chosen, groupOwner, $settings, need, exercise, servedMuscle, mainLift, wanted) {
  wanted = wanted === VOID ? null : wanted;
  var most = wanted == null ? 2 : wanted;
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(most, 2);
  var tmp0 = downTo(most, tmp$ret$0);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = tmp0.xc_1;
    var last = tmp0.yc_1;
    var step = tmp0.zc_1;
    if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + step | 0;
        var it = element;
        if (used._v + generate$seconds(chosen, $settings, exercise, it) <= budget) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
       while (!(element === last));
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var sets = tmp;
  used._v = used._v + generate$seconds(chosen, $settings, exercise, sets);
  chosen.f(new Picked(exercise, servedMuscle, sets, mainLift, wanted));
  generate$contribute(need, exercise, sets);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = exercise.e1c_1.j();
  while (_iterator__ex2g4s.k()) {
    var element_0 = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.getOrPut' call
    var value = groupOwner.t1(element_0);
    var tmp_0;
    if (value == null) {
      var answer = exercise.s1b_1;
      groupOwner.l2(element_0, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
  }
  return true;
}
function generate$maxSets($settings, picked) {
  return !(picked.f1l_1 == null) ? picked.f1l_1 : !$settings.y1f_1.equals(CompoundSetRule_GREEDY_getInstance()) && !picked.e1l_1 ? 4 : !picked.e1l_1 ? 3 : $settings.i1f_1.equals(TrainingGoal_STRENGTH_getInstance()) ? 5 : 4;
}
function generate$coverage(need, exercise) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = exercise.v1b_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    var tmp0_elvis_lhs = need.t1(element);
    // Inline function 'kotlin.math.max' call
    var b = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    sum = tmp + Math.max(0.0, b);
  }
  var tmp_0 = sum;
  // Inline function 'kotlin.collections.sumOf' call
  var sum_0 = 0;
  var _iterator__ex2g4s_0 = exercise.w1b_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp_1 = sum_0;
    var tmp0_elvis_lhs_0 = need.t1(element_0);
    // Inline function 'kotlin.math.max' call
    var b_0 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
    sum_0 = tmp_1 + Math.max(0.0, b_0);
  }
  return tmp_0 + 0.5 * sum_0;
}
function generate$variety(usage, exercise) {
  var tmp0_elvis_lhs = usage.t1(exercise.s1b_1);
  return 3.0 * (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
}
function generate$staple(exercise) {
  var tmp0_safe_receiver = exercise.d1c_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = ProgramGenerator_getInstance().h1m_1.t1(tmp0_safe_receiver);
  }
  return tmp;
}
function generate$preferred(usage, duplicate, score) {
  var tmp;
  if (duplicate === VOID) {
    tmp = ProgramGenerator$generate$preferred$lambda;
  } else {
    tmp = duplicate;
  }
  duplicate = tmp;
  var tmp_0 = ProgramGenerator$generate$preferred$lambda_0;
  var tmp_1 = ProgramGenerator$generate$preferred$lambda_1;
  var tmp_2 = ProgramGenerator$generate$preferred$lambda_2(duplicate);
  var tmp_3 = ProgramGenerator$generate$preferred$lambda_3;
  var tmp_4 = ProgramGenerator$generate$preferred$lambda_4;
  var tmp_5 = ProgramGenerator$generate$preferred$lambda_5;
  var tmp_6 = ProgramGenerator$generate$preferred$lambda_6(usage);
  var tmp_7 = ProgramGenerator$generate$preferred$lambda_7;
  var tmp_8 = ProgramGenerator$generate$preferred$lambda_8(score);
  var tmp_9 = ProgramGenerator$generate$preferred$lambda_9;
  return compareBy([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, ProgramGenerator$generate$preferred$lambda_10]);
}
function ProgramGenerator$generate$lambda_0($template) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0 = b.v1b_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.m();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$2 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if ($template.z1k_1.r(element)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$2 = count;
    }
    var tmp_0 = tmp$ret$2;
    var tmp0_0 = a.v1b_1;
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.count' call
      var tmp_1;
      if (isInterface(tmp0_0, Collection)) {
        tmp_1 = tmp0_0.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$5 = 0;
        break $l$block_0;
      }
      var count_0 = 0;
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if ($template.z1k_1.r(element_0)) {
          count_0 = count_0 + 1 | 0;
          checkCountOverflow(count_0);
        }
      }
      tmp$ret$5 = count_0;
    }
    var tmp$ret$4 = tmp$ret$5;
    return compareValues(tmp_0, tmp$ret$4);
  };
}
function ProgramGenerator$generate$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.s1b_1;
      var tmp$ret$2 = b.s1b_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_2($rankSlot, $settings, $need, $usage) {
  return function (it) {
    return generate$coverage($need, it) - generate$variety($usage, it) + generate$rankBonus($settings, it, $rankSlot) + ($settings.i1f_1.equals(TrainingGoal_STRENGTH_getInstance()) && it.u1b_1.equals(Equipment_BARBELL_getInstance()) ? 1.0 : 0.0);
  };
}
function ProgramGenerator$generate$lambda_3($need) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0_elvis_lhs = $need.t1(a);
    var tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp0_elvis_lhs_0 = $need.t1(b);
    var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
    return compareValues(tmp, tmp$ret$2);
  };
}
function ProgramGenerator$generate$lambda_4($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b.y1_1;
      var tmp$ret$2 = a.y1_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_5(it) {
  return !it.equals(Muscle_ABDOMINALS_getInstance());
}
function ProgramGenerator$generate$lambda_6($need) {
  return function (it) {
    var tmp0_elvis_lhs = $need.t1(it);
    return tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  };
}
function ProgramGenerator$generate$lambda_7($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b.y1_1;
      var tmp$ret$2 = a.y1_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_8($settings) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = $settings.i1f_1.equals(TrainingGoal_STRENGTH_getInstance()) && a.gb_1.e1l_1 ? 0 : 1;
    var tmp$ret$2 = $settings.i1f_1.equals(TrainingGoal_STRENGTH_getInstance()) && b.gb_1.e1l_1 ? 0 : 1;
    return compareValues(tmp, tmp$ret$2);
  };
}
function ProgramGenerator$generate$lambda_9($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.gb_1.d1l_1;
      var tmp$ret$2 = b.gb_1.d1l_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_10($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.fb_1;
      var tmp$ret$2 = b.fb_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function generate$duplicate(patterns, families, exercise) {
  return !(exercise.h1c_1 == null) && patterns.r(exercise.h1c_1) || (!(exercise.d1c_1 == null) && families.r(exercise.d1c_1));
}
function ProgramGenerator$generate$duplicate$ref($patterns, $families) {
  return constructCallableReference(function (p0) {
    return generate$duplicate($patterns, $families, p0);
  }, 1, 0, 0, 'duplicate', [$patterns, $families]);
}
function ProgramGenerator$generate$lambda_11($need, $usage, $settings) {
  return function (it) {
    return (ProgramGenerator_getInstance().q1m(it) ? 0.0 : 3.0) + generate$coverage($need, it) - generate$variety($usage, it) + generate$rankBonus($settings, it, ExerciseSlot_ACCESSORY_getInstance());
  };
}
function ProgramGenerator$nameDays$$inlined$groupingBy$1($this) {
  this.r1m_1 = $this;
}
protoOf(ProgramGenerator$nameDays$$inlined$groupingBy$1).j2 = function () {
  return this.r1m_1.j();
};
protoOf(ProgramGenerator$nameDays$$inlined$groupingBy$1).o12 = function (element) {
  return element.n1a_1;
};
protoOf(ProgramGenerator$nameDays$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function Slot_SQUAT_getInstance() {
  static_init_47();
  return Slot_SQUAT_instance;
}
function Slot_HINGE_getInstance() {
  static_init_47();
  return Slot_HINGE_instance;
}
function Slot_HORIZONTAL_PUSH_getInstance() {
  static_init_47();
  return Slot_HORIZONTAL_PUSH_instance;
}
function Slot_VERTICAL_PUSH_getInstance() {
  static_init_47();
  return Slot_VERTICAL_PUSH_instance;
}
function Slot_HORIZONTAL_PULL_getInstance() {
  static_init_47();
  return Slot_HORIZONTAL_PULL_instance;
}
function Slot_VERTICAL_PULL_getInstance() {
  static_init_47();
  return Slot_VERTICAL_PULL_instance;
}
function Slot_SINGLE_LEG_getInstance() {
  static_init_47();
  return Slot_SINGLE_LEG_instance;
}
function Template_FULL_BODY_getInstance() {
  static_init_48();
  return Template_FULL_BODY_instance;
}
function Template_UPPER_getInstance() {
  static_init_48();
  return Template_UPPER_instance;
}
function Template_LOWER_getInstance() {
  static_init_48();
  return Template_LOWER_instance;
}
function Template_PUSH_getInstance() {
  static_init_48();
  return Template_PUSH_instance;
}
function Template_PULL_getInstance() {
  static_init_48();
  return Template_PULL_instance;
}
function Template_LEGS_getInstance() {
  static_init_48();
  return Template_LEGS_instance;
}
function Template_HINGE_getInstance() {
  static_init_48();
  return Template_HINGE_instance;
}
function Template_SQUAT_getInstance() {
  static_init_48();
  return Template_SQUAT_instance;
}
function Template_ACCESSORIES_getInstance() {
  static_init_48();
  return Template_ACCESSORIES_instance;
}
function ProgramGenerator() {
  ProgramGenerator_instance = this;
  this.j1l_1 = 40;
  this.k1l_1 = 60;
  this.l1l_1 = 75;
  this.m1l_1 = 2;
  this.n1l_1 = 3;
  this.o1l_1 = 4;
  this.p1l_1 = 5;
  this.q1l_1 = 2.0;
  this.r1l_1 = 0.3333333333333333;
  this.s1l_1 = 0.6666666666666666;
  this.t1l_1 = 9;
  this.u1l_1 = 1.5;
  this.v1l_1 = 0.75;
  this.w1l_1 = 3.0;
  this.x1l_1 = 5;
  this.y1l_1 = 5;
  this.z1l_1 = 5;
  this.a1m_1 = 4;
  this.b1m_1 = 65;
  this.c1m_1 = 2.0;
  this.d1m_1 = 3.0;
  this.e1m_1 = setOf([Muscle_CHEST_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_BICEPS_getInstance(), Muscle_TRICEPS_getInstance()]);
  this.f1m_1 = setOf([Muscle_CALVES_getInstance(), Muscle_ABDOMINALS_getInstance()]);
  this.g1m_1 = listOf(['bench press', 'incline bench press', 'chest press', 'leverage chest press', 'pushup', 'push up', 'dip tricep', 'parallel dip', 'standing military press', 'shoulder press', 'seated military press', 'leverage shoulder press', 'military press', 'bent over row', 'seated row', 'row', 't row handle', 'lying t row', 'leverage iso row', 'inverted row', 'lat pulldown', 'pullup', 'chin up', 'pulldown', 'front lat pulldown', 'v pulldown', 'squat', 'leg press', 'hack squat', 'goblet squat', 'bodyweight squat', 'lunge', 'walking lunge', 'split squat dumbbell', 'step ups', 'bodyweight walking lunge', 'romanian deadlift', 'deadlift', 'stiff legged deadlift', 'hip thrust', 'lying leg curl', 'seated leg curl', 'leg extension', 'standing calf raise', 'seated calf raise', 'calf raise', 'flye', 'crossover', 'side lateral raise', 'rear delt fly', 'face pull', 'curl', 'bicep curl', 'hammer curl', 'preacher curl', 'incline curl', 'tricep pushdown', 'skullcrusher', 'lying tricep extension', 'tricep extension', 'crunch', 'plank', 'hanging leg raise']);
  var tmp = this;
  // Inline function 'kotlin.collections.associate' call
  var this_0 = withIndex(this.g1m_1);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var index = element.hb();
    var family = element.ib();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(family, index);
    destination.l2(pair.nb_1, pair.ob_1);
  }
  tmp.h1m_1 = destination;
  this.i1m_1 = Regex_init_$Create$_0('\\b(wide|close|narrow|reverse|single|one[- ](arm|leg)|alternat\\w*|neutral|underhand|behind|deficit|pause\\w*|chains?|bands?|banded|speed|partials?|powerlifting)\\b', RegexOption_IGNORE_CASE_getInstance());
}
protoOf(ProgramGenerator).s1m = function (ageYears) {
  return !(ageYears == null) && ageYears >= 65;
};
protoOf(ProgramGenerator).t1m = function (daysPerWeek) {
  return daysPerWeek <= 3 ? Split_FULL_BODY_getInstance() : daysPerWeek === 4 ? Split_UPPER_LOWER_getInstance() : daysPerWeek === 5 ? Split_PPL_UPPER_LOWER_getInstance() : Split_PPL_getInstance();
};
protoOf(ProgramGenerator).u1m = function (goal, compound) {
  var tmp;
  switch (goal.y1_1) {
    case 0:
      tmp = compound ? 180 : 120;
      break;
    case 1:
      tmp = compound ? 150 : 90;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(ProgramGenerator).p1m = function (settings, exercise) {
  var compound = this.q1m(exercise);
  var tmp;
  switch (settings.z1f_1.y1_1) {
    case 0:
      tmp = this.u1m(settings.i1f_1, compound);
      break;
    case 1:
      tmp = Companion_getInstance_13().x1m(exercise).equals(Region_CORE_getInstance()) ? 180 : !compound ? 90 : settings.i1f_1.equals(TrainingGoal_HYPERTROPHY_getInstance()) ? 150 : 180;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(ProgramGenerator).y1m = function (goal, compound, mainLift) {
  var tmp;
  switch (goal.y1_1) {
    case 0:
      tmp = mainLift ? to(3, 6) : compound ? to(5, 8) : to(8, 12);
      break;
    case 1:
      tmp = compound ? to(6, 10) : to(10, 15);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(ProgramGenerator).z1m = function (settings) {
  var tmp;
  switch (settings.l1f_1.y1_1) {
    case 0:
      tmp = to(8.0, 12.0);
      break;
    case 1:
      tmp = to(12.0, 16.0);
      break;
    case 2:
      tmp = to(16.0, 20.0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var _destruct__k2r9zo = tmp;
  var startBase = _destruct__k2r9zo.hb();
  var peakBase = _destruct__k2r9zo.ib();
  // Inline function 'kotlin.collections.groupingBy' call
  var this_0 = settings.n1f_1;
  var tmp$ret$0 = new ProgramGenerator$weeklyTargets$$inlined$groupingBy$1(this_0);
  var points = eachCount(tmp$ret$0);
  var start = LinkedHashMap_init_$Create$_1();
  var peak = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = get_entries_31().j();
  while (_iterator__ex2g4s.k()) {
    var muscle = _iterator__ex2g4s.l();
    var tmp1_elvis_lhs = points.t1(muscle);
    var focusPoints = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var share = this.e1m_1.r(muscle) ? 1.0 : this.f1m_1.r(muscle) || focusPoints > 0 ? 0.6666666666666666 : 0.0;
    var s = startBase * share;
    var p = peakBase * share;
    if (focusPoints > 0) {
      s = s + 2.0 * focusPoints;
      p = p + 2.0 * focusPoints;
    } else if (settings.o1f_1.r(muscle)) {
      s = s * 0.3333333333333333;
      p = s;
    }
    // Inline function 'kotlin.collections.set' call
    var value = s;
    start.l2(muscle, value);
    // Inline function 'kotlin.collections.set' call
    var value_0 = p;
    peak.l2(muscle, value_0);
  }
  return to(start, peak);
};
protoOf(ProgramGenerator).a1n = function (settings, gym, catalogue, dayGyms) {
  var containsArg = settings.j1f_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= 7 : false)) {
    var message = 'daysPerWeek must be 1\u20137';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsArg_0 = settings.k1f_1;
  // Inline function 'kotlin.require' call
  if (!(10 <= containsArg_0 ? containsArg_0 <= 300 : false)) {
    var message_0 = 'minutesPerSession must be 10\u2013300';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(settings.n1f_1.o() <= 5)) {
    var message_1 = 'at most 5 focus points';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.require' call
  if (!(distinct(settings.o1f_1).o() <= 5)) {
    var message_2 = 'at most 5 deprioritised muscles';
    throw IllegalArgumentException_init_$Create$(toString(message_2));
  }
  // Inline function 'kotlin.require' call
  if (!(settings.r1f_1 >= 1)) {
    var message_3 = 'cycles must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message_3));
  }
  var split = settings.m1f_1.equals(Split_AUTO_getInstance()) ? this.t1m(settings.j1f_1) : settings.m1f_1;
  var templates_0 = templates(this, split);
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var size = settings.j1f_1;
  var list = ArrayList_init_$Create$(size);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$14 = templates_0.n(index % templates_0.o() | 0);
      list.f(tmp$ret$14);
    }
     while (inductionVariable < size);
  var dayTemplates = list;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = catalogue.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    if (equals_0(element.z1b_1, 'strength', true) && !element.b1c_1 && !settings.t1f_1.r(element.s1b_1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !element.v1b_1.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (!settings.v1f_1 || settings.w1f_1.n1(element_0.g1c_1)) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.distinctBy' call
  var set = HashSet_init_$Create$();
  var list_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var e = _iterator__ex2g4s_1.l();
    var key = e.s1b_1;
    if (set.f(key)) {
      list_0.f(e);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = ProgramGenerator$generate$lambda;
  var tmp$ret$25 = new sam$kotlin_Comparator$0_9(tmp_0);
  var candidates = sortedWith(list_0, tmp$ret$25);
  var defaultPool = generate$poolFor(candidates, gym);
  var groupOwner = HashMap_init_$Create$();
  var _destruct__k2r9zo = this.z1m(settings);
  var startTargets = _destruct__k2r9zo.hb();
  var peakTargets = _destruct__k2r9zo.ib();
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = get_entries_31();
  var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s_2 = this_0.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_indices(dayTemplates);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$_0();
    var inductionVariable_0 = tmp0.xc_1;
    var last = tmp0.yc_1;
    if (inductionVariable_0 <= last)
      do {
        var element_2 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var it = element_2;
        if (dayTemplates.n(it).z1k_1.r(element_1) || (settings.n1f_1.r(element_1) && dayTemplates.n(it).equals(Template_ACCESSORIES_getInstance()))) {
          destination_1.f(element_2);
        }
      }
       while (!(element_2 === last));
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (destination_1.m()) {
      var tmp_2;
      var tmp0_elvis_lhs = peakTargets.t1(element_1);
      if ((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) > 0.0) {
        tmp_2 = toList(get_indices(dayTemplates));
      } else {
        tmp_2 = emptyList();
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = destination_1;
    }
    var tmp$ret$28 = tmp_1;
    result.l2(element_1, tmp$ret$28);
  }
  var daysFor = result;
  var budget = settings.k1f_1 * 60.0;
  var usage = HashMap_init_$Create$();
  var days = ArrayList_init_$Create$_0();
  var occurrences = HashMap_init_$Create$();
  var tmp_3;
  if (settings.p1f_1 && settings.r1f_1 >= 2) {
    tmp_3 = settings.q1f_1.equals(DeloadPosition_NONE_getInstance()) ? DeloadPosition_LAST_getInstance() : settings.q1f_1;
  } else {
    tmp_3 = DeloadPosition_NONE_getInstance();
  }
  var deload = tmp_3;
  var iterator = dayTemplates.j();
  var index_0 = 0;
  while (iterator.k()) {
    var dayIndex = index_0;
    index_0 = index_0 + 1 | 0;
    var template = iterator.l();
    var tmp0_0 = take(dayTemplates, dayIndex);
    var tmp$ret$34;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_4;
      if (isInterface(tmp0_0, Collection)) {
        tmp_4 = tmp0_0.m();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$34 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s_3 = tmp0_0.j();
      while (_iterator__ex2g4s_3.k()) {
        var element_3 = _iterator__ex2g4s_3.l();
        if (element_3.equals(template)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$34 = count;
    }
    var repeat = tmp$ret$34;
    // Inline function 'kotlin.math.max' call
    var b = template.y1k_1.o() / 2 | 0;
    var step = Math.max(1, b);
    var tmp_5;
    if (template.y1k_1.m()) {
      tmp_5 = emptyList();
    } else {
      var rotation = imul(repeat, step) % template.y1k_1.o() | 0;
      tmp_5 = plus(drop(template.y1k_1, rotation), take(template.y1k_1, rotation));
    }
    var slots = plus(tmp_5, template.a1l_1);
    var need = LinkedHashMap_init_$Create$_1();
    var _iterator__ex2g4s_4 = get_entries_31().j();
    while (_iterator__ex2g4s_4.k()) {
      var muscle = _iterator__ex2g4s_4.l();
      var trainingDays = getValue(daysFor, muscle);
      var tmp_6;
      if (trainingDays.r(dayIndex)) {
        var tmp0_elvis_lhs_0 = peakTargets.t1(muscle);
        tmp_6 = (tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) / trainingDays.o();
      } else {
        tmp_6 = 0.0;
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp_6;
      need.l2(muscle, value);
    }
    var chosen = ArrayList_init_$Create$_0();
    var used = {_v: 0.0};
    var tmp1_safe_receiver = getOrNull_0(dayGyms, dayIndex);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ob_1;
    var tmp_7;
    if (tmp2_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_7 = generate$poolFor(candidates, tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_7;
    var pool = tmp3_elvis_lhs == null ? defaultPool : tmp3_elvis_lhs;
    if (settings.a1g_1) {
      var tmp4_safe_receiver = getOrNull_0(dayGyms, dayIndex);
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.ob_1;
      var dayGym = tmp5_elvis_lhs == null ? gym : tmp5_elvis_lhs;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_5 = catalogue.j();
      while (_iterator__ex2g4s_5.k()) {
        var element_4 = _iterator__ex2g4s_5.l();
        if (equals_0(element_4.z1b_1, 'plyometrics', true) && !element_4.b1c_1 && !settings.t1f_1.r(element_4.s1b_1) && !dayGym.d1h_1.r(element_4.s1b_1) && dayGym.k1h(element_4.u1b_1)) {
          destination_2.f(element_4);
        }
      }
      var powerPool = destination_2;
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_8 = ProgramGenerator$generate$lambda_0(template);
      // Inline function 'kotlin.comparisons.thenBy' call
      var this_1 = new sam$kotlin_Comparator$0_9(tmp_8);
      var tmp_9 = ProgramGenerator$generate$lambda_1(this_1);
      var tmp$ret$44 = new sam$kotlin_Comparator$0_9(tmp_9);
      var tmp6_safe_receiver = firstOrNull(sortedWith(powerPool, tmp$ret$44));
      if (tmp6_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver = firstOrNull(tmp6_safe_receiver.v1b_1);
        var tmp_10;
        if (tmp0_safe_receiver == null) {
          tmp_10 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_10 = generate$addExercise(used, budget, chosen, groupOwner, settings, need, tmp6_safe_receiver, tmp0_safe_receiver, false, 2);
        }
      }
    }
    var _iterator__ex2g4s_6 = slots.j();
    $l$loop_1: while (_iterator__ex2g4s_6.k()) {
      var slot = _iterator__ex2g4s_6.l();
      if (chosen.o() >= 9)
        break $l$loop_1;
      // Inline function 'kotlin.collections.maxOf' call
      var iterator_0 = slot.r1k_1.j();
      if (!iterator_0.k())
        throw NoSuchElementException_init_$Create$_0();
      var it_0 = iterator_0.l();
      var tmp0_elvis_lhs_1 = need.t1(it_0);
      var maxValue = tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1;
      while (iterator_0.k()) {
        var it_1 = iterator_0.l();
        var tmp0_elvis_lhs_2 = need.t1(it_1);
        var v = tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2;
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      if (maxValue < 1.5)
        continue $l$loop_1;
      var rankSlot = chosen.m() ? ExerciseSlot_PRIMARY_getInstance() : ExerciseSlot_SECONDARY_getInstance();
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_3 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_7 = pool.j();
      while (_iterator__ex2g4s_7.k()) {
        var element_5 = _iterator__ex2g4s_7.l();
        var tmp_11;
        var tmp_12;
        var tmp_13;
        if (ProgramGenerator_getInstance().q1m(element_5)) {
          var tmp0_1 = element_5.v1b_1;
          var tmp$ret$56;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_14;
            if (isInterface(tmp0_1, Collection)) {
              tmp_14 = tmp0_1.m();
            } else {
              tmp_14 = false;
            }
            if (tmp_14) {
              tmp$ret$56 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s_8 = tmp0_1.j();
            while (_iterator__ex2g4s_8.k()) {
              var element_6 = _iterator__ex2g4s_8.l();
              if (slot.r1k_1.r(element_6)) {
                tmp$ret$56 = true;
                break $l$block_1;
              }
            }
            tmp$ret$56 = false;
          }
          tmp_13 = tmp$ret$56;
        } else {
          tmp_13 = false;
        }
        if (tmp_13) {
          var tmp$ret$58;
          $l$block_3: {
            // Inline function 'kotlin.collections.none' call
            var tmp_15;
            if (isInterface(chosen, Collection)) {
              tmp_15 = chosen.m();
            } else {
              tmp_15 = false;
            }
            if (tmp_15) {
              tmp$ret$58 = true;
              break $l$block_3;
            }
            var _iterator__ex2g4s_9 = chosen.j();
            while (_iterator__ex2g4s_9.k()) {
              var element_7 = _iterator__ex2g4s_9.l();
              if (element_7.b1l_1.s1b_1 === element_5.s1b_1) {
                tmp$ret$58 = false;
                break $l$block_3;
              }
            }
            tmp$ret$58 = true;
          }
          tmp_12 = tmp$ret$58;
        } else {
          tmp_12 = false;
        }
        if (tmp_12) {
          tmp_11 = generate$allowed(settings, groupOwner, element_5);
        } else {
          tmp_11 = false;
        }
        if (tmp_11) {
          destination_3.f(element_5);
        }
      }
      var fits = destination_3;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_10 = fits.j();
      while (_iterator__ex2g4s_10.k()) {
        var element_8 = _iterator__ex2g4s_10.l();
        if (equals(element_8.h1c_1, slot.t1k_1) && (slot.u1k_1 == null || element_8.i1c_1 === slot.u1k_1)) {
          destination_4.f(element_8);
        }
      }
      // Inline function 'kotlin.collections.ifEmpty' call
      var tmp_16;
      if (destination_4.m()) {
        var tmp_17;
        if (slot.equals(Slot_SINGLE_LEG_getInstance())) {
          tmp_17 = emptyList();
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_5 = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s_11 = fits.j();
          while (_iterator__ex2g4s_11.k()) {
            var element_9 = _iterator__ex2g4s_11.l();
            if (element_9.y1b_1 == null || equals(element_9.y1b_1, slot.s1k_1)) {
              destination_5.f(element_9);
            }
          }
          tmp_17 = destination_5;
        }
        tmp_16 = tmp_17;
      } else {
        tmp_16 = destination_4;
      }
      var candidates_0 = tmp_16;
      var tmp7_elvis_lhs = minWithOrNull(candidates_0, generate$preferred(usage, VOID, ProgramGenerator$generate$lambda_2(rankSlot, settings, need, usage)));
      var tmp_18;
      if (tmp7_elvis_lhs == null) {
        continue $l$loop_1;
      } else {
        tmp_18 = tmp7_elvis_lhs;
      }
      var best = tmp_18;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_2 = slot.r1k_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination_6 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_12 = tmp0_2.j();
      while (_iterator__ex2g4s_12.k()) {
        var element_10 = _iterator__ex2g4s_12.l();
        if (best.v1b_1.r(element_10) || best.w1b_1.r(element_10)) {
          destination_6.f(element_10);
        }
      }
      var tmp_19 = destination_6;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_20 = ProgramGenerator$generate$lambda_3(need);
      // Inline function 'kotlin.comparisons.thenByDescending' call
      var this_2 = new sam$kotlin_Comparator$0_9(tmp_20);
      var tmp_21 = ProgramGenerator$generate$lambda_4(this_2);
      var tmp$ret$72 = new sam$kotlin_Comparator$0_9(tmp_21);
      var tmp8_elvis_lhs = maxWithOrNull(tmp_19, tmp$ret$72);
      var served = tmp8_elvis_lhs == null ? first(best.v1b_1) : tmp8_elvis_lhs;
      var tmp$ret$73;
      $l$block_5: {
        // Inline function 'kotlin.collections.none' call
        var tmp_22;
        if (isInterface(chosen, Collection)) {
          tmp_22 = chosen.m();
        } else {
          tmp_22 = false;
        }
        if (tmp_22) {
          tmp$ret$73 = true;
          break $l$block_5;
        }
        var _iterator__ex2g4s_13 = chosen.j();
        while (_iterator__ex2g4s_13.k()) {
          var element_11 = _iterator__ex2g4s_13.l();
          if (element_11.e1l_1) {
            tmp$ret$73 = false;
            break $l$block_5;
          }
        }
        tmp$ret$73 = true;
      }
      var tmp_23 = tmp$ret$73;
      var tmp9_elvis_lhs = need.t1(served);
      generate$addExercise(used, budget, chosen, groupOwner, settings, need, best, served, tmp_23, settings.y1f_1.h1k(tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs));
    }
    var exhausted = HashSet_init_$Create$();
    var deferred = HashSet_init_$Create$();
    $l$loop_4: while (true) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_3 = get_entries_31();
      // Inline function 'kotlin.collections.filterTo' call
      var destination_7 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_14 = tmp0_3.j();
      while (_iterator__ex2g4s_14.k()) {
        var element_12 = _iterator__ex2g4s_14.l();
        var tmp_24;
        if (!exhausted.r(element_12)) {
          var tmp0_elvis_lhs_3 = need.t1(element_12);
          tmp_24 = (tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) >= 0.75;
        } else {
          tmp_24 = false;
        }
        if (tmp_24) {
          destination_7.f(element_12);
        }
      }
      var open = destination_7;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_8 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_15 = open.j();
      while (_iterator__ex2g4s_15.k()) {
        var element_13 = _iterator__ex2g4s_15.l();
        if (!deferred.r(element_13)) {
          destination_8.f(element_13);
        }
      }
      // Inline function 'kotlin.collections.ifEmpty' call
      var tmp_25;
      if (destination_8.m()) {
        tmp_25 = open;
      } else {
        tmp_25 = destination_8;
      }
      var tmp_26 = tmp_25;
      var tmp_27 = ProgramGenerator$generate$lambda_5;
      // Inline function 'kotlin.comparisons.thenByDescending' call
      var this_3 = compareBy([tmp_27, ProgramGenerator$generate$lambda_6(need)]);
      var tmp_28 = ProgramGenerator$generate$lambda_7(this_3);
      var tmp$ret$83 = new sam$kotlin_Comparator$0_9(tmp_28);
      var tmp10_elvis_lhs = maxWithOrNull(tmp_26, tmp$ret$83);
      var tmp_29;
      if (tmp10_elvis_lhs == null) {
        break $l$loop_4;
      } else {
        tmp_29 = tmp10_elvis_lhs;
      }
      var muscle_0 = tmp_29;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_4 = withIndex(chosen);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_9 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_16 = tmp0_4.j();
      while (_iterator__ex2g4s_16.k()) {
        var element_14 = _iterator__ex2g4s_16.l();
        var picked = element_14.ib();
        if (picked.b1l_1.v1b_1.r(muscle_0) && picked.d1l_1 < generate$maxSets(settings, picked)) {
          destination_9.f(element_14);
        }
      }
      var tmp_30 = destination_9;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_31 = ProgramGenerator$generate$lambda_8(settings);
      // Inline function 'kotlin.comparisons.thenBy' call
      var this_4 = new sam$kotlin_Comparator$0_9(tmp_31);
      var tmp_32 = ProgramGenerator$generate$lambda_9(this_4);
      // Inline function 'kotlin.comparisons.thenBy' call
      var this_5 = new sam$kotlin_Comparator$0_9(tmp_32);
      var tmp_33 = ProgramGenerator$generate$lambda_10(this_5);
      var tmp$ret$89 = new sam$kotlin_Comparator$0_9(tmp_33);
      var tmp11_safe_receiver = minWithOrNull(tmp_30, tmp$ret$89);
      var existing = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.gb_1;
      if (!(existing == null)) {
        var cost = 40 + this.p1m(settings, existing.b1l_1) | 0;
        if (used._v + cost <= budget) {
          used._v = used._v + cost;
          existing.d1l_1 = existing.d1l_1 + 1 | 0;
          generate$contribute(need, existing.b1l_1, 1);
          continue $l$loop_4;
        }
      }
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_10 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_17 = chosen.j();
      while (_iterator__ex2g4s_17.k()) {
        var element_15 = _iterator__ex2g4s_17.l();
        var tmp0_safe_receiver_0 = element_15.b1l_1.h1c_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_10.f(tmp0_safe_receiver_0);
        }
      }
      var patterns = toSet(destination_10);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_11 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_18 = chosen.j();
      while (_iterator__ex2g4s_18.k()) {
        var element_16 = _iterator__ex2g4s_18.l();
        var tmp0_safe_receiver_1 = element_16.b1l_1.d1c_1;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_11.f(tmp0_safe_receiver_1);
        }
      }
      var families = toSet(destination_11);
      var tmp_34;
      var tmp_35;
      if (chosen.o() < 9) {
        var tmp12_elvis_lhs = need.t1(muscle_0);
        tmp_35 = (tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs) >= 1.5;
      } else {
        tmp_35 = false;
      }
      if (tmp_35) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_12 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_19 = pool.j();
        while (_iterator__ex2g4s_19.k()) {
          var element_17 = _iterator__ex2g4s_19.l();
          var tmp_36;
          var tmp_37;
          if (element_17.v1b_1.r(muscle_0)) {
            var tmp$ret$107;
            $l$block_7: {
              // Inline function 'kotlin.collections.none' call
              var tmp_38;
              if (isInterface(chosen, Collection)) {
                tmp_38 = chosen.m();
              } else {
                tmp_38 = false;
              }
              if (tmp_38) {
                tmp$ret$107 = true;
                break $l$block_7;
              }
              var _iterator__ex2g4s_20 = chosen.j();
              while (_iterator__ex2g4s_20.k()) {
                var element_18 = _iterator__ex2g4s_20.l();
                if (element_18.b1l_1.s1b_1 === element_17.s1b_1) {
                  tmp$ret$107 = false;
                  break $l$block_7;
                }
              }
              tmp$ret$107 = true;
            }
            tmp_37 = tmp$ret$107;
          } else {
            tmp_37 = false;
          }
          if (tmp_37) {
            tmp_36 = generate$allowed(settings, groupOwner, element_17);
          } else {
            tmp_36 = false;
          }
          if (tmp_36) {
            destination_12.f(element_17);
          }
        }
        var tmp_39 = destination_12;
        var tmp_40 = ProgramGenerator$generate$duplicate$ref(patterns, families);
        tmp_34 = minWithOrNull(tmp_39, generate$preferred(usage, tmp_40, ProgramGenerator$generate$lambda_11(need, usage, settings)));
      } else {
        tmp_34 = null;
      }
      var best_0 = tmp_34;
      var tmp_41;
      if (!(best_0 == null) && generate$duplicate(patterns, families, best_0) && !deferred.r(muscle_0)) {
        var tmp$ret$109;
        $l$block_9: {
          // Inline function 'kotlin.collections.any' call
          var tmp_42;
          if (isInterface(open, Collection)) {
            tmp_42 = open.m();
          } else {
            tmp_42 = false;
          }
          if (tmp_42) {
            tmp$ret$109 = false;
            break $l$block_9;
          }
          var _iterator__ex2g4s_21 = open.j();
          while (_iterator__ex2g4s_21.k()) {
            var element_19 = _iterator__ex2g4s_21.l();
            if (!element_19.equals(muscle_0) && !deferred.r(element_19)) {
              tmp$ret$109 = true;
              break $l$block_9;
            }
          }
          tmp$ret$109 = false;
        }
        tmp_41 = tmp$ret$109;
      } else {
        tmp_41 = false;
      }
      if (tmp_41) {
        deferred.f(muscle_0);
        continue $l$loop_4;
      }
      if (best_0 == null || !generate$addExercise(used, budget, chosen, groupOwner, settings, need, best_0, muscle_0, false)) {
        exhausted.f(muscle_0);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_22 = chosen.j();
    while (_iterator__ex2g4s_22.k()) {
      var element_20 = _iterator__ex2g4s_22.l();
      var tmp2 = element_20.b1l_1.s1b_1;
      var tmp0_elvis_lhs_4 = usage.t1(element_20.b1l_1.s1b_1);
      // Inline function 'kotlin.collections.set' call
      var value_0 = (tmp0_elvis_lhs_4 == null ? 0 : tmp0_elvis_lhs_4) + 1 | 0;
      usage.l2(tmp2, value_0);
    }
    var tmp_43 = Warmups_getInstance();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_13 = ArrayList_init_$Create$(collectionSizeOrDefault(chosen, 10));
    var _iterator__ex2g4s_23 = chosen.j();
    while (_iterator__ex2g4s_23.k()) {
      var item = _iterator__ex2g4s_23.l();
      var tmp$ret$116 = item.b1l_1.u1b_1;
      destination_13.f(tmp$ret$116);
    }
    var warmupIndexes = tmp_43.b1n(destination_13);
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_14 = ArrayList_init_$Create$(collectionSizeOrDefault(chosen, 10));
    var index_1 = 0;
    var _iterator__ex2g4s_24 = chosen.j();
    while (_iterator__ex2g4s_24.k()) {
      var item_0 = _iterator__ex2g4s_24.l();
      var _unary__edvuaz = index_1;
      index_1 = _unary__edvuaz + 1 | 0;
      var index_2 = checkIndexOverflow(_unary__edvuaz);
      var compound = ProgramGenerator_getInstance().q1m(item_0.b1l_1);
      var _destruct__k2r9zo_0 = ProgramGenerator_getInstance().y1m(settings.i1f_1, compound, item_0.e1l_1);
      var repMin = _destruct__k2r9zo_0.hb();
      var repMax = _destruct__k2r9zo_0.ib();
      var tmp0_elvis_lhs_5 = peakTargets.t1(item_0.c1l_1);
      var peakTarget = tmp0_elvis_lhs_5 == null ? 0.0 : tmp0_elvis_lhs_5;
      var tmp1_elvis_lhs = startTargets.t1(item_0.c1l_1);
      var startTarget = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      var tmp_44;
      if (peakTarget > 0.0) {
        // Inline function 'kotlin.math.max' call
        var b_0 = roundHalfUp_0(ProgramGenerator_getInstance(), item_0.d1l_1 * startTarget / peakTarget);
        tmp_44 = Math.max(1, b_0);
      } else {
        tmp_44 = item_0.d1l_1;
      }
      var startSets = tmp_44;
      var tmp2_elvis_lhs = occurrences.t1(item_0.b1l_1.s1b_1);
      var occurrence = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var tmp2_0 = item_0.b1l_1.s1b_1;
      // Inline function 'kotlin.collections.set' call
      var value_1 = occurrence + 1 | 0;
      occurrences.l2(tmp2_0, value_1);
      var tmp_45 = ProgramGenerator_getInstance().p1m(settings, item_0.b1l_1);
      var tmp_46 = warmupIndexes.r(index_2) ? Companion_getInstance_24().c1n_1 : Companion_getInstance_24().e1n_1;
      var tmp_47 = Periodisation_instance;
      // Inline function 'kotlin.math.min' call
      var b_1 = item_0.d1l_1;
      var tmp$ret$122 = Math.min(startSets, b_1);
      var tmp$ret$119 = new ProgramExercise(item_0.b1l_1.s1b_1, tmp_45, tmp_46, settings.s1f_1, tmp_47.b1k(settings.r1f_1, tmp$ret$122, item_0.d1l_1, repMin, repMax, settings.s1f_1, deload, VOID, VOID, VOID, occurrence));
      destination_14.f(tmp$ret$119);
    }
    var exercises = destination_14;
    var tmp13_safe_receiver = getOrNull_0(dayGyms, dayIndex);
    days.f(new ProgramDay(template.x1k_1, exercises, tmp13_safe_receiver == null ? null : tmp13_safe_receiver.nb_1));
  }
  var named = nameDays(this, days);
  var tmp14_elvis_lhs = settings.u1f_1;
  var program = new TrainingProgram(tmp14_elvis_lhs == null ? split.e1k_1 + ' ' + settings.j1f_1 + 'x' : tmp14_elvis_lhs, settings.i1f_1, settings.r1f_1, deload, named);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(catalogue, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_15 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_25 = catalogue.j();
  while (_iterator__ex2g4s_25.k()) {
    var element_21 = _iterator__ex2g4s_25.l();
    var tmp$ret$125 = element_21.s1b_1;
    destination_15.l2(tmp$ret$125, element_21);
  }
  var byId = destination_15;
  var firstLoading = deload.equals(DeloadPosition_FIRST_getInstance()) ? 1 : 0;
  var lastLoading = deload.equals(DeloadPosition_LAST_getInstance()) ? settings.r1f_1 - 2 | 0 : settings.r1f_1 - 1 | 0;
  var tmp_48 = this.f1n(program, firstLoading, byId);
  var tmp_49 = this.f1n(program, lastLoading, byId);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_16 = ArrayList_init_$Create$(collectionSizeOrDefault(named, 10));
  var _iterator__ex2g4s_26 = named.j();
  while (_iterator__ex2g4s_26.k()) {
    var item_1 = _iterator__ex2g4s_26.l();
    var tmp$ret$128 = ProgramGenerator_getInstance().g1n(item_1, lastLoading, byId) / 60.0;
    destination_16.f(tmp$ret$128);
  }
  return new GeneratedProgram(program, split, startTargets, peakTargets, tmp_48, tmp_49, destination_16);
};
protoOf(ProgramGenerator).f1n = function (program, cycle, catalogue) {
  var sets = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = get_entries_31().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.set' call
    sets.l2(element, 0.0);
  }
  var _iterator__ex2g4s_0 = program.j1a_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var day = _iterator__ex2g4s_0.l();
    var _iterator__ex2g4s_1 = day.o1a_1.j();
    $l$loop_0: while (_iterator__ex2g4s_1.k()) {
      var planned = _iterator__ex2g4s_1.l();
      var tmp0_elvis_lhs = catalogue.t1(planned.w1a_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var exercise = tmp;
      var prescription = planned.e1b(cycle);
      if (prescription.u1a_1.equals(SetType_WARMUP_getInstance()))
        continue $l$loop_0;
      var count = prescription.q1a_1;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = exercise.v1b_1.j();
      while (_iterator__ex2g4s_2.k()) {
        var element_0 = _iterator__ex2g4s_2.l();
        // Inline function 'kotlin.collections.set' call
        var value = getValue(sets, element_0) + count;
        sets.l2(element_0, value);
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = exercise.w1b_1.j();
      while (_iterator__ex2g4s_3.k()) {
        var element_1 = _iterator__ex2g4s_3.l();
        // Inline function 'kotlin.collections.set' call
        var value_0 = getValue(sets, element_1) + 0.5 * count;
        sets.l2(element_1, value_0);
      }
    }
  }
  return sets;
};
protoOf(ProgramGenerator).g1n = function (day, cycle, catalogue) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = day.o1a_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    var prescription = element.e1b(cycle);
    var tmp_0;
    switch (element.y1a_1.h1n_1.y1_1) {
      case 0:
      case 1:
        tmp_0 = Warmups_getInstance().j1m_1.o();
        break;
      case 2:
        tmp_0 = 0;
        break;
      case 3:
        tmp_0 = element.y1a_1.i1n_1.o();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var warmups = tmp_0;
    sum = tmp + (prescription.q1a_1 * (40 + element.x1a_1 | 0) + 60 + imul(warmups, 75));
  }
  return sum;
};
protoOf(ProgramGenerator).q1m = function (exercise) {
  var tmp0_subject = exercise.x1b_1;
  var tmp;
  switch (tmp0_subject == null ? -1 : tmp0_subject.y1_1) {
    case 0:
      tmp = true;
      break;
    case 1:
      tmp = false;
      break;
    case -1:
      tmp = (exercise.v1b_1.o() + exercise.w1b_1.o() | 0) > 1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var ProgramGenerator_instance;
function ProgramGenerator_getInstance() {
  if (ProgramGenerator_instance == null)
    new ProgramGenerator();
  return ProgramGenerator_instance;
}
function Substitute(exercise, score) {
  this.m1d_1 = exercise;
  this.n1d_1 = score;
}
protoOf(Substitute).toString = function () {
  return 'Substitute(exercise=' + this.m1d_1.toString() + ', score=' + this.n1d_1 + ')';
};
protoOf(Substitute).hashCode = function () {
  var result = this.m1d_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.n1d_1) | 0;
  return result;
};
protoOf(Substitute).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Substitute))
    return false;
  if (!this.m1d_1.equals(other.m1d_1))
    return false;
  if (!equals(this.n1d_1, other.n1d_1))
    return false;
  return true;
};
function jaccard($this, a, b) {
  if (a.m() && b.m())
    return 1.0;
  return intersect(a, b).o() / union(a, b).o();
}
function sam$kotlin_Comparator$0_10(function_0) {
  this.j1n_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_10).ea = function (a, b) {
  return this.j1n_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_10).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_10).h2 = function () {
  return this.j1n_1;
};
protoOf(sam$kotlin_Comparator$0_10).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_10).hashCode = function () {
  return hashCode(this.h2());
};
function Substitutions$rank$lambda($exercise, $hidden) {
  return function (it) {
    return !(it.s1b_1 === $exercise.s1b_1) && !it.b1c_1 && !$hidden.r(it.s1b_1);
  };
}
function Substitutions$rank$lambda_0($exercise) {
  return function (it) {
    return equals_0(it.z1b_1, $exercise.z1b_1, true);
  };
}
function Substitutions$rank$lambda_1($gym) {
  return function (it) {
    return $gym == null || (!$gym.d1h_1.r(it.s1b_1) && $gym.k1h(it.u1b_1));
  };
}
function Substitutions$rank$lambda_2($skills) {
  return function (it) {
    return $skills == null || $skills.n1(it.g1c_1);
  };
}
function Substitutions$rank$lambda_3($primary) {
  return function (candidate) {
    var tmp0 = candidate.v1b_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.m();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if ($primary.r(element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function Substitutions$rank$lambda_4($primary, $secondary, $exercise) {
  return function (candidate) {
    var score = 10.0 * jaccard(Substitutions_instance, $primary, toSet(candidate.v1b_1)) + 3.0 * jaccard(Substitutions_instance, $secondary, toSet(candidate.w1b_1)) + (!(candidate.d1c_1 == null) && candidate.d1c_1 == $exercise.d1c_1 ? 2.0 : 0.0) + (!(candidate.x1b_1 == null) && equals(candidate.x1b_1, $exercise.x1b_1) ? 2.0 : 0.0) + (!(candidate.h1c_1 == null) && equals(candidate.h1c_1, $exercise.h1c_1) ? 1.0 : 0.0) + (!(candidate.y1b_1 == null) && equals(candidate.y1b_1, $exercise.y1b_1) ? 1.0 : 0.0) + (candidate.u1b_1.equals($exercise.u1b_1) ? 0.5 : 0.0);
    return new Substitute(candidate, score);
  };
}
function Substitutions$rank$lambda_5(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.n1d_1;
  var tmp$ret$2 = a.n1d_1;
  return compareValues(tmp, tmp$ret$2);
}
function Substitutions$rank$lambda_6($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.m1d_1.t1b_1;
      var tmp$ret$2 = b.m1d_1.t1b_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function Substitutions$rank$lambda_7($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.m1d_1.s1b_1;
      var tmp$ret$2 = b.m1d_1.s1b_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function Substitutions() {
}
protoOf(Substitutions).k1n = function (exerciseId, catalogue, gym, hidden, limit, skills) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = catalogue.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.s1b_1 === exerciseId) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return emptyList();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var exercise = tmp;
  return this.l1n(exercise, catalogue, gym, hidden, limit, skills);
};
protoOf(Substitutions).m1n = function (exerciseId, catalogue, gym, hidden, limit, skills, $super) {
  gym = gym === VOID ? null : gym;
  hidden = hidden === VOID ? emptySet() : hidden;
  limit = limit === VOID ? 10 : limit;
  skills = skills === VOID ? null : skills;
  return $super === VOID ? this.k1n(exerciseId, catalogue, gym, hidden, limit, skills) : $super.k1n.call(this, exerciseId, catalogue, gym, hidden, limit, skills);
};
protoOf(Substitutions).l1n = function (exercise, catalogue, gym, hidden, limit, skills) {
  // Inline function 'kotlin.require' call
  if (!(limit > 0)) {
    var message = 'limit must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var primary = toSet(exercise.v1b_1);
  var secondary = toSet(exercise.w1b_1);
  var tmp = asSequence(catalogue);
  var tmp_0 = filter(tmp, Substitutions$rank$lambda(exercise, hidden));
  var tmp_1 = filter(tmp_0, Substitutions$rank$lambda_0(exercise));
  var tmp_2 = filter(tmp_1, Substitutions$rank$lambda_1(gym));
  var tmp_3 = filter(tmp_2, Substitutions$rank$lambda_2(skills));
  var tmp_4 = filter(tmp_3, Substitutions$rank$lambda_3(primary));
  var tmp_5 = map(tmp_4, Substitutions$rank$lambda_4(primary, secondary, exercise));
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_6 = Substitutions$rank$lambda_5;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_10(tmp_6);
  var tmp_7 = Substitutions$rank$lambda_6(this_0);
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_1 = new sam$kotlin_Comparator$0_10(tmp_7);
  var tmp_8 = Substitutions$rank$lambda_7(this_1);
  var tmp$ret$4 = new sam$kotlin_Comparator$0_10(tmp_8);
  return toList_0(take_0(sortedWith_0(tmp_5, tmp$ret$4), limit));
};
protoOf(Substitutions).l1d = function (exercise, catalogue, gym, hidden, limit, skills, $super) {
  gym = gym === VOID ? null : gym;
  hidden = hidden === VOID ? emptySet() : hidden;
  limit = limit === VOID ? 10 : limit;
  skills = skills === VOID ? null : skills;
  return $super === VOID ? this.l1n(exercise, catalogue, gym, hidden, limit, skills) : $super.l1n.call(this, exercise, catalogue, gym, hidden, limit, skills);
};
var Substitutions_instance;
function Substitutions_getInstance() {
  return Substitutions_instance;
}
function Experience_BEGINNER_getInstance() {
  static_init_43();
  return Experience_BEGINNER_instance;
}
function Experience_INTERMEDIATE_getInstance() {
  static_init_43();
  return Experience_INTERMEDIATE_instance;
}
function Experience_ADVANCED_getInstance() {
  static_init_43();
  return Experience_ADVANCED_instance;
}
function Split_AUTO_getInstance() {
  static_init_44();
  return Split_AUTO_instance;
}
function Split_FULL_BODY_getInstance() {
  static_init_44();
  return Split_FULL_BODY_instance;
}
function Split_UPPER_LOWER_getInstance() {
  static_init_44();
  return Split_UPPER_LOWER_instance;
}
function Split_PPL_getInstance() {
  static_init_44();
  return Split_PPL_instance;
}
function Split_PUSH_PULL_HINGE_SQUAT_getInstance() {
  static_init_44();
  return Split_PUSH_PULL_HINGE_SQUAT_instance;
}
function Split_PPL_ACCESSORIES_getInstance() {
  static_init_44();
  return Split_PPL_ACCESSORIES_instance;
}
function Split_PPHS_ACCESSORIES_getInstance() {
  static_init_44();
  return Split_PPHS_ACCESSORIES_instance;
}
function Split_PPL_UPPER_LOWER_getInstance() {
  static_init_44();
  return Split_PPL_UPPER_LOWER_instance;
}
function Split_PPHS_UPPER_LOWER_getInstance() {
  static_init_44();
  return Split_PPHS_UPPER_LOWER_instance;
}
function CompoundSetRule_GREEDY_getInstance() {
  static_init_45();
  return CompoundSetRule_GREEDY_instance;
}
function CompoundSetRule_POWER_getInstance() {
  static_init_45();
  return CompoundSetRule_POWER_instance;
}
function RestRule_BY_GOAL_getInstance() {
  static_init_46();
  return RestRule_BY_GOAL_instance;
}
function RestRule_BY_TYPE_getInstance() {
  static_init_46();
  return RestRule_BY_TYPE_instance;
}
function ImportedProgram(program, unmatched) {
  this.n1n_1 = program;
  this.o1n_1 = unmatched;
}
protoOf(ImportedProgram).toString = function () {
  return 'ImportedProgram(program=' + this.n1n_1.toString() + ', unmatched=' + toString(this.o1n_1) + ')';
};
protoOf(ImportedProgram).hashCode = function () {
  var result = this.n1n_1.hashCode();
  result = imul(result, 31) + hashCode(this.o1n_1) | 0;
  return result;
};
protoOf(ImportedProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ImportedProgram))
    return false;
  if (!this.n1n_1.equals(other.n1n_1))
    return false;
  if (!equals(this.o1n_1, other.o1n_1))
    return false;
  return true;
};
function words($this, text) {
  var tmp = Regex_init_$Create$('[a-z0-9]+');
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = text.toLowerCase();
  var tmp_0 = tmp.e9(replace_0(tmp$ret$0, '-', ''));
  return toSet_0(map(tmp_0, ProgramImport$words$lambda));
}
function reps($this, text) {
  var tmp0_safe_receiver = $this.t1n_1.c9(text);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var low = toInt(tmp0_safe_receiver.ba().n(1));
    var high = toInt(tmp0_safe_receiver.ba().n(2));
    if (1 <= low ? low <= high : false)
      return to(low, high);
  }
  var tmp1_safe_receiver = $this.u1n_1.c9(text);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q1();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toDoubleOrNull(tmp2_safe_receiver);
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : numberToInt(tmp3_safe_receiver);
  var tmp;
  if (tmp4_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp4_safe_receiver >= 1) {
      tmp_0 = tmp4_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var single = tmp;
  return !(single == null) ? to(single, single) : to(8, 12);
}
function rir($this, text, columnIsRpe) {
  var tmp0_safe_receiver = $this.u1n_1.c9(text);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q1();
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return 2;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var value = tmp;
  var tmp_0;
  if (columnIsRpe || contains_1(text, 'rpe', true)) {
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.text.trimStart' call
    var tmp$ret$0 = toString(trimStart(isCharSequence(text) ? text : THROW_CCE()));
    tmp_0 = startsWith(tmp$ret$0, '@');
  }
  var rpe = tmp_0;
  var tmp_1;
  if (rpe) {
    tmp_1 = Companion_instance_30.v1n(value);
  } else {
    // Inline function 'kotlin.math.floor' call
    var x = value + 0.5;
    var tmp$ret$1 = Math.floor(x);
    tmp_1 = coerceIn_0(numberToInt(tmp$ret$1), 0, 10);
  }
  return tmp_1;
}
function rest($this, text) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var lower = text.toLowerCase();
  var clock = Regex_init_$Create$('(\\d+):(\\d{2})').c9(lower);
  if (!(clock == null))
    return imul(toInt(clock.ba().n(1)), 60) + toInt(clock.ba().n(2)) | 0;
  var tmp0_safe_receiver = $this.u1n_1.c9(lower);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q1();
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return 120;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var value = tmp;
  return coerceIn_0(numberToInt(contains_1(lower, 'min') || endsWith(lower, 'm') ? value * 60 : value), 0, 3600);
}
function setType($this, text) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var lower = text.toLowerCase();
  return contains_1(lower, 'warm') ? SetType_WARMUP_getInstance() : contains_1(lower, 'drop') ? SetType_DROP_getInstance() : contains_1(lower, 'myo') || contains_1(lower, 'rest') ? SetType_MYO_getInstance() : contains_1(lower, 'fail') || contains_1(lower, 'amrap') ? SetType_FAILURE_getInstance() : SetType_STANDARD_getInstance();
}
function ProgramImport$parse$lambda(it) {
  return removePrefix(it, '\uFEFF');
}
function ProgramImport$parse$lambda_0(it) {
  // Inline function 'kotlin.text.isNotBlank' call
  return !isBlank(it);
}
function parse$column(header, names) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = header.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      if (contains_2(names, item)) {
        tmp$ret$0 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$0 = -1;
  }
  return tmp$ret$0;
}
function parse$cell(cells, index) {
  var tmp;
  if (index >= 0) {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = getOrNull_0(cells, index);
    tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  } else {
    tmp = '';
  }
  return tmp;
}
function ProgramImport$words$lambda(m) {
  // Inline function 'kotlin.let' call
  var it = m.q1();
  return it.length > 3 && endsWith(it, 's') && !endsWith(it, 'ss') ? dropLast(it, 1) : it;
}
function ProgramImport() {
  ProgramImport_instance = this;
  this.p1n_1 = 3;
  this.q1n_1 = 120;
  this.r1n_1 = 2;
  this.s1n_1 = Regex_init_$Create$('set \\d+ type');
  this.t1n_1 = Regex_init_$Create$('(\\d+)\\s*(?:[-\u2013\u2014]|to)\\s*(\\d+)');
  this.u1n_1 = Regex_init_$Create$('\\d+(?:\\.\\d+)?');
}
protoOf(ProgramImport).w1n = function (csv, catalogue, name) {
  var tmp = lineSequence(csv);
  var tmp_0 = map(tmp, ProgramImport$parse$lambda);
  var lines = toList_0(filter(tmp_0, ProgramImport$parse$lambda_0));
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!!lines.m()) {
    var message = 'the file is empty';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = TrainingBacktest_getInstance().b1o(first(lines));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = toString(trim(isCharSequence(item) ? item : THROW_CCE())).toLowerCase();
    destination.f(tmp$ret$5);
  }
  var header = destination;
  var exerciseColumn = parse$column(header, ['exercise', 'exercise name', 'movement']);
  // Inline function 'kotlin.require' call
  if (!(exerciseColumn >= 0)) {
    var message_0 = 'the header needs an Exercise column';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var dayColumn = parse$column(header, ['day', 'workout', 'day name']);
  var setsColumn = parse$column(header, ['sets', 'set count']);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_indices(header);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      if (ProgramImport_getInstance().s1n_1.a9(header.n(it))) {
        destination_0.f(element);
      }
    }
     while (!(element === last));
  var setTypeColumns = destination_0;
  var repsColumn = parse$column(header, ['rep range', 'reps', 'rep target']);
  var tmp$ret$14;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s_0 = header.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      switch (item_0) {
        case 'rir':
        case 'rpe':
        case 'rir or rpe':
          var tmp$ret$15 = true;
          break;
        default:
          tmp$ret$15 = item_0 === 'rir/rpe';
          break;
      }
      if (tmp$ret$15) {
        tmp$ret$14 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$14 = -1;
  }
  var effortColumn = tmp$ret$14;
  var effortIsRpe = effortColumn >= 0 && header.n(effortColumn) === 'rpe';
  var restColumn = parse$column(header, ['rest', 'rest (s)', 'rest time']);
  var days = LinkedHashMap_init_$Create$_1();
  var unmatched = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = drop(lines, 1).j();
  $l$loop_0: while (_iterator__ex2g4s_1.k()) {
    var line = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.map' call
    var this_1 = TrainingBacktest_getInstance().b1o(line);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_2 = this_1.j();
    while (_iterator__ex2g4s_2.k()) {
      var item_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$18 = toString(trim(isCharSequence(item_1) ? item_1 : THROW_CCE()));
      destination_1.f(tmp$ret$18);
    }
    var cells = destination_1;
    var exerciseName = parse$cell(cells, exerciseColumn);
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(exerciseName) === 0)
      continue $l$loop_0;
    var exercise = this.c1o(exerciseName, catalogue);
    if (exercise == null) {
      if (!unmatched.r(exerciseName)) {
        unmatched.f(exerciseName);
      }
      continue $l$loop_0;
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(setTypeColumns, 10));
    var _iterator__ex2g4s_3 = setTypeColumns.j();
    while (_iterator__ex2g4s_3.k()) {
      var item_2 = _iterator__ex2g4s_3.l();
      var tmp$ret$23 = parse$cell(cells, item_2);
      destination_2.f(tmp$ret$23);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_4 = destination_2.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_0 = _iterator__ex2g4s_4.l();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(element_0) > 0) {
        destination_3.f(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_3, 10));
    var _iterator__ex2g4s_5 = destination_3.j();
    while (_iterator__ex2g4s_5.k()) {
      var item_3 = _iterator__ex2g4s_5.l();
      var tmp$ret$30 = setType(this, item_3);
      destination_4.f(tmp$ret$30);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_5 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_6 = destination_4.j();
    while (_iterator__ex2g4s_6.k()) {
      var element_1 = _iterator__ex2g4s_6.l();
      if (!element_1.equals(SetType_WARMUP_getInstance())) {
        destination_5.f(element_1);
      }
    }
    var types = destination_5;
    var tmp0_safe_receiver = toIntOrNull(parse$cell(cells, setsColumn));
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_2;
      if (1 <= tmp0_safe_receiver ? tmp0_safe_receiver <= 20 : false) {
        tmp_2 = tmp0_safe_receiver;
      } else {
        tmp_2 = null;
      }
      tmp_1 = tmp_2;
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.takeIf' call
      var this_2 = types.o();
      var tmp_4;
      if (this_2 > 0) {
        tmp_4 = this_2;
      } else {
        tmp_4 = null;
      }
      tmp_3 = tmp_4;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp_3;
    var sets = tmp2_elvis_lhs == null ? 3 : tmp2_elvis_lhs;
    var _destruct__k2r9zo = reps(this, parse$cell(cells, repsColumn));
    var repMin = _destruct__k2r9zo.hb();
    var repMax = _destruct__k2r9zo.ib();
    var tmp_5 = rir(this, parse$cell(cells, effortColumn), effortIsRpe);
    var tmp3_elvis_lhs = firstOrNull(types);
    var prescription = new CyclePrescription(sets, repMin, repMax, tmp_5, tmp3_elvis_lhs == null ? SetType_STANDARD_getInstance() : tmp3_elvis_lhs);
    // Inline function 'kotlin.text.ifEmpty' call
    var this_3 = parse$cell(cells, dayColumn);
    var tmp_6;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_3) === 0) {
      tmp_6 = 'Day 1';
    } else {
      tmp_6 = this_3;
    }
    var day = tmp_6;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = days.t1(day);
    var tmp_7;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      days.l2(day, answer);
      tmp_7 = answer;
    } else {
      tmp_7 = value;
    }
    tmp_7.f(new ProgramExercise(exercise.s1b_1, rest(this, parse$cell(cells, restColumn)), Companion_getInstance_24().c1n_1, ProgressionScheme_DOUBLE_getInstance(), listOf_0(prescription)));
  }
  var tmp_8 = TrainingGoal_HYPERTROPHY_getInstance();
  var tmp_9 = DeloadPosition_NONE_getInstance();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(days.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_7 = days.w1().j();
  while (_iterator__ex2g4s_7.k()) {
    var item_4 = _iterator__ex2g4s_7.l();
    // Inline function 'kotlin.collections.component1' call
    var dayName = item_4.p1();
    // Inline function 'kotlin.collections.component2' call
    var exercises = item_4.q1();
    // Inline function 'kotlin.collections.distinctBy' call
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_8 = exercises.j();
    while (_iterator__ex2g4s_8.k()) {
      var e = _iterator__ex2g4s_8.l();
      var key = e.w1a_1;
      if (set.f(key)) {
        list.f(e);
      }
    }
    var tmp$ret$46 = new ProgramDay(dayName, list);
    destination_6.f(tmp$ret$46);
  }
  var program = new TrainingProgram(name, tmp_8, 1, tmp_9, destination_6);
  return new ImportedProgram(program, unmatched);
};
protoOf(ProgramImport).c1o = function (name, catalogue) {
  var wanted = words(this, name);
  if (wanted.m())
    return null;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = catalogue.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (equals(words(ProgramImport_getInstance(), element.t1b_1), wanted)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = catalogue.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (words(ProgramImport_getInstance(), element_0.t1b_1).n1(wanted)) {
        destination.f(element_0);
      }
    }
    var tmp$ret$5;
    $l$block_1: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = destination.j();
      if (!iterator.k()) {
        tmp$ret$5 = null;
        break $l$block_1;
      }
      var minElem = iterator.l();
      if (!iterator.k()) {
        tmp$ret$5 = minElem;
        break $l$block_1;
      }
      var minValue = minElem.t1b_1.length;
      do {
        var e = iterator.l();
        var v = e.t1b_1.length;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.k());
      tmp$ret$5 = minElem;
    }
    tmp = tmp$ret$5;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
var ProgramImport_instance;
function ProgramImport_getInstance() {
  if (ProgramImport_instance == null)
    new ProgramImport();
  return ProgramImport_instance;
}
function CyclePrescription(sets, repMin, repMax, rir, setType, skip) {
  setType = setType === VOID ? SetType_STANDARD_getInstance() : setType;
  skip = skip === VOID ? false : skip;
  this.q1a_1 = sets;
  this.r1a_1 = repMin;
  this.s1a_1 = repMax;
  this.t1a_1 = rir;
  this.u1a_1 = setType;
  this.v1a_1 = skip;
  // Inline function 'kotlin.require' call
  if (!(this.q1a_1 >= 1)) {
    var message = 'sets must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsUpper = this.s1a_1;
  var containsArg = this.r1a_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= containsUpper : false)) {
    var message_0 = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var containsArg_0 = this.t1a_1;
  // Inline function 'kotlin.require' call
  if (!(0 <= containsArg_0 ? containsArg_0 <= 10 : false)) {
    var message_1 = 'rir must be 0\u201310';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(CyclePrescription).toString = function () {
  return 'CyclePrescription(sets=' + this.q1a_1 + ', repMin=' + this.r1a_1 + ', repMax=' + this.s1a_1 + ', rir=' + this.t1a_1 + ', setType=' + this.u1a_1.toString() + ', skip=' + this.v1a_1 + ')';
};
protoOf(CyclePrescription).hashCode = function () {
  var result = this.q1a_1;
  result = imul(result, 31) + this.r1a_1 | 0;
  result = imul(result, 31) + this.s1a_1 | 0;
  result = imul(result, 31) + this.t1a_1 | 0;
  result = imul(result, 31) + this.u1a_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.v1a_1) | 0;
  return result;
};
protoOf(CyclePrescription).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CyclePrescription))
    return false;
  if (!(this.q1a_1 === other.q1a_1))
    return false;
  if (!(this.r1a_1 === other.r1a_1))
    return false;
  if (!(this.s1a_1 === other.s1a_1))
    return false;
  if (!(this.t1a_1 === other.t1a_1))
    return false;
  if (!this.u1a_1.equals(other.u1a_1))
    return false;
  if (!(this.v1a_1 === other.v1a_1))
    return false;
  return true;
};
function SetRecord(day, loadKg, reps, rir, type, sessionId) {
  rir = rir === VOID ? null : rir;
  type = type === VOID ? SetType_STANDARD_getInstance() : type;
  sessionId = sessionId === VOID ? null : sessionId;
  this.l1e_1 = day;
  this.m1e_1 = loadKg;
  this.n1e_1 = reps;
  this.o1e_1 = rir;
  this.p1e_1 = type;
  this.q1e_1 = sessionId;
}
protoOf(SetRecord).toString = function () {
  return 'SetRecord(day=' + this.l1e_1 + ', loadKg=' + this.m1e_1 + ', reps=' + this.n1e_1 + ', rir=' + this.o1e_1 + ', type=' + this.p1e_1.toString() + ', sessionId=' + this.q1e_1 + ')';
};
protoOf(SetRecord).hashCode = function () {
  var result = this.l1e_1;
  result = imul(result, 31) + getNumberHashCode(this.m1e_1) | 0;
  result = imul(result, 31) + this.n1e_1 | 0;
  result = imul(result, 31) + (this.o1e_1 == null ? 0 : this.o1e_1) | 0;
  result = imul(result, 31) + this.p1e_1.hashCode() | 0;
  result = imul(result, 31) + (this.q1e_1 == null ? 0 : getStringHashCode(this.q1e_1)) | 0;
  return result;
};
protoOf(SetRecord).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetRecord))
    return false;
  if (!(this.l1e_1 === other.l1e_1))
    return false;
  if (!equals(this.m1e_1, other.m1e_1))
    return false;
  if (!(this.n1e_1 === other.n1e_1))
    return false;
  if (!(this.o1e_1 == other.o1e_1))
    return false;
  if (!this.p1e_1.equals(other.p1e_1))
    return false;
  if (!(this.q1e_1 == other.q1e_1))
    return false;
  return true;
};
var static_init_called_49;
function static_init_49() {
  if (static_init_called_49)
    return Unit_instance;
  static_init_called_49 = true;
  AdjustmentPriority_REPS_FIRST_instance = new AdjustmentPriority('REPS_FIRST', 0);
  AdjustmentPriority_WEIGHT_FIRST_instance = new AdjustmentPriority('WEIGHT_FIRST', 1);
}
var AdjustmentPriority_REPS_FIRST_instance;
var AdjustmentPriority_WEIGHT_FIRST_instance;
function values_33() {
  static_init_49();
  return [AdjustmentPriority_REPS_FIRST_getInstance(), AdjustmentPriority_WEIGHT_FIRST_getInstance()];
}
function valueOf_12(value) {
  static_init_49();
  switch (value) {
    case 'REPS_FIRST':
      return AdjustmentPriority_REPS_FIRST_getInstance();
    case 'WEIGHT_FIRST':
      return AdjustmentPriority_WEIGHT_FIRST_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.AdjustmentPriority.' + value);
      break;
  }
}
function get_entries_28() {
  static_init_49();
  if ($ENTRIES_28 == null)
    $ENTRIES_28 = enumEntries(values_33());
  return $ENTRIES_28;
}
var $ENTRIES_28;
function AdjustmentPriority(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ProgressionOptions(priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct) {
  priority = priority === VOID ? AdjustmentPriority_REPS_FIRST_getInstance() : priority;
  expandRepRange = expandRepRange === VOID ? true : expandRepRange;
  expandBy = expandBy === VOID ? 2 : expandBy;
  weightMatch = weightMatch === VOID ? true : weightMatch;
  fatigue = fatigue === VOID ? new FixedReps() : fatigue;
  curve = curve === VOID ? new EpleyCurve() : curve;
  maxLoadIncreasePct = maxLoadIncreasePct === VOID ? 5.0 : maxLoadIncreasePct;
  maxRepIncrease = maxRepIncrease === VOID ? 2 : maxRepIncrease;
  bodyweightKg = bodyweightKg === VOID ? 0.0 : bodyweightKg;
  bodyweightFactor = bodyweightFactor === VOID ? 0.0 : bodyweightFactor;
  startingOneRepMaxKg = startingOneRepMaxKg === VOID ? null : startingOneRepMaxKg;
  sessionSmoothing = sessionSmoothing === VOID ? 0.6 : sessionSmoothing;
  todayWeight = todayWeight === VOID ? 0.7 : todayWeight;
  rirAdjustment = rirAdjustment === VOID ? 0 : rirAdjustment;
  linearDeloadPct = linearDeloadPct === VOID ? 10.0 : linearDeloadPct;
  clampOneRepMax = clampOneRepMax === VOID ? false : clampOneRepMax;
  surprise = surprise === VOID ? SurpriseCarry_NONE_getInstance() : surprise;
  sessionStepPct = sessionStepPct === VOID ? 0.0 : sessionStepPct;
  this.d1o_1 = priority;
  this.e1o_1 = expandRepRange;
  this.f1o_1 = expandBy;
  this.g1o_1 = weightMatch;
  this.h1o_1 = fatigue;
  this.i1o_1 = curve;
  this.j1o_1 = maxLoadIncreasePct;
  this.k1o_1 = maxRepIncrease;
  this.l1o_1 = bodyweightKg;
  this.m1o_1 = bodyweightFactor;
  this.n1o_1 = startingOneRepMaxKg;
  this.o1o_1 = sessionSmoothing;
  this.p1o_1 = todayWeight;
  this.q1o_1 = rirAdjustment;
  this.r1o_1 = linearDeloadPct;
  this.s1o_1 = clampOneRepMax;
  this.t1o_1 = surprise;
  this.u1o_1 = sessionStepPct;
}
protoOf(ProgressionOptions).v1o = function (priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct) {
  return new ProgressionOptions(priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct);
};
protoOf(ProgressionOptions).w1o = function (priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct, $super) {
  priority = priority === VOID ? this.d1o_1 : priority;
  expandRepRange = expandRepRange === VOID ? this.e1o_1 : expandRepRange;
  expandBy = expandBy === VOID ? this.f1o_1 : expandBy;
  weightMatch = weightMatch === VOID ? this.g1o_1 : weightMatch;
  fatigue = fatigue === VOID ? this.h1o_1 : fatigue;
  curve = curve === VOID ? this.i1o_1 : curve;
  maxLoadIncreasePct = maxLoadIncreasePct === VOID ? this.j1o_1 : maxLoadIncreasePct;
  maxRepIncrease = maxRepIncrease === VOID ? this.k1o_1 : maxRepIncrease;
  bodyweightKg = bodyweightKg === VOID ? this.l1o_1 : bodyweightKg;
  bodyweightFactor = bodyweightFactor === VOID ? this.m1o_1 : bodyweightFactor;
  startingOneRepMaxKg = startingOneRepMaxKg === VOID ? this.n1o_1 : startingOneRepMaxKg;
  sessionSmoothing = sessionSmoothing === VOID ? this.o1o_1 : sessionSmoothing;
  todayWeight = todayWeight === VOID ? this.p1o_1 : todayWeight;
  rirAdjustment = rirAdjustment === VOID ? this.q1o_1 : rirAdjustment;
  linearDeloadPct = linearDeloadPct === VOID ? this.r1o_1 : linearDeloadPct;
  clampOneRepMax = clampOneRepMax === VOID ? this.s1o_1 : clampOneRepMax;
  surprise = surprise === VOID ? this.t1o_1 : surprise;
  sessionStepPct = sessionStepPct === VOID ? this.u1o_1 : sessionStepPct;
  return $super === VOID ? this.v1o(priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct) : $super.v1o.call(this, priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct);
};
protoOf(ProgressionOptions).toString = function () {
  return 'ProgressionOptions(priority=' + this.d1o_1.toString() + ', expandRepRange=' + this.e1o_1 + ', expandBy=' + this.f1o_1 + ', weightMatch=' + this.g1o_1 + ', fatigue=' + toString(this.h1o_1) + ', curve=' + toString(this.i1o_1) + ', maxLoadIncreasePct=' + this.j1o_1 + ', maxRepIncrease=' + this.k1o_1 + ', bodyweightKg=' + this.l1o_1 + ', bodyweightFactor=' + this.m1o_1 + ', startingOneRepMaxKg=' + this.n1o_1 + ', sessionSmoothing=' + this.o1o_1 + ', todayWeight=' + this.p1o_1 + ', rirAdjustment=' + this.q1o_1 + ', linearDeloadPct=' + this.r1o_1 + ', clampOneRepMax=' + this.s1o_1 + ', surprise=' + this.t1o_1.toString() + ', sessionStepPct=' + this.u1o_1 + ')';
};
protoOf(ProgressionOptions).hashCode = function () {
  var result = this.d1o_1.hashCode();
  result = imul(result, 31) + getBooleanHashCode(this.e1o_1) | 0;
  result = imul(result, 31) + this.f1o_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.g1o_1) | 0;
  result = imul(result, 31) + hashCode(this.h1o_1) | 0;
  result = imul(result, 31) + hashCode(this.i1o_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.j1o_1) | 0;
  result = imul(result, 31) + this.k1o_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.l1o_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.m1o_1) | 0;
  result = imul(result, 31) + (this.n1o_1 == null ? 0 : getNumberHashCode(this.n1o_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.o1o_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.p1o_1) | 0;
  result = imul(result, 31) + this.q1o_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1o_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.s1o_1) | 0;
  result = imul(result, 31) + this.t1o_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.u1o_1) | 0;
  return result;
};
protoOf(ProgressionOptions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProgressionOptions))
    return false;
  if (!this.d1o_1.equals(other.d1o_1))
    return false;
  if (!(this.e1o_1 === other.e1o_1))
    return false;
  if (!(this.f1o_1 === other.f1o_1))
    return false;
  if (!(this.g1o_1 === other.g1o_1))
    return false;
  if (!equals(this.h1o_1, other.h1o_1))
    return false;
  if (!equals(this.i1o_1, other.i1o_1))
    return false;
  if (!equals(this.j1o_1, other.j1o_1))
    return false;
  if (!(this.k1o_1 === other.k1o_1))
    return false;
  if (!equals(this.l1o_1, other.l1o_1))
    return false;
  if (!equals(this.m1o_1, other.m1o_1))
    return false;
  if (!equals(this.n1o_1, other.n1o_1))
    return false;
  if (!equals(this.o1o_1, other.o1o_1))
    return false;
  if (!equals(this.p1o_1, other.p1o_1))
    return false;
  if (!(this.q1o_1 === other.q1o_1))
    return false;
  if (!equals(this.r1o_1, other.r1o_1))
    return false;
  if (!(this.s1o_1 === other.s1o_1))
    return false;
  if (!this.t1o_1.equals(other.t1o_1))
    return false;
  if (!equals(this.u1o_1, other.u1o_1))
    return false;
  return true;
};
var static_init_called_50;
function static_init_50() {
  if (static_init_called_50)
    return Unit_instance;
  static_init_called_50 = true;
  TargetIssue_NONE_instance = new TargetIssue('NONE', 0);
  TargetIssue_NO_HISTORY_instance = new TargetIssue('NO_HISTORY', 1);
  TargetIssue_NO_LOADS_instance = new TargetIssue('NO_LOADS', 2);
  TargetIssue_OUTSIDE_REP_RANGE_instance = new TargetIssue('OUTSIDE_REP_RANGE', 3);
  TargetIssue_NO_FEASIBLE_TARGET_instance = new TargetIssue('NO_FEASIBLE_TARGET', 4);
}
var TargetIssue_NONE_instance;
var TargetIssue_NO_HISTORY_instance;
var TargetIssue_NO_LOADS_instance;
var TargetIssue_OUTSIDE_REP_RANGE_instance;
var TargetIssue_NO_FEASIBLE_TARGET_instance;
function TargetIssue(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_51;
function static_init_51() {
  if (static_init_called_51)
    return Unit_instance;
  static_init_called_51 = true;
  AlternativeKind_NEXT_LOAD_UP_instance = new AlternativeKind('NEXT_LOAD_UP', 0);
  AlternativeKind_NEXT_LOAD_DOWN_instance = new AlternativeKind('NEXT_LOAD_DOWN', 1);
  AlternativeKind_EXPAND_REP_RANGE_instance = new AlternativeKind('EXPAND_REP_RANGE', 2);
  AlternativeKind_WEIGHT_MATCH_instance = new AlternativeKind('WEIGHT_MATCH', 3);
}
var AlternativeKind_NEXT_LOAD_UP_instance;
var AlternativeKind_NEXT_LOAD_DOWN_instance;
var AlternativeKind_EXPAND_REP_RANGE_instance;
var AlternativeKind_WEIGHT_MATCH_instance;
function AlternativeKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TargetAlternative(kind, loadKg, reps) {
  this.x1o_1 = kind;
  this.y1o_1 = loadKg;
  this.z1o_1 = reps;
}
protoOf(TargetAlternative).toString = function () {
  return 'TargetAlternative(kind=' + this.x1o_1.toString() + ', loadKg=' + this.y1o_1 + ', reps=' + this.z1o_1 + ')';
};
protoOf(TargetAlternative).hashCode = function () {
  var result = this.x1o_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.y1o_1) | 0;
  result = imul(result, 31) + this.z1o_1 | 0;
  return result;
};
protoOf(TargetAlternative).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TargetAlternative))
    return false;
  if (!this.x1o_1.equals(other.x1o_1))
    return false;
  if (!equals(this.y1o_1, other.y1o_1))
    return false;
  if (!(this.z1o_1 === other.z1o_1))
    return false;
  return true;
};
function PlannedSet(index, loadKg, reps, rir, type, done, outsideRepRange) {
  outsideRepRange = outsideRepRange === VOID ? false : outsideRepRange;
  this.a1p_1 = index;
  this.b1p_1 = loadKg;
  this.c1p_1 = reps;
  this.d1p_1 = rir;
  this.e1p_1 = type;
  this.f1p_1 = done;
  this.g1p_1 = outsideRepRange;
}
protoOf(PlannedSet).toString = function () {
  return 'PlannedSet(index=' + this.a1p_1 + ', loadKg=' + this.b1p_1 + ', reps=' + this.c1p_1 + ', rir=' + this.d1p_1 + ', type=' + this.e1p_1.toString() + ', done=' + this.f1p_1 + ', outsideRepRange=' + this.g1p_1 + ')';
};
protoOf(PlannedSet).hashCode = function () {
  var result = this.a1p_1;
  result = imul(result, 31) + (this.b1p_1 == null ? 0 : getNumberHashCode(this.b1p_1)) | 0;
  result = imul(result, 31) + this.c1p_1 | 0;
  result = imul(result, 31) + this.d1p_1 | 0;
  result = imul(result, 31) + this.e1p_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.f1p_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.g1p_1) | 0;
  return result;
};
protoOf(PlannedSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlannedSet))
    return false;
  if (!(this.a1p_1 === other.a1p_1))
    return false;
  if (!equals(this.b1p_1, other.b1p_1))
    return false;
  if (!(this.c1p_1 === other.c1p_1))
    return false;
  if (!(this.d1p_1 === other.d1p_1))
    return false;
  if (!this.e1p_1.equals(other.e1p_1))
    return false;
  if (!(this.f1p_1 === other.f1p_1))
    return false;
  if (!(this.g1p_1 === other.g1p_1))
    return false;
  return true;
};
function ExerciseTargets(sets, oneRepMaxKg, issue, warning, alternatives, progressed) {
  this.h1p_1 = sets;
  this.i1p_1 = oneRepMaxKg;
  this.j1p_1 = issue;
  this.k1p_1 = warning;
  this.l1p_1 = alternatives;
  this.m1p_1 = progressed;
}
protoOf(ExerciseTargets).n1p = function (sets, oneRepMaxKg, issue, warning, alternatives, progressed) {
  return new ExerciseTargets(sets, oneRepMaxKg, issue, warning, alternatives, progressed);
};
protoOf(ExerciseTargets).o1p = function (sets, oneRepMaxKg, issue, warning, alternatives, progressed, $super) {
  sets = sets === VOID ? this.h1p_1 : sets;
  oneRepMaxKg = oneRepMaxKg === VOID ? this.i1p_1 : oneRepMaxKg;
  issue = issue === VOID ? this.j1p_1 : issue;
  warning = warning === VOID ? this.k1p_1 : warning;
  alternatives = alternatives === VOID ? this.l1p_1 : alternatives;
  progressed = progressed === VOID ? this.m1p_1 : progressed;
  return $super === VOID ? this.n1p(sets, oneRepMaxKg, issue, warning, alternatives, progressed) : $super.n1p.call(this, sets, oneRepMaxKg, issue, warning, alternatives, progressed);
};
protoOf(ExerciseTargets).toString = function () {
  return 'ExerciseTargets(sets=' + toString(this.h1p_1) + ', oneRepMaxKg=' + this.i1p_1 + ', issue=' + this.j1p_1.toString() + ', warning=' + this.k1p_1 + ', alternatives=' + toString(this.l1p_1) + ', progressed=' + this.m1p_1 + ')';
};
protoOf(ExerciseTargets).hashCode = function () {
  var result = hashCode(this.h1p_1);
  result = imul(result, 31) + (this.i1p_1 == null ? 0 : getNumberHashCode(this.i1p_1)) | 0;
  result = imul(result, 31) + this.j1p_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.k1p_1) | 0;
  result = imul(result, 31) + hashCode(this.l1p_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.m1p_1) | 0;
  return result;
};
protoOf(ExerciseTargets).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExerciseTargets))
    return false;
  if (!equals(this.h1p_1, other.h1p_1))
    return false;
  if (!equals(this.i1p_1, other.i1p_1))
    return false;
  if (!this.j1p_1.equals(other.j1p_1))
    return false;
  if (!(this.k1p_1 === other.k1p_1))
    return false;
  if (!equals(this.l1p_1, other.l1p_1))
    return false;
  if (!(this.m1p_1 === other.m1p_1))
    return false;
  return true;
};
function Context(prescription, scheme, options) {
  this.p1p_1 = prescription;
  this.q1p_1 = scheme;
  this.r1p_1 = options;
  var tmp = this;
  // Inline function 'kotlin.math.max' call
  var b = this.r1p_1.l1o_1 * this.r1p_1.m1o_1;
  tmp.s1p_1 = Math.max(0.0, b);
  var tmp_0 = this;
  var tmp_1;
  if (this.p1p_1.u1a_1.equals(SetType_FAILURE_getInstance())) {
    tmp_1 = 0;
  } else {
    // Inline function 'kotlin.math.max' call
    var b_0 = this.p1p_1.t1a_1 + this.r1p_1.q1o_1 | 0;
    // Inline function 'kotlin.math.min' call
    var b_1 = Math.max(0, b_0);
    tmp_1 = Math.min(10, b_1);
  }
  tmp_0.t1p_1 = tmp_1;
  this.u1p_1 = this.p1p_1.r1a_1;
  this.v1p_1 = this.p1p_1.s1a_1;
  this.w1p_1 = (this.u1p_1 + this.v1p_1 | 0) / 2.0;
  this.x1p_1 = this.r1p_1.i1o_1;
  var tmp_2 = this;
  var tmp_3 = this.r1p_1.h1o_1;
  var tmp0_safe_receiver = tmp_3 instanceof FixedReps ? tmp_3 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s1e_1;
  tmp_2.y1p_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp_4 = this;
  var tmp_5 = this.r1p_1.h1o_1;
  var tmp0_safe_receiver_0 = tmp_5 instanceof FixedReps ? tmp_5 : null;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.s1e_1;
  tmp_4.z1p_1 = tmp1_elvis_lhs_0 == null ? (new FixedReps()).s1e_1 : tmp1_elvis_lhs_0;
  var tmp_6 = this;
  var tmp_7 = this.r1p_1.h1o_1;
  tmp_6.a1q_1 = tmp_7 instanceof PowerLaw ? tmp_7 : null;
  this.b1q_1 = arrayListOf([0.0]);
}
protoOf(Context).c1q = function (index) {
  return this.p1p_1.u1a_1.y1_1 === 2 ? index === 0 ? SetType_STANDARD_getInstance() : SetType_DROP_getInstance() : this.p1p_1.u1a_1;
};
protoOf(Context).d1q = function () {
  this.b1q_1.z3();
  this.b1q_1.f(0.0);
};
protoOf(Context).e1q = function (index, reps, rir) {
  var tmp0_elvis_lhs = this.a1q_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var model = tmp;
  while (this.b1q_1.o() <= index) {
    this.b1q_1.f(last(this.b1q_1));
  }
  while (this.b1q_1.o() > (index + 1 | 0)) {
    this.b1q_1.w2(this.b1q_1.o() - 1 | 0);
  }
  var tmp_0 = this.b1q_1.n(index);
  // Inline function 'kotlin.math.max' call
  var tmp_1 = Math.max(0, reps);
  // Inline function 'kotlin.math.max' call
  var tmp$ret$1 = Math.max(0, rir);
  this.b1q_1.f(tmp_0 + model.w1e(tmp_1, tmp$ret$1));
};
protoOf(Context).f1q = function (index) {
  var tmp0_safe_receiver = this.a1q_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.b1q_1;
    var tmp_0;
    if (0 <= index ? index < this_0.o() : false) {
      tmp_0 = this_0.n(index);
    } else {
      tmp_0 = last(this.b1q_1);
    }
    var tmp$ret$0 = tmp_0;
    tmp = tmp0_safe_receiver.x1e(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
};
protoOf(Context).g1q = function (effectiveLoad, oneRepMax, setIndex) {
  return this.x1p_1.h1q(effectiveLoad, oneRepMax * this.f1q(setIndex)) - this.y1p_1 * setIndex - this.t1p_1;
};
protoOf(Context).i1q = function (load, reps, rir, position, fatiguingBefore) {
  var rtf = (reps + rir | 0) + this.y1p_1 * position;
  var estimate = this.x1p_1.j1q(load, rtf);
  if (this.r1p_1.s1o_1)
    estimate = OneRepMaxClamp_instance.m1q(estimate, load, reps + rir | 0);
  var tmp0_safe_receiver = this.a1q_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = estimate / tmp0_safe_receiver.x1e(fatiguingBefore);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? estimate : tmp1_elvis_lhs;
};
protoOf(Context).n1q = function (effectiveLoad) {
  // Inline function 'kotlin.math.max' call
  var b = gram(Progression_instance, effectiveLoad - this.s1p_1);
  return Math.max(0.0, b);
};
function prior($this, sessions, ctx) {
  var tmp0_elvis_lhs = oneRepMax_0($this, sessions, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return ctx.r1p_1.n1o_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var prior = tmp;
  var options = ctx.r1p_1;
  var stepped = ctx.q1p_1.equals(ProgressionScheme_STATIC_getInstance()) || ctx.q1p_1.equals(ProgressionScheme_UNDULATING_getInstance()) || ctx.q1p_1.equals(ProgressionScheme_REVERSE_LINEAR_getInstance());
  if (options.u1o_1 <= 0.0 || !stepped || options.q1o_1 > 0 || missedLast($this, sessions, ctx))
    return prior;
  return prior * (1.0 + options.u1o_1 / 100.0);
}
function missedLast($this, sessions, ctx) {
  var tmp0_safe_receiver = lastOrNull(sessions);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = sessionOneRepMax(Progression_instance, tmp0_safe_receiver, ctx);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var last = tmp_0;
  var tmp2_elvis_lhs = oneRepMax_0($this, dropLast_0(sessions, 1), ctx);
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return false;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var before = tmp_1;
  return last < before;
}
function current($this, prior, today, ctx) {
  var options = ctx.r1p_1;
  if (options.t1o_1.equals(SurpriseCarry_NONE_getInstance())) {
    var todayEstimate = sessionOneRepMax($this, today, ctx);
    return prior == null ? todayEstimate : todayEstimate == null ? prior : options.p1o_1 * todayEstimate + (1.0 - options.p1o_1) * prior;
  }
  var estimate = prior;
  var fatigue = 0.0;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = strengthSets($this, today).j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var position = checkIndexOverflow(_unary__edvuaz);
    var load = item.m1e_1 + ctx.s1p_1;
    var tmp0_elvis_lhs = item.o1e_1;
    var rir = tmp0_elvis_lhs == null ? ctx.t1p_1 : tmp0_elvis_lhs;
    if (load > 0.0 && item.n1e_1 > 0) {
      var fresh = ctx.i1q(load, item.n1e_1, rir, position, fatigue);
      var tmp1_safe_receiver = estimate;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var surprise = coerceIn(fresh / tmp1_safe_receiver - 1.0, -0.25, 0.25);
        tmp = tmp1_safe_receiver * (1.0 + options.t1o_1.g1f(surprise) * surprise);
      }
      var tmp2_elvis_lhs = tmp;
      estimate = tmp2_elvis_lhs == null ? fresh : tmp2_elvis_lhs;
    }
    var tmp3_safe_receiver = ctx.a1q_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = fatigue;
      // Inline function 'kotlin.math.max' call
      var b = item.n1e_1;
      var tmp_1 = Math.max(0, b);
      // Inline function 'kotlin.math.max' call
      var tmp$ret$7 = Math.max(0, rir);
      fatigue = tmp_0 + tmp3_safe_receiver.w1e(tmp_1, tmp$ret$7);
    }
  }
  return estimate;
}
function Choice(load, reps, outside, issue) {
  this.o1q_1 = load;
  this.p1q_1 = reps;
  this.q1q_1 = outside;
  this.r1q_1 = issue;
}
protoOf(Choice).s1q = function (index, ctx) {
  return new PlannedSet(index, ctx.n1q(this.o1q_1), this.p1q_1, ctx.t1p_1, ctx.c1q(index), false, this.q1q_1);
};
function freshPlan($this, ctx, loads, oneRepMax, sessions) {
  var last = lastOrNull(sessions);
  var tmp;
  if (last == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = topLoad(Progression_instance, last, ctx);
  }
  var lastLoad = tmp;
  ctx.d1q();
  var first = nudge($this, capReps($this, firstSet($this, ctx, loads, oneRepMax, sessions), 0, last, ctx), 0, last, ctx);
  var plan = ArrayList_init_$Create$_0();
  plan.f(first.s1q(0, ctx));
  ctx.e1q(0, first.p1q_1, ctx.t1p_1);
  var previous = first.o1q_1;
  var inductionVariable = 1;
  var last_0 = ctx.p1p_1.q1a_1;
  if (inductionVariable < last_0)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var choice = nudge($this, capReps($this, laterSet($this, ctx, loads, oneRepMax, i, previous, first.p1q_1), i, last, ctx), i, last, ctx);
      plan.f(choice.s1q(i, ctx));
      ctx.e1q(i, choice.p1q_1, ctx.t1p_1);
      previous = choice.o1q_1;
    }
     while (inductionVariable < last_0);
  var warning = !first.r1q_1.equals(TargetIssue_NONE_getInstance());
  return new ExerciseTargets(plan, oneRepMax, first.r1q_1, warning, warning ? alternatives($this, ctx, loads, oneRepMax, 0, lastLoad) : emptyList(), false);
}
function firstSet($this, ctx, loads, oneRepMax, sessions) {
  var tmp0_elvis_lhs = lastOrNull(sessions);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return smart($this, ctx, loads, oneRepMax, 0, null);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var lastLoad = topLoad($this, last, ctx);
  var tmp1_elvis_lhs = Loads_instance.i1i(loads, lastLoad);
  var anchor = tmp1_elvis_lhs == null ? lastLoad : tmp1_elvis_lhs;
  var tmp_0;
  switch (ctx.q1p_1.y1_1) {
    case 0:
      var reps = round_0($this, ctx.g1q(anchor, oneRepMax, 0));
      // Inline function 'kotlin.collections.filter' call

      var tmp0 = strengthSets($this, last);
      // Inline function 'kotlin.collections.filterTo' call

      var destination = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.math.abs' call
        var x = element.m1e_1 + ctx.s1p_1 - anchor;
        if (Math.abs(x) < 1.0E-9) {
          destination.f(element);
        }
      }

      var atAnchor = destination;
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call

      if (!atAnchor.m()) {
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp_2;
          if (isInterface(atAnchor, Collection)) {
            tmp_2 = atAnchor.m();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$5 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = atAnchor.j();
          while (_iterator__ex2g4s_0.k()) {
            var element_0 = _iterator__ex2g4s_0.l();
            if (!(element_0.n1e_1 >= ctx.v1p_1)) {
              tmp$ret$5 = false;
              break $l$block_0;
            }
          }
          tmp$ret$5 = true;
        }
        tmp_1 = tmp$ret$5;
      } else {
        tmp_1 = false;
      }

      var hitTop = tmp_1;
      var tmp_3;
      if (reps > ctx.v1p_1 || hitTop) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_1 = loads.j();
        while (_iterator__ex2g4s_1.k()) {
          var element_1 = _iterator__ex2g4s_1.l();
          if (element_1 > anchor + 1.0E-9) {
            destination_0.f(element_1);
          }
        }
        var tmp$ret$10;
        $l$block_1: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_2 = destination_0.j();
          while (_iterator__ex2g4s_2.k()) {
            var element_2 = _iterator__ex2g4s_2.l();
            if (round_0(Progression_instance, ctx.g1q(element_2, oneRepMax, 0)) >= ctx.u1p_1) {
              tmp$ret$10 = element_2;
              break $l$block_1;
            }
          }
          tmp$ret$10 = null;
        }
        var up = tmp$ret$10;
        var tmp_4;
        if (!(up == null)) {
          tmp_4 = new Choice(up, coerceIn_0(round_0($this, ctx.g1q(up, oneRepMax, 0)), ctx.u1p_1, ctx.v1p_1), false, TargetIssue_NONE_getInstance());
        } else if (ctx.r1p_1.e1o_1) {
          var tmp3_safe_receiver = firstOrNull(atAnchor);
          var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.n1e_1;
          // Inline function 'kotlin.math.max' call
          var b = (tmp4_elvis_lhs == null ? reps : tmp4_elvis_lhs) + 1 | 0;
          var tmp0_0 = Math.max(reps, b);
          // Inline function 'kotlin.math.min' call
          var b_0 = ctx.v1p_1 + ctx.r1p_1.f1o_1 | 0;
          var expanded = Math.min(tmp0_0, b_0);
          tmp_4 = new Choice(anchor, expanded, expanded > ctx.v1p_1, expanded > ctx.v1p_1 ? TargetIssue_OUTSIDE_REP_RANGE_getInstance() : TargetIssue_NONE_getInstance());
        } else {
          tmp_4 = new Choice(anchor, ctx.v1p_1, false, TargetIssue_NO_FEASIBLE_TARGET_getInstance());
        }
        tmp_3 = tmp_4;
      } else if (reps >= ctx.u1p_1) {
        tmp_3 = new Choice(anchor, reps, false, TargetIssue_NONE_getInstance());
      } else {
        tmp_3 = smart($this, ctx, loads, oneRepMax, 0, anchor);
      }

      tmp_0 = tmp_3;
      break;
    case 1:
      var success = linearSuccess($this, last, lastLoad, ctx);
      var previous = getOrNull_0(sessions, sessions.o() - 2 | 0);
      var tmp_5;
      var tmp_6;
      if (!success && !(previous == null)) {
        // Inline function 'kotlin.math.abs' call
        var x_0 = topLoad($this, previous, ctx) - lastLoad;
        tmp_6 = Math.abs(x_0) < 1.0E-9;
      } else {
        tmp_6 = false;
      }

      if (tmp_6) {
        tmp_5 = !linearSuccess($this, previous, lastLoad, ctx);
      } else {
        tmp_5 = false;
      }

      var missedTwice = tmp_5;
      var tmp_7;
      if (success) {
        var tmp5_elvis_lhs = Loads_instance.k1i(loads, lastLoad);
        tmp_7 = tmp5_elvis_lhs == null ? lastLoad : tmp5_elvis_lhs;
      } else if (missedTwice) {
        var tmp6_elvis_lhs = Loads_instance.i1i(loads, lastLoad * (1.0 - ctx.r1p_1.r1o_1 / 100.0));
        tmp_7 = tmp6_elvis_lhs == null ? lastLoad : tmp6_elvis_lhs;
      } else {
        tmp_7 = anchor;
      }

      var load = tmp_7;
      var reps_0 = round_0($this, ctx.g1q(load, oneRepMax, 0));
      var tmp_8;
      if (reps_0 < ctx.u1p_1) {
        // Inline function 'kotlin.math.max' call
        var tmp$ret$15 = Math.max(1, reps_0);
        tmp_8 = new Choice(load, tmp$ret$15, true, TargetIssue_OUTSIDE_REP_RANGE_getInstance());
      } else {
        // Inline function 'kotlin.math.min' call
        var b_1 = ctx.v1p_1;
        var tmp$ret$16 = Math.min(reps_0, b_1);
        tmp_8 = new Choice(load, tmp$ret$16, false, TargetIssue_NONE_getInstance());
      }

      tmp_0 = tmp_8;
      break;
    case 4:
    case 2:
    case 3:
      var reps_1 = round_0($this, ctx.g1q(anchor, oneRepMax, 0));
      var tmp_9;
      var tmp_10;
      if (ctx.r1p_1.g1o_1) {
        var containsLower = ctx.u1p_1;
        tmp_10 = reps_1 <= ctx.v1p_1 ? containsLower <= reps_1 : false;
      } else {
        tmp_10 = false;
      }

      if (tmp_10) {
        tmp_9 = new Choice(anchor, reps_1, false, TargetIssue_NONE_getInstance());
      } else {
        tmp_9 = smart($this, ctx, loads, oneRepMax, 0, anchor);
      }

      tmp_0 = tmp_9;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
}
function laterSet($this, ctx, loads, oneRepMax, index, previousLoad, plannedReps) {
  switch (ctx.p1p_1.u1a_1.y1_1) {
    case 2:
      var tmp1_elvis_lhs = Loads_instance.h1i(loads, previousLoad * 0.8, LoadRounding_DOWN_getInstance());
      var load = tmp1_elvis_lhs == null ? previousLoad : tmp1_elvis_lhs;
      // Inline function 'kotlin.math.max' call

      var b = round_0($this, ctx.g1q(load, oneRepMax, index));
      var tmp$ret$0 = Math.max(1, b);
      return new Choice(load, tmp$ret$0, false, TargetIssue_NONE_getInstance());
    case 3:
      // Inline function 'kotlin.math.max' call

      var b_0 = round_0($this, plannedReps * 0.3);
      var tmp$ret$1 = Math.max(3, b_0);
      return new Choice(previousLoad, tmp$ret$1, false, TargetIssue_NONE_getInstance());
    default:
      break;
  }
  var tmp;
  if (ctx.q1p_1.equals(ProgressionScheme_LINEAR_getInstance())) {
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(loads, Collection)) {
        tmp_0 = loads.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = loads.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.math.abs' call
        var x = element - previousLoad;
        if (Math.abs(x) < 1.0E-9) {
          tmp$ret$2 = true;
          break $l$block_0;
        }
      }
      tmp$ret$2 = false;
    }
    tmp = tmp$ret$2;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'kotlin.math.max' call
    var b_1 = round_0($this, ctx.g1q(previousLoad, oneRepMax, index) + ctx.t1p_1);
    // Inline function 'kotlin.math.min' call
    var b_2 = Math.max(1, b_1);
    var reps = Math.min(plannedReps, b_2);
    var containsLower = ctx.u1p_1;
    return new Choice(previousLoad, reps, !(reps <= ctx.v1p_1 ? containsLower <= reps : false), TargetIssue_NONE_getInstance());
  }
  var range = numberRangeToNumber(ctx.u1p_1, ctx.v1p_1);
  if (ctx.r1p_1.d1o_1.equals(AdjustmentPriority_WEIGHT_FIRST_getInstance())) {
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Progression$laterSet$lambda(ctx, oneRepMax, index, plannedReps);
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_0 = new sam$kotlin_Comparator$0_11(tmp_1);
    var tmp_2 = Progression$laterSet$lambda_0(this_0, previousLoad);
    // Inline function 'kotlin.comparisons.thenByDescending' call
    var this_1 = new sam$kotlin_Comparator$0_11(tmp_2);
    var tmp_3 = Progression$laterSet$lambda_1(this_1);
    var tmp$ret$9 = new sam$kotlin_Comparator$0_11(tmp_3);
    var best = minWithOrNull(loads, tmp$ret$9);
    if (!(best == null)) {
      var reps_0 = round_0($this, ctx.g1q(best, oneRepMax, index));
      var containsLower_0 = range.xc_1;
      if (reps_0 <= range.yc_1 ? containsLower_0 <= reps_0 : false)
        return new Choice(best, reps_0, false, TargetIssue_NONE_getInstance());
    }
  } else {
    var reps_1 = round_0($this, ctx.g1q(previousLoad, oneRepMax, index));
    var tmp_4;
    var containsLower_1 = range.xc_1;
    if (reps_1 <= range.yc_1 ? containsLower_1 <= reps_1 : false) {
      var tmp$ret$10;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_5;
        if (isInterface(loads, Collection)) {
          tmp_5 = loads.m();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp$ret$10 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = loads.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          // Inline function 'kotlin.math.abs' call
          var x_0 = element_0 - previousLoad;
          if (Math.abs(x_0) < 1.0E-9) {
            tmp$ret$10 = true;
            break $l$block_2;
          }
        }
        tmp$ret$10 = false;
      }
      tmp_4 = tmp$ret$10;
    } else {
      tmp_4 = false;
    }
    if (tmp_4)
      return new Choice(previousLoad, reps_1, false, TargetIssue_NONE_getInstance());
  }
  return smart($this, ctx, loads, oneRepMax, index, previousLoad);
}
function smart($this, ctx, loads, oneRepMax, index, previousLoad) {
  var options = ctx.r1p_1;
  var target = Strength_instance.t1q(oneRepMax, loads, ctx.u1p_1, ctx.v1p_1, ctx.t1p_1, index, ctx.y1p_1, options.g1o_1 ? previousLoad : null, VOID, options.e1o_1, options.f1o_1, ctx.x1p_1, ctx.f1q(index));
  if (!(target == null)) {
    return new Choice(target.u1q_1, target.v1q_1, target.w1q_1, target.w1q_1 ? TargetIssue_OUTSIDE_REP_RANGE_getInstance() : TargetIssue_NONE_getInstance());
  }
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.minBy' call
    var iterator = loads.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$_0();
    var minElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$0 = minElem;
      break $l$block;
    }
    var it = minElem;
    // Inline function 'kotlin.math.abs' call
    var x = ctx.g1q(it, oneRepMax, index) - ctx.w1p_1;
    var minValue = Math.abs(x);
    do {
      var e = iterator.l();
      // Inline function 'kotlin.math.abs' call
      var x_0 = ctx.g1q(e, oneRepMax, index) - ctx.w1p_1;
      var v = Math.abs(x_0);
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$0 = minElem;
  }
  var closest = tmp$ret$0;
  // Inline function 'kotlin.math.max' call
  var b = round_0($this, ctx.g1q(closest, oneRepMax, index));
  var tmp$ret$5 = Math.max(1, b);
  return new Choice(closest, tmp$ret$5, true, TargetIssue_NO_FEASIBLE_TARGET_getInstance());
}
function alternatives($this, ctx, loads, oneRepMax, index, previousLoad) {
  var options = ctx.r1p_1;
  var ideal = ctx.x1p_1.x1q(oneRepMax * ctx.f1q(index), ctx.w1p_1 + ctx.t1p_1 + ctx.y1p_1 * index);
  var result = ArrayList_init_$Create$_0();
  var tmp = AlternativeKind_NEXT_LOAD_UP_getInstance();
  var tmp0_safe_receiver = Loads_instance.h1i(loads, ideal, LoadRounding_UP_getInstance());
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (tmp0_safe_receiver >= ideal - 1.0E-9) {
      tmp_1 = tmp0_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  alternatives$add(ctx, oneRepMax, index, result, tmp, tmp_0);
  var tmp_2 = AlternativeKind_NEXT_LOAD_DOWN_getInstance();
  var tmp1_safe_receiver = Loads_instance.h1i(loads, ideal, LoadRounding_DOWN_getInstance());
  var tmp_3;
  if (tmp1_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_4;
    if (tmp1_safe_receiver <= ideal + 1.0E-9) {
      tmp_4 = tmp1_safe_receiver;
    } else {
      tmp_4 = null;
    }
    tmp_3 = tmp_4;
  }
  alternatives$add(ctx, oneRepMax, index, result, tmp_2, tmp_3);
  var tmp2_safe_receiver = Strength_instance.t1q(oneRepMax, loads, ctx.u1p_1, ctx.v1p_1, ctx.t1p_1, index, ctx.y1p_1, previousLoad, VOID, true, options.f1o_1, ctx.x1p_1, ctx.f1q(index));
  var tmp_5;
  if (tmp2_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_6;
    if (tmp2_safe_receiver.w1q_1) {
      tmp_6 = tmp2_safe_receiver;
    } else {
      tmp_6 = null;
    }
    tmp_5 = tmp_6;
  }
  var tmp3_safe_receiver = tmp_5;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    alternatives$add(ctx, oneRepMax, index, result, AlternativeKind_EXPAND_REP_RANGE_getInstance(), tmp3_safe_receiver.u1q_1);
  }
  var tmp_7;
  if (!(previousLoad == null)) {
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_8;
      if (isInterface(loads, Collection)) {
        tmp_8 = loads.m();
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$8 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = loads.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.math.abs' call
        var x = element - previousLoad;
        if (Math.abs(x) < 1.0E-9) {
          tmp$ret$8 = true;
          break $l$block_0;
        }
      }
      tmp$ret$8 = false;
    }
    tmp_7 = tmp$ret$8;
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    alternatives$add(ctx, oneRepMax, index, result, AlternativeKind_WEIGHT_MATCH_getInstance(), previousLoad);
  }
  return result;
}
function capReps($this, choice, index, last, ctx) {
  var tmp1_elvis_lhs = last == null ? null : getOrNull_0(last, index);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return choice;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var lastSet = tmp;
  // Inline function 'kotlin.math.abs' call
  var x = lastSet.m1e_1 + ctx.s1p_1 - choice.o1q_1;
  if (Math.abs(x) > 1.0E-9)
    return choice;
  var tmp0 = choice.p1q_1;
  // Inline function 'kotlin.math.min' call
  var b = lastSet.n1e_1 + ctx.r1p_1.k1o_1 | 0;
  var reps = Math.min(tmp0, b);
  if (reps === choice.p1q_1)
    return choice;
  var containsLower = ctx.u1p_1;
  return new Choice(choice.o1q_1, reps, !(reps <= ctx.v1p_1 ? containsLower <= reps : false), choice.r1q_1);
}
function nudge($this, choice, index, last, ctx) {
  if (!ctx.q1p_1.equals(ProgressionScheme_DOUBLE_getInstance()) || choice.q1q_1)
    return choice;
  var tmp1_elvis_lhs = last == null ? null : getOrNull_0(last, index);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return choice;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var lastSet = tmp;
  // Inline function 'kotlin.math.abs' call
  var x = lastSet.m1e_1 + ctx.s1p_1 - choice.o1q_1;
  if (Math.abs(x) > 1.0E-9)
    return choice;
  var tmp2_elvis_lhs = lastSet.o1e_1;
  if ((tmp2_elvis_lhs == null ? ctx.t1p_1 : tmp2_elvis_lhs) < ctx.t1p_1)
    return choice;
  var tmp0 = ctx.v1p_1;
  var tmp0_0 = choice.p1q_1;
  var tmp0_1 = lastSet.n1e_1 + 1 | 0;
  // Inline function 'kotlin.math.min' call
  var b = choice.p1q_1 + 1 | 0;
  // Inline function 'kotlin.math.max' call
  var b_0 = Math.min(tmp0_1, b);
  // Inline function 'kotlin.math.min' call
  var b_1 = Math.max(tmp0_0, b_0);
  var reps = Math.min(tmp0, b_1);
  return reps === choice.p1q_1 ? choice : new Choice(choice.o1q_1, reps, false, choice.r1q_1);
}
function capLoads($this, loads, lastLoad, maxIncreasePct) {
  var tmp0 = lastLoad * (1.0 + maxIncreasePct / 100.0);
  var tmp0_elvis_lhs = Loads_instance.k1i(loads, lastLoad);
  // Inline function 'kotlin.math.max' call
  var b = tmp0_elvis_lhs == null ? lastLoad : tmp0_elvis_lhs;
  var limit = Math.max(tmp0, b);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = loads.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element <= limit + 1.0E-9) {
      destination.f(element);
    }
  }
  return destination;
}
function linearSuccess($this, session, load, ctx) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = session.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.math.abs' call
    var x = element.m1e_1 + ctx.s1p_1 - load;
    if (Math.abs(x) < 1.0E-9) {
      destination.f(element);
    }
  }
  var atLoad = destination;
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!atLoad.m()) {
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(atLoad, Collection)) {
        tmp_0 = atLoad.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = atLoad.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (!(element_0.n1e_1 >= ctx.u1p_1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    tmp = tmp$ret$5;
  } else {
    tmp = false;
  }
  return tmp;
}
function repsOnly($this, ctx, sessions, today) {
  var options = ctx.r1p_1;
  var prior = null;
  var _iterator__ex2g4s = sessions.j();
  $l$loop: while (_iterator__ex2g4s.k()) {
    var session = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = repsOnly$sessionRtf(ctx, session);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rtf = tmp;
    var tmp1_safe_receiver = prior;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = options.o1o_1 * rtf + (1.0 - options.o1o_1) * tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp_0;
    prior = tmp2_elvis_lhs == null ? rtf : tmp2_elvis_lhs;
  }
  var todayRtf = repsOnly$sessionRtf(ctx, today);
  var current = prior == null ? todayRtf : todayRtf == null ? prior : options.p1o_1 * todayRtf + (1.0 - options.p1o_1) * prior;
  var tmp3_elvis_lhs = lastOrNull(today);
  var tmp_1;
  if (tmp3_elvis_lhs == null) {
    var tmp4_safe_receiver = lastOrNull(sessions);
    tmp_1 = tmp4_safe_receiver == null ? null : lastOrNull(tmp4_safe_receiver);
  } else {
    tmp_1 = tmp3_elvis_lhs;
  }
  var tmp5_safe_receiver = tmp_1;
  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.m1e_1;
  var load = tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs;
  var last = lastOrNull(sessions);
  var planned = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s_0 = today.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var i = checkIndexOverflow(_unary__edvuaz);
    planned.f(doneSet(Progression_instance, i, item, ctx));
  }
  var ceiling = ctx.v1p_1 + (options.e1o_1 ? options.f1o_1 : 0) | 0;
  var inductionVariable = today.o();
  var last_0 = ctx.p1p_1.q1a_1;
  if (inductionVariable < last_0)
    do {
      var i_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_2;
      if (current == null) {
        // Inline function 'kotlin.math.floor' call
        var x = ctx.w1p_1;
        var tmp$ret$4 = Math.floor(x);
        tmp_2 = numberToInt(tmp$ret$4);
      } else {
        tmp_2 = round_0($this, current - ctx.z1p_1 * i_0 - ctx.t1p_1);
      }
      var reps = tmp_2;
      if (today.m()) {
        var tmp8_safe_receiver = last == null ? null : getOrNull_0(last, i_0);
        if (tmp8_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0 = reps;
          // Inline function 'kotlin.math.min' call
          var b = tmp8_safe_receiver.n1e_1 + options.k1o_1 | 0;
          reps = Math.min(tmp0, b);
        }
      }
      reps = coerceIn_0(reps, 1, ceiling);
      planned.f(new PlannedSet(i_0, load, reps, ctx.t1p_1, ctx.c1q(i_0), false, reps > ctx.v1p_1 || reps < ctx.u1p_1));
    }
     while (inductionVariable < last_0);
  return new ExerciseTargets(planned, null, current == null ? TargetIssue_NO_HISTORY_getInstance() : TargetIssue_NO_LOADS_getInstance(), false, emptyList(), progressed($this, sessions, ctx));
}
function doneSet($this, index, set, ctx) {
  var tmp0_elvis_lhs = set.o1e_1;
  var tmp = tmp0_elvis_lhs == null ? ctx.t1p_1 : tmp0_elvis_lhs;
  var containsLower = ctx.u1p_1;
  var containsUpper = ctx.v1p_1;
  var containsArg = set.n1e_1;
  return new PlannedSet(index, set.m1e_1, set.n1e_1, tmp, set.p1e_1, true, !(containsLower <= containsArg ? containsArg <= containsUpper : false));
}
function sessions($this, sets) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = element.q1e_1;
    var key = tmp0_elvis_lhs == null ? 'day:' + element.l1e_1 : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  var tmp_0 = destination.v1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = Progression$sessions$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_12(tmp_1);
  var tmp_2 = Progression$sessions$lambda_0(this_0);
  var tmp$ret$6 = new sam$kotlin_Comparator$0_12(tmp_2);
  return sortedWith(tmp_0, tmp$ret$6);
}
function strengthSets($this, session) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = session.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.p1e_1.equals(SetType_STANDARD_getInstance()) || element.p1e_1.equals(SetType_FAILURE_getInstance())) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp;
  if (destination.m()) {
    tmp = session;
  } else {
    tmp = destination;
  }
  return tmp;
}
function sessionOneRepMax($this, session, ctx) {
  var weighted = 0.0;
  var total = 0.0;
  var fatigue = 0.0;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = strengthSets($this, session).j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp0 = checkIndexOverflow(_unary__edvuaz);
    $l$block: {
      var load = item.m1e_1 + ctx.s1p_1;
      var tmp0_elvis_lhs = item.o1e_1;
      var rir = tmp0_elvis_lhs == null ? ctx.t1p_1 : tmp0_elvis_lhs;
      var before = fatigue;
      var tmp1_safe_receiver = ctx.a1q_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp = fatigue;
        // Inline function 'kotlin.math.max' call
        var b = item.n1e_1;
        var tmp_0 = Math.max(0, b);
        // Inline function 'kotlin.math.max' call
        var tmp$ret$5 = Math.max(0, rir);
        fatigue = tmp + tmp1_safe_receiver.w1e(tmp_0, tmp$ret$5);
      }
      if (load <= 0.0 || item.n1e_1 <= 0) {
        break $l$block;
      }
      var estimate = ctx.i1q(load, item.n1e_1, rir, tmp0, before);
      var weight = rir <= 3 ? 1.0 : rir <= 5 ? 0.5 : 0.25;
      weighted = weighted + estimate * weight;
      total = total + weight;
    }
  }
  return total > 0.0 ? weighted / total : null;
}
function oneRepMax_0($this, sessions, ctx) {
  var estimate = null;
  var _iterator__ex2g4s = sessions.j();
  $l$loop: while (_iterator__ex2g4s.k()) {
    var session = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = sessionOneRepMax($this, session, ctx);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_safe_receiver = estimate;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = ctx.r1p_1.o1o_1 * value + (1.0 - ctx.r1p_1.o1o_1) * tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp_0;
    estimate = tmp2_elvis_lhs == null ? value : tmp2_elvis_lhs;
  }
  return estimate;
}
function topLoad($this, session, ctx) {
  // Inline function 'kotlin.collections.maxOf' call
  var iterator = strengthSets($this, session).j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var maxValue = iterator.l().m1e_1;
  while (iterator.k()) {
    var v = iterator.l().m1e_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = maxValue;
    maxValue = Math.max(a, v);
  }
  var tmp$ret$0 = maxValue;
  return gram($this, tmp$ret$0 + ctx.s1p_1);
}
function progressed($this, sessions, ctx) {
  var tmp0_safe_receiver = lastOrNull(sessions);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = firstOrNull(strengthSets(Progression_instance, tmp0_safe_receiver));
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var last = tmp_0;
  var tmp0 = asReversed(dropLast_0(sessions, 1));
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_0 = element.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          // Inline function 'kotlin.math.abs' call
          var x = element_0.m1e_1 - last.m1e_1;
          if (Math.abs(x) < 1.0E-9) {
            tmp$ret$4 = element_0;
            break $l$block;
          }
        }
        tmp$ret$4 = null;
      }
      var result = tmp$ret$4;
      if (!(result == null)) {
        tmp$ret$2 = result;
        break $l$block_0;
      }
    }
    tmp$ret$2 = null;
  }
  var previousAtLoad = tmp$ret$2;
  var tmp_1 = Strength_instance;
  // Inline function 'kotlin.math.max' call
  var b = last.m1e_1;
  var tmp_2 = Math.max(0.0, b);
  // Inline function 'kotlin.math.max' call
  var b_0 = last.n1e_1;
  var tmp_3 = Math.max(1, b_0);
  var tmp2_elvis_lhs = last.o1e_1;
  var tmp_4 = new LoggedSet(tmp_2, tmp_3, tmp2_elvis_lhs == null ? ctx.t1p_1 : tmp2_elvis_lhs);
  return tmp_1.y1q(tmp_4, ctx.u1p_1, ctx.v1p_1, ctx.t1p_1, previousAtLoad == null ? null : previousAtLoad.n1e_1);
}
function round_0($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function round1000($this, value) {
  return numberToLong(round(value * 1000.0));
}
function gram($this, value) {
  return Loads_instance.v1h(value);
}
function sam$kotlin_Comparator$0_11(function_0) {
  this.z1q_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_11).ea = function (a, b) {
  return this.z1q_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_11).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_11).h2 = function () {
  return this.z1q_1;
};
protoOf(sam$kotlin_Comparator$0_11).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_11).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_12(function_0) {
  this.a1r_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_12).ea = function (a, b) {
  return this.a1r_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_12).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_12).h2 = function () {
  return this.a1r_1;
};
protoOf(sam$kotlin_Comparator$0_12).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_12).hashCode = function () {
  return hashCode(this.h2());
};
function Progression$laterSet$lambda($ctx, $oneRepMax, $index, $plannedReps) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = Progression_instance;
    // Inline function 'kotlin.math.abs' call
    var x = $ctx.g1q(a, $oneRepMax, $index) - $plannedReps;
    var tmp$ret$2 = Math.abs(x);
    var tmp_0 = round1000(tmp, tmp$ret$2);
    var tmp_1 = Progression_instance;
    // Inline function 'kotlin.math.abs' call
    var x_0 = $ctx.g1q(b, $oneRepMax, $index) - $plannedReps;
    var tmp$ret$4 = Math.abs(x_0);
    var tmp$ret$3 = round1000(tmp_1, tmp$ret$4);
    return compareValues(tmp_0, tmp$ret$3);
  };
}
function Progression$laterSet$lambda_0($this, $previousLoad) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0;
      // Inline function 'kotlin.math.abs' call
      var x = a - $previousLoad;
      if (Math.abs(x) < 1.0E-9) {
        tmp_0 = 0;
      } else {
        tmp_0 = 1;
      }
      var tmp_1 = tmp_0;
      var tmp_2;
      // Inline function 'kotlin.math.abs' call
      var x_0 = b - $previousLoad;
      if (Math.abs(x_0) < 1.0E-9) {
        tmp_2 = 0;
      } else {
        tmp_2 = 1;
      }
      var tmp$ret$3 = tmp_2;
      tmp = compareValues(tmp_1, tmp$ret$3);
    }
    return tmp;
  };
}
function Progression$laterSet$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b;
      tmp = compareValues(tmp_0, a);
    }
    return tmp;
  };
}
function alternatives$add($ctx, $oneRepMax, $index, result, kind, load) {
  if (load == null)
    return Unit_instance;
  var reps = round_0(Progression_instance, $ctx.g1q(load, $oneRepMax, $index));
  if (reps < 1)
    return Unit_instance;
  var alternative = new TargetAlternative(kind, $ctx.n1q(load), reps);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp;
    if (isInterface(result, Collection)) {
      tmp = result.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = result.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var tmp_0;
      // Inline function 'kotlin.math.abs' call
      var x = element.y1o_1 - alternative.y1o_1;
      if (Math.abs(x) < 1.0E-9) {
        tmp_0 = element.z1o_1 === alternative.z1o_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  if (tmp$ret$0) {
    result.f(alternative);
  }
}
function repsOnly$sessionRtf($ctx, sets) {
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(sets, 10));
  var index = 0;
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var i = checkIndexOverflow(_unary__edvuaz);
    var tmp0_elvis_lhs = item.o1e_1;
    var tmp$ret$2 = (item.n1e_1 + (tmp0_elvis_lhs == null ? $ctx.t1p_1 : tmp0_elvis_lhs) | 0) + $ctx.z1p_1 * i;
    destination.f(tmp$ret$2);
  }
  return maxOrNull(destination);
}
function Progression$sessions$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'kotlin.collections.minOf' call
  var iterator = a.j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var minValue = iterator.l().l1e_1;
  while (iterator.k()) {
    var v = iterator.l().l1e_1;
    if (compareTo(minValue, v) > 0) {
      minValue = v;
    }
  }
  var tmp = minValue;
  // Inline function 'kotlin.collections.minOf' call
  var iterator_0 = b.j();
  if (!iterator_0.k())
    throw NoSuchElementException_init_$Create$_0();
  var minValue_0 = iterator_0.l().l1e_1;
  while (iterator_0.k()) {
    var v_0 = iterator_0.l().l1e_1;
    if (compareTo(minValue_0, v_0) > 0) {
      minValue_0 = v_0;
    }
  }
  var tmp$ret$5 = minValue_0;
  return compareValues(tmp, tmp$ret$5);
}
function Progression$sessions$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp0_elvis_lhs = first(a).q1e_1;
      var tmp_0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      var tmp0_elvis_lhs_0 = first(b).q1e_1;
      var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function Progression() {
  this.b1r_1 = 0.8;
  this.c1r_1 = 0.3;
  this.d1r_1 = 3;
}
protoOf(Progression).e1r = function (prescription, scheme, loads, history, doneToday, options) {
  // Inline function 'kotlin.require' call
  if (!(options.n1o_1 == null || options.n1o_1 > 0.0)) {
    var message = 'startingOneRepMaxKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var ctx = new Context(prescription, scheme, options);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = history.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.p1e_1.equals(SetType_WARMUP_getInstance())) {
      destination.f(element);
    }
  }
  var sessions_0 = sessions(this, destination);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = doneToday.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (!element_0.p1e_1.equals(SetType_WARMUP_getInstance())) {
      destination_0.f(element_0);
    }
  }
  var today = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = loads.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    if (element_1 >= 0.0) {
      destination_1.f(element_1);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_1, 10));
  var _iterator__ex2g4s_2 = destination_1.j();
  while (_iterator__ex2g4s_2.k()) {
    var item = _iterator__ex2g4s_2.l();
    var tmp$ret$13 = gram(Progression_instance, item + ctx.s1p_1);
    destination_2.f(tmp$ret$13);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = destination_2.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    if (element_2 > 0.0) {
      destination_3.f(element_2);
    }
  }
  var effectiveLoads = sorted(distinct(destination_3));
  var tmp0 = plus(flatten(sessions_0), today);
  var tmp$ret$17;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$17 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_4 = tmp0.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      if (element_3.m1e_1 + ctx.s1p_1 > 0.0) {
        tmp$ret$17 = true;
        break $l$block_0;
      }
    }
    tmp$ret$17 = false;
  }
  var loggedLoad = tmp$ret$17;
  var tmp_0;
  var tmp_1;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!effectiveLoads.m()) {
    tmp_1 = true;
  } else {
    tmp_1 = ctx.s1p_1 > 0.0;
  }
  if (tmp_1) {
    tmp_0 = loggedLoad || (sessions_0.m() && today.m());
  } else {
    tmp_0 = false;
  }
  var loadBased = tmp_0;
  if (!loadBased)
    return repsOnly(this, ctx, sessions_0, today);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_2;
  if (effectiveLoads.m()) {
    tmp_2 = listOf_0(gram(Progression_instance, ctx.s1p_1));
  } else {
    tmp_2 = effectiveLoads;
  }
  var feasible = tmp_2;
  var prior_0 = prior(this, sessions_0, ctx);
  var current_0 = current(this, prior_0, today, ctx);
  var progressed_0 = progressed(this, sessions_0, ctx);
  if (current_0 == null) {
    // Inline function 'kotlin.math.floor' call
    var x = (prescription.r1a_1 + prescription.s1a_1 | 0) / 2.0;
    var tmp$ret$22 = Math.floor(x);
    var reps = numberToInt(tmp$ret$22);
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(today, 10));
    var index = 0;
    var _iterator__ex2g4s_5 = today.j();
    while (_iterator__ex2g4s_5.k()) {
      var item_0 = _iterator__ex2g4s_5.l();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var i = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$25 = doneSet(Progression_instance, i, item_0, ctx);
      destination_4.f(tmp$ret$25);
    }
    var tmp_3 = destination_4;
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(today.o(), prescription.q1a_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.xc_1;
    var last_0 = this_0.yc_1;
    if (inductionVariable <= last_0)
      do {
        var item_1 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item_1;
        var tmp$ret$28 = new PlannedSet(it, null, reps, ctx.t1p_1, ctx.c1q(it), false);
        destination_5.f(tmp$ret$28);
      }
       while (!(item_1 === last_0));
    var planned = plus(tmp_3, destination_5);
    return new ExerciseTargets(planned, null, TargetIssue_NO_HISTORY_getInstance(), false, emptyList(), false);
  }
  var last_1 = lastOrNull(sessions_0);
  var capped = last_1 == null ? feasible : capLoads(this, feasible, topLoad(this, last_1, ctx), options.j1o_1);
  var base = !(prior_0 == null) ? freshPlan(this, ctx, capped, prior_0, sessions_0) : null;
  if (today.m() && !(base == null))
    return base.o1p(VOID, VOID, VOID, VOID, VOID, progressed_0);
  var tmp1_safe_receiver = base == null ? null : base.h1p_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.c1p_1;
  var plannedReps = tmp3_elvis_lhs == null ? first(today).n1e_1 : tmp3_elvis_lhs;
  var planned_0 = ArrayList_init_$Create$_0();
  ctx.d1q();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index_0 = 0;
  var _iterator__ex2g4s_6 = today.j();
  while (_iterator__ex2g4s_6.k()) {
    var item_2 = _iterator__ex2g4s_6.l();
    var _unary__edvuaz_0 = index_0;
    index_0 = _unary__edvuaz_0 + 1 | 0;
    var i_0 = checkIndexOverflow(_unary__edvuaz_0);
    planned_0.f(doneSet(Progression_instance, i_0, item_2, ctx));
    var tmp0_elvis_lhs = item_2.o1e_1;
    ctx.e1q(i_0, item_2.n1e_1, tmp0_elvis_lhs == null ? ctx.t1p_1 : tmp0_elvis_lhs);
  }
  var previous = gram(this, last(today).m1e_1 + ctx.s1p_1);
  var first_0 = null;
  var inductionVariable_0 = today.o();
  var last_2 = prescription.q1a_1;
  if (inductionVariable_0 < last_2)
    do {
      var i_1 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var choice = laterSet(this, ctx, feasible, current_0, i_1, previous, plannedReps);
      if (first_0 == null)
        first_0 = choice;
      planned_0.f(choice.s1q(i_1, ctx));
      ctx.e1q(i_1, choice.p1q_1, ctx.t1p_1);
      previous = choice.o1q_1;
    }
     while (inductionVariable_0 < last_2);
  var tmp4_safe_receiver = first_0;
  var tmp_4;
  if (tmp4_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = !tmp4_safe_receiver.r1q_1.equals(TargetIssue_NONE_getInstance());
  }
  var tmp5_elvis_lhs = tmp_4;
  var warning = tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
  var tmp6_safe_receiver = first_0;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.r1q_1;
  return new ExerciseTargets(planned_0, current_0, tmp7_elvis_lhs == null ? TargetIssue_NONE_getInstance() : tmp7_elvis_lhs, warning, warning ? alternatives(this, ctx, feasible, current_0, today.o(), last(today).m1e_1 + ctx.s1p_1) : emptyList(), progressed_0);
};
var Progression_instance;
function Progression_getInstance() {
  return Progression_instance;
}
function AdjustmentPriority_REPS_FIRST_getInstance() {
  static_init_49();
  return AdjustmentPriority_REPS_FIRST_instance;
}
function AdjustmentPriority_WEIGHT_FIRST_getInstance() {
  static_init_49();
  return AdjustmentPriority_WEIGHT_FIRST_instance;
}
function TargetIssue_NONE_getInstance() {
  static_init_50();
  return TargetIssue_NONE_instance;
}
function TargetIssue_NO_HISTORY_getInstance() {
  static_init_50();
  return TargetIssue_NO_HISTORY_instance;
}
function TargetIssue_NO_LOADS_getInstance() {
  static_init_50();
  return TargetIssue_NO_LOADS_instance;
}
function TargetIssue_OUTSIDE_REP_RANGE_getInstance() {
  static_init_50();
  return TargetIssue_OUTSIDE_REP_RANGE_instance;
}
function TargetIssue_NO_FEASIBLE_TARGET_getInstance() {
  static_init_50();
  return TargetIssue_NO_FEASIBLE_TARGET_instance;
}
function AlternativeKind_NEXT_LOAD_UP_getInstance() {
  static_init_51();
  return AlternativeKind_NEXT_LOAD_UP_instance;
}
function AlternativeKind_NEXT_LOAD_DOWN_getInstance() {
  static_init_51();
  return AlternativeKind_NEXT_LOAD_DOWN_instance;
}
function AlternativeKind_EXPAND_REP_RANGE_getInstance() {
  static_init_51();
  return AlternativeKind_EXPAND_REP_RANGE_instance;
}
function AlternativeKind_WEIGHT_MATCH_getInstance() {
  static_init_51();
  return AlternativeKind_WEIGHT_MATCH_instance;
}
var static_init_called_52;
function static_init_52() {
  if (static_init_called_52)
    return Unit_instance;
  static_init_called_52 = true;
  SeriesRange_WEEK_instance = new SeriesRange('WEEK', 0, 7);
  SeriesRange_MONTH_instance = new SeriesRange('MONTH', 1, 30);
  SeriesRange_THREE_MONTHS_instance = new SeriesRange('THREE_MONTHS', 2, 91);
  SeriesRange_SIX_MONTHS_instance = new SeriesRange('SIX_MONTHS', 3, 182);
  SeriesRange_YEAR_instance = new SeriesRange('YEAR', 4, 365);
  SeriesRange_ALL_instance = new SeriesRange('ALL', 5, null);
}
var SeriesRange_WEEK_instance;
var SeriesRange_MONTH_instance;
var SeriesRange_THREE_MONTHS_instance;
var SeriesRange_SIX_MONTHS_instance;
var SeriesRange_YEAR_instance;
var SeriesRange_ALL_instance;
function valueOf_13(value) {
  static_init_52();
  switch (value) {
    case 'WEEK':
      return SeriesRange_WEEK_getInstance();
    case 'MONTH':
      return SeriesRange_MONTH_getInstance();
    case 'THREE_MONTHS':
      return SeriesRange_THREE_MONTHS_getInstance();
    case 'SIX_MONTHS':
      return SeriesRange_SIX_MONTHS_getInstance();
    case 'YEAR':
      return SeriesRange_YEAR_getInstance();
    case 'ALL':
      return SeriesRange_ALL_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.SeriesRange.' + value);
      break;
  }
}
function SeriesRange(name, ordinal, days) {
  Enum.call(this, name, ordinal);
  this.h1r_1 = days;
}
var static_init_called_53;
function static_init_53() {
  if (static_init_called_53)
    return Unit_instance;
  static_init_called_53 = true;
  SeriesAggregation_DAY_instance = new SeriesAggregation('DAY', 0);
  SeriesAggregation_WEEK_instance = new SeriesAggregation('WEEK', 1);
  SeriesAggregation_MONTH_instance = new SeriesAggregation('MONTH', 2);
}
var SeriesAggregation_DAY_instance;
var SeriesAggregation_WEEK_instance;
var SeriesAggregation_MONTH_instance;
function valueOf_14(value) {
  static_init_53();
  switch (value) {
    case 'DAY':
      return SeriesAggregation_DAY_getInstance();
    case 'WEEK':
      return SeriesAggregation_WEEK_getInstance();
    case 'MONTH':
      return SeriesAggregation_MONTH_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.SeriesAggregation.' + value);
      break;
  }
}
function SeriesAggregation(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_54;
function static_init_54() {
  if (static_init_called_54)
    return Unit_instance;
  static_init_called_54 = true;
  SeriesAverage_SIMPLE_instance = new SeriesAverage('SIMPLE', 0);
  SeriesAverage_EMA_instance = new SeriesAverage('EMA', 1);
}
var SeriesAverage_SIMPLE_instance;
var SeriesAverage_EMA_instance;
function valueOf_15(value) {
  static_init_54();
  switch (value) {
    case 'SIMPLE':
      return SeriesAverage_SIMPLE_getInstance();
    case 'EMA':
      return SeriesAverage_EMA_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.SeriesAverage.' + value);
      break;
  }
}
function SeriesAverage(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function SeriesPoint(day, value) {
  this.i1r_1 = day;
  this.j1r_1 = value;
}
protoOf(SeriesPoint).toString = function () {
  return 'SeriesPoint(day=' + this.i1r_1 + ', value=' + this.j1r_1 + ')';
};
protoOf(SeriesPoint).hashCode = function () {
  var result = this.i1r_1;
  result = imul(result, 31) + getNumberHashCode(this.j1r_1) | 0;
  return result;
};
protoOf(SeriesPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SeriesPoint))
    return false;
  if (!(this.i1r_1 === other.i1r_1))
    return false;
  if (!equals(this.j1r_1, other.j1r_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_13(function_0) {
  this.k1r_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_13).ea = function (a, b) {
  return this.k1r_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_13).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_13).h2 = function () {
  return this.k1r_1;
};
protoOf(sam$kotlin_Comparator$0_13).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_13).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_14(function_0) {
  this.l1r_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_14).ea = function (a, b) {
  return this.l1r_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_14).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_14).h2 = function () {
  return this.l1r_1;
};
protoOf(sam$kotlin_Comparator$0_14).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_14).hashCode = function () {
  return hashCode(this.h2());
};
function SeriesRanges$apply$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.p1();
  var tmp$ret$2 = b.p1();
  return compareValues(tmp, tmp$ret$2);
}
function SeriesRanges$records$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.i1r_1;
  var tmp$ret$2 = b.i1r_1;
  return compareValues(tmp, tmp$ret$2);
}
function SeriesRanges() {
  this.m1r_1 = 0.3;
}
protoOf(SeriesRanges).n1r = function (points, today, range, aggregation, average, recordsOnly) {
  var shown = recordsOnly ? this.o1r(points) : points;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = shown.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.i1r_1 <= today && (range.h1r_1 == null || element.i1r_1 > (today - range.h1r_1 | 0))) {
      destination.f(element);
    }
  }
  var inRange = destination;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = inRange.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = SeriesRanges_instance.p1r(element_0.i1r_1, aggregation);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination_0.w1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = SeriesRanges$apply$lambda;
  var tmp$ret$9 = new sam$kotlin_Comparator$0_13(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$9);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_1 = this_1.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var start = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.q1();
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = group.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$_0();
    var maxValue = iterator.l().j1r_1;
    while (iterator.k()) {
      var v = iterator.l().j1r_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    var tmp$ret$15 = maxValue;
    var tmp$ret$12 = new SeriesPoint(start, tmp$ret$15);
    destination_1.f(tmp$ret$12);
  }
  var buckets = destination_1;
  if (average.equals(SeriesAverage_SIMPLE_getInstance()))
    return buckets;
  var smoothed = null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(buckets, 10));
  var _iterator__ex2g4s_2 = buckets.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp0_safe_receiver = smoothed;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = 0.3 * item_0.j1r_1 + (1.0 - 0.3) * tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp_1;
    var next = tmp1_elvis_lhs == null ? item_0.j1r_1 : tmp1_elvis_lhs;
    smoothed = next;
    var tmp$ret$21 = new SeriesPoint(item_0.i1r_1, next);
    destination_2.f(tmp$ret$21);
  }
  return destination_2;
};
protoOf(SeriesRanges).o1r = function (points) {
  var best = -Infinity;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = SeriesRanges$records$lambda;
  var tmp$ret$1 = new sam$kotlin_Comparator$0_14(tmp);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = sortedWith(points, tmp$ret$1);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.also' call
    var this_0 = element.j1r_1 > best;
    if (this_0)
      best = element.j1r_1;
    if (this_0) {
      destination.f(element);
    }
  }
  return destination;
};
protoOf(SeriesRanges).p1r = function (day, aggregation) {
  var tmp;
  switch (aggregation.y1_1) {
    case 0:
      tmp = day;
      break;
    case 1:
      tmp = EpochDays_getInstance().ge(day);
      break;
    case 2:
      tmp = ensureNotNull(EpochDays_getInstance().de(substring(EpochDays_getInstance().ee(day), 0, 8) + '01'));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var SeriesRanges_instance;
function SeriesRanges_getInstance() {
  return SeriesRanges_instance;
}
function SeriesRange_WEEK_getInstance() {
  static_init_52();
  return SeriesRange_WEEK_instance;
}
function SeriesRange_MONTH_getInstance() {
  static_init_52();
  return SeriesRange_MONTH_instance;
}
function SeriesRange_THREE_MONTHS_getInstance() {
  static_init_52();
  return SeriesRange_THREE_MONTHS_instance;
}
function SeriesRange_SIX_MONTHS_getInstance() {
  static_init_52();
  return SeriesRange_SIX_MONTHS_instance;
}
function SeriesRange_YEAR_getInstance() {
  static_init_52();
  return SeriesRange_YEAR_instance;
}
function SeriesRange_ALL_getInstance() {
  static_init_52();
  return SeriesRange_ALL_instance;
}
function SeriesAggregation_DAY_getInstance() {
  static_init_53();
  return SeriesAggregation_DAY_instance;
}
function SeriesAggregation_WEEK_getInstance() {
  static_init_53();
  return SeriesAggregation_WEEK_instance;
}
function SeriesAggregation_MONTH_getInstance() {
  static_init_53();
  return SeriesAggregation_MONTH_instance;
}
function SeriesAverage_SIMPLE_getInstance() {
  static_init_54();
  return SeriesAverage_SIMPLE_instance;
}
function SeriesAverage_EMA_getInstance() {
  static_init_54();
  return SeriesAverage_EMA_instance;
}
function LoggedSet(loadKg, reps, rir) {
  this.q1r_1 = loadKg;
  this.r1r_1 = reps;
  this.s1r_1 = rir;
}
protoOf(LoggedSet).toString = function () {
  return 'LoggedSet(loadKg=' + this.q1r_1 + ', reps=' + this.r1r_1 + ', rir=' + this.s1r_1 + ')';
};
protoOf(LoggedSet).hashCode = function () {
  var result = getNumberHashCode(this.q1r_1);
  result = imul(result, 31) + this.r1r_1 | 0;
  result = imul(result, 31) + this.s1r_1 | 0;
  return result;
};
protoOf(LoggedSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LoggedSet))
    return false;
  if (!equals(this.q1r_1, other.q1r_1))
    return false;
  if (!(this.r1r_1 === other.r1r_1))
    return false;
  if (!(this.s1r_1 === other.s1r_1))
    return false;
  return true;
};
function SetTarget(loadKg, reps, outsideRepRange) {
  this.u1q_1 = loadKg;
  this.v1q_1 = reps;
  this.w1q_1 = outsideRepRange;
}
protoOf(SetTarget).toString = function () {
  return 'SetTarget(loadKg=' + this.u1q_1 + ', reps=' + this.v1q_1 + ', outsideRepRange=' + this.w1q_1 + ')';
};
protoOf(SetTarget).hashCode = function () {
  var result = getNumberHashCode(this.u1q_1);
  result = imul(result, 31) + this.v1q_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.w1q_1) | 0;
  return result;
};
protoOf(SetTarget).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetTarget))
    return false;
  if (!equals(this.u1q_1, other.u1q_1))
    return false;
  if (!(this.v1q_1 === other.v1q_1))
    return false;
  if (!(this.w1q_1 === other.w1q_1))
    return false;
  return true;
};
function roundTo($this, value, step) {
  return round(value / step) * step;
}
function Candidate(load, reps, predicted) {
  this.t1r_1 = load;
  this.u1r_1 = reps;
  this.v1r_1 = predicted;
}
function sam$kotlin_Comparator$0_15(function_0) {
  this.w1r_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_15).ea = function (a, b) {
  return this.w1r_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_15).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_15).h2 = function () {
  return this.w1r_1;
};
protoOf(sam$kotlin_Comparator$0_15).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_15).hashCode = function () {
  return hashCode(this.h2());
};
function Strength$nextSetTarget$pick$lambda($midpoint) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'kotlin.math.abs' call
    var x = a.v1r_1 - $midpoint;
    var tmp$ret$2 = Math.abs(x);
    var tmp = round(tmp$ret$2 * 1000);
    // Inline function 'kotlin.math.abs' call
    var x_0 = b.v1r_1 - $midpoint;
    var tmp$ret$4 = Math.abs(x_0);
    var tmp$ret$3 = round(tmp$ret$4 * 1000);
    return compareValues(tmp, tmp$ret$3);
  };
}
function Strength$nextSetTarget$pick$lambda_0($this, $previousLoadKg) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0;
      var tmp_1;
      if (!($previousLoadKg == null)) {
        // Inline function 'kotlin.math.abs' call
        var x = a.t1r_1 - $previousLoadKg;
        tmp_1 = Math.abs(x) < 1.0E-9;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = 0;
      } else {
        tmp_0 = 1;
      }
      var tmp_2 = tmp_0;
      var tmp_3;
      var tmp_4;
      if (!($previousLoadKg == null)) {
        // Inline function 'kotlin.math.abs' call
        var x_0 = b.t1r_1 - $previousLoadKg;
        tmp_4 = Math.abs(x_0) < 1.0E-9;
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp_3 = 0;
      } else {
        tmp_3 = 1;
      }
      var tmp$ret$3 = tmp_3;
      tmp = compareValues(tmp_2, tmp$ret$3);
    }
    return tmp;
  };
}
function Strength$nextSetTarget$pick$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b.t1r_1;
      var tmp$ret$2 = a.t1r_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function nextSetTarget$pick(candidates, midpoint, $previousLoadKg, minReps, maxReps) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = candidates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsArg = element.u1r_1;
    if (minReps <= containsArg ? containsArg <= maxReps : false) {
      destination.f(element);
    }
  }
  var tmp = destination;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = Strength$nextSetTarget$pick$lambda(midpoint);
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_15(tmp_0);
  var tmp_1 = Strength$nextSetTarget$pick$lambda_0(this_0, $previousLoadKg);
  // Inline function 'kotlin.comparisons.thenByDescending' call
  var this_1 = new sam$kotlin_Comparator$0_15(tmp_1);
  var tmp_2 = Strength$nextSetTarget$pick$lambda_1(this_1);
  var tmp$ret$5 = new sam$kotlin_Comparator$0_15(tmp_2);
  return minWithOrNull(tmp, tmp$ret$5);
}
function Strength() {
  this.a1i_1 = 30.0;
}
protoOf(Strength).x1r = function (set) {
  return set.r1r_1 + set.s1r_1 | 0;
};
protoOf(Strength).y1r = function (set, k) {
  // Inline function 'kotlin.require' call
  if (!(set.q1r_1 >= 0.0 && set.r1r_1 > 0 && set.s1r_1 >= 0)) {
    var message = 'invalid set';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var rtf = this.x1r(set);
  return rtf <= 1 ? set.q1r_1 : set.q1r_1 * (1.0 + rtf / k);
};
protoOf(Strength).z1r = function (set, k, $super) {
  k = k === VOID ? 30.0 : k;
  return $super === VOID ? this.y1r(set, k) : $super.y1r.call(this, set, k);
};
protoOf(Strength).a1s = function (loadKg, oneRepMaxKg, k) {
  // Inline function 'kotlin.require' call
  if (!(loadKg > 0.0 && oneRepMaxKg > 0.0)) {
    var message = 'loads must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (loadKg >= oneRepMaxKg)
    return 1.0;
  return k * (oneRepMaxKg / loadKg - 1.0);
};
protoOf(Strength).y1q = function (set, repMin, repMax, rirTarget, previousRepsAtSameLoad) {
  // Inline function 'kotlin.require' call
  if (!(1 <= repMin ? repMin <= repMax : false)) {
    var message = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (rirTarget === 0) {
    return !(previousRepsAtSameLoad == null) && set.r1r_1 > previousRepsAtSameLoad;
  }
  var midpoint = (repMin + repMax | 0) / 2.0;
  return (set.r1r_1 + set.s1r_1 | 0) >= midpoint + rirTarget + 1;
};
protoOf(Strength).b1s = function (oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance) {
  // Inline function 'kotlin.require' call
  if (!(1 <= repMin ? repMin <= repMax : false)) {
    var message = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(setIndex >= 0)) {
    var message_0 = 'setIndex must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(performance > 0.0)) {
    var message_1 = 'performance must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = feasibleLoadsKg.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  var loads = distinct(destination);
  if (loads.m())
    return null;
  var midpoint = (repMin + repMax | 0) / 2.0;
  var strength = oneRepMaxKg * performance;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(loads, 10));
  var _iterator__ex2g4s_0 = loads.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var predicted = curve.h1q(item, strength) - fatigueRepsPerSet * setIndex - rirTarget;
    // Inline function 'kotlin.math.floor' call
    var x = predicted + 0.5;
    var tmp$ret$12 = Math.floor(x);
    var tmp$ret$11 = new Candidate(item, numberToInt(tmp$ret$12), predicted);
    destination_0.f(tmp$ret$11);
  }
  var candidates = destination_0;
  var tmp0_safe_receiver = nextSetTarget$pick(candidates, midpoint, previousLoadKg, repMin, repMax);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return new SetTarget(tmp0_safe_receiver.t1r_1, tmp0_safe_receiver.u1r_1, false);
  }
  if (!expandRepRange)
    return null;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = repMin - expandBy | 0;
  var tmp$ret$15 = Math.max(1, b);
  var tmp1_elvis_lhs = nextSetTarget$pick(candidates, midpoint, previousLoadKg, tmp$ret$15, repMax + expandBy | 0);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var widened = tmp;
  return new SetTarget(widened.t1r_1, widened.u1r_1, true);
};
protoOf(Strength).t1q = function (oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance, $super) {
  setIndex = setIndex === VOID ? 0 : setIndex;
  fatigueRepsPerSet = fatigueRepsPerSet === VOID ? 1.0 : fatigueRepsPerSet;
  previousLoadKg = previousLoadKg === VOID ? null : previousLoadKg;
  k = k === VOID ? 30.0 : k;
  expandRepRange = expandRepRange === VOID ? true : expandRepRange;
  expandBy = expandBy === VOID ? 2 : expandBy;
  curve = curve === VOID ? new EpleyCurve(k) : curve;
  performance = performance === VOID ? 1.0 : performance;
  return $super === VOID ? this.b1s(oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance) : $super.b1s.call(this, oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance);
};
protoOf(Strength).b1i = function (ranges) {
  var loads = HashSet_init_$Create$();
  var _iterator__ex2g4s = ranges.j();
  while (_iterator__ex2g4s.k()) {
    var range = _iterator__ex2g4s.l();
    // Inline function 'kotlin.require' call
    if (!(range.j1h_1 > 0.0 && range.i1h_1 >= range.h1h_1)) {
      var message = 'invalid stack range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var load = range.h1h_1;
    while (load <= range.i1h_1 + 1.0E-9) {
      loads.f(roundTo(this, load, 0.001));
      load = load + range.j1h_1;
    }
  }
  return sorted(loads);
};
var Strength_instance;
function Strength_getInstance() {
  return Strength_instance;
}
function StackRange(startKg, endKg, incrementKg) {
  this.h1h_1 = startKg;
  this.i1h_1 = endKg;
  this.j1h_1 = incrementKg;
}
protoOf(StackRange).toString = function () {
  return 'StackRange(startKg=' + this.h1h_1 + ', endKg=' + this.i1h_1 + ', incrementKg=' + this.j1h_1 + ')';
};
protoOf(StackRange).hashCode = function () {
  var result = getNumberHashCode(this.h1h_1);
  result = imul(result, 31) + getNumberHashCode(this.i1h_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.j1h_1) | 0;
  return result;
};
protoOf(StackRange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StackRange))
    return false;
  if (!equals(this.h1h_1, other.h1h_1))
    return false;
  if (!equals(this.i1h_1, other.i1h_1))
    return false;
  if (!equals(this.j1h_1, other.j1h_1))
    return false;
  return true;
};
function StrengthCurve() {
}
function EpleyCurve(k) {
  k = k === VOID ? 30.0 : k;
  this.c1s_1 = k;
  // Inline function 'kotlin.require' call
  if (!(this.c1s_1 > 0.0)) {
    var message = 'k must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(EpleyCurve).h1e = function (rtf) {
  return 1.0 / (1.0 + rtf / this.c1s_1);
};
protoOf(EpleyCurve).j1q = function (loadKg, rtf) {
  return rtf <= 1.0 ? loadKg : loadKg * (1.0 + rtf / this.c1s_1);
};
protoOf(EpleyCurve).h1q = function (loadKg, oneRepMaxKg) {
  return Strength_instance.a1s(loadKg, oneRepMaxKg, this.c1s_1);
};
protoOf(EpleyCurve).x1q = function (oneRepMaxKg, rtf) {
  return oneRepMaxKg / (1.0 + rtf / this.c1s_1);
};
protoOf(EpleyCurve).toString = function () {
  return 'EpleyCurve(k=' + this.c1s_1 + ')';
};
protoOf(EpleyCurve).hashCode = function () {
  return getNumberHashCode(this.c1s_1);
};
protoOf(EpleyCurve).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EpleyCurve))
    return false;
  if (!equals(this.c1s_1, other.c1s_1))
    return false;
  return true;
};
function Companion_13() {
  Companion_instance_15 = this;
  this.d1s_1 = 0.2;
  this.e1s_1 = 0.958;
  this.f1s_1 = 100.0;
  this.g1s_1 = mapOf_0([to(1, 1.0), to(2, 0.95), to(3, 0.93), to(4, 0.9), to(5, 0.87), to(6, 0.85), to(7, 0.83), to(8, 0.8), to(9, 0.77), to(10, 0.75), to(12, 0.67), to(15, 0.65)]);
}
var Companion_instance_15;
function Companion_getInstance_12() {
  if (Companion_instance_15 == null)
    new Companion_13();
  return Companion_instance_15;
}
function FlooredExpCurve(base, floor) {
  Companion_getInstance_12();
  floor = floor === VOID ? 0.2 : floor;
  this.f1e_1 = base;
  this.g1e_1 = floor;
  // Inline function 'kotlin.require' call
  if (!(this.f1e_1 > 0.0 && this.f1e_1 < 1.0)) {
    var message = 'base must be between 0 and 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.g1e_1 >= 0.0 && this.g1e_1 < 1.0)) {
    var message_0 = 'floor must be between 0 and 1';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(FlooredExpCurve).h1e = function (rtf) {
  var tmp = 1.0 - this.g1e_1;
  var tmp0 = this.f1e_1;
  // Inline function 'kotlin.math.pow' call
  var x = rtf - 1.0;
  var tmp$ret$0 = Math.pow(tmp0, x);
  return this.g1e_1 + tmp * tmp$ret$0;
};
protoOf(FlooredExpCurve).h1q = function (loadKg, oneRepMaxKg) {
  // Inline function 'kotlin.require' call
  if (!(loadKg > 0.0 && oneRepMaxKg > 0.0)) {
    var message = 'loads must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var share = loadKg / oneRepMaxKg;
  if (share >= 1.0)
    return 1.0;
  if (share <= this.g1e_1 + 1.0E-9)
    return 100.0;
  // Inline function 'kotlin.math.ln' call
  var x = (share - this.g1e_1) / (1.0 - this.g1e_1);
  var tmp = Math.log(x);
  // Inline function 'kotlin.math.ln' call
  var x_0 = this.f1e_1;
  // Inline function 'kotlin.math.min' call
  var b = 1.0 + tmp / Math.log(x_0);
  return Math.min(100.0, b);
};
protoOf(FlooredExpCurve).toString = function () {
  return 'FlooredExpCurve(base=' + this.f1e_1 + ', floor=' + this.g1e_1 + ')';
};
protoOf(FlooredExpCurve).hashCode = function () {
  var result = getNumberHashCode(this.f1e_1);
  result = imul(result, 31) + getNumberHashCode(this.g1e_1) | 0;
  return result;
};
protoOf(FlooredExpCurve).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FlooredExpCurve))
    return false;
  if (!equals(this.f1e_1, other.f1e_1))
    return false;
  if (!equals(this.g1e_1, other.g1e_1))
    return false;
  return true;
};
function OneRepMaxClamp() {
  this.k1q_1 = 0.99;
  this.l1q_1 = 0.95;
}
protoOf(OneRepMaxClamp).m1q = function (oneRepMaxKg, loadKg, rtf) {
  if (rtf <= 1.0)
    return oneRepMaxKg;
  // Inline function 'kotlin.math.pow' call
  var x = rtf - 1.0;
  var lower = loadKg / Math.pow(0.99, x);
  // Inline function 'kotlin.math.pow' call
  var x_0 = rtf - 1.0;
  var upper = loadKg / Math.pow(0.95, x_0);
  return coerceIn(oneRepMaxKg, lower, upper);
};
var OneRepMaxClamp_instance;
function OneRepMaxClamp_getInstance() {
  return OneRepMaxClamp_instance;
}
var static_init_called_55;
function static_init_55() {
  if (static_init_called_55)
    return Unit_instance;
  static_init_called_55 = true;
  CurveModel_EPLEY_instance = new CurveModel('EPLEY', 0);
  CurveModel_FLOORED_EXP_FITTED_instance = new CurveModel('FLOORED_EXP_FITTED', 1);
}
var CurveModel_EPLEY_instance;
var CurveModel_FLOORED_EXP_FITTED_instance;
function values_34() {
  static_init_55();
  return [CurveModel_EPLEY_getInstance(), CurveModel_FLOORED_EXP_FITTED_getInstance()];
}
function get_entries_29() {
  static_init_55();
  if ($ENTRIES_29 == null)
    $ENTRIES_29 = enumEntries(values_34());
  return $ENTRIES_29;
}
var $ENTRIES_29;
function CurveModel(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_56;
function static_init_56() {
  if (static_init_called_56)
    return Unit_instance;
  static_init_called_56 = true;
  Region_UPPER_instance = new Region('UPPER', 0, 'upper');
  Region_LOWER_instance = new Region('LOWER', 1, 'lower');
  Region_CORE_instance = new Region('CORE', 2, 'core');
  Region_FULL_instance = new Region('FULL', 3, 'full');
  if (Companion_instance_16 == null) {
    Companion_instance_0;
    new Companion_14();
  }
}
var Region_UPPER_instance;
var Region_LOWER_instance;
var Region_CORE_instance;
var Region_FULL_instance;
function Companion_14() {
  Companion_instance_16 = this;
  this.v1m_1 = setOf([Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_TRAPS_getInstance(), Muscle_NECK_getInstance()]);
  this.w1m_1 = setOf([Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance()]);
}
protoOf(Companion_14).h1f = function (key) {
  var tmp0 = get_entries_30();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.j1s_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
protoOf(Companion_14).x1m = function (exercise) {
  var tmp0_elvis_lhs = exercise.c1c_1;
  return tmp0_elvis_lhs == null ? this.k1s(exercise.v1b_1) : tmp0_elvis_lhs;
};
protoOf(Companion_14).k1s = function (primary) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(primary, Collection)) {
      tmp = primary.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = primary.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (Companion_getInstance_13().v1m_1.r(element)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  var upper = tmp$ret$0;
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlin.collections.any' call
    var tmp_0;
    if (isInterface(primary, Collection)) {
      tmp_0 = primary.m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$2 = false;
      break $l$block_2;
    }
    var _iterator__ex2g4s_0 = primary.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (Companion_getInstance_13().w1m_1.r(element_0)) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
    }
    tmp$ret$2 = false;
  }
  var lower = tmp$ret$2;
  return upper && lower ? Region_FULL_getInstance() : upper ? Region_UPPER_getInstance() : lower ? Region_LOWER_getInstance() : Region_CORE_getInstance();
};
var Companion_instance_16;
function Companion_getInstance_13() {
  static_init_56();
  return Companion_instance_16;
}
function values_35() {
  static_init_56();
  return [Region_UPPER_getInstance(), Region_LOWER_getInstance(), Region_CORE_getInstance(), Region_FULL_getInstance()];
}
function get_entries_30() {
  static_init_56();
  if ($ENTRIES_30 == null)
    $ENTRIES_30 = enumEntries(values_35());
  return $ENTRIES_30;
}
var $ENTRIES_30;
function Region(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.j1s_1 = key;
}
function CurveModel_EPLEY_getInstance() {
  static_init_55();
  return CurveModel_EPLEY_instance;
}
function CurveModel_FLOORED_EXP_FITTED_getInstance() {
  static_init_55();
  return CurveModel_FLOORED_EXP_FITTED_instance;
}
function Region_UPPER_getInstance() {
  static_init_56();
  return Region_UPPER_instance;
}
function Region_LOWER_getInstance() {
  static_init_56();
  return Region_LOWER_instance;
}
function Region_CORE_getInstance() {
  static_init_56();
  return Region_CORE_instance;
}
function Region_FULL_getInstance() {
  static_init_56();
  return Region_FULL_instance;
}
var static_init_called_57;
function static_init_57() {
  if (static_init_called_57)
    return Unit_instance;
  static_init_called_57 = true;
  Muscle_CHEST_instance = new Muscle('CHEST', 0, 'chest');
  Muscle_SHOULDERS_instance = new Muscle('SHOULDERS', 1, 'shoulders');
  Muscle_TRICEPS_instance = new Muscle('TRICEPS', 2, 'triceps');
  Muscle_BICEPS_instance = new Muscle('BICEPS', 3, 'biceps');
  Muscle_FOREARMS_instance = new Muscle('FOREARMS', 4, 'forearms');
  Muscle_LATS_instance = new Muscle('LATS', 5, 'lats');
  Muscle_MIDDLE_BACK_instance = new Muscle('MIDDLE_BACK', 6, 'middle back');
  Muscle_LOWER_BACK_instance = new Muscle('LOWER_BACK', 7, 'lower back');
  Muscle_TRAPS_instance = new Muscle('TRAPS', 8, 'traps');
  Muscle_ABDOMINALS_instance = new Muscle('ABDOMINALS', 9, 'abdominals');
  Muscle_QUADRICEPS_instance = new Muscle('QUADRICEPS', 10, 'quadriceps');
  Muscle_HAMSTRINGS_instance = new Muscle('HAMSTRINGS', 11, 'hamstrings');
  Muscle_GLUTES_instance = new Muscle('GLUTES', 12, 'glutes');
  Muscle_CALVES_instance = new Muscle('CALVES', 13, 'calves');
  Muscle_ADDUCTORS_instance = new Muscle('ADDUCTORS', 14, 'adductors');
  Muscle_ABDUCTORS_instance = new Muscle('ABDUCTORS', 15, 'abductors');
  Muscle_NECK_instance = new Muscle('NECK', 16, 'neck');
  if (Companion_instance_17 == null) {
    Companion_instance_0;
    new Companion_15();
  }
}
var Muscle_CHEST_instance;
var Muscle_SHOULDERS_instance;
var Muscle_TRICEPS_instance;
var Muscle_BICEPS_instance;
var Muscle_FOREARMS_instance;
var Muscle_LATS_instance;
var Muscle_MIDDLE_BACK_instance;
var Muscle_LOWER_BACK_instance;
var Muscle_TRAPS_instance;
var Muscle_ABDOMINALS_instance;
var Muscle_QUADRICEPS_instance;
var Muscle_HAMSTRINGS_instance;
var Muscle_GLUTES_instance;
var Muscle_CALVES_instance;
var Muscle_ADDUCTORS_instance;
var Muscle_ABDUCTORS_instance;
var Muscle_NECK_instance;
function Companion_15() {
}
protoOf(Companion_15).b1g = function (key) {
  var tmp0 = get_entries_31();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.n1s_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_17;
function Companion_getInstance_14() {
  return Companion_instance_17;
}
function values_36() {
  static_init_57();
  return [Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_TRAPS_getInstance(), Muscle_ABDOMINALS_getInstance(), Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance(), Muscle_NECK_getInstance()];
}
function get_entries_31() {
  static_init_57();
  if ($ENTRIES_31 == null)
    $ENTRIES_31 = enumEntries(values_36());
  return $ENTRIES_31;
}
var $ENTRIES_31;
function Muscle(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.n1s_1 = key;
}
var static_init_called_58;
function static_init_58() {
  if (static_init_called_58)
    return Unit_instance;
  static_init_called_58 = true;
  Equipment_BARBELL_instance = new Equipment('BARBELL', 0, 'barbell');
  Equipment_DUMBBELL_instance = new Equipment('DUMBBELL', 1, 'dumbbell');
  Equipment_MACHINE_instance = new Equipment('MACHINE', 2, 'machine');
  Equipment_CABLE_instance = new Equipment('CABLE', 3, 'cable');
  Equipment_KETTLEBELL_instance = new Equipment('KETTLEBELL', 4, 'kettlebell');
  Equipment_BODYWEIGHT_instance = new Equipment('BODYWEIGHT', 5, 'bodyweight');
  Equipment_BAND_instance = new Equipment('BAND', 6, 'band');
  Equipment_SMITH_instance = new Equipment('SMITH', 7, 'smith');
  Equipment_OTHER_instance = new Equipment('OTHER', 8, 'other');
  if (Companion_instance_18 == null) {
    Companion_instance_0;
    new Companion_16();
  }
}
var Equipment_BARBELL_instance;
var Equipment_DUMBBELL_instance;
var Equipment_MACHINE_instance;
var Equipment_CABLE_instance;
var Equipment_KETTLEBELL_instance;
var Equipment_BODYWEIGHT_instance;
var Equipment_BAND_instance;
var Equipment_SMITH_instance;
var Equipment_OTHER_instance;
function Companion_16() {
}
protoOf(Companion_16).h1f = function (key) {
  var tmp0 = get_entries_32();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.t1g_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? Equipment_OTHER_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_18;
function Companion_getInstance_15() {
  return Companion_instance_18;
}
function values_37() {
  static_init_58();
  return [Equipment_BARBELL_getInstance(), Equipment_DUMBBELL_getInstance(), Equipment_MACHINE_getInstance(), Equipment_CABLE_getInstance(), Equipment_KETTLEBELL_getInstance(), Equipment_BODYWEIGHT_getInstance(), Equipment_BAND_getInstance(), Equipment_SMITH_getInstance(), Equipment_OTHER_getInstance()];
}
function get_entries_32() {
  static_init_58();
  if ($ENTRIES_32 == null)
    $ENTRIES_32 = enumEntries(values_37());
  return $ENTRIES_32;
}
var $ENTRIES_32;
function Equipment(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.t1g_1 = key;
}
var static_init_called_59;
function static_init_59() {
  if (static_init_called_59)
    return Unit_instance;
  static_init_called_59 = true;
  SetType_STANDARD_instance = new SetType('STANDARD', 0, 'standard');
  SetType_WARMUP_instance = new SetType('WARMUP', 1, 'warmup');
  SetType_DROP_instance = new SetType('DROP', 2, 'drop');
  SetType_MYO_instance = new SetType('MYO', 3, 'myo');
  SetType_FAILURE_instance = new SetType('FAILURE', 4, 'failure');
  if (Companion_instance_19 == null) {
    Companion_instance_0;
    new Companion_17();
  }
}
var SetType_STANDARD_instance;
var SetType_WARMUP_instance;
var SetType_DROP_instance;
var SetType_MYO_instance;
var SetType_FAILURE_instance;
function Companion_17() {
}
protoOf(Companion_17).h1f = function (key) {
  var tmp0 = get_entries_33();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.q1s_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? SetType_STANDARD_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_19;
function Companion_getInstance_16() {
  return Companion_instance_19;
}
function values_38() {
  static_init_59();
  return [SetType_STANDARD_getInstance(), SetType_WARMUP_getInstance(), SetType_DROP_getInstance(), SetType_MYO_getInstance(), SetType_FAILURE_getInstance()];
}
function get_entries_33() {
  static_init_59();
  if ($ENTRIES_33 == null)
    $ENTRIES_33 = enumEntries(values_38());
  return $ENTRIES_33;
}
var $ENTRIES_33;
function SetType(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.q1s_1 = key;
}
var static_init_called_60;
function static_init_60() {
  if (static_init_called_60)
    return Unit_instance;
  static_init_called_60 = true;
  ProgressionScheme_DOUBLE_instance = new ProgressionScheme('DOUBLE', 0, 'double');
  ProgressionScheme_LINEAR_instance = new ProgressionScheme('LINEAR', 1, 'linear');
  ProgressionScheme_REVERSE_LINEAR_instance = new ProgressionScheme('REVERSE_LINEAR', 2, 'reverseLinear');
  ProgressionScheme_UNDULATING_instance = new ProgressionScheme('UNDULATING', 3, 'undulating');
  ProgressionScheme_STATIC_instance = new ProgressionScheme('STATIC', 4, 'static');
  if (Companion_instance_20 == null) {
    Companion_instance_0;
    new Companion_18();
  }
}
var ProgressionScheme_DOUBLE_instance;
var ProgressionScheme_LINEAR_instance;
var ProgressionScheme_REVERSE_LINEAR_instance;
var ProgressionScheme_UNDULATING_instance;
var ProgressionScheme_STATIC_instance;
function Companion_18() {
}
protoOf(Companion_18).h1f = function (key) {
  var tmp0 = get_entries_34();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.t1s_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? ProgressionScheme_DOUBLE_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_20;
function Companion_getInstance_17() {
  return Companion_instance_20;
}
function values_39() {
  static_init_60();
  return [ProgressionScheme_DOUBLE_getInstance(), ProgressionScheme_LINEAR_getInstance(), ProgressionScheme_REVERSE_LINEAR_getInstance(), ProgressionScheme_UNDULATING_getInstance(), ProgressionScheme_STATIC_getInstance()];
}
function get_entries_34() {
  static_init_60();
  if ($ENTRIES_34 == null)
    $ENTRIES_34 = enumEntries(values_39());
  return $ENTRIES_34;
}
var $ENTRIES_34;
function ProgressionScheme(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.t1s_1 = key;
}
var static_init_called_61;
function static_init_61() {
  if (static_init_called_61)
    return Unit_instance;
  static_init_called_61 = true;
  Mechanic_COMPOUND_instance = new Mechanic('COMPOUND', 0, 'compound');
  Mechanic_ISOLATION_instance = new Mechanic('ISOLATION', 1, 'isolation');
  if (Companion_instance_21 == null) {
    Companion_instance_0;
    new Companion_19();
  }
}
var Mechanic_COMPOUND_instance;
var Mechanic_ISOLATION_instance;
function Companion_19() {
}
protoOf(Companion_19).h1f = function (key) {
  var tmp0 = get_entries_35();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.w1s_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_21;
function Companion_getInstance_18() {
  return Companion_instance_21;
}
function values_40() {
  static_init_61();
  return [Mechanic_COMPOUND_getInstance(), Mechanic_ISOLATION_getInstance()];
}
function get_entries_35() {
  static_init_61();
  if ($ENTRIES_35 == null)
    $ENTRIES_35 = enumEntries(values_40());
  return $ENTRIES_35;
}
var $ENTRIES_35;
function Mechanic(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.w1s_1 = key;
}
var static_init_called_62;
function static_init_62() {
  if (static_init_called_62)
    return Unit_instance;
  static_init_called_62 = true;
  Force_PUSH_instance = new Force('PUSH', 0, 'push');
  Force_PULL_instance = new Force('PULL', 1, 'pull');
  Force_STATIC_instance = new Force('STATIC', 2, 'static');
  if (Companion_instance_22 == null) {
    Companion_instance_0;
    new Companion_20();
  }
}
var Force_PUSH_instance;
var Force_PULL_instance;
var Force_STATIC_instance;
function Companion_20() {
}
protoOf(Companion_20).h1f = function (key) {
  var tmp0 = get_entries_36();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.z1s_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_22;
function Companion_getInstance_19() {
  return Companion_instance_22;
}
function values_41() {
  static_init_62();
  return [Force_PUSH_getInstance(), Force_PULL_getInstance(), Force_STATIC_getInstance()];
}
function get_entries_36() {
  static_init_62();
  if ($ENTRIES_36 == null)
    $ENTRIES_36 = enumEntries(values_41());
  return $ENTRIES_36;
}
var $ENTRIES_36;
function Force(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.z1s_1 = key;
}
var static_init_called_63;
function static_init_63() {
  if (static_init_called_63)
    return Unit_instance;
  static_init_called_63 = true;
  TrainingGoal_STRENGTH_instance = new TrainingGoal('STRENGTH', 0, 'strength');
  TrainingGoal_HYPERTROPHY_instance = new TrainingGoal('HYPERTROPHY', 1, 'hypertrophy');
  if (Companion_instance_23 == null) {
    Companion_instance_0;
    new Companion_21();
  }
}
var TrainingGoal_STRENGTH_instance;
var TrainingGoal_HYPERTROPHY_instance;
function Companion_21() {
}
protoOf(Companion_21).h1f = function (key) {
  var tmp0 = get_entries_37();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.c1t_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? TrainingGoal_HYPERTROPHY_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_23;
function Companion_getInstance_20() {
  return Companion_instance_23;
}
function values_42() {
  static_init_63();
  return [TrainingGoal_STRENGTH_getInstance(), TrainingGoal_HYPERTROPHY_getInstance()];
}
function get_entries_37() {
  static_init_63();
  if ($ENTRIES_37 == null)
    $ENTRIES_37 = enumEntries(values_42());
  return $ENTRIES_37;
}
var $ENTRIES_37;
function TrainingGoal(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.c1t_1 = key;
}
var static_init_called_64;
function static_init_64() {
  if (static_init_called_64)
    return Unit_instance;
  static_init_called_64 = true;
  DeloadPosition_NONE_instance = new DeloadPosition('NONE', 0, 'none');
  DeloadPosition_FIRST_instance = new DeloadPosition('FIRST', 1, 'first');
  DeloadPosition_LAST_instance = new DeloadPosition('LAST', 2, 'last');
  if (Companion_instance_24 == null) {
    Companion_instance_0;
    new Companion_22();
  }
}
var DeloadPosition_NONE_instance;
var DeloadPosition_FIRST_instance;
var DeloadPosition_LAST_instance;
function Companion_22() {
}
protoOf(Companion_22).h1f = function (key) {
  var tmp0 = get_entries_38();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.f1t_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? DeloadPosition_NONE_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_24;
function Companion_getInstance_21() {
  return Companion_instance_24;
}
function values_43() {
  static_init_64();
  return [DeloadPosition_NONE_getInstance(), DeloadPosition_FIRST_getInstance(), DeloadPosition_LAST_getInstance()];
}
function get_entries_38() {
  static_init_64();
  if ($ENTRIES_38 == null)
    $ENTRIES_38 = enumEntries(values_43());
  return $ENTRIES_38;
}
var $ENTRIES_38;
function DeloadPosition(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.f1t_1 = key;
}
var static_init_called_65;
function static_init_65() {
  if (static_init_called_65)
    return Unit_instance;
  static_init_called_65 = true;
  MovementPattern_SQUAT_instance = new MovementPattern('SQUAT', 0, 'squat');
  MovementPattern_HINGE_instance = new MovementPattern('HINGE', 1, 'hinge');
  MovementPattern_HORIZONTAL_PUSH_instance = new MovementPattern('HORIZONTAL_PUSH', 2, 'horizontalPush');
  MovementPattern_VERTICAL_PUSH_instance = new MovementPattern('VERTICAL_PUSH', 3, 'verticalPush');
  MovementPattern_HORIZONTAL_PULL_instance = new MovementPattern('HORIZONTAL_PULL', 4, 'horizontalPull');
  MovementPattern_VERTICAL_PULL_instance = new MovementPattern('VERTICAL_PULL', 5, 'verticalPull');
  if (Companion_instance_25 == null) {
    Companion_instance_0;
    new Companion_23();
  }
}
var MovementPattern_SQUAT_instance;
var MovementPattern_HINGE_instance;
var MovementPattern_HORIZONTAL_PUSH_instance;
var MovementPattern_VERTICAL_PUSH_instance;
var MovementPattern_HORIZONTAL_PULL_instance;
var MovementPattern_VERTICAL_PULL_instance;
function Companion_23() {
}
protoOf(Companion_23).h1f = function (key) {
  var tmp0 = get_entries_39();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.i1t_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_25;
function Companion_getInstance_22() {
  return Companion_instance_25;
}
function values_44() {
  static_init_65();
  return [MovementPattern_SQUAT_getInstance(), MovementPattern_HINGE_getInstance(), MovementPattern_HORIZONTAL_PUSH_getInstance(), MovementPattern_VERTICAL_PUSH_getInstance(), MovementPattern_HORIZONTAL_PULL_getInstance(), MovementPattern_VERTICAL_PULL_getInstance()];
}
function get_entries_39() {
  static_init_65();
  if ($ENTRIES_39 == null)
    $ENTRIES_39 = enumEntries(values_44());
  return $ENTRIES_39;
}
var $ENTRIES_39;
function MovementPattern(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.i1t_1 = key;
}
var static_init_called_66;
function static_init_66() {
  if (static_init_called_66)
    return Unit_instance;
  static_init_called_66 = true;
  ExerciseSlot_PRIMARY_instance = new ExerciseSlot('PRIMARY', 0, 'primary');
  ExerciseSlot_SECONDARY_instance = new ExerciseSlot('SECONDARY', 1, 'secondary');
  ExerciseSlot_ACCESSORY_instance = new ExerciseSlot('ACCESSORY', 2, 'accessory');
  if (Companion_instance_26 == null) {
    Companion_instance_0;
    new Companion_24();
  }
}
var ExerciseSlot_PRIMARY_instance;
var ExerciseSlot_SECONDARY_instance;
var ExerciseSlot_ACCESSORY_instance;
function Companion_24() {
}
protoOf(Companion_24).h1f = function (key) {
  var tmp0 = get_entries_40();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.l1t_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_26;
function Companion_getInstance_23() {
  return Companion_instance_26;
}
function values_45() {
  static_init_66();
  return [ExerciseSlot_PRIMARY_getInstance(), ExerciseSlot_SECONDARY_getInstance(), ExerciseSlot_ACCESSORY_getInstance()];
}
function get_entries_40() {
  static_init_66();
  if ($ENTRIES_40 == null)
    $ENTRIES_40 = enumEntries(values_45());
  return $ENTRIES_40;
}
var $ENTRIES_40;
function ExerciseSlot(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.l1t_1 = key;
}
function Exercise(id, name, equipment, primaryMuscles, secondaryMuscles, mechanic, force, category, bodyweightFactor, hidden, region, family, exclusionGroups, rank, preconditions, pattern, unilateral) {
  secondaryMuscles = secondaryMuscles === VOID ? emptyList() : secondaryMuscles;
  mechanic = mechanic === VOID ? null : mechanic;
  force = force === VOID ? null : force;
  category = category === VOID ? 'strength' : category;
  bodyweightFactor = bodyweightFactor === VOID ? 0.0 : bodyweightFactor;
  hidden = hidden === VOID ? false : hidden;
  region = region === VOID ? null : region;
  family = family === VOID ? null : family;
  exclusionGroups = exclusionGroups === VOID ? emptyList() : exclusionGroups;
  rank = rank === VOID ? emptyMap() : rank;
  preconditions = preconditions === VOID ? emptyList() : preconditions;
  pattern = pattern === VOID ? null : pattern;
  unilateral = unilateral === VOID ? false : unilateral;
  this.s1b_1 = id;
  this.t1b_1 = name;
  this.u1b_1 = equipment;
  this.v1b_1 = primaryMuscles;
  this.w1b_1 = secondaryMuscles;
  this.x1b_1 = mechanic;
  this.y1b_1 = force;
  this.z1b_1 = category;
  this.a1c_1 = bodyweightFactor;
  this.b1c_1 = hidden;
  this.c1c_1 = region;
  this.d1c_1 = family;
  this.e1c_1 = exclusionGroups;
  this.f1c_1 = rank;
  this.g1c_1 = preconditions;
  this.h1c_1 = pattern;
  this.i1c_1 = unilateral;
}
protoOf(Exercise).toString = function () {
  return 'Exercise(id=' + this.s1b_1 + ', name=' + this.t1b_1 + ', equipment=' + this.u1b_1.toString() + ', primaryMuscles=' + toString(this.v1b_1) + ', secondaryMuscles=' + toString(this.w1b_1) + ', mechanic=' + toString_0(this.x1b_1) + ', force=' + toString_0(this.y1b_1) + ', category=' + this.z1b_1 + ', bodyweightFactor=' + this.a1c_1 + ', hidden=' + this.b1c_1 + ', region=' + toString_0(this.c1c_1) + ', family=' + this.d1c_1 + ', exclusionGroups=' + toString(this.e1c_1) + ', rank=' + toString(this.f1c_1) + ', preconditions=' + toString(this.g1c_1) + ', pattern=' + toString_0(this.h1c_1) + ', unilateral=' + this.i1c_1 + ')';
};
protoOf(Exercise).hashCode = function () {
  var result = getStringHashCode(this.s1b_1);
  result = imul(result, 31) + getStringHashCode(this.t1b_1) | 0;
  result = imul(result, 31) + this.u1b_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.v1b_1) | 0;
  result = imul(result, 31) + hashCode(this.w1b_1) | 0;
  result = imul(result, 31) + (this.x1b_1 == null ? 0 : this.x1b_1.hashCode()) | 0;
  result = imul(result, 31) + (this.y1b_1 == null ? 0 : this.y1b_1.hashCode()) | 0;
  result = imul(result, 31) + getStringHashCode(this.z1b_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a1c_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.b1c_1) | 0;
  result = imul(result, 31) + (this.c1c_1 == null ? 0 : this.c1c_1.hashCode()) | 0;
  result = imul(result, 31) + (this.d1c_1 == null ? 0 : getStringHashCode(this.d1c_1)) | 0;
  result = imul(result, 31) + hashCode(this.e1c_1) | 0;
  result = imul(result, 31) + hashCode(this.f1c_1) | 0;
  result = imul(result, 31) + hashCode(this.g1c_1) | 0;
  result = imul(result, 31) + (this.h1c_1 == null ? 0 : this.h1c_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i1c_1) | 0;
  return result;
};
protoOf(Exercise).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Exercise))
    return false;
  if (!(this.s1b_1 === other.s1b_1))
    return false;
  if (!(this.t1b_1 === other.t1b_1))
    return false;
  if (!this.u1b_1.equals(other.u1b_1))
    return false;
  if (!equals(this.v1b_1, other.v1b_1))
    return false;
  if (!equals(this.w1b_1, other.w1b_1))
    return false;
  if (!equals(this.x1b_1, other.x1b_1))
    return false;
  if (!equals(this.y1b_1, other.y1b_1))
    return false;
  if (!(this.z1b_1 === other.z1b_1))
    return false;
  if (!equals(this.a1c_1, other.a1c_1))
    return false;
  if (!(this.b1c_1 === other.b1c_1))
    return false;
  if (!equals(this.c1c_1, other.c1c_1))
    return false;
  if (!(this.d1c_1 == other.d1c_1))
    return false;
  if (!equals(this.e1c_1, other.e1c_1))
    return false;
  if (!equals(this.f1c_1, other.f1c_1))
    return false;
  if (!equals(this.g1c_1, other.g1c_1))
    return false;
  if (!equals(this.h1c_1, other.h1c_1))
    return false;
  if (!(this.i1c_1 === other.i1c_1))
    return false;
  return true;
};
function ExerciseCatalogue() {
}
protoOf(ExerciseCatalogue).ng = function (json) {
  var root = Json_instance.ng(json);
  var tmp;
  if (!(root == null) ? isInterface(root, KtMap) : false) {
    var tmp_0 = JsonRead_instance;
    // Inline function 'kotlin.collections.get' call
    var key = 'exercises';
    var tmp$ret$0 = (isInterface(root, KtMap) ? root : THROW_CCE()).t1(key);
    tmp = tmp_0.rr(tmp$ret$0);
  } else {
    tmp = JsonRead_instance.rr(root);
  }
  var items = tmp;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = items.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$5;
    $l$block: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$5 = null;
        break $l$block;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var map = tmp_1;
      var tmp_2 = ExerciseCatalogue_instance;
      tmp$ret$5 = tmp_2.q1g(isInterface(map, KtMap) ? map : THROW_CCE());
    }
    var tmp0_safe_receiver = tmp$ret$5;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
};
protoOf(ExerciseCatalogue).q1g = function (map) {
  var tmp0_safe_receiver = JsonRead_instance.br(map, 'id');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(tmp0_safe_receiver)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var id = tmp_1;
  var tmp2_safe_receiver = JsonRead_instance.br(map, 'name');
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(tmp2_safe_receiver)) {
      tmp_3 = tmp2_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var name = tmp_4;
  var tmp_5 = Companion_instance_18.h1f(JsonRead_instance.br(map, 'equipment'));
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.h14(map, 'primaryMuscles');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver_0 = Companion_instance_17.b1g(element);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_6 = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = JsonRead_instance.h14(map, 'secondaryMuscles');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = tmp0_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver_1 = Companion_instance_17.b1g(element_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_1);
    }
  }
  var tmp_7 = destination_0;
  var tmp_8 = Companion_instance_21.h1f(JsonRead_instance.br(map, 'mechanic'));
  var tmp_9 = Companion_instance_22.h1f(JsonRead_instance.br(map, 'force'));
  var tmp4_elvis_lhs = JsonRead_instance.br(map, 'category');
  var tmp_10 = tmp4_elvis_lhs == null ? 'strength' : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = JsonRead_instance.cr(map, 'bodyweightFactor');
  var tmp_11 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
  var tmp6_elvis_lhs = JsonRead_instance.tr(map, 'hidden');
  var tmp_12 = tmp6_elvis_lhs == null ? false : tmp6_elvis_lhs;
  var tmp_13 = Companion_getInstance_13().h1f(JsonRead_instance.br(map, 'region'));
  var tmp_14 = JsonRead_instance.br(map, 'family');
  var tmp_15 = JsonRead_instance.h14(map, 'exclusionGroups');
  var tmp_16 = this.m1t(map.t1('rank'));
  var tmp_17 = JsonRead_instance.h14(map, 'preconditions');
  var tmp_18 = Companion_instance_25.h1f(JsonRead_instance.br(map, 'pattern'));
  var tmp7_elvis_lhs = JsonRead_instance.tr(map, 'unilateral');
  return new Exercise(id, name, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp7_elvis_lhs == null ? false : tmp7_elvis_lhs);
};
protoOf(ExerciseCatalogue).m1t = function (value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return emptyMap();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var byGoal = tmp;
  var result = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = byGoal.w1().j();
  $l$loop: while (_iterator__ex2g4s.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var goalKey = _destruct__k2r9zo.p1();
    // Inline function 'kotlin.collections.component2' call
    var slots = _destruct__k2r9zo.q1();
    var tmp0 = get_entries_37();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element = _iterator__ex2g4s_0.l();
        if (equals(element.c1t_1, goalKey)) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$3;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var goal = tmp_0;
    var tmp2_safe_receiver = (!(slots == null) ? isInterface(slots, KtMap) : false) ? slots : null;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w1();
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = tmp3_safe_receiver.j();
      while (_iterator__ex2g4s_1.k()) {
        var element_0 = _iterator__ex2g4s_1.l();
        var tmp$ret$9;
        $l$block_1: {
          // Inline function 'kotlin.collections.component1' call
          var slotKey = element_0.p1();
          // Inline function 'kotlin.collections.component2' call
          var rank = element_0.q1();
          var tmp_2 = Companion_instance_26;
          var tmp0_elvis_lhs_0 = tmp_2.h1f((!(slotKey == null) ? typeof slotKey === 'string' : false) ? slotKey : null);
          var tmp_3;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$9 = null;
            break $l$block_1;
          } else {
            tmp_3 = tmp0_elvis_lhs_0;
          }
          var slot = tmp_3;
          var tmp1_safe_receiver = isNumber(rank) ? rank : null;
          var tmp2_safe_receiver_0 = tmp1_safe_receiver == null ? null : numberToDouble(tmp1_safe_receiver);
          var tmp_4;
          if (tmp2_safe_receiver_0 == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_5;
            if (1.0 <= tmp2_safe_receiver_0 ? tmp2_safe_receiver_0 <= 9.0 : false) {
              tmp_5 = tmp2_safe_receiver_0;
            } else {
              tmp_5 = null;
            }
            tmp_4 = tmp_5;
          }
          var tmp3_elvis_lhs = tmp_4;
          var tmp_6;
          if (tmp3_elvis_lhs == null) {
            tmp$ret$9 = null;
            break $l$block_1;
          } else {
            tmp_6 = tmp3_elvis_lhs;
          }
          var level = tmp_6;
          tmp$ret$9 = to(slot, level);
        }
        var tmp0_safe_receiver = tmp$ret$9;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.f(tmp0_safe_receiver);
        }
      }
      tmp_1 = destination;
    }
    var tmp4_safe_receiver = tmp_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs_1 = tmp4_safe_receiver == null ? null : toMap(tmp4_safe_receiver);
    var bySlot = tmp0_elvis_lhs_1 == null ? emptyMap() : tmp0_elvis_lhs_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!bySlot.m()) {
      // Inline function 'kotlin.collections.set' call
      result.l2(goal, bySlot);
    }
  }
  return result;
};
var ExerciseCatalogue_instance;
function ExerciseCatalogue_getInstance() {
  return ExerciseCatalogue_instance;
}
function Muscle_CHEST_getInstance() {
  static_init_57();
  return Muscle_CHEST_instance;
}
function Muscle_SHOULDERS_getInstance() {
  static_init_57();
  return Muscle_SHOULDERS_instance;
}
function Muscle_TRICEPS_getInstance() {
  static_init_57();
  return Muscle_TRICEPS_instance;
}
function Muscle_BICEPS_getInstance() {
  static_init_57();
  return Muscle_BICEPS_instance;
}
function Muscle_FOREARMS_getInstance() {
  static_init_57();
  return Muscle_FOREARMS_instance;
}
function Muscle_LATS_getInstance() {
  static_init_57();
  return Muscle_LATS_instance;
}
function Muscle_MIDDLE_BACK_getInstance() {
  static_init_57();
  return Muscle_MIDDLE_BACK_instance;
}
function Muscle_LOWER_BACK_getInstance() {
  static_init_57();
  return Muscle_LOWER_BACK_instance;
}
function Muscle_TRAPS_getInstance() {
  static_init_57();
  return Muscle_TRAPS_instance;
}
function Muscle_ABDOMINALS_getInstance() {
  static_init_57();
  return Muscle_ABDOMINALS_instance;
}
function Muscle_QUADRICEPS_getInstance() {
  static_init_57();
  return Muscle_QUADRICEPS_instance;
}
function Muscle_HAMSTRINGS_getInstance() {
  static_init_57();
  return Muscle_HAMSTRINGS_instance;
}
function Muscle_GLUTES_getInstance() {
  static_init_57();
  return Muscle_GLUTES_instance;
}
function Muscle_CALVES_getInstance() {
  static_init_57();
  return Muscle_CALVES_instance;
}
function Muscle_ADDUCTORS_getInstance() {
  static_init_57();
  return Muscle_ADDUCTORS_instance;
}
function Muscle_ABDUCTORS_getInstance() {
  static_init_57();
  return Muscle_ABDUCTORS_instance;
}
function Muscle_NECK_getInstance() {
  static_init_57();
  return Muscle_NECK_instance;
}
function Equipment_BARBELL_getInstance() {
  static_init_58();
  return Equipment_BARBELL_instance;
}
function Equipment_DUMBBELL_getInstance() {
  static_init_58();
  return Equipment_DUMBBELL_instance;
}
function Equipment_MACHINE_getInstance() {
  static_init_58();
  return Equipment_MACHINE_instance;
}
function Equipment_CABLE_getInstance() {
  static_init_58();
  return Equipment_CABLE_instance;
}
function Equipment_KETTLEBELL_getInstance() {
  static_init_58();
  return Equipment_KETTLEBELL_instance;
}
function Equipment_BODYWEIGHT_getInstance() {
  static_init_58();
  return Equipment_BODYWEIGHT_instance;
}
function Equipment_BAND_getInstance() {
  static_init_58();
  return Equipment_BAND_instance;
}
function Equipment_SMITH_getInstance() {
  static_init_58();
  return Equipment_SMITH_instance;
}
function Equipment_OTHER_getInstance() {
  static_init_58();
  return Equipment_OTHER_instance;
}
function SetType_STANDARD_getInstance() {
  static_init_59();
  return SetType_STANDARD_instance;
}
function SetType_WARMUP_getInstance() {
  static_init_59();
  return SetType_WARMUP_instance;
}
function SetType_DROP_getInstance() {
  static_init_59();
  return SetType_DROP_instance;
}
function SetType_MYO_getInstance() {
  static_init_59();
  return SetType_MYO_instance;
}
function SetType_FAILURE_getInstance() {
  static_init_59();
  return SetType_FAILURE_instance;
}
function ProgressionScheme_DOUBLE_getInstance() {
  static_init_60();
  return ProgressionScheme_DOUBLE_instance;
}
function ProgressionScheme_LINEAR_getInstance() {
  static_init_60();
  return ProgressionScheme_LINEAR_instance;
}
function ProgressionScheme_REVERSE_LINEAR_getInstance() {
  static_init_60();
  return ProgressionScheme_REVERSE_LINEAR_instance;
}
function ProgressionScheme_UNDULATING_getInstance() {
  static_init_60();
  return ProgressionScheme_UNDULATING_instance;
}
function ProgressionScheme_STATIC_getInstance() {
  static_init_60();
  return ProgressionScheme_STATIC_instance;
}
function Mechanic_COMPOUND_getInstance() {
  static_init_61();
  return Mechanic_COMPOUND_instance;
}
function Mechanic_ISOLATION_getInstance() {
  static_init_61();
  return Mechanic_ISOLATION_instance;
}
function Force_PUSH_getInstance() {
  static_init_62();
  return Force_PUSH_instance;
}
function Force_PULL_getInstance() {
  static_init_62();
  return Force_PULL_instance;
}
function Force_STATIC_getInstance() {
  static_init_62();
  return Force_STATIC_instance;
}
function TrainingGoal_STRENGTH_getInstance() {
  static_init_63();
  return TrainingGoal_STRENGTH_instance;
}
function TrainingGoal_HYPERTROPHY_getInstance() {
  static_init_63();
  return TrainingGoal_HYPERTROPHY_instance;
}
function DeloadPosition_NONE_getInstance() {
  static_init_64();
  return DeloadPosition_NONE_instance;
}
function DeloadPosition_FIRST_getInstance() {
  static_init_64();
  return DeloadPosition_FIRST_instance;
}
function DeloadPosition_LAST_getInstance() {
  static_init_64();
  return DeloadPosition_LAST_instance;
}
function MovementPattern_SQUAT_getInstance() {
  static_init_65();
  return MovementPattern_SQUAT_instance;
}
function MovementPattern_HINGE_getInstance() {
  static_init_65();
  return MovementPattern_HINGE_instance;
}
function MovementPattern_HORIZONTAL_PUSH_getInstance() {
  static_init_65();
  return MovementPattern_HORIZONTAL_PUSH_instance;
}
function MovementPattern_VERTICAL_PUSH_getInstance() {
  static_init_65();
  return MovementPattern_VERTICAL_PUSH_instance;
}
function MovementPattern_HORIZONTAL_PULL_getInstance() {
  static_init_65();
  return MovementPattern_HORIZONTAL_PULL_instance;
}
function MovementPattern_VERTICAL_PULL_getInstance() {
  static_init_65();
  return MovementPattern_VERTICAL_PULL_instance;
}
function ExerciseSlot_PRIMARY_getInstance() {
  static_init_66();
  return ExerciseSlot_PRIMARY_instance;
}
function ExerciseSlot_SECONDARY_getInstance() {
  static_init_66();
  return ExerciseSlot_SECONDARY_instance;
}
function ExerciseSlot_ACCESSORY_getInstance() {
  static_init_66();
  return ExerciseSlot_ACCESSORY_instance;
}
function TrainingSet(workoutId, day, exerciseId, order, type, loadKg, reps, rir, bodyweightKg) {
  rir = rir === VOID ? null : rir;
  bodyweightKg = bodyweightKg === VOID ? null : bodyweightKg;
  this.o1c_1 = workoutId;
  this.p1c_1 = day;
  this.q1c_1 = exerciseId;
  this.r1c_1 = order;
  this.s1c_1 = type;
  this.t1c_1 = loadKg;
  this.u1c_1 = reps;
  this.v1c_1 = rir;
  this.w1c_1 = bodyweightKg;
}
protoOf(TrainingSet).toString = function () {
  return 'TrainingSet(workoutId=' + this.o1c_1 + ', day=' + this.p1c_1 + ', exerciseId=' + this.q1c_1 + ', order=' + this.r1c_1 + ', type=' + this.s1c_1.toString() + ', loadKg=' + this.t1c_1 + ', reps=' + this.u1c_1 + ', rir=' + this.v1c_1 + ', bodyweightKg=' + this.w1c_1 + ')';
};
protoOf(TrainingSet).hashCode = function () {
  var result = getStringHashCode(this.o1c_1);
  result = imul(result, 31) + this.p1c_1 | 0;
  result = imul(result, 31) + getStringHashCode(this.q1c_1) | 0;
  result = imul(result, 31) + this.r1c_1 | 0;
  result = imul(result, 31) + this.s1c_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.t1c_1) | 0;
  result = imul(result, 31) + this.u1c_1 | 0;
  result = imul(result, 31) + (this.v1c_1 == null ? 0 : this.v1c_1) | 0;
  result = imul(result, 31) + (this.w1c_1 == null ? 0 : getNumberHashCode(this.w1c_1)) | 0;
  return result;
};
protoOf(TrainingSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingSet))
    return false;
  if (!(this.o1c_1 === other.o1c_1))
    return false;
  if (!(this.p1c_1 === other.p1c_1))
    return false;
  if (!(this.q1c_1 === other.q1c_1))
    return false;
  if (!(this.r1c_1 === other.r1c_1))
    return false;
  if (!this.s1c_1.equals(other.s1c_1))
    return false;
  if (!equals(this.t1c_1, other.t1c_1))
    return false;
  if (!(this.u1c_1 === other.u1c_1))
    return false;
  if (!(this.v1c_1 == other.v1c_1))
    return false;
  if (!equals(this.w1c_1, other.w1c_1))
    return false;
  return true;
};
function RepMaxPoint(day, workoutId, kg) {
  this.l1c_1 = day;
  this.m1c_1 = workoutId;
  this.n1c_1 = kg;
}
protoOf(RepMaxPoint).toString = function () {
  return 'RepMaxPoint(day=' + this.l1c_1 + ', workoutId=' + this.m1c_1 + ', kg=' + this.n1c_1 + ')';
};
protoOf(RepMaxPoint).hashCode = function () {
  var result = this.l1c_1;
  result = imul(result, 31) + getStringHashCode(this.m1c_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.n1c_1) | 0;
  return result;
};
protoOf(RepMaxPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RepMaxPoint))
    return false;
  if (!(this.l1c_1 === other.l1c_1))
    return false;
  if (!(this.m1c_1 === other.m1c_1))
    return false;
  if (!equals(this.n1c_1, other.n1c_1))
    return false;
  return true;
};
function WorkoutVolume(workoutId, day, sets, reps, externalVolumeKg, bodyweightVolumeKg) {
  this.n1t_1 = workoutId;
  this.o1t_1 = day;
  this.p1t_1 = sets;
  this.q1t_1 = reps;
  this.r1t_1 = externalVolumeKg;
  this.s1t_1 = bodyweightVolumeKg;
}
protoOf(WorkoutVolume).toString = function () {
  return 'WorkoutVolume(workoutId=' + this.n1t_1 + ', day=' + this.o1t_1 + ', sets=' + this.p1t_1 + ', reps=' + this.q1t_1 + ', externalVolumeKg=' + this.r1t_1 + ', bodyweightVolumeKg=' + this.s1t_1 + ')';
};
protoOf(WorkoutVolume).hashCode = function () {
  var result = getStringHashCode(this.n1t_1);
  result = imul(result, 31) + this.o1t_1 | 0;
  result = imul(result, 31) + this.p1t_1 | 0;
  result = imul(result, 31) + this.q1t_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.s1t_1) | 0;
  return result;
};
protoOf(WorkoutVolume).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WorkoutVolume))
    return false;
  if (!(this.n1t_1 === other.n1t_1))
    return false;
  if (!(this.o1t_1 === other.o1t_1))
    return false;
  if (!(this.p1t_1 === other.p1t_1))
    return false;
  if (!(this.q1t_1 === other.q1t_1))
    return false;
  if (!equals(this.r1t_1, other.r1t_1))
    return false;
  if (!equals(this.s1t_1, other.s1t_1))
    return false;
  return true;
};
function WeeklyVolume(weekStart, workouts, sets, reps, externalVolumeKg, bodyweightVolumeKg) {
  this.t1t_1 = weekStart;
  this.u1t_1 = workouts;
  this.v1t_1 = sets;
  this.w1t_1 = reps;
  this.x1t_1 = externalVolumeKg;
  this.y1t_1 = bodyweightVolumeKg;
}
protoOf(WeeklyVolume).toString = function () {
  return 'WeeklyVolume(weekStart=' + this.t1t_1 + ', workouts=' + this.u1t_1 + ', sets=' + this.v1t_1 + ', reps=' + this.w1t_1 + ', externalVolumeKg=' + this.x1t_1 + ', bodyweightVolumeKg=' + this.y1t_1 + ')';
};
protoOf(WeeklyVolume).hashCode = function () {
  var result = this.t1t_1;
  result = imul(result, 31) + this.u1t_1 | 0;
  result = imul(result, 31) + this.v1t_1 | 0;
  result = imul(result, 31) + this.w1t_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.x1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.y1t_1) | 0;
  return result;
};
protoOf(WeeklyVolume).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyVolume))
    return false;
  if (!(this.t1t_1 === other.t1t_1))
    return false;
  if (!(this.u1t_1 === other.u1t_1))
    return false;
  if (!(this.v1t_1 === other.v1t_1))
    return false;
  if (!(this.w1t_1 === other.w1t_1))
    return false;
  if (!equals(this.x1t_1, other.x1t_1))
    return false;
  if (!equals(this.y1t_1, other.y1t_1))
    return false;
  return true;
};
var static_init_called_67;
function static_init_67() {
  if (static_init_called_67)
    return Unit_instance;
  static_init_called_67 = true;
  LevelsWindow_WEEK_instance = new LevelsWindow('WEEK', 0, 7);
  LevelsWindow_MONTH_instance = new LevelsWindow('MONTH', 1, 28);
  LevelsWindow_THREE_MONTHS_instance = new LevelsWindow('THREE_MONTHS', 2, 91);
}
var LevelsWindow_WEEK_instance;
var LevelsWindow_MONTH_instance;
var LevelsWindow_THREE_MONTHS_instance;
function LevelsWindow(name, ordinal, days) {
  Enum.call(this, name, ordinal);
  this.s1j_1 = days;
}
function working($this, sets) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.s1c_1.equals(SetType_WARMUP_getInstance()) && element.u1c_1 > 0) {
      destination.f(element);
    }
  }
  return destination;
}
function bodyweightShare($this, set, factor) {
  var tmp0_elvis_lhs = set.w1c_1;
  // Inline function 'kotlin.math.max' call
  var b = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) * factor;
  return Math.max(0.0, b);
}
function oneRepMax_1($this, set, factor, k) {
  return oneRepMax_2($this, set, factor, new EpleyCurve(k));
}
function oneRepMax_2($this, set, factor, curve) {
  var load = set.t1c_1 + bodyweightShare($this, set, factor);
  if (load <= 0.0 || set.u1c_1 <= 0)
    return null;
  var tmp0_elvis_lhs = set.v1c_1;
  // Inline function 'kotlin.math.max' call
  var b = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp$ret$0 = Math.max(0, b);
  return curve.j1q(load, set.u1c_1 + tmp$ret$0 | 0);
}
function sam$kotlin_Comparator$0_16(function_0) {
  this.z1t_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_16).ea = function (a, b) {
  return this.z1t_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_16).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_16).h2 = function () {
  return this.z1t_1;
};
protoOf(sam$kotlin_Comparator$0_16).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_16).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_17(function_0) {
  this.a1u_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_17).ea = function (a, b) {
  return this.a1u_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_17).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_17).h2 = function () {
  return this.a1u_1;
};
protoOf(sam$kotlin_Comparator$0_17).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_17).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_18(function_0) {
  this.b1u_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_18).ea = function (a, b) {
  return this.b1u_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_18).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_18).h2 = function () {
  return this.b1u_1;
};
protoOf(sam$kotlin_Comparator$0_18).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_18).hashCode = function () {
  return hashCode(this.h2());
};
function sam$kotlin_Comparator$0_19(function_0) {
  this.c1u_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_19).ea = function (a, b) {
  return this.c1u_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_19).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_19).h2 = function () {
  return this.c1u_1;
};
protoOf(sam$kotlin_Comparator$0_19).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_19).hashCode = function () {
  return hashCode(this.h2());
};
function TrainingAnalytics$repMaxSeries$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.l1c_1;
  var tmp$ret$2 = b.l1c_1;
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics$repMaxSeries$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.m1c_1;
      var tmp$ret$2 = b.m1c_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function TrainingAnalytics$workoutVolumes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1t_1;
  var tmp$ret$2 = b.o1t_1;
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics$workoutVolumes$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.n1t_1;
      var tmp$ret$2 = b.n1t_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function TrainingAnalytics$weeklyVolumes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.p1();
  var tmp$ret$2 = b.p1();
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics$strengthIndex$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.p1();
  var tmp$ret$2 = b.p1();
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics() {
  this.j1c_1 = 28;
}
protoOf(TrainingAnalytics).d1u = function (oneRepMaxKg, targetReps, k, curve) {
  // Inline function 'kotlin.require' call
  if (!(targetReps >= 1)) {
    var message = 'targetReps must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return targetReps === 1 ? oneRepMaxKg : curve.x1q(oneRepMaxKg, targetReps);
};
protoOf(TrainingAnalytics).e1u = function (oneRepMaxKg, targetReps, k, curve, $super) {
  k = k === VOID ? 30.0 : k;
  curve = curve === VOID ? new EpleyCurve(k) : curve;
  return $super === VOID ? this.d1u(oneRepMaxKg, targetReps, k, curve) : $super.d1u.call(this, oneRepMaxKg, targetReps, k, curve);
};
protoOf(TrainingAnalytics).f1u = function (sets, exerciseId, targetReps, bodyweightFactor, k, curve) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = working(this, sets);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.q1c_1 === exerciseId) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.o1c_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$13;
    $l$block: {
      // Inline function 'kotlin.collections.component1' call
      var workoutId = element_1.p1();
      // Inline function 'kotlin.collections.component2' call
      var session = element_1.q1();
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = session.j();
      while (_iterator__ex2g4s_2.k()) {
        var element_2 = _iterator__ex2g4s_2.l();
        var tmp0_safe_receiver = oneRepMax_2(TrainingAnalytics_instance, element_2, bodyweightFactor, curve);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_2.f(tmp0_safe_receiver);
        }
      }
      var tmp0_elvis_lhs = maxOrNull(destination_2);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$13 = null;
        break $l$block;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var best = tmp_0;
      // Inline function 'kotlin.collections.minOf' call
      var iterator = session.j();
      if (!iterator.k())
        throw NoSuchElementException_init_$Create$_0();
      var minValue = iterator.l().p1c_1;
      while (iterator.k()) {
        var v = iterator.l().p1c_1;
        if (compareTo(minValue, v) > 0) {
          minValue = v;
        }
      }
      var tmp$ret$23 = minValue;
      tmp$ret$13 = new RepMaxPoint(tmp$ret$23, workoutId, TrainingAnalytics_instance.e1u(best, targetReps, VOID, curve));
    }
    var tmp0_safe_receiver_0 = tmp$ret$13;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_1 = destination_1;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_2 = TrainingAnalytics$repMaxSeries$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_16(tmp_2);
  var tmp_3 = TrainingAnalytics$repMaxSeries$lambda_0(this_0);
  var tmp$ret$29 = new sam$kotlin_Comparator$0_16(tmp_3);
  return sortedWith(tmp_1, tmp$ret$29);
};
protoOf(TrainingAnalytics).k1c = function (sets, exerciseId, targetReps, bodyweightFactor, k, curve, $super) {
  targetReps = targetReps === VOID ? 1 : targetReps;
  bodyweightFactor = bodyweightFactor === VOID ? 0.0 : bodyweightFactor;
  k = k === VOID ? 30.0 : k;
  curve = curve === VOID ? new EpleyCurve(k) : curve;
  return $super === VOID ? this.f1u(sets, exerciseId, targetReps, bodyweightFactor, k, curve) : $super.f1u.call(this, sets, exerciseId, targetReps, bodyweightFactor, k, curve);
};
protoOf(TrainingAnalytics).g1u = function (sets, exercises) {
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0 = working(this, sets);
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = element.o1c_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(destination.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = destination.w1().j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var workoutId = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var workout = item.q1();
    // Inline function 'kotlin.collections.minOf' call
    var iterator = workout.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$_0();
    var minValue = iterator.l().p1c_1;
    while (iterator.k()) {
      var v = iterator.l().p1c_1;
      if (compareTo(minValue, v) > 0) {
        minValue = v;
      }
    }
    var tmp_0 = minValue;
    var tmp_1 = workout.o();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = workout.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var tmp_2 = sum;
      sum = tmp_2 + element_0.u1c_1 | 0;
    }
    var tmp_3 = sum;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = workout.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_4 = sum_0;
      sum_0 = tmp_4 + element_1.t1c_1 * element_1.u1c_1;
    }
    var tmp_5 = sum_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_3 = workout.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      var tmp_6 = sum_1;
      var tmp_7 = TrainingAnalytics_instance;
      var tmp0_safe_receiver = exercises.t1(element_2.q1c_1);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1c_1;
      sum_1 = tmp_6 + bodyweightShare(tmp_7, element_2, tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) * element_2.u1c_1;
    }
    var tmp$ret$18 = sum_1;
    var tmp$ret$8 = new WorkoutVolume(workoutId, tmp_0, tmp_1, tmp_3, tmp_5, tmp$ret$18);
    destination_0.f(tmp$ret$8);
  }
  var tmp_8 = destination_0;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_9 = TrainingAnalytics$workoutVolumes$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_17(tmp_9);
  var tmp_10 = TrainingAnalytics$workoutVolumes$lambda_0(this_0);
  var tmp$ret$21 = new sam$kotlin_Comparator$0_17(tmp_10);
  return sortedWith(tmp_8, tmp$ret$21);
};
protoOf(TrainingAnalytics).h1u = function (sets, exercises) {
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0 = this.g1u(sets, exercises);
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = EpochDays_getInstance().ge(element.o1t_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination.w1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = TrainingAnalytics$weeklyVolumes$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_18(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$6);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var start = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var workouts = item.q1();
    var tmp_1 = workouts.o();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = workouts.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var tmp_2 = sum;
      sum = tmp_2 + element_0.p1t_1 | 0;
    }
    var tmp_3 = sum;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = workouts.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_4 = sum_0;
      sum_0 = tmp_4 + element_1.q1t_1 | 0;
    }
    var tmp_5 = sum_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_3 = workouts.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      var tmp_6 = sum_1;
      sum_1 = tmp_6 + element_2.r1t_1;
    }
    var tmp_7 = sum_1;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_2 = 0;
    var _iterator__ex2g4s_4 = workouts.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      var tmp_8 = sum_2;
      sum_2 = tmp_8 + element_3.s1t_1;
    }
    var tmp$ret$18 = sum_2;
    var tmp$ret$9 = new WeeklyVolume(start, tmp_1, tmp_3, tmp_5, tmp_7, tmp$ret$18);
    destination_0.f(tmp$ret$9);
  }
  return destination_0;
};
protoOf(TrainingAnalytics).n1j = function (sets, exercises, today, windowDays) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var totals = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = get_entries_31().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.set' call
    totals.l2(element, 0.0);
  }
  var _iterator__ex2g4s_0 = working(this, sets).j();
  $l$loop_0: while (_iterator__ex2g4s_0.k()) {
    var set = _iterator__ex2g4s_0.l();
    if (set.p1c_1 > today || set.p1c_1 <= (today - windowDays | 0))
      continue $l$loop_0;
    var tmp0_elvis_lhs = exercises.t1(set.q1c_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var exercise = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = exercise.v1b_1.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      // Inline function 'kotlin.collections.set' call
      var value = getValue(totals, element_0) + 1.0;
      totals.l2(element_0, value);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = exercise.w1b_1.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.collections.set' call
      var value_0 = getValue(totals, element_1) + 0.5;
      totals.l2(element_1, value_0);
    }
  }
  var weeks = windowDays / 7.0;
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap_init_$Create$(mapCapacity(totals.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_3 = totals.w1().j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    var tmp_0 = element_2.p1();
    var tmp$ret$15 = element_2.q1() / weeks;
    destination.l2(tmp_0, tmp$ret$15);
  }
  return destination;
};
protoOf(TrainingAnalytics).i1u = function (sets, today, windowDays) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0 = working(this, sets);
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.p1c_1 <= today && element.p1c_1 > (today - windowDays | 0)) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$2 = count;
  }
  return tmp$ret$2 / (windowDays / 7.0);
};
protoOf(TrainingAnalytics).j1u = function (sets, today, windowDays, $super) {
  windowDays = windowDays === VOID ? 28 : windowDays;
  return $super === VOID ? this.i1u(sets, today, windowDays) : $super.i1u.call(this, sets, today, windowDays);
};
protoOf(TrainingAnalytics).k1u = function (sets, exercises, exerciseIds, fromDay, k) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = working(this, sets);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.p1c_1 >= fromDay && (exerciseIds == null || exerciseIds.r(element.q1c_1))) {
      destination.f(element);
    }
  }
  var relevant = destination;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = relevant.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = to(element_0.q1c_1, element_0.p1c_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var key_0 = element_1.p1();
    // Inline function 'kotlin.collections.component2' call
    var group = element_1.q1();
    var tmp0_safe_receiver = exercises.t1(key_0.nb_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1c_1;
    var factor = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_2 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = group.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      var tmp0_safe_receiver_0 = oneRepMax_1(TrainingAnalytics_instance, element_2, factor, k);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_2.f(tmp0_safe_receiver_0);
      }
    }
    var tmp2_safe_receiver = maxOrNull(destination_2);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = to(key_0, tmp2_safe_receiver);
    }
    var tmp0_safe_receiver_1 = tmp_0;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_1);
    }
  }
  var bestByExerciseAndDay = toMap(destination_1);
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0_0 = bestByExerciseAndDay.w1();
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_3 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_3 = tmp0_0.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var key_1 = element_3.p1().nb_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value_0 = destination_3.t1(key_1);
    var tmp_1;
    if (value_0 == null) {
      var answer_0 = ArrayList_init_$Create$_0();
      destination_3.l2(key_1, answer_0);
      tmp_1 = answer_0;
    } else {
      tmp_1 = value_0;
    }
    var list_0 = tmp_1;
    list_0.f(element_3);
  }
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_4 = LinkedHashMap_init_$Create$(mapCapacity(destination_3.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_4 = destination_3.w1().j();
  while (_iterator__ex2g4s_4.k()) {
    var element_4 = _iterator__ex2g4s_4.l();
    var tmp_2 = element_4.p1();
    // Inline function 'kotlin.collections.component2' call
    var entries = element_4.q1();
    var tmp$ret$38;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var iterator = entries.j();
      if (!iterator.k())
        throw NoSuchElementException_init_$Create$_0();
      var minElem = iterator.l();
      if (!iterator.k()) {
        tmp$ret$38 = minElem;
        break $l$block;
      }
      var minValue = minElem.p1().ob_1;
      do {
        var e = iterator.l();
        var v = e.p1().ob_1;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.k());
      tmp$ret$38 = minElem;
    }
    var tmp$ret$36 = tmp$ret$38.q1();
    destination_4.l2(tmp_2, tmp$ret$36);
  }
  var reference = destination_4;
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0_1 = bestByExerciseAndDay.w1();
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_5 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_5 = tmp0_1.j();
  while (_iterator__ex2g4s_5.k()) {
    var element_5 = _iterator__ex2g4s_5.l();
    var key_2 = element_5.p1().ob_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value_1 = destination_5.t1(key_2);
    var tmp_3;
    if (value_1 == null) {
      var answer_1 = ArrayList_init_$Create$_0();
      destination_5.l2(key_2, answer_1);
      tmp_3 = answer_1;
    } else {
      tmp_3 = value_1;
    }
    var list_1 = tmp_3;
    list_1.f(element_5);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination_5.w1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_4 = TrainingAnalytics$strengthIndex$lambda;
  var tmp$ret$47 = new sam$kotlin_Comparator$0_19(tmp_4);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$47);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_6 = this_1.j();
  while (_iterator__ex2g4s_6.k()) {
    var item = _iterator__ex2g4s_6.l();
    // Inline function 'kotlin.collections.component1' call
    var day = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var entries_0 = item.q1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(entries_0, 10));
    var _iterator__ex2g4s_7 = entries_0.j();
    while (_iterator__ex2g4s_7.k()) {
      var item_0 = _iterator__ex2g4s_7.l();
      var tmp$ret$55 = item_0.q1() / getValue(reference, item_0.p1().nb_1) * 100.0;
      destination_7.f(tmp$ret$55);
    }
    var tmp$ret$50 = new StrengthIndexPoint(day, average(destination_7));
    destination_6.f(tmp$ret$50);
  }
  return destination_6;
};
protoOf(TrainingAnalytics).l1u = function (sets, exercises, exerciseIds, fromDay, k, $super) {
  exerciseIds = exerciseIds === VOID ? null : exerciseIds;
  fromDay = fromDay === VOID ? -2147483648 : fromDay;
  k = k === VOID ? 30.0 : k;
  return $super === VOID ? this.k1u(sets, exercises, exerciseIds, fromDay, k) : $super.k1u.call(this, sets, exercises, exerciseIds, fromDay, k);
};
var TrainingAnalytics_instance;
function TrainingAnalytics_getInstance() {
  return TrainingAnalytics_instance;
}
function LevelsWindow_WEEK_getInstance() {
  static_init_67();
  return LevelsWindow_WEEK_instance;
}
function TrainingBacktest() {
  TrainingBacktest_instance = this;
  this.x1n_1 = listOf(['date', 'workoutId', 'exercise', 'order', 'type', 'loadKg', 'reps', 'rir']);
  this.y1n_1 = listOf(['bodyweightKg', 'bodyweightFactor', 'region']);
  this.z1n_1 = 2.5;
  var tmp = this;
  var tmp_0 = to('EPLEY_K30', new TrainingSettings());
  var tmp_1 = to('FLOORED_EXP_FITTED', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, CurveModel_FLOORED_EXP_FITTED_getInstance()));
  var tmp_2 = to('CLAMP', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
  var tmp_3 = to('FATIGUE_POWER_OURS', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, FatigueChoice_POWER_OURS_getInstance()));
  var tmp_4 = to('SURPRISE_SYMMETRIC', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, SurpriseCarry_SYMMETRIC_getInstance()));
  var tmp_5 = to('SURPRISE_ASYMMETRIC', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, SurpriseCarry_ASYMMETRIC_getInstance()));
  var tmp_6 = to('STEP_0.5', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 0.5));
  var tmp_7 = to('STEP_1', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 1.0));
  var tmp_8 = to('STEP_2', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 2.0));
  var tmp0_curve = CurveModel_FLOORED_EXP_FITTED_getInstance();
  var tmp1_fatigue = FatigueChoice_POWER_OURS_getInstance();
  var tmp2_surprise = SurpriseCarry_ASYMMETRIC_getInstance();
  tmp.a1o_1 = linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, to('OURS_ALL', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_curve, tmp1_fatigue, tmp2_surprise, true, 1.0))]);
}
protoOf(TrainingBacktest).b1o = function (line) {
  var result = ArrayList_init_$Create$_0();
  var current = StringBuilder_init_$Create$();
  var quoted = false;
  var i = 0;
  while (i < line.length) {
    var c = charCodeAt(line, i);
    var tmp;
    if (quoted && c === _Char___init__impl__6a9atx(34)) {
      var tmp_0 = getOrNull(line, i + 1 | 0);
      tmp = equals(tmp_0 == null ? null : new Char(tmp_0), new Char(_Char___init__impl__6a9atx(34)));
    } else {
      tmp = false;
    }
    if (tmp) {
      current.t6(_Char___init__impl__6a9atx(34));
      i = i + 1 | 0;
    } else {
      if (c === _Char___init__impl__6a9atx(34)) {
        quoted = !quoted;
      } else {
        if (c === _Char___init__impl__6a9atx(44) && !quoted) {
          result.f(current.toString());
          current.n8();
        } else {
          current.t6(c);
        }
      }
    }
    i = i + 1 | 0;
  }
  result.f(current.toString());
  return result;
};
var TrainingBacktest_instance;
function TrainingBacktest_getInstance() {
  if (TrainingBacktest_instance == null)
    new TrainingBacktest();
  return TrainingBacktest_instance;
}
var static_init_called_68;
function static_init_68() {
  if (static_init_called_68)
    return Unit_instance;
  static_init_called_68 = true;
  Kind_AUTO_instance = new Kind('AUTO', 0);
  Kind_SMART_instance = new Kind('SMART', 1);
  Kind_NONE_instance = new Kind('NONE', 2);
  Kind_CUSTOM_instance = new Kind('CUSTOM', 3);
}
var Kind_AUTO_instance;
var Kind_SMART_instance;
var Kind_NONE_instance;
var Kind_CUSTOM_instance;
function Kind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion_25() {
  Companion_instance_27 = this;
  this.c1n_1 = new WarmupSpec(Kind_AUTO_getInstance());
  this.d1n_1 = new WarmupSpec(Kind_SMART_getInstance());
  this.e1n_1 = new WarmupSpec(Kind_NONE_getInstance());
}
protoOf(Companion_25).m1u = function (value) {
  var tmp;
  if (equals(value, 'none')) {
    tmp = this.e1n_1;
  } else {
    if (equals(value, 'smart')) {
      tmp = this.d1n_1;
    } else {
      if (!(value == null) ? isInterface(value, KtList) : false) {
        var tmp_0 = Kind_CUSTOM_getInstance();
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = value.j();
        while (_iterator__ex2g4s.k()) {
          var element = _iterator__ex2g4s.l();
          var tmp$ret$4;
          $l$block_1: {
            var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$4 = null;
              break $l$block_1;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            var map = tmp_1;
            var tmp1_elvis_lhs = JsonRead_instance.cr(map, 'pct');
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              tmp$ret$4 = null;
              break $l$block_1;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }
            var pct = tmp_2;
            var tmp2_elvis_lhs = JsonRead_instance.qr(map, 'reps');
            var tmp_3;
            if (tmp2_elvis_lhs == null) {
              tmp$ret$4 = null;
              break $l$block_1;
            } else {
              tmp_3 = tmp2_elvis_lhs;
            }
            var reps = tmp_3;
            // Inline function 'kotlin.takeIf' call
            var this_0 = new WarmupStep(pct, reps);
            var tmp_4;
            if (pct > 0.0 && reps > 0) {
              tmp_4 = this_0;
            } else {
              tmp_4 = null;
            }
            tmp$ret$4 = tmp_4;
          }
          var tmp0_safe_receiver = tmp$ret$4;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.f(tmp0_safe_receiver);
          }
        }
        tmp = new WarmupSpec(tmp_0, destination);
      } else {
        tmp = this.c1n_1;
      }
    }
  }
  return tmp;
};
protoOf(Companion_25).n1u = function (spec) {
  var tmp;
  switch (spec.h1n_1.y1_1) {
    case 0:
      tmp = 'auto';
      break;
    case 1:
      tmp = 'smart';
      break;
    case 2:
      tmp = 'none';
      break;
    case 3:
      // Inline function 'kotlin.collections.map' call

      var this_0 = spec.i1n_1;
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.j();
      while (_iterator__ex2g4s.k()) {
        var item = _iterator__ex2g4s.l();
        var tmp$ret$2 = linkedMapOf([to('pct', item.o1u_1), to('reps', item.p1u_1)]);
        destination.f(tmp$ret$2);
      }

      tmp = destination;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Companion_instance_27;
function Companion_getInstance_24() {
  if (Companion_instance_27 == null)
    new Companion_25();
  return Companion_instance_27;
}
function Kind_AUTO_getInstance() {
  static_init_68();
  return Kind_AUTO_instance;
}
function Kind_SMART_getInstance() {
  static_init_68();
  return Kind_SMART_instance;
}
function Kind_NONE_getInstance() {
  static_init_68();
  return Kind_NONE_instance;
}
function Kind_CUSTOM_getInstance() {
  static_init_68();
  return Kind_CUSTOM_instance;
}
function WarmupSpec(kind, steps) {
  Companion_getInstance_24();
  steps = steps === VOID ? emptyList() : steps;
  this.h1n_1 = kind;
  this.i1n_1 = steps;
}
protoOf(WarmupSpec).toString = function () {
  return 'WarmupSpec(kind=' + this.h1n_1.toString() + ', steps=' + toString(this.i1n_1) + ')';
};
protoOf(WarmupSpec).hashCode = function () {
  var result = this.h1n_1.hashCode();
  result = imul(result, 31) + hashCode(this.i1n_1) | 0;
  return result;
};
protoOf(WarmupSpec).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WarmupSpec))
    return false;
  if (!this.h1n_1.equals(other.h1n_1))
    return false;
  if (!equals(this.i1n_1, other.i1n_1))
    return false;
  return true;
};
var static_init_called_69;
function static_init_69() {
  if (static_init_called_69)
    return Unit_instance;
  static_init_called_69 = true;
  GroupKind_SUPERSET_instance = new GroupKind('SUPERSET', 0, 'superset');
  GroupKind_CIRCUIT_instance = new GroupKind('CIRCUIT', 1, 'circuit');
  if (Companion_instance_28 == null) {
    Companion_instance_0;
    new Companion_26();
  }
}
var GroupKind_SUPERSET_instance;
var GroupKind_CIRCUIT_instance;
function Companion_26() {
}
protoOf(Companion_26).h1f = function (key) {
  var tmp0 = get_entries_41();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.s1u_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_28;
function Companion_getInstance_25() {
  return Companion_instance_28;
}
function values_46() {
  static_init_69();
  return [GroupKind_SUPERSET_getInstance(), GroupKind_CIRCUIT_getInstance()];
}
function get_entries_41() {
  static_init_69();
  if ($ENTRIES_41 == null)
    $ENTRIES_41 = enumEntries(values_46());
  return $ENTRIES_41;
}
var $ENTRIES_41;
function GroupKind(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.s1u_1 = key;
}
function ProgramExercise(exerciseId, restSec, warmup, progression, cycles, supersetGroup, deload, groupKind) {
  supersetGroup = supersetGroup === VOID ? null : supersetGroup;
  deload = deload === VOID ? null : deload;
  groupKind = groupKind === VOID ? null : groupKind;
  this.w1a_1 = exerciseId;
  this.x1a_1 = restSec;
  this.y1a_1 = warmup;
  this.z1a_1 = progression;
  this.a1b_1 = cycles;
  this.b1b_1 = supersetGroup;
  this.c1b_1 = deload;
  this.d1b_1 = groupKind;
}
protoOf(ProgramExercise).e1b = function (cycle) {
  return this.a1b_1.n(coerceIn_0(cycle, 0, this.a1b_1.o() - 1 | 0));
};
protoOf(ProgramExercise).toString = function () {
  return 'ProgramExercise(exerciseId=' + this.w1a_1 + ', restSec=' + this.x1a_1 + ', warmup=' + this.y1a_1.toString() + ', progression=' + this.z1a_1.toString() + ', cycles=' + toString(this.a1b_1) + ', supersetGroup=' + this.b1b_1 + ', deload=' + toString_0(this.c1b_1) + ', groupKind=' + toString_0(this.d1b_1) + ')';
};
protoOf(ProgramExercise).hashCode = function () {
  var result = getStringHashCode(this.w1a_1);
  result = imul(result, 31) + this.x1a_1 | 0;
  result = imul(result, 31) + this.y1a_1.hashCode() | 0;
  result = imul(result, 31) + this.z1a_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.a1b_1) | 0;
  result = imul(result, 31) + (this.b1b_1 == null ? 0 : getStringHashCode(this.b1b_1)) | 0;
  result = imul(result, 31) + (this.c1b_1 == null ? 0 : this.c1b_1.hashCode()) | 0;
  result = imul(result, 31) + (this.d1b_1 == null ? 0 : this.d1b_1.hashCode()) | 0;
  return result;
};
protoOf(ProgramExercise).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProgramExercise))
    return false;
  if (!(this.w1a_1 === other.w1a_1))
    return false;
  if (!(this.x1a_1 === other.x1a_1))
    return false;
  if (!this.y1a_1.equals(other.y1a_1))
    return false;
  if (!this.z1a_1.equals(other.z1a_1))
    return false;
  if (!equals(this.a1b_1, other.a1b_1))
    return false;
  if (!(this.b1b_1 == other.b1b_1))
    return false;
  if (!equals(this.c1b_1, other.c1b_1))
    return false;
  if (!equals(this.d1b_1, other.d1b_1))
    return false;
  return true;
};
function ProgramDay(name, exercises, gymId) {
  gymId = gymId === VOID ? null : gymId;
  this.n1a_1 = name;
  this.o1a_1 = exercises;
  this.p1a_1 = gymId;
}
protoOf(ProgramDay).t1u = function (name, exercises, gymId) {
  return new ProgramDay(name, exercises, gymId);
};
protoOf(ProgramDay).g1l = function (name, exercises, gymId, $super) {
  name = name === VOID ? this.n1a_1 : name;
  exercises = exercises === VOID ? this.o1a_1 : exercises;
  gymId = gymId === VOID ? this.p1a_1 : gymId;
  return $super === VOID ? this.t1u(name, exercises, gymId) : $super.t1u.call(this, name, exercises, gymId);
};
protoOf(ProgramDay).toString = function () {
  return 'ProgramDay(name=' + this.n1a_1 + ', exercises=' + toString(this.o1a_1) + ', gymId=' + this.p1a_1 + ')';
};
protoOf(ProgramDay).hashCode = function () {
  var result = getStringHashCode(this.n1a_1);
  result = imul(result, 31) + hashCode(this.o1a_1) | 0;
  result = imul(result, 31) + (this.p1a_1 == null ? 0 : getStringHashCode(this.p1a_1)) | 0;
  return result;
};
protoOf(ProgramDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProgramDay))
    return false;
  if (!(this.n1a_1 === other.n1a_1))
    return false;
  if (!equals(this.o1a_1, other.o1a_1))
    return false;
  if (!(this.p1a_1 == other.p1a_1))
    return false;
  return true;
};
function TrainingProgram(name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId) {
  endBehaviour = endBehaviour === VOID ? 'repeat' : endBehaviour;
  archived = archived === VOID ? false : archived;
  nextProgramId = nextProgramId === VOID ? null : nextProgramId;
  this.f1a_1 = name;
  this.g1a_1 = goal;
  this.h1a_1 = cycles;
  this.i1a_1 = deload;
  this.j1a_1 = days;
  this.k1a_1 = endBehaviour;
  this.l1a_1 = archived;
  this.m1a_1 = nextProgramId;
}
protoOf(TrainingProgram).u1u = function (name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId) {
  return new TrainingProgram(name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId);
};
protoOf(TrainingProgram).s1d = function (name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId, $super) {
  name = name === VOID ? this.f1a_1 : name;
  goal = goal === VOID ? this.g1a_1 : goal;
  cycles = cycles === VOID ? this.h1a_1 : cycles;
  deload = deload === VOID ? this.i1a_1 : deload;
  days = days === VOID ? this.j1a_1 : days;
  endBehaviour = endBehaviour === VOID ? this.k1a_1 : endBehaviour;
  archived = archived === VOID ? this.l1a_1 : archived;
  nextProgramId = nextProgramId === VOID ? this.m1a_1 : nextProgramId;
  return $super === VOID ? this.u1u(name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId) : $super.u1u.call(this, name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId);
};
protoOf(TrainingProgram).toString = function () {
  return 'TrainingProgram(name=' + this.f1a_1 + ', goal=' + this.g1a_1.toString() + ', cycles=' + this.h1a_1 + ', deload=' + this.i1a_1.toString() + ', days=' + toString(this.j1a_1) + ', endBehaviour=' + this.k1a_1 + ', archived=' + this.l1a_1 + ', nextProgramId=' + this.m1a_1 + ')';
};
protoOf(TrainingProgram).hashCode = function () {
  var result = getStringHashCode(this.f1a_1);
  result = imul(result, 31) + this.g1a_1.hashCode() | 0;
  result = imul(result, 31) + this.h1a_1 | 0;
  result = imul(result, 31) + this.i1a_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.j1a_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.k1a_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.l1a_1) | 0;
  result = imul(result, 31) + (this.m1a_1 == null ? 0 : getStringHashCode(this.m1a_1)) | 0;
  return result;
};
protoOf(TrainingProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingProgram))
    return false;
  if (!(this.f1a_1 === other.f1a_1))
    return false;
  if (!this.g1a_1.equals(other.g1a_1))
    return false;
  if (!(this.h1a_1 === other.h1a_1))
    return false;
  if (!this.i1a_1.equals(other.i1a_1))
    return false;
  if (!equals(this.j1a_1, other.j1a_1))
    return false;
  if (!(this.k1a_1 === other.k1a_1))
    return false;
  if (!(this.l1a_1 === other.l1a_1))
    return false;
  if (!(this.m1a_1 == other.m1a_1))
    return false;
  return true;
};
function cycleJson($this, it) {
  // Inline function 'kotlin.apply' call
  var this_0 = linkedMapOf([to('sets', it.q1a_1), to('repMin', it.r1a_1), to('repMax', it.s1a_1), to('rir', it.t1a_1), to('setType', it.u1a_1.q1s_1)]);
  if (it.v1a_1) {
    this_0.l2('skip', true);
  }
  return this_0;
}
function cycle($this, value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cycle = tmp;
  // Inline function 'kotlin.runCatching' call
  var tmp_0;
  try {
    var tmp0_elvis_lhs_0 = JsonRead_instance.qr(cycle, 'sets');
    var tmp_1;
    if (tmp0_elvis_lhs_0 == null) {
      return null;
    } else {
      tmp_1 = tmp0_elvis_lhs_0;
    }
    var tmp_2 = tmp_1;
    var tmp1_elvis_lhs = JsonRead_instance.qr(cycle, 'repMin');
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp_4 = tmp_3;
    var tmp2_elvis_lhs = JsonRead_instance.qr(cycle, 'repMax');
    var tmp_5;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    var tmp_6 = tmp_5;
    var tmp3_elvis_lhs = JsonRead_instance.qr(cycle, 'rir');
    var tmp_7 = tmp3_elvis_lhs == null ? 2 : tmp3_elvis_lhs;
    var tmp_8 = Companion_instance_19.h1f(JsonRead_instance.br(cycle, 'setType'));
    var tmp4_elvis_lhs = JsonRead_instance.tr(cycle, 'skip');
    // Inline function 'kotlin.Companion.success' call
    var value_0 = new CyclePrescription(tmp_2, tmp_4, tmp_6, tmp_7, tmp_8, tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs);
    tmp_0 = _Result___init__impl__xyqfz8(value_0);
  } catch ($p) {
    var tmp_9;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_9 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp_0 = tmp_9;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp_0;
  return _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
}
function TrainingProgramJson() {
}
protoOf(TrainingProgramJson).v1u = function (program, active, startDate) {
  var tmp = Json_instance;
  var tmp_0 = to('name', program.f1a_1);
  var tmp_1 = to('goal', program.g1a_1.c1t_1);
  var tmp_2 = to('active', active);
  var tmp_3 = to('startDate', startDate);
  var tmp_4 = to('cycles', program.h1a_1);
  var tmp_5 = to('deload', program.i1a_1.f1t_1);
  var tmp_6 = to('endBehaviour', program.k1a_1);
  var tmp_7 = to('repeat', program.k1a_1 === 'stop' ? 'ONCE' : 'FOREVER');
  var tmp_8 = to('archived', program.l1a_1);
  var tmp_9 = to('nextProgramId', program.m1a_1);
  // Inline function 'kotlin.collections.map' call
  var this_0 = program.j1a_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp_10 = to('name', item.n1a_1);
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.o1a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp_11 = to('exerciseId', item_0.w1a_1);
      var tmp_12 = to('supersetGroup', item_0.b1b_1);
      var tmp_13 = to('restSec', item_0.x1a_1);
      var tmp_14 = to('warmup', Companion_getInstance_24().n1u(item_0.y1a_1));
      var tmp_15 = to('progression', item_0.z1a_1.t1s_1);
      // Inline function 'kotlin.collections.map' call
      var this_2 = item_0.a1b_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_1 = this_2.j();
      while (_iterator__ex2g4s_1.k()) {
        var item_1 = _iterator__ex2g4s_1.l();
        var tmp$ret$8 = cycleJson(TrainingProgramJson_instance, item_1);
        destination_1.f(tmp$ret$8);
      }
      // Inline function 'kotlin.apply' call
      var this_3 = linkedMapOf([tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, to('cycles', destination_1)]);
      var tmp0_safe_receiver = item_0.c1b_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this_3.l2('deload', cycleJson(TrainingProgramJson_instance, tmp0_safe_receiver));
      }
      var tmp1_safe_receiver = item_0.d1b_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this_3.l2('groupKind', tmp1_safe_receiver.s1u_1);
      }
      destination_0.f(this_3);
    }
    // Inline function 'kotlin.apply' call
    var this_4 = linkedMapOf([tmp_10, to('exercises', destination_0)]);
    var tmp0_safe_receiver_0 = item.p1a_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_4.l2('gymId', tmp0_safe_receiver_0);
    }
    destination.f(this_4);
  }
  return tmp.sg(linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, to('days', destination)]));
};
protoOf(TrainingProgramJson).w1u = function (program, active, startDate, $super) {
  active = active === VOID ? false : active;
  startDate = startDate === VOID ? null : startDate;
  return $super === VOID ? this.v1u(program, active, startDate) : $super.v1u.call(this, program, active, startDate);
};
protoOf(TrainingProgramJson).x1u = function (json) {
  var map = JsonRead_instance.og(Json_instance.ng(json), 'TPROG');
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.rr(map.t1('days'));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var day = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.br(day, 'name');
      var tmp_0 = tmp1_elvis_lhs == null ? 'Day' : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = JsonRead_instance.rr(day.t1('exercises'));
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        var tmp$ret$9;
        $l$block_2: {
          var tmp0_elvis_lhs_0 = (!(element_0 == null) ? isInterface(element_0, KtMap) : false) ? element_0 : null;
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$9 = null;
            break $l$block_2;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var exercise = tmp_1;
          var tmp1_elvis_lhs_0 = JsonRead_instance.br(exercise, 'exerciseId');
          var tmp_2;
          if (tmp1_elvis_lhs_0 == null) {
            tmp$ret$9 = null;
            break $l$block_2;
          } else {
            tmp_2 = tmp1_elvis_lhs_0;
          }
          var id = tmp_2;
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0_1 = JsonRead_instance.rr(exercise.t1('cycles'));
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_1 = ArrayList_init_$Create$_0();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_1 = tmp0_1.j();
          while (_iterator__ex2g4s_1.k()) {
            var element_1 = _iterator__ex2g4s_1.l();
            var tmp0_safe_receiver = cycle(TrainingProgramJson_instance, element_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_1.f(tmp0_safe_receiver);
            }
          }
          var cycles = destination_1;
          if (cycles.m()) {
            tmp$ret$9 = null;
            break $l$block_2;
          }
          var tmp2_elvis_lhs = JsonRead_instance.qr(exercise, 'restSec');
          tmp$ret$9 = new ProgramExercise(id, tmp2_elvis_lhs == null ? 120 : tmp2_elvis_lhs, Companion_getInstance_24().m1u(exercise.t1('warmup')), Companion_instance_20.h1f(JsonRead_instance.br(exercise, 'progression')), cycles, JsonRead_instance.br(exercise, 'supersetGroup'), cycle(TrainingProgramJson_instance, exercise.t1('deload')), Companion_instance_28.h1f(JsonRead_instance.br(exercise, 'groupKind')));
        }
        var tmp0_safe_receiver_0 = tmp$ret$9;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.f(tmp0_safe_receiver_0);
        }
      }
      tmp$ret$4 = new ProgramDay(tmp_0, destination_0, JsonRead_instance.br(day, 'gymId'));
    }
    var tmp0_safe_receiver_1 = tmp$ret$4;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_1);
    }
  }
  var days = destination;
  var tmp0_elvis_lhs_1 = JsonRead_instance.br(map, 'endBehaviour');
  var tmp_3;
  if (tmp0_elvis_lhs_1 == null) {
    tmp_3 = JsonRead_instance.br(map, 'repeat') === 'ONCE' ? 'stop' : 'repeat';
  } else {
    tmp_3 = tmp0_elvis_lhs_1;
  }
  var endBehaviour = tmp_3;
  var tmp2_elvis_lhs_0 = JsonRead_instance.br(map, 'name');
  var tmp_4 = tmp2_elvis_lhs_0 == null ? 'Program' : tmp2_elvis_lhs_0;
  var tmp_5 = Companion_instance_23.h1f(JsonRead_instance.br(map, 'goal'));
  var tmp3_elvis_lhs = JsonRead_instance.qr(map, 'cycles');
  var tmp_6 = coerceAtLeast(tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs, 1);
  var tmp_7 = Companion_instance_24.h1f(JsonRead_instance.br(map, 'deload'));
  var tmp4_elvis_lhs = JsonRead_instance.tr(map, 'archived');
  return new TrainingProgram(tmp_4, tmp_5, tmp_6, tmp_7, days, endBehaviour, tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs, JsonRead_instance.br(map, 'nextProgramId'));
};
var TrainingProgramJson_instance;
function TrainingProgramJson_getInstance() {
  return TrainingProgramJson_instance;
}
function GroupKind_SUPERSET_getInstance() {
  static_init_69();
  return GroupKind_SUPERSET_instance;
}
function GroupKind_CIRCUIT_getInstance() {
  static_init_69();
  return GroupKind_CIRCUIT_instance;
}
var static_init_called_70;
function static_init_70() {
  if (static_init_called_70)
    return Unit_instance;
  static_init_called_70 = true;
  Prefill_SMART_instance = new Prefill('SMART', 0);
  Prefill_PREVIOUS_instance = new Prefill('PREVIOUS', 1);
}
var Prefill_SMART_instance;
var Prefill_PREVIOUS_instance;
function values_47() {
  static_init_70();
  return [Prefill_SMART_getInstance(), Prefill_PREVIOUS_getInstance()];
}
function get_entries_42() {
  static_init_70();
  if ($ENTRIES_42 == null)
    $ENTRIES_42 = enumEntries(values_47());
  return $ENTRIES_42;
}
var $ENTRIES_42;
function Prefill(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_71;
function static_init_71() {
  if (static_init_called_71)
    return Unit_instance;
  static_init_called_71 = true;
  PreviousScope_ANY_instance = new PreviousScope('ANY', 0);
  PreviousScope_PROGRAM_instance = new PreviousScope('PROGRAM', 1);
}
var PreviousScope_ANY_instance;
var PreviousScope_PROGRAM_instance;
function values_48() {
  static_init_71();
  return [PreviousScope_ANY_getInstance(), PreviousScope_PROGRAM_getInstance()];
}
function get_entries_43() {
  static_init_71();
  if ($ENTRIES_43 == null)
    $ENTRIES_43 = enumEntries(values_48());
  return $ENTRIES_43;
}
var $ENTRIES_43;
function PreviousScope(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_72;
function static_init_72() {
  if (static_init_called_72)
    return Unit_instance;
  static_init_called_72 = true;
  WarmupCategory_UPPER_COMPOUND_instance = new WarmupCategory('UPPER_COMPOUND', 0, 'upperCompound');
  WarmupCategory_LOWER_COMPOUND_instance = new WarmupCategory('LOWER_COMPOUND', 1, 'lowerCompound');
  WarmupCategory_UPPER_ISOLATION_instance = new WarmupCategory('UPPER_ISOLATION', 2, 'upperIsolation');
  WarmupCategory_LOWER_ISOLATION_instance = new WarmupCategory('LOWER_ISOLATION', 3, 'lowerIsolation');
  WarmupCategory_CORE_instance = new WarmupCategory('CORE', 4, 'core');
  if (Companion_instance_29 == null) {
    Companion_instance_0;
    new Companion_27();
  }
}
var WarmupCategory_UPPER_COMPOUND_instance;
var WarmupCategory_LOWER_COMPOUND_instance;
var WarmupCategory_UPPER_ISOLATION_instance;
var WarmupCategory_LOWER_ISOLATION_instance;
var WarmupCategory_CORE_instance;
function Companion_27() {
}
protoOf(Companion_27).h1f = function (key) {
  var tmp0 = get_entries_44();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.a1v_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_29;
function Companion_getInstance_26() {
  return Companion_instance_29;
}
function values_49() {
  static_init_72();
  return [WarmupCategory_UPPER_COMPOUND_getInstance(), WarmupCategory_LOWER_COMPOUND_getInstance(), WarmupCategory_UPPER_ISOLATION_getInstance(), WarmupCategory_LOWER_ISOLATION_getInstance(), WarmupCategory_CORE_getInstance()];
}
function get_entries_44() {
  static_init_72();
  if ($ENTRIES_44 == null)
    $ENTRIES_44 = enumEntries(values_49());
  return $ENTRIES_44;
}
var $ENTRIES_44;
function WarmupCategory(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.a1v_1 = key;
}
function Companion_28() {
}
protoOf(Companion_28).v1n = function (rpe) {
  // Inline function 'kotlin.math.floor' call
  var x = 10.0 - rpe + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return coerceIn_0(numberToInt(tmp$ret$0), 0, 10);
};
var Companion_instance_30;
function Companion_getInstance_27() {
  return Companion_instance_30;
}
function TrainingSettings(weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills, dismissedSuggestions) {
  weekdays = weekdays === VOID ? null : weekdays;
  prefill = prefill === VOID ? Prefill_SMART_getInstance() : prefill;
  previousScope = previousScope === VOID ? PreviousScope_ANY_getInstance() : previousScope;
  inSessionFill = inSessionFill === VOID ? true : inSessionFill;
  rirAutofill = rirAutofill === VOID ? true : rirAutofill;
  propagateEdits = propagateEdits === VOID ? false : propagateEdits;
  priority = priority === VOID ? AdjustmentPriority_REPS_FIRST_getInstance() : priority;
  expandRepRange = expandRepRange === VOID ? null : expandRepRange;
  weightMatch = weightMatch === VOID ? null : weightMatch;
  rpeInput = rpeInput === VOID ? false : rpeInput;
  curve = curve === VOID ? CurveModel_EPLEY_getInstance() : curve;
  fatigue = fatigue === VOID ? FatigueChoice_FIXED_getInstance() : fatigue;
  surprise = surprise === VOID ? SurpriseCarry_NONE_getInstance() : surprise;
  clampOneRepMax = clampOneRepMax === VOID ? false : clampOneRepMax;
  sessionStepPct = sessionStepPct === VOID ? 0.0 : sessionStepPct;
  smartWarmups = smartWarmups === VOID ? SmartWarmupStyle_OURS_getInstance() : smartWarmups;
  warmupLastRestSec = warmupLastRestSec === VOID ? 120 : warmupLastRestSec;
  warmupSchemes = warmupSchemes === VOID ? emptyMap() : warmupSchemes;
  warmupOverrides = warmupOverrides === VOID ? emptyMap() : warmupOverrides;
  compoundRestSec = compoundRestSec === VOID ? null : compoundRestSec;
  isolationRestSec = isolationRestSec === VOID ? null : isolationRestSec;
  restOverrides = restOverrides === VOID ? emptyMap() : restOverrides;
  sideRestSec = sideRestSec === VOID ? null : sideRestSec;
  betweenExercisesSec = betweenExercisesSec === VOID ? null : betweenExercisesSec;
  skills = skills === VOID ? emptySet() : skills;
  dismissedSuggestions = dismissedSuggestions === VOID ? emptyMap() : dismissedSuggestions;
  this.b1v_1 = weekdays;
  this.c1v_1 = prefill;
  this.d1v_1 = previousScope;
  this.e1v_1 = inSessionFill;
  this.f1v_1 = rirAutofill;
  this.g1v_1 = propagateEdits;
  this.h1v_1 = priority;
  this.i1v_1 = expandRepRange;
  this.j1v_1 = weightMatch;
  this.k1v_1 = rpeInput;
  this.l1v_1 = curve;
  this.m1v_1 = fatigue;
  this.n1v_1 = surprise;
  this.o1v_1 = clampOneRepMax;
  this.p1v_1 = sessionStepPct;
  this.q1v_1 = smartWarmups;
  this.r1v_1 = warmupLastRestSec;
  this.s1v_1 = warmupSchemes;
  this.t1v_1 = warmupOverrides;
  this.u1v_1 = compoundRestSec;
  this.v1v_1 = isolationRestSec;
  this.w1v_1 = restOverrides;
  this.x1v_1 = sideRestSec;
  this.y1v_1 = betweenExercisesSec;
  this.z1v_1 = skills;
  this.a1w_1 = dismissedSuggestions;
}
protoOf(TrainingSettings).b1w = function (exercise, history, bodyweightKg, rirAdjustment, clientExpand, clientWeightMatch) {
  var tmp0_elvis_lhs = this.i1v_1;
  var tmp = tmp0_elvis_lhs == null ? clientExpand : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = this.j1v_1;
  return new ProgressionOptions(this.h1v_1, tmp, VOID, tmp1_elvis_lhs == null ? clientWeightMatch : tmp1_elvis_lhs, this.m1v_1.c1f_1, this.c1w(exercise, history, bodyweightKg), VOID, VOID, bodyweightKg, exercise.a1c_1, VOID, VOID, VOID, rirAdjustment, VOID, this.o1v_1, this.n1v_1, this.p1v_1);
};
protoOf(TrainingSettings).c1w = function (exercise, history, bodyweightKg) {
  var tmp;
  switch (this.l1v_1.y1_1) {
    case 0:
      tmp = new EpleyCurve();
      break;
    case 1:
      tmp = CurveFit_instance.r1e(history, bodyweightKg * exercise.a1c_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(TrainingSettings).d1w = function (weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills, dismissedSuggestions) {
  return new TrainingSettings(weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills, dismissedSuggestions);
};
protoOf(TrainingSettings).e1w = function (weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills, dismissedSuggestions, $super) {
  weekdays = weekdays === VOID ? this.b1v_1 : weekdays;
  prefill = prefill === VOID ? this.c1v_1 : prefill;
  previousScope = previousScope === VOID ? this.d1v_1 : previousScope;
  inSessionFill = inSessionFill === VOID ? this.e1v_1 : inSessionFill;
  rirAutofill = rirAutofill === VOID ? this.f1v_1 : rirAutofill;
  propagateEdits = propagateEdits === VOID ? this.g1v_1 : propagateEdits;
  priority = priority === VOID ? this.h1v_1 : priority;
  expandRepRange = expandRepRange === VOID ? this.i1v_1 : expandRepRange;
  weightMatch = weightMatch === VOID ? this.j1v_1 : weightMatch;
  rpeInput = rpeInput === VOID ? this.k1v_1 : rpeInput;
  curve = curve === VOID ? this.l1v_1 : curve;
  fatigue = fatigue === VOID ? this.m1v_1 : fatigue;
  surprise = surprise === VOID ? this.n1v_1 : surprise;
  clampOneRepMax = clampOneRepMax === VOID ? this.o1v_1 : clampOneRepMax;
  sessionStepPct = sessionStepPct === VOID ? this.p1v_1 : sessionStepPct;
  smartWarmups = smartWarmups === VOID ? this.q1v_1 : smartWarmups;
  warmupLastRestSec = warmupLastRestSec === VOID ? this.r1v_1 : warmupLastRestSec;
  warmupSchemes = warmupSchemes === VOID ? this.s1v_1 : warmupSchemes;
  warmupOverrides = warmupOverrides === VOID ? this.t1v_1 : warmupOverrides;
  compoundRestSec = compoundRestSec === VOID ? this.u1v_1 : compoundRestSec;
  isolationRestSec = isolationRestSec === VOID ? this.v1v_1 : isolationRestSec;
  restOverrides = restOverrides === VOID ? this.w1v_1 : restOverrides;
  sideRestSec = sideRestSec === VOID ? this.x1v_1 : sideRestSec;
  betweenExercisesSec = betweenExercisesSec === VOID ? this.y1v_1 : betweenExercisesSec;
  skills = skills === VOID ? this.z1v_1 : skills;
  dismissedSuggestions = dismissedSuggestions === VOID ? this.a1w_1 : dismissedSuggestions;
  return $super === VOID ? this.d1w(weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills, dismissedSuggestions) : $super.d1w.call(this, weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills, dismissedSuggestions);
};
protoOf(TrainingSettings).toString = function () {
  return 'TrainingSettings(weekdays=' + toString_0(this.b1v_1) + ', prefill=' + this.c1v_1.toString() + ', previousScope=' + this.d1v_1.toString() + ', inSessionFill=' + this.e1v_1 + ', rirAutofill=' + this.f1v_1 + ', propagateEdits=' + this.g1v_1 + ', priority=' + this.h1v_1.toString() + ', expandRepRange=' + this.i1v_1 + ', weightMatch=' + this.j1v_1 + ', rpeInput=' + this.k1v_1 + ', curve=' + this.l1v_1.toString() + ', fatigue=' + this.m1v_1.toString() + ', surprise=' + this.n1v_1.toString() + ', clampOneRepMax=' + this.o1v_1 + ', sessionStepPct=' + this.p1v_1 + ', smartWarmups=' + this.q1v_1.toString() + ', warmupLastRestSec=' + this.r1v_1 + ', warmupSchemes=' + toString(this.s1v_1) + ', warmupOverrides=' + toString(this.t1v_1) + ', compoundRestSec=' + this.u1v_1 + ', isolationRestSec=' + this.v1v_1 + ', restOverrides=' + toString(this.w1v_1) + ', sideRestSec=' + this.x1v_1 + ', betweenExercisesSec=' + this.y1v_1 + ', skills=' + toString(this.z1v_1) + ', dismissedSuggestions=' + toString(this.a1w_1) + ')';
};
protoOf(TrainingSettings).hashCode = function () {
  var result = this.b1v_1 == null ? 0 : hashCode(this.b1v_1);
  result = imul(result, 31) + this.c1v_1.hashCode() | 0;
  result = imul(result, 31) + this.d1v_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.e1v_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.f1v_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.g1v_1) | 0;
  result = imul(result, 31) + this.h1v_1.hashCode() | 0;
  result = imul(result, 31) + (this.i1v_1 == null ? 0 : getBooleanHashCode(this.i1v_1)) | 0;
  result = imul(result, 31) + (this.j1v_1 == null ? 0 : getBooleanHashCode(this.j1v_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.k1v_1) | 0;
  result = imul(result, 31) + this.l1v_1.hashCode() | 0;
  result = imul(result, 31) + this.m1v_1.hashCode() | 0;
  result = imul(result, 31) + this.n1v_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.o1v_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.p1v_1) | 0;
  result = imul(result, 31) + this.q1v_1.hashCode() | 0;
  result = imul(result, 31) + this.r1v_1 | 0;
  result = imul(result, 31) + hashCode(this.s1v_1) | 0;
  result = imul(result, 31) + hashCode(this.t1v_1) | 0;
  result = imul(result, 31) + (this.u1v_1 == null ? 0 : this.u1v_1) | 0;
  result = imul(result, 31) + (this.v1v_1 == null ? 0 : this.v1v_1) | 0;
  result = imul(result, 31) + hashCode(this.w1v_1) | 0;
  result = imul(result, 31) + (this.x1v_1 == null ? 0 : this.x1v_1) | 0;
  result = imul(result, 31) + (this.y1v_1 == null ? 0 : this.y1v_1) | 0;
  result = imul(result, 31) + hashCode(this.z1v_1) | 0;
  result = imul(result, 31) + hashCode(this.a1w_1) | 0;
  return result;
};
protoOf(TrainingSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingSettings))
    return false;
  if (!equals(this.b1v_1, other.b1v_1))
    return false;
  if (!this.c1v_1.equals(other.c1v_1))
    return false;
  if (!this.d1v_1.equals(other.d1v_1))
    return false;
  if (!(this.e1v_1 === other.e1v_1))
    return false;
  if (!(this.f1v_1 === other.f1v_1))
    return false;
  if (!(this.g1v_1 === other.g1v_1))
    return false;
  if (!this.h1v_1.equals(other.h1v_1))
    return false;
  if (!(this.i1v_1 == other.i1v_1))
    return false;
  if (!(this.j1v_1 == other.j1v_1))
    return false;
  if (!(this.k1v_1 === other.k1v_1))
    return false;
  if (!this.l1v_1.equals(other.l1v_1))
    return false;
  if (!this.m1v_1.equals(other.m1v_1))
    return false;
  if (!this.n1v_1.equals(other.n1v_1))
    return false;
  if (!(this.o1v_1 === other.o1v_1))
    return false;
  if (!equals(this.p1v_1, other.p1v_1))
    return false;
  if (!this.q1v_1.equals(other.q1v_1))
    return false;
  if (!(this.r1v_1 === other.r1v_1))
    return false;
  if (!equals(this.s1v_1, other.s1v_1))
    return false;
  if (!equals(this.t1v_1, other.t1v_1))
    return false;
  if (!(this.u1v_1 == other.u1v_1))
    return false;
  if (!(this.v1v_1 == other.v1v_1))
    return false;
  if (!equals(this.w1v_1, other.w1v_1))
    return false;
  if (!(this.x1v_1 == other.x1v_1))
    return false;
  if (!(this.y1v_1 == other.y1v_1))
    return false;
  if (!equals(this.z1v_1, other.z1v_1))
    return false;
  if (!equals(this.a1w_1, other.a1w_1))
    return false;
  return true;
};
function fromMap$enum($map, key, values, default_0) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = values.length;
    while (inductionVariable < last) {
      var element = values[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.x1_1 === JsonRead_instance.br($map, key)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
}
function fromMap$seconds($map, key) {
  var tmp0_safe_receiver = JsonRead_instance.qr($map, key);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (0 <= tmp0_safe_receiver ? tmp0_safe_receiver <= 3600 : false) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function fromMap$obj($map, key) {
  var tmp = $map.t1(key);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
}
function TrainingSettingsJson() {
  this.f1w_1 = 5.0;
}
protoOf(TrainingSettingsJson).mg = function (json) {
  var tmp;
  if (json == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_0;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.og(Json_instance.ng(json), 'training');
      tmp_0 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_0;
    tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return new TrainingSettings();
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var map = tmp_2;
  return this.g1w(map);
};
protoOf(TrainingSettingsJson).g1w = function (map) {
  var d = new TrainingSettings();
  var tmp = map.t1('weekdays');
  var tmp_0;
  if (((!(tmp == null) ? isInterface(tmp, KtList) : false) ? tmp : null) == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = JsonRead_instance.sr(map, 'weekdays');
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (1 <= element ? element <= 7 : false) {
        destination.f(element);
      }
    }
    tmp_0 = toSet(destination);
  }
  var tmp_1 = tmp_0;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = get_entries_42();
  var tmp$ret$5 = copyToArray(this_0);
  var tmp_2 = fromMap$enum(map, 'prefill', tmp$ret$5, d.c1v_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = get_entries_43();
  var tmp$ret$6 = copyToArray(this_1);
  var tmp_3 = fromMap$enum(map, 'previousScope', tmp$ret$6, d.d1v_1);
  var tmp1_elvis_lhs = JsonRead_instance.tr(map, 'inSessionFill');
  var tmp_4 = tmp1_elvis_lhs == null ? d.e1v_1 : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = JsonRead_instance.tr(map, 'rirAutofill');
  var tmp_5 = tmp2_elvis_lhs == null ? d.f1v_1 : tmp2_elvis_lhs;
  var tmp3_elvis_lhs = JsonRead_instance.tr(map, 'propagateEdits');
  var tmp_6 = tmp3_elvis_lhs == null ? d.g1v_1 : tmp3_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_2 = get_entries_28();
  var tmp$ret$7 = copyToArray(this_2);
  var tmp_7 = fromMap$enum(map, 'priority', tmp$ret$7, d.h1v_1);
  var tmp_8 = JsonRead_instance.tr(map, 'expandRepRange');
  var tmp_9 = JsonRead_instance.tr(map, 'weightMatch');
  var tmp4_elvis_lhs = JsonRead_instance.tr(map, 'rpeInput');
  var tmp_10 = tmp4_elvis_lhs == null ? d.k1v_1 : tmp4_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_3 = get_entries_29();
  var tmp$ret$8 = copyToArray(this_3);
  var tmp_11 = fromMap$enum(map, 'curve', tmp$ret$8, d.l1v_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_4 = get_entries_20();
  var tmp$ret$9 = copyToArray(this_4);
  var tmp_12 = fromMap$enum(map, 'fatigue', tmp$ret$9, d.m1v_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_5 = get_entries_21();
  var tmp$ret$10 = copyToArray(this_5);
  var tmp_13 = fromMap$enum(map, 'surprise', tmp$ret$10, d.n1v_1);
  var tmp5_elvis_lhs = JsonRead_instance.tr(map, 'clampOneRepMax');
  var tmp_14 = tmp5_elvis_lhs == null ? d.o1v_1 : tmp5_elvis_lhs;
  var tmp6_safe_receiver = JsonRead_instance.cr(map, 'sessionStepPct');
  var tmp_15;
  if (tmp6_safe_receiver == null) {
    tmp_15 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_16;
    if (0.0 <= tmp6_safe_receiver ? tmp6_safe_receiver <= 5.0 : false) {
      tmp_16 = tmp6_safe_receiver;
    } else {
      tmp_16 = null;
    }
    tmp_15 = tmp_16;
  }
  var tmp7_elvis_lhs = tmp_15;
  var tmp_17 = tmp7_elvis_lhs == null ? d.p1v_1 : tmp7_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_6 = get_entries_45();
  var tmp$ret$13 = copyToArray(this_6);
  var tmp_18 = fromMap$enum(map, 'smartWarmups', tmp$ret$13, d.q1v_1);
  var tmp8_elvis_lhs = fromMap$seconds(map, 'warmupLastRestSec');
  var tmp_19 = tmp8_elvis_lhs == null ? d.r1v_1 : tmp8_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = fromMap$obj(map, 'warmupSchemes');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = tmp0_0.w1().j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var key = element_0.p1();
    // Inline function 'kotlin.collections.component2' call
    var value = element_0.q1();
    var tmp0_safe_receiver = Companion_instance_29.h1f(key);
    var tmp_20;
    if (tmp0_safe_receiver == null) {
      tmp_20 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_20 = to(tmp0_safe_receiver, Companion_getInstance_24().m1u(value));
    }
    var tmp0_safe_receiver_0 = tmp_20;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_21 = toMap(destination_0);
  // Inline function 'kotlin.collections.mapValues' call
  var this_7 = fromMap$obj(map, 'warmupOverrides');
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_1 = LinkedHashMap_init_$Create$(mapCapacity(this_7.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_1 = this_7.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp_22 = element_1.p1();
    var tmp$ret$30 = Companion_getInstance_24().m1u(element_1.q1());
    destination_1.l2(tmp_22, tmp$ret$30);
  }
  var tmp_23 = destination_1;
  var tmp_24 = fromMap$seconds(map, 'compoundRestSec');
  var tmp_25 = fromMap$seconds(map, 'isolationRestSec');
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_1 = fromMap$obj(map, 'restOverrides');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = tmp0_1.w1().j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.component1' call
    var id = element_2.p1();
    // Inline function 'kotlin.collections.component2' call
    var value_0 = element_2.q1();
    var tmp0_safe_receiver_1 = isNumber(value_0) ? value_0 : null;
    var tmp1_safe_receiver = tmp0_safe_receiver_1 == null ? null : numberToInt(tmp0_safe_receiver_1);
    var tmp_26;
    if (tmp1_safe_receiver == null) {
      tmp_26 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_27;
      if (0 <= tmp1_safe_receiver ? tmp1_safe_receiver <= 3600 : false) {
        tmp_27 = tmp1_safe_receiver;
      } else {
        tmp_27 = null;
      }
      tmp_26 = tmp_27;
    }
    var tmp2_safe_receiver = tmp_26;
    var tmp_28;
    if (tmp2_safe_receiver == null) {
      tmp_28 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_28 = to(id, tmp2_safe_receiver);
    }
    var tmp0_safe_receiver_2 = tmp_28;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_2.f(tmp0_safe_receiver_2);
    }
  }
  var tmp_29 = toMap(destination_2);
  var tmp_30 = fromMap$seconds(map, 'sideRestSec');
  var tmp_31 = fromMap$seconds(map, 'betweenExercisesSec');
  var tmp_32 = toSet(JsonRead_instance.h14(map, 'skills'));
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_2 = fromMap$obj(map, 'dismissedSuggestions');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_3 = tmp0_2.w1().j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    // Inline function 'kotlin.collections.component1' call
    var id_0 = element_3.p1();
    // Inline function 'kotlin.collections.component2' call
    var value_1 = element_3.q1();
    var tmp0_safe_receiver_3 = (!(value_1 == null) ? typeof value_1 === 'string' : false) ? value_1 : null;
    var tmp_33;
    if (tmp0_safe_receiver_3 == null) {
      tmp_33 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_33 = EpochDays_getInstance().de(tmp0_safe_receiver_3);
    }
    var tmp1_safe_receiver_0 = tmp_33;
    var tmp_34;
    if (tmp1_safe_receiver_0 == null) {
      tmp_34 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_34 = to(id_0, tmp1_safe_receiver_0);
    }
    var tmp0_safe_receiver_4 = tmp_34;
    if (tmp0_safe_receiver_4 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_3.f(tmp0_safe_receiver_4);
    }
  }
  return new TrainingSettings(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_17, tmp_18, tmp_19, tmp_21, tmp_23, tmp_24, tmp_25, tmp_29, tmp_30, tmp_31, tmp_32, toMap(destination_3));
};
protoOf(TrainingSettingsJson).h1w = function (settings) {
  var tmp0_safe_receiver = settings.b1v_1;
  var tmp = to('weekdays', tmp0_safe_receiver == null ? null : sorted(tmp0_safe_receiver));
  var tmp_0 = to('prefill', settings.c1v_1.x1_1);
  var tmp_1 = to('previousScope', settings.d1v_1.x1_1);
  var tmp_2 = to('inSessionFill', settings.e1v_1);
  var tmp_3 = to('rirAutofill', settings.f1v_1);
  var tmp_4 = to('propagateEdits', settings.g1v_1);
  var tmp_5 = to('priority', settings.h1v_1.x1_1);
  var tmp_6 = to('expandRepRange', settings.i1v_1);
  var tmp_7 = to('weightMatch', settings.j1v_1);
  var tmp_8 = to('rpeInput', settings.k1v_1);
  var tmp_9 = to('curve', settings.l1v_1.x1_1);
  var tmp_10 = to('fatigue', settings.m1v_1.x1_1);
  var tmp_11 = to('surprise', settings.n1v_1.x1_1);
  var tmp_12 = to('clampOneRepMax', settings.o1v_1);
  var tmp_13 = to('sessionStepPct', settings.p1v_1);
  var tmp_14 = to('smartWarmups', settings.q1v_1.x1_1);
  var tmp_15 = to('warmupLastRestSec', settings.r1v_1);
  // Inline function 'kotlin.collections.associate' call
  var this_0 = settings.s1v_1.w1();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.p1().a1v_1, Companion_getInstance_24().n1u(element.q1()));
    destination.l2(pair.nb_1, pair.ob_1);
  }
  var tmp_16 = to('warmupSchemes', destination);
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = settings.t1v_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_0 = LinkedHashMap_init_$Create$(mapCapacity(this_1.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_0 = this_1.w1().j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp_17 = element_0.p1();
    var tmp$ret$8 = Companion_getInstance_24().n1u(element_0.q1());
    destination_0.l2(tmp_17, tmp$ret$8);
  }
  var tmp_18 = to('warmupOverrides', destination_0);
  var tmp_19 = to('compoundRestSec', settings.u1v_1);
  var tmp_20 = to('isolationRestSec', settings.v1v_1);
  var tmp_21 = to('restOverrides', settings.w1v_1);
  var tmp_22 = to('sideRestSec', settings.x1v_1);
  var tmp_23 = to('betweenExercisesSec', settings.y1v_1);
  var tmp_24 = to('skills', sorted(settings.z1v_1));
  // Inline function 'kotlin.collections.mapValues' call
  var this_2 = settings.a1w_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_1 = LinkedHashMap_init_$Create$(mapCapacity(this_2.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_1 = this_2.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp_25 = element_1.p1();
    var tmp$ret$13 = EpochDays_getInstance().ee(element_1.q1());
    destination_1.l2(tmp_25, tmp$ret$13);
  }
  return linkedMapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, to('dismissedSuggestions', destination_1)]);
};
protoOf(TrainingSettingsJson).i1w = function (settings, existing) {
  var tmp;
  if (existing == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_0;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.og(Json_instance.ng(existing), 'training');
      tmp_0 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_0;
    tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp1_elvis_lhs = tmp;
  var old = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp_2 = Json_instance;
  // Inline function 'kotlin.apply' call
  var this_1 = LinkedHashMap_init_$Create$_0(old);
  this_1.j4(TrainingSettingsJson_instance.h1w(settings));
  return tmp_2.sg(this_1);
};
var TrainingSettingsJson_instance;
function TrainingSettingsJson_getInstance() {
  return TrainingSettingsJson_instance;
}
function Prefill_SMART_getInstance() {
  static_init_70();
  return Prefill_SMART_instance;
}
function Prefill_PREVIOUS_getInstance() {
  static_init_70();
  return Prefill_PREVIOUS_instance;
}
function PreviousScope_ANY_getInstance() {
  static_init_71();
  return PreviousScope_ANY_instance;
}
function PreviousScope_PROGRAM_getInstance() {
  static_init_71();
  return PreviousScope_PROGRAM_instance;
}
function WarmupCategory_UPPER_COMPOUND_getInstance() {
  static_init_72();
  return WarmupCategory_UPPER_COMPOUND_instance;
}
function WarmupCategory_LOWER_COMPOUND_getInstance() {
  static_init_72();
  return WarmupCategory_LOWER_COMPOUND_instance;
}
function WarmupCategory_UPPER_ISOLATION_getInstance() {
  static_init_72();
  return WarmupCategory_UPPER_ISOLATION_instance;
}
function WarmupCategory_LOWER_ISOLATION_getInstance() {
  static_init_72();
  return WarmupCategory_LOWER_ISOLATION_instance;
}
function WarmupCategory_CORE_getInstance() {
  static_init_72();
  return WarmupCategory_CORE_instance;
}
function TrainingWeekdays() {
  TrainingWeekdays_instance = this;
  this.j1w_1 = mapOf_0([to(1, setOf_0(1)), to(2, setOf([1, 4])), to(3, setOf([1, 3, 5])), to(4, setOf([1, 2, 4, 5])), to(5, setOf([1, 2, 3, 5, 6])), to(6, setOf([1, 2, 3, 4, 5, 6]))]);
}
protoOf(TrainingWeekdays).k1w = function (sessions) {
  var tmp;
  if (sessions >= 7) {
    tmp = toSet(numberRangeToNumber(1, 7));
  } else {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = this.j1w_1.t1(sessions);
    tmp = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(TrainingWeekdays).l1w = function (chosen, activeProgramSessions) {
  var tmp;
  if (chosen == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = chosen.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (1 <= element ? element <= 7 : false) {
        destination.f(element);
      }
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toSet(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    var tmp_1;
    if (activeProgramSessions == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = this.k1w(activeProgramSessions);
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp_1;
    tmp_0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  return tmp_0;
};
var TrainingWeekdays_instance;
function TrainingWeekdays_getInstance() {
  if (TrainingWeekdays_instance == null)
    new TrainingWeekdays();
  return TrainingWeekdays_instance;
}
function WarmupStep(pct, reps) {
  this.o1u_1 = pct;
  this.p1u_1 = reps;
}
protoOf(WarmupStep).toString = function () {
  return 'WarmupStep(pct=' + this.o1u_1 + ', reps=' + this.p1u_1 + ')';
};
protoOf(WarmupStep).hashCode = function () {
  var result = getNumberHashCode(this.o1u_1);
  result = imul(result, 31) + this.p1u_1 | 0;
  return result;
};
protoOf(WarmupStep).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WarmupStep))
    return false;
  if (!equals(this.o1u_1, other.o1u_1))
    return false;
  if (!(this.p1u_1 === other.p1u_1))
    return false;
  return true;
};
function WarmupSet(loadKg, reps, pct) {
  this.m1w_1 = loadKg;
  this.n1w_1 = reps;
  this.o1w_1 = pct;
}
protoOf(WarmupSet).toString = function () {
  return 'WarmupSet(loadKg=' + this.m1w_1 + ', reps=' + this.n1w_1 + ', pct=' + this.o1w_1 + ')';
};
protoOf(WarmupSet).hashCode = function () {
  var result = getNumberHashCode(this.m1w_1);
  result = imul(result, 31) + this.n1w_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.o1w_1) | 0;
  return result;
};
protoOf(WarmupSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WarmupSet))
    return false;
  if (!equals(this.m1w_1, other.m1w_1))
    return false;
  if (!(this.n1w_1 === other.n1w_1))
    return false;
  if (!equals(this.o1w_1, other.o1w_1))
    return false;
  return true;
};
var static_init_called_73;
function static_init_73() {
  if (static_init_called_73)
    return Unit_instance;
  static_init_called_73 = true;
  SmartWarmupStyle_OURS_instance = new SmartWarmupStyle('OURS', 0);
}
var SmartWarmupStyle_OURS_instance;
function values_50() {
  static_init_73();
  return [SmartWarmupStyle_OURS_getInstance()];
}
function get_entries_45() {
  static_init_73();
  if ($ENTRIES_45 == null)
    $ENTRIES_45 = enumEntries(values_50());
  return $ENTRIES_45;
}
var $ENTRIES_45;
function SmartWarmupStyle(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function halfUp($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function sam$kotlin_Comparator$0_20(function_0) {
  this.p1w_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_20).ea = function (a, b) {
  return this.p1w_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_20).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_20).h2 = function () {
  return this.p1w_1;
};
protoOf(sam$kotlin_Comparator$0_20).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_20).hashCode = function () {
  return hashCode(this.h2());
};
function Warmups$generate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1u_1;
  var tmp$ret$2 = b.o1u_1;
  return compareValues(tmp, tmp$ret$2);
}
function Warmups() {
  Warmups_instance = this;
  this.j1m_1 = listOf([new WarmupStep(40.0, 8), new WarmupStep(60.0, 5), new WarmupStep(80.0, 3)]);
  this.k1m_1 = listOf([0.45, 0.65, 0.8, 0.9]);
  this.l1m_1 = 0.9;
  this.m1m_1 = 10;
  this.n1m_1 = 0.025;
  this.o1m_1 = 120;
}
protoOf(Warmups).q1w = function (workingLoadKg, loads, scheme, minLoadKg) {
  // Inline function 'kotlin.require' call
  if (!(workingLoadKg >= 0.0)) {
    var message = 'workingLoadKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(scheme, Collection)) {
      tmp = scheme.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = scheme.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(element.o1u_1 > 0.0 && element.p1u_1 > 0)) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
    }
    tmp$ret$2 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$2) {
    var message_0 = 'warm-up steps need a positive % and reps';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var sets = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = Warmups$generate$lambda;
  var tmp$ret$7 = new sam$kotlin_Comparator$0_20(tmp_0);
  var _iterator__ex2g4s_0 = sortedWith(scheme, tmp$ret$7).j();
  $l$loop_1: while (_iterator__ex2g4s_0.k()) {
    var step = _iterator__ex2g4s_0.l();
    var raw = workingLoadKg * step.o1u_1 / 100.0;
    if (raw < minLoadKg - 1.0E-9)
      continue $l$loop_1;
    var tmp1_elvis_lhs = Loads_instance.i1i(loads, raw);
    var load = tmp1_elvis_lhs == null ? Loads_instance.v1h(raw) : tmp1_elvis_lhs;
    if (load < minLoadKg - 1.0E-9 || load >= workingLoadKg - 1.0E-9)
      continue $l$loop_1;
    var tmp_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!sets.m()) {
      // Inline function 'kotlin.math.abs' call
      var x = last(sets).m1w_1 - load;
      tmp_1 = Math.abs(x) < 1.0E-9;
    } else {
      tmp_1 = false;
    }
    if (tmp_1)
      continue $l$loop_1;
    sets.f(new WarmupSet(load, step.p1u_1, step.o1u_1));
  }
  return sets;
};
protoOf(Warmups).r1w = function (workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar) {
  // Inline function 'kotlin.require' call
  if (!(workingLoadKg >= 0.0)) {
    var message = 'workingLoadKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (oneRepMaxKg == null || oneRepMaxKg <= 0.0)
    return this.q1w(workingLoadKg, loads, this.j1m_1, minLoadKg);
  var ratio = (workingLoadKg + bodyweightKg) / oneRepMaxKg;
  var tmp;
  if (style.y1_1 === 0) {
    var tmp0 = this.k1m_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$2 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element < ratio) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$2 = count;
    }
    var rungs = tmp$ret$2;
    var tmp_1;
    switch (rungs) {
      case 0:
        tmp_1 = emptyList();
        break;
      case 1:
        tmp_1 = listOf_0(first(this.k1m_1));
        break;
      default:
        // Inline function 'kotlin.collections.map' call

        var this_0 = until(0, rungs);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.xc_1;
        var last_0 = this_0.yc_1;
        if (inductionVariable <= last_0)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = item;
            var tmp$ret$6 = first(Warmups_getInstance().k1m_1) + (0.9 * ratio - first(Warmups_getInstance().k1m_1)) * it / (rungs - 1 | 0);
            destination.f(tmp$ret$6);
          }
           while (!(item === last_0));
        tmp_1 = destination;
        break;
    }
    var pcts = tmp_1;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(pcts, 10));
    var _iterator__ex2g4s_0 = pcts.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$9 = coerceIn_0(halfUp(Warmups_getInstance(), curve.h1q(item_0 * oneRepMaxKg, oneRepMaxKg) / 3.0), 1, 10);
      destination_0.f(tmp$ret$9);
    }
    var reps = destination_0;
    var all = zip(pcts, reps);
    tmp = warmedUp ? takeLast(all, 1) : all;
  } else {
    noWhenBranchMatchedException();
  }
  var steps = tmp;
  var sets = ArrayList_init_$Create$_0();
  var previousPlates = null;
  var _iterator__ex2g4s_1 = steps.j();
  $l$loop_1: while (_iterator__ex2g4s_1.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_1.l();
    var pct = _destruct__k2r9zo.hb();
    var reps_0 = _destruct__k2r9zo.ib();
    var raw = pct * oneRepMaxKg - bodyweightKg;
    if (raw < minLoadKg - 1.0E-9)
      continue $l$loop_1;
    var load = this.s1w(raw, loads, bar, previousPlates);
    if (load < minLoadKg - 1.0E-9 || load >= workingLoadKg - 1.0E-9)
      continue $l$loop_1;
    var tmp_2;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!sets.m()) {
      // Inline function 'kotlin.math.abs' call
      var x = last(sets).m1w_1 - load;
      tmp_2 = Math.abs(x) < 1.0E-9;
    } else {
      tmp_2 = false;
    }
    if (tmp_2)
      continue $l$loop_1;
    sets.f(new WarmupSet(load, reps_0, workingLoadKg > 0.0 ? 100.0 * load / workingLoadKg : 0.0));
    var tmp_3;
    if (bar == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      var barKg = bar.hb();
      var plates = bar.ib();
      tmp_3 = PlateCalculator_instance.t1i(load, barKg, plates).q1h_1;
    }
    previousPlates = tmp_3;
  }
  return sets;
};
protoOf(Warmups).t1w = function (workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar, $super) {
  style = style === VOID ? SmartWarmupStyle_OURS_getInstance() : style;
  curve = curve === VOID ? new EpleyCurve() : curve;
  warmedUp = warmedUp === VOID ? false : warmedUp;
  bodyweightKg = bodyweightKg === VOID ? 0.0 : bodyweightKg;
  var tmp;
  if (minLoadKg === VOID) {
    var tmp0_elvis_lhs = minOrNull(loads);
    tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  } else {
    tmp = minLoadKg;
  }
  minLoadKg = tmp;
  bar = bar === VOID ? null : bar;
  return $super === VOID ? this.r1w(workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar) : $super.r1w.call(this, workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar);
};
protoOf(Warmups).s1w = function (target, loads, bar, previousPlates) {
  var tmp0_elvis_lhs = Loads_instance.i1i(loads, target);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Loads_instance.v1h(target);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nearest = tmp;
  if (bar == null || previousPlates == null)
    return nearest;
  var barKg = bar.hb();
  var plates = bar.ib();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = loads.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.math.abs' call
    var x = element - target;
    if (Math.abs(x) <= 0.025 * target + 1.0E-9) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (PlateCalculator_instance.u1i(previousPlates, PlateCalculator_instance.t1i(element_0, barKg, plates).q1h_1)) {
      destination_0.f(element_0);
    }
  }
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.minByOrNull' call
    var iterator = destination_0.j();
    if (!iterator.k()) {
      tmp$ret$7 = null;
      break $l$block_0;
    }
    var minElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$7 = minElem;
      break $l$block_0;
    }
    // Inline function 'kotlin.math.abs' call
    var x_0 = minElem - target;
    var minValue = Math.abs(x_0);
    do {
      var e = iterator.l();
      // Inline function 'kotlin.math.abs' call
      var x_1 = e - target;
      var v = Math.abs(x_1);
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$7 = minElem;
  }
  var tmp1_elvis_lhs = tmp$ret$7;
  return tmp1_elvis_lhs == null ? nearest : tmp1_elvis_lhs;
};
protoOf(Warmups).b1n = function (equipment) {
  var seen = HashSet_init_$Create$();
  var result = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = equipment.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    if (!item.equals(Equipment_BODYWEIGHT_getInstance()) && !item.equals(Equipment_BAND_getInstance()) && !item.equals(Equipment_OTHER_getInstance()) && seen.f(item)) {
      result.f(index_0);
    }
  }
  return result;
};
var Warmups_instance;
function Warmups_getInstance() {
  if (Warmups_instance == null)
    new Warmups();
  return Warmups_instance;
}
function SmartWarmupStyle_OURS_getInstance() {
  static_init_73();
  return SmartWarmupStyle_OURS_instance;
}
var static_init_called_74;
function static_init_74() {
  if (static_init_called_74)
    return Unit_instance;
  static_init_called_74 = true;
  TrendMethod_CLASSIC_instance = new TrendMethod('CLASSIC', 0);
  TrendMethod_LESS_LAG_instance = new TrendMethod('LESS_LAG', 1);
  TrendMethod_CLASSIC_FAST_instance = new TrendMethod('CLASSIC_FAST', 2);
  TrendMethod_LESS_LAG_WATER_instance = new TrendMethod('LESS_LAG_WATER', 3);
}
var TrendMethod_CLASSIC_instance;
var TrendMethod_LESS_LAG_instance;
var TrendMethod_CLASSIC_FAST_instance;
var TrendMethod_LESS_LAG_WATER_instance;
function valueOf_16(value) {
  static_init_74();
  switch (value) {
    case 'CLASSIC':
      return TrendMethod_CLASSIC_getInstance();
    case 'LESS_LAG':
      return TrendMethod_LESS_LAG_getInstance();
    case 'CLASSIC_FAST':
      return TrendMethod_CLASSIC_FAST_getInstance();
    case 'LESS_LAG_WATER':
      return TrendMethod_LESS_LAG_WATER_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.trend.TrendMethod.' + value);
      break;
  }
}
function TrendMethod(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Trend() {
}
protoOf(Trend).rw = function (weighIns, endDay, method) {
  var tmp;
  switch (method.y1_1) {
    case 0:
      tmp = WeightTrend_instance.on(weighIns, endDay);
      break;
    case 2:
      tmp = WeightTrend_instance.u1w(weighIns, endDay, 0.2222222222222222);
      break;
    case 1:
      tmp = LessLagTrend_instance.v1w(weighIns, endDay);
      break;
    case 3:
      // Inline function 'kotlin.collections.map' call

      var this_0 = TransientTrend_instance.w1w(weighIns, endDay);
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.j();
      while (_iterator__ex2g4s.k()) {
        var item = _iterator__ex2g4s.l();
        var tmp$ret$2 = item.uu_1;
        destination.f(tmp$ret$2);
      }

      tmp = destination;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Trend_instance;
function Trend_getInstance() {
  return Trend_instance;
}
function LessLagParams(measurementSdKg, levelSdKg, slopeSdKgPerDay, initialSlopeSdKgPerDay) {
  measurementSdKg = measurementSdKg === VOID ? 0.4 : measurementSdKg;
  levelSdKg = levelSdKg === VOID ? 0.02 : levelSdKg;
  slopeSdKgPerDay = slopeSdKgPerDay === VOID ? 0.002 : slopeSdKgPerDay;
  initialSlopeSdKgPerDay = initialSlopeSdKgPerDay === VOID ? 0.05 : initialSlopeSdKgPerDay;
  this.x1w_1 = measurementSdKg;
  this.y1w_1 = levelSdKg;
  this.z1w_1 = slopeSdKgPerDay;
  this.a1x_1 = initialSlopeSdKgPerDay;
  // Inline function 'kotlin.require' call
  if (!(this.x1w_1 > 0.0 && this.y1w_1 >= 0.0 && this.z1w_1 > 0.0 && this.a1x_1 > 0.0)) {
    var message = 'noise settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(LessLagParams).toString = function () {
  return 'LessLagParams(measurementSdKg=' + this.x1w_1 + ', levelSdKg=' + this.y1w_1 + ', slopeSdKgPerDay=' + this.z1w_1 + ', initialSlopeSdKgPerDay=' + this.a1x_1 + ')';
};
protoOf(LessLagParams).hashCode = function () {
  var result = getNumberHashCode(this.x1w_1);
  result = imul(result, 31) + getNumberHashCode(this.y1w_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z1w_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a1x_1) | 0;
  return result;
};
protoOf(LessLagParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LessLagParams))
    return false;
  if (!equals(this.x1w_1, other.x1w_1))
    return false;
  if (!equals(this.y1w_1, other.y1w_1))
    return false;
  if (!equals(this.z1w_1, other.z1w_1))
    return false;
  if (!equals(this.a1x_1, other.a1x_1))
    return false;
  return true;
};
function State(level, slope, p00, p01, p11) {
  this.b1x_1 = level;
  this.c1x_1 = slope;
  this.d1x_1 = p00;
  this.e1x_1 = p01;
  this.f1x_1 = p11;
}
function smooth($this, predicted, filtered) {
  var n = filtered.o();
  var levels = new Float64Array(n);
  var slopes = new Float64Array(n);
  levels[n - 1 | 0] = filtered.n(n - 1 | 0).b1x_1;
  slopes[n - 1 | 0] = filtered.n(n - 1 | 0).c1x_1;
  var inductionVariable = n - 2 | 0;
  if (0 <= inductionVariable)
    $l$loop: do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var f = filtered.n(i);
      var p = predicted.n(i + 1 | 0);
      var a00 = f.d1x_1 + f.e1x_1;
      var a01 = f.e1x_1;
      var a10 = f.e1x_1 + f.f1x_1;
      var a11 = f.f1x_1;
      var det = p.d1x_1 * p.f1x_1 - p.e1x_1 * p.e1x_1;
      if (det <= 1.0E-18) {
        levels[i] = f.b1x_1;
        slopes[i] = f.c1x_1;
        continue $l$loop;
      }
      var i00 = p.f1x_1 / det;
      var i01 = -p.e1x_1 / det;
      var i11 = p.d1x_1 / det;
      var c00 = a00 * i00 + a01 * i01;
      var c01 = a00 * i01 + a01 * i11;
      var c10 = a10 * i00 + a11 * i01;
      var c11 = a10 * i01 + a11 * i11;
      var dLevel = levels[i + 1 | 0] - p.b1x_1;
      var dSlope = slopes[i + 1 | 0] - p.c1x_1;
      levels[i] = f.b1x_1 + c00 * dLevel + c01 * dSlope;
      slopes[i] = f.c1x_1 + c10 * dLevel + c11 * dSlope;
    }
     while (0 <= inductionVariable);
  return levels;
}
function LessLagTrend$compute$$inlined$groupingBy$1($this) {
  this.g1x_1 = $this;
}
protoOf(LessLagTrend$compute$$inlined$groupingBy$1).j2 = function () {
  return this.g1x_1.j();
};
protoOf(LessLagTrend$compute$$inlined$groupingBy$1).o12 = function (element) {
  return element.gm_1;
};
protoOf(LessLagTrend$compute$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function LessLagTrend() {
}
protoOf(LessLagTrend).h1x = function (weighIns, endDay, params) {
  var daily = WeightTrend_instance.um(weighIns);
  if (daily.m())
    return emptyList();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weighIns.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.hm_1 >= 25.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$3 = new LessLagTrend$compute$$inlined$groupingBy$1(destination);
  var counts = eachCount(tmp$ret$3);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = daily.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = element_0.gm_1;
    var tmp$ret$7 = element_0.hm_1;
    destination_0.l2(tmp, tmp$ret$7);
  }
  var byDay = destination_0;
  var firstDay = first(daily).gm_1;
  var tmp0 = endDay == null ? last(daily).gm_1 : endDay;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = last(daily).gm_1;
  var lastDay = Math.max(tmp0, b);
  var r = params.x1w_1 * params.x1w_1;
  var qLevel = params.y1w_1 * params.y1w_1;
  var qSlope = params.z1w_1 * params.z1w_1;
  var predicted = ArrayList_init_$Create$((lastDay - firstDay | 0) + 1 | 0);
  var filtered = ArrayList_init_$Create$((lastDay - firstDay | 0) + 1 | 0);
  var state = new State(first(daily).hm_1, 0.0, r, 0.0, params.a1x_1 * params.a1x_1);
  var inductionVariable = firstDay;
  if (inductionVariable <= lastDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0;
      if (day === firstDay) {
        tmp_0 = state;
      } else {
        tmp_0 = new State(state.b1x_1 + state.c1x_1, state.c1x_1, state.d1x_1 + 2 * state.e1x_1 + state.f1x_1 + qLevel, state.e1x_1 + state.f1x_1, state.f1x_1 + qSlope);
      }
      var prior = tmp_0;
      predicted.f(prior);
      var reading = byDay.t1(day);
      var tmp_1;
      if (reading == null || day === firstDay) {
        tmp_1 = prior;
      } else {
        var tmp1_elvis_lhs = counts.t1(day);
        var variance = r / (tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs);
        var s = prior.d1x_1 + variance;
        var k0 = prior.d1x_1 / s;
        var k1 = prior.e1x_1 / s;
        var innovation = reading - prior.b1x_1;
        tmp_1 = new State(prior.b1x_1 + k0 * innovation, prior.c1x_1 + k1 * innovation, prior.d1x_1 - k0 * prior.d1x_1, prior.e1x_1 - k0 * prior.e1x_1, prior.f1x_1 - k1 * prior.e1x_1);
      }
      state = tmp_1;
      filtered.f(state);
    }
     while (!(day === lastDay));
  var smoothedLevels = smooth(this, predicted, filtered);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = numberRangeToNumber(firstDay, lastDay);
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var inductionVariable_0 = this_0.xc_1;
  var last_0 = this_0.yc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var tmp0_0 = checkIndexOverflow(_unary__edvuaz);
      var day_0 = item;
      var scale = byDay.t1(day_0);
      var tmp$ret$11 = new TrendPoint(day_0, scale, scale == null ? smoothedLevels[tmp0_0] : scale, smoothedLevels[tmp0_0]);
      destination_1.f(tmp$ret$11);
    }
     while (!(item === last_0));
  return destination_1;
};
protoOf(LessLagTrend).v1w = function (weighIns, endDay, params, $super) {
  endDay = endDay === VOID ? null : endDay;
  params = params === VOID ? new LessLagParams() : params;
  return $super === VOID ? this.h1x(weighIns, endDay, params) : $super.h1x.call(this, weighIns, endDay, params);
};
var LessLagTrend_instance;
function LessLagTrend_getInstance() {
  return LessLagTrend_instance;
}
function TrendMethod_CLASSIC_getInstance() {
  static_init_74();
  return TrendMethod_CLASSIC_instance;
}
function TrendMethod_LESS_LAG_getInstance() {
  static_init_74();
  return TrendMethod_LESS_LAG_instance;
}
function TrendMethod_CLASSIC_FAST_getInstance() {
  static_init_74();
  return TrendMethod_CLASSIC_FAST_instance;
}
function TrendMethod_LESS_LAG_WATER_getInstance() {
  static_init_74();
  return TrendMethod_LESS_LAG_WATER_instance;
}
function TransientTrendParams(levelSdKg, slopeSdKgPerDay, initialSlopeSdKgPerDay, transientSdKg, transientHalfLifeDays, readingNoiseFraction, readingNoiseMinKg, readingNoiseMaxKg, readingNoiseKg, robust, huberK, residualWindow, minResiduals) {
  levelSdKg = levelSdKg === VOID ? 0.02 : levelSdKg;
  slopeSdKgPerDay = slopeSdKgPerDay === VOID ? 0.002 : slopeSdKgPerDay;
  initialSlopeSdKgPerDay = initialSlopeSdKgPerDay === VOID ? 0.05 : initialSlopeSdKgPerDay;
  transientSdKg = transientSdKg === VOID ? 0.3 : transientSdKg;
  transientHalfLifeDays = transientHalfLifeDays === VOID ? 3.5 : transientHalfLifeDays;
  readingNoiseFraction = readingNoiseFraction === VOID ? 0.007 : readingNoiseFraction;
  readingNoiseMinKg = readingNoiseMinKg === VOID ? 0.45 : readingNoiseMinKg;
  readingNoiseMaxKg = readingNoiseMaxKg === VOID ? 0.85 : readingNoiseMaxKg;
  readingNoiseKg = readingNoiseKg === VOID ? 0.4 : readingNoiseKg;
  robust = robust === VOID ? true : robust;
  huberK = huberK === VOID ? 1.345 : huberK;
  residualWindow = residualWindow === VOID ? 30 : residualWindow;
  minResiduals = minResiduals === VOID ? 7 : minResiduals;
  this.i1x_1 = levelSdKg;
  this.j1x_1 = slopeSdKgPerDay;
  this.k1x_1 = initialSlopeSdKgPerDay;
  this.l1x_1 = transientSdKg;
  this.m1x_1 = transientHalfLifeDays;
  this.n1x_1 = readingNoiseFraction;
  this.o1x_1 = readingNoiseMinKg;
  this.p1x_1 = readingNoiseMaxKg;
  this.q1x_1 = readingNoiseKg;
  this.r1x_1 = robust;
  this.s1x_1 = huberK;
  this.t1x_1 = residualWindow;
  this.u1x_1 = minResiduals;
  // Inline function 'kotlin.require' call
  if (!(this.i1x_1 >= 0.0 && this.j1x_1 > 0.0 && this.k1x_1 > 0.0 && this.l1x_1 >= 0.0)) {
    var message = 'noise must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.m1x_1 >= 0.0 && this.q1x_1 > 0.0 && this.o1x_1 > 0.0 && this.p1x_1 >= this.o1x_1)) {
    var message_0 = 'settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(this.s1x_1 > 0.0 && this.t1x_1 > 0 && this.u1x_1 > 0)) {
    var message_1 = 'robust settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(TransientTrendParams).toString = function () {
  return 'TransientTrendParams(levelSdKg=' + this.i1x_1 + ', slopeSdKgPerDay=' + this.j1x_1 + ', initialSlopeSdKgPerDay=' + this.k1x_1 + ', transientSdKg=' + this.l1x_1 + ', transientHalfLifeDays=' + this.m1x_1 + ', readingNoiseFraction=' + this.n1x_1 + ', readingNoiseMinKg=' + this.o1x_1 + ', readingNoiseMaxKg=' + this.p1x_1 + ', readingNoiseKg=' + this.q1x_1 + ', robust=' + this.r1x_1 + ', huberK=' + this.s1x_1 + ', residualWindow=' + this.t1x_1 + ', minResiduals=' + this.u1x_1 + ')';
};
protoOf(TransientTrendParams).hashCode = function () {
  var result = getNumberHashCode(this.i1x_1);
  result = imul(result, 31) + getNumberHashCode(this.j1x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.k1x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.l1x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.m1x_1) | 0;
  result = imul(result, 31) + (this.n1x_1 == null ? 0 : getNumberHashCode(this.n1x_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.o1x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.p1x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.q1x_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.r1x_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.s1x_1) | 0;
  result = imul(result, 31) + this.t1x_1 | 0;
  result = imul(result, 31) + this.u1x_1 | 0;
  return result;
};
protoOf(TransientTrendParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransientTrendParams))
    return false;
  if (!equals(this.i1x_1, other.i1x_1))
    return false;
  if (!equals(this.j1x_1, other.j1x_1))
    return false;
  if (!equals(this.k1x_1, other.k1x_1))
    return false;
  if (!equals(this.l1x_1, other.l1x_1))
    return false;
  if (!equals(this.m1x_1, other.m1x_1))
    return false;
  if (!equals(this.n1x_1, other.n1x_1))
    return false;
  if (!equals(this.o1x_1, other.o1x_1))
    return false;
  if (!equals(this.p1x_1, other.p1x_1))
    return false;
  if (!equals(this.q1x_1, other.q1x_1))
    return false;
  if (!(this.r1x_1 === other.r1x_1))
    return false;
  if (!equals(this.s1x_1, other.s1x_1))
    return false;
  if (!(this.t1x_1 === other.t1x_1))
    return false;
  if (!(this.u1x_1 === other.u1x_1))
    return false;
  return true;
};
function TransientTrendPoint(point, transientKg, noiseKg) {
  this.uu_1 = point;
  this.vu_1 = transientKg;
  this.wu_1 = noiseKg;
}
protoOf(TransientTrendPoint).toString = function () {
  return 'TransientTrendPoint(point=' + this.uu_1.toString() + ', transientKg=' + this.vu_1 + ', noiseKg=' + this.wu_1 + ')';
};
protoOf(TransientTrendPoint).hashCode = function () {
  var result = this.uu_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.vu_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.wu_1) | 0;
  return result;
};
protoOf(TransientTrendPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransientTrendPoint))
    return false;
  if (!this.uu_1.equals(other.uu_1))
    return false;
  if (!equals(this.vu_1, other.vu_1))
    return false;
  if (!equals(this.wu_1, other.wu_1))
    return false;
  return true;
};
function update_0($this, x, p, innovation, r) {
  var tmp = 0;
  var tmp_0 = new Float64Array(3);
  while (tmp < 3) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = p.k12(tmp_1, 0) + p.k12(tmp_1, 2);
    tmp = tmp + 1 | 0;
  }
  var ph = tmp_0;
  var s = ph[0] + ph[2] + r;
  var tmp_2 = 0;
  var tmp_3 = new Float64Array(3);
  while (tmp_2 < 3) {
    var tmp_4 = tmp_2;
    tmp_3[tmp_4] = ph[tmp_4] / s;
    tmp_2 = tmp_2 + 1 | 0;
  }
  var gain = tmp_3;
  var tmp_5 = 0;
  var tmp_6 = new Float64Array(9);
  while (tmp_5 < 9) {
    var tmp_7 = tmp_5;
    var i = tmp_7 / 3 | 0;
    var j = tmp_7 % 3 | 0;
    tmp_6[tmp_7] = (i === j ? 1.0 : 0.0) - gain[i] * (j === 0 || j === 2 ? 1.0 : 0.0);
    tmp_5 = tmp_5 + 1 | 0;
  }
  var a = new Matrix3(tmp_6);
  var joseph = a.l12(p).m12(a);
  var tmp_8 = 0;
  var tmp_9 = new Float64Array(9);
  while (tmp_8 < 9) {
    var tmp_10 = tmp_8;
    tmp_9[tmp_10] = joseph.j12_1[tmp_10] + gain[tmp_10 / 3 | 0] * r * gain[tmp_10 % 3 | 0];
    tmp_8 = tmp_8 + 1 | 0;
  }
  var covariance = new Matrix3(tmp_9);
  var tmp_11 = 0;
  var tmp_12 = new Float64Array(3);
  while (tmp_11 < 3) {
    var tmp_13 = tmp_11;
    tmp_12[tmp_13] = x[tmp_13] + gain[tmp_13] * innovation;
    tmp_11 = tmp_11 + 1 | 0;
  }
  return to(tmp_12, covariance);
}
function smooth_0($this, f, predictedX, predictedP, filteredX, filteredP) {
  var n = filteredX.o();
  var result = ArrayList_init_$Create$_1(filteredX);
  var inductionVariable = n - 2 | 0;
  if (0 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var c = filteredP.n(i).m12(f).l12(predictedP.n(i + 1 | 0).s12());
      var next = result.n(i + 1 | 0);
      var pred = predictedX.n(i + 1 | 0);
      var tmp = 0;
      var tmp_0 = new Float64Array(3);
      while (tmp < 3) {
        var tmp_1 = tmp;
        tmp_0[tmp_1] = next[tmp_1] - pred[tmp_1];
        tmp = tmp + 1 | 0;
      }
      var diff = tmp_0;
      var tmp_2 = 0;
      var tmp_3 = new Float64Array(3);
      while (tmp_2 < 3) {
        var tmp_4 = tmp_2;
        tmp_3[tmp_4] = filteredX.n(i)[tmp_4] + c.k12(tmp_4, 0) * diff[0] + c.k12(tmp_4, 1) * diff[1] + c.k12(tmp_4, 2) * diff[2];
        tmp_2 = tmp_2 + 1 | 0;
      }
      result.o2(i, tmp_3);
    }
     while (0 <= inductionVariable);
  return result;
}
function median($this, values) {
  var sorted_0 = sorted(values);
  var middle = sorted_0.o() / 2 | 0;
  return (sorted_0.o() % 2 | 0) === 1 ? sorted_0.n(middle) : (sorted_0.n(middle - 1 | 0) + sorted_0.n(middle)) / 2.0;
}
function TransientTrend$compute$$inlined$groupingBy$1($this) {
  this.v1x_1 = $this;
}
protoOf(TransientTrend$compute$$inlined$groupingBy$1).j2 = function () {
  return this.v1x_1.j();
};
protoOf(TransientTrend$compute$$inlined$groupingBy$1).o12 = function (element) {
  return element.gm_1;
};
protoOf(TransientTrend$compute$$inlined$groupingBy$1).k2 = function (element) {
  return this.o12(element);
};
function TransientTrend() {
  this.ru_1 = 1.4826;
  this.su_1 = 1.0E-12;
}
protoOf(TransientTrend).tu = function (weighIns, endDay, params) {
  var daily = WeightTrend_instance.um(weighIns);
  if (daily.m())
    return emptyList();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weighIns.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.hm_1 >= 25.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$3 = new TransientTrend$compute$$inlined$groupingBy$1(destination);
  var counts = eachCount(tmp$ret$3);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = daily.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = element_0.gm_1;
    var tmp$ret$7 = element_0.hm_1;
    destination_0.l2(tmp, tmp$ret$7);
  }
  var byDay = destination_0;
  var firstDay = first(daily).gm_1;
  var tmp0 = endDay == null ? last(daily).gm_1 : endDay;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = last(daily).gm_1;
  var lastDay = Math.max(tmp0, b);
  var tmp_0;
  if (params.m1x_1 === 0.0) {
    tmp_0 = 0.0;
  } else {
    // Inline function 'kotlin.math.pow' call
    var x = 1.0 / params.m1x_1;
    tmp_0 = Math.pow(0.5, x);
  }
  var phi = tmp_0;
  var transientVariance = params.l1x_1 * params.l1x_1;
  // Inline function 'kotlin.doubleArrayOf' call
  var tmp$ret$10 = new Float64Array([1.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, phi]);
  var f = new Matrix3(tmp$ret$10);
  var qLevel = params.i1x_1 * params.i1x_1;
  var qSlope = params.j1x_1 * params.j1x_1;
  var qTransient = transientVariance * (1.0 - phi * phi) + 1.0E-12;
  var firstNoise = this.w1x(first(daily).hm_1, params);
  var n = (lastDay - firstDay | 0) + 1 | 0;
  var predictedX = ArrayList_init_$Create$(n);
  var predictedP = ArrayList_init_$Create$(n);
  var filteredX = ArrayList_init_$Create$(n);
  var filteredP = ArrayList_init_$Create$(n);
  // Inline function 'kotlin.doubleArrayOf' call
  var x_0 = new Float64Array([first(daily).hm_1, 0.0, 0.0]);
  var p = Companion_instance_6.p12(firstNoise * firstNoise + transientVariance, params.k1x_1 * params.k1x_1, transientVariance + 1.0E-12);
  var residuals = ArrayDeque_init_$Create$();
  var inductionVariable = firstDay;
  if (inductionVariable <= lastDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(day === firstDay)) {
        // Inline function 'kotlin.doubleArrayOf' call
        x_0 = new Float64Array([x_0[0] + x_0[1], x_0[1], phi * x_0[2]]);
        p = f.l12(p).m12(f).q12(qLevel, qSlope, qTransient);
      }
      predictedX.f(x_0);
      predictedP.f(p);
      var reading = byDay.t1(day);
      if (!(reading == null) && !(day === firstDay)) {
        var sd = this.w1x(reading, params);
        var tmp_1 = sd * sd;
        var tmp1_elvis_lhs = counts.t1(day);
        var r = tmp_1 / (tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs);
        var innovation = reading - (x_0[0] + x_0[2]);
        var s = p.k12(0, 0) + 2.0 * p.k12(0, 2) + p.k12(2, 2) + r;
        if (params.r1x_1) {
          // Inline function 'kotlin.math.sqrt' call
          var z = innovation / Math.sqrt(s);
          if (residuals.ua_1 >= params.u1x_1) {
            var centre = median(this, residuals);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(residuals, 10));
            var _iterator__ex2g4s_1 = residuals.j();
            while (_iterator__ex2g4s_1.k()) {
              var item = _iterator__ex2g4s_1.l();
              // Inline function 'kotlin.math.abs' call
              var x_1 = item - centre;
              var tmp$ret$16 = Math.abs(x_1);
              destination_1.f(tmp$ret$16);
            }
            var scale = 1.4826 * median(this, destination_1);
            var tmp_2;
            if (scale > 0.0) {
              // Inline function 'kotlin.math.abs' call
              var x_2 = z - centre;
              tmp_2 = Math.abs(x_2) / scale;
            } else {
              tmp_2 = 0.0;
            }
            var u = tmp_2;
            if (u > params.s1x_1)
              r = r * (u / params.s1x_1);
          }
          residuals.ya(z);
          if (residuals.ua_1 > params.t1x_1) {
            residuals.za();
          }
        }
        var _destruct__k2r9zo = update_0(this, x_0, p, innovation, r);
        var updatedX = _destruct__k2r9zo.hb();
        var updatedP = _destruct__k2r9zo.ib();
        x_0 = updatedX;
        p = updatedP;
      }
      filteredX.f(x_0);
      filteredP.f(p);
    }
     while (!(day === lastDay));
  var smoothed = smooth_0(this, f, predictedX, predictedP, filteredX, filteredP);
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, n);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable_0 = this_0.xc_1;
  var last_0 = this_0.yc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var index = item_0;
      var day_0 = firstDay + index | 0;
      var scale_0 = byDay.t1(day_0);
      var level = smoothed.n(index)[0];
      var tmp_3 = TransientTrend_instance;
      // Inline function 'kotlin.let' call
      var it = tmp_3.w1x(scale_0 == null ? level : scale_0, params);
      // Inline function 'kotlin.math.sqrt' call
      var x_3 = it * it + transientVariance;
      var noise = Math.sqrt(x_3);
      var tmp$ret$21 = new TransientTrendPoint(new TrendPoint(day_0, scale_0, scale_0 == null ? level : scale_0, level), smoothed.n(index)[2], noise);
      destination_2.f(tmp$ret$21);
    }
     while (!(item_0 === last_0));
  return destination_2;
};
protoOf(TransientTrend).w1w = function (weighIns, endDay, params, $super) {
  endDay = endDay === VOID ? null : endDay;
  params = params === VOID ? new TransientTrendParams() : params;
  return $super === VOID ? this.tu(weighIns, endDay, params) : $super.tu.call(this, weighIns, endDay, params);
};
protoOf(TransientTrend).w1x = function (kg, params) {
  var tmp0_safe_receiver = params.n1x_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.math.max' call
    var tmp$ret$2 = Math.max(kg, 25.0);
    tmp = coerceIn(tmp0_safe_receiver * tmp$ret$2, params.o1x_1, params.p1x_1);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? params.q1x_1 : tmp1_elvis_lhs;
};
var TransientTrend_instance;
function TransientTrend_getInstance() {
  return TransientTrend_instance;
}
var static_init_called_75;
function static_init_75() {
  if (static_init_called_75)
    return Unit_instance;
  static_init_called_75 = true;
  Direction_INCREASE_instance = new Direction('INCREASE', 0);
  Direction_DECREASE_instance = new Direction('DECREASE', 1);
  Direction_NO_CHANGE_instance = new Direction('NO_CHANGE', 2);
}
var Direction_INCREASE_instance;
var Direction_DECREASE_instance;
var Direction_NO_CHANGE_instance;
function Direction(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeightChange(days, kg) {
  this.x1x_1 = days;
  this.y1x_1 = kg;
}
protoOf(WeightChange).sz = function () {
  var tmp0_safe_receiver = this.y1x_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp0_safe_receiver >= 0.05 ? Direction_INCREASE_getInstance() : tmp0_safe_receiver <= -0.05 ? Direction_DECREASE_getInstance() : Direction_NO_CHANGE_getInstance();
  }
  return tmp;
};
protoOf(WeightChange).toString = function () {
  return 'WeightChange(days=' + this.x1x_1 + ', kg=' + this.y1x_1 + ')';
};
protoOf(WeightChange).hashCode = function () {
  var result = this.x1x_1;
  result = imul(result, 31) + (this.y1x_1 == null ? 0 : getNumberHashCode(this.y1x_1)) | 0;
  return result;
};
protoOf(WeightChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightChange))
    return false;
  if (!(this.x1x_1 === other.x1x_1))
    return false;
  if (!equals(this.y1x_1, other.y1x_1))
    return false;
  return true;
};
function Companion_29() {
  Companion_instance_31 = this;
  this.ex_1 = listOf([3, 7, 14, 30, 90]);
  this.fx_1 = 21;
  this.gx_1 = 30;
  this.hx_1 = 0.05;
}
protoOf(Companion_29).z1x = function (points, kcalPerKg, windows, weeklyWindowDays, projectionDays) {
  // Inline function 'kotlin.require' call
  if (!(kcalPerKg > 0.0)) {
    var message = 'kcalPerKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(weeklyWindowDays > 0 && projectionDays > 0)) {
    var message_0 = 'windows must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var tmp0_elvis_lhs = lastOrNull(points);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var current = tmp;
  var tmp1_safe_receiver = this.ix(points, weeklyWindowDays);
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = tmp1_safe_receiver / weeklyWindowDays * 7.0;
  }
  var weekly = tmp_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(windows, 10));
  var _iterator__ex2g4s = windows.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$8 = new WeightChange(item, Companion_getInstance_28().ix(points, item));
    destination.f(tmp$ret$8);
  }
  var tmp_1 = destination;
  var tmp_2;
  if (weekly == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = weekly / 7.0 * kcalPerKg;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  if (weekly == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = current.sn_1 + weekly / 7.0 * projectionDays;
  }
  return new WeightInsights(current.sn_1, tmp_1, weekly, tmp_3, tmp_4, projectionDays);
};
protoOf(Companion_29).a1y = function (points, kcalPerKg, windows, weeklyWindowDays, projectionDays, $super) {
  windows = windows === VOID ? this.ex_1 : windows;
  weeklyWindowDays = weeklyWindowDays === VOID ? 21 : weeklyWindowDays;
  projectionDays = projectionDays === VOID ? 30 : projectionDays;
  return $super === VOID ? this.z1x(points, kcalPerKg, windows, weeklyWindowDays, projectionDays) : $super.z1x.call(this, points, kcalPerKg, windows, weeklyWindowDays, projectionDays);
};
protoOf(Companion_29).ix = function (points, days) {
  // Inline function 'kotlin.require' call
  if (!(days > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = lastOrNull(points);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = points.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.pn_1 === (last.pn_1 - days | 0)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var start = tmp_0;
  return last.sn_1 - start.sn_1;
};
var Companion_instance_31;
function Companion_getInstance_28() {
  if (Companion_instance_31 == null)
    new Companion_29();
  return Companion_instance_31;
}
function WeightInsights(currentKg, changes, weeklyChangeKg, energyBalanceKcalPerDay, projectionKg, projectionDays) {
  Companion_getInstance_28();
  this.b1y_1 = currentKg;
  this.c1y_1 = changes;
  this.d1y_1 = weeklyChangeKg;
  this.e1y_1 = energyBalanceKcalPerDay;
  this.f1y_1 = projectionKg;
  this.g1y_1 = projectionDays;
}
protoOf(WeightInsights).toString = function () {
  return 'WeightInsights(currentKg=' + this.b1y_1 + ', changes=' + toString(this.c1y_1) + ', weeklyChangeKg=' + this.d1y_1 + ', energyBalanceKcalPerDay=' + this.e1y_1 + ', projectionKg=' + this.f1y_1 + ', projectionDays=' + this.g1y_1 + ')';
};
protoOf(WeightInsights).hashCode = function () {
  var result = getNumberHashCode(this.b1y_1);
  result = imul(result, 31) + hashCode(this.c1y_1) | 0;
  result = imul(result, 31) + (this.d1y_1 == null ? 0 : getNumberHashCode(this.d1y_1)) | 0;
  result = imul(result, 31) + (this.e1y_1 == null ? 0 : getNumberHashCode(this.e1y_1)) | 0;
  result = imul(result, 31) + (this.f1y_1 == null ? 0 : getNumberHashCode(this.f1y_1)) | 0;
  result = imul(result, 31) + this.g1y_1 | 0;
  return result;
};
protoOf(WeightInsights).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightInsights))
    return false;
  if (!equals(this.b1y_1, other.b1y_1))
    return false;
  if (!equals(this.c1y_1, other.c1y_1))
    return false;
  if (!equals(this.d1y_1, other.d1y_1))
    return false;
  if (!equals(this.e1y_1, other.e1y_1))
    return false;
  if (!equals(this.f1y_1, other.f1y_1))
    return false;
  if (!(this.g1y_1 === other.g1y_1))
    return false;
  return true;
};
function WeighInHabit() {
}
protoOf(WeighInHabit).h1y = function (days, today) {
  var logged = toHashSet(days);
  var day = logged.r(today) ? today : today - 1 | 0;
  var count = 0;
  while (logged.r(day)) {
    count = count + 1 | 0;
    day = day - 1 | 0;
  }
  return count;
};
var WeighInHabit_instance;
function WeighInHabit_getInstance() {
  return WeighInHabit_instance;
}
function Direction_INCREASE_getInstance() {
  static_init_75();
  return Direction_INCREASE_instance;
}
function Direction_DECREASE_getInstance() {
  static_init_75();
  return Direction_DECREASE_instance;
}
function Direction_NO_CHANGE_getInstance() {
  static_init_75();
  return Direction_NO_CHANGE_instance;
}
function WeighIn(day, kg) {
  this.gm_1 = day;
  this.hm_1 = kg;
}
protoOf(WeighIn).toString = function () {
  return 'WeighIn(day=' + this.gm_1 + ', kg=' + this.hm_1 + ')';
};
protoOf(WeighIn).hashCode = function () {
  var result = this.gm_1;
  result = imul(result, 31) + getNumberHashCode(this.hm_1) | 0;
  return result;
};
protoOf(WeighIn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeighIn))
    return false;
  if (!(this.gm_1 === other.gm_1))
    return false;
  if (!equals(this.hm_1, other.hm_1))
    return false;
  return true;
};
function TrendPoint(day, scaleKg, filledKg, trendKg) {
  this.pn_1 = day;
  this.qn_1 = scaleKg;
  this.rn_1 = filledKg;
  this.sn_1 = trendKg;
}
protoOf(TrendPoint).toString = function () {
  return 'TrendPoint(day=' + this.pn_1 + ', scaleKg=' + this.qn_1 + ', filledKg=' + this.rn_1 + ', trendKg=' + this.sn_1 + ')';
};
protoOf(TrendPoint).hashCode = function () {
  var result = this.pn_1;
  result = imul(result, 31) + (this.qn_1 == null ? 0 : getNumberHashCode(this.qn_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.rn_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.sn_1) | 0;
  return result;
};
protoOf(TrendPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrendPoint))
    return false;
  if (!(this.pn_1 === other.pn_1))
    return false;
  if (!equals(this.qn_1, other.qn_1))
    return false;
  if (!equals(this.rn_1, other.rn_1))
    return false;
  if (!equals(this.sn_1, other.sn_1))
    return false;
  return true;
};
function interpolate($this, daily, previousIndex, day) {
  var previous = daily.n(previousIndex);
  var tmp0_elvis_lhs = getOrNull_0(daily, previousIndex + 1 | 0);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return previous.hm_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var next = tmp;
  var span = next.gm_1 - previous.gm_1 | 0;
  var fraction = (day - previous.gm_1 | 0) / span;
  return previous.hm_1 + (next.hm_1 - previous.hm_1) * fraction;
}
function sam$kotlin_Comparator$0_21(function_0) {
  this.i1y_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_21).ea = function (a, b) {
  return this.i1y_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_21).compare = function (a, b) {
  return this.ea(a, b);
};
protoOf(sam$kotlin_Comparator$0_21).h2 = function () {
  return this.i1y_1;
};
protoOf(sam$kotlin_Comparator$0_21).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.h2(), other.h2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_21).hashCode = function () {
  return hashCode(this.h2());
};
function WeightTrend$dailyAverages$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.gm_1;
  var tmp$ret$2 = b.gm_1;
  return compareValues(tmp, tmp$ret$2);
}
function WeightTrend() {
  this.qm_1 = 0.1;
  this.rm_1 = 20;
  this.sm_1 = 0.2222222222222222;
  this.tm_1 = 25.0;
}
protoOf(WeightTrend).um = function (weighIns) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weighIns.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.hm_1 >= 25.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.gm_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.t1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.l2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(destination_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.w1().j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var day = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var readings = item.q1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = readings.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_0 = sum;
      sum = tmp_0 + element_1.hm_1;
    }
    var tmp$ret$14 = sum;
    var tmp$ret$11 = new WeighIn(day, tmp$ret$14 / readings.o());
    destination_1.f(tmp$ret$11);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = WeightTrend$dailyAverages$lambda;
  var tmp$ret$17 = new sam$kotlin_Comparator$0_21(tmp_1);
  return sortedWith(destination_1, tmp$ret$17);
};
protoOf(WeightTrend).u1w = function (weighIns, endDay, alpha) {
  // Inline function 'kotlin.require' call
  if (!(alpha > 0.0 && alpha <= 1.0)) {
    var message = 'alpha must be in (0, 1]';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var daily = this.um(weighIns);
  if (daily.m())
    return emptyList();
  var firstDay = first(daily).gm_1;
  var tmp0 = endDay == null ? last(daily).gm_1 : endDay;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = last(daily).gm_1;
  var lastDay = Math.max(tmp0, b);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = daily.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = element.gm_1;
    var tmp$ret$6 = element.hm_1;
    destination.l2(tmp, tmp$ret$6);
  }
  var byDay = destination;
  var points = ArrayList_init_$Create$((lastDay - firstDay | 0) + 1 | 0);
  var previousIndex = 0;
  var trend = first(daily).hm_1;
  var inductionVariable = firstDay;
  if (inductionVariable <= lastDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while ((previousIndex + 1 | 0) < daily.o() && daily.n(previousIndex + 1 | 0).gm_1 <= day) {
        previousIndex = previousIndex + 1 | 0;
      }
      var scale = byDay.t1(day);
      var filled = scale == null ? interpolate(this, daily, previousIndex, day) : scale;
      trend = day === firstDay ? filled : trend + alpha * (filled - trend);
      points.f(new TrendPoint(day, scale, filled, trend));
    }
     while (!(day === lastDay));
  return points;
};
protoOf(WeightTrend).on = function (weighIns, endDay, alpha, $super) {
  endDay = endDay === VOID ? null : endDay;
  alpha = alpha === VOID ? 0.1 : alpha;
  return $super === VOID ? this.u1w(weighIns, endDay, alpha) : $super.u1w.call(this, weighIns, endDay, alpha);
};
protoOf(WeightTrend).j1y = function (points, windowDays) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (points.o() <= windowDays)
    return null;
  var last_0 = last(points);
  var start = points.n((points.o() - 1 | 0) - windowDays | 0);
  return (last_0.sn_1 - start.sn_1) / (last_0.pn_1 - start.pn_1 | 0) * 7.0;
};
protoOf(WeightTrend).zu = function (points, windowDays, $super) {
  windowDays = windowDays === VOID ? 20 : windowDays;
  return $super === VOID ? this.j1y(points, windowDays) : $super.j1y.call(this, points, windowDays);
};
var WeightTrend_instance;
function WeightTrend_getInstance() {
  return WeightTrend_instance;
}
function ounceGrams() {
  return 28.349523125;
}
function amountGramsFor(amount, portionGrams) {
  var tmp;
  if (portionGrams == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new Portion('', portionGrams);
  }
  return gramsFor(amount, tmp);
}
function gramsToAmountFor(grams, portionGrams) {
  var tmp;
  if (portionGrams == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new Portion('', portionGrams);
  }
  return amountFor(grams, tmp);
}
function JsSuggestedAmount(label, amount, portionLabel, portionGrams) {
  this.label = label;
  this.amount = amount;
  this.portionLabel = portionLabel;
  this.portionGrams = portionGrams;
}
protoOf(JsSuggestedAmount).k1y = function () {
  return this.label;
};
protoOf(JsSuggestedAmount).l1y = function () {
  return this.amount;
};
protoOf(JsSuggestedAmount).m1y = function () {
  return this.portionLabel;
};
protoOf(JsSuggestedAmount).n1y = function () {
  return this.portionGrams;
};
function suggestedAmountsJs(portionLabels, portionGramsList, usualGrams, usualPortionLabel, usualPortionGrams) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(portionLabels);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$2 = new Portion(portionLabels[it], portionGramsList[it]);
      destination.f(tmp$ret$2);
    }
     while (!(item === last));
  var portions = destination;
  var tmp;
  if (usualPortionLabel == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    if (usualPortionGrams == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new Portion(usualPortionLabel, usualPortionGrams);
    }
    tmp = tmp_0;
  }
  var usualPortion = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = suggestedAmounts(portions, usualGrams, usualPortion);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = item_0.b13_1;
    var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x12_1;
    var tmp1_safe_receiver = item_0.b13_1;
    var tmp$ret$9 = new JsSuggestedAmount(item_0.z12_1, item_0.a13_1, tmp_1, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.y12_1);
    destination_0.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function JsUnitChoice(kind, portionLabel, portionGrams, isAiChosen) {
  this.kind = kind;
  this.portionLabel = portionLabel;
  this.portionGrams = portionGrams;
  this.isAiChosen = isAiChosen;
}
protoOf(JsUnitChoice).o1y = function () {
  return this.kind;
};
protoOf(JsUnitChoice).m1y = function () {
  return this.portionLabel;
};
protoOf(JsUnitChoice).n1y = function () {
  return this.portionGrams;
};
protoOf(JsUnitChoice).p1y = function () {
  return this.isAiChosen;
};
function unitChoicesForJs(portionLabels, portionGramsList, useImperialWeight, aiPortionLabel) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(portionLabels);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$2 = new Portion(portionLabels[it], portionGramsList[it]);
      destination.f(tmp$ret$2);
    }
     while (!(item === last));
  var portions = destination;
  var tmp;
  if (aiPortionLabel == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = portions.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.x12_1 === aiPortionLabel) {
          tmp$ret$5 = element;
          break $l$block;
        }
      }
      tmp$ret$5 = null;
    }
    tmp = tmp$ret$5;
  }
  var aiPortion = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = unitChoicesFor(portions, useImperialWeight, aiPortion);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var unit = item_0.v12_1;
    var tmp_0;
    if (equals(unit, Grams_getInstance())) {
      tmp_0 = new JsUnitChoice('g', null, null, item_0.w12_1);
    } else {
      if (equals(unit, Ounces_getInstance())) {
        tmp_0 = new JsUnitChoice('oz', null, null, item_0.w12_1);
      } else {
        if (unit instanceof Household) {
          tmp_0 = new JsUnitChoice('portion', unit.t12_1.x12_1, unit.t12_1.y12_1, item_0.w12_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var tmp$ret$9 = tmp_0;
    destination_0.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function parseAmount(text) {
  return parseAmountText(text);
}
function scaleDishGrams(gramsList, factor) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(gramsList.length);
  var inductionVariable = 0;
  var last = gramsList.length;
  while (inductionVariable < last) {
    var item = gramsList[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp$ret$2 = item * factor;
    destination.f(tmp$ret$2);
  }
  return toDoubleArray(destination);
}
function dishTotalJson(itemsJson) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.rr(Json_instance.ng(itemsJson));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block_1: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var map = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.cr(map, 'grams');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_1;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var grams = tmp_0;
      var tmp_1 = map.t1('per100g');
      var tmp2_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = NutrientJson_instance.h19(tmp2_safe_receiver);
      }
      var tmp3_elvis_lhs = tmp_2;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_1;
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var per100g = tmp_3;
      tmp$ret$4 = new DishItem(grams, per100g);
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var items = destination;
  return Json_instance.sg(dishTotal(items));
}
function ageYearsJs(birthDate, today) {
  return AgeGate_instance.xe(birthDate, today);
}
function isAdultJs(birthDate, today) {
  return AgeGate_instance.ye(birthDate, today);
}
function underAgeMessage() {
  return 'Macrotide is for adults 18 and over.';
}
function JsExpenditureModel(series, dynamic, initialKcal, kcalPerKg, bandDays, bandSettledKcal, bandResponsiveKcal, comparison) {
  this.series = series;
  this.dynamic = dynamic;
  this.initialKcal = initialKcal;
  this.kcalPerKg = kcalPerKg;
  this.bandDays = bandDays;
  this.bandSettledKcal = bandSettledKcal;
  this.bandResponsiveKcal = bandResponsiveKcal;
  this.comparison = comparison;
}
protoOf(JsExpenditureModel).q1y = function () {
  return this.series;
};
protoOf(JsExpenditureModel).r1y = function () {
  return this.dynamic;
};
protoOf(JsExpenditureModel).s1y = function () {
  return this.initialKcal;
};
protoOf(JsExpenditureModel).t1y = function () {
  return this.kcalPerKg;
};
protoOf(JsExpenditureModel).u1y = function () {
  return this.bandDays;
};
protoOf(JsExpenditureModel).v1y = function () {
  return this.bandSettledKcal;
};
protoOf(JsExpenditureModel).w1y = function () {
  return this.bandResponsiveKcal;
};
protoOf(JsExpenditureModel).x1y = function () {
  return this.comparison;
};
function expenditureModel(algorithmsJson, endDay, weighDays, weighKg, intakeDays, intakeKcal, intakeStatus, intakeCarbsG, intakeSodiumMg, trendKg, sex, ageYears, heightCm, bodyFatFraction, waistCm, activityLevel, goalDays, goalTypes, goalRates, goalTargets, stepsDays, steps, checkInDays, checkInKcal) {
  // Inline function 'kotlin.require' call
  if (!(intakeCarbsG.length === intakeDays.length && intakeSodiumMg.length === intakeDays.length)) {
    var message = 'intake arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(goalDays.length === goalTypes.length && goalDays.length === goalRates.length && goalDays.length === goalTargets.length)) {
    var message_0 = 'goal arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(stepsDays.length === steps.length && checkInDays.length === checkInKcal.length)) {
    var message_1 = 'parallel arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  var intake = toIntake(intakeDays, intakeKcal, intakeStatus);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_indices(intake);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.xc_1;
  var last = tmp0.yc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      if (intake.n(it).hk_1.equals(DayStatus_COMPLETE_getInstance())) {
        destination.f(element);
      }
    }
     while (!(element === last));
  var logged = destination;
  var tmp;
  if (!(sex == null) && !(ageYears == null) && !(heightCm == null) && !(activityLevel == null)) {
    tmp = new BodyProfile(valueOf_7(sex), ageYears, heightCm, bodyFatFraction, null, valueOf_8(activityLevel), waistCm);
  } else {
    tmp = null;
  }
  var profile = tmp;
  var tmp_0 = ExpenditureRunner_instance;
  var tmp_1 = AlgorithmJson_getInstance().mg(algorithmsJson);
  var tmp_2 = toWeighIns(weighDays, weighKg);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(goalDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable_0 = this_0.xc_1;
  var last_0 = this_0.yc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = item;
      var tmp$ret$11 = new GoalPeriodStart(goalDays[it_0], new Goal(valueOf(goalTypes[it_0]), goalRates[it_0], goalTargets[it_0]));
      destination_0.f(tmp$ret$11);
    }
     while (!(item === last_0));
  var tmp_3 = destination_0;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(logged, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_1 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = logged.j();
  while (_iterator__ex2g4s.k()) {
    var element_0 = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(intakeDays[element_0], intakeCarbsG[element_0]);
    destination_1.l2(pair.nb_1, pair.ob_1);
  }
  var tmp_4 = destination_1;
  // Inline function 'kotlin.collections.associate' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(logged, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_2 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_0 = logged.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_1 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair_0 = to(intakeDays[element_1], intakeSodiumMg[element_1]);
    destination_2.l2(pair_0.nb_1, pair_0.ob_1);
  }
  var tmp_5 = destination_2;
  // Inline function 'kotlin.collections.associate' call
  var this_1 = get_indices_1(stepsDays);
  var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_3 = LinkedHashMap_init_$Create$(capacity_1);
  var inductionVariable_1 = this_1.xc_1;
  var last_1 = this_1.yc_1;
  if (inductionVariable_1 <= last_1)
    do {
      var element_2 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var it_1 = element_2;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_1 = to(stepsDays[it_1], steps[it_1]);
      destination_3.l2(pair_1.nb_1, pair_1.ob_1);
    }
     while (!(element_2 === last_1));
  var tmp_6 = new DailyInputs(tmp_4, tmp_5, destination_3);
  // Inline function 'kotlin.collections.associate' call
  var this_2 = get_indices_1(checkInDays);
  var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_4 = LinkedHashMap_init_$Create$(capacity_2);
  var inductionVariable_2 = this_2.xc_1;
  var last_2 = this_2.yc_1;
  if (inductionVariable_2 <= last_2)
    do {
      var element_3 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var it_2 = element_3;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_2 = to(checkInDays[it_2], checkInKcal[it_2]);
      destination_4.l2(pair_2.nb_1, pair_2.ob_1);
    }
     while (!(element_3 === last_2));
  var run = tmp_0.pm(tmp_1, new ExpenditureInput(endDay, tmp_2, intake, profile, trendKg, bodyFatFraction, tmp_3, tmp_6, destination_4));
  var tmp_7 = toJs_0(run.zl_1);
  var tmp_8 = toJs_0(run.am_1);
  var tmp0_safe_receiver = run.dm_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xz_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toIntArray(tmp1_safe_receiver);
  var tmp_9 = tmp2_elvis_lhs == null ? new Int32Array(0) : tmp2_elvis_lhs;
  var tmp3_safe_receiver = run.dm_1;
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.yz_1;
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : toDoubleArray(tmp4_safe_receiver);
  var tmp_10 = tmp5_elvis_lhs == null ? new Float64Array(0) : tmp5_elvis_lhs;
  var tmp6_safe_receiver = run.dm_1;
  var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.zz_1;
  var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : toDoubleArray(tmp7_safe_receiver);
  var tmp_11 = tmp8_elvis_lhs == null ? new Float64Array(0) : tmp8_elvis_lhs;
  var tmp9_safe_receiver = run.em_1;
  return new JsExpenditureModel(tmp_7, tmp_8, run.bm_1, run.cm_1, tmp_9, tmp_10, tmp_11, tmp9_safe_receiver == null ? null : toJs_0(tmp9_safe_receiver));
}
function JsAlgorithmOption(key, label, help, kind, values, labels) {
  this.key = key;
  this.label = label;
  this.help = help;
  this.kind = kind;
  this.values = values;
  this.labels = labels;
}
protoOf(JsAlgorithmOption).p1 = function () {
  return this.key;
};
protoOf(JsAlgorithmOption).k1y = function () {
  return this.label;
};
protoOf(JsAlgorithmOption).y1y = function () {
  return this.help;
};
protoOf(JsAlgorithmOption).o1y = function () {
  return this.kind;
};
protoOf(JsAlgorithmOption).v1 = function () {
  return this.values;
};
protoOf(JsAlgorithmOption).z1y = function () {
  return this.labels;
};
function algorithmOptions() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = AlgorithmJson_getInstance().kg_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.ff_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$5 = item_0.ze_1;
      destination_0.f(tmp$ret$5);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(destination_0);
    // Inline function 'kotlin.collections.map' call
    var this_2 = item.ff_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_1 = this_2.j();
    while (_iterator__ex2g4s_1.k()) {
      var item_1 = _iterator__ex2g4s_1.l();
      var tmp$ret$9 = item_1.af_1;
      destination_1.f(tmp$ret$9);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$10 = copyToArray(destination_1);
    var tmp$ret$2 = new JsAlgorithmOption(item.bf_1, item.cf_1, item.df_1, item.ef_1.x1_1, tmp, tmp$ret$10);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function algorithmValues(algorithmsJson) {
  var values = AlgorithmJson_getInstance().pg(AlgorithmJson_getInstance().mg(algorithmsJson));
  // Inline function 'kotlin.collections.map' call
  var this_0 = AlgorithmJson_getInstance().kg_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = getValue(values, item.bf_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function algorithmsWith(algorithmsJson, key, value) {
  return AlgorithmJson_getInstance().qg(algorithmsJson, key, value);
}
function JsDisplayedExpenditure(point, waitingForWeighIn) {
  this.point = point;
  this.waitingForWeighIn = waitingForWeighIn;
}
protoOf(JsDisplayedExpenditure).a1z = function () {
  return this.point;
};
protoOf(JsDisplayedExpenditure).b1z = function () {
  return this.waitingForWeighIn;
};
function displayedExpenditure(series, today, weighedInToday) {
  var tmp0_safe_receiver = ExpenditureInsights_getInstance().vw(toPoints(series), today, weighedInToday);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new JsDisplayedExpenditure(toJs(tmp0_safe_receiver.ww_1), tmp0_safe_receiver.xw_1);
  }
  return tmp;
}
function JsExpenditureChanges(changeDays, changeKcal, changeDirection, averageDailyChangeKcal) {
  this.changeDays = changeDays;
  this.changeKcal = changeKcal;
  this.changeDirection = changeDirection;
  this.averageDailyChangeKcal = averageDailyChangeKcal;
}
protoOf(JsExpenditureChanges).c1z = function () {
  return this.changeDays;
};
protoOf(JsExpenditureChanges).d1z = function () {
  return this.changeKcal;
};
protoOf(JsExpenditureChanges).e1z = function () {
  return this.changeDirection;
};
protoOf(JsExpenditureChanges).f1z = function () {
  return this.averageDailyChangeKcal;
};
function expenditureChanges(series) {
  var list = toPoints(series);
  var changes = ExpenditureInsights_getInstance().vz(list);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(changes, 10));
  var _iterator__ex2g4s = changes.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.qz_1;
    destination.f(tmp$ret$2);
  }
  var tmp = toIntArray(destination);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(changes, 10));
  var _iterator__ex2g4s_0 = changes.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.rz_1;
    destination_0.f(tmp$ret$5);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_0 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(changes, 10));
  var _iterator__ex2g4s_1 = changes.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver = item_1.sz();
    var tmp$ret$9 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1_1;
    destination_1.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$10 = copyToArray(destination_1);
  return new JsExpenditureChanges(tmp, tmp_0, tmp$ret$10, ExpenditureInsights_getInstance().wz(list));
}
function JsEnergyBalancePoint(day, intakeKcal, status, usable, expenditureKcal, targetKcal, balanceKcal, intakeAverageKcal, expenditureAverageKcal, balanceAverageKcal) {
  this.day = day;
  this.intakeKcal = intakeKcal;
  this.status = status;
  this.usable = usable;
  this.expenditureKcal = expenditureKcal;
  this.targetKcal = targetKcal;
  this.balanceKcal = balanceKcal;
  this.intakeAverageKcal = intakeAverageKcal;
  this.expenditureAverageKcal = expenditureAverageKcal;
  this.balanceAverageKcal = balanceAverageKcal;
}
protoOf(JsEnergyBalancePoint).g1z = function () {
  return this.day;
};
protoOf(JsEnergyBalancePoint).h1z = function () {
  return this.intakeKcal;
};
protoOf(JsEnergyBalancePoint).i1z = function () {
  return this.status;
};
protoOf(JsEnergyBalancePoint).j1z = function () {
  return this.usable;
};
protoOf(JsEnergyBalancePoint).k1z = function () {
  return this.expenditureKcal;
};
protoOf(JsEnergyBalancePoint).l1z = function () {
  return this.targetKcal;
};
protoOf(JsEnergyBalancePoint).m1z = function () {
  return this.balanceKcal;
};
protoOf(JsEnergyBalancePoint).n1z = function () {
  return this.intakeAverageKcal;
};
protoOf(JsEnergyBalancePoint).o1z = function () {
  return this.expenditureAverageKcal;
};
protoOf(JsEnergyBalancePoint).p1z = function () {
  return this.balanceAverageKcal;
};
function JsEnergyBalance(points, usableDays, averageIntakeKcal, averageExpenditureKcal, averageBalanceKcal, averageTargetKcal, impliedChangeKg) {
  this.points = points;
  this.usableDays = usableDays;
  this.averageIntakeKcal = averageIntakeKcal;
  this.averageExpenditureKcal = averageExpenditureKcal;
  this.averageBalanceKcal = averageBalanceKcal;
  this.averageTargetKcal = averageTargetKcal;
  this.impliedChangeKg = impliedChangeKg;
}
protoOf(JsEnergyBalance).q1z = function () {
  return this.points;
};
protoOf(JsEnergyBalance).r1z = function () {
  return this.usableDays;
};
protoOf(JsEnergyBalance).s1z = function () {
  return this.averageIntakeKcal;
};
protoOf(JsEnergyBalance).t1z = function () {
  return this.averageExpenditureKcal;
};
protoOf(JsEnergyBalance).u1z = function () {
  return this.averageBalanceKcal;
};
protoOf(JsEnergyBalance).v1z = function () {
  return this.averageTargetKcal;
};
protoOf(JsEnergyBalance).w1z = function () {
  return this.impliedChangeKg;
};
function energyBalance(intakeDays, intakeKcal, intakeStatus, expenditure, fromDay, toDay, targetDays, targetKcal, kcalPerKg) {
  // Inline function 'kotlin.require' call
  if (!(targetDays.length === targetKcal.length)) {
    var message = 'target arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = EnergyBalance_instance;
  var tmp_0 = toIntake(intakeDays, intakeKcal, intakeStatus);
  var tmp_1 = toPoints(expenditure);
  // Inline function 'kotlin.collections.associate' call
  var this_0 = get_indices_1(targetDays);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(targetDays[it], targetKcal[it]);
      destination.l2(pair.nb_1, pair.ob_1);
    }
     while (!(element === last));
  var series = tmp.kz(tmp_0, tmp_1, fromDay, toDay, destination);
  var summary = EnergyBalance_instance.lz(series, kcalPerKg);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(series, 10));
  var _iterator__ex2g4s = series.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = item.ty_1;
    var tmp$ret$8 = new JsEnergyBalancePoint(item.ry_1, item.sy_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1_1, item.uy_1, item.vy_1, item.wy_1, item.xy_1, item.yy_1, item.zy_1, item.az_1);
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$9 = copyToArray(destination_0);
  return new JsEnergyBalance(tmp$ret$9, summary.cz_1, summary.dz_1, summary.ez_1, summary.fz_1, summary.gz_1, summary.hz_1);
}
function JsMessageArg(name, value) {
  this.name = name;
  this.value = value;
}
protoOf(JsMessageArg).x1z = function () {
  return this.name;
};
protoOf(JsMessageArg).q1 = function () {
  return this.value;
};
function JsMessage(key, args) {
  this.key = key;
  this.args = args;
}
protoOf(JsMessage).p1 = function () {
  return this.key;
};
protoOf(JsMessage).y1z = function () {
  return this.args;
};
function JsWeeklyCheckIn(day, targets, averageTargetKcal, rawTargetKcal, changeKcal, limitedByFloor, targetsUpdated, expenditureKcal, expenditureStatus, expenditureHolding, trendWeightKg, weeklyChangeKg, kcalPerKg, leanMassKg, effectiveRatePctPerWeek, needsWeighIn, hasWeighInThisWeek, weighInsThisWeek, loggingBreak, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays, persistenceDirection, persistenceWeeks, trainingShiftKcal, guardrailTriggered, guardrailChangePct, suggestedRatePctPerWeek, suggestDietBreak, flagModules, flagCodes, flagMessages, flagMessageKeys, flagDays, checkInJson, lifts, fastLoss, sleepAverageMin, energyAvailability, onDietBreak) {
  this.day = day;
  this.targets = targets;
  this.averageTargetKcal = averageTargetKcal;
  this.rawTargetKcal = rawTargetKcal;
  this.changeKcal = changeKcal;
  this.limitedByFloor = limitedByFloor;
  this.targetsUpdated = targetsUpdated;
  this.expenditureKcal = expenditureKcal;
  this.expenditureStatus = expenditureStatus;
  this.expenditureHolding = expenditureHolding;
  this.trendWeightKg = trendWeightKg;
  this.weeklyChangeKg = weeklyChangeKg;
  this.kcalPerKg = kcalPerKg;
  this.leanMassKg = leanMassKg;
  this.effectiveRatePctPerWeek = effectiveRatePctPerWeek;
  this.needsWeighIn = needsWeighIn;
  this.hasWeighInThisWeek = hasWeighInThisWeek;
  this.weighInsThisWeek = weighInsThisWeek;
  this.loggingBreak = loggingBreak;
  this.possibleFastingDays = possibleFastingDays;
  this.partialDays = partialDays;
  this.fastedDays = fastedDays;
  this.unloggedDays = unloggedDays;
  this.usableDays = usableDays;
  this.persistenceDirection = persistenceDirection;
  this.persistenceWeeks = persistenceWeeks;
  this.trainingShiftKcal = trainingShiftKcal;
  this.guardrailTriggered = guardrailTriggered;
  this.guardrailChangePct = guardrailChangePct;
  this.suggestedRatePctPerWeek = suggestedRatePctPerWeek;
  this.suggestDietBreak = suggestDietBreak;
  this.flagModules = flagModules;
  this.flagCodes = flagCodes;
  this.flagMessages = flagMessages;
  this.flagMessageKeys = flagMessageKeys;
  this.flagDays = flagDays;
  this.checkInJson = checkInJson;
  this.lifts = lifts;
  this.fastLoss = fastLoss;
  this.sleepAverageMin = sleepAverageMin;
  this.energyAvailability = energyAvailability;
  this.onDietBreak = onDietBreak;
}
protoOf(JsWeeklyCheckIn).g1z = function () {
  return this.day;
};
protoOf(JsWeeklyCheckIn).z1z = function () {
  return this.targets;
};
protoOf(JsWeeklyCheckIn).v1z = function () {
  return this.averageTargetKcal;
};
protoOf(JsWeeklyCheckIn).a20 = function () {
  return this.rawTargetKcal;
};
protoOf(JsWeeklyCheckIn).d1z = function () {
  return this.changeKcal;
};
protoOf(JsWeeklyCheckIn).b20 = function () {
  return this.limitedByFloor;
};
protoOf(JsWeeklyCheckIn).c20 = function () {
  return this.targetsUpdated;
};
protoOf(JsWeeklyCheckIn).k1z = function () {
  return this.expenditureKcal;
};
protoOf(JsWeeklyCheckIn).d20 = function () {
  return this.expenditureStatus;
};
protoOf(JsWeeklyCheckIn).e20 = function () {
  return this.expenditureHolding;
};
protoOf(JsWeeklyCheckIn).f20 = function () {
  return this.trendWeightKg;
};
protoOf(JsWeeklyCheckIn).g20 = function () {
  return this.weeklyChangeKg;
};
protoOf(JsWeeklyCheckIn).t1y = function () {
  return this.kcalPerKg;
};
protoOf(JsWeeklyCheckIn).h20 = function () {
  return this.leanMassKg;
};
protoOf(JsWeeklyCheckIn).i20 = function () {
  return this.effectiveRatePctPerWeek;
};
protoOf(JsWeeklyCheckIn).j20 = function () {
  return this.needsWeighIn;
};
protoOf(JsWeeklyCheckIn).k20 = function () {
  return this.hasWeighInThisWeek;
};
protoOf(JsWeeklyCheckIn).l20 = function () {
  return this.weighInsThisWeek;
};
protoOf(JsWeeklyCheckIn).m20 = function () {
  return this.loggingBreak;
};
protoOf(JsWeeklyCheckIn).n20 = function () {
  return this.possibleFastingDays;
};
protoOf(JsWeeklyCheckIn).o20 = function () {
  return this.partialDays;
};
protoOf(JsWeeklyCheckIn).p20 = function () {
  return this.fastedDays;
};
protoOf(JsWeeklyCheckIn).q20 = function () {
  return this.unloggedDays;
};
protoOf(JsWeeklyCheckIn).r1z = function () {
  return this.usableDays;
};
protoOf(JsWeeklyCheckIn).r20 = function () {
  return this.persistenceDirection;
};
protoOf(JsWeeklyCheckIn).s20 = function () {
  return this.persistenceWeeks;
};
protoOf(JsWeeklyCheckIn).t20 = function () {
  return this.trainingShiftKcal;
};
protoOf(JsWeeklyCheckIn).u20 = function () {
  return this.guardrailTriggered;
};
protoOf(JsWeeklyCheckIn).v20 = function () {
  return this.guardrailChangePct;
};
protoOf(JsWeeklyCheckIn).w20 = function () {
  return this.suggestedRatePctPerWeek;
};
protoOf(JsWeeklyCheckIn).x20 = function () {
  return this.suggestDietBreak;
};
protoOf(JsWeeklyCheckIn).y20 = function () {
  return this.flagModules;
};
protoOf(JsWeeklyCheckIn).z20 = function () {
  return this.flagCodes;
};
protoOf(JsWeeklyCheckIn).a21 = function () {
  return this.flagMessages;
};
protoOf(JsWeeklyCheckIn).b21 = function () {
  return this.flagMessageKeys;
};
protoOf(JsWeeklyCheckIn).c21 = function () {
  return this.flagDays;
};
protoOf(JsWeeklyCheckIn).d21 = function () {
  return this.checkInJson;
};
protoOf(JsWeeklyCheckIn).e21 = function () {
  return this.lifts;
};
protoOf(JsWeeklyCheckIn).f21 = function () {
  return this.fastLoss;
};
protoOf(JsWeeklyCheckIn).g21 = function () {
  return this.sleepAverageMin;
};
protoOf(JsWeeklyCheckIn).h21 = function () {
  return this.energyAvailability;
};
protoOf(JsWeeklyCheckIn).i21 = function () {
  return this.onDietBreak;
};
function JsFastLoss(ratePctPerWeek, deficitKcal, suggestedRatePctPerWeek, title, message, actionLabel) {
  this.ratePctPerWeek = ratePctPerWeek;
  this.deficitKcal = deficitKcal;
  this.suggestedRatePctPerWeek = suggestedRatePctPerWeek;
  this.title = title;
  this.message = message;
  this.actionLabel = actionLabel;
}
protoOf(JsFastLoss).j21 = function () {
  return this.ratePctPerWeek;
};
protoOf(JsFastLoss).k21 = function () {
  return this.deficitKcal;
};
protoOf(JsFastLoss).w20 = function () {
  return this.suggestedRatePctPerWeek;
};
protoOf(JsFastLoss).l21 = function () {
  return this.title;
};
protoOf(JsFastLoss).c7 = function () {
  return this.message;
};
protoOf(JsFastLoss).cq = function () {
  return this.actionLabel;
};
function weeklyCheckIn(day, programJson, goalType, ratePctPerWeek, targetWeightKg, sex, ageYears, heightCm, bodyFatFraction, leanMassKg, waistCm, activityLevel, intakeDays, intakeKcal, intakeStatus, weighDays, weighKg, expenditure, previousCheckInJson, trendMethod, trainingWeekdays, strengthDays, strengthIndex, algorithmsJson, weeklyHardSets, recoveryDays, recoverySleepMin, recoveryHrvMs, recoveryRestingHr, goalStartDay) {
  goalStartDay = goalStartDay === VOID ? null : goalStartDay;
  // Inline function 'kotlin.require' call
  if (!(strengthDays.length === strengthIndex.length)) {
    var message = 'strength arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(recoveryDays.length === recoverySleepMin.length && recoveryDays.length === recoveryHrvMs.length && recoveryDays.length === recoveryRestingHr.length)) {
    var message_0 = 'recovery arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var tmp = WeeklyCheckIn_instance;
  var tmp_0 = NutritionJson_instance.nr(programJson);
  var tmp_1 = new Goal(valueOf(goalType), ratePctPerWeek, targetWeightKg);
  var tmp_2 = new BodyProfile(valueOf_7(sex), ageYears, heightCm, bodyFatFraction, leanMassKg, valueOf_8(activityLevel), waistCm);
  var tmp_3 = toIntake(intakeDays, intakeKcal, intakeStatus);
  var tmp_4 = toWeighIns(weighDays, weighKg);
  var tmp_5 = toPoints(expenditure);
  var tmp_6;
  if (previousCheckInJson == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_6 = NutritionJson_instance.vr(previousCheckInJson);
  }
  var tmp_7 = tmp_6;
  var tmp_8 = valueOf_16(trendMethod);
  var tmp_9 = toSet_1(trainingWeekdays);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(strengthDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$8 = new StrengthIndexPoint(strengthDays[it], strengthIndex[it]);
      destination.f(tmp$ret$8);
    }
     while (!(item === last));
  var tmp_10 = destination;
  var tmp_11 = AlgorithmJson_getInstance().mg(algorithmsJson);
  // Inline function 'kotlin.collections.map' call
  var this_1 = get_indices_1(recoveryDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable_0 = this_1.xc_1;
  var last_0 = this_1.yc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = item_0;
      var tmp$ret$11 = new RecoveryDay(recoveryDays[it_0], recoverySleepMin[it_0], recoveryHrvMs[it_0], recoveryRestingHr[it_0]);
      destination_0.f(tmp$ret$11);
    }
     while (!(item_0 === last_0));
  var tmp1_elvis_lhs = tmp.kr(new WeeklyCheckInInput(day, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, weeklyHardSets, VOID, destination_0, goalStartDay));
  var tmp_12;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_12 = tmp1_elvis_lhs;
  }
  var result = tmp_12;
  // Inline function 'kotlin.collections.map' call
  var this_2 = result.ns_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item_1 = _iterator__ex2g4s.l();
    var tmp$ret$14 = toJs_1(item_1);
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_13 = copyToArray(destination_1);
  var tmp_14 = toIntArray(result.xr_1.zs_1);
  var tmp_15 = toIntArray(result.xr_1.at_1);
  var tmp_16 = toIntArray(result.xr_1.bt_1);
  var tmp_17 = toIntArray(result.xr_1.ct_1);
  var tmp2_safe_receiver = result.rs_1;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.jt_1;
  var tmp_18 = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  var tmp4_safe_receiver = result.rs_1;
  var tmp_19 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.kt_1;
  var tmp5_safe_receiver = result.rs_1;
  var tmp_20 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.mt_1;
  var tmp6_safe_receiver = result.rs_1;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.nt_1;
  var tmp_21 = tmp7_elvis_lhs == null ? false : tmp7_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  var this_3 = result.ss_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_2 = _iterator__ex2g4s_0.l();
    var tmp$ret$18 = item_2.mw_1.x1_1;
    destination_2.f(tmp$ret$18);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_22 = copyToArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  var this_4 = result.ss_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_1 = this_4.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_3 = _iterator__ex2g4s_1.l();
    var tmp$ret$22 = item_3.nw_1.x1_1;
    destination_3.f(tmp$ret$22);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_23 = copyToArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  var this_5 = result.ss_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_2 = this_5.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_4 = _iterator__ex2g4s_2.l();
    var tmp$ret$26 = item_4.ow_1;
    destination_4.f(tmp$ret$26);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_24 = copyToArray(destination_4);
  // Inline function 'kotlin.collections.map' call
  var this_6 = result.ss_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(this_6, 10));
  var _iterator__ex2g4s_3 = this_6.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_5 = _iterator__ex2g4s_3.l();
    var tmp$ret$30 = toJs_2(item_5.qw_1);
    destination_5.f(tmp$ret$30);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_25 = copyToArray(destination_5);
  // Inline function 'kotlin.collections.map' call
  var this_7 = result.ss_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
  var _iterator__ex2g4s_4 = this_7.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_6 = _iterator__ex2g4s_4.l();
    var tmp$ret$34 = toIntArray(item_6.pw_1);
    destination_6.f(tmp$ret$34);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_26 = copyToArray(destination_6);
  var tmp_27 = NutritionJson_instance.et(result);
  var tmp8_safe_receiver = result.us_1;
  var tmp_28 = tmp8_safe_receiver == null ? null : toJs_3(tmp8_safe_receiver);
  var tmp9_safe_receiver = result.vs_1;
  var tmp_29 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.pj_1;
  var tmp10_safe_receiver = result.vs_1;
  return new JsWeeklyCheckIn(result.wr_1, tmp_13, result.ks_1, result.js_1, result.ls_1, result.ms_1, result.os_1, result.cs_1.jn_1, result.cs_1.ln_1.x1_1, result.ds_1, result.es_1, result.fs_1, result.gs_1, result.hs_1, result.is_1, result.as_1, result.zr_1, result.yr_1, result.bs_1, tmp_14, tmp_15, tmp_16, tmp_17, result.xr_1.dt_1, result.ps_1.aj_1, result.ps_1.bj_1, result.qs_1, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, result.ts_1, tmp_28, tmp_29, tmp10_safe_receiver == null ? null : tmp10_safe_receiver.rj_1, result.ws_1);
}
function fastLossWarning(ratePctPerWeek, weightKg, bodyFatFraction, algorithmsJson, weeklyHardSets) {
  var algorithms = AlgorithmJson_getInstance().mg(algorithmsJson);
  var lifts = LossPace_instance.jq(algorithms.xf_1, weeklyHardSets);
  var tmp0_safe_receiver = LossPace_instance.tq(ratePctPerWeek, weightKg, algorithms.xg(weightKg, bodyFatFraction), lifts);
  return tmp0_safe_receiver == null ? null : toJs_3(tmp0_safe_receiver);
}
function JsDietBreak(startDay, endDay, weeks) {
  this.startDay = startDay;
  this.endDay = endDay;
  this.weeks = weeks;
}
protoOf(JsDietBreak).m21 = function () {
  return this.startDay;
};
protoOf(JsDietBreak).xk = function () {
  return this.endDay;
};
protoOf(JsDietBreak).n21 = function () {
  return this.weeks;
};
function dietBreak_0(programJson) {
  var tmp0_safe_receiver = NutritionJson_instance.nr(programJson).nv_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new JsDietBreak(tmp0_safe_receiver.vk_1, tmp0_safe_receiver.xk(), tmp0_safe_receiver.wk_1);
  }
  return tmp;
}
function dietBreakWeekChoices() {
  return toIntArray(Companion_getInstance_0().tk_1);
}
function dietBreakExplainer() {
  return "A diet break holds your calories at maintenance. Breaks can make dieting easier on appetite; they don't speed up fat loss, and each break week adds a week to your diet.";
}
function programWithDietBreak(programJson, startDay, weeks) {
  // Inline function 'kotlin.require' call
  if (!(startDay == null || Companion_getInstance_0().tk_1.r(weeks))) {
    var message = 'weeks must be one of ' + toString(Companion_getInstance_0().tk_1);
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = NutritionJson_instance;
  var tmp_0;
  if (startDay == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = new DietBreak(startDay, weeks);
  }
  return tmp.ur(programJson, tmp_0);
}
function trainingShiftCarbsHelp() {
  return "The extra calories on training days are carbohydrate, to fuel harder sessions, and rest days have a little less. Protein and fat stay the same and so does the weekly total; it supports performance, it doesn't speed up fat loss.";
}
function collaborativeEdit(kcal, proteinG, fatG, carbsG, field, value, bodyWeightKg, diet, days, keepCalories, keepWeeklyTotal) {
  // Inline function 'kotlin.require' call
  if (!(kcal.length === proteinG.length && kcal.length === fatG.length && kcal.length === carbsG.length)) {
    var message = 'target arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_2(kcal);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new MacroTargets(kcal[it], proteinG[it], fatG[it], carbsG[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var targets = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = CollaborativeTargets_instance.pk(targets, valueOf_1(field), value, bodyWeightKg, valueOf_3(diet), toSet_1(days), keepCalories, keepWeeklyTotal);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$7 = toJs_1(item_0);
    destination_0.f(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function dayOneTargets(goalJson, profileJson, algorithmsJson, programJson, today, weightKg) {
  return NewProgram_instance.pr(goalJson, profileJson, algorithmsJson, programJson, today, weightKg);
}
function dayOneTargetsWithTraining(goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays) {
  return NewProgram_instance.lr(goalJson, profileJson, algorithmsJson, programJson, today, weightKg, toSet_1(trainingWeekdays));
}
function defaultCheckInWeekday(setupDay) {
  return NewProgram_instance.er(setupDay);
}
function firstCheckInDay(setupDay) {
  return NewProgram_instance.hr(setupDay);
}
function firstCheckInDayOn(setupDay, checkInWeekday) {
  return NewProgram_instance.gr(setupDay, checkInWeekday);
}
function ageYears(birthDay, today) {
  return NewProgram_instance.mr(birthDay, today);
}
function goalPacePresets(goalType) {
  var tmp = Json_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = GoalPace_getInstance().qo(valueOf(goalType));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = linkedMapOf([to('id', item.un_1), to('label', item.vn_1), to('description', item.xn_1), to('ratePctPerWeek', item.wn_1)]);
    destination.f(tmp$ret$2);
  }
  return tmp.sg(destination);
}
function goalProjection(currentKg, targetKg, ratePctPerWeek, today, kcalPerKg) {
  var tmp = GoalPace_getInstance();
  // Inline function 'kotlin.takeUnless' call
  var tmp_0;
  if (!isNaN_0(targetKg)) {
    tmp_0 = targetKg;
  } else {
    tmp_0 = null;
  }
  var tmp$ret$0 = tmp_0;
  var projection = tmp.ro(currentKg, tmp$ret$0, ratePctPerWeek, today);
  var tmp_1 = Json_instance;
  var tmp_2 = to('reachDay', projection.bo_1);
  // Inline function 'kotlin.collections.map' call
  var this_0 = projection.ao_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = linkedMapOf([to('day', item.yn_1), to('kg', item.zn_1)]);
    destination.f(tmp$ret$4);
  }
  return tmp_1.sg(linkedMapOf([tmp_2, to('points', destination), to('dailyDeltaKcal', CheckIn_instance.jj(ratePctPerWeek, currentKg, kcalPerKg))]));
}
function goalCurve(currentKg, targetKg, ratePctPerWeek, today, lastDay) {
  var tmp = GoalPace_getInstance();
  // Inline function 'kotlin.takeUnless' call
  var tmp_0;
  if (!isNaN_0(targetKg)) {
    tmp_0 = targetKg;
  } else {
    tmp_0 = null;
  }
  var tmp$ret$0 = tmp_0;
  var projection = tmp.ro(currentKg, tmp$ret$0, ratePctPerWeek, today);
  var tmp_1 = Json_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = GoalPace_getInstance().ip(projection, lastDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = linkedMapOf([to('day', item.co_1), to('kg', item.do_1)]);
    destination.f(tmp$ret$4);
  }
  return tmp_1.sg(destination);
}
function suggestedTargetKg(weightKg, heightCm, waistCm, bmiThreshold) {
  return GoalPace_getInstance().hp(weightKg, heightCm, waistCm, bmiThreshold);
}
function ethnicityBmiThreshold(ethnicity) {
  var tmp = GoalPace_getInstance();
  var tmp0 = get_entries_12();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.x1_1 === ethnicity) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp.gp(tmp$ret$0);
}
function waistToHeightBand(waistCm, heightCm) {
  var tmp0_safe_receiver = WaistToHeight_instance.mp(waistCm, heightCm);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1_1;
}
function availableGoalTypes(ageYears) {
  var tmp = Json_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = GoalAvailability_instance.ei(ageYears);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.x1_1;
    destination.f(tmp$ret$2);
  }
  return tmp.sg(destination);
}
function dailyDeltaKcal(ratePctPerWeek, trendWeightKg, kcalPerKg) {
  return CheckIn_instance.jj(ratePctPerWeek, trendWeightKg, kcalPerKg);
}
function kgPerWeek(ratePctPerWeek, weightKg) {
  return Goals_instance.vp(ratePctPerWeek, weightKg);
}
function ratePctPerWeek(kgPerWeek, weightKg) {
  return Goals_instance.xp(kgPerWeek, weightKg);
}
function JsGoalProgress(startKg, currentKg, targetKg, changeKg, remainingKg, fractionDone, reached, projectedDay, projectedDayAtGoalRate) {
  this.startKg = startKg;
  this.currentKg = currentKg;
  this.targetKg = targetKg;
  this.changeKg = changeKg;
  this.remainingKg = remainingKg;
  this.fractionDone = fractionDone;
  this.reached = reached;
  this.projectedDay = projectedDay;
  this.projectedDayAtGoalRate = projectedDayAtGoalRate;
}
protoOf(JsGoalProgress).o21 = function () {
  return this.startKg;
};
protoOf(JsGoalProgress).p21 = function () {
  return this.currentKg;
};
protoOf(JsGoalProgress).q21 = function () {
  return this.targetKg;
};
protoOf(JsGoalProgress).r21 = function () {
  return this.changeKg;
};
protoOf(JsGoalProgress).s21 = function () {
  return this.remainingKg;
};
protoOf(JsGoalProgress).t21 = function () {
  return this.fractionDone;
};
protoOf(JsGoalProgress).u21 = function () {
  return this.reached;
};
protoOf(JsGoalProgress).v21 = function () {
  return this.projectedDay;
};
protoOf(JsGoalProgress).w21 = function () {
  return this.projectedDayAtGoalRate;
};
function goalProgress(startKg, targetKg, currentKg, today, currentRateKgPerWeek, goalRatePctPerWeek) {
  var p = Goals_instance.fp(startKg, targetKg, currentKg, today, currentRateKgPerWeek, goalRatePctPerWeek);
  return new JsGoalProgress(p.so_1, p.to_1, p.uo_1, p.vo_1, p.wo_1, p.xo_1, p.yo_1, p.zo_1, p.ap_1);
}
function JsWeightMilestone(index, thresholdKg, changeKg, fractionOfGoal, reachedDay, isTarget) {
  this.index = index;
  this.thresholdKg = thresholdKg;
  this.changeKg = changeKg;
  this.fractionOfGoal = fractionOfGoal;
  this.reachedDay = reachedDay;
  this.isTarget = isTarget;
}
protoOf(JsWeightMilestone).x21 = function () {
  return this.index;
};
protoOf(JsWeightMilestone).y21 = function () {
  return this.thresholdKg;
};
protoOf(JsWeightMilestone).r21 = function () {
  return this.changeKg;
};
protoOf(JsWeightMilestone).z21 = function () {
  return this.fractionOfGoal;
};
protoOf(JsWeightMilestone).a22 = function () {
  return this.reachedDay;
};
protoOf(JsWeightMilestone).b22 = function () {
  return this.isTarget;
};
function weightMilestones(startKg, targetKg, trendDays, trendKg, kind, step, losing) {
  // Inline function 'kotlin.require' call
  if (!(trendDays.length === trendKg.length)) {
    var message = 'trend arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(trendDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new TrendPoint(trendDays[it], null, trendKg[it], trendKg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var trend = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = Goals_instance.yp(startKg, targetKg, trend, valueOf_2(kind), step, losing);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$7 = new JsWeightMilestone(item_0.np_1, item_0.op_1, item_0.pp_1, item_0.qp_1, item_0.rp_1, item_0.sp_1);
    destination_0.f(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function JsNutrientGoal(key, name, unit, floor, target, ceiling) {
  this.key = key;
  this.name = name;
  this.unit = unit;
  this.floor = floor;
  this.target = target;
  this.ceiling = ceiling;
}
protoOf(JsNutrientGoal).p1 = function () {
  return this.key;
};
protoOf(JsNutrientGoal).x1z = function () {
  return this.name;
};
protoOf(JsNutrientGoal).c22 = function () {
  return this.unit;
};
protoOf(JsNutrientGoal).d22 = function () {
  return this.floor;
};
protoOf(JsNutrientGoal).e22 = function () {
  return this.target;
};
protoOf(JsNutrientGoal).f22 = function () {
  return this.ceiling;
};
function nutrientGoals(sex, ageYears, energyKcal) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientGoals_instance.o19(valueOf_7(sex), ageYears, energyKcal);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.w1().j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var goal = item.q1();
    var info = Nutrients_getInstance().p17(key);
    var tmp1_elvis_lhs = info == null ? null : info.c19_1;
    var tmp = tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = info == null ? null : info.d19_1;
    var tmp$ret$3 = new JsNutrientGoal(key, tmp, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs, goal.m18_1, goal.n18_1, goal.o18_1);
    destination.f(tmp$ret$3);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsCompleteness(key, byKcal, byEntries, entries, entriesWithValue) {
  this.key = key;
  this.byKcal = byKcal;
  this.byEntries = byEntries;
  this.entries = entries;
  this.entriesWithValue = entriesWithValue;
}
protoOf(JsCompleteness).p1 = function () {
  return this.key;
};
protoOf(JsCompleteness).g22 = function () {
  return this.byKcal;
};
protoOf(JsCompleteness).h22 = function () {
  return this.byEntries;
};
protoOf(JsCompleteness).w1 = function () {
  return this.entries;
};
protoOf(JsCompleteness).i22 = function () {
  return this.entriesWithValue;
};
function nutrientCompleteness(entriesJson, fromDay, toDay) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientAnalysis_instance.p16(NutrientJson_instance.g19(entriesJson), fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsCompleteness(item.l15_1, item.m15_1, item.n15_1, item.o15_1, item.p15_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsContributor(foodKey, name, amount, share, entries) {
  this.foodKey = foodKey;
  this.name = name;
  this.amount = amount;
  this.share = share;
  this.entries = entries;
}
protoOf(JsContributor).j22 = function () {
  return this.foodKey;
};
protoOf(JsContributor).x1z = function () {
  return this.name;
};
protoOf(JsContributor).l1y = function () {
  return this.amount;
};
protoOf(JsContributor).k22 = function () {
  return this.share;
};
protoOf(JsContributor).w1 = function () {
  return this.entries;
};
function nutrientTopContributors(entriesJson, key, fromDay, toDay, limit) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientAnalysis_instance.c17(NutrientJson_instance.g19(entriesJson), key, fromDay, toDay, limit);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsContributor(item.q15_1, item.r15_1, item.s15_1, item.t15_1, item.u15_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsNutrientAverages(key, dailyAverage, days, weekStarts, weeklyAverages, weeklyDays) {
  this.key = key;
  this.dailyAverage = dailyAverage;
  this.days = days;
  this.weekStarts = weekStarts;
  this.weeklyAverages = weeklyAverages;
  this.weeklyDays = weeklyDays;
}
protoOf(JsNutrientAverages).p1 = function () {
  return this.key;
};
protoOf(JsNutrientAverages).l22 = function () {
  return this.dailyAverage;
};
protoOf(JsNutrientAverages).m22 = function () {
  return this.days;
};
protoOf(JsNutrientAverages).n22 = function () {
  return this.weekStarts;
};
protoOf(JsNutrientAverages).o22 = function () {
  return this.weeklyAverages;
};
protoOf(JsNutrientAverages).p22 = function () {
  return this.weeklyDays;
};
function nutrientAverages(entriesJson, key, fromDay, toDay) {
  var averages = NutrientAnalysis_instance.f17(NutrientJson_instance.g19(entriesJson), key, fromDay, toDay);
  // Inline function 'kotlin.collections.map' call
  var this_0 = averages.i16_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.c16_1;
    destination.f(tmp$ret$2);
  }
  var tmp = toIntArray(destination);
  // Inline function 'kotlin.collections.map' call
  var this_1 = averages.i16_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.d16_1;
    destination_0.f(tmp$ret$5);
  }
  var tmp_0 = toDoubleArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_2 = averages.i16_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item_1.e16_1;
    destination_1.f(tmp$ret$8);
  }
  return new JsNutrientAverages(averages.f16_1, averages.g16_1, averages.h16_1, tmp, tmp_0, toIntArray(destination_1));
}
function JsAlcohol(volumeMl, abvPct, alcoholG, alcoholKcal, carbsG, kcal, ukUnits, grams, per100gKcal, per100gCarbs, per100gAlcohol) {
  this.volumeMl = volumeMl;
  this.abvPct = abvPct;
  this.alcoholG = alcoholG;
  this.alcoholKcal = alcoholKcal;
  this.carbsG = carbsG;
  this.kcal = kcal;
  this.ukUnits = ukUnits;
  this.grams = grams;
  this.per100gKcal = per100gKcal;
  this.per100gCarbs = per100gCarbs;
  this.per100gAlcohol = per100gAlcohol;
}
protoOf(JsAlcohol).q22 = function () {
  return this.volumeMl;
};
protoOf(JsAlcohol).r22 = function () {
  return this.abvPct;
};
protoOf(JsAlcohol).s22 = function () {
  return this.alcoholG;
};
protoOf(JsAlcohol).t22 = function () {
  return this.alcoholKcal;
};
protoOf(JsAlcohol).u22 = function () {
  return this.carbsG;
};
protoOf(JsAlcohol).hh = function () {
  return this.kcal;
};
protoOf(JsAlcohol).v22 = function () {
  return this.ukUnits;
};
protoOf(JsAlcohol).w22 = function () {
  return this.grams;
};
protoOf(JsAlcohol).x22 = function () {
  return this.per100gKcal;
};
protoOf(JsAlcohol).y22 = function () {
  return this.per100gCarbs;
};
protoOf(JsAlcohol).z22 = function () {
  return this.per100gAlcohol;
};
function alcohol(volumeMl, abvPct, carbsPer100Ml, densityGPerMl) {
  return toJs_4(Alcohol_instance.d15(volumeMl, abvPct, carbsPer100Ml, densityGPerMl));
}
function alcoholDrink(drinkType, volumeMl, abvPct) {
  var drink = valueOf_9(drinkType);
  var tmp = Alcohol_instance;
  var tmp_0 = volumeMl == null ? drink.p14_1 : volumeMl;
  return toJs_4(tmp.e15(drink, tmp_0, abvPct == null ? drink.m14_1 : abvPct));
}
function JsDrinkType(name, label, abvPct, carbsPer100Ml, densityGPerMl, servingMl) {
  this.name = name;
  this.label = label;
  this.abvPct = abvPct;
  this.carbsPer100Ml = carbsPer100Ml;
  this.densityGPerMl = densityGPerMl;
  this.servingMl = servingMl;
}
protoOf(JsDrinkType).x1z = function () {
  return this.name;
};
protoOf(JsDrinkType).k1y = function () {
  return this.label;
};
protoOf(JsDrinkType).r22 = function () {
  return this.abvPct;
};
protoOf(JsDrinkType).a23 = function () {
  return this.carbsPer100Ml;
};
protoOf(JsDrinkType).b23 = function () {
  return this.densityGPerMl;
};
protoOf(JsDrinkType).c23 = function () {
  return this.servingMl;
};
function drinkTypes() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries_18();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsDrinkType(item.x1_1, item.l14_1, item.m14_1, item.n14_1, item.o14_1, item.p14_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function toWeighIns(days, kg) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kg.length)) {
    var message = 'weigh-in arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new WeighIn(days[it], kg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return destination;
}
function toIntake(days, kcal, status) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kcal.length && days.length === status.length)) {
    var message = 'intake arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new IntakeDay(days[it], kcal[it], valueOf_5(status[it]));
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return destination;
}
function toPoints(series) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(series.length);
  var inductionVariable = 0;
  var last = series.length;
  while (inductionVariable < last) {
    var item = series[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp$ret$2 = new ExpenditurePoint(item.day, item.kcal, item.sdKcal, valueOf_6(item.status), item.floored, item.goalAdjustmentKcal);
    destination.f(tmp$ret$2);
  }
  return destination;
}
function toJs(_this__u8e3s4) {
  return new JsExpenditurePoint(_this__u8e3s4.in_1, _this__u8e3s4.jn_1, _this__u8e3s4.kn_1, _this__u8e3s4.ln_1.x1_1, _this__u8e3s4.mn_1, _this__u8e3s4.nn_1);
}
function toJs_0(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = toJs(item);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function toJs_1(_this__u8e3s4) {
  return new JsMacros(_this__u8e3s4.jk_1, _this__u8e3s4.kk_1, _this__u8e3s4.lk_1, _this__u8e3s4.mk_1);
}
function toJs_2(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.b14_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.w1().j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var name = item.p1();
    // Inline function 'kotlin.collections.component2' call
    var value = item.q1();
    var tmp$ret$3 = new JsMessageArg(name, value);
    destination.f(tmp$ret$3);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$6 = copyToArray(destination);
  return new JsMessage(_this__u8e3s4.a14_1, tmp$ret$6);
}
function toJs_3(_this__u8e3s4) {
  return new JsFastLoss(_this__u8e3s4.zp_1, _this__u8e3s4.aq_1, _this__u8e3s4.bq_1, 'A gentler pace may keep more muscle', _this__u8e3s4.c7(), _this__u8e3s4.cq());
}
function toJs_4(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.y14_1.m13_1;
  return new JsAlcohol(_this__u8e3s4.q14_1, _this__u8e3s4.r14_1, _this__u8e3s4.s14_1, _this__u8e3s4.t14_1, _this__u8e3s4.u14_1, _this__u8e3s4.v14_1, _this__u8e3s4.w14_1, _this__u8e3s4.x14_1, _this__u8e3s4.y14_1.e13_1, _this__u8e3s4.y14_1.h13_1, tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
function JsTrendPoint(day, scaleKg, filledKg, trendKg) {
  this.day = day;
  this.scaleKg = scaleKg;
  this.filledKg = filledKg;
  this.trendKg = trendKg;
}
protoOf(JsTrendPoint).g1z = function () {
  return this.day;
};
protoOf(JsTrendPoint).d23 = function () {
  return this.scaleKg;
};
protoOf(JsTrendPoint).e23 = function () {
  return this.filledKg;
};
protoOf(JsTrendPoint).f23 = function () {
  return this.trendKg;
};
function JsExpenditurePoint(day, kcal, sdKcal, status, floored, goalAdjustmentKcal) {
  this.day = day;
  this.kcal = kcal;
  this.sdKcal = sdKcal;
  this.status = status;
  this.floored = floored;
  this.goalAdjustmentKcal = goalAdjustmentKcal;
}
protoOf(JsExpenditurePoint).g1z = function () {
  return this.day;
};
protoOf(JsExpenditurePoint).hh = function () {
  return this.kcal;
};
protoOf(JsExpenditurePoint).g23 = function () {
  return this.sdKcal;
};
protoOf(JsExpenditurePoint).i1z = function () {
  return this.status;
};
protoOf(JsExpenditurePoint).h23 = function () {
  return this.floored;
};
protoOf(JsExpenditurePoint).i23 = function () {
  return this.goalAdjustmentKcal;
};
function JsCheckInResult(targetKcal, rawTargetKcal, effectiveRatePctPerWeek, limitedByFloor, changeKcal) {
  this.targetKcal = targetKcal;
  this.rawTargetKcal = rawTargetKcal;
  this.effectiveRatePctPerWeek = effectiveRatePctPerWeek;
  this.limitedByFloor = limitedByFloor;
  this.changeKcal = changeKcal;
}
protoOf(JsCheckInResult).l1z = function () {
  return this.targetKcal;
};
protoOf(JsCheckInResult).a20 = function () {
  return this.rawTargetKcal;
};
protoOf(JsCheckInResult).i20 = function () {
  return this.effectiveRatePctPerWeek;
};
protoOf(JsCheckInResult).b20 = function () {
  return this.limitedByFloor;
};
protoOf(JsCheckInResult).d1z = function () {
  return this.changeKcal;
};
function JsMacros(kcal, proteinG, fatG, carbsG) {
  this.kcal = kcal;
  this.proteinG = proteinG;
  this.fatG = fatG;
  this.carbsG = carbsG;
}
protoOf(JsMacros).hh = function () {
  return this.kcal;
};
protoOf(JsMacros).j23 = function () {
  return this.proteinG;
};
protoOf(JsMacros).k23 = function () {
  return this.fatG;
};
protoOf(JsMacros).u22 = function () {
  return this.carbsG;
};
function weightTrend(days, kg, endDay, method) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = trendPoints(days, kg, endDay, method);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsTrendPoint(item.pn_1, item.qn_1, item.rn_1, item.sn_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function changeRateKgPerWeek(days, kg, endDay, method) {
  return WeightTrend_instance.zu(trendPoints(days, kg, endDay, method));
}
function JsWeightInsights(currentKg, changeDays, changeKg, changeDirection, weeklyChangeKg, energyBalanceKcalPerDay, projectionKg, projectionDays) {
  this.currentKg = currentKg;
  this.changeDays = changeDays;
  this.changeKg = changeKg;
  this.changeDirection = changeDirection;
  this.weeklyChangeKg = weeklyChangeKg;
  this.energyBalanceKcalPerDay = energyBalanceKcalPerDay;
  this.projectionKg = projectionKg;
  this.projectionDays = projectionDays;
}
protoOf(JsWeightInsights).p21 = function () {
  return this.currentKg;
};
protoOf(JsWeightInsights).c1z = function () {
  return this.changeDays;
};
protoOf(JsWeightInsights).r21 = function () {
  return this.changeKg;
};
protoOf(JsWeightInsights).e1z = function () {
  return this.changeDirection;
};
protoOf(JsWeightInsights).g20 = function () {
  return this.weeklyChangeKg;
};
protoOf(JsWeightInsights).l23 = function () {
  return this.energyBalanceKcalPerDay;
};
protoOf(JsWeightInsights).m23 = function () {
  return this.projectionKg;
};
protoOf(JsWeightInsights).n23 = function () {
  return this.projectionDays;
};
function weightInsights(days, kg, endDay, method, kcalPerKg) {
  var tmp0_elvis_lhs = Companion_getInstance_28().a1y(trendPoints(days, kg, endDay, method), kcalPerKg);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var insights = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = insights.c1y_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.x1x_1;
    destination.f(tmp$ret$2);
  }
  var tmp_0 = toIntArray(destination);
  // Inline function 'kotlin.collections.map' call
  var this_1 = insights.c1y_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.y1x_1;
    destination_0.f(tmp$ret$5);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_2 = insights.c1y_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver = item_1.sz();
    var tmp$ret$9 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1_1;
    destination_1.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$10 = copyToArray(destination_1);
  return new JsWeightInsights(insights.b1y_1, tmp_0, tmp_1, tmp$ret$10, insights.d1y_1, insights.e1y_1, insights.f1y_1, insights.g1y_1);
}
function weighInStreak(days, today) {
  return WeighInHabit_instance.h1y(toList_1(days), today);
}
function energyDensityKcalPerKg(bodyWeightKg, bodyFatFraction) {
  return EnergyDensity_instance.xg(bodyWeightKg, bodyFatFraction);
}
function checkIn(expenditureKcal, trendWeightKg, goalType, ratePctPerWeek, targetWeightKg, kcalPerKg, previousTargetKcal, sameDirectionWeeks, expenditureHolding, calorieFloor) {
  var result = CheckIn_instance.lj(new CheckInInput(expenditureKcal, trendWeightKg, new Goal(valueOf(goalType), ratePctPerWeek, targetWeightKg), kcalPerKg, previousTargetKcal, sameDirectionWeeks, expenditureHolding, valueOf_0(calorieFloor)));
  return new JsCheckInResult(result.vi_1, result.wi_1, result.xi_1, result.yi_1, result.zi_1);
}
function macroTargets(kcal, bodyWeightKg, leanMassKg, diet, protein) {
  var macros = Macros_instance.zq(kcal, bodyWeightKg, leanMassKg, valueOf_3(diet), valueOf_4(protein));
  return new JsMacros(macros.jk_1, macros.kk_1, macros.lk_1, macros.mk_1);
}
function estimatedOneRepMax(loadKg, reps, rir) {
  return Strength_instance.z1r(new LoggedSet(loadKg, reps, rir));
}
function localizeUnits(message, pounds, kilojoules) {
  return UnitText_getInstance().ue(message, pounds, kilojoules);
}
function trendPoints(days, kg, endDay, method) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kg.length)) {
    var message = 'days and kg must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = Trend_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new WeighIn(days[it], kg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return tmp.rw(destination, endDay, valueOf_16(method));
}
function offProductUrl(code) {
  return OffProduct_getInstance().x13(code);
}
function offFoodJson(code, responseJson) {
  return OffProduct_getInstance().y13(code, responseJson);
}
function JsNutrientInfo(key, name, unit) {
  this.key = key;
  this.name = name;
  this.unit = unit;
}
protoOf(JsNutrientInfo).p1 = function () {
  return this.key;
};
protoOf(JsNutrientInfo).x1z = function () {
  return this.name;
};
protoOf(JsNutrientInfo).c22 = function () {
  return this.unit;
};
function nutrientInfos() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = Nutrients_getInstance().a17_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsNutrientInfo(item.b19_1, item.c19_1, item.d19_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsNutrientGoalSetting(key, name, unit, floor, target, ceiling, method, since) {
  this.key = key;
  this.name = name;
  this.unit = unit;
  this.floor = floor;
  this.target = target;
  this.ceiling = ceiling;
  this.method = method;
  this.since = since;
}
protoOf(JsNutrientGoalSetting).p1 = function () {
  return this.key;
};
protoOf(JsNutrientGoalSetting).x1z = function () {
  return this.name;
};
protoOf(JsNutrientGoalSetting).c22 = function () {
  return this.unit;
};
protoOf(JsNutrientGoalSetting).d22 = function () {
  return this.floor;
};
protoOf(JsNutrientGoalSetting).e22 = function () {
  return this.target;
};
protoOf(JsNutrientGoalSetting).f22 = function () {
  return this.ceiling;
};
protoOf(JsNutrientGoalSetting).o23 = function () {
  return this.method;
};
protoOf(JsNutrientGoalSetting).p23 = function () {
  return this.since;
};
function nutrientGoalHistory(nutrientsJson) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientGoalHistory_instance.a19(NutrientGoalJson_instance.e19(nutrientsJson));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsNutrientGoalSetting(item.v18_1, item.w18_1, item.x18_1, item.y18_1.d18_1, item.y18_1.e18_1, item.y18_1.f18_1, item.y18_1.g18_1.b18_1, item.y18_1.h18_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsGoalMethod(value, label) {
  this.value = value;
  this.label = label;
}
protoOf(JsGoalMethod).q1 = function () {
  return this.value;
};
protoOf(JsGoalMethod).k1y = function () {
  return this.label;
};
function nutrientGoalMethods(key) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientGoalMethods_getInstance().l18(key);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsGoalMethod(item.b18_1, item.c18_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function nutrientGoalsWith(nutrientsJson, key, floor, target, ceiling, method, since) {
  var tmp0 = Companion_instance_10.y17(method);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = "unknown goal method '" + method + "'";
      throw IllegalArgumentException_init_$Create$(toString(message));
    } else {
      tmp$ret$0 = tmp0;
      break $l$block;
    }
  }
  var goalMethod = tmp$ret$0;
  return NutrientGoalJson_instance.f19(nutrientsJson, key, new NutrientGoalSetting(floor, target, ceiling, goalMethod, since));
}
function nutrientGoalsWithout(nutrientsJson, key) {
  return NutrientGoalJson_instance.f19(nutrientsJson, key, null);
}
function JsNutrientDay(day, amount, average7, floor, target, ceiling, status) {
  this.day = day;
  this.amount = amount;
  this.average7 = average7;
  this.floor = floor;
  this.target = target;
  this.ceiling = ceiling;
  this.status = status;
}
protoOf(JsNutrientDay).g1z = function () {
  return this.day;
};
protoOf(JsNutrientDay).l1y = function () {
  return this.amount;
};
protoOf(JsNutrientDay).q23 = function () {
  return this.average7;
};
protoOf(JsNutrientDay).d22 = function () {
  return this.floor;
};
protoOf(JsNutrientDay).e22 = function () {
  return this.target;
};
protoOf(JsNutrientDay).f22 = function () {
  return this.ceiling;
};
protoOf(JsNutrientDay).i1z = function () {
  return this.status;
};
function JsNutrientFocus(key, name, unit, days, average, loggedDays, goalDays, goalCustom, goalMethod, goalSince) {
  this.key = key;
  this.name = name;
  this.unit = unit;
  this.days = days;
  this.average = average;
  this.loggedDays = loggedDays;
  this.goalDays = goalDays;
  this.goalCustom = goalCustom;
  this.goalMethod = goalMethod;
  this.goalSince = goalSince;
}
protoOf(JsNutrientFocus).p1 = function () {
  return this.key;
};
protoOf(JsNutrientFocus).x1z = function () {
  return this.name;
};
protoOf(JsNutrientFocus).c22 = function () {
  return this.unit;
};
protoOf(JsNutrientFocus).m22 = function () {
  return this.days;
};
protoOf(JsNutrientFocus).r23 = function () {
  return this.average;
};
protoOf(JsNutrientFocus).s23 = function () {
  return this.loggedDays;
};
protoOf(JsNutrientFocus).t23 = function () {
  return this.goalDays;
};
protoOf(JsNutrientFocus).u23 = function () {
  return this.goalCustom;
};
protoOf(JsNutrientFocus).v23 = function () {
  return this.goalMethod;
};
protoOf(JsNutrientFocus).w23 = function () {
  return this.goalSince;
};
function nutrientFocus(entriesJson, key, fromDay, toDay, nutrientsJson, sex, ageYears, bodyWeightKg, energyKcal) {
  var setting = NutrientGoalJson_instance.e19(nutrientsJson).t1(key);
  var tmp;
  if (!(sex == null) && !(ageYears == null)) {
    var tmp_0 = NutrientGoals_instance;
    var tmp_1 = valueOf_7(sex);
    var tmp_2;
    if (energyKcal == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_3;
      if (energyKcal > 0.0) {
        tmp_3 = energyKcal;
      } else {
        tmp_3 = null;
      }
      tmp_2 = tmp_3;
    }
    tmp = tmp_0.o19(tmp_1, ageYears, tmp_2).t1(key);
  } else {
    tmp = null;
  }
  var default_0 = tmp;
  var focus = Companion_instance_9.l17(NutrientJson_instance.g19(entriesJson), key, fromDay, toDay, setting, default_0, bodyWeightKg, energyKcal);
  // Inline function 'kotlin.collections.map' call
  var this_0 = focus.s17_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = item.j17_1;
    var tmp_4 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m18_1;
    var tmp1_safe_receiver = item.j17_1;
    var tmp_5 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n18_1;
    var tmp2_safe_receiver = item.j17_1;
    var tmp$ret$4 = new JsNutrientDay(item.g17_1, item.h17_1, item.i17_1, tmp_4, tmp_5, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.o18_1, item.k17_1.x1_1);
    destination.f(tmp$ret$4);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_6 = copyToArray(destination);
  var tmp_7 = !(setting == null);
  var tmp2_elvis_lhs = setting == null ? null : setting.g18_1;
  var tmp_8 = (tmp2_elvis_lhs == null ? GoalMethod_FIXED_getInstance() : tmp2_elvis_lhs).b18_1;
  return new JsNutrientFocus(key, focus.r17_1.c19_1, focus.r17_1.d19_1, tmp_6, focus.t17_1, focus.u17_1, focus.v17_1, tmp_7, tmp_8, setting == null ? null : setting.h18_1);
}
var catalogueCache;
function JsPlateLoadout(targetKg, barKg, platesPerSide, achievedKg, remainderKg, exact) {
  this.targetKg = targetKg;
  this.barKg = barKg;
  this.platesPerSide = platesPerSide;
  this.achievedKg = achievedKg;
  this.remainderKg = remainderKg;
  this.exact = exact;
}
protoOf(JsPlateLoadout).q21 = function () {
  return this.targetKg;
};
protoOf(JsPlateLoadout).x23 = function () {
  return this.barKg;
};
protoOf(JsPlateLoadout).y23 = function () {
  return this.platesPerSide;
};
protoOf(JsPlateLoadout).z23 = function () {
  return this.achievedKg;
};
protoOf(JsPlateLoadout).a24 = function () {
  return this.remainderKg;
};
protoOf(JsPlateLoadout).b24 = function () {
  return this.exact;
};
function plateLoadout(targetKg, barKg, plateKg, platePairs) {
  // Inline function 'kotlin.require' call
  if (!(plateKg.length === platePairs.length)) {
    var message = 'plate arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = PlateCalculator_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_2(plateKg);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new PlatePair(plateKg[it], platePairs[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var loadout = tmp.t1i(targetKg, barKg, destination);
  return new JsPlateLoadout(loadout.o1h_1, loadout.p1h_1, toDoubleArray(loadout.q1h_1), loadout.r1h_1, loadout.s1h_1, loadout.t1h_1);
}
function gymLoads(gymJson, equipment, stackName) {
  return toDoubleArray(Loads_instance.g1i(Companion_getInstance_11().p1g(gymJson), Companion_instance_18.h1f(equipment), stackName));
}
function nearestLoad(loads, targetKg, rounding) {
  return Loads_instance.h1i(toList_2(loads), targetKg, valueOf_11(rounding));
}
function JsWarmupSet(loadKg, reps, pct) {
  this.loadKg = loadKg;
  this.reps = reps;
  this.pct = pct;
}
protoOf(JsWarmupSet).c24 = function () {
  return this.loadKg;
};
protoOf(JsWarmupSet).d24 = function () {
  return this.reps;
};
protoOf(JsWarmupSet).e24 = function () {
  return this.pct;
};
function warmupSets(workingLoadKg, loads, pcts, reps, minLoadKg) {
  // Inline function 'kotlin.require' call
  if (!(pcts.length === reps.length)) {
    var message = 'warm-up arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (pcts.length === 0) {
    tmp = Warmups_getInstance().j1m_1;
  } else {
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_indices_2(pcts);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.xc_1;
    var last = this_0.yc_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$5 = new WarmupStep(pcts[it], reps[it]);
        destination.f(tmp$ret$5);
      }
       while (!(item === last));
    tmp = destination;
  }
  var scheme = tmp;
  var list = toList_2(loads);
  var tmp_0 = Warmups_getInstance();
  var tmp_1;
  if (minLoadKg == null) {
    var tmp1_elvis_lhs = minOrNull(list);
    tmp_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  } else {
    tmp_1 = minLoadKg;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0.q1w(workingLoadKg, list, scheme, tmp_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$8 = new JsWarmupSet(item_0.m1w_1, item_0.n1w_1, item_0.o1w_1);
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function JsExerciseTargets(loadKg, reps, rir, setType, done, outsideRepRange, oneRepMaxKg, issue, warning, alternativeKinds, alternativeLoadKg, alternativeReps, progressed) {
  this.loadKg = loadKg;
  this.reps = reps;
  this.rir = rir;
  this.setType = setType;
  this.done = done;
  this.outsideRepRange = outsideRepRange;
  this.oneRepMaxKg = oneRepMaxKg;
  this.issue = issue;
  this.warning = warning;
  this.alternativeKinds = alternativeKinds;
  this.alternativeLoadKg = alternativeLoadKg;
  this.alternativeReps = alternativeReps;
  this.progressed = progressed;
}
protoOf(JsExerciseTargets).c24 = function () {
  return this.loadKg;
};
protoOf(JsExerciseTargets).d24 = function () {
  return this.reps;
};
protoOf(JsExerciseTargets).f24 = function () {
  return this.rir;
};
protoOf(JsExerciseTargets).g24 = function () {
  return this.setType;
};
protoOf(JsExerciseTargets).h24 = function () {
  return this.done;
};
protoOf(JsExerciseTargets).i24 = function () {
  return this.outsideRepRange;
};
protoOf(JsExerciseTargets).j24 = function () {
  return this.oneRepMaxKg;
};
protoOf(JsExerciseTargets).k24 = function () {
  return this.issue;
};
protoOf(JsExerciseTargets).l24 = function () {
  return this.warning;
};
protoOf(JsExerciseTargets).m24 = function () {
  return this.alternativeKinds;
};
protoOf(JsExerciseTargets).n24 = function () {
  return this.alternativeLoadKg;
};
protoOf(JsExerciseTargets).o24 = function () {
  return this.alternativeReps;
};
protoOf(JsExerciseTargets).p24 = function () {
  return this.progressed;
};
function nextSetTargets(sets, repMin, repMax, rir, setType, progression, loads, historyDays, historySessions, historyLoadKg, historyReps, historyRir, historyTypes, todayLoadKg, todayReps, todayRir, todayTypes, priority, expandRepRange, weightMatch, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, rirAdjustment, trainingSettingsJson, region) {
  var n = historyDays.length;
  // Inline function 'kotlin.require' call
  if (!(historySessions.length === n && historyLoadKg.length === n && historyReps.length === n && historyRir.length === n && historyTypes.length === n)) {
    var message = 'history arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var m = todayLoadKg.length;
  // Inline function 'kotlin.require' call
  if (!(todayReps.length === m && todayRir.length === m && todayTypes.length === m)) {
    var message_0 = "today's arrays must have the same length";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, n);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$6 = new SetRecord(historyDays[it], historyLoadKg[it], historyReps[it], historyRir[it], Companion_instance_19.h1f(historyTypes[it]), historySessions[it]);
      destination.f(tmp$ret$6);
    }
     while (!(item === last));
  var history = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = until(0, m);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable_0 = this_1.xc_1;
  var last_0 = this_1.yc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = item_0;
      var tmp$ret$9 = new SetRecord(0, todayLoadKg[it_0], todayReps[it_0], todayRir[it_0], Companion_instance_19.h1f(todayTypes[it_0]), 'today');
      destination_0.f(tmp$ret$9);
    }
     while (!(item_0 === last_0));
  var today = destination_0;
  var settings = TrainingSettingsJson_instance.mg(trainingSettingsJson);
  var exercise = new Exercise('exercise', 'exercise', Equipment_OTHER_getInstance(), emptyList(), VOID, VOID, VOID, VOID, bodyweightFactor, VOID, Companion_getInstance_13().h1f(region));
  // Inline function 'kotlin.let' call
  var it_1 = settings.b1w(exercise, history, bodyweightKg, rirAdjustment, expandRepRange, weightMatch);
  var options = trainingSettingsJson == null ? it_1.w1o(valueOf_12(priority)) : it_1;
  var targets = Progression_instance.e1r(new CyclePrescription(sets, repMin, repMax, rir, Companion_instance_19.h1f(setType)), Companion_instance_20.h1f(progression), toList_2(loads), history, today, options.w1o(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, startingOneRepMaxKg));
  // Inline function 'kotlin.collections.map' call
  var this_2 = targets.h1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item_1 = _iterator__ex2g4s.l();
    var tmp$ret$14 = item_1.b1p_1;
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp = copyToArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  var this_3 = targets.h1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_2 = _iterator__ex2g4s_0.l();
    var tmp$ret$18 = item_2.c1p_1;
    destination_2.f(tmp$ret$18);
  }
  var tmp_0 = toIntArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  var this_4 = targets.h1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_1 = this_4.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_3 = _iterator__ex2g4s_1.l();
    var tmp$ret$21 = item_3.d1p_1;
    destination_3.f(tmp$ret$21);
  }
  var tmp_1 = toIntArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  var this_5 = targets.h1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_2 = this_5.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_4 = _iterator__ex2g4s_2.l();
    var tmp$ret$24 = item_4.e1p_1.q1s_1;
    destination_4.f(tmp$ret$24);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_2 = copyToArray(destination_4);
  // Inline function 'kotlin.collections.map' call
  var this_6 = targets.h1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(this_6, 10));
  var _iterator__ex2g4s_3 = this_6.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_5 = _iterator__ex2g4s_3.l();
    var tmp$ret$28 = item_5.f1p_1;
    destination_5.f(tmp$ret$28);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_3 = copyToArray(destination_5);
  // Inline function 'kotlin.collections.map' call
  var this_7 = targets.h1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
  var _iterator__ex2g4s_4 = this_7.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_6 = _iterator__ex2g4s_4.l();
    var tmp$ret$32 = item_6.g1p_1;
    destination_6.f(tmp$ret$32);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_4 = copyToArray(destination_6);
  // Inline function 'kotlin.collections.map' call
  var this_8 = targets.l1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(this_8, 10));
  var _iterator__ex2g4s_5 = this_8.j();
  while (_iterator__ex2g4s_5.k()) {
    var item_7 = _iterator__ex2g4s_5.l();
    var tmp$ret$36 = item_7.x1o_1.x1_1;
    destination_7.f(tmp$ret$36);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_5 = copyToArray(destination_7);
  // Inline function 'kotlin.collections.map' call
  var this_9 = targets.l1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_8 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
  var _iterator__ex2g4s_6 = this_9.j();
  while (_iterator__ex2g4s_6.k()) {
    var item_8 = _iterator__ex2g4s_6.l();
    var tmp$ret$40 = item_8.y1o_1;
    destination_8.f(tmp$ret$40);
  }
  var tmp_6 = toDoubleArray(destination_8);
  // Inline function 'kotlin.collections.map' call
  var this_10 = targets.l1p_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_9 = ArrayList_init_$Create$(collectionSizeOrDefault(this_10, 10));
  var _iterator__ex2g4s_7 = this_10.j();
  while (_iterator__ex2g4s_7.k()) {
    var item_9 = _iterator__ex2g4s_7.l();
    var tmp$ret$43 = item_9.z1o_1;
    destination_9.f(tmp$ret$43);
  }
  return new JsExerciseTargets(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, targets.i1p_1, targets.j1p_1.x1_1, targets.k1p_1, tmp_5, tmp_6, toIntArray(destination_9), targets.m1p_1);
}
function JsGeneratedProgram(programJson, split, muscles, targetSets, peakTargetSets, weeklySets, peakWeeklySets, estimatedMinutes) {
  this.programJson = programJson;
  this.split = split;
  this.muscles = muscles;
  this.targetSets = targetSets;
  this.peakTargetSets = peakTargetSets;
  this.weeklySets = weeklySets;
  this.peakWeeklySets = peakWeeklySets;
  this.estimatedMinutes = estimatedMinutes;
}
protoOf(JsGeneratedProgram).q24 = function () {
  return this.programJson;
};
protoOf(JsGeneratedProgram).r24 = function () {
  return this.split;
};
protoOf(JsGeneratedProgram).s24 = function () {
  return this.muscles;
};
protoOf(JsGeneratedProgram).t24 = function () {
  return this.targetSets;
};
protoOf(JsGeneratedProgram).u24 = function () {
  return this.peakTargetSets;
};
protoOf(JsGeneratedProgram).v24 = function () {
  return this.weeklySets;
};
protoOf(JsGeneratedProgram).w24 = function () {
  return this.peakWeeklySets;
};
protoOf(JsGeneratedProgram).x24 = function () {
  return this.estimatedMinutes;
};
function generateProgram(settingsJson, gymJson, catalogueJson, dayGymIds, dayGymJsons) {
  // Inline function 'kotlin.require' call
  if (!(dayGymIds.length === dayGymJsons.length)) {
    var message = 'day gym arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(dayGymIds);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = item;
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      var this_1 = dayGymIds[i];
      if (charSequenceLength(this_1) === 0) {
        tmp = null;
      } else {
        tmp = to(dayGymIds[i], Companion_getInstance_11().p1g(dayGymJsons[i]));
      }
      var tmp$ret$4 = tmp;
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var dayGyms = destination;
  var result = ProgramGenerator_getInstance().a1n(GeneratorSettingsJson_instance.ng(settingsJson), Companion_getInstance_11().p1g(gymJson), catalogue(catalogueJson), dayGyms);
  var muscles = toList(result.k1k_1.u1());
  var tmp_0 = TrainingProgramJson_instance.w1u(result.i1k_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s = muscles.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$8 = item_0.n1s_1;
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_0 = muscles.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_1 = _iterator__ex2g4s_0.l();
    var tmp$ret$12 = getValue(result.k1k_1, item_1);
    destination_1.f(tmp$ret$12);
  }
  var tmp_2 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_1 = muscles.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_2 = _iterator__ex2g4s_1.l();
    var tmp$ret$15 = getValue(result.l1k_1, item_2);
    destination_2.f(tmp$ret$15);
  }
  var tmp_3 = toDoubleArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_2 = muscles.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_3 = _iterator__ex2g4s_2.l();
    var tmp$ret$18 = getValue(result.m1k_1, item_3);
    destination_3.f(tmp$ret$18);
  }
  var tmp_4 = toDoubleArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_3 = muscles.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_4 = _iterator__ex2g4s_3.l();
    var tmp$ret$21 = getValue(result.n1k_1, item_4);
    destination_4.f(tmp$ret$21);
  }
  return new JsGeneratedProgram(tmp_0, result.j1k_1.x1_1, tmp_1, tmp_2, tmp_3, tmp_4, toDoubleArray(destination_4), toDoubleArray(result.o1k_1));
}
function defaultPowerWork(ageYears) {
  return ProgramGenerator_getInstance().s1m(ageYears);
}
function JsSubstitute(exerciseId, name, equipment, score) {
  this.exerciseId = exerciseId;
  this.name = name;
  this.equipment = equipment;
  this.score = score;
}
protoOf(JsSubstitute).y24 = function () {
  return this.exerciseId;
};
protoOf(JsSubstitute).x1z = function () {
  return this.name;
};
protoOf(JsSubstitute).z24 = function () {
  return this.equipment;
};
protoOf(JsSubstitute).a25 = function () {
  return this.score;
};
function substitutes(exerciseId, catalogueJson, gymJson, hiddenIds, limit) {
  var tmp = Substitutions_instance;
  var tmp_0 = catalogue(catalogueJson);
  var tmp_1;
  if (gymJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = Companion_getInstance_11().p1g(gymJson);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp.m1n(exerciseId, tmp_0, tmp_1, toSet_2(hiddenIds), limit);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = new JsSubstitute(item.m1d_1.s1b_1, item.m1d_1.t1b_1, item.m1d_1.u1b_1.t1g_1, item.n1d_1);
    destination.f(tmp$ret$4);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsRepMaxPoint(day, workoutId, kg) {
  this.day = day;
  this.workoutId = workoutId;
  this.kg = kg;
}
protoOf(JsRepMaxPoint).g1z = function () {
  return this.day;
};
protoOf(JsRepMaxPoint).b25 = function () {
  return this.workoutId;
};
protoOf(JsRepMaxPoint).c25 = function () {
  return this.kg;
};
function repMaxSeries(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, exerciseId, targetReps, bodyweightFactor) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = TrainingAnalytics_instance.k1c(trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg), exerciseId, targetReps, bodyweightFactor);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsRepMaxPoint(item.l1c_1, item.m1c_1, item.n1c_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsMuscleSets(muscles, sets) {
  this.muscles = muscles;
  this.sets = sets;
}
protoOf(JsMuscleSets).s24 = function () {
  return this.muscles;
};
protoOf(JsMuscleSets).d25 = function () {
  return this.sets;
};
function weeklySetsPerMuscle(workoutIds, days, exerciseIds, types, reps, catalogueJson, today, windowDays) {
  var n = workoutIds.length;
  var tmp = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  var sets = trainingSets(workoutIds, days, exerciseIds, types, tmp, reps, tmp_0, tmp$ret$1);
  var tmp_1 = TrainingAnalytics_instance;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4 = element.s1b_1;
    destination.l2(tmp$ret$4, element);
  }
  var result = tmp_1.n1j(sets, destination, today, windowDays);
  // Inline function 'kotlin.collections.map' call
  var this_1 = result.u1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$7 = item.n1s_1;
    destination_0.f(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$8 = copyToArray(destination_0);
  return new JsMuscleSets(tmp$ret$8, toDoubleArray(result.v1()));
}
function smartWarmupSets(workingLoadKg, oneRepMaxKg, loads, style, curveModel, region, warmedUp, bodyweightShareKg) {
  var exercise = new Exercise('exercise', 'exercise', Equipment_OTHER_getInstance(), emptyList(), VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_13().h1f(region));
  var tmp0 = get_entries_29();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.x1_1 === curveModel) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var curve = (new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_elvis_lhs == null ? CurveModel_EPLEY_getInstance() : tmp0_elvis_lhs)).c1w(exercise, emptyList(), 0.0);
  var tmp0_0 = get_entries_45();
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = tmp0_0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0.x1_1 === style) {
        tmp$ret$2 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$2;
  var styleValue = tmp1_elvis_lhs == null ? SmartWarmupStyle_OURS_getInstance() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  var this_0 = Warmups_getInstance().t1w(workingLoadKg, oneRepMaxKg, toList_2(loads), styleValue, curve, warmedUp, bodyweightShareKg);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_1 = this_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$6 = new JsWarmupSet(item.m1w_1, item.n1w_1, item.o1w_1);
    destination.f(tmp$ret$6);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function normalisedTrainingSettings(json) {
  return TrainingSettingsJson_instance.i1w(TrainingSettingsJson_instance.mg(json), json);
}
function rirFromRpe(rpe) {
  return Companion_instance_30.v1n(rpe);
}
function repMaxSeriesOnCurve(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, exerciseId, targetReps, bodyweightFactor, curveModel, region) {
  var sets = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  var exercise = new Exercise(exerciseId, exerciseId, Equipment_OTHER_getInstance(), emptyList(), VOID, VOID, VOID, VOID, bodyweightFactor, VOID, Companion_getInstance_13().h1f(region));
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.q1c_1 === exerciseId) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = new SetRecord(item.p1c_1, item.t1c_1, item.u1c_1, item.v1c_1, item.s1c_1, item.o1c_1);
    destination_0.f(tmp$ret$5);
  }
  var history = destination_0;
  var tmp$ret$6;
  $l$block: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator = sets.p(sets.o());
    while (iterator.c3()) {
      var element_0 = iterator.d3();
      if (element_0.q1c_1 === exerciseId) {
        tmp$ret$6 = element_0;
        break $l$block;
      }
    }
    tmp$ret$6 = null;
  }
  var tmp0_safe_receiver = tmp$ret$6;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1c_1;
  var bodyweight = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp0 = get_entries_29();
  var tmp$ret$8;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_1 = tmp0.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      if (element_1.x1_1 === curveModel) {
        tmp$ret$8 = element_1;
        break $l$block_0;
      }
    }
    tmp$ret$8 = null;
  }
  var tmp2_elvis_lhs = tmp$ret$8;
  var curve = (new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_elvis_lhs == null ? CurveModel_EPLEY_getInstance() : tmp2_elvis_lhs)).c1w(exercise, history, bodyweight);
  // Inline function 'kotlin.collections.map' call
  var this_0 = TrainingAnalytics_instance.k1c(sets, exerciseId, targetReps, bodyweightFactor, VOID, curve);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_2 = this_0.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp$ret$12 = new JsRepMaxPoint(item_0.l1c_1, item_0.m1c_1, item_0.n1c_1);
    destination_1.f(tmp$ret$12);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_1);
}
function JsMuscleLevels(muscles, sets, targets, statuses, recovery) {
  this.muscles = muscles;
  this.sets = sets;
  this.targets = targets;
  this.statuses = statuses;
  this.recovery = recovery;
}
protoOf(JsMuscleLevels).s24 = function () {
  return this.muscles;
};
protoOf(JsMuscleLevels).d25 = function () {
  return this.sets;
};
protoOf(JsMuscleLevels).z1z = function () {
  return this.targets;
};
protoOf(JsMuscleLevels).e25 = function () {
  return this.statuses;
};
protoOf(JsMuscleLevels).f25 = function () {
  return this.recovery;
};
function muscleLevels(workoutIds, days, exerciseIds, types, reps, catalogueJson, today, programJson, cycle) {
  var n = workoutIds.length;
  var tmp = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  var sets = trainingSets(workoutIds, days, exerciseIds, types, tmp, reps, tmp_0, tmp$ret$1);
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4 = element.s1b_1;
    destination.l2(tmp$ret$4, element);
  }
  var byId = destination;
  var tmp_1;
  if (programJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = ProgramGenerator_getInstance().f1n(TrainingProgramJson_instance.x1u(programJson), cycle, byId);
  }
  var tmp1_elvis_lhs = tmp_1;
  var targets = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var levels = MuscleLevels_instance.p1j(sets, byId, today, targets);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_0 = levels.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$9 = item.v1i_1.n1s_1;
    destination_0.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_2 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_1 = levels.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_0 = _iterator__ex2g4s_1.l();
    var tmp$ret$13 = item_0.w1i_1;
    destination_1.f(tmp$ret$13);
  }
  var tmp_3 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_2 = levels.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_1 = _iterator__ex2g4s_2.l();
    var tmp0_elvis_lhs = item_1.x1i_1;
    var tmp$ret$16 = tmp0_elvis_lhs == null ? NaN : tmp0_elvis_lhs;
    destination_2.f(tmp$ret$16);
  }
  var tmp_4 = toDoubleArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_3 = levels.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_2 = _iterator__ex2g4s_3.l();
    var tmp$ret$19 = item_2.z1i_1.x1_1;
    destination_3.f(tmp$ret$19);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_5 = copyToArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_4 = levels.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_3 = _iterator__ex2g4s_4.l();
    var tmp$ret$23 = item_3.a1j_1;
    destination_4.f(tmp$ret$23);
  }
  return new JsMuscleLevels(tmp_2, tmp_3, tmp_4, tmp_5, toDoubleArray(destination_4));
}
function JsMuscleHighlights(muscles, intensities) {
  this.muscles = muscles;
  this.intensities = intensities;
}
protoOf(JsMuscleHighlights).s24 = function () {
  return this.muscles;
};
protoOf(JsMuscleHighlights).g25 = function () {
  return this.intensities;
};
function muscleHighlights(primaryMuscles, secondaryMuscles) {
  var tmp = MuscleHighlights_instance;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = primaryMuscles.length;
  while (inductionVariable < last) {
    var element = primaryMuscles[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp0_safe_receiver = Companion_instance_17.b1g(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var tmp_0 = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = secondaryMuscles.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = secondaryMuscles[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var tmp0_safe_receiver_0 = Companion_instance_17.b1g(element_0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  var result = tmp.v1j(tmp_0, destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = result.u1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$16 = item.n1s_1;
    destination_1.f(tmp$ret$16);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  var this_1 = result.v1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$20 = item_0.x1_1;
    destination_2.f(tmp$ret$20);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$21 = copyToArray(destination_2);
  return new JsMuscleHighlights(tmp_1, tmp$ret$21);
}
function bodyMapMuscles(muscleId) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = BodyMapArt_getInstance().u1d(muscleId);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.n1s_1;
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsImportedProgram(programJson, unmatched) {
  this.programJson = programJson;
  this.unmatched = unmatched;
}
protoOf(JsImportedProgram).q24 = function () {
  return this.programJson;
};
protoOf(JsImportedProgram).h25 = function () {
  return this.unmatched;
};
function importProgramCsv(csv, catalogueJson, name) {
  var imported = ProgramImport_getInstance().w1n(csv, catalogue(catalogueJson), name);
  var tmp = TrainingProgramJson_instance.w1u(imported.n1n_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = imported.o1n_1;
  var tmp$ret$0 = copyToArray(this_0);
  return new JsImportedProgram(tmp, tmp$ret$0);
}
function JsSeries(days, values) {
  this.days = days;
  this.values = values;
}
protoOf(JsSeries).m22 = function () {
  return this.days;
};
protoOf(JsSeries).v1 = function () {
  return this.values;
};
function rangeSeries(days, values, today, range, aggregation, average, recordsOnly) {
  // Inline function 'kotlin.require' call
  if (!(days.length === values.length)) {
    var message = 'series arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = SeriesRanges_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new SeriesPoint(days[it], values[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var points = tmp.n1r(destination, today, valueOf_13(range), valueOf_14(aggregation), valueOf_15(average), recordsOnly);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$7 = item_0.i1r_1;
    destination_0.f(tmp$ret$7);
  }
  var tmp_0 = toIntArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s_0 = points.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_1 = _iterator__ex2g4s_0.l();
    var tmp$ret$10 = item_1.j1r_1;
    destination_1.f(tmp$ret$10);
  }
  return new JsSeries(tmp_0, toDoubleArray(destination_1));
}
function weeklyHardSets(workoutIds, days, exerciseIds, types, reps, today) {
  var n = workoutIds.length;
  var tmp = TrainingAnalytics_instance;
  var tmp_0 = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  return tmp.j1u(trainingSets(workoutIds, days, exerciseIds, types, tmp_0, reps, tmp_1, tmp$ret$1), today);
}
function checkInStrengthIndex(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, catalogueJson, day) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.p1c_1 <= day) {
      destination.f(element);
    }
  }
  var sets = destination;
  var tmp = TrainingAnalytics_instance;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = this_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = element_0.s1b_1;
    destination_0.l2(tmp$ret$5, element_0);
  }
  var points = tmp.l1u(sets, destination_0, VOID, day - 21 | 0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s_1 = points.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item.ht_1;
    destination_1.f(tmp$ret$8);
  }
  var tmp_0 = toIntArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s_2 = points.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp$ret$11 = item_0.it_1;
    destination_2.f(tmp$ret$11);
  }
  return new JsSeries(tmp_0, toDoubleArray(destination_2));
}
function trainingWeekdays(trainingSettingsJson, activeProgramSessions) {
  return toIntArray(sorted(TrainingWeekdays_getInstance().l1w(TrainingSettingsJson_instance.mg(trainingSettingsJson).b1v_1, activeProgramSessions)));
}
function JsWeeklyVolumes(weekStarts, externalKg, bodyweightKg) {
  this.weekStarts = weekStarts;
  this.externalKg = externalKg;
  this.bodyweightKg = bodyweightKg;
}
protoOf(JsWeeklyVolumes).n22 = function () {
  return this.weekStarts;
};
protoOf(JsWeeklyVolumes).i25 = function () {
  return this.externalKg;
};
protoOf(JsWeeklyVolumes).j25 = function () {
  return this.bodyweightKg;
};
function weeklyVolumes(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, catalogueJson) {
  var sets = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  var tmp = TrainingAnalytics_instance;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.s1b_1;
    destination.l2(tmp$ret$2, element);
  }
  var weeks = tmp.h1u(sets, destination);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(weeks, 10));
  var _iterator__ex2g4s_0 = weeks.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item.t1t_1;
    destination_0.f(tmp$ret$5);
  }
  var tmp_0 = toIntArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(weeks, 10));
  var _iterator__ex2g4s_1 = weeks.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_0 = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item_0.x1t_1;
    destination_1.f(tmp$ret$8);
  }
  var tmp_1 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(weeks, 10));
  var _iterator__ex2g4s_2 = weeks.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_1 = _iterator__ex2g4s_2.l();
    var tmp$ret$11 = item_1.y1t_1;
    destination_2.f(tmp$ret$11);
  }
  return new JsWeeklyVolumes(tmp_0, tmp_1, toDoubleArray(destination_2));
}
function gymTemplate(kind) {
  return Json_instance.sg(Companion_getInstance_11().u1g(valueOf_10(kind)).g1h());
}
function checklistEquipment() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_CHECKLIST_EQUIPMENT();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.t1g_1;
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function gymHasEquipment(gymJson, equipment) {
  return Companion_getInstance_11().p1g(gymJson).k1h(Companion_instance_18.h1f(equipment));
}
function equipmentIsWeightStack(equipment) {
  return isWeightStack(Companion_instance_18.h1f(equipment));
}
function machineStepPresetsKg() {
  return toDoubleArray(get_MACHINE_STEP_PRESETS_KG());
}
function gymAdding(gymJson, equipment, stackName, stackStepKg) {
  var stack = !(stackName == null) && !(stackStepKg == null) ? stackFromStep(stackName, stackStepKg) : null;
  return Json_instance.sg(adding(Companion_getInstance_11().p1g(gymJson), Companion_instance_18.h1f(equipment), stack).g1h());
}
function gymRemoving(gymJson, equipment) {
  return Json_instance.sg(removing(Companion_getInstance_11().p1g(gymJson), Companion_instance_18.h1f(equipment)).g1h());
}
function JsPeriodLevels(days, totalSets, levels) {
  this.days = days;
  this.totalSets = totalSets;
  this.levels = levels;
}
protoOf(JsPeriodLevels).m22 = function () {
  return this.days;
};
protoOf(JsPeriodLevels).k25 = function () {
  return this.totalSets;
};
protoOf(JsPeriodLevels).l25 = function () {
  return this.levels;
};
function muscleLevelsForPeriod(workoutIds, days, exerciseIds, types, reps, catalogueJson, today, programJson, cycle, period) {
  var n = workoutIds.length;
  var tmp = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  var sets = trainingSets(workoutIds, days, exerciseIds, types, tmp, reps, tmp_0, tmp$ret$1);
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4 = element.s1b_1;
    destination.l2(tmp$ret$4, element);
  }
  var byId = destination;
  var tmp_1;
  if (programJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = ProgramGenerator_getInstance().f1n(TrainingProgramJson_instance.x1u(programJson), cycle, byId);
  }
  var tmp1_elvis_lhs = tmp_1;
  var targets = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp_2 = MuscleLevels_instance;
  var tmp0 = get_entries_23();
  var tmp$ret$7;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var _iterator__ex2g4s_0 = tmp0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0.d1j_1 === period) {
        tmp$ret$7 = element_0;
        break $l$block;
      }
    }
    throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
  }
  var result = tmp_2.t1j(sets, byId, today, targets, tmp$ret$7);
  var levels = result.i1j_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_1 = levels.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$11 = getValue(result.h1j_1, item.v1i_1);
    destination_0.f(tmp$ret$11);
  }
  var tmp_3 = toDoubleArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_2 = levels.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp$ret$14 = item_0.v1i_1.n1s_1;
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_4 = copyToArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_3 = levels.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_1 = _iterator__ex2g4s_3.l();
    var tmp$ret$18 = item_1.w1i_1;
    destination_2.f(tmp$ret$18);
  }
  var tmp_5 = toDoubleArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_4 = levels.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_2 = _iterator__ex2g4s_4.l();
    var tmp0_elvis_lhs = item_2.x1i_1;
    var tmp$ret$21 = tmp0_elvis_lhs == null ? NaN : tmp0_elvis_lhs;
    destination_3.f(tmp$ret$21);
  }
  var tmp_6 = toDoubleArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_5 = levels.j();
  while (_iterator__ex2g4s_5.k()) {
    var item_3 = _iterator__ex2g4s_5.l();
    var tmp$ret$24 = item_3.z1i_1.x1_1;
    destination_4.f(tmp$ret$24);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_7 = copyToArray(destination_4);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_6 = levels.j();
  while (_iterator__ex2g4s_6.k()) {
    var item_4 = _iterator__ex2g4s_6.l();
    var tmp$ret$28 = item_4.a1j_1;
    destination_5.f(tmp$ret$28);
  }
  return new JsPeriodLevels(result.g1j_1, tmp_3, new JsMuscleLevels(tmp_4, tmp_5, tmp_6, tmp_7, toDoubleArray(destination_5)));
}
function JsTrainingSuggestion(id, kind, exerciseId, title, body, evidence, fromExerciseId, toExerciseId, exerciseIds, fromDays, toDays, programJson) {
  this.id = id;
  this.kind = kind;
  this.exerciseId = exerciseId;
  this.title = title;
  this.body = body;
  this.evidence = evidence;
  this.fromExerciseId = fromExerciseId;
  this.toExerciseId = toExerciseId;
  this.exerciseIds = exerciseIds;
  this.fromDays = fromDays;
  this.toDays = toDays;
  this.programJson = programJson;
}
protoOf(JsTrainingSuggestion).m25 = function () {
  return this.id;
};
protoOf(JsTrainingSuggestion).o1y = function () {
  return this.kind;
};
protoOf(JsTrainingSuggestion).y24 = function () {
  return this.exerciseId;
};
protoOf(JsTrainingSuggestion).l21 = function () {
  return this.title;
};
protoOf(JsTrainingSuggestion).n25 = function () {
  return this.body;
};
protoOf(JsTrainingSuggestion).o25 = function () {
  return this.evidence;
};
protoOf(JsTrainingSuggestion).p25 = function () {
  return this.fromExerciseId;
};
protoOf(JsTrainingSuggestion).q25 = function () {
  return this.toExerciseId;
};
protoOf(JsTrainingSuggestion).r25 = function () {
  return this.exerciseIds;
};
protoOf(JsTrainingSuggestion).s25 = function () {
  return this.fromDays;
};
protoOf(JsTrainingSuggestion).t25 = function () {
  return this.toDays;
};
protoOf(JsTrainingSuggestion).q24 = function () {
  return this.programJson;
};
function trainingSuggestions(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, catalogueJson, programJson, sessionWorkoutIds, sessionDays, sessionCycles, sessionDayIndexes, today, programStartDay, gymJson, trainingSettingsJson, recoveryFlag) {
  // Inline function 'kotlin.require' call
  if (!(sessionDays.length === sessionWorkoutIds.length && sessionCycles.length === sessionWorkoutIds.length && sessionDayIndexes.length === sessionWorkoutIds.length)) {
    var message = 'session arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var program = TrainingProgramJson_instance.x1u(programJson);
  var programMap = JsonRead_instance.og(Json_instance.ng(programJson), 'TPROG');
  var tmp0_elvis_lhs = JsonRead_instance.tr(programMap, 'active');
  var active = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  var startDate = JsonRead_instance.br(programMap, 'startDate');
  var settings = TrainingSettingsJson_instance.mg(trainingSettingsJson);
  var tmp = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  var tmp_0 = catalogue(catalogueJson);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(sessionWorkoutIds);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = Companion_instance_11.e1a(sessionWorkoutIds[it], sessionDays[it], program, sessionCycles[it], sessionDayIndexes[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var tmp_1 = destination;
  var tmp_2;
  if (gymJson == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = Companion_getInstance_11().p1g(gymJson);
  }
  var input = new AdaptiveInput(tmp, tmp_0, program, tmp_1, today, programStartDay, tmp_2, settings.z1v_1, recoveryFlag, settings.a1w_1);
  // Inline function 'kotlin.collections.map' call
  var this_1 = AdaptiveTraining_instance.r1d(input);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var change = item_0.d1a_1;
    var tmp0_safe_receiver = change instanceof SwapExercise ? change : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p19_1;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = change instanceof StopSuggesting ? change : null;
      tmp_3 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.v19_1;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp_4 = tmp_3;
    var tmp3_safe_receiver = change instanceof SwapExercise ? change : null;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.q19_1;
    var tmp_5;
    if (tmp4_elvis_lhs == null) {
      var tmp5_safe_receiver = change instanceof StopSuggesting ? change : null;
      tmp_5 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.w19_1;
    } else {
      tmp_5 = tmp4_elvis_lhs;
    }
    var tmp_6 = tmp_5;
    var tmp6_safe_receiver = change instanceof Deload ? change : null;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs_0 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.r19_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_2 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
    var tmp_7 = copyToArray(this_2);
    var tmp7_safe_receiver = change instanceof Consolidate ? change : null;
    var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.s19_1;
    var tmp_8 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
    var tmp9_safe_receiver = change instanceof Consolidate ? change : null;
    var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.t19_1;
    var tmp_9 = tmp10_elvis_lhs == null ? 0 : tmp10_elvis_lhs;
    var tmp11_safe_receiver = change instanceof Consolidate ? change : null;
    var tmp_10;
    if (tmp11_safe_receiver == null) {
      tmp_10 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_10 = TrainingProgramJson_instance.v1u(tmp11_safe_receiver.u19_1, active, startDate);
    }
    var tmp$ret$9 = new JsTrainingSuggestion(item_0.x19_1, item_0.y19_1.x1_1, item_0.z19_1, item_0.a1a_1, item_0.b1a_1, item_0.c1a_1, tmp_4, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10);
    destination_0.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function dismissTrainingSuggestion(trainingSettingsJson, id, today) {
  var settings = TrainingSettingsJson_instance.mg(trainingSettingsJson);
  return TrainingSettingsJson_instance.i1w(settings.e1w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, plus_1(settings.a1w_1, to(id, today))), trainingSettingsJson);
}
function catalogue(json) {
  var tmp0_safe_receiver = catalogueCache;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var cachedJson = tmp0_safe_receiver.hb();
    var exercises = tmp0_safe_receiver.ib();
    if (cachedJson === json)
      return exercises;
  }
  // Inline function 'kotlin.also' call
  var this_0 = ExerciseCatalogue_instance.ng(json);
  catalogueCache = to(json, this_0);
  return this_0;
}
function trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg) {
  var n = workoutIds.length;
  // Inline function 'kotlin.require' call
  if (!(days.length === n && exerciseIds.length === n && types.length === n && loadKg.length === n && reps.length === n && rir.length === n && bodyweightKg.length === n)) {
    var message = 'set arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, n);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new TrainingSet(workoutIds[it], days[it], exerciseIds[it], it, Companion_instance_19.h1f(types[it]), loadKg[it], reps[it], rir[it], bodyweightKg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return destination;
}
function JsTrendChart(bandDays, bandLowKg, bandHighKg, projectionFromDay, projectionFromKg, projectionToDay, projectionToKg) {
  this.bandDays = bandDays;
  this.bandLowKg = bandLowKg;
  this.bandHighKg = bandHighKg;
  this.projectionFromDay = projectionFromDay;
  this.projectionFromKg = projectionFromKg;
  this.projectionToDay = projectionToDay;
  this.projectionToKg = projectionToKg;
}
protoOf(JsTrendChart).u1y = function () {
  return this.bandDays;
};
protoOf(JsTrendChart).u25 = function () {
  return this.bandLowKg;
};
protoOf(JsTrendChart).v25 = function () {
  return this.bandHighKg;
};
protoOf(JsTrendChart).w25 = function () {
  return this.projectionFromDay;
};
protoOf(JsTrendChart).x25 = function () {
  return this.projectionFromKg;
};
protoOf(JsTrendChart).y25 = function () {
  return this.projectionToDay;
};
protoOf(JsTrendChart).z25 = function () {
  return this.projectionToKg;
};
function weightTrendChart(days, kg, endDay, method, predictionStyle, goalType, goalRatePctPerWeek, goalTargetKg) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kg.length)) {
    var message = 'days and kg must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.xc_1;
  var last = this_0.yc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new WeighIn(days[it], kg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var weighIns = destination;
  var trend = Trend_instance.rw(weighIns, endDay, valueOf_16(method));
  var band = TrendChart_instance.xu(trend, weighIns);
  var tmp;
  if (goalType == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new Goal(valueOf(goalType), goalRatePctPerWeek, goalTargetKg);
  }
  var goal = tmp;
  var tmp0 = get_entries_2();
  var tmp$ret$7;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.x1_1 === predictionStyle) {
        tmp$ret$7 = element;
        break $l$block;
      }
    }
    tmp$ret$7 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$7;
  var style = tmp1_elvis_lhs == null ? PredictionStyle_DATA_getInstance() : tmp1_elvis_lhs;
  var projection = TrendChart_instance.av(trend, style, goal);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(band, 10));
  var _iterator__ex2g4s_0 = band.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$11 = item_0.hu_1;
    destination_0.f(tmp$ret$11);
  }
  var tmp_0 = toIntArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(band, 10));
  var _iterator__ex2g4s_1 = band.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$14 = item_1.iu_1;
    destination_1.f(tmp$ret$14);
  }
  var tmp_1 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(band, 10));
  var _iterator__ex2g4s_2 = band.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_2 = _iterator__ex2g4s_2.l();
    var tmp$ret$17 = item_2.ju_1;
    destination_2.f(tmp$ret$17);
  }
  var tmp_2 = toDoubleArray(destination_2);
  var tmp_3 = projection == null ? null : projection.ku_1;
  var tmp_4 = projection == null ? null : projection.lu_1;
  var tmp_5 = projection == null ? null : projection.mu_1;
  return new JsTrendChart(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, projection == null ? null : projection.nu_1);
}
function trendBandCenterLine(values, window_0) {
  window_0 = window_0 === VOID ? 9 : window_0;
  return toDoubleArray(TrendBand_instance.mx(toList_2(values), window_0));
}
function trendBandHalfWidth(residuals) {
  return TrendBand_instance.nx(toList_2(residuals));
}
//region block: post-declaration
protoOf(FlooredExpCurve).j1q = oneRepMax;
protoOf(FlooredExpCurve).x1q = load;
//endregion
//region block: init
Fmt_instance = new Fmt();
AgeGate_instance = new AgeGate();
CalorieFloors_instance = new CalorieFloors();
GoalAvailability_instance = new GoalAvailability();
CheckIn_instance = new CheckIn();
CheckInSignals_instance = new CheckInSignals();
CollaborativeTargets_instance = new CollaborativeTargets();
DailyTargets_instance = new DailyTargets();
ExpenditureRunner_instance = new ExpenditureRunner();
WaistToHeight_instance = new WaistToHeight();
Goals_instance = new Goals();
LossPace_instance = new LossPace();
Macros_instance = new Macros();
NewProgram_instance = new NewProgram();
NutritionJson_instance = new NutritionJson();
PartialDays_instance = new PartialDays();
PerformanceGuardrail_instance = new PerformanceGuardrail();
TrainingShift_instance = new TrainingShift();
TrendChart_instance = new TrendChart();
WeeklyCheckIn_instance = new WeeklyCheckIn();
WeeklyDistribution_instance = new WeeklyDistribution();
TrendBand_instance = new TrendBand();
AdaptiveExpenditure_instance = new AdaptiveExpenditure();
BodyComposition_instance = new BodyComposition();
EnergyBalance_instance = new EnergyBalance();
EnergyDensity_instance = new EnergyDensity();
ExpenditureFloor_instance = new ExpenditureFloor();
ExpenditureV2_instance = new ExpenditureV2();
Companion_instance_4 = new Companion_2();
InitialExpenditure_instance = new InitialExpenditure();
StateSpaceExpenditure_instance = new StateSpaceExpenditure();
Companion_instance_6 = new Companion_4();
Companion_instance_7 = new Companion_5();
Json_instance = new Json();
JsonRead_instance = new JsonRead();
Alcohol_instance = new Alcohol();
Companion_instance_8 = new Companion_6();
NutrientAnalysis_instance = new NutrientAnalysis();
Companion_instance_9 = new Companion_7();
Companion_instance_10 = new Companion_8();
NutrientGoalHistory_instance = new NutrientGoalHistory();
NutrientGoalJson_instance = new NutrientGoalJson();
NutrientJson_instance = new NutrientJson();
NutrientGoals_instance = new NutrientGoals();
Companion_instance_11 = new Companion_9();
AdaptiveTraining_instance = new AdaptiveTraining();
CurveFit_instance = new CurveFit();
Companion_instance_13 = new Companion_11();
GeneratorSettingsJson_instance = new GeneratorSettingsJson();
Loads_instance = new Loads();
PlateCalculator_instance = new PlateCalculator();
MuscleLevels_instance = new MuscleLevels();
MuscleHighlights_instance = new MuscleHighlights();
Periodisation_instance = new Periodisation();
Substitutions_instance = new Substitutions();
Progression_instance = new Progression();
SeriesRanges_instance = new SeriesRanges();
Strength_instance = new Strength();
OneRepMaxClamp_instance = new OneRepMaxClamp();
Companion_instance_17 = new Companion_15();
Companion_instance_18 = new Companion_16();
Companion_instance_19 = new Companion_17();
Companion_instance_20 = new Companion_18();
Companion_instance_21 = new Companion_19();
Companion_instance_22 = new Companion_20();
Companion_instance_23 = new Companion_21();
Companion_instance_24 = new Companion_22();
Companion_instance_25 = new Companion_23();
Companion_instance_26 = new Companion_24();
ExerciseCatalogue_instance = new ExerciseCatalogue();
TrainingAnalytics_instance = new TrainingAnalytics();
Companion_instance_28 = new Companion_26();
TrainingProgramJson_instance = new TrainingProgramJson();
Companion_instance_29 = new Companion_27();
Companion_instance_30 = new Companion_28();
TrainingSettingsJson_instance = new TrainingSettingsJson();
Trend_instance = new Trend();
LessLagTrend_instance = new LessLagTrend();
TransientTrend_instance = new TransientTrend();
WeighInHabit_instance = new WeighInHabit();
WeightTrend_instance = new WeightTrend();
catalogueCache = null;
//endregion
//region block: exports
export {
  ounceGrams as ounceGrams,
  amountGramsFor as amountGramsFor,
  gramsToAmountFor as gramsToAmountFor,
  JsSuggestedAmount as JsSuggestedAmount,
  suggestedAmountsJs as suggestedAmountsJs,
  JsUnitChoice as JsUnitChoice,
  unitChoicesForJs as unitChoicesForJs,
  parseAmount as parseAmount,
  scaleDishGrams as scaleDishGrams,
  dishTotalJson as dishTotalJson,
  ageYearsJs as ageYearsJs,
  isAdultJs as isAdultJs,
  underAgeMessage as underAgeMessage,
  JsExpenditureModel as JsExpenditureModel,
  expenditureModel as expenditureModel,
  JsAlgorithmOption as JsAlgorithmOption,
  algorithmOptions as algorithmOptions,
  algorithmValues as algorithmValues,
  algorithmsWith as algorithmsWith,
  JsDisplayedExpenditure as JsDisplayedExpenditure,
  displayedExpenditure as displayedExpenditure,
  JsExpenditureChanges as JsExpenditureChanges,
  expenditureChanges as expenditureChanges,
  JsEnergyBalancePoint as JsEnergyBalancePoint,
  JsEnergyBalance as JsEnergyBalance,
  energyBalance as energyBalance,
  JsMessageArg as JsMessageArg,
  JsMessage as JsMessage,
  JsWeeklyCheckIn as JsWeeklyCheckIn,
  JsFastLoss as JsFastLoss,
  weeklyCheckIn as weeklyCheckIn,
  fastLossWarning as fastLossWarning,
  JsDietBreak as JsDietBreak,
  dietBreak_0 as dietBreak,
  dietBreakWeekChoices as dietBreakWeekChoices,
  dietBreakExplainer as dietBreakExplainer,
  programWithDietBreak as programWithDietBreak,
  trainingShiftCarbsHelp as trainingShiftCarbsHelp,
  collaborativeEdit as collaborativeEdit,
  dayOneTargets as dayOneTargets,
  dayOneTargetsWithTraining as dayOneTargetsWithTraining,
  defaultCheckInWeekday as defaultCheckInWeekday,
  firstCheckInDay as firstCheckInDay,
  firstCheckInDayOn as firstCheckInDayOn,
  ageYears as ageYears,
  goalPacePresets as goalPacePresets,
  goalProjection as goalProjection,
  goalCurve as goalCurve,
  suggestedTargetKg as suggestedTargetKg,
  ethnicityBmiThreshold as ethnicityBmiThreshold,
  waistToHeightBand as waistToHeightBand,
  availableGoalTypes as availableGoalTypes,
  dailyDeltaKcal as dailyDeltaKcal,
  kgPerWeek as kgPerWeek,
  ratePctPerWeek as ratePctPerWeek,
  JsGoalProgress as JsGoalProgress,
  goalProgress as goalProgress,
  JsWeightMilestone as JsWeightMilestone,
  weightMilestones as weightMilestones,
  JsNutrientGoal as JsNutrientGoal,
  nutrientGoals as nutrientGoals,
  JsCompleteness as JsCompleteness,
  nutrientCompleteness as nutrientCompleteness,
  JsContributor as JsContributor,
  nutrientTopContributors as nutrientTopContributors,
  JsNutrientAverages as JsNutrientAverages,
  nutrientAverages as nutrientAverages,
  JsAlcohol as JsAlcohol,
  alcohol as alcohol,
  alcoholDrink as alcoholDrink,
  JsDrinkType as JsDrinkType,
  drinkTypes as drinkTypes,
  JsTrendPoint as JsTrendPoint,
  JsExpenditurePoint as JsExpenditurePoint,
  JsCheckInResult as JsCheckInResult,
  JsMacros as JsMacros,
  weightTrend as weightTrend,
  changeRateKgPerWeek as changeRateKgPerWeek,
  JsWeightInsights as JsWeightInsights,
  weightInsights as weightInsights,
  weighInStreak as weighInStreak,
  energyDensityKcalPerKg as energyDensityKcalPerKg,
  checkIn as checkIn,
  macroTargets as macroTargets,
  estimatedOneRepMax as estimatedOneRepMax,
  localizeUnits as localizeUnits,
  offProductUrl as offProductUrl,
  offFoodJson as offFoodJson,
  JsNutrientInfo as JsNutrientInfo,
  nutrientInfos as nutrientInfos,
  JsNutrientGoalSetting as JsNutrientGoalSetting,
  nutrientGoalHistory as nutrientGoalHistory,
  JsGoalMethod as JsGoalMethod,
  nutrientGoalMethods as nutrientGoalMethods,
  nutrientGoalsWith as nutrientGoalsWith,
  nutrientGoalsWithout as nutrientGoalsWithout,
  JsNutrientDay as JsNutrientDay,
  JsNutrientFocus as JsNutrientFocus,
  nutrientFocus as nutrientFocus,
  JsPlateLoadout as JsPlateLoadout,
  plateLoadout as plateLoadout,
  gymLoads as gymLoads,
  nearestLoad as nearestLoad,
  JsWarmupSet as JsWarmupSet,
  warmupSets as warmupSets,
  JsExerciseTargets as JsExerciseTargets,
  nextSetTargets as nextSetTargets,
  JsGeneratedProgram as JsGeneratedProgram,
  generateProgram as generateProgram,
  defaultPowerWork as defaultPowerWork,
  JsSubstitute as JsSubstitute,
  substitutes as substitutes,
  JsRepMaxPoint as JsRepMaxPoint,
  repMaxSeries as repMaxSeries,
  JsMuscleSets as JsMuscleSets,
  weeklySetsPerMuscle as weeklySetsPerMuscle,
  smartWarmupSets as smartWarmupSets,
  normalisedTrainingSettings as normalisedTrainingSettings,
  rirFromRpe as rirFromRpe,
  repMaxSeriesOnCurve as repMaxSeriesOnCurve,
  JsMuscleLevels as JsMuscleLevels,
  muscleLevels as muscleLevels,
  JsMuscleHighlights as JsMuscleHighlights,
  muscleHighlights as muscleHighlights,
  bodyMapMuscles as bodyMapMuscles,
  JsImportedProgram as JsImportedProgram,
  importProgramCsv as importProgramCsv,
  JsSeries as JsSeries,
  rangeSeries as rangeSeries,
  weeklyHardSets as weeklyHardSets,
  checkInStrengthIndex as checkInStrengthIndex,
  trainingWeekdays as trainingWeekdays,
  JsWeeklyVolumes as JsWeeklyVolumes,
  weeklyVolumes as weeklyVolumes,
  gymTemplate as gymTemplate,
  checklistEquipment as checklistEquipment,
  gymHasEquipment as gymHasEquipment,
  equipmentIsWeightStack as equipmentIsWeightStack,
  machineStepPresetsKg as machineStepPresetsKg,
  gymAdding as gymAdding,
  gymRemoving as gymRemoving,
  JsPeriodLevels as JsPeriodLevels,
  muscleLevelsForPeriod as muscleLevelsForPeriod,
  JsTrainingSuggestion as JsTrainingSuggestion,
  trainingSuggestions as trainingSuggestions,
  dismissTrainingSuggestion as dismissTrainingSuggestion,
  JsTrendChart as JsTrendChart,
  weightTrendChart as weightTrendChart,
  trendBandCenterLine as trendBandCenterLine,
  trendBandHalfWidth as trendBandHalfWidth,
};
//endregion

//# sourceMappingURL=macrotide-shared.mjs.map
